var xw = Object.defineProperty, bw = Object.defineProperties;
var jw = Object.getOwnPropertyDescriptors;
var _s = Object.getOwnPropertySymbols;
var Kl = Object.prototype.hasOwnProperty, Jl = Object.prototype.propertyIsEnumerable;
var oi = Math.pow, ii = (e, t, n) => t in e ? xw(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, R = (e, t) => {
  for (var n in t || (t = {}))
    Kl.call(t, n) && ii(e, n, t[n]);
  if (_s)
    for (var n of _s(t))
      Jl.call(t, n) && ii(e, n, t[n]);
  return e;
}, X = (e, t) => bw(e, jw(t));
var ct = (e, t) => {
  var n = {};
  for (var r in e)
    Kl.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && _s)
    for (var r of _s(e))
      t.indexOf(r) < 0 && Jl.call(e, r) && (n[r] = e[r]);
  return n;
};
var ne = (e, t, n) => (ii(e, typeof t != "symbol" ? t + "" : t, n), n);
var V = (e, t, n) => new Promise((r, s) => {
  var a = (l) => {
    try {
      c(n.next(l));
    } catch (d) {
      s(d);
    }
  }, o = (l) => {
    try {
      c(n.throw(l));
    } catch (d) {
      s(d);
    }
  }, c = (l) => l.done ? r(l.value) : Promise.resolve(l.value).then(a, o);
  c((n = n.apply(e, t)).next());
});
import * as De from "react";
import wa, { useLayoutEffect as Cw, useEffect as he, createContext as Ct, createRef as Nw, useContext as tt, useState as Y, useCallback as vt, useRef as Te, useMemo as ke, isValidElement as th, Component as nh, forwardRef as va, createElement as gr, Fragment as sn, cloneElement as Dw, memo as Sw } from "react";
import { faArrowUpRightFromSquare as rh, faBars as $w, faXmark as Fo, faCircleExclamation as sh, faEye as Bo, faEyeSlash as Uo, faChevronDown as jr, faPrint as Aw, faFileLines as ah, faChevronRight as zo, faExternalLinkAlt as ih, faChevronUp as Ew, faCheck as oh, faTrash as ya, faX as Iw, faRefresh as _w, faPlus as Tw, faCircleCheck as ch, faExclamationCircle as Rw, faInbox as Mw, faMagnifyingGlass as Pw, faInfoCircle as Ho, faAngleRight as Ow, faClipboardCheck as lh, faClipboardList as dh, faFlask as uh, faArrowTrendUp as fh, faArrowRight as kw, faTriangleExclamation as Lw, faCircleInfo as Fw, faNoteSticky as Bw, faUser as Uw, faWarning as zw, faHandHoldingMedical as Hw, faCircleH as hh, faPills as Ww, faUsers as Vw, faHeartPulse as qw, faClipboard as Gw, faFileImage as Yw, faFilePdf as Qw, faHourglass as Zw, faCalendarWeek as Kw } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon as me } from "@fortawesome/react-fontawesome";
import { useReactToPrint as Jw } from "react-to-print";
import { Viewer as Xw, Worker as ev } from "@react-pdf-viewer/core";
import { DOMParser as tv } from "@xmldom/xmldom";
import k from "xpath";
import { isBefore as nv, isEqual as rv, format as Qt, parseISO as un, differenceInYears as ph, isValid as no, formatISO as sv, parse as ro, max as av, subYears as iv, isAfter as ov, differenceInDays as cv } from "date-fns";
import W from "classnames";
import Xl from "@react-hook/resize-observer";
import { toZonedTime as lv, format as wr } from "date-fns-tz";
import { QueryClient as dv, QueryCache as uv, useQuery as mh, QueryClientProvider as fv } from "@tanstack/react-query";
import ed from "fhir-kit-client";
import { datadogLogs as qr } from "@datadog/browser-logs";
import { datadogRum as er } from "@datadog/browser-rum-slim";
import hv from "jwt-decode";
import { faCircleCheck as gh, faClock as pv, faFaceFrown as mv, faFaceMeh as gv, faFaceSmile as wv, faFaceGrinHearts as vv, faNoteSticky as yv, faFileLines as ss, faUser as xv, faCalendar as td } from "@fortawesome/free-regular-svg-icons";
import { toast as Bs, ToastContainer as bv, Zoom as jv } from "react-toastify";
import { GraphQLClient as Cv, gql as Ae } from "graphql-request";
import { Transition as kn, Dialog as Ys, Menu as wh, Listbox as Ts, Combobox as cr, Tab as Gr } from "@headlessui/react";
import Nv from "html-react-parser";
import * as qt from "@radix-ui/react-dropdown-menu";
import { UnleashClient as Dv, FlagProvider as Sv, useUnleashContext as $v, useUnleashClient as Av, useFlagsStatus as Ev } from "@unleash/proxy-client-react";
import * as Yr from "@radix-ui/react-tooltip";
import { ReactJason as Iv } from "react-jason";
import nd, { z as Ce, ZodEffects as Qs, ZodString as vh, ZodNumber as yh, ZodBoolean as xh, ZodDate as so, ZodArray as bh, ZodOptional as jh, ZodObject as ao, ZodLiteral as _v, ZodNativeEnum as Tv, ZodEnum as Rv, ZodDefault as Mv, ZodUnknown as Pv } from "zod";
import Ch from "dompurify";
import { Interweave as Nh } from "interweave";
import Ov from "react-responsive-masonry";
var Rs = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function oe(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var io = { exports: {} }, tr = {};
/** @license React v16.14.0
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var rd;
function kv() {
  if (rd)
    return tr;
  rd = 1;
  var e = wa, t = 60103;
  if (tr.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var n = Symbol.for;
    t = n("react.element"), tr.Fragment = n("react.fragment");
  }
  var r = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, s = Object.prototype.hasOwnProperty, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(c, l, d) {
    var u, h = {}, f = null, p = null;
    d !== void 0 && (f = "" + d), l.key !== void 0 && (f = "" + l.key), l.ref !== void 0 && (p = l.ref);
    for (u in l)
      s.call(l, u) && !a.hasOwnProperty(u) && (h[u] = l[u]);
    if (c && c.defaultProps)
      for (u in l = c.defaultProps, l)
        h[u] === void 0 && (h[u] = l[u]);
    return { $$typeof: t, type: c, key: f, ref: p, props: h, _owner: r.current };
  }
  return tr.jsx = o, tr.jsxs = o, tr;
}
var ci = {};
/** @license React v16.14.0
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var sd;
function Lv() {
  return sd || (sd = 1, function(e) {
    process.env.NODE_ENV !== "production" && function() {
      var t = wa, n = 60103, r = 60106;
      e.Fragment = 60107;
      var s = 60108, a = 60114, o = 60109, c = 60110, l = 60112, d = 60113, u = 60120, h = 60115, f = 60116, p = 60121, m = 60122, C = 60117, y = 60129, g = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var w = Symbol.for;
        n = w("react.element"), r = w("react.portal"), e.Fragment = w("react.fragment"), s = w("react.strict_mode"), a = w("react.profiler"), o = w("react.provider"), c = w("react.context"), l = w("react.forward_ref"), d = w("react.suspense"), u = w("react.suspense_list"), h = w("react.memo"), f = w("react.lazy"), p = w("react.block"), m = w("react.server.block"), C = w("react.fundamental"), w("react.scope"), w("react.opaque.id"), y = w("react.debug_trace_mode"), w("react.offscreen"), g = w("react.legacy_hidden");
      }
      var x = typeof Symbol == "function" && Symbol.iterator, S = "@@iterator";
      function N(O) {
        if (O === null || typeof O != "object")
          return null;
        var K = x && O[x] || O[S];
        return typeof K == "function" ? K : null;
      }
      var v = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function b(O) {
        {
          for (var K = arguments.length, ee = new Array(K > 1 ? K - 1 : 0), ae = 1; ae < K; ae++)
            ee[ae - 1] = arguments[ae];
          j("error", O, ee);
        }
      }
      function j(O, K, ee) {
        {
          var ae = v.ReactDebugCurrentFrame, se = "";
          if (Q) {
            var je = G(Q.type), Se = Q._owner;
            se += L(je, Q._source, Se && G(Se.type));
          }
          se += ae.getStackAddendum(), se !== "" && (K += "%s", ee = ee.concat([se]));
          var ve = ee.map(function(ot) {
            return "" + ot;
          });
          ve.unshift("Warning: " + K), Function.prototype.apply.call(console[O], console, ve);
        }
      }
      var D = !1;
      function $(O) {
        return !!(typeof O == "string" || typeof O == "function" || O === e.Fragment || O === a || O === y || O === s || O === d || O === u || O === g || D || typeof O == "object" && O !== null && (O.$$typeof === f || O.$$typeof === h || O.$$typeof === o || O.$$typeof === c || O.$$typeof === l || O.$$typeof === C || O.$$typeof === p || O[0] === m));
      }
      var _ = /^(.*)[\\\/]/;
      function L(O, K, ee) {
        var ae = "";
        if (K) {
          var se = K.fileName, je = se.replace(_, "");
          if (/^index\./.test(je)) {
            var Se = se.match(_);
            if (Se) {
              var ve = Se[1];
              if (ve) {
                var ot = ve.replace(_, "");
                je = ot + "/" + je;
              }
            }
          }
          ae = " (at " + je + ":" + K.lineNumber + ")";
        } else
          ee && (ae = " (created by " + ee + ")");
        return `
    in ` + (O || "Unknown") + ae;
      }
      var I = 1;
      function A(O) {
        return O._status === I ? O._result : null;
      }
      function M(O, K, ee) {
        var ae = K.displayName || K.name || "";
        return O.displayName || (ae !== "" ? ee + "(" + ae + ")" : ee);
      }
      function G(O) {
        if (O == null)
          return null;
        if (typeof O.tag == "number" && b("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof O == "function")
          return O.displayName || O.name || null;
        if (typeof O == "string")
          return O;
        switch (O) {
          case e.Fragment:
            return "Fragment";
          case r:
            return "Portal";
          case a:
            return "Profiler";
          case s:
            return "StrictMode";
          case d:
            return "Suspense";
          case u:
            return "SuspenseList";
        }
        if (typeof O == "object")
          switch (O.$$typeof) {
            case c:
              return "Context.Consumer";
            case o:
              return "Context.Provider";
            case l:
              return M(O, O.render, "ForwardRef");
            case h:
              return G(O.type);
            case p:
              return G(O.render);
            case f: {
              var K = O, ee = A(K);
              if (ee)
                return G(ee);
              break;
            }
          }
        return null;
      }
      var Z = {};
      v.ReactDebugCurrentFrame;
      var Q = null;
      function T(O) {
        Q = O;
      }
      function P(O, K, ee, ae, se) {
        {
          var je = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var Se in O)
            if (je(O, Se)) {
              var ve = void 0;
              try {
                if (typeof O[Se] != "function") {
                  var ot = Error((ae || "React class") + ": " + ee + " type `" + Se + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof O[Se] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw ot.name = "Invariant Violation", ot;
                }
                ve = O[Se](K, Se, ae, ee, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (Nt) {
                ve = Nt;
              }
              ve && !(ve instanceof Error) && (T(se), b("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", ae || "React class", ee, Se, typeof ve), T(null)), ve instanceof Error && !(ve.message in Z) && (Z[ve.message] = !0, T(se), b("Failed %s type: %s", ee, ve.message), T(null));
            }
        }
      }
      var E = v.ReactCurrentOwner, z = Object.prototype.hasOwnProperty, H = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, te, q, B;
      B = {};
      function F(O) {
        if (z.call(O, "ref")) {
          var K = Object.getOwnPropertyDescriptor(O, "ref").get;
          if (K && K.isReactWarning)
            return !1;
        }
        return O.ref !== void 0;
      }
      function U(O) {
        if (z.call(O, "key")) {
          var K = Object.getOwnPropertyDescriptor(O, "key").get;
          if (K && K.isReactWarning)
            return !1;
        }
        return O.key !== void 0;
      }
      function J(O, K) {
        if (typeof O.ref == "string" && E.current && K && E.current.stateNode !== K) {
          var ee = G(E.current.type);
          B[ee] || (b('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', G(E.current.type), O.ref), B[ee] = !0);
        }
      }
      function fe(O, K) {
        {
          var ee = function() {
            te || (te = !0, b("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", K));
          };
          ee.isReactWarning = !0, Object.defineProperty(O, "key", {
            get: ee,
            configurable: !0
          });
        }
      }
      function re(O, K) {
        {
          var ee = function() {
            q || (q = !0, b("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", K));
          };
          ee.isReactWarning = !0, Object.defineProperty(O, "ref", {
            get: ee,
            configurable: !0
          });
        }
      }
      var ce = function(O, K, ee, ae, se, je, Se) {
        var ve = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: n,
          // Built-in properties that belong on the element
          type: O,
          key: K,
          ref: ee,
          props: Se,
          // Record the component responsible for creating this element.
          _owner: je
        };
        return ve._store = {}, Object.defineProperty(ve._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(ve, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: ae
        }), Object.defineProperty(ve, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: se
        }), Object.freeze && (Object.freeze(ve.props), Object.freeze(ve)), ve;
      };
      function ge(O, K, ee, ae, se) {
        {
          var je, Se = {}, ve = null, ot = null;
          ee !== void 0 && (ve = "" + ee), U(K) && (ve = "" + K.key), F(K) && (ot = K.ref, J(K, se));
          for (je in K)
            z.call(K, je) && !H.hasOwnProperty(je) && (Se[je] = K[je]);
          if (O && O.defaultProps) {
            var Nt = O.defaultProps;
            for (je in Nt)
              Se[je] === void 0 && (Se[je] = Nt[je]);
          }
          if (ve || ot) {
            var Mt = typeof O == "function" ? O.displayName || O.name || "Unknown" : O;
            ve && fe(Se, Mt), ot && re(Se, Mt);
          }
          return ce(O, ve, ot, se, ae, E.current, Se);
        }
      }
      var we = v.ReactCurrentOwner;
      v.ReactDebugCurrentFrame;
      function ue(O) {
        Q = O;
      }
      var pe;
      pe = !1;
      function le(O) {
        return typeof O == "object" && O !== null && O.$$typeof === n;
      }
      function de() {
        {
          if (we.current) {
            var O = G(we.current.type);
            if (O)
              return `

Check the render method of \`` + O + "`.";
          }
          return "";
        }
      }
      function Me(O) {
        {
          if (O !== void 0) {
            var K = O.fileName.replace(/^.*[\\\/]/, ""), ee = O.lineNumber;
            return `

Check your code at ` + K + ":" + ee + ".";
          }
          return "";
        }
      }
      var Ye = {};
      function Ke(O) {
        {
          var K = de();
          if (!K) {
            var ee = typeof O == "string" ? O : O.displayName || O.name;
            ee && (K = `

Check the top-level render call using <` + ee + ">.");
          }
          return K;
        }
      }
      function at(O, K) {
        {
          if (!O._store || O._store.validated || O.key != null)
            return;
          O._store.validated = !0;
          var ee = Ke(K);
          if (Ye[ee])
            return;
          Ye[ee] = !0;
          var ae = "";
          O && O._owner && O._owner !== we.current && (ae = " It was passed a child from " + G(O._owner.type) + "."), ue(O), b('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', ee, ae), ue(null);
        }
      }
      function Ne(O, K) {
        {
          if (typeof O != "object")
            return;
          if (Array.isArray(O))
            for (var ee = 0; ee < O.length; ee++) {
              var ae = O[ee];
              le(ae) && at(ae, K);
            }
          else if (le(O))
            O._store && (O._store.validated = !0);
          else if (O) {
            var se = N(O);
            if (typeof se == "function" && se !== O.entries)
              for (var je = se.call(O), Se; !(Se = je.next()).done; )
                le(Se.value) && at(Se.value, K);
          }
        }
      }
      function ze(O) {
        {
          var K = O.type;
          if (K == null || typeof K == "string")
            return;
          var ee;
          if (typeof K == "function")
            ee = K.propTypes;
          else if (typeof K == "object" && (K.$$typeof === l || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          K.$$typeof === h))
            ee = K.propTypes;
          else
            return;
          if (ee) {
            var ae = G(K);
            P(ee, O.props, "prop", ae, O);
          } else if (K.PropTypes !== void 0 && !pe) {
            pe = !0;
            var se = G(K);
            b("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", se || "Unknown");
          }
          typeof K.getDefaultProps == "function" && !K.getDefaultProps.isReactClassApproved && b("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function bt(O) {
        {
          for (var K = Object.keys(O.props), ee = 0; ee < K.length; ee++) {
            var ae = K[ee];
            if (ae !== "children" && ae !== "key") {
              ue(O), b("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", ae), ue(null);
              break;
            }
          }
          O.ref !== null && (ue(O), b("Invalid attribute `ref` supplied to `React.Fragment`."), ue(null));
        }
      }
      function it(O, K, ee, ae, se, je) {
        {
          var Se = $(O);
          if (!Se) {
            var ve = "";
            (O === void 0 || typeof O == "object" && O !== null && Object.keys(O).length === 0) && (ve += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var ot = Me(se);
            ot ? ve += ot : ve += de();
            var Nt;
            O === null ? Nt = "null" : Array.isArray(O) ? Nt = "array" : O !== void 0 && O.$$typeof === n ? (Nt = "<" + (G(O.type) || "Unknown") + " />", ve = " Did you accidentally export a JSX literal instead of a component?") : Nt = typeof O, b("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Nt, ve);
          }
          var Mt = ge(O, K, ee, se, je);
          if (Mt == null)
            return Mt;
          if (Se) {
            var en = K.children;
            if (en !== void 0)
              if (ae)
                if (Array.isArray(en)) {
                  for (var Tn = 0; Tn < en.length; Tn++)
                    Ne(en[Tn], O);
                  Object.freeze && Object.freeze(en);
                } else
                  b("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                Ne(en, O);
          }
          return O === e.Fragment ? bt(Mt) : ze(Mt), Mt;
        }
      }
      function Vt(O, K, ee) {
        return it(O, K, ee, !0);
      }
      function ie(O, K, ee) {
        return it(O, K, ee, !1);
      }
      var be = ie, _e = Vt;
      e.jsx = be, e.jsxs = _e;
    }();
  }(ci)), ci;
}
process.env.NODE_ENV === "production" ? io.exports = kv() : io.exports = Lv();
var i = io.exports, Fv = typeof Rs == "object" && Rs && Rs.Object === Object && Rs, Dh = Fv, Bv = Dh, Uv = typeof self == "object" && self && self.Object === Object && self, zv = Bv || Uv || Function("return this")(), gt = zv, Hv = gt, Wv = Hv.Symbol, Cr = Wv;
function Vv(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, s = Array(r); ++n < r; )
    s[n] = t(e[n], n, e);
  return s;
}
var on = Vv, qv = Array.isArray, Ge = qv;
const Ft = /* @__PURE__ */ oe(Ge);
var ad = Cr, Sh = Object.prototype, Gv = Sh.hasOwnProperty, Yv = Sh.toString, Qr = ad ? ad.toStringTag : void 0;
function Qv(e) {
  var t = Gv.call(e, Qr), n = e[Qr];
  try {
    e[Qr] = void 0;
    var r = !0;
  } catch (a) {
  }
  var s = Yv.call(e);
  return r && (t ? e[Qr] = n : delete e[Qr]), s;
}
var Zv = Qv, Kv = Object.prototype, Jv = Kv.toString;
function Xv(e) {
  return Jv.call(e);
}
var ey = Xv, id = Cr, ty = Zv, ny = ey, ry = "[object Null]", sy = "[object Undefined]", od = id ? id.toStringTag : void 0;
function ay(e) {
  return e == null ? e === void 0 ? sy : ry : od && od in Object(e) ? ty(e) : ny(e);
}
var gn = ay;
function iy(e) {
  return e != null && typeof e == "object";
}
var St = iy, oy = gn, cy = St, ly = "[object Symbol]";
function dy(e) {
  return typeof e == "symbol" || cy(e) && oy(e) == ly;
}
var Nr = dy, cd = Cr, uy = on, fy = Ge, hy = Nr, py = 1 / 0, ld = cd ? cd.prototype : void 0, dd = ld ? ld.toString : void 0;
function $h(e) {
  if (typeof e == "string")
    return e;
  if (fy(e))
    return uy(e, $h) + "";
  if (hy(e))
    return dd ? dd.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -py ? "-0" : t;
}
var Ah = $h, my = Ah;
function gy(e) {
  return e == null ? "" : my(e);
}
var cn = gy;
function wy(e, t, n) {
  var r = -1, s = e.length;
  t < 0 && (t = -t > s ? 0 : s + t), n = n > s ? s : n, n < 0 && (n += s), s = t > n ? 0 : n - t >>> 0, t >>>= 0;
  for (var a = Array(s); ++r < s; )
    a[r] = e[r + t];
  return a;
}
var Wo = wy, vy = Wo;
function yy(e, t, n) {
  var r = e.length;
  return n = n === void 0 ? r : n, !t && n >= r ? e : vy(e, t, n);
}
var Eh = yy, xy = "\\ud800-\\udfff", by = "\\u0300-\\u036f", jy = "\\ufe20-\\ufe2f", Cy = "\\u20d0-\\u20ff", Ny = by + jy + Cy, Dy = "\\ufe0e\\ufe0f", Sy = "\\u200d", $y = RegExp("[" + Sy + xy + Ny + Dy + "]");
function Ay(e) {
  return $y.test(e);
}
var Vo = Ay;
function Ey(e) {
  return e.split("");
}
var Iy = Ey, Ih = "\\ud800-\\udfff", _y = "\\u0300-\\u036f", Ty = "\\ufe20-\\ufe2f", Ry = "\\u20d0-\\u20ff", My = _y + Ty + Ry, Py = "\\ufe0e\\ufe0f", Oy = "[" + Ih + "]", oo = "[" + My + "]", co = "\\ud83c[\\udffb-\\udfff]", ky = "(?:" + oo + "|" + co + ")", _h = "[^" + Ih + "]", Th = "(?:\\ud83c[\\udde6-\\uddff]){2}", Rh = "[\\ud800-\\udbff][\\udc00-\\udfff]", Ly = "\\u200d", Mh = ky + "?", Ph = "[" + Py + "]?", Fy = "(?:" + Ly + "(?:" + [_h, Th, Rh].join("|") + ")" + Ph + Mh + ")*", By = Ph + Mh + Fy, Uy = "(?:" + [_h + oo + "?", oo, Th, Rh, Oy].join("|") + ")", zy = RegExp(co + "(?=" + co + ")|" + Uy + By, "g");
function Hy(e) {
  return e.match(zy) || [];
}
var Wy = Hy, Vy = Iy, qy = Vo, Gy = Wy;
function Yy(e) {
  return qy(e) ? Gy(e) : Vy(e);
}
var Oh = Yy, Qy = Eh, Zy = Vo, Ky = Oh, Jy = cn;
function Xy(e) {
  return function(t) {
    t = Jy(t);
    var n = Zy(t) ? Ky(t) : void 0, r = n ? n[0] : t.charAt(0), s = n ? Qy(n, 1).join("") : t.slice(1);
    return r[e]() + s;
  };
}
var ex = Xy, tx = ex, nx = tx("toUpperCase"), kh = nx, rx = cn, sx = kh;
function ax(e) {
  return sx(rx(e).toLowerCase());
}
var qo = ax;
const qe = /* @__PURE__ */ oe(qo);
function ix(e, t, n, r) {
  var s = -1, a = e == null ? 0 : e.length;
  for (r && a && (n = e[++s]); ++s < a; )
    n = t(n, e[s], s, e);
  return n;
}
var ox = ix;
function cx(e) {
  return function(t) {
    return e == null ? void 0 : e[t];
  };
}
var lx = cx, dx = lx, ux = {
  // Latin-1 Supplement block.
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  Ç: "C",
  ç: "c",
  Ð: "D",
  ð: "d",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  Ñ: "N",
  ñ: "n",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  Ý: "Y",
  ý: "y",
  ÿ: "y",
  Æ: "Ae",
  æ: "ae",
  Þ: "Th",
  þ: "th",
  ß: "ss",
  // Latin Extended-A block.
  Ā: "A",
  Ă: "A",
  Ą: "A",
  ā: "a",
  ă: "a",
  ą: "a",
  Ć: "C",
  Ĉ: "C",
  Ċ: "C",
  Č: "C",
  ć: "c",
  ĉ: "c",
  ċ: "c",
  č: "c",
  Ď: "D",
  Đ: "D",
  ď: "d",
  đ: "d",
  Ē: "E",
  Ĕ: "E",
  Ė: "E",
  Ę: "E",
  Ě: "E",
  ē: "e",
  ĕ: "e",
  ė: "e",
  ę: "e",
  ě: "e",
  Ĝ: "G",
  Ğ: "G",
  Ġ: "G",
  Ģ: "G",
  ĝ: "g",
  ğ: "g",
  ġ: "g",
  ģ: "g",
  Ĥ: "H",
  Ħ: "H",
  ĥ: "h",
  ħ: "h",
  Ĩ: "I",
  Ī: "I",
  Ĭ: "I",
  Į: "I",
  İ: "I",
  ĩ: "i",
  ī: "i",
  ĭ: "i",
  į: "i",
  ı: "i",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  ĸ: "k",
  Ĺ: "L",
  Ļ: "L",
  Ľ: "L",
  Ŀ: "L",
  Ł: "L",
  ĺ: "l",
  ļ: "l",
  ľ: "l",
  ŀ: "l",
  ł: "l",
  Ń: "N",
  Ņ: "N",
  Ň: "N",
  Ŋ: "N",
  ń: "n",
  ņ: "n",
  ň: "n",
  ŋ: "n",
  Ō: "O",
  Ŏ: "O",
  Ő: "O",
  ō: "o",
  ŏ: "o",
  ő: "o",
  Ŕ: "R",
  Ŗ: "R",
  Ř: "R",
  ŕ: "r",
  ŗ: "r",
  ř: "r",
  Ś: "S",
  Ŝ: "S",
  Ş: "S",
  Š: "S",
  ś: "s",
  ŝ: "s",
  ş: "s",
  š: "s",
  Ţ: "T",
  Ť: "T",
  Ŧ: "T",
  ţ: "t",
  ť: "t",
  ŧ: "t",
  Ũ: "U",
  Ū: "U",
  Ŭ: "U",
  Ů: "U",
  Ű: "U",
  Ų: "U",
  ũ: "u",
  ū: "u",
  ŭ: "u",
  ů: "u",
  ű: "u",
  ų: "u",
  Ŵ: "W",
  ŵ: "w",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Ź: "Z",
  Ż: "Z",
  Ž: "Z",
  ź: "z",
  ż: "z",
  ž: "z",
  Ĳ: "IJ",
  ĳ: "ij",
  Œ: "Oe",
  œ: "oe",
  ŉ: "'n",
  ſ: "s"
}, fx = dx(ux), hx = fx, px = hx, mx = cn, gx = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, wx = "\\u0300-\\u036f", vx = "\\ufe20-\\ufe2f", yx = "\\u20d0-\\u20ff", xx = wx + vx + yx, bx = "[" + xx + "]", jx = RegExp(bx, "g");
function Cx(e) {
  return e = mx(e), e && e.replace(gx, px).replace(jx, "");
}
var Nx = Cx, Dx = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function Sx(e) {
  return e.match(Dx) || [];
}
var $x = Sx, Ax = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function Ex(e) {
  return Ax.test(e);
}
var Ix = Ex, Lh = "\\ud800-\\udfff", _x = "\\u0300-\\u036f", Tx = "\\ufe20-\\ufe2f", Rx = "\\u20d0-\\u20ff", Mx = _x + Tx + Rx, Fh = "\\u2700-\\u27bf", Bh = "a-z\\xdf-\\xf6\\xf8-\\xff", Px = "\\xac\\xb1\\xd7\\xf7", Ox = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", kx = "\\u2000-\\u206f", Lx = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Uh = "A-Z\\xc0-\\xd6\\xd8-\\xde", Fx = "\\ufe0e\\ufe0f", zh = Px + Ox + kx + Lx, Hh = "['’]", ud = "[" + zh + "]", Bx = "[" + Mx + "]", Wh = "\\d+", Ux = "[" + Fh + "]", Vh = "[" + Bh + "]", qh = "[^" + Lh + zh + Wh + Fh + Bh + Uh + "]", zx = "\\ud83c[\\udffb-\\udfff]", Hx = "(?:" + Bx + "|" + zx + ")", Wx = "[^" + Lh + "]", Gh = "(?:\\ud83c[\\udde6-\\uddff]){2}", Yh = "[\\ud800-\\udbff][\\udc00-\\udfff]", ir = "[" + Uh + "]", Vx = "\\u200d", fd = "(?:" + Vh + "|" + qh + ")", qx = "(?:" + ir + "|" + qh + ")", hd = "(?:" + Hh + "(?:d|ll|m|re|s|t|ve))?", pd = "(?:" + Hh + "(?:D|LL|M|RE|S|T|VE))?", Qh = Hx + "?", Zh = "[" + Fx + "]?", Gx = "(?:" + Vx + "(?:" + [Wx, Gh, Yh].join("|") + ")" + Zh + Qh + ")*", Yx = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Qx = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Zx = Zh + Qh + Gx, Kx = "(?:" + [Ux, Gh, Yh].join("|") + ")" + Zx, Jx = RegExp([
  ir + "?" + Vh + "+" + hd + "(?=" + [ud, ir, "$"].join("|") + ")",
  qx + "+" + pd + "(?=" + [ud, ir + fd, "$"].join("|") + ")",
  ir + "?" + fd + "+" + hd,
  ir + "+" + pd,
  Qx,
  Yx,
  Wh,
  Kx
].join("|"), "g");
function Xx(e) {
  return e.match(Jx) || [];
}
var e2 = Xx, t2 = $x, n2 = Ix, r2 = cn, s2 = e2;
function a2(e, t, n) {
  return e = r2(e), t = n ? void 0 : t, t === void 0 ? n2(e) ? s2(e) : t2(e) : e.match(t) || [];
}
var i2 = a2, o2 = ox, c2 = Nx, l2 = i2, d2 = "['’]", u2 = RegExp(d2, "g");
function f2(e) {
  return function(t) {
    return o2(l2(c2(t).replace(u2, "")), e, "");
  };
}
var xa = f2, h2 = qo, p2 = xa, m2 = p2(function(e, t, n) {
  return t = t.toLowerCase(), e + (n ? h2(t) : t);
}), g2 = m2;
const w2 = /* @__PURE__ */ oe(g2);
function v2(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var $t = v2;
const y2 = /* @__PURE__ */ oe($t);
var x2 = $t, md = Object.create, b2 = function() {
  function e() {
  }
  return function(t) {
    if (!x2(t))
      return {};
    if (md)
      return md(t);
    e.prototype = t;
    var n = new e();
    return e.prototype = void 0, n;
  };
}(), ba = b2;
function j2() {
}
var Go = j2, C2 = ba, N2 = Go, D2 = 4294967295;
function Zs(e) {
  this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = D2, this.__views__ = [];
}
Zs.prototype = C2(N2.prototype);
Zs.prototype.constructor = Zs;
var Yo = Zs, S2 = ba, $2 = Go;
function Ks(e, t) {
  this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!t, this.__index__ = 0, this.__values__ = void 0;
}
Ks.prototype = S2($2.prototype);
Ks.prototype.constructor = Ks;
var Qo = Ks;
function A2(e, t) {
  var n = -1, r = e.length;
  for (t || (t = Array(r)); ++n < r; )
    t[n] = e[n];
  return t;
}
var Dr = A2, E2 = Yo, I2 = Qo, _2 = Dr;
function T2(e) {
  if (e instanceof E2)
    return e.clone();
  var t = new I2(e.__wrapped__, e.__chain__);
  return t.__actions__ = _2(e.__actions__), t.__index__ = e.__index__, t.__values__ = e.__values__, t;
}
var R2 = T2, M2 = Yo, gd = Qo, P2 = Go, O2 = Ge, k2 = St, L2 = R2, F2 = Object.prototype, B2 = F2.hasOwnProperty;
function Js(e) {
  if (k2(e) && !O2(e) && !(e instanceof M2)) {
    if (e instanceof gd)
      return e;
    if (B2.call(e, "__wrapped__"))
      return L2(e);
  }
  return new gd(e);
}
Js.prototype = P2.prototype;
Js.prototype.constructor = Js;
var U2 = Js;
function z2(e, t) {
  return e === t || e !== e && t !== t;
}
var us = z2, H2 = gn, W2 = $t, V2 = "[object AsyncFunction]", q2 = "[object Function]", G2 = "[object GeneratorFunction]", Y2 = "[object Proxy]";
function Q2(e) {
  if (!W2(e))
    return !1;
  var t = H2(e);
  return t == q2 || t == G2 || t == V2 || t == Y2;
}
var Sr = Q2;
const dr = /* @__PURE__ */ oe(Sr);
var Z2 = 9007199254740991;
function K2(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Z2;
}
var Zo = K2, J2 = Sr, X2 = Zo;
function eb(e) {
  return e != null && X2(e.length) && !J2(e);
}
var $n = eb, tb = 9007199254740991, nb = /^(?:0|[1-9]\d*)$/;
function rb(e, t) {
  var n = typeof e;
  return t = t == null ? tb : t, !!t && (n == "number" || n != "symbol" && nb.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var fs = rb, sb = us, ab = $n, ib = fs, ob = $t;
function cb(e, t, n) {
  if (!ob(n))
    return !1;
  var r = typeof t;
  return (r == "number" ? ab(n) && ib(t, n.length) : r == "string" && t in n) ? sb(n[t], e) : !1;
}
var hs = cb, lb = /\s/;
function db(e) {
  for (var t = e.length; t-- && lb.test(e.charAt(t)); )
    ;
  return t;
}
var ub = db, fb = ub, hb = /^\s+/;
function pb(e) {
  return e && e.slice(0, fb(e) + 1).replace(hb, "");
}
var mb = pb, gb = mb, wd = $t, wb = Nr, vd = 0 / 0, vb = /^[-+]0x[0-9a-f]+$/i, yb = /^0b[01]+$/i, xb = /^0o[0-7]+$/i, bb = parseInt;
function jb(e) {
  if (typeof e == "number")
    return e;
  if (wb(e))
    return vd;
  if (wd(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = wd(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = gb(e);
  var n = yb.test(e);
  return n || xb.test(e) ? bb(e.slice(2), n ? 2 : 8) : vb.test(e) ? vd : +e;
}
var ja = jb, Cb = ja, yd = 1 / 0, Nb = 17976931348623157e292;
function Db(e) {
  if (!e)
    return e === 0 ? e : 0;
  if (e = Cb(e), e === yd || e === -yd) {
    var t = e < 0 ? -1 : 1;
    return t * Nb;
  }
  return e === e ? e : 0;
}
var Sb = Db, $b = Sb;
function Ab(e) {
  var t = $b(e), n = t % 1;
  return t === t ? n ? t - n : t : 0;
}
var ps = Ab, Eb = Wo, Ib = hs, _b = ps, Tb = Math.ceil, Rb = Math.max;
function Mb(e, t, n) {
  (n ? Ib(e, t, n) : t === void 0) ? t = 1 : t = Rb(_b(t), 0);
  var r = e == null ? 0 : e.length;
  if (!r || t < 1)
    return [];
  for (var s = 0, a = 0, o = Array(Tb(r / t)); s < r; )
    o[a++] = Eb(e, s, s += t);
  return o;
}
var Kh = Mb;
const Pb = /* @__PURE__ */ oe(Kh);
function Ob() {
  this.__data__ = [], this.size = 0;
}
var kb = Ob, Lb = us;
function Fb(e, t) {
  for (var n = e.length; n--; )
    if (Lb(e[n][0], t))
      return n;
  return -1;
}
var Ca = Fb, Bb = Ca, Ub = Array.prototype, zb = Ub.splice;
function Hb(e) {
  var t = this.__data__, n = Bb(t, e);
  if (n < 0)
    return !1;
  var r = t.length - 1;
  return n == r ? t.pop() : zb.call(t, n, 1), --this.size, !0;
}
var Wb = Hb, Vb = Ca;
function qb(e) {
  var t = this.__data__, n = Vb(t, e);
  return n < 0 ? void 0 : t[n][1];
}
var Gb = qb, Yb = Ca;
function Qb(e) {
  return Yb(this.__data__, e) > -1;
}
var Zb = Qb, Kb = Ca;
function Jb(e, t) {
  var n = this.__data__, r = Kb(n, e);
  return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
var Xb = Jb, e5 = kb, t5 = Wb, n5 = Gb, r5 = Zb, s5 = Xb;
function $r(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
$r.prototype.clear = e5;
$r.prototype.delete = t5;
$r.prototype.get = n5;
$r.prototype.has = r5;
$r.prototype.set = s5;
var Na = $r, a5 = Na;
function i5() {
  this.__data__ = new a5(), this.size = 0;
}
var o5 = i5;
function c5(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
var l5 = c5;
function d5(e) {
  return this.__data__.get(e);
}
var u5 = d5;
function f5(e) {
  return this.__data__.has(e);
}
var h5 = f5, p5 = gt, m5 = p5["__core-js_shared__"], g5 = m5, li = g5, xd = function() {
  var e = /[^.]+$/.exec(li && li.keys && li.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function w5(e) {
  return !!xd && xd in e;
}
var v5 = w5, y5 = Function.prototype, x5 = y5.toString;
function b5(e) {
  if (e != null) {
    try {
      return x5.call(e);
    } catch (t) {
    }
    try {
      return e + "";
    } catch (t) {
    }
  }
  return "";
}
var Jh = b5, j5 = Sr, C5 = v5, N5 = $t, D5 = Jh, S5 = /[\\^$.*+?()[\]{}|]/g, $5 = /^\[object .+?Constructor\]$/, A5 = Function.prototype, E5 = Object.prototype, I5 = A5.toString, _5 = E5.hasOwnProperty, T5 = RegExp(
  "^" + I5.call(_5).replace(S5, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function R5(e) {
  if (!N5(e) || C5(e))
    return !1;
  var t = j5(e) ? T5 : $5;
  return t.test(D5(e));
}
var M5 = R5;
function P5(e, t) {
  return e == null ? void 0 : e[t];
}
var O5 = P5, k5 = M5, L5 = O5;
function F5(e, t) {
  var n = L5(e, t);
  return k5(n) ? n : void 0;
}
var zn = F5, B5 = zn, U5 = gt, z5 = B5(U5, "Map"), Ko = z5, H5 = zn, W5 = H5(Object, "create"), Da = W5, bd = Da;
function V5() {
  this.__data__ = bd ? bd(null) : {}, this.size = 0;
}
var q5 = V5;
function G5(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var Y5 = G5, Q5 = Da, Z5 = "__lodash_hash_undefined__", K5 = Object.prototype, J5 = K5.hasOwnProperty;
function X5(e) {
  var t = this.__data__;
  if (Q5) {
    var n = t[e];
    return n === Z5 ? void 0 : n;
  }
  return J5.call(t, e) ? t[e] : void 0;
}
var ej = X5, tj = Da, nj = Object.prototype, rj = nj.hasOwnProperty;
function sj(e) {
  var t = this.__data__;
  return tj ? t[e] !== void 0 : rj.call(t, e);
}
var aj = sj, ij = Da, oj = "__lodash_hash_undefined__";
function cj(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = ij && t === void 0 ? oj : t, this;
}
var lj = cj, dj = q5, uj = Y5, fj = ej, hj = aj, pj = lj;
function Ar(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Ar.prototype.clear = dj;
Ar.prototype.delete = uj;
Ar.prototype.get = fj;
Ar.prototype.has = hj;
Ar.prototype.set = pj;
var mj = Ar, jd = mj, gj = Na, wj = Ko;
function vj() {
  this.size = 0, this.__data__ = {
    hash: new jd(),
    map: new (wj || gj)(),
    string: new jd()
  };
}
var yj = vj;
function xj(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var bj = xj, jj = bj;
function Cj(e, t) {
  var n = e.__data__;
  return jj(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
var Sa = Cj, Nj = Sa;
function Dj(e) {
  var t = Nj(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var Sj = Dj, $j = Sa;
function Aj(e) {
  return $j(this, e).get(e);
}
var Ej = Aj, Ij = Sa;
function _j(e) {
  return Ij(this, e).has(e);
}
var Tj = _j, Rj = Sa;
function Mj(e, t) {
  var n = Rj(this, e), r = n.size;
  return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
var Pj = Mj, Oj = yj, kj = Sj, Lj = Ej, Fj = Tj, Bj = Pj;
function Er(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Er.prototype.clear = Oj;
Er.prototype.delete = kj;
Er.prototype.get = Lj;
Er.prototype.has = Fj;
Er.prototype.set = Bj;
var Jo = Er, Uj = Na, zj = Ko, Hj = Jo, Wj = 200;
function Vj(e, t) {
  var n = this.__data__;
  if (n instanceof Uj) {
    var r = n.__data__;
    if (!zj || r.length < Wj - 1)
      return r.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new Hj(r);
  }
  return n.set(e, t), this.size = n.size, this;
}
var qj = Vj, Gj = Na, Yj = o5, Qj = l5, Zj = u5, Kj = h5, Jj = qj;
function Ir(e) {
  var t = this.__data__ = new Gj(e);
  this.size = t.size;
}
Ir.prototype.clear = Yj;
Ir.prototype.delete = Qj;
Ir.prototype.get = Zj;
Ir.prototype.has = Kj;
Ir.prototype.set = Jj;
var $a = Ir;
function Xj(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r && t(e[n], n, e) !== !1; )
    ;
  return e;
}
var Xo = Xj, e3 = zn, t3 = function() {
  try {
    var e = e3(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch (t) {
  }
}(), Xh = t3, Cd = Xh;
function n3(e, t, n) {
  t == "__proto__" && Cd ? Cd(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
var _r = n3, r3 = _r, s3 = us, a3 = Object.prototype, i3 = a3.hasOwnProperty;
function o3(e, t, n) {
  var r = e[t];
  (!(i3.call(e, t) && s3(r, n)) || n === void 0 && !(t in e)) && r3(e, t, n);
}
var ec = o3, c3 = ec, l3 = _r;
function d3(e, t, n, r) {
  var s = !n;
  n || (n = {});
  for (var a = -1, o = t.length; ++a < o; ) {
    var c = t[a], l = r ? r(n[c], e[c], c, n, e) : void 0;
    l === void 0 && (l = e[c]), s ? l3(n, c, l) : c3(n, c, l);
  }
  return n;
}
var Tr = d3;
function u3(e, t) {
  for (var n = -1, r = Array(e); ++n < e; )
    r[n] = t(n);
  return r;
}
var f3 = u3, h3 = gn, p3 = St, m3 = "[object Arguments]";
function g3(e) {
  return p3(e) && h3(e) == m3;
}
var w3 = g3, Nd = w3, v3 = St, ep = Object.prototype, y3 = ep.hasOwnProperty, x3 = ep.propertyIsEnumerable, b3 = Nd(function() {
  return arguments;
}()) ? Nd : function(e) {
  return v3(e) && y3.call(e, "callee") && !x3.call(e, "callee");
}, ms = b3, Xs = { exports: {} };
function j3() {
  return !1;
}
var C3 = j3;
Xs.exports;
(function(e, t) {
  var n = gt, r = C3, s = t && !t.nodeType && t, a = s && !0 && e && !e.nodeType && e, o = a && a.exports === s, c = o ? n.Buffer : void 0, l = c ? c.isBuffer : void 0, d = l || r;
  e.exports = d;
})(Xs, Xs.exports);
var gs = Xs.exports, N3 = gn, D3 = Zo, S3 = St, $3 = "[object Arguments]", A3 = "[object Array]", E3 = "[object Boolean]", I3 = "[object Date]", _3 = "[object Error]", T3 = "[object Function]", R3 = "[object Map]", M3 = "[object Number]", P3 = "[object Object]", O3 = "[object RegExp]", k3 = "[object Set]", L3 = "[object String]", F3 = "[object WeakMap]", B3 = "[object ArrayBuffer]", U3 = "[object DataView]", z3 = "[object Float32Array]", H3 = "[object Float64Array]", W3 = "[object Int8Array]", V3 = "[object Int16Array]", q3 = "[object Int32Array]", G3 = "[object Uint8Array]", Y3 = "[object Uint8ClampedArray]", Q3 = "[object Uint16Array]", Z3 = "[object Uint32Array]", Ve = {};
Ve[z3] = Ve[H3] = Ve[W3] = Ve[V3] = Ve[q3] = Ve[G3] = Ve[Y3] = Ve[Q3] = Ve[Z3] = !0;
Ve[$3] = Ve[A3] = Ve[B3] = Ve[E3] = Ve[U3] = Ve[I3] = Ve[_3] = Ve[T3] = Ve[R3] = Ve[M3] = Ve[P3] = Ve[O3] = Ve[k3] = Ve[L3] = Ve[F3] = !1;
function K3(e) {
  return S3(e) && D3(e.length) && !!Ve[N3(e)];
}
var J3 = K3;
function X3(e) {
  return function(t) {
    return e(t);
  };
}
var Rr = X3, ea = { exports: {} };
ea.exports;
(function(e, t) {
  var n = Dh, r = t && !t.nodeType && t, s = r && !0 && e && !e.nodeType && e, a = s && s.exports === r, o = a && n.process, c = function() {
    try {
      var l = s && s.require && s.require("util").types;
      return l || o && o.binding && o.binding("util");
    } catch (d) {
    }
  }();
  e.exports = c;
})(ea, ea.exports);
var Aa = ea.exports, eC = J3, tC = Rr, Dd = Aa, Sd = Dd && Dd.isTypedArray, nC = Sd ? tC(Sd) : eC, Ea = nC, rC = f3, sC = ms, aC = Ge, iC = gs, oC = fs, cC = Ea, lC = Object.prototype, dC = lC.hasOwnProperty;
function uC(e, t) {
  var n = aC(e), r = !n && sC(e), s = !n && !r && iC(e), a = !n && !r && !s && cC(e), o = n || r || s || a, c = o ? rC(e.length, String) : [], l = c.length;
  for (var d in e)
    (t || dC.call(e, d)) && !(o && // Safari 9 has enumerable `arguments.length` in strict mode.
    (d == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    s && (d == "offset" || d == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    a && (d == "buffer" || d == "byteLength" || d == "byteOffset") || // Skip index properties.
    oC(d, l))) && c.push(d);
  return c;
}
var tp = uC, fC = Object.prototype;
function hC(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || fC;
  return e === n;
}
var Ia = hC;
function pC(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var np = pC, mC = np, gC = mC(Object.keys, Object), wC = gC, vC = Ia, yC = wC, xC = Object.prototype, bC = xC.hasOwnProperty;
function jC(e) {
  if (!vC(e))
    return yC(e);
  var t = [];
  for (var n in Object(e))
    bC.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
var tc = jC, CC = tp, NC = tc, DC = $n;
function SC(e) {
  return DC(e) ? CC(e) : NC(e);
}
var An = SC, $C = Tr, AC = An;
function EC(e, t) {
  return e && $C(t, AC(t), e);
}
var rp = EC;
function IC(e) {
  var t = [];
  if (e != null)
    for (var n in Object(e))
      t.push(n);
  return t;
}
var _C = IC, TC = $t, RC = Ia, MC = _C, PC = Object.prototype, OC = PC.hasOwnProperty;
function kC(e) {
  if (!TC(e))
    return MC(e);
  var t = RC(e), n = [];
  for (var r in e)
    r == "constructor" && (t || !OC.call(e, r)) || n.push(r);
  return n;
}
var LC = kC, FC = tp, BC = LC, UC = $n;
function zC(e) {
  return UC(e) ? FC(e, !0) : BC(e);
}
var ws = zC, HC = Tr, WC = ws;
function VC(e, t) {
  return e && HC(t, WC(t), e);
}
var qC = VC, ta = { exports: {} };
ta.exports;
(function(e, t) {
  var n = gt, r = t && !t.nodeType && t, s = r && !0 && e && !e.nodeType && e, a = s && s.exports === r, o = a ? n.Buffer : void 0, c = o ? o.allocUnsafe : void 0;
  function l(d, u) {
    if (u)
      return d.slice();
    var h = d.length, f = c ? c(h) : new d.constructor(h);
    return d.copy(f), f;
  }
  e.exports = l;
})(ta, ta.exports);
var sp = ta.exports;
function GC(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, s = 0, a = []; ++n < r; ) {
    var o = e[n];
    t(o, n, e) && (a[s++] = o);
  }
  return a;
}
var ap = GC;
function YC() {
  return [];
}
var ip = YC, QC = ap, ZC = ip, KC = Object.prototype, JC = KC.propertyIsEnumerable, $d = Object.getOwnPropertySymbols, XC = $d ? function(e) {
  return e == null ? [] : (e = Object(e), QC($d(e), function(t) {
    return JC.call(e, t);
  }));
} : ZC, nc = XC, eN = Tr, tN = nc;
function nN(e, t) {
  return eN(e, tN(e), t);
}
var rN = nN;
function sN(e, t) {
  for (var n = -1, r = t.length, s = e.length; ++n < r; )
    e[s + n] = t[n];
  return e;
}
var _a = sN, aN = np, iN = aN(Object.getPrototypeOf, Object), rc = iN, oN = _a, cN = rc, lN = nc, dN = ip, uN = Object.getOwnPropertySymbols, fN = uN ? function(e) {
  for (var t = []; e; )
    oN(t, lN(e)), e = cN(e);
  return t;
} : dN, op = fN, hN = Tr, pN = op;
function mN(e, t) {
  return hN(e, pN(e), t);
}
var gN = mN, wN = _a, vN = Ge;
function yN(e, t, n) {
  var r = t(e);
  return vN(e) ? r : wN(r, n(e));
}
var cp = yN, xN = cp, bN = nc, jN = An;
function CN(e) {
  return xN(e, jN, bN);
}
var lp = CN, NN = cp, DN = op, SN = ws;
function $N(e) {
  return NN(e, SN, DN);
}
var sc = $N, AN = zn, EN = gt, IN = AN(EN, "DataView"), _N = IN, TN = zn, RN = gt, MN = TN(RN, "Promise"), PN = MN, ON = zn, kN = gt, LN = ON(kN, "Set"), dp = LN, FN = zn, BN = gt, UN = FN(BN, "WeakMap"), up = UN, lo = _N, uo = Ko, fo = PN, ho = dp, po = up, fp = gn, Mr = Jh, Ad = "[object Map]", zN = "[object Object]", Ed = "[object Promise]", Id = "[object Set]", _d = "[object WeakMap]", Td = "[object DataView]", HN = Mr(lo), WN = Mr(uo), VN = Mr(fo), qN = Mr(ho), GN = Mr(po), Mn = fp;
(lo && Mn(new lo(new ArrayBuffer(1))) != Td || uo && Mn(new uo()) != Ad || fo && Mn(fo.resolve()) != Ed || ho && Mn(new ho()) != Id || po && Mn(new po()) != _d) && (Mn = function(e) {
  var t = fp(e), n = t == zN ? e.constructor : void 0, r = n ? Mr(n) : "";
  if (r)
    switch (r) {
      case HN:
        return Td;
      case WN:
        return Ad;
      case VN:
        return Ed;
      case qN:
        return Id;
      case GN:
        return _d;
    }
  return t;
});
var Pr = Mn, YN = Object.prototype, QN = YN.hasOwnProperty;
function ZN(e) {
  var t = e.length, n = new e.constructor(t);
  return t && typeof e[0] == "string" && QN.call(e, "index") && (n.index = e.index, n.input = e.input), n;
}
var KN = ZN, JN = gt, XN = JN.Uint8Array, hp = XN, Rd = hp;
function e4(e) {
  var t = new e.constructor(e.byteLength);
  return new Rd(t).set(new Rd(e)), t;
}
var ac = e4, t4 = ac;
function n4(e, t) {
  var n = t ? t4(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.byteLength);
}
var r4 = n4, s4 = /\w*$/;
function a4(e) {
  var t = new e.constructor(e.source, s4.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var i4 = a4, Md = Cr, Pd = Md ? Md.prototype : void 0, Od = Pd ? Pd.valueOf : void 0;
function o4(e) {
  return Od ? Object(Od.call(e)) : {};
}
var c4 = o4, l4 = ac;
function d4(e, t) {
  var n = t ? l4(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.length);
}
var pp = d4, u4 = ac, f4 = r4, h4 = i4, p4 = c4, m4 = pp, g4 = "[object Boolean]", w4 = "[object Date]", v4 = "[object Map]", y4 = "[object Number]", x4 = "[object RegExp]", b4 = "[object Set]", j4 = "[object String]", C4 = "[object Symbol]", N4 = "[object ArrayBuffer]", D4 = "[object DataView]", S4 = "[object Float32Array]", $4 = "[object Float64Array]", A4 = "[object Int8Array]", E4 = "[object Int16Array]", I4 = "[object Int32Array]", _4 = "[object Uint8Array]", T4 = "[object Uint8ClampedArray]", R4 = "[object Uint16Array]", M4 = "[object Uint32Array]";
function P4(e, t, n) {
  var r = e.constructor;
  switch (t) {
    case N4:
      return u4(e);
    case g4:
    case w4:
      return new r(+e);
    case D4:
      return f4(e, n);
    case S4:
    case $4:
    case A4:
    case E4:
    case I4:
    case _4:
    case T4:
    case R4:
    case M4:
      return m4(e, n);
    case v4:
      return new r();
    case y4:
    case j4:
      return new r(e);
    case x4:
      return h4(e);
    case b4:
      return new r();
    case C4:
      return p4(e);
  }
}
var O4 = P4, k4 = ba, L4 = rc, F4 = Ia;
function B4(e) {
  return typeof e.constructor == "function" && !F4(e) ? k4(L4(e)) : {};
}
var mp = B4, U4 = Pr, z4 = St, H4 = "[object Map]";
function W4(e) {
  return z4(e) && U4(e) == H4;
}
var V4 = W4, q4 = V4, G4 = Rr, kd = Aa, Ld = kd && kd.isMap, Y4 = Ld ? G4(Ld) : q4, Q4 = Y4, Z4 = Pr, K4 = St, J4 = "[object Set]";
function X4(e) {
  return K4(e) && Z4(e) == J4;
}
var eD = X4, tD = eD, nD = Rr, Fd = Aa, Bd = Fd && Fd.isSet, rD = Bd ? nD(Bd) : tD, sD = rD, aD = $a, iD = Xo, oD = ec, cD = rp, lD = qC, dD = sp, uD = Dr, fD = rN, hD = gN, pD = lp, mD = sc, gD = Pr, wD = KN, vD = O4, yD = mp, xD = Ge, bD = gs, jD = Q4, CD = $t, ND = sD, DD = An, SD = ws, $D = 1, AD = 2, ED = 4, gp = "[object Arguments]", ID = "[object Array]", _D = "[object Boolean]", TD = "[object Date]", RD = "[object Error]", wp = "[object Function]", MD = "[object GeneratorFunction]", PD = "[object Map]", OD = "[object Number]", vp = "[object Object]", kD = "[object RegExp]", LD = "[object Set]", FD = "[object String]", BD = "[object Symbol]", UD = "[object WeakMap]", zD = "[object ArrayBuffer]", HD = "[object DataView]", WD = "[object Float32Array]", VD = "[object Float64Array]", qD = "[object Int8Array]", GD = "[object Int16Array]", YD = "[object Int32Array]", QD = "[object Uint8Array]", ZD = "[object Uint8ClampedArray]", KD = "[object Uint16Array]", JD = "[object Uint32Array]", We = {};
We[gp] = We[ID] = We[zD] = We[HD] = We[_D] = We[TD] = We[WD] = We[VD] = We[qD] = We[GD] = We[YD] = We[PD] = We[OD] = We[vp] = We[kD] = We[LD] = We[FD] = We[BD] = We[QD] = We[ZD] = We[KD] = We[JD] = !0;
We[RD] = We[wp] = We[UD] = !1;
function Us(e, t, n, r, s, a) {
  var o, c = t & $D, l = t & AD, d = t & ED;
  if (n && (o = s ? n(e, r, s, a) : n(e)), o !== void 0)
    return o;
  if (!CD(e))
    return e;
  var u = xD(e);
  if (u) {
    if (o = wD(e), !c)
      return uD(e, o);
  } else {
    var h = gD(e), f = h == wp || h == MD;
    if (bD(e))
      return dD(e, c);
    if (h == vp || h == gp || f && !s) {
      if (o = l || f ? {} : yD(e), !c)
        return l ? hD(e, lD(o, e)) : fD(e, cD(o, e));
    } else {
      if (!We[h])
        return s ? e : {};
      o = vD(e, h, c);
    }
  }
  a || (a = new aD());
  var p = a.get(e);
  if (p)
    return p;
  a.set(e, o), ND(e) ? e.forEach(function(y) {
    o.add(Us(y, t, n, y, e, a));
  }) : jD(e) && e.forEach(function(y, g) {
    o.set(g, Us(y, t, n, g, e, a));
  });
  var m = d ? l ? mD : pD : l ? SD : DD, C = u ? void 0 : m(e);
  return iD(C || e, function(y, g) {
    C && (g = y, y = e[g]), oD(o, g, Us(y, t, n, g, e, a));
  }), o;
}
var vs = Us, XD = vs, eS = 4;
function tS(e) {
  return XD(e, eS);
}
var nS = tS, rS = vs, sS = 1, aS = 4;
function iS(e) {
  return rS(e, sS | aS);
}
var yp = iS;
const Fn = /* @__PURE__ */ oe(yp);
function oS(e) {
  for (var t = -1, n = e == null ? 0 : e.length, r = 0, s = []; ++t < n; ) {
    var a = e[t];
    a && (s[r++] = a);
  }
  return s;
}
var xp = oS;
const Ee = /* @__PURE__ */ oe(xp);
var Ud = Cr, cS = ms, lS = Ge, zd = Ud ? Ud.isConcatSpreadable : void 0;
function dS(e) {
  return lS(e) || cS(e) || !!(zd && e && e[zd]);
}
var uS = dS, fS = _a, hS = uS;
function bp(e, t, n, r, s) {
  var a = -1, o = e.length;
  for (n || (n = hS), s || (s = []); ++a < o; ) {
    var c = e[a];
    t > 0 && n(c) ? t > 1 ? bp(c, t - 1, n, r, s) : fS(s, c) : r || (s[s.length] = c);
  }
  return s;
}
var ic = bp, pS = _a, mS = ic, gS = Dr, wS = Ge;
function vS() {
  var e = arguments.length;
  if (!e)
    return [];
  for (var t = Array(e - 1), n = arguments[0], r = e; r--; )
    t[r - 1] = arguments[r];
  return pS(wS(n) ? gS(n) : [n], mS(t, 1));
}
var yS = vS;
function xS(e) {
  return e;
}
var Hn = xS;
const bS = /* @__PURE__ */ oe(Hn);
var Hd = up, jS = Hd && new Hd(), jp = jS, CS = Hn, Wd = jp, NS = Wd ? function(e, t) {
  return Wd.set(e, t), e;
} : CS, Cp = NS, DS = ba, SS = $t;
function $S(e) {
  return function() {
    var t = arguments;
    switch (t.length) {
      case 0:
        return new e();
      case 1:
        return new e(t[0]);
      case 2:
        return new e(t[0], t[1]);
      case 3:
        return new e(t[0], t[1], t[2]);
      case 4:
        return new e(t[0], t[1], t[2], t[3]);
      case 5:
        return new e(t[0], t[1], t[2], t[3], t[4]);
      case 6:
        return new e(t[0], t[1], t[2], t[3], t[4], t[5]);
      case 7:
        return new e(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
    }
    var n = DS(e.prototype), r = e.apply(n, t);
    return SS(r) ? r : n;
  };
}
var Ta = $S, AS = Ta, ES = gt, IS = 1;
function _S(e, t, n) {
  var r = t & IS, s = AS(e);
  function a() {
    var o = this && this !== ES && this instanceof a ? s : e;
    return o.apply(r ? n : this, arguments);
  }
  return a;
}
var TS = _S;
function RS(e, t, n) {
  switch (n.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, n[0]);
    case 2:
      return e.call(t, n[0], n[1]);
    case 3:
      return e.call(t, n[0], n[1], n[2]);
  }
  return e.apply(t, n);
}
var oc = RS, MS = Math.max;
function PS(e, t, n, r) {
  for (var s = -1, a = e.length, o = n.length, c = -1, l = t.length, d = MS(a - o, 0), u = Array(l + d), h = !r; ++c < l; )
    u[c] = t[c];
  for (; ++s < o; )
    (h || s < a) && (u[n[s]] = e[s]);
  for (; d--; )
    u[c++] = e[s++];
  return u;
}
var Np = PS, OS = Math.max;
function kS(e, t, n, r) {
  for (var s = -1, a = e.length, o = -1, c = n.length, l = -1, d = t.length, u = OS(a - c, 0), h = Array(u + d), f = !r; ++s < u; )
    h[s] = e[s];
  for (var p = s; ++l < d; )
    h[p + l] = t[l];
  for (; ++o < c; )
    (f || s < a) && (h[p + n[o]] = e[s++]);
  return h;
}
var Dp = kS;
function LS(e, t) {
  for (var n = e.length, r = 0; n--; )
    e[n] === t && ++r;
  return r;
}
var FS = LS;
function BS() {
}
var Sp = BS, Vd = jp, US = Sp, zS = Vd ? function(e) {
  return Vd.get(e);
} : US, cc = zS, HS = {}, WS = HS, qd = WS, VS = Object.prototype, qS = VS.hasOwnProperty;
function GS(e) {
  for (var t = e.name + "", n = qd[t], r = qS.call(qd, t) ? n.length : 0; r--; ) {
    var s = n[r], a = s.func;
    if (a == null || a == e)
      return s.name;
  }
  return t;
}
var $p = GS, YS = Yo, QS = cc, ZS = $p, KS = U2;
function JS(e) {
  var t = ZS(e), n = KS[t];
  if (typeof n != "function" || !(t in YS.prototype))
    return !1;
  if (e === n)
    return !0;
  var r = QS(n);
  return !!r && e === r[0];
}
var Ap = JS, XS = 800, e$ = 16, t$ = Date.now;
function n$(e) {
  var t = 0, n = 0;
  return function() {
    var r = t$(), s = e$ - (r - n);
    if (n = r, s > 0) {
      if (++t >= XS)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
var Ep = n$, r$ = Cp, s$ = Ep, a$ = s$(r$), Ip = a$, i$ = /\{\n\/\* \[wrapped with (.+)\] \*/, o$ = /,? & /;
function c$(e) {
  var t = e.match(i$);
  return t ? t[1].split(o$) : [];
}
var l$ = c$, d$ = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
function u$(e, t) {
  var n = t.length;
  if (!n)
    return e;
  var r = n - 1;
  return t[r] = (n > 1 ? "& " : "") + t[r], t = t.join(n > 2 ? ", " : " "), e.replace(d$, `{
/* [wrapped with ` + t + `] */
`);
}
var f$ = u$;
function h$(e) {
  return function() {
    return e;
  };
}
var p$ = h$, m$ = p$, Gd = Xh, g$ = Hn, w$ = Gd ? function(e, t) {
  return Gd(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: m$(t),
    writable: !0
  });
} : g$, v$ = w$, y$ = v$, x$ = Ep, b$ = x$(y$), lc = b$;
function j$(e, t, n, r) {
  for (var s = e.length, a = n + (r ? 1 : -1); r ? a-- : ++a < s; )
    if (t(e[a], a, e))
      return a;
  return -1;
}
var _p = j$;
function C$(e) {
  return e !== e;
}
var N$ = C$;
function D$(e, t, n) {
  for (var r = n - 1, s = e.length; ++r < s; )
    if (e[r] === t)
      return r;
  return -1;
}
var S$ = D$, $$ = _p, A$ = N$, E$ = S$;
function I$(e, t, n) {
  return t === t ? E$(e, t, n) : $$(e, A$, n);
}
var _$ = I$, T$ = _$;
function R$(e, t) {
  var n = e == null ? 0 : e.length;
  return !!n && T$(e, t, 0) > -1;
}
var dc = R$, M$ = Xo, P$ = dc, O$ = 1, k$ = 2, L$ = 8, F$ = 16, B$ = 32, U$ = 64, z$ = 128, H$ = 256, W$ = 512, V$ = [
  ["ary", z$],
  ["bind", O$],
  ["bindKey", k$],
  ["curry", L$],
  ["curryRight", F$],
  ["flip", W$],
  ["partial", B$],
  ["partialRight", U$],
  ["rearg", H$]
];
function q$(e, t) {
  return M$(V$, function(n) {
    var r = "_." + n[0];
    t & n[1] && !P$(e, r) && e.push(r);
  }), e.sort();
}
var G$ = q$, Y$ = l$, Q$ = f$, Z$ = lc, K$ = G$;
function J$(e, t, n) {
  var r = t + "";
  return Z$(e, Q$(r, K$(Y$(r), n)));
}
var Tp = J$, X$ = Ap, eA = Ip, tA = Tp, nA = 1, rA = 2, sA = 4, aA = 8, Yd = 32, Qd = 64;
function iA(e, t, n, r, s, a, o, c, l, d) {
  var u = t & aA, h = u ? o : void 0, f = u ? void 0 : o, p = u ? a : void 0, m = u ? void 0 : a;
  t |= u ? Yd : Qd, t &= ~(u ? Qd : Yd), t & sA || (t &= ~(nA | rA));
  var C = [
    e,
    t,
    s,
    p,
    h,
    m,
    f,
    c,
    l,
    d
  ], y = n.apply(void 0, C);
  return X$(e) && eA(y, C), y.placeholder = r, tA(y, e, t);
}
var Rp = iA;
function oA(e) {
  var t = e;
  return t.placeholder;
}
var Mp = oA, cA = Dr, lA = fs, dA = Math.min;
function uA(e, t) {
  for (var n = e.length, r = dA(t.length, n), s = cA(e); r--; ) {
    var a = t[r];
    e[r] = lA(a, n) ? s[a] : void 0;
  }
  return e;
}
var fA = uA, Zd = "__lodash_placeholder__";
function hA(e, t) {
  for (var n = -1, r = e.length, s = 0, a = []; ++n < r; ) {
    var o = e[n];
    (o === t || o === Zd) && (e[n] = Zd, a[s++] = n);
  }
  return a;
}
var uc = hA, pA = Np, mA = Dp, gA = FS, Kd = Ta, wA = Rp, vA = Mp, yA = fA, xA = uc, bA = gt, jA = 1, CA = 2, NA = 8, DA = 16, SA = 128, $A = 512;
function Pp(e, t, n, r, s, a, o, c, l, d) {
  var u = t & SA, h = t & jA, f = t & CA, p = t & (NA | DA), m = t & $A, C = f ? void 0 : Kd(e);
  function y() {
    for (var g = arguments.length, w = Array(g), x = g; x--; )
      w[x] = arguments[x];
    if (p)
      var S = vA(y), N = gA(w, S);
    if (r && (w = pA(w, r, s, p)), a && (w = mA(w, a, o, p)), g -= N, p && g < d) {
      var v = xA(w, S);
      return wA(
        e,
        t,
        Pp,
        y.placeholder,
        n,
        w,
        v,
        c,
        l,
        d - g
      );
    }
    var b = h ? n : this, j = f ? b[e] : e;
    return g = w.length, c ? w = yA(w, c) : m && g > 1 && w.reverse(), u && l < g && (w.length = l), this && this !== bA && this instanceof y && (j = C || Kd(j)), j.apply(b, w);
  }
  return y;
}
var Op = Pp, AA = oc, EA = Ta, IA = Op, _A = Rp, TA = Mp, RA = uc, MA = gt;
function PA(e, t, n) {
  var r = EA(e);
  function s() {
    for (var a = arguments.length, o = Array(a), c = a, l = TA(s); c--; )
      o[c] = arguments[c];
    var d = a < 3 && o[0] !== l && o[a - 1] !== l ? [] : RA(o, l);
    if (a -= d.length, a < n)
      return _A(
        e,
        t,
        IA,
        s.placeholder,
        void 0,
        o,
        d,
        void 0,
        void 0,
        n - a
      );
    var u = this && this !== MA && this instanceof s ? r : e;
    return AA(u, this, o);
  }
  return s;
}
var OA = PA, kA = oc, LA = Ta, FA = gt, BA = 1;
function UA(e, t, n, r) {
  var s = t & BA, a = LA(e);
  function o() {
    for (var c = -1, l = arguments.length, d = -1, u = r.length, h = Array(u + l), f = this && this !== FA && this instanceof o ? a : e; ++d < u; )
      h[d] = r[d];
    for (; l--; )
      h[d++] = arguments[++c];
    return kA(f, s ? n : this, h);
  }
  return o;
}
var zA = UA, HA = Np, WA = Dp, Jd = uc, Xd = "__lodash_placeholder__", di = 1, VA = 2, qA = 4, eu = 8, Zr = 128, tu = 256, GA = Math.min;
function YA(e, t) {
  var n = e[1], r = t[1], s = n | r, a = s < (di | VA | Zr), o = r == Zr && n == eu || r == Zr && n == tu && e[7].length <= t[8] || r == (Zr | tu) && t[7].length <= t[8] && n == eu;
  if (!(a || o))
    return e;
  r & di && (e[2] = t[2], s |= n & di ? 0 : qA);
  var c = t[3];
  if (c) {
    var l = e[3];
    e[3] = l ? HA(l, c, t[4]) : c, e[4] = l ? Jd(e[3], Xd) : t[4];
  }
  return c = t[5], c && (l = e[5], e[5] = l ? WA(l, c, t[6]) : c, e[6] = l ? Jd(e[5], Xd) : t[6]), c = t[7], c && (e[7] = c), r & Zr && (e[8] = e[8] == null ? t[8] : GA(e[8], t[8])), e[9] == null && (e[9] = t[9]), e[0] = t[0], e[1] = s, e;
}
var QA = YA, ZA = Cp, KA = TS, JA = OA, XA = Op, eE = zA, tE = cc, nE = QA, rE = Ip, sE = Tp, nu = ps, aE = "Expected a function", ru = 1, iE = 2, ui = 8, fi = 16, hi = 32, su = 64, au = Math.max;
function oE(e, t, n, r, s, a, o, c) {
  var l = t & iE;
  if (!l && typeof e != "function")
    throw new TypeError(aE);
  var d = r ? r.length : 0;
  if (d || (t &= ~(hi | su), r = s = void 0), o = o === void 0 ? o : au(nu(o), 0), c = c === void 0 ? c : nu(c), d -= s ? s.length : 0, t & su) {
    var u = r, h = s;
    r = s = void 0;
  }
  var f = l ? void 0 : tE(e), p = [
    e,
    t,
    n,
    r,
    s,
    u,
    h,
    a,
    o,
    c
  ];
  if (f && nE(p, f), e = p[0], t = p[1], n = p[2], r = p[3], s = p[4], c = p[9] = p[9] === void 0 ? l ? 0 : e.length : au(p[9] - d, 0), !c && t & (ui | fi) && (t &= ~(ui | fi)), !t || t == ru)
    var m = KA(e, t, n);
  else
    t == ui || t == fi ? m = JA(e, t, c) : (t == hi || t == (ru | hi)) && !s.length ? m = eE(e, t, n, r) : m = XA.apply(void 0, p);
  var C = f ? ZA : rE;
  return sE(C(m, p), e, t);
}
var fc = oE, cE = fc, lE = 8;
function hc(e, t, n) {
  t = n ? void 0 : t;
  var r = cE(e, lE, void 0, void 0, void 0, void 0, void 0, t);
  return r.placeholder = hc.placeholder, r;
}
hc.placeholder = {};
var kp = hc;
const dE = /* @__PURE__ */ oe(kp);
var uE = gt, fE = function() {
  return uE.Date.now();
}, hE = fE, pE = $t, pi = hE, iu = ja, mE = "Expected a function", gE = Math.max, wE = Math.min;
function vE(e, t, n) {
  var r, s, a, o, c, l, d = 0, u = !1, h = !1, f = !0;
  if (typeof e != "function")
    throw new TypeError(mE);
  t = iu(t) || 0, pE(n) && (u = !!n.leading, h = "maxWait" in n, a = h ? gE(iu(n.maxWait) || 0, t) : a, f = "trailing" in n ? !!n.trailing : f);
  function p(v) {
    var b = r, j = s;
    return r = s = void 0, d = v, o = e.apply(j, b), o;
  }
  function m(v) {
    return d = v, c = setTimeout(g, t), u ? p(v) : o;
  }
  function C(v) {
    var b = v - l, j = v - d, D = t - b;
    return h ? wE(D, a - j) : D;
  }
  function y(v) {
    var b = v - l, j = v - d;
    return l === void 0 || b >= t || b < 0 || h && j >= a;
  }
  function g() {
    var v = pi();
    if (y(v))
      return w(v);
    c = setTimeout(g, C(v));
  }
  function w(v) {
    return c = void 0, f && r ? p(v) : (r = s = void 0, o);
  }
  function x() {
    c !== void 0 && clearTimeout(c), d = 0, r = l = s = c = void 0;
  }
  function S() {
    return c === void 0 ? o : w(pi());
  }
  function N() {
    var v = pi(), b = y(v);
    if (r = arguments, s = this, l = v, b) {
      if (c === void 0)
        return m(l);
      if (h)
        return clearTimeout(c), c = setTimeout(g, t), p(l);
    }
    return c === void 0 && (c = setTimeout(g, t)), o;
  }
  return N.cancel = x, N.flush = S, N;
}
var yE = vE;
const xE = /* @__PURE__ */ oe(yE);
var bE = "Expected a function";
function jE(e, t, n) {
  if (typeof e != "function")
    throw new TypeError(bE);
  return setTimeout(function() {
    e.apply(void 0, n);
  }, t);
}
var CE = jE, NE = oc, ou = Math.max;
function DE(e, t, n) {
  return t = ou(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var r = arguments, s = -1, a = ou(r.length - t, 0), o = Array(a); ++s < a; )
      o[s] = r[t + s];
    s = -1;
    for (var c = Array(t + 1); ++s < t; )
      c[s] = r[s];
    return c[t] = n(o), NE(e, this, c);
  };
}
var Lp = DE, SE = Hn, $E = Lp, AE = lc;
function EE(e, t) {
  return AE($E(e, t, SE), e + "");
}
var ys = EE, IE = CE, _E = ys, TE = ja;
_E(function(e, t, n) {
  return IE(e, TE(t) || 0, n);
});
var RE = cn, Fp = /[\\^$.*+?()[\]{}|]/g, ME = RegExp(Fp.source);
function PE(e) {
  return e = RE(e), e && ME.test(e) ? e.replace(Fp, "\\$&") : e;
}
var OE = PE;
const kE = /* @__PURE__ */ oe(OE);
function LE(e) {
  return function(t, n, r) {
    for (var s = -1, a = Object(t), o = r(t), c = o.length; c--; ) {
      var l = o[e ? c : ++s];
      if (n(a[l], l, a) === !1)
        break;
    }
    return t;
  };
}
var FE = LE, BE = FE, UE = BE(), Bp = UE, zE = Bp, HE = An;
function WE(e, t) {
  return e && zE(e, t, HE);
}
var Up = WE, VE = $n;
function qE(e, t) {
  return function(n, r) {
    if (n == null)
      return n;
    if (!VE(n))
      return e(n, r);
    for (var s = n.length, a = t ? s : -1, o = Object(n); (t ? a-- : ++a < s) && r(o[a], a, o) !== !1; )
      ;
    return n;
  };
}
var GE = qE, YE = Up, QE = GE, ZE = QE(YE), Ra = ZE, KE = "__lodash_hash_undefined__";
function JE(e) {
  return this.__data__.set(e, KE), this;
}
var XE = JE;
function eI(e) {
  return this.__data__.has(e);
}
var tI = eI, nI = Jo, rI = XE, sI = tI;
function na(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new nI(); ++t < n; )
    this.add(e[t]);
}
na.prototype.add = na.prototype.push = rI;
na.prototype.has = sI;
var pc = na;
function aI(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r; )
    if (t(e[n], n, e))
      return !0;
  return !1;
}
var zp = aI;
function iI(e, t) {
  return e.has(t);
}
var mc = iI, oI = pc, cI = zp, lI = mc, dI = 1, uI = 2;
function fI(e, t, n, r, s, a) {
  var o = n & dI, c = e.length, l = t.length;
  if (c != l && !(o && l > c))
    return !1;
  var d = a.get(e), u = a.get(t);
  if (d && u)
    return d == t && u == e;
  var h = -1, f = !0, p = n & uI ? new oI() : void 0;
  for (a.set(e, t), a.set(t, e); ++h < c; ) {
    var m = e[h], C = t[h];
    if (r)
      var y = o ? r(C, m, h, t, e, a) : r(m, C, h, e, t, a);
    if (y !== void 0) {
      if (y)
        continue;
      f = !1;
      break;
    }
    if (p) {
      if (!cI(t, function(g, w) {
        if (!lI(p, w) && (m === g || s(m, g, n, r, a)))
          return p.push(w);
      })) {
        f = !1;
        break;
      }
    } else if (!(m === C || s(m, C, n, r, a))) {
      f = !1;
      break;
    }
  }
  return a.delete(e), a.delete(t), f;
}
var Hp = fI;
function hI(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r, s) {
    n[++t] = [s, r];
  }), n;
}
var pI = hI;
function mI(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r) {
    n[++t] = r;
  }), n;
}
var gc = mI, cu = Cr, lu = hp, gI = us, wI = Hp, vI = pI, yI = gc, xI = 1, bI = 2, jI = "[object Boolean]", CI = "[object Date]", NI = "[object Error]", DI = "[object Map]", SI = "[object Number]", $I = "[object RegExp]", AI = "[object Set]", EI = "[object String]", II = "[object Symbol]", _I = "[object ArrayBuffer]", TI = "[object DataView]", du = cu ? cu.prototype : void 0, mi = du ? du.valueOf : void 0;
function RI(e, t, n, r, s, a, o) {
  switch (n) {
    case TI:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case _I:
      return !(e.byteLength != t.byteLength || !a(new lu(e), new lu(t)));
    case jI:
    case CI:
    case SI:
      return gI(+e, +t);
    case NI:
      return e.name == t.name && e.message == t.message;
    case $I:
    case EI:
      return e == t + "";
    case DI:
      var c = vI;
    case AI:
      var l = r & xI;
      if (c || (c = yI), e.size != t.size && !l)
        return !1;
      var d = o.get(e);
      if (d)
        return d == t;
      r |= bI, o.set(e, t);
      var u = wI(c(e), c(t), r, s, a, o);
      return o.delete(e), u;
    case II:
      if (mi)
        return mi.call(e) == mi.call(t);
  }
  return !1;
}
var MI = RI, uu = lp, PI = 1, OI = Object.prototype, kI = OI.hasOwnProperty;
function LI(e, t, n, r, s, a) {
  var o = n & PI, c = uu(e), l = c.length, d = uu(t), u = d.length;
  if (l != u && !o)
    return !1;
  for (var h = l; h--; ) {
    var f = c[h];
    if (!(o ? f in t : kI.call(t, f)))
      return !1;
  }
  var p = a.get(e), m = a.get(t);
  if (p && m)
    return p == t && m == e;
  var C = !0;
  a.set(e, t), a.set(t, e);
  for (var y = o; ++h < l; ) {
    f = c[h];
    var g = e[f], w = t[f];
    if (r)
      var x = o ? r(w, g, f, t, e, a) : r(g, w, f, e, t, a);
    if (!(x === void 0 ? g === w || s(g, w, n, r, a) : x)) {
      C = !1;
      break;
    }
    y || (y = f == "constructor");
  }
  if (C && !y) {
    var S = e.constructor, N = t.constructor;
    S != N && "constructor" in e && "constructor" in t && !(typeof S == "function" && S instanceof S && typeof N == "function" && N instanceof N) && (C = !1);
  }
  return a.delete(e), a.delete(t), C;
}
var FI = LI, gi = $a, BI = Hp, UI = MI, zI = FI, fu = Pr, hu = Ge, pu = gs, HI = Ea, WI = 1, mu = "[object Arguments]", gu = "[object Array]", Ms = "[object Object]", VI = Object.prototype, wu = VI.hasOwnProperty;
function qI(e, t, n, r, s, a) {
  var o = hu(e), c = hu(t), l = o ? gu : fu(e), d = c ? gu : fu(t);
  l = l == mu ? Ms : l, d = d == mu ? Ms : d;
  var u = l == Ms, h = d == Ms, f = l == d;
  if (f && pu(e)) {
    if (!pu(t))
      return !1;
    o = !0, u = !1;
  }
  if (f && !u)
    return a || (a = new gi()), o || HI(e) ? BI(e, t, n, r, s, a) : UI(e, t, l, n, r, s, a);
  if (!(n & WI)) {
    var p = u && wu.call(e, "__wrapped__"), m = h && wu.call(t, "__wrapped__");
    if (p || m) {
      var C = p ? e.value() : e, y = m ? t.value() : t;
      return a || (a = new gi()), s(C, y, n, r, a);
    }
  }
  return f ? (a || (a = new gi()), zI(e, t, n, r, s, a)) : !1;
}
var GI = qI, YI = GI, vu = St;
function Wp(e, t, n, r, s) {
  return e === t ? !0 : e == null || t == null || !vu(e) && !vu(t) ? e !== e && t !== t : YI(e, t, n, r, Wp, s);
}
var wc = Wp, QI = $a, ZI = wc, KI = 1, JI = 2;
function XI(e, t, n, r) {
  var s = n.length, a = s, o = !r;
  if (e == null)
    return !a;
  for (e = Object(e); s--; ) {
    var c = n[s];
    if (o && c[2] ? c[1] !== e[c[0]] : !(c[0] in e))
      return !1;
  }
  for (; ++s < a; ) {
    c = n[s];
    var l = c[0], d = e[l], u = c[1];
    if (o && c[2]) {
      if (d === void 0 && !(l in e))
        return !1;
    } else {
      var h = new QI();
      if (r)
        var f = r(d, u, l, e, t, h);
      if (!(f === void 0 ? ZI(u, d, KI | JI, r, h) : f))
        return !1;
    }
  }
  return !0;
}
var e_ = XI, t_ = $t;
function n_(e) {
  return e === e && !t_(e);
}
var Vp = n_, r_ = Vp, s_ = An;
function a_(e) {
  for (var t = s_(e), n = t.length; n--; ) {
    var r = t[n], s = e[r];
    t[n] = [r, s, r_(s)];
  }
  return t;
}
var i_ = a_;
function o_(e, t) {
  return function(n) {
    return n == null ? !1 : n[e] === t && (t !== void 0 || e in Object(n));
  };
}
var qp = o_, c_ = e_, l_ = i_, d_ = qp;
function u_(e) {
  var t = l_(e);
  return t.length == 1 && t[0][2] ? d_(t[0][0], t[0][1]) : function(n) {
    return n === e || c_(n, e, t);
  };
}
var f_ = u_, h_ = Ge, p_ = Nr, m_ = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, g_ = /^\w*$/;
function w_(e, t) {
  if (h_(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || p_(e) ? !0 : g_.test(e) || !m_.test(e) || t != null && e in Object(t);
}
var vc = w_, Gp = Jo, v_ = "Expected a function";
function yc(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(v_);
  var n = function() {
    var r = arguments, s = t ? t.apply(this, r) : r[0], a = n.cache;
    if (a.has(s))
      return a.get(s);
    var o = e.apply(this, r);
    return n.cache = a.set(s, o) || a, o;
  };
  return n.cache = new (yc.Cache || Gp)(), n;
}
yc.Cache = Gp;
var y_ = yc, x_ = y_, b_ = 500;
function j_(e) {
  var t = x_(e, function(r) {
    return n.size === b_ && n.clear(), r;
  }), n = t.cache;
  return t;
}
var C_ = j_, N_ = C_, D_ = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, S_ = /\\(\\)?/g, $_ = N_(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(D_, function(n, r, s, a) {
    t.push(s ? a.replace(S_, "$1") : r || n);
  }), t;
}), Yp = $_, A_ = Ge, E_ = vc, I_ = Yp, __ = cn;
function T_(e, t) {
  return A_(e) ? e : E_(e, t) ? [e] : I_(__(e));
}
var Or = T_, R_ = Nr, M_ = 1 / 0;
function P_(e) {
  if (typeof e == "string" || R_(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -M_ ? "-0" : t;
}
var Wn = P_, O_ = Or, k_ = Wn;
function L_(e, t) {
  t = O_(t, e);
  for (var n = 0, r = t.length; e != null && n < r; )
    e = e[k_(t[n++])];
  return n && n == r ? e : void 0;
}
var xs = L_, F_ = xs;
function B_(e, t, n) {
  var r = e == null ? void 0 : F_(e, t);
  return r === void 0 ? n : r;
}
var xc = B_;
const ln = /* @__PURE__ */ oe(xc);
function U_(e, t) {
  return e != null && t in Object(e);
}
var z_ = U_, H_ = Or, W_ = ms, V_ = Ge, q_ = fs, G_ = Zo, Y_ = Wn;
function Q_(e, t, n) {
  t = H_(t, e);
  for (var r = -1, s = t.length, a = !1; ++r < s; ) {
    var o = Y_(t[r]);
    if (!(a = e != null && n(e, o)))
      break;
    e = e[o];
  }
  return a || ++r != s ? a : (s = e == null ? 0 : e.length, !!s && G_(s) && q_(o, s) && (V_(e) || W_(e)));
}
var Z_ = Q_, K_ = z_, J_ = Z_;
function X_(e, t) {
  return e != null && J_(e, t, K_);
}
var Qp = X_, eT = wc, tT = xc, nT = Qp, rT = vc, sT = Vp, aT = qp, iT = Wn, oT = 1, cT = 2;
function lT(e, t) {
  return rT(e) && sT(t) ? aT(iT(e), t) : function(n) {
    var r = tT(n, e);
    return r === void 0 && r === t ? nT(n, e) : eT(t, r, oT | cT);
  };
}
var Zp = lT;
function dT(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var uT = dT, fT = xs;
function hT(e) {
  return function(t) {
    return fT(t, e);
  };
}
var pT = hT, mT = uT, gT = pT, wT = vc, vT = Wn;
function yT(e) {
  return wT(e) ? mT(vT(e)) : gT(e);
}
var xT = yT, bT = f_, jT = Zp, CT = Hn, NT = Ge, DT = xT;
function ST(e) {
  return typeof e == "function" ? e : e == null ? CT : typeof e == "object" ? NT(e) ? jT(e[0], e[1]) : bT(e) : DT(e);
}
var Bt = ST, $T = Ra;
function AT(e, t) {
  var n = [];
  return $T(e, function(r, s, a) {
    t(r, s, a) && n.push(r);
  }), n;
}
var ET = AT, IT = ap, _T = ET, TT = Bt, RT = Ge;
function MT(e, t) {
  var n = RT(e) ? IT : _T;
  return n(e, TT(t));
}
var Kp = MT;
const bc = /* @__PURE__ */ oe(Kp);
var PT = Bt, OT = $n, kT = An;
function LT(e) {
  return function(t, n, r) {
    var s = Object(t);
    if (!OT(t)) {
      var a = PT(n);
      t = kT(t), n = function(c) {
        return a(s[c], c, s);
      };
    }
    var o = e(t, n, r);
    return o > -1 ? s[a ? t[o] : o] : void 0;
  };
}
var FT = LT, BT = _p, UT = Bt, zT = ps, HT = Math.max;
function WT(e, t, n) {
  var r = e == null ? 0 : e.length;
  if (!r)
    return -1;
  var s = n == null ? 0 : zT(n);
  return s < 0 && (s = HT(r + s, 0)), BT(e, UT(t), s);
}
var VT = WT, qT = FT, GT = VT, YT = qT(GT), Jp = YT;
const Ue = /* @__PURE__ */ oe(Jp);
var QT = ic;
function ZT(e) {
  var t = e == null ? 0 : e.length;
  return t ? QT(e, 1) : [];
}
var Xp = ZT;
const KT = /* @__PURE__ */ oe(Xp);
function JT(e, t, n, r) {
  for (var s = -1, a = e == null ? 0 : e.length; ++s < a; ) {
    var o = e[s];
    t(r, o, n(o), e);
  }
  return r;
}
var XT = JT, eR = Ra;
function tR(e, t, n, r) {
  return eR(e, function(s, a, o) {
    t(r, s, n(s), o);
  }), r;
}
var nR = tR, rR = XT, sR = nR, aR = Bt, iR = Ge;
function oR(e, t) {
  return function(n, r) {
    var s = iR(n) ? rR : sR, a = t ? t() : {};
    return s(n, e, aR(r), a);
  };
}
var jc = oR, cR = _r, lR = jc, dR = Object.prototype, uR = dR.hasOwnProperty, fR = lR(function(e, t, n) {
  uR.call(e, n) ? e[n].push(t) : cR(e, n, [t]);
}), em = fR;
const Dn = /* @__PURE__ */ oe(em);
function hR(e, t, n) {
  for (var r = -1, s = e == null ? 0 : e.length; ++r < s; )
    if (n(t, e[r]))
      return !0;
  return !1;
}
var tm = hR, pR = pc, mR = dc, gR = tm, wR = on, vR = Rr, yu = mc, yR = Math.min;
function xR(e, t, n) {
  for (var r = n ? gR : mR, s = e[0].length, a = e.length, o = a, c = Array(a), l = 1 / 0, d = []; o--; ) {
    var u = e[o];
    o && t && (u = wR(u, vR(t))), l = yR(u.length, l), c[o] = !n && (t || s >= 120 && u.length >= 120) ? new pR(o && u) : void 0;
  }
  u = e[0];
  var h = -1, f = c[0];
  e:
    for (; ++h < s && d.length < l; ) {
      var p = u[h], m = t ? t(p) : p;
      if (p = n || p !== 0 ? p : 0, !(f ? yu(f, m) : r(d, m, n))) {
        for (o = a; --o; ) {
          var C = c[o];
          if (!(C ? yu(C, m) : r(e[o], m, n)))
            continue e;
        }
        f && f.push(m), d.push(p);
      }
    }
  return d;
}
var nm = xR, bR = $n, jR = St;
function CR(e) {
  return jR(e) && bR(e);
}
var rm = CR, NR = rm;
function DR(e) {
  return NR(e) ? e : [];
}
var sm = DR, SR = on, $R = nm, AR = ys, ER = sm, IR = AR(function(e) {
  var t = SR(e, ER);
  return t.length && t[0] === e[0] ? $R(t) : [];
}), _R = IR;
const TR = /* @__PURE__ */ oe(_R);
function RR(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
var Ma = RR;
const MR = /* @__PURE__ */ oe(Ma);
var PR = on, OR = nm, kR = ys, LR = sm, FR = Ma, BR = kR(function(e) {
  var t = FR(e), n = PR(e, LR);
  return t = typeof t == "function" ? t : void 0, t && n.pop(), n.length && n[0] === e[0] ? OR(n, void 0, t) : [];
}), am = BR;
const UR = /* @__PURE__ */ oe(am);
var zR = tc, HR = Pr, WR = ms, VR = Ge, qR = $n, GR = gs, YR = Ia, QR = Ea, ZR = "[object Map]", KR = "[object Set]", JR = Object.prototype, XR = JR.hasOwnProperty;
function eM(e) {
  if (e == null)
    return !0;
  if (qR(e) && (VR(e) || typeof e == "string" || typeof e.splice == "function" || GR(e) || QR(e) || WR(e)))
    return !e.length;
  var t = HR(e);
  if (t == ZR || t == KR)
    return !e.size;
  if (YR(e))
    return !zR(e).length;
  for (var n in e)
    if (XR.call(e, n))
      return !1;
  return !0;
}
var tM = eM;
const xe = /* @__PURE__ */ oe(tM);
var nM = wc;
function rM(e, t) {
  return nM(e, t);
}
var im = rM;
const bs = /* @__PURE__ */ oe(im);
var sM = gt, aM = sM.isFinite;
function iM(e) {
  return typeof e == "number" && aM(e);
}
var oM = iM;
const om = /* @__PURE__ */ oe(oM);
function cM(e) {
  return e === void 0;
}
var lM = cM;
const dM = /* @__PURE__ */ oe(lM);
var uM = gn, fM = Ge, hM = St, pM = "[object String]";
function mM(e) {
  return typeof e == "string" || !fM(e) && hM(e) && uM(e) == pM;
}
var gM = mM;
const Cn = /* @__PURE__ */ oe(gM);
var wM = _r, vM = jc, yM = vM(function(e, t, n) {
  wM(e, n, t);
}), xM = yM;
const nr = /* @__PURE__ */ oe(xM);
var bM = Ra, jM = $n;
function CM(e, t) {
  var n = -1, r = jM(e) ? Array(e.length) : [];
  return bM(e, function(s, a, o) {
    r[++n] = t(s, a, o);
  }), r;
}
var cm = CM, NM = on, DM = Bt, SM = cm, $M = Ge;
function AM(e, t) {
  var n = $M(e) ? NM : SM;
  return n(e, DM(t));
}
var lm = AM;
const ur = /* @__PURE__ */ oe(lm);
var EM = _r, IM = Up, _M = Bt;
function TM(e, t) {
  var n = {};
  return t = _M(t), IM(e, function(r, s, a) {
    EM(n, s, t(r, s, a));
  }), n;
}
var dm = TM;
const js = /* @__PURE__ */ oe(dm);
var RM = _r, MM = us;
function PM(e, t, n) {
  (n !== void 0 && !MM(e[t], n) || n === void 0 && !(t in e)) && RM(e, t, n);
}
var um = PM, OM = gn, kM = rc, LM = St, FM = "[object Object]", BM = Function.prototype, UM = Object.prototype, fm = BM.toString, zM = UM.hasOwnProperty, HM = fm.call(Object);
function WM(e) {
  if (!LM(e) || OM(e) != FM)
    return !1;
  var t = kM(e);
  if (t === null)
    return !0;
  var n = zM.call(t, "constructor") && t.constructor;
  return typeof n == "function" && n instanceof n && fm.call(n) == HM;
}
var Cc = WM;
function VM(e, t) {
  if (!(t === "constructor" && typeof e[t] == "function") && t != "__proto__")
    return e[t];
}
var hm = VM, qM = Tr, GM = ws;
function YM(e) {
  return qM(e, GM(e));
}
var QM = YM, xu = um, ZM = sp, KM = pp, JM = Dr, XM = mp, bu = ms, ju = Ge, eP = rm, tP = gs, nP = Sr, rP = $t, sP = Cc, aP = Ea, Cu = hm, iP = QM;
function oP(e, t, n, r, s, a, o) {
  var c = Cu(e, n), l = Cu(t, n), d = o.get(l);
  if (d) {
    xu(e, n, d);
    return;
  }
  var u = a ? a(c, l, n + "", e, t, o) : void 0, h = u === void 0;
  if (h) {
    var f = ju(l), p = !f && tP(l), m = !f && !p && aP(l);
    u = l, f || p || m ? ju(c) ? u = c : eP(c) ? u = JM(c) : p ? (h = !1, u = ZM(l, !0)) : m ? (h = !1, u = KM(l, !0)) : u = [] : sP(l) || bu(l) ? (u = c, bu(c) ? u = iP(c) : (!rP(c) || nP(c)) && (u = XM(l))) : h = !1;
  }
  h && (o.set(l, u), s(u, l, r, a, o), o.delete(l)), xu(e, n, u);
}
var cP = oP, lP = $a, dP = um, uP = Bp, fP = cP, hP = $t, pP = ws, mP = hm;
function pm(e, t, n, r, s) {
  e !== t && uP(t, function(a, o) {
    if (s || (s = new lP()), hP(a))
      fP(e, t, o, n, pm, r, s);
    else {
      var c = r ? r(mP(e, o), a, o + "", e, t, s) : void 0;
      c === void 0 && (c = a), dP(e, o, c);
    }
  }, pP);
}
var mm = pm, gP = ys, wP = hs;
function vP(e) {
  return gP(function(t, n) {
    var r = -1, s = n.length, a = s > 1 ? n[s - 1] : void 0, o = s > 2 ? n[2] : void 0;
    for (a = e.length > 3 && typeof a == "function" ? (s--, a) : void 0, o && wP(n[0], n[1], o) && (a = s < 3 ? void 0 : a, s = 1), t = Object(t); ++r < s; ) {
      var c = n[r];
      c && e(t, c, r, a);
    }
    return t;
  });
}
var gm = vP, yP = mm, xP = gm, bP = xP(function(e, t, n) {
  yP(e, t, n);
}), jP = bP;
const wm = /* @__PURE__ */ oe(jP);
var CP = mm, NP = gm, DP = NP(function(e, t, n, r) {
  CP(e, t, n, r);
}), SP = DP;
const $P = /* @__PURE__ */ oe(SP);
var AP = "Expected a function";
function EP(e) {
  if (typeof e != "function")
    throw new TypeError(AP);
  return function() {
    var t = arguments;
    switch (t.length) {
      case 0:
        return !e.call(this);
      case 1:
        return !e.call(this, t[0]);
      case 2:
        return !e.call(this, t[0], t[1]);
      case 3:
        return !e.call(this, t[0], t[1], t[2]);
    }
    return !e.apply(this, t);
  };
}
var IP = EP, _P = ec, TP = Or, RP = fs, Nu = $t, MP = Wn;
function PP(e, t, n, r) {
  if (!Nu(e))
    return e;
  t = TP(t, e);
  for (var s = -1, a = t.length, o = a - 1, c = e; c != null && ++s < a; ) {
    var l = MP(t[s]), d = n;
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return e;
    if (s != o) {
      var u = c[l];
      d = r ? r(u, l, c) : void 0, d === void 0 && (d = Nu(u) ? u : RP(t[s + 1]) ? [] : {});
    }
    _P(c, l, d), c = c[l];
  }
  return e;
}
var vm = PP, OP = xs, kP = vm, LP = Or;
function FP(e, t, n) {
  for (var r = -1, s = t.length, a = {}; ++r < s; ) {
    var o = t[r], c = OP(e, o);
    n(c, o) && kP(a, LP(o, e), c);
  }
  return a;
}
var ym = FP, BP = on, UP = Bt, zP = ym, HP = sc;
function WP(e, t) {
  if (e == null)
    return {};
  var n = BP(HP(e), function(r) {
    return [r];
  });
  return t = UP(t), zP(e, n, function(r, s) {
    return t(r, s[0]);
  });
}
var xm = WP;
const mo = /* @__PURE__ */ oe(xm);
var VP = Bt, qP = IP, GP = xm;
function YP(e, t) {
  return GP(e, qP(VP(t)));
}
var QP = YP;
const bm = /* @__PURE__ */ oe(QP);
function ZP(e, t) {
  var n = e.length;
  for (e.sort(t); n--; )
    e[n] = e[n].value;
  return e;
}
var KP = ZP, Du = Nr;
function JP(e, t) {
  if (e !== t) {
    var n = e !== void 0, r = e === null, s = e === e, a = Du(e), o = t !== void 0, c = t === null, l = t === t, d = Du(t);
    if (!c && !d && !a && e > t || a && o && l && !c && !d || r && o && l || !n && l || !s)
      return 1;
    if (!r && !a && !d && e < t || d && n && s && !r && !a || c && n && s || !o && s || !l)
      return -1;
  }
  return 0;
}
var XP = JP, e8 = XP;
function t8(e, t, n) {
  for (var r = -1, s = e.criteria, a = t.criteria, o = s.length, c = n.length; ++r < o; ) {
    var l = e8(s[r], a[r]);
    if (l) {
      if (r >= c)
        return l;
      var d = n[r];
      return l * (d == "desc" ? -1 : 1);
    }
  }
  return e.index - t.index;
}
var n8 = t8, wi = on, r8 = xs, s8 = Bt, a8 = cm, i8 = KP, o8 = Rr, c8 = n8, l8 = Hn, d8 = Ge;
function u8(e, t, n) {
  t.length ? t = wi(t, function(a) {
    return d8(a) ? function(o) {
      return r8(o, a.length === 1 ? a[0] : a);
    } : a;
  }) : t = [l8];
  var r = -1;
  t = wi(t, o8(s8));
  var s = a8(e, function(a, o, c) {
    var l = wi(t, function(d) {
      return d(a);
    });
    return { criteria: l, index: ++r, value: a };
  });
  return i8(s, function(a, o) {
    return c8(a, o, n);
  });
}
var jm = u8, f8 = jm, Su = Ge;
function h8(e, t, n, r) {
  return e == null ? [] : (Su(t) || (t = t == null ? [] : [t]), n = r ? void 0 : n, Su(n) || (n = n == null ? [] : [n]), f8(e, t, n));
}
var Cm = h8;
const nt = /* @__PURE__ */ oe(Cm);
var p8 = jc, m8 = p8(function(e, t, n) {
  e[n ? 0 : 1].push(t);
}, function() {
  return [[], []];
}), Nm = m8;
const g8 = /* @__PURE__ */ oe(Nm);
var w8 = gt, v8 = ps, y8 = ja, $u = cn, x8 = w8.isFinite, b8 = Math.min;
function j8(e) {
  var t = Math[e];
  return function(n, r) {
    if (n = y8(n), r = r == null ? 0 : b8(v8(r), 292), r && x8(n)) {
      var s = ($u(n) + "e").split("e"), a = t(s[0] + "e" + (+s[1] + r));
      return s = ($u(a) + "e").split("e"), +(s[0] + "e" + (+s[1] - r));
    }
    return t(n);
  };
}
var C8 = j8, N8 = C8, D8 = N8("round"), S8 = D8;
const $8 = /* @__PURE__ */ oe(S8);
var A8 = xa, E8 = A8(function(e, t, n) {
  return e + (n ? "_" : "") + t.toLowerCase();
}), I8 = E8;
const _8 = /* @__PURE__ */ oe(I8);
var T8 = Ra;
function R8(e, t) {
  var n;
  return T8(e, function(r, s, a) {
    return n = t(r, s, a), !n;
  }), !!n;
}
var M8 = R8, P8 = zp, O8 = Bt, k8 = M8, L8 = Ge, F8 = hs;
function B8(e, t, n) {
  var r = L8(e) ? P8 : k8;
  return n && F8(e, t, n) && (t = void 0), r(e, O8(t));
}
var U8 = B8;
const fn = /* @__PURE__ */ oe(U8);
var z8 = ic, H8 = jm, W8 = ys, Au = hs, V8 = W8(function(e, t) {
  if (e == null)
    return [];
  var n = t.length;
  return n > 1 && Au(e, t[0], t[1]) ? t = [] : n > 2 && Au(t[0], t[1], t[2]) && (t = [t[0]]), H8(e, z8(t, 1), []);
}), Dm = V8;
const Nc = /* @__PURE__ */ oe(Dm);
var q8 = xa, G8 = kh, Y8 = q8(function(e, t, n) {
  return e + (n ? " " : "") + G8(t);
}), Q8 = Y8;
const Dc = /* @__PURE__ */ oe(Q8);
function Z8(e, t) {
  for (var n, r = -1, s = e.length; ++r < s; ) {
    var a = t(e[r]);
    a !== void 0 && (n = n === void 0 ? a : n + a);
  }
  return n;
}
var K8 = Z8, J8 = K8, X8 = Hn;
function e6(e) {
  return e && e.length ? J8(e, X8) : 0;
}
var t6 = e6;
const n6 = /* @__PURE__ */ oe(t6);
var vi = dp, r6 = Sp, s6 = gc, a6 = 1 / 0, i6 = vi && 1 / s6(new vi([, -0]))[1] == a6 ? function(e) {
  return new vi(e);
} : r6, o6 = i6, c6 = pc, l6 = dc, d6 = tm, u6 = mc, f6 = o6, h6 = gc, p6 = 200;
function m6(e, t, n) {
  var r = -1, s = l6, a = e.length, o = !0, c = [], l = c;
  if (n)
    o = !1, s = d6;
  else if (a >= p6) {
    var d = t ? null : f6(e);
    if (d)
      return h6(d);
    o = !1, s = u6, l = new c6();
  } else
    l = t ? [] : c;
  e:
    for (; ++r < a; ) {
      var u = e[r], h = t ? t(u) : u;
      if (u = n || u !== 0 ? u : 0, o && h === h) {
        for (var f = l.length; f--; )
          if (l[f] === h)
            continue e;
        t && l.push(h), c.push(u);
      } else
        s(l, h, n) || (l !== c && l.push(h), c.push(u));
    }
  return c;
}
var Sc = m6, g6 = Sc;
function w6(e) {
  return e && e.length ? g6(e) : [];
}
var Sm = w6;
const ht = /* @__PURE__ */ oe(Sm);
var v6 = Bt, y6 = Sc;
function x6(e, t) {
  return e && e.length ? y6(e, v6(t)) : [];
}
var b6 = x6;
const $c = /* @__PURE__ */ oe(b6);
var j6 = Sc;
function C6(e, t) {
  return t = typeof t == "function" ? t : void 0, e && e.length ? j6(e, void 0, t) : [];
}
var $m = C6;
const wn = /* @__PURE__ */ oe($m);
var N6 = xa, D6 = N6(function(e, t, n) {
  return e + (n ? " " : "") + t.toUpperCase();
}), S6 = D6;
const Am = /* @__PURE__ */ oe(S6);
var $6 = on;
function A6(e, t) {
  return $6(t, function(n) {
    return e[n];
  });
}
var E6 = A6, I6 = E6, _6 = An;
function T6(e) {
  return e == null ? [] : I6(e, _6(e));
}
var R6 = T6;
const Eu = (e) => {
  var n;
  if (e.text)
    return e.text;
  let t = "";
  return t += e.use ? `${qe(e.use)}: ` : "", t += xe(e.line) ? "" : `${(n = e.line) == null ? void 0 : n.join(`
`)}
`, t += e.city ? `${e.city}, ` : "", t += e.state ? `${e.state} ` : "", t += e.postalCode || "", t += e.country ? `
${e.country}` : "", t;
}, M6 = (e) => xe(e) ? "" : Ft(e) ? e.map(Eu).join(`
`) : Eu(e);
function P6(e) {
  return Ft(e) && e.every((t) => typeof t == "object");
}
function O6(e) {
  return Ft(e) && e.every((t) => typeof t == "string");
}
const Iu = (e) => {
  if (e.text)
    return e.text;
  let t = "";
  return e.given && e.given.length > 0 && (t = e.given.join(" "), e.family && (t = `${t} ${e.family}`)), e.prefix && e.prefix.length > 0 && (t = `${e.prefix.join(" ")} ${t}`), t;
}, Em = (e) => xe(e) ? "" : typeof e == "string" ? e : O6(e) ? e.reduce((t, n, r) => `${t}${r === 0 ? "" : `
`}${n}`, "") : P6(e) ? e.map(Iu).join(", ") : Iu(e), _u = ({ use: e, system: t, value: n }) => {
  const r = e ? ` (${e})` : "";
  return `${t ? `${qe(t)}${r}:` : ""} ${n}`.trim();
}, k6 = (e) => xe(e) ? "" : Ft(e) ? e.map(_u).join(`
`) : _u(e), L6 = {
  BAD: "bad",
  DIR: "direct",
  H: "home",
  HP: "primary home",
  HV: "vacation home",
  PHYS: "physical",
  PST: "postal",
  PUB: "public",
  TMP: "temporary",
  WP: "work",
  CONF: "confidential"
}, Im = (e) => {
  if (!e)
    return "";
  const t = (n) => {
    const r = String(k.select1("string(@use)", n)), s = {
      line: ur(
        k.select("*[name()='streetAddressLine']", n),
        (a) => String(k.select("string(text())", a))
      ).filter(Boolean),
      city: String(k.select("string(*[name()='city'])", n)),
      state: String(k.select("string(*[name()='state'])", n)),
      postalCode: String(k.select("string(*[name()='postalCode'])", n)),
      country: String(k.select("string(*[name()='country'])", n)),
      use: L6[r]
    };
    return M6(s);
  };
  return Ft(e) ? e.map(t).join(`
`) : t(e);
}, F6 = {
  BAD: "bad",
  CONF: "confidential",
  OLD: "old",
  H: "home",
  HP: "primary home",
  HV: "vacation Home",
  TMP: "temporary",
  WP: "work",
  DIR: "direct",
  PUB: "public",
  AS: "answering service",
  EC: "emergency:",
  MC: "mobile",
  PG: "pager"
}, yi = {
  tel: "phone",
  mailto: "email"
}, B6 = (e) => {
  if (!e)
    return "";
  const t = (n) => {
    const s = String(k.select1("string(@value)", n)).split(":");
    let a, o;
    if (s.length === 2 && ([a, o] = s), s.length === 1 && ([o] = s), !o)
      return "";
    const c = o.includes("@") ? yi.mailto : yi.tel, d = {
      system: yi[a] || c,
      value: o,
      use: F6[String(k.select1("string(@use)", n))]
    };
    return k6(d);
  };
  return Ft(e) ? e.map(t).join(`
`) : t(e);
}, It = (e, t) => {
  const n = Im(e), r = B6(t);
  return `${n || ""}${n && r ? `
` : ""}${r || ""}`;
}, U6 = {
  A: "Artist/Stage",
  ABC: "Alphabetic",
  ASGN: "Assigned",
  C: "License",
  I: "Indigenous/Tribal",
  IDE: "Ideographic",
  L: "Legal",
  P: "Pseudonym",
  PHON: "Phonetic",
  R: "Religious",
  SNDX: "Soundex",
  SRCH: "Search",
  SYL: "Syllabic"
}, Zt = (e) => {
  if (!e)
    return "";
  const t = (n) => {
    const r = {
      use: U6[String(k.select("string(@use)", n))],
      given: ur(
        k.select("(*[name()='given'])", n),
        (s) => String(k.select1("string(text())", s))
      ),
      family: String(k.select1("string(*[name()='family']/text())", n)),
      prefix: ur(
        k.select("(*[name()='prefix'])", n),
        (s) => String(k.select1("string(text())", s))
      ),
      suffix: ur(
        k.select("(*[name()='suffix'])", n),
        (s) => String(k.select1("string(text())", s))
      )
    };
    return Em(r);
  };
  return Ft(e) ? e.map(t).join(`
`) : t(e);
}, pn = (e) => {
  if (!e)
    return "";
  const t = String(k.select1("string(@root)", e)), n = String(k.select1("string(@extension)", e));
  return `${n}${n ? " (" : ""}${t}${n ? ")" : ""}`;
}, z6 = (e) => {
  const t = e.replace(/:/g, ""), n = t.lastIndexOf("+"), r = t.lastIndexOf("-");
  if (n > 0)
    return { index: t.length - n - 1, timezoneSign: "+" };
  if (r > 0) {
    const s = t[r - 3];
    return om(Number(s)) || s === "T" ? { index: t.length - r - 1, timezoneSign: "-" } : { index: -1 };
  }
  return { index: -1 };
}, jn = (e) => e && e.length > 1 && e.split("").every((t) => om(Number(t))), H6 = ({
  year: e,
  month: t,
  day: n,
  hour: r,
  minute: s,
  second: a,
  timezoneHour: o,
  timezoneMinute: c,
  timezoneSign: l
}) => {
  let d = "";
  return jn(e) && (d += e, jn(t) && (d += `-${t}`, jn(n) && (d += `-${n}`, jn(r) && (d += `T${r}`, jn(s) ? d += `:${s}` : d += ":00", jn(a) ? d += `:${a}` : d += ":00", l && jn(o) ? (d += `${l}${o}`, jn(c) ? d += `:${c}` : d += ":00") : d += "-00:00")))), d;
}, Pt = (e) => {
  if (!e)
    return "";
  const { index: t, timezoneSign: n } = z6(e);
  let r = e.replace(/T/g, "").replace(/-/g, "").replace("+", "").replace(/:/g, ""), s = "";
  (t === 4 || t === 2) && r.length > 9 && (s = r.substring(r.length - t), r = r.substring(0, r.length - t));
  const a = r.slice(0, 4), o = r.slice(4, 6), c = r.slice(6, 8), l = r.slice(8, 10), d = r.slice(10, 12), u = r.slice(12, 14), h = s.slice(0, 2), f = s.slice(2);
  return c ? H6({
    year: a,
    month: o,
    day: c,
    hour: l,
    minute: d,
    second: u,
    timezoneHour: h,
    timezoneMinute: f,
    timezoneSign: n
  }) : "";
}, Ac = (e) => {
  if (!e)
    return {};
  const t = String(k.select1("string(*[name()='low']/@value)", e)), n = String(k.select1("string(*[name()='high']/@value)", e));
  if (!t && !n)
    return {};
  if (t && !n)
    return {
      start: Pt(t)
    };
  if (!t && n)
    return {
      end: Pt(n)
    };
  let r = Pt(t), s = Pt(n);
  return (r.includes("T") || s.includes("T")) && (r = Pt(r), s = Pt(s)), nv(new Date(r), new Date(s)) || rv(new Date(r), new Date(s)) ? { start: r, end: s } : { start: r };
}, ra = (e, t, n, r = !0) => {
  if (Ft(t))
    return t.reduce((a, o) => ra(a, o, n), e);
  const s = r ? kE : bS;
  return e.replace(new RegExp(s(t), "g"), n);
}, Kr = (e, t, n) => {
  const r = [`</${t}>`, `<${t}>`, `</${t}`, `<${t}`], s = [`</${n}>`, `<${n}>`, `</${n}`, `<${n}`];
  return r.reduce(
    (a, o, c) => ra(a, r[c], s[c]),
    e
  );
}, W6 = (e) => {
  let t = e.toString();
  return t = ra(
    t,
    [
      "<list/>",
      "<item/>",
      "<content/>",
      "<paragraph/>",
      "<section/>",
      "<br/>",
      '<text xmlns="urn:hl7-org:v3">',
      "<text />",
      "<text/>"
    ],
    ""
  ), t = ra(t, ' styleCode="(.*?)"', "", !1), t = Kr(t, "section", "div"), t = Kr(t, "list", "ul"), t = Kr(t, "item", "li"), t = Kr(t, "content", "div"), t = Kr(t, "paragraph", "p"), t;
}, vr = (e) => {
  if (!e)
    return "";
  const [t, n = ""] = e.split("T");
  return Qt(new Date(t), "MMMM dd, yyyy") + (n.split("").some((r) => Number(r) > 0) ? `, ${n}` : "");
}, V6 = (e) => !!e, Ec = (e) => !!e, q6 = (e) => {
  const t = k.select(
    "*[name()='ClinicalDocument']/*[name()='authenticator']",
    e
  );
  if (!xe(t))
    return t.map((n) => {
      const r = k.select1("*[name()='assignedEntity']", n);
      if (!r)
        return;
      const s = k.select1(
        "*[name()='assignedPerson']",
        r
      ), a = Zt(k.select("*[name()='name']", s)), o = It(
        k.select("*[name()='addr']", r),
        k.select("*[name()='telecom']", r)
      ), c = Pt(
        String(k.select1("string(*[name()='time']/@value)", n))
      );
      return { name: a, contactDetails: o, time: c };
    }).filter(Ec);
};
const G6 = ({ dataChunk: e, indexKey: t, chunkSize: n }) => {
  var a, o;
  if (!e[0].value && !((a = e[1]) != null && a.value) && !((o = e[2]) != null && o.value))
    return null;
  let r = null, s = e;
  return n === 3 && (s = e.slice(0, 2), [r] = e.slice(2)), /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
    /* @__PURE__ */ i.jsx("tr", { children: s.map((c, l) => {
      var u, h;
      if (!c.value)
        return null;
      let d = 1;
      return (l === 0 && (!s[l + 1] || !s[l + 1].value) || l === 1 && (!s[l - 1] || !s[l - 1].value)) && (d = 3), /* @__PURE__ */ i.jsxs(
        wa.Fragment,
        {
          children: [
            /* @__PURE__ */ i.jsx(
              "td",
              {
                className: "ctw-ccda-common-td1",
                rowSpan: r && r.value && l === 0 ? 2 : 1,
                children: c.label.replace(/:/g, "")
              }
            ),
            /* @__PURE__ */ i.jsx(
              "td",
              {
                className: "ctw-ccda-common-td2",
                colSpan: d,
                rowSpan: r && r.value && l === 0 ? 2 : 1,
                children: c.value
              }
            )
          ]
        },
        `${s[0].label}-${String(
          s[0].value
        )}-${l}-${t}-${((u = s[1]) == null ? void 0 : u.label) || ""}-${((h = s[1]) == null ? void 0 : h.value) || ""}`
      );
    }) }),
    r && r.value && /* @__PURE__ */ i.jsxs("tr", { children: [
      /* @__PURE__ */ i.jsx("td", { className: "ctw-ccda-common-td1", children: r.label.replace(/:/g, "") }),
      /* @__PURE__ */ i.jsx("td", { className: "ctw-ccda-common-td2", children: r.value })
    ] })
  ] });
}, Y6 = ({ tuple: e, indexKey: t }) => !e[0].value && !e[1].value ? null : /* @__PURE__ */ i.jsx("tr", { children: e.map((n, r) => {
  if (!n.value)
    return null;
  let s = 1;
  return (r === 0 && !e[1].value || r === 1 && !e[0].value) && (s = 3), /* @__PURE__ */ i.jsxs(
    wa.Fragment,
    {
      children: [
        /* @__PURE__ */ i.jsx("td", { className: "ctw-ccda-common-td1", children: n.label.replace(/:/g, "") }),
        /* @__PURE__ */ i.jsx("td", { className: "ctw-ccda-common-td2", colSpan: s, children: n.value })
      ]
    },
    `${e[0].label}-${e[0].value}-${r}-${t}-${e[1].label || ""}-${e[1].value}`
  );
}) }), At = ({ data: e, chunkSize: t = 2 }) => {
  const [n, r] = g8(e, (a) => !Ft(a)), s = Pb(n, t);
  return /* @__PURE__ */ i.jsx("table", { className: "ctw-ccda-common-table", children: /* @__PURE__ */ i.jsxs("tbody", { children: [
    s.map((a, o) => /* @__PURE__ */ i.jsx(
      G6,
      {
        dataChunk: a,
        chunkSize: t,
        indexKey: o
      },
      `${a[0].label}-${o}`
    )),
    r.map((a, o) => /* @__PURE__ */ i.jsx(
      Y6,
      {
        tuple: a,
        indexKey: o
      },
      `${a[0].label}-${a[1].label}-${o}`
    ))
  ] }) });
}, Q6 = ({ document: e }) => {
  const t = q6(e);
  if (!t || xe(t))
    return null;
  const n = t.flatMap((r) => [
    {
      label: "Authenticator",
      value: `${r.name || "Unknown"}${r.time ? ` signed at ${r.time}` : ""}`
    },
    {
      label: "Contact Details",
      value: r.contactDetails
    }
  ]);
  return /* @__PURE__ */ i.jsx(At, { data: n });
}, _m = (e) => {
  const t = k.select(
    "*[name()='ClinicalDocument']/*[name()='author']",
    e
  );
  return xe(t) ? void 0 : t.map((r) => {
    const s = k.select1(
      "*[name()='assignedAuthor']/*[name()='assignedPerson']/*[name()='name']",
      r
    ), a = k.select1(
      "*[name()='assignedAuthor']/*[name()='assignedAuthoringDevice']",
      r
    );
    let o = "";
    if (s)
      o = Zt(s);
    else if (a) {
      const d = String(
        k.select1("string(*[name()='manufacturerModelName'])", a)
      ), u = String(k.select1("string(*[name()='softwareName'])", a));
      o = [d, u].filter(Boolean).join("; ");
    }
    const c = String(
      k.select1(
        "string(*[name()='assignedAuthor']/*[name()='representedOrganization']/*[name()='name'])",
        r
      )
    ), l = Pt(String(k.select1("string(*[name()='time'])", r)));
    return [
      { label: "Name:", value: o },
      { label: "Organization:", value: c },
      { label: "Authored on", value: l }
    ];
  }).reduce((r, s, a) => X(R({}, r), { [`author${a + 1}`]: s }), {});
}, Z6 = (e) => {
  const t = k.select(
    "*[name()='ClinicalDocument']/*[name()='author']",
    e
  );
  if (xe(t))
    return;
  const n = _m(e);
  return t.map((r, s) => {
    const a = k.select1("*[name()='assignedAuthor']", r), o = It(
      k.select("*[name()='addr']", a),
      k.select("*[name()='telecom']", a)
    ), c = k.select1(
      "*[name()='representedOrganization']",
      a
    ), l = {
      name: n[`author${s + 1}`][0].value,
      contactDetails: o,
      organization: {
        name: n[`author${s + 1}`][1].value,
        contactDetails: ""
      }
    };
    if (c) {
      const d = It(
        k.select("*[name()='addr']", c),
        k.select("*[name()='telecom']", c)
      );
      return X(R({}, l), {
        organization: X(R({}, l.organization), {
          contactDetails: d
        })
      });
    }
    return l;
  });
}, K6 = ({ document: e }) => {
  const t = Z6(e);
  if (!t || xe(t))
    return null;
  const n = t.flatMap((r) => [
    {
      label: "Author",
      value: `${r.name || "Unknown"}${r.organization.name ? `, Organization: ${r.organization.name}` : ""}`
    },
    {
      label: "Contact Details",
      value: r.contactDetails
    },
    {
      label: "Contact Details (Organization)",
      value: r.organization.contactDetails
    }
  ]);
  return /* @__PURE__ */ i.jsx(At, { data: n, chunkSize: 3 });
}, J6 = (e) => {
  const t = k.select(
    "*[name()='ClinicalDocument']/*[name()='authorization']/*[name()='consent']",
    e
  );
  return xe(t) ? void 0 : t.map((r) => {
    const s = pn(k.select1("*[name()='id']", r)), a = String(k.select1("string(*[name()='code']/@displayName)", r)), o = String(k.select1("string(*[name()='statusCode']/@code)", r));
    return [
      { label: "ID:", value: s },
      { label: "Code:", value: a },
      { label: "Status:", value: o }
    ];
  }).reduce((r, s, a) => X(R({}, r), { [`consent${a + 1}`]: s }), {});
}, X6 = (e) => {
  const t = J6(e);
  return Object.values(t || {});
}, e7 = ({ document: e }) => {
  const t = X6(e);
  if (xe(t))
    return null;
  const n = t.flatMap((r) => [
    {
      label: "Consent",
      value: `Order: ${r[0].value || "Unknown"}, ${r[1].value || "Unknown"}, ${r[2].value || "Unknown"}`
    },
    { label: "", value: "" }
  ]);
  return /* @__PURE__ */ i.jsx(At, { data: n });
}, t7 = (e) => {
  const t = k.select1(
    "*[name()='ClinicalDocument']/*[name()='custodian']/*[name()='assignedCustodian']/*[name()='representedCustodianOrganization']",
    e
  );
  if (!t)
    return;
  const n = String(k.select1("string(*[name()='name'])", t)), r = It(
    k.select1(
      "*[name()='ClinicalDocument']/*[name()='custodian']/*[name()='assignedCustodian']/*[name()='representedCustodianOrganization']/*[name()='addr']",
      e
    ),
    k.select1(
      "*[name()='ClinicalDocument']/*[name()='custodian']/*[name()='assignedCustodian']/*[name()='representedCustodianOrganization']/*[name()='telecom']",
      e
    )
  );
  return { name: n, contactDetails: r };
}, n7 = ({ document: e }) => {
  const t = t7(e);
  if (!t)
    return null;
  const { name: n, contactDetails: r } = t, s = [
    {
      label: "Custodian",
      value: n
    },
    {
      label: "Contact Details",
      value: r
    }
  ];
  return /* @__PURE__ */ i.jsx(At, { data: s });
}, r7 = (e) => {
  const t = k.select1(
    "*[name()='ClinicalDocument']/*[name()='dataEnterer']/*[name()='assignedEntity']",
    e
  );
  if (!t)
    return;
  const n = k.select1("*[name()='assignedPerson']", t), r = Zt(k.select("*[name()='name']", n)), s = It(
    k.select("*[name()='addr']", t),
    k.select("*[name()='telecom']", t)
  );
  return { name: r, contactDetails: s };
}, s7 = ({ document: e }) => {
  const t = r7(e);
  if (!t)
    return null;
  const { name: n, contactDetails: r } = t, s = [
    {
      label: "Data Enterer",
      value: n
    },
    {
      label: "Contact Details",
      value: r
    }
  ];
  return /* @__PURE__ */ i.jsx(At, { data: s });
}, a7 = {
  N: "normal",
  R: "restricted",
  V: "very restricted"
}, i7 = (e) => {
  const t = pn(
    k.select1("*[name()='ClinicalDocument']/*[name()='id']", e)
  ), n = Pt(
    String(
      k.select1(
        "string(*[name()='ClinicalDocument']/*[name()='effectiveTime']/@value)",
        e
      )
    )
  ), r = vr(n), s = String(
    k.select1("string(*[name()='ClinicalDocument']/*[name()='versionNumber']/@value)", e)
  ), a = pn(
    k.select1("*[name()='ClinicalDocument']/*[name()='setId']", e)
  ), o = a7[String(
    k.select1(
      "string(*[name()='ClinicalDocument']/*[name()='confidentialityCode']/@code)",
      e
    )
  )], c = String(
    k.select1("string(*[name()='ClinicalDocument']/*[name()='code']/@displayName)", e)
  ), l = String(
    k.select1("string(*[name()='ClinicalDocument']/*[name()='languageCode']/@code)", e)
  );
  return {
    id: t,
    createdOn: r,
    version: s,
    setId: a,
    confidentialityCode: o,
    code: c,
    languageCode: l
  };
}, o7 = ({ document: e }) => {
  const { id: t, createdOn: n, version: r, setId: s, confidentialityCode: a, code: o, languageCode: c } = i7(e), l = [
    {
      label: "Document",
      value: /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
        /* @__PURE__ */ i.jsx("b", { children: "ID: " }),
        t,
        s && /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
          /* @__PURE__ */ i.jsx("br", {}),
          /* @__PURE__ */ i.jsx("b", { children: "Set ID: " }),
          s
        ] })
      ] })
    },
    {
      label: "Created on",
      value: n
    },
    {
      label: "Version",
      value: r || "Unknown"
    },
    {
      label: "Confidentiality",
      value: a
    },
    {
      label: "Code",
      value: o
    },
    {
      label: "Language",
      value: c
    }
  ];
  return /* @__PURE__ */ i.jsx(At, { data: l });
}, c7 = (e) => {
  const t = k.select(
    "//*[name()='documentationOf']/*[name()='serviceEvent']",
    e
  );
  return xe(t) ? void 0 : t.map((r) => {
    const s = k.select1("*[name()='effectiveTime']", r), a = Ac(s), c = k.select(
      "*[name()='performer']/*[name()='assignedEntity']/*[name()='assignedPerson']/*[name()='name']",
      r
    ).map((l) => Zt(l));
    return [
      {
        label: "Date/Time:",
        value: a.start || a.end ? `from ${vr(a.start) || "unknown"} to ${vr(a.end) || "unknown"}` : ""
      },
      ...c.map((l) => ({
        label: "Performer:",
        value: l
      }))
    ];
  }).reduce((r, s, a) => X(R({}, r), { [`documentationOf${a + 1}`]: s }), {});
}, l7 = (e) => {
  const t = k.select(
    "//*[name()='documentationOf']/*[name()='serviceEvent']",
    e
  );
  if (xe(t))
    return;
  const n = c7(e);
  return t.map(
    (r, s) => {
      const o = k.select("*[name()='performer']", r).map(
        (c, l) => {
          const d = String(
            k.select1("string(*[name()='functionCode']/@displayName)", c)
          ), u = ln(
            n,
            `documentationOf${s + 1}[${l + 1}].value`
          ), h = It(
            k.select("*[name()='assignedEntity']/*[name()='addr']", c),
            k.select(
              "*[name()='assignedEntity']/*[name()='telecom']",
              c
            )
          );
          if (!(!u && !d && !h))
            return {
              functionCode: d,
              name: u,
              contactDetails: h
            };
        }
      );
      return {
        dateTime: ln(
          n,
          `documentationOf${s + 1}[0].value`
        ),
        // first element is date time
        finalPerformers: o.filter(V6)
      };
    }
  );
}, d7 = ({ document: e }) => {
  const t = l7(e);
  if (!t || xe(t))
    return null;
  const n = t.flatMap((r) => [
    { label: "Documentation of - Date/Time", value: r.dateTime },
    { label: "", value: "" },
    ...r.finalPerformers.flatMap((s) => [
      {
        label: "Performer",
        value: `${s.name || "Unknown"}${s.functionCode ? ` - ${s.functionCode}` : ""}`
      },
      { label: "Contact Details", value: s.contactDetails }
    ])
  ]);
  return /* @__PURE__ */ i.jsx(At, { data: n });
}, Tm = (e) => {
  const t = k.select1(
    "*[name()='ClinicalDocument']/*[name()='componentOf']/*[name()='encompassingEncounter']",
    e
  );
  if (!t)
    return;
  const n = pn(k.select1("*[name()='id']", t)), r = String(
    k.select1(
      "string(*[name()='code']/@displayName)",
      t
    )
  ), s = Ac(
    k.select1("*[name()='effectiveTime']", t)
  );
  return [
    {
      label: "ID",
      value: s.start || s.end || n ? n || "Unknown" : ""
    },
    { label: "Type", value: r },
    {
      label: "Date/Time",
      value: s.start || s.end ? `from ${vr(s.start) || "unknown"} to ${vr(s.end) || "unknown"}` : ""
    }
  ];
}, u7 = (e) => {
  const t = k.select1(
    "*[name()='ClinicalDocument']/*[name()='componentOf']/*[name()='encompassingEncounter']",
    e
  );
  if (!t)
    return;
  const n = Tm(e), r = String(
    k.select1(
      "string(*[name()='dischargeDispositionCode']/@displayName)",
      t
    )
  ), s = pn(
    k.select1(
      "*[name()='location']/*[name()='healthCareFacility']/*[name()='id']",
      t
    )
  );
  return {
    id: n[0],
    // we now that they are returned in that order
    type: n[1],
    dateTime: n[2],
    dischargeDisposition: r,
    encounterLocation: s ? `ID: ${s}` : null
  };
}, f7 = ({ document: e }) => {
  const t = u7(e);
  if (!t)
    return null;
  const { dischargeDisposition: n, encounterLocation: r, id: s, type: a, dateTime: o } = t, c = [
    {
      label: "Encounter",
      value: o.value || n || r || s.value ? /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
        /* @__PURE__ */ i.jsx("b", { children: "ID: " }),
        s.value || "Unknown",
        a.value && /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
          /* @__PURE__ */ i.jsx("br", {}),
          /* @__PURE__ */ i.jsx("b", { children: "Type: " }),
          a.value
        ] })
      ] }) : null
    },
    {
      label: "Date/Time",
      value: o.value
    },
    {
      label: "Discharge Disposition",
      value: n
    },
    {
      label: "Encounter Location",
      value: r
    }
  ];
  return /* @__PURE__ */ i.jsx(At, { data: c });
}, h7 = (e) => {
  const t = k.select(
    "*[name()='ClinicalDocument']/*[name()='informant']",
    e
  );
  if (!xe(t))
    return t.map((n) => {
      const r = k.select1("*[name()='assignedEntity']", n);
      if (r) {
        const a = k.select1(
          "*[name()='assignedPerson']",
          r
        ), o = Zt(k.select("*[name()='name']", a)), c = It(
          k.select("*[name()='addr']", r),
          k.select("*[name()='telecom']", r)
        );
        return { name: o, contactDetails: c, relationship: "" };
      }
      const s = k.select1("*[name()='relatedEntity']", n);
      if (s) {
        const a = k.select1("*[name()='relatedPerson']", s), o = Zt(k.select("*[name()='name']", a)), c = It(
          k.select("*[name()='addr']", s),
          k.select("*[name()='telecom']", s)
        ), l = String(
          k.select1("string(*[name()='code']/@displayName)", s)
        ).toLowerCase();
        return { name: o, contactDetails: c, relationship: l };
      }
    }).filter(Ec);
}, p7 = ({ document: e }) => {
  const t = h7(e);
  if (!t || xe(t))
    return null;
  const n = t.flatMap((r) => [
    {
      label: "Informant",
      value: `${r.name || "Unknown"}${r.relationship ? ` - ${r.relationship}` : ""}`
    },
    {
      label: "Contact Details",
      value: r.contactDetails
    }
  ]);
  return /* @__PURE__ */ i.jsx(At, { data: n });
}, m7 = (e) => {
  const t = k.select(
    "*[name()='ClinicalDocument']/*[name()='informationRecipient']/*[name()='intendedRecipient']",
    e
  );
  if (!xe(t))
    return t.map((n) => {
      let r = "";
      const s = k.select1(
        "*[name()='informationRecipient']",
        n
      );
      s && (r = Zt(
        k.select1("*[name()='name']", s)
      ));
      const a = k.select("*[name()='id']", n).map(pn).join(", ");
      let o = "";
      const c = k.select1(
        "*[name()='receivedOrganization']",
        n
      );
      return c && (o = String(
        k.select1("string(*[name()='name']/node())", c)
      )), {
        name: r,
        id: a,
        organization: o
      };
    });
}, g7 = ({ document: e }) => {
  const t = m7(e);
  if (!t || xe(t))
    return null;
  const n = t.flatMap((r) => {
    var s;
    return [
      {
        label: "Information Recipient",
        value: (s = r.name) != null ? s : "Unnamed"
      },
      {
        label: "ID",
        value: r.id
      },
      {
        label: "Organization",
        value: r.organization
      }
    ];
  });
  return /* @__PURE__ */ i.jsx(At, { data: n, chunkSize: 3 });
}, w7 = (e) => {
  const t = k.select(
    "*[name()='ClinicalDocument']/*[name()='inFulfillmentOf']/*[name()='order']",
    e
  );
  return xe(t) ? void 0 : t.map((r) => {
    const s = pn(k.select1("*[name()='id']", r)), a = String(k.select1("string(*[name()='code']/@displayName)", r));
    return [
      { label: "Order ID:", value: s },
      { label: "Code:", value: a }
    ];
  }).reduce(
    (r, s, a) => X(R({}, r), { [`inFulfillmentOf${a + 1}`]: s }),
    {}
  );
}, v7 = (e) => {
  const t = w7(e);
  return Object.values(t || {});
}, y7 = ({ document: e }) => {
  const t = v7(e);
  if (xe(t))
    return null;
  const n = t.flatMap((r) => [
    {
      label: "In Fulfillment Of",
      value: `Order: ${r[0].value || "Unknown"}, ${// [0] is id
      r[1].value || "Unknown"}`
    },
    { label: "", value: "" }
  ]);
  return /* @__PURE__ */ i.jsx(At, { data: n });
}, x7 = (e) => {
  const t = k.select1(
    "*[name()='ClinicalDocument']/*[name()='legalAuthenticator']",
    e
  );
  if (!t)
    return;
  const n = k.select1(
    "*[name()='assignedEntity']",
    t
  ), r = k.select1("*[name()='assignedPerson']", n), s = Zt(k.select("*[name()='name']", r)), a = It(
    k.select("*[name()='addr']", n),
    k.select("*[name()='telecom']", n)
  ), o = vr(
    Pt(String(k.select1("string(*[name()='time']/@value)", t)))
  );
  return { name: s, contactDetails: a, time: o };
}, b7 = ({ document: e }) => {
  const t = x7(e);
  if (!t)
    return null;
  const { name: n, time: r, contactDetails: s } = t, a = r ? ` signed at ${r}` : "", o = [
    {
      label: "Legal Authenticator",
      value: `${n}${a}`
    },
    { label: "Contact Details", value: s }
  ];
  return /* @__PURE__ */ i.jsx(At, { data: o });
}, j7 = (e) => {
  const t = k.select(
    "*[name()='ClinicalDocument']/*[name()='participant']",
    e
  );
  if (!xe(t))
    return t.map((n) => {
      const r = k.select1("*[name()='associatedEntity']", n);
      if (r) {
        const s = k.select1(
          "*[name()='associatedPerson']",
          r
        ), a = Zt(k.select("*[name()='name']", s)), o = It(
          k.select("*[name()='addr']", r),
          k.select("*[name()='telecom']", r)
        ), c = k.select1("*[name()='time']", n), l = Ac(c), d = String(
          k.select1("string(*[name()='code']/@displayName)", r)
        ).toLowerCase();
        return {
          name: a,
          contactDetails: o,
          time: `from ${l.start} to ${l.end}`,
          relationship: d
        };
      }
    }).filter(Ec);
}, C7 = ({ document: e }) => {
  const t = j7(e);
  if (!t || xe(t))
    return null;
  const n = t.flatMap((r) => [
    {
      label: "Participant",
      value: `${r.name}${r.relationship ? ` - ${r.relationship}` : ""}`
    },
    {
      label: "Contact Details",
      value: r.contactDetails
    }
  ]);
  return /* @__PURE__ */ i.jsx(At, { data: n });
}, N7 = (e) => {
  const t = k.select1(
    "*[name()='birthplace']/*[name()='place']/*[name()='addr']",
    e
  );
  return t ? Im(t) : "";
}, D7 = (e) => {
  const t = k.select1("*[name()='ethnicGroupCode']", e);
  if (t)
    return String(k.select1("string(@displayName)", t));
  const n = k.select(
    "*[name()='sdtc:ethnicGroupCode']",
    e
  );
  return xe(n) ? "" : String(k.select1("string(@displayName)", n[0]));
}, Rm = (e) => {
  const t = k.select(
    "*[name()='patient']/*[name()='guardian']",
    e
  );
  if (!xe(t))
    return t.map((n) => {
      const r = k.select1("*[name()='guardianPerson']", n), s = String(k.select1("string(*[name()='code']/@displayName)", n)), a = Zt(k.select("*[name()='name']", r)), o = s ? ` - ${s}` : "";
      return {
        label: "",
        value: `${a}${o}`
      };
    });
}, S7 = (e) => {
  const t = k.select(
    "//*[name()='patientRole']/*[name()='patient']/*[name()='guardian']",
    document
  );
  if (!t || xe(t))
    return;
  const n = Rm(e);
  return t.map((r, s) => {
    const a = It(
      k.select("*[name()='addr']", r),
      k.select("*[name()='telecom']", r)
    );
    return { name: n[s].value, contactDetails: a };
  });
}, $7 = (e) => k.select("*[name()='languageCommunication']", e).reduce((n, r, s) => {
  const a = String(k.select1("string(*[name()='languageCode']/@code)", r));
  if (!a)
    return n;
  const o = String(k.select1("string(*[name()='preferenceInd']/@value)", r)), c = s === 0 ? "" : `
`, l = o !== "" ? `, preferred: ${o}` : "";
  return `${n}${c}${a}${l}`;
}, ""), A7 = (e) => String(k.select1("string(*[name()='maritalStatusCode']/@displayName)", e)), E7 = (e) => {
  const t = k.select1("*[name()='providerOrganization']", e), n = k.select1(
    "//*[name()='custodian']/*[name()='assignedCustodian']/*[name()='representedCustodianOrganization']",
    e
  ), r = t || n;
  if (!r)
    return {
      name: "",
      contactDetails: ""
    };
  const s = k.select("*[name()='id']", r).map(pn).join(", "), a = Em(k.select("string(*[name()='name'])", r)), o = It(
    k.select("*[name()='addr']", r),
    k.select("*[name()='telecom']", r)
  ), c = a ? `
${a}` : "";
  return {
    name: `${s}${c}`,
    contactDetails: o
  };
}, I7 = (e) => {
  const t = k.select1("*[name()='raceCode']", e);
  if (t)
    return String(k.select1("string(@displayName)", t));
  const n = k.select("*[name()='sdtc:raceCode']", e);
  return xe(n) ? "" : String(k.select1("string(@displayName)", n[0]));
}, _7 = (e) => String(k.select1("string(*[name()='religiousAffiliationCode']/@displayName)", e)), T7 = (e) => {
  const n = k.select(
    "*[name()='ClinicalDocument']/*[name()='recordTarget']/*[name()='patientRole']",
    e
  ).map(
    (r) => {
      const s = k.select1("*[name()='patient']", r), a = Zt(k.select1("*[name()='name']", s)), o = k.select("*[name()='id']", r).map(pn).join(", "), c = String(
        k.select1("string(*[name()='administrativeGenderCode']/@displayName)", s)
      ), l = un(
        Pt(String(k.select1("string(*[name()='birthTime']/@value)", s)))
      ), d = un(
        Pt(
          String(k.select1("string(*[name()='sdtc:deceasedTime']/@value)", s))
        )
      ), u = String(k.select1("string(*[name()='sdtc:deceasedInd']/@value)", s)) === "true", h = u ? "deceased" : ph(no(d) ? d : /* @__PURE__ */ new Date(), l), f = `${Qt(l, "MMMM dd, yyyy")} (${h}${u ? "" : " yr"}${no(d) ? " - deceased" : ""})`, p = Rm(r);
      return {
        patient: [
          { label: "Name:", value: a },
          {
            label: "ID:",
            value: o
          },
          {
            label: "Date of birth:",
            value: f
          },
          { label: "Gender:", value: c }
        ],
        guardian: p
      };
    }
  );
  return ur(n, (r) => [r.patient, r.guardian]).reduce(
    (r, s, a) => X(R({}, r), {
      [`patient${a + 1}`]: s[0],
      [`guardian${a + 1}`]: s[1]
    }),
    {}
  );
}, R7 = (e) => {
  const t = k.select("//*[name()='patientRole']", e);
  if (!t || xe(t))
    return;
  const n = T7(e), r = Object.entries(n).reduce(
    (s, [a, o]) => X(R({}, s), {
      [a]: o == null ? void 0 : o.reduce(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (c, l) => X(R({}, c), {
          [w2(l.label)]: l.value
        }),
        {}
      )
    }),
    {}
  );
  return t.map((s, a) => {
    const o = k.select1("*[name()='patient']", s), c = I7(o), l = D7(o), d = It(
      k.select("*[name()='addr']", s),
      k.select("*[name()='telecom']", s)
    ), u = $7(o), h = E7(s), f = S7(s), p = A7(o), m = _7(o), C = N7(o);
    return {
      name: r[`patient${a + 1}`].name,
      contactDetails: d,
      dateOfBirth: r[`patient${a + 1}`].dateOfBirth,
      gender: r[`patient${a + 1}`].gender,
      race: c,
      ethnicity: l,
      patientId: r[`patient${a + 1}`].id,
      language: u,
      maritalStatus: p,
      religion: m,
      birthPlace: C,
      guardian: f || [],
      providerOrganization: h.name,
      providerOrganizationContactDetails: h.contactDetails
    };
  });
}, M7 = ({ document: e }) => {
  const t = R7(e);
  return !t || xe(t) ? null : /* @__PURE__ */ i.jsx(i.Fragment, { children: t.map((n) => {
    const r = [
      { label: "Patient", value: n.name },
      { label: "Contact Details", value: n.contactDetails },
      { label: "Date Of Birth", value: n.dateOfBirth },
      { label: "Gender", value: n.gender },
      { label: "Race", value: n.race },
      { label: "Ethnicity", value: n.ethnicity },
      { label: "Patient ID", value: n.patientId },
      { label: "Language", value: n.language },
      { label: "Marital Status", value: n.maritalStatus },
      { label: "Religion", value: n.religion },
      { label: "Birth Place", value: n.birthPlace },
      ...n.guardian.map((s) => [
        { label: "Guardian", value: s.name },
        { label: "Contact Details", value: s.contactDetails }
      ]),
      // ts does not understand, we must explicitly state it is ok
      [
        {
          label: "Provider Organization",
          value: n.providerOrganization
        },
        {
          label: "Contact Details (Organization)",
          value: n.providerOrganizationContactDetails
        }
      ]
    ];
    return /* @__PURE__ */ i.jsx(
      At,
      {
        data: r.filter((s) => Ft(s) || s.value)
      },
      `${n.patientId}-${n.name}-${n.dateOfBirth}`
    );
  }) });
}, P7 = ({ document: e }) => /* @__PURE__ */ i.jsxs("div", { id: "document-details", children: [
  /* @__PURE__ */ i.jsx(o7, { document: e }),
  /* @__PURE__ */ i.jsx(n7, { document: e }),
  /* @__PURE__ */ i.jsx(M7, { document: e }),
  /* @__PURE__ */ i.jsx(K6, { document: e }),
  /* @__PURE__ */ i.jsx(s7, { document: e }),
  /* @__PURE__ */ i.jsx(p7, { document: e }),
  /* @__PURE__ */ i.jsx(g7, { document: e }),
  /* @__PURE__ */ i.jsx(b7, { document: e }),
  /* @__PURE__ */ i.jsx(Q6, { document: e }),
  /* @__PURE__ */ i.jsx(C7, { document: e }),
  /* @__PURE__ */ i.jsx(d7, { document: e }),
  /* @__PURE__ */ i.jsx(y7, { document: e }),
  /* @__PURE__ */ i.jsx(e7, { document: e }),
  /* @__PURE__ */ i.jsx(f7, { document: e })
] });
function O7(e, t) {
  return /* @__PURE__ */ De.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: t
  }, e), /* @__PURE__ */ De.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
  }));
}
const k7 = De.forwardRef(O7), L7 = k7;
function F7(e, t) {
  return /* @__PURE__ */ De.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: t
  }, e), /* @__PURE__ */ De.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
  }));
}
const B7 = De.forwardRef(F7), U7 = B7;
function z7(e, t) {
  return /* @__PURE__ */ De.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: t
  }, e), /* @__PURE__ */ De.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10 14H5.236a2 2 0 01-1.789-2.894l3.5-7A2 2 0 018.736 3h4.018a2 2 0 01.485.06l3.76.94m-7 10v5a2 2 0 002 2h.096c.5 0 .905-.405.905-.904 0-.715.211-1.413.608-2.008L17 13V4m-7 10h2m5-10h2a2 2 0 012 2v6a2 2 0 01-2 2h-2.5"
  }));
}
const H7 = De.forwardRef(z7), W7 = H7;
function V7(e, t) {
  return /* @__PURE__ */ De.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: t
  }, e), /* @__PURE__ */ De.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5"
  }));
}
const q7 = De.forwardRef(V7), G7 = q7;
function Y7(e, t) {
  return /* @__PURE__ */ De.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: t
  }, e), /* @__PURE__ */ De.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6 18L18 6M6 6l12 12"
  }));
}
const Q7 = De.forwardRef(Y7), Mm = Q7, Z7 = (e) => String(
  k.select1("string(*[name()='ClinicalDocument']/*[name()='title']/text())", e)
), K7 = "ctw-modal", Ic = "document-header", _c = "table-of-contents", J7 = (e, t) => {
  var c, l;
  const n = t ? document.getElementById("ccda-viewer") : document.getElementById("ctw-modal"), r = (c = document.getElementById("document-header")) == null ? void 0 : c.getBoundingClientRect().y, s = (l = document.getElementById("table-of-contents")) == null ? void 0 : l.getBoundingClientRect().bottom, a = document.getElementById(e);
  if (s === void 0 || r === void 0 || !n || !a)
    return;
  const o = a.getBoundingClientRect().top;
  if (t) {
    const d = window.scrollY;
    document.documentElement.scrollTop = d + o - s + r;
    return;
  }
  n.scrollTop += o - s + r;
}, Pm = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyMiAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzIyNF82NzYwKSI+CjxwYXRoIGQ9Ik0xNi45NzY3IDE3LjIyMkwxMS40MTQ5IDEzLjk1NDVMMTUuNDI0OCA2Ljg4NDc0QzE1LjQ1MSA2LjgzOTI1IDE1LjQ5NzIgNi43NTYxMSAxNS40MjQ4IDYuNjI3NDhDMTUuMzUyNCA2LjQ5ODg1IDE1LjI1NjggNi40OTg4NSAxNS4yMDYgNi40OTg4NUg3LjE4NDU3Vi0wLjAzOTE4NDZIMTUuMjA2QzE3LjYxOTMgLTAuMDM5MTg0NiAxOS43Nzk5IDEuMjI5ODQgMjAuOTg2NiAzLjM1Njg5QzIyLjE5MzMgNS40ODM5NSAyMi4xOTMzIDguMDIzNTYgMjAuOTg2NiAxMC4xNTA2TDE2Ljk3NjcgMTcuMjIwNFYxNy4yMjJaIiBmaWxsPSIjMDA4MDUxIi8+CjxwYXRoIGQ9Ik0xNC41OTQgMjRINi42NDY2QzQuMjMzMjQgMjQgMi4wNzI2MiAyMi43MzA5IDAuODY1OTQ2IDIwLjYwMzlDLTAuMzQwNzMyIDE4LjQ3NjggLTAuMzQwNzMyIDE1LjkzNzIgMC44NjU5NDYgMTMuODEwMkw0Ljg3NTg4IDYuNzQwMzZMMTAuNDM2MiAxMC4wMDc4TDYuNDI2MjIgMTcuMDc3NkM2LjQwMDAyIDE3LjEyMzEgNi4zNTM3OSAxNy4yMDYyIDYuNDI2MjIgMTcuMzM0OUM2LjQ5ODY1IDE3LjQ2MzUgNi41OTQyIDE3LjQ2MzUgNi42NDUwNiAxNy40NjM1SDE0LjU5MjVWMjRIMTQuNTk0WiIgZmlsbD0iIzcxQjJDOSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzIyNF82NzYwIj4KPHJlY3Qgd2lkdGg9IjIyIiBoZWlnaHQ9IjI0IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=", Tc = typeof window != "undefined" ? Cw : he, X7 = "ctw-", Om = {
  xs: 400,
  sm: 640,
  md: 768,
  lg: 1024
}, eO = {
  colors: {
    transparent: "transparent",
    white: "#ffffff",
    black: "#000000",
    primary: {
      light: "#D0FBE2",
      main: "#008052",
      dark: "#036240"
    },
    icon: {
      default: "#374151",
      light: "#D1D5DB",
      active: "#A855F7"
    },
    divider: {
      main: "#D1D5DB",
      light: "#E5E7EB"
    },
    content: {
      black: "#111827",
      light: "#6B7280",
      lighter: "#9CA3AF"
    },
    error: {
      main: "#EF4444",
      light: "#FEE2E2",
      dark: "#7F1D1D",
      text: "#991B1B",
      message: "#B91C1B",
      bg: "#FEF2F2",
      icon: "#F97171"
    },
    success: {
      main: "#10B981",
      light: "#D1FAE5",
      dark: "#065F46"
    },
    caution: {
      bg: "#FFFBEB",
      icon: "#F59E0B",
      light: "#FEF3C7",
      text: "#92400E",
      textHover: "#D4753C"
    },
    notification: {
      light: "#F3E8FF",
      main: "#A855F7",
      icon: "#EF4444",
      dark: "#4B5563"
    },
    info: {
      bg: "#F0F9FF",
      light: "#E0F2FE",
      icon: "#0EA5E9",
      text: "#075985",
      textHover: "#0979B6"
    },
    bg: {
      white: "#FFFFFF",
      lighter: "#F9FAFB",
      light: "#F3F4F6",
      dark: "#E5E7EB",
      black: "#111827",
      zusLogoBlue: "#71B2C9"
    },
    zap: {
      headerBg: "#ffffff"
    }
  }
}, tO = {
  "--tw-pan-x": " ",
  "--tw-pan-y": " ",
  "--tw-pinch-zoom": " ",
  "--tw-ordinal": " ",
  "--tw-slashed-zero": " ",
  "--tw-numeric-figure": " ",
  "--tw-numeric-spacing": " ",
  "--tw-numeric-fraction": " ",
  "--tw-ring-inset": " ",
  "--tw-blur": " ",
  "--tw-brightness": " ",
  "--tw-contrast": " ",
  "--tw-grayscale": " ",
  "--tw-hue-rotate": " ",
  "--tw-invert": " ",
  "--tw-saturate": " ",
  "--tw-sepia": " ",
  "--tw-drop-shadow": " ",
  "--tw-backdrop-blur": " ",
  "--tw-backdrop-brightness": " ",
  "--tw-backdrop-contrast": " ",
  "--tw-backdrop-grayscale": " ",
  "--tw-backdrop-hue-rotate": " ",
  "--tw-backdrop-invert": " ",
  "--tw-backdrop-opacity": " ",
  "--tw-backdrop-saturate": " ",
  "--tw-backdrop-sepia": " "
}, km = X(R({}, eO), {
  breakpoints: Om
});
function Tu(e) {
  return `--${X7}-${e}`;
}
function nO(e) {
  const t = {};
  return Object.entries(e).forEach(([n, r]) => {
    typeof r == "string" ? t[Tu(n)] = Ru(r) : Object.entries(r).forEach(([s, a]) => {
      t[Tu(`${n}-${s}`)] = Ru(a);
    });
  }), t;
}
function Ru(e, t) {
  if (e.startsWith("#")) {
    const n = parseInt(e.slice(1, 3), 16), r = parseInt(e.slice(3, 5), 16), s = parseInt(e.slice(5, 7), 16);
    return t ? `rgba(${n}, ${r}, ${s}, ${t})` : `rgb(${n}, ${r}, ${s})`;
  }
  return e;
}
const Rc = Ct({
  theme: km,
  ctwThemeRef: Nw()
});
function Lm() {
  return tt(Rc);
}
const rO = (
  // @ts-ignore
  Xl.default || Xl
);
function wt(e) {
  const { theme: t } = Lm(), [n, r] = Y(X(R({}, js(Om, () => !1)), {
    width: 0
  })), s = vt(() => {
    const a = e.current;
    if (!a)
      return;
    const { width: o } = a.getBoundingClientRect();
    if (o === 0)
      return;
    const c = { width: o };
    Object.entries(t.breakpoints).forEach(([l, d]) => {
      c[l] = o < d;
    }), r(c);
  }, [e, t.breakpoints]);
  return Tc(s, [e.current, t]), rO(e.current, s), n;
}
const go = (e) => {
  const [t, n] = Y(0);
  return he(() => {
    const r = () => {
      const a = document.getElementById(e), o = a ? a.getBoundingClientRect().height : 0;
      n(o);
    }, s = setTimeout(() => {
      const a = document.getElementById(e);
      if (a) {
        const o = new ResizeObserver(r);
        return o.observe(a), () => {
          o.unobserve(a);
        };
      }
    }, 500);
    return () => {
      clearTimeout(s);
    };
  }, [e]), t;
}, sO = ({
  document: e,
  children: t,
  sections: n,
  overridePatient: r
}) => {
  const s = Te(null), a = wt(s), o = go(Ic), c = [
    ...n.map(({ title: l, id: d, isEmpty: u }) => ({ title: l, id: d, isEmpty: u })),
    { title: "Demographic Details", id: "demographic-details", isEmpty: !1 }
  ];
  return /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
    /* @__PURE__ */ i.jsx(
      "div",
      {
        className: W("ctw-text-lg ctw-top-0 ctw-z-50", {
          "ctw-sticky": !a.md
        }),
        id: _c,
        ref: s,
        style: { top: o },
        children: /* @__PURE__ */ i.jsx(
          iO,
          {
            document: e,
            sections: c,
            breakpoints: a,
            overridePatient: r
          }
        )
      }
    ),
    /* @__PURE__ */ i.jsx("div", { className: "ctw-ccda-header-container ctw-space-y-4", children: /* @__PURE__ */ i.jsx("div", { className: "ctw-flex ctw-w-full", children: /* @__PURE__ */ i.jsx("div", { className: "ctw-w-fit ctw-basis-1/2", children: t }) }) })
  ] });
}, aO = ({
  onClose: e,
  actions: t,
  overridePatient: n,
  binaryId: r
}) => {
  var h;
  const s = Ze(), a = Te(null), o = wt(a), c = n || s.patient.data, { featureFlags: l } = Xe(), d = `/ccda/${r}`, u = typeof window != "undefined" && new URL(window.location.href).pathname === d;
  return /* @__PURE__ */ i.jsxs(
    "div",
    {
      className: "ctw-flex ctw-justify-between ctw-bg-bg-black ctw-text-white ctw-p-3 ctw-top-0 ctw-z-50 ctw-sticky",
      ref: a,
      id: Ic,
      children: [
        /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-space-x-4 ctw-overflow-hidden", children: [
          /* @__PURE__ */ i.jsx("img", { src: Pm, alt: "Zus" }),
          c && /* @__PURE__ */ i.jsxs(
            "div",
            {
              className: W("ctw-space-x-1", {
                "ctw-text-ellipsis ctw-text-sm ctw-overflow-hidden ctw-whitespace-nowrap": o.sm
              }),
              children: [
                /* @__PURE__ */ i.jsx("span", { children: c.firstName }),
                /* @__PURE__ */ i.jsx("span", { children: c.lastName }),
                /* @__PURE__ */ i.jsx("span", { className: "ctw-uppercase", children: `(${(h = c.gender) == null ? void 0 : h[0]}),` }),
                /* @__PURE__ */ i.jsx("span", { children: c.dob }),
                /* @__PURE__ */ i.jsx("span", { children: `(${c.age}yr)` })
              ]
            }
          )
        ] }),
        /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-space-x-2 ctw-items-center", children: [
          (l == null ? void 0 : l.openCCDAInNewTab) && !u && /* @__PURE__ */ i.jsx(
            "a",
            {
              "aria-label": "Open in new tab",
              href: d,
              className: "ctw-flex ctw-items-center ctw-space-x-2",
              rel: "noopener noreferrer",
              target: "_blank",
              children: /* @__PURE__ */ i.jsx(me, { className: "ctw-cursor-pointer", icon: rh })
            }
          ),
          t && /* @__PURE__ */ i.jsx("div", { className: "ctw-flex", children: t }),
          !u && /* @__PURE__ */ i.jsxs(dO, { onClose: e, children: [
            /* @__PURE__ */ i.jsx("span", { className: " ctw-text-white ctw-text-sm", children: "Close" }),
            /* @__PURE__ */ i.jsx(Mm, { className: "ctw-h-4 ctw-w-4 ctw-text-white", "aria-hidden": "true" })
          ] })
        ] })
      ]
    }
  );
}, iO = ({
  document: e,
  sections: t,
  breakpoints: n,
  overridePatient: r
}) => {
  const [s, a] = Y(!0), { trackInteraction: o } = Be(), c = () => {
    a(!s), o("toggle_document_section", {
      action: s ? "collapse_document_section" : "expand_document_section"
    });
  };
  return /* @__PURE__ */ i.jsxs("div", { className: "ctw-bg-bg-lighter ctw-min-w-[300px] ctw-w-full ctw-flex ctw-flex-col", children: [
    /* @__PURE__ */ i.jsxs("div", { className: "ctw-text-sm ctw-px-4 ctw-py-2  ctw-uppercase ctw-bg-bg-zusLogoBlue ctw-text-white ", children: [
      /* @__PURE__ */ i.jsxs("button", { type: "button", className: "ctw-ccda-section-arrow section", onClick: c, children: [
        /* @__PURE__ */ i.jsx("span", { className: "ctw-hidden", children: "hide" }),
        /* @__PURE__ */ i.jsx(
          me,
          {
            icon: s ? $w : Fo,
            className: W("ctw-ml-auto ctw-w-4")
          }
        )
      ] }),
      "in this document"
    ] }),
    !s && /* @__PURE__ */ i.jsx("div", { children: /* @__PURE__ */ i.jsxs(
      "div",
      {
        className: W(
          "ctw-in-this-document-section ctw-items-baseline ctw-space-y-2.5 ctw-px-4 ctw-py-2",
          { "!ctw-flex ctw-flex-col": n == null ? void 0 : n.lg }
        ),
        children: [
          /* @__PURE__ */ i.jsx(oO, { sections: t, breakpoints: n }),
          /* @__PURE__ */ i.jsx(cO, { breakpoints: n, overridePatient: r }),
          /* @__PURE__ */ i.jsx(lO, { breakpoints: n, document: e })
        ]
      }
    ) })
  ] });
}, oO = ({
  sections: e,
  breakpoints: t
}) => {
  const n = typeof window != "undefined" && new URL(window.location.href).pathname.includes("/ccda/"), r = e.length > 7 && e.length < 15, s = e.length < 8, a = () => s ? 1 : t != null && t.md || r ? 2 : 3, o = Math.ceil(e.length / a()), c = a();
  return /* @__PURE__ */ i.jsxs("div", { className: "ctw-w-full ctw-space-y-1", children: [
    /* @__PURE__ */ i.jsx("h1", { className: "ctw-font-medium ctw-text-content-light ctw-uppercase ctw-text-sm", children: "Contents Menu" }),
    /* @__PURE__ */ i.jsx(
      "ol",
      {
        style: {
          "--number-of-columns": c,
          "--number-of-rows": o
        },
        className: W(
          "ctw-items-baseline ctw-list-decimal ctw-list-inside table-of-contents ctw-text-sm",
          { "!ctw-gap-1 ": t == null ? void 0 : t.sm }
        ),
        children: e.map(({ title: l, id: d, isEmpty: u }) => /* @__PURE__ */ i.jsx(
          "button",
          {
            className: W(
              "ctw-button-list-item",
              { "!ctw-p-1": t == null ? void 0 : t.sm },
              { "ctw-text-content-light": u }
            ),
            type: "button",
            onClick: () => {
              J7(d, n);
            },
            children: /* @__PURE__ */ i.jsxs("li", { className: "ctw-list-item", children: [
              l,
              " ",
              u && " (empty)"
            ] })
          },
          `el-text-${d}`
        ))
      }
    )
  ] });
}, cO = ({
  breakpoints: e,
  overridePatient: t
}) => {
  var s;
  const n = Ze(), r = t || n.patient.data;
  return /* @__PURE__ */ i.jsxs("div", { className: W("ctw-text-base ctw-space-y-1", { "ctw-p-1": e == null ? void 0 : e.md }), children: [
    /* @__PURE__ */ i.jsx("div", { className: "ctw-font-medium ctw-text-content-light ctw-uppercase ctw-text-sm", children: "Details" }),
    /* @__PURE__ */ i.jsxs("div", { className: "ctw-patient-details", children: [
      /* @__PURE__ */ i.jsxs("div", { className: "item", children: [
        /* @__PURE__ */ i.jsx("div", { className: "ctw-capitalize ctw-font-medium", children: "patient name:" }),
        /* @__PURE__ */ i.jsxs("div", { className: "ctw-space-x-1", children: [
          /* @__PURE__ */ i.jsx("span", { children: r == null ? void 0 : r.firstName }),
          /* @__PURE__ */ i.jsx("span", { children: r == null ? void 0 : r.lastName }),
          /* @__PURE__ */ i.jsx("span", { className: "ctw-uppercase", children: `(${(s = r == null ? void 0 : r.gender) == null ? void 0 : s[0]})` })
        ] })
      ] }),
      /* @__PURE__ */ i.jsxs("div", { className: "item", children: [
        /* @__PURE__ */ i.jsx("div", { className: "ctw-capitalize ctw-font-medium", children: "dob:" }),
        /* @__PURE__ */ i.jsx("div", { children: r == null ? void 0 : r.dob })
      ] }),
      /* @__PURE__ */ i.jsxs("div", { className: "item", children: [
        /* @__PURE__ */ i.jsx("div", { className: "ctw-capitalize ctw-font-medium", children: "phone:" }),
        /* @__PURE__ */ i.jsx("div", { children: r == null ? void 0 : r.phoneNumber })
      ] }),
      /* @__PURE__ */ i.jsxs("div", { className: "item", children: [
        /* @__PURE__ */ i.jsx("div", { className: "ctw-capitalize ctw-font-medium", children: "email:" }),
        /* @__PURE__ */ i.jsx("div", { children: r == null ? void 0 : r.email })
      ] })
    ] })
  ] });
}, lO = ({
  breakpoints: e,
  document: t
}) => {
  var l, d, u, h;
  const n = Z7(t), r = Tm(t), s = (l = r == null ? void 0 : r.find((f) => f.label === "Type")) == null ? void 0 : l.value, a = (d = r == null ? void 0 : r.find((f) => f.label === "Date/Time")) == null ? void 0 : d.value, o = _m(t), c = (h = (u = o == null ? void 0 : o.author1) == null ? void 0 : u.find((f) => f.label === "Organization:")) == null ? void 0 : h.value;
  return /* @__PURE__ */ i.jsx("div", { className: W("ctw-text-base ctw-space-y-1", { "ctw-p-1": e == null ? void 0 : e.md }), children: /* @__PURE__ */ i.jsxs("div", { className: "ctw-document-details", children: [
    n && /* @__PURE__ */ i.jsxs("div", { className: "item", children: [
      /* @__PURE__ */ i.jsx("div", { className: "ctw-capitalize ctw-font-medium", children: "title:" }),
      /* @__PURE__ */ i.jsx("div", { children: n })
    ] }),
    s && /* @__PURE__ */ i.jsxs("div", { className: "item", children: [
      /* @__PURE__ */ i.jsx("div", { className: "ctw-capitalize ctw-font-medium", children: "encounter type:" }),
      /* @__PURE__ */ i.jsx("div", { children: s })
    ] }),
    a && /* @__PURE__ */ i.jsxs("div", { className: "item", children: [
      /* @__PURE__ */ i.jsx("div", { className: "ctw-capitalize ctw-font-medium", children: "date:" }),
      /* @__PURE__ */ i.jsx("div", { children: a })
    ] }),
    c && /* @__PURE__ */ i.jsxs("div", { className: "item", children: [
      /* @__PURE__ */ i.jsx("div", { className: "ctw-capitalize ctw-font-medium", children: "author:" }),
      /* @__PURE__ */ i.jsx("div", { children: c })
    ] })
  ] }) });
}, dO = ({ onClose: e, children: t }) => {
  const { trackInteraction: n } = Be();
  return /* @__PURE__ */ i.jsx(
    "button",
    {
      type: "button",
      "aria-label": "close",
      onClick: () => {
        e && e(), n("close_document");
      },
      className: "ctw-btn-clear ctw-flex ctw-items-center ctw-space-x-1",
      children: t
    }
  );
}, Fm = Ct({}), Bm = Ct(void 0), Mu = (e) => /* @__PURE__ */ i.jsx("div", {});
function uO() {
  const [e, t] = Y(!1), [n, r] = Y({
    // Create some dummy initial props for the drawer. These will get
    // overwritten when openDrawer() is used.
    component: Mu
  }), s = Be(), a = ke(
    () => ({
      closeDrawer: () => {
        t(!1);
      },
      openDrawer: (c) => {
        r(c), t(!1), setTimeout(() => {
          t(!0), s.trackInteraction("open_drawer", c.trackingMetadata);
        });
      }
    }),
    [s]
  );
  return { drawerComponent: ke(
    () => n.component({
      isOpen: e,
      onClose: () => {
        t(!1), r({
          component: Mu
        });
      }
    }),
    [n, e]
  ), drawerState: a };
}
const Vn = () => {
  const e = tt(Bm);
  if (!e)
    throw new Error("useDrawer must be used within a DrawerProvider");
  return e;
}, Um = Ct(void 0), fO = (e) => /* @__PURE__ */ i.jsx("div", {});
function hO() {
  const [e, t] = Y(!1), [n, r] = Y({
    // Create some dummy initial props for the modal. These will get
    // overwritten when openModal() is used.
    component: fO
  }), s = ke(
    () => ({
      openModal: (o) => {
        r(o), t(!1), setTimeout(() => {
          t(!0);
        });
      }
    }),
    []
  );
  return { modalComponent: ke(
    () => n.component({
      isOpen: e,
      onClose: () => t(!1)
    }),
    [n, e]
  ), modalState: s };
}
const Mc = () => {
  const e = tt(Um);
  if (!e)
    throw new Error("useModal must be used within a ModalProvider");
  return e;
};
function pO({ children: e }) {
  const { modalComponent: t, modalState: n } = hO(), { drawerComponent: r, drawerState: s } = uO();
  return /* @__PURE__ */ i.jsx(Um.Provider, { value: n, children: /* @__PURE__ */ i.jsxs(Bm.Provider, { value: s, children: [
    t,
    r,
    e
  ] }) });
}
const zm = Ct(void 0), Hm = Ct({
  getAuthToken: () => Promise.resolve(""),
  isExpired: !1
});
function Pc() {
  return tt(Hm).getAuthToken;
}
const Wm = Ct(void 0), Pa = (e) => e === "production" ? "https://api.zusapi.com" : `https://api.${e}.zusapi.com`, Kt = (e, t) => e === "phitest" && ["fqs", "patient-history", "zap-data-subscriptions"].includes(t) ? `https://${t}.phitest.zusapi.com` : e === "production" ? `https://${t}.zusapi.com` : `https://${t}.${e}.zusapi.com`, mO = (e) => e === "production" ? "https://zap.zushealth.com" : `https://zap.${e}.zushealth.com`, Vm = (e) => {
  const { VITE_LOCAL_EHR_HOOKS_URL: t } = { VITE_GIT_SHA: "84994953378fa7228577bb56ccff158a1e13f77b", BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 };
  return t || (e === "production" ? "https://ehr-hooks.zusapi.com" : `https://ehr-hooks.${e}.zusapi.com`);
}, gO = (e) => `${Pa(e)}/fhir`, wO = (e) => `${Pa(e)}/forms-data/terminology/conditions`, vO = (e) => `${Pa(e)}/forms-data/terminology/dosages`, sa = (e) => window.location.hostname === "localhost" ? {}.VITE_LOCAL_METRICS_URL || "http://localhost:3000" : ["prod", "production"].includes(e) ? "https://app.zushealth.com" : `https://app.${e}.zushealth.com`, Oc = (e) => {
  switch (e) {
    case "dev":
      return "bc1c791a-581c-4117-8b17-f9c59f39caf8";
    case "phitest":
      return "186d5446-46ec-4beb-8699-9e42903a3dd2";
    case "production":
      return "5e0f86eb-bb0b-4543-8489-262fcbf661da";
    case "sandbox":
      return "d8ab3e86-7ff2-482d-bbed-b30df2dd7ec7";
    default:
      throw new Error("Unknown environment");
  }
};
class dn extends Error {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(n, ...r) {
    super(...r);
    ne(this, "statusCode");
    ne(this, "statusText");
    ne(this, "requestInfo");
    ne(this, "stack");
    Error.captureStackTrace && Error.captureStackTrace(this, dn), this.name = "RequestError", this.statusCode = n.status, this.statusText = n.statusText, this.requestInfo = n;
  }
}
class Oa extends Error {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(n, ...r) {
    super(...r);
    ne(this, "identifier", "");
    ne(this, "otherQueryKeys", {});
    ne(this, "responseErrors", { status: 200, errors: {} });
    ne(this, "requestErrors", { query: "", variables: {} });
    ne(this, "stack");
    Error.captureStackTrace && Error.captureStackTrace(this, dn), this.name = "ReactQueryError", this.init(n);
  }
  init(n) {
    const [r, ...s] = n.queryKey, a = Oa.serializedQueryKey(s);
    this.identifier = r, this.otherQueryKeys = a;
    const o = n.state.error;
    o && (this.setRequestErrors(o.request), this.setResponseErrors(o.response));
  }
  setRequestErrors(n) {
    this.requestErrors = n;
  }
  setResponseErrors(n) {
    this.responseErrors = n;
  }
  static serializedQueryKey(n) {
    const r = {};
    return n.forEach((s, a) => {
      try {
        r[`query${a + 2}`] = JSON.stringify(s);
      } catch (o) {
        s.constructor.name && (r[`query${a + 2}`] = s.constructor.name);
      }
    }), r;
  }
  toString() {
    return `${this.name}: ${this.identifier} - ${JSON.stringify(
      this.otherQueryKeys
    )} - ${JSON.stringify(this.stack)}`;
  }
}
const qm = (e) => new Promise((t) => {
  setTimeout(t, e);
}), yO = 1e3 * 60 * 60, Ps = "zus:sessionLastActiveTimestamp", xi = "zus:sessionUserId";
class Pn {
  static isActive() {
    const t = localStorage.getItem(Ps);
    if (t) {
      const n = parseInt(t, 10);
      return (/* @__PURE__ */ new Date()).getTime() - yO < n;
    }
    return !1;
  }
  static setSessionLastActiveTimestamp() {
    localStorage.setItem(Ps, (/* @__PURE__ */ new Date()).getTime().toString());
  }
  static clearSessionLastActiveTimestamp() {
    localStorage.removeItem(Ps);
  }
  /**
   * Sets the session user id. If the user id is already set and not of the
   * same value, the active session will be cleared.
   */
  static setSessionUserId(t) {
    localStorage.getItem(xi) !== t && (Pn.clearSession(), localStorage.setItem(xi, t));
  }
  static clearSession() {
    localStorage.removeItem(xi), localStorage.removeItem(Ps);
  }
}
function Gm(e) {
  return typeof e == "object" && e !== null ? "issue" in e : !1;
}
var Ym = {};
(function(e) {
  e.aliasToReal = {
    // Lodash aliases.
    each: "forEach",
    eachRight: "forEachRight",
    entries: "toPairs",
    entriesIn: "toPairsIn",
    extend: "assignIn",
    extendAll: "assignInAll",
    extendAllWith: "assignInAllWith",
    extendWith: "assignInWith",
    first: "head",
    // Methods that are curried variants of others.
    conforms: "conformsTo",
    matches: "isMatch",
    property: "get",
    // Ramda aliases.
    __: "placeholder",
    F: "stubFalse",
    T: "stubTrue",
    all: "every",
    allPass: "overEvery",
    always: "constant",
    any: "some",
    anyPass: "overSome",
    apply: "spread",
    assoc: "set",
    assocPath: "set",
    complement: "negate",
    compose: "flowRight",
    contains: "includes",
    dissoc: "unset",
    dissocPath: "unset",
    dropLast: "dropRight",
    dropLastWhile: "dropRightWhile",
    equals: "isEqual",
    identical: "eq",
    indexBy: "keyBy",
    init: "initial",
    invertObj: "invert",
    juxt: "over",
    omitAll: "omit",
    nAry: "ary",
    path: "get",
    pathEq: "matchesProperty",
    pathOr: "getOr",
    paths: "at",
    pickAll: "pick",
    pipe: "flow",
    pluck: "map",
    prop: "get",
    propEq: "matchesProperty",
    propOr: "getOr",
    props: "at",
    symmetricDifference: "xor",
    symmetricDifferenceBy: "xorBy",
    symmetricDifferenceWith: "xorWith",
    takeLast: "takeRight",
    takeLastWhile: "takeRightWhile",
    unapply: "rest",
    unnest: "flatten",
    useWith: "overArgs",
    where: "conformsTo",
    whereEq: "isMatch",
    zipObj: "zipObject"
  }, e.aryMethod = {
    1: [
      "assignAll",
      "assignInAll",
      "attempt",
      "castArray",
      "ceil",
      "create",
      "curry",
      "curryRight",
      "defaultsAll",
      "defaultsDeepAll",
      "floor",
      "flow",
      "flowRight",
      "fromPairs",
      "invert",
      "iteratee",
      "memoize",
      "method",
      "mergeAll",
      "methodOf",
      "mixin",
      "nthArg",
      "over",
      "overEvery",
      "overSome",
      "rest",
      "reverse",
      "round",
      "runInContext",
      "spread",
      "template",
      "trim",
      "trimEnd",
      "trimStart",
      "uniqueId",
      "words",
      "zipAll"
    ],
    2: [
      "add",
      "after",
      "ary",
      "assign",
      "assignAllWith",
      "assignIn",
      "assignInAllWith",
      "at",
      "before",
      "bind",
      "bindAll",
      "bindKey",
      "chunk",
      "cloneDeepWith",
      "cloneWith",
      "concat",
      "conformsTo",
      "countBy",
      "curryN",
      "curryRightN",
      "debounce",
      "defaults",
      "defaultsDeep",
      "defaultTo",
      "delay",
      "difference",
      "divide",
      "drop",
      "dropRight",
      "dropRightWhile",
      "dropWhile",
      "endsWith",
      "eq",
      "every",
      "filter",
      "find",
      "findIndex",
      "findKey",
      "findLast",
      "findLastIndex",
      "findLastKey",
      "flatMap",
      "flatMapDeep",
      "flattenDepth",
      "forEach",
      "forEachRight",
      "forIn",
      "forInRight",
      "forOwn",
      "forOwnRight",
      "get",
      "groupBy",
      "gt",
      "gte",
      "has",
      "hasIn",
      "includes",
      "indexOf",
      "intersection",
      "invertBy",
      "invoke",
      "invokeMap",
      "isEqual",
      "isMatch",
      "join",
      "keyBy",
      "lastIndexOf",
      "lt",
      "lte",
      "map",
      "mapKeys",
      "mapValues",
      "matchesProperty",
      "maxBy",
      "meanBy",
      "merge",
      "mergeAllWith",
      "minBy",
      "multiply",
      "nth",
      "omit",
      "omitBy",
      "overArgs",
      "pad",
      "padEnd",
      "padStart",
      "parseInt",
      "partial",
      "partialRight",
      "partition",
      "pick",
      "pickBy",
      "propertyOf",
      "pull",
      "pullAll",
      "pullAt",
      "random",
      "range",
      "rangeRight",
      "rearg",
      "reject",
      "remove",
      "repeat",
      "restFrom",
      "result",
      "sampleSize",
      "some",
      "sortBy",
      "sortedIndex",
      "sortedIndexOf",
      "sortedLastIndex",
      "sortedLastIndexOf",
      "sortedUniqBy",
      "split",
      "spreadFrom",
      "startsWith",
      "subtract",
      "sumBy",
      "take",
      "takeRight",
      "takeRightWhile",
      "takeWhile",
      "tap",
      "throttle",
      "thru",
      "times",
      "trimChars",
      "trimCharsEnd",
      "trimCharsStart",
      "truncate",
      "union",
      "uniqBy",
      "uniqWith",
      "unset",
      "unzipWith",
      "without",
      "wrap",
      "xor",
      "zip",
      "zipObject",
      "zipObjectDeep"
    ],
    3: [
      "assignInWith",
      "assignWith",
      "clamp",
      "differenceBy",
      "differenceWith",
      "findFrom",
      "findIndexFrom",
      "findLastFrom",
      "findLastIndexFrom",
      "getOr",
      "includesFrom",
      "indexOfFrom",
      "inRange",
      "intersectionBy",
      "intersectionWith",
      "invokeArgs",
      "invokeArgsMap",
      "isEqualWith",
      "isMatchWith",
      "flatMapDepth",
      "lastIndexOfFrom",
      "mergeWith",
      "orderBy",
      "padChars",
      "padCharsEnd",
      "padCharsStart",
      "pullAllBy",
      "pullAllWith",
      "rangeStep",
      "rangeStepRight",
      "reduce",
      "reduceRight",
      "replace",
      "set",
      "slice",
      "sortedIndexBy",
      "sortedLastIndexBy",
      "transform",
      "unionBy",
      "unionWith",
      "update",
      "xorBy",
      "xorWith",
      "zipWith"
    ],
    4: [
      "fill",
      "setWith",
      "updateWith"
    ]
  }, e.aryRearg = {
    2: [1, 0],
    3: [2, 0, 1],
    4: [3, 2, 0, 1]
  }, e.iterateeAry = {
    dropRightWhile: 1,
    dropWhile: 1,
    every: 1,
    filter: 1,
    find: 1,
    findFrom: 1,
    findIndex: 1,
    findIndexFrom: 1,
    findKey: 1,
    findLast: 1,
    findLastFrom: 1,
    findLastIndex: 1,
    findLastIndexFrom: 1,
    findLastKey: 1,
    flatMap: 1,
    flatMapDeep: 1,
    flatMapDepth: 1,
    forEach: 1,
    forEachRight: 1,
    forIn: 1,
    forInRight: 1,
    forOwn: 1,
    forOwnRight: 1,
    map: 1,
    mapKeys: 1,
    mapValues: 1,
    partition: 1,
    reduce: 2,
    reduceRight: 2,
    reject: 1,
    remove: 1,
    some: 1,
    takeRightWhile: 1,
    takeWhile: 1,
    times: 1,
    transform: 2
  }, e.iterateeRearg = {
    mapKeys: [1],
    reduceRight: [1, 0]
  }, e.methodRearg = {
    assignInAllWith: [1, 0],
    assignInWith: [1, 2, 0],
    assignAllWith: [1, 0],
    assignWith: [1, 2, 0],
    differenceBy: [1, 2, 0],
    differenceWith: [1, 2, 0],
    getOr: [2, 1, 0],
    intersectionBy: [1, 2, 0],
    intersectionWith: [1, 2, 0],
    isEqualWith: [1, 2, 0],
    isMatchWith: [2, 1, 0],
    mergeAllWith: [1, 0],
    mergeWith: [1, 2, 0],
    padChars: [2, 1, 0],
    padCharsEnd: [2, 1, 0],
    padCharsStart: [2, 1, 0],
    pullAllBy: [2, 1, 0],
    pullAllWith: [2, 1, 0],
    rangeStep: [1, 2, 0],
    rangeStepRight: [1, 2, 0],
    setWith: [3, 1, 2, 0],
    sortedIndexBy: [2, 1, 0],
    sortedLastIndexBy: [2, 1, 0],
    unionBy: [1, 2, 0],
    unionWith: [1, 2, 0],
    updateWith: [3, 1, 2, 0],
    xorBy: [1, 2, 0],
    xorWith: [1, 2, 0],
    zipWith: [1, 2, 0]
  }, e.methodSpread = {
    assignAll: { start: 0 },
    assignAllWith: { start: 0 },
    assignInAll: { start: 0 },
    assignInAllWith: { start: 0 },
    defaultsAll: { start: 0 },
    defaultsDeepAll: { start: 0 },
    invokeArgs: { start: 2 },
    invokeArgsMap: { start: 2 },
    mergeAll: { start: 0 },
    mergeAllWith: { start: 0 },
    partial: { start: 1 },
    partialRight: { start: 1 },
    without: { start: 1 },
    zipAll: { start: 0 }
  }, e.mutate = {
    array: {
      fill: !0,
      pull: !0,
      pullAll: !0,
      pullAllBy: !0,
      pullAllWith: !0,
      pullAt: !0,
      remove: !0,
      reverse: !0
    },
    object: {
      assign: !0,
      assignAll: !0,
      assignAllWith: !0,
      assignIn: !0,
      assignInAll: !0,
      assignInAllWith: !0,
      assignInWith: !0,
      assignWith: !0,
      defaults: !0,
      defaultsAll: !0,
      defaultsDeep: !0,
      defaultsDeepAll: !0,
      merge: !0,
      mergeAll: !0,
      mergeAllWith: !0,
      mergeWith: !0
    },
    set: {
      set: !0,
      setWith: !0,
      unset: !0,
      update: !0,
      updateWith: !0
    }
  }, e.realToAlias = function() {
    var t = Object.prototype.hasOwnProperty, n = e.aliasToReal, r = {};
    for (var s in n) {
      var a = n[s];
      t.call(r, a) ? r[a].push(s) : r[a] = [s];
    }
    return r;
  }(), e.remap = {
    assignAll: "assign",
    assignAllWith: "assignWith",
    assignInAll: "assignIn",
    assignInAllWith: "assignInWith",
    curryN: "curry",
    curryRightN: "curryRight",
    defaultsAll: "defaults",
    defaultsDeepAll: "defaultsDeep",
    findFrom: "find",
    findIndexFrom: "findIndex",
    findLastFrom: "findLast",
    findLastIndexFrom: "findLastIndex",
    getOr: "get",
    includesFrom: "includes",
    indexOfFrom: "indexOf",
    invokeArgs: "invoke",
    invokeArgsMap: "invokeMap",
    lastIndexOfFrom: "lastIndexOf",
    mergeAll: "merge",
    mergeAllWith: "mergeWith",
    padChars: "pad",
    padCharsEnd: "padEnd",
    padCharsStart: "padStart",
    propertyOf: "get",
    rangeStep: "range",
    rangeStepRight: "rangeRight",
    restFrom: "rest",
    spreadFrom: "spread",
    trimChars: "trim",
    trimCharsEnd: "trimEnd",
    trimCharsStart: "trimStart",
    zipAll: "zip"
  }, e.skipFixed = {
    castArray: !0,
    flow: !0,
    flowRight: !0,
    iteratee: !0,
    mixin: !0,
    rearg: !0,
    runInContext: !0
  }, e.skipRearg = {
    add: !0,
    assign: !0,
    assignIn: !0,
    bind: !0,
    bindKey: !0,
    concat: !0,
    difference: !0,
    divide: !0,
    eq: !0,
    gt: !0,
    gte: !0,
    isEqual: !0,
    lt: !0,
    lte: !0,
    matchesProperty: !0,
    merge: !0,
    multiply: !0,
    overArgs: !0,
    partial: !0,
    partialRight: !0,
    propertyOf: !0,
    random: !0,
    range: !0,
    rangeRight: !0,
    subtract: !0,
    zip: !0,
    zipObject: !0,
    zipObjectDeep: !0
  };
})(Ym);
var bi, Pu;
function Le() {
  return Pu || (Pu = 1, bi = {}), bi;
}
var lt = Ym, xO = Le(), Ou = Array.prototype.push;
function bO(e, t) {
  return t == 2 ? function(n, r) {
    return e.apply(void 0, arguments);
  } : function(n) {
    return e.apply(void 0, arguments);
  };
}
function ji(e, t) {
  return t == 2 ? function(n, r) {
    return e(n, r);
  } : function(n) {
    return e(n);
  };
}
function ku(e) {
  for (var t = e ? e.length : 0, n = Array(t); t--; )
    n[t] = e[t];
  return n;
}
function jO(e) {
  return function(t) {
    return e({}, t);
  };
}
function CO(e, t) {
  return function() {
    for (var n = arguments.length, r = n - 1, s = Array(n); n--; )
      s[n] = arguments[n];
    var a = s[t], o = s.slice(0, t);
    return a && Ou.apply(o, a), t != r && Ou.apply(o, s.slice(t + 1)), e.apply(this, o);
  };
}
function Ci(e, t) {
  return function() {
    var n = arguments.length;
    if (n) {
      for (var r = Array(n); n--; )
        r[n] = arguments[n];
      var s = r[0] = t.apply(void 0, r);
      return e.apply(void 0, r), s;
    }
  };
}
function wo(e, t, n, r) {
  var s = typeof t == "function", a = t === Object(t);
  if (a && (r = n, n = t, t = void 0), n == null)
    throw new TypeError();
  r || (r = {});
  var o = {
    cap: "cap" in r ? r.cap : !0,
    curry: "curry" in r ? r.curry : !0,
    fixed: "fixed" in r ? r.fixed : !0,
    immutable: "immutable" in r ? r.immutable : !0,
    rearg: "rearg" in r ? r.rearg : !0
  }, c = s ? n : xO, l = "curry" in r && r.curry, d = "fixed" in r && r.fixed, u = "rearg" in r && r.rearg, h = s ? n.runInContext() : void 0, f = s ? n : {
    ary: e.ary,
    assign: e.assign,
    clone: e.clone,
    curry: e.curry,
    forEach: e.forEach,
    isArray: e.isArray,
    isError: e.isError,
    isFunction: e.isFunction,
    isWeakMap: e.isWeakMap,
    iteratee: e.iteratee,
    keys: e.keys,
    rearg: e.rearg,
    toInteger: e.toInteger,
    toPath: e.toPath
  }, p = f.ary, m = f.assign, C = f.clone, y = f.curry, g = f.forEach, w = f.isArray, x = f.isError, S = f.isFunction, N = f.isWeakMap, v = f.keys, b = f.rearg, j = f.toInteger, D = f.toPath, $ = v(lt.aryMethod), _ = {
    castArray: function(q) {
      return function() {
        var B = arguments[0];
        return w(B) ? q(ku(B)) : q.apply(void 0, arguments);
      };
    },
    iteratee: function(q) {
      return function() {
        var B = arguments[0], F = arguments[1], U = q(B, F), J = U.length;
        return o.cap && typeof F == "number" ? (F = F > 2 ? F - 2 : 1, J && J <= F ? U : ji(U, F)) : U;
      };
    },
    mixin: function(q) {
      return function(B) {
        var F = this;
        if (!S(F))
          return q(F, Object(B));
        var U = [];
        return g(v(B), function(J) {
          S(B[J]) && U.push([J, F.prototype[J]]);
        }), q(F, Object(B)), g(U, function(J) {
          var fe = J[1];
          S(fe) ? F.prototype[J[0]] = fe : delete F.prototype[J[0]];
        }), F;
      };
    },
    nthArg: function(q) {
      return function(B) {
        var F = B < 0 ? 1 : j(B) + 1;
        return y(q(B), F);
      };
    },
    rearg: function(q) {
      return function(B, F) {
        var U = F ? F.length : 0;
        return y(q(B, F), U);
      };
    },
    runInContext: function(q) {
      return function(B) {
        return wo(e, q(B), r);
      };
    }
  };
  function L(q, B) {
    if (o.cap) {
      var F = lt.iterateeRearg[q];
      if (F)
        return P(B, F);
      var U = !s && lt.iterateeAry[q];
      if (U)
        return T(B, U);
    }
    return B;
  }
  function I(q, B, F) {
    return l || o.curry && F > 1 ? y(B, F) : B;
  }
  function A(q, B, F) {
    if (o.fixed && (d || !lt.skipFixed[q])) {
      var U = lt.methodSpread[q], J = U && U.start;
      return J === void 0 ? p(B, F) : CO(B, J);
    }
    return B;
  }
  function M(q, B, F) {
    return o.rearg && F > 1 && (u || !lt.skipRearg[q]) ? b(B, lt.methodRearg[q] || lt.aryRearg[F]) : B;
  }
  function G(q, B) {
    B = D(B);
    for (var F = -1, U = B.length, J = U - 1, fe = C(Object(q)), re = fe; re != null && ++F < U; ) {
      var ce = B[F], ge = re[ce];
      ge != null && !(S(ge) || x(ge) || N(ge)) && (re[ce] = C(F == J ? ge : Object(ge))), re = re[ce];
    }
    return fe;
  }
  function Z(q) {
    return H.runInContext.convert(q)(void 0);
  }
  function Q(q, B) {
    var F = lt.aliasToReal[q] || q, U = lt.remap[F] || F, J = r;
    return function(fe) {
      var re = s ? h : f, ce = s ? h[U] : B, ge = m(m({}, J), fe);
      return wo(re, F, ce, ge);
    };
  }
  function T(q, B) {
    return E(q, function(F) {
      return typeof F == "function" ? ji(F, B) : F;
    });
  }
  function P(q, B) {
    return E(q, function(F) {
      var U = B.length;
      return bO(b(ji(F, U), B), U);
    });
  }
  function E(q, B) {
    return function() {
      var F = arguments.length;
      if (!F)
        return q();
      for (var U = Array(F); F--; )
        U[F] = arguments[F];
      var J = o.rearg ? 0 : F - 1;
      return U[J] = B(U[J]), q.apply(void 0, U);
    };
  }
  function z(q, B, F) {
    var U, J = lt.aliasToReal[q] || q, fe = B, re = _[J];
    return re ? fe = re(B) : o.immutable && (lt.mutate.array[J] ? fe = Ci(B, ku) : lt.mutate.object[J] ? fe = Ci(B, jO(B)) : lt.mutate.set[J] && (fe = Ci(B, G))), g($, function(ce) {
      return g(lt.aryMethod[ce], function(ge) {
        if (J == ge) {
          var we = lt.methodSpread[J], ue = we && we.afterRearg;
          return U = ue ? A(J, M(J, fe, ce), ce) : M(J, A(J, fe, ce), ce), U = L(J, U), U = I(J, U, ce), !1;
        }
      }), !U;
    }), U || (U = fe), U == B && (U = l ? y(U, 1) : function() {
      return B.apply(this, arguments);
    }), U.convert = Q(J, B), U.placeholder = B.placeholder = F, U;
  }
  if (!a)
    return z(t, n, c);
  var H = n, te = [];
  return g($, function(q) {
    g(lt.aryMethod[q], function(B) {
      var F = H[lt.remap[B] || B];
      F && te.push([B, z(B, F, H)]);
    });
  }), g(v(H), function(q) {
    var B = H[q];
    if (typeof B == "function") {
      for (var F = te.length; F--; )
        if (te[F][0] == q)
          return;
      B.convert = Q(q, B), te.push([q, B]);
    }
  }), g(te, function(q) {
    H[q[0]] = q[1];
  }), H.convert = Z, H.placeholder = H, g(v(H), function(q) {
    g(lt.realToAlias[q] || [], function(B) {
      H[B] = H[q];
    });
  }), H;
}
var NO = wo, DO = fc, SO = 128;
function $O(e, t, n) {
  return t = n ? void 0 : t, t = e && t == null ? e.length : t, DO(e, SO, void 0, void 0, void 0, void 0, t);
}
var AO = $O, EO = gn, IO = St, _O = Cc, TO = "[object DOMException]", RO = "[object Error]";
function MO(e) {
  if (!IO(e))
    return !1;
  var t = EO(e);
  return t == RO || t == TO || typeof e.message == "string" && typeof e.name == "string" && !_O(e);
}
var PO = MO, OO = Pr, kO = St, LO = "[object WeakMap]";
function FO(e) {
  return kO(e) && OO(e) == LO;
}
var BO = FO, UO = vs, zO = Bt, HO = 1;
function WO(e) {
  return zO(typeof e == "function" ? e : UO(e, HO));
}
var VO = WO, Ni, Lu;
function ka() {
  if (Lu)
    return Ni;
  Lu = 1;
  var e = Xp, t = Lp, n = lc;
  function r(s) {
    return n(t(s, void 0, e), s + "");
  }
  return Ni = r, Ni;
}
var qO = fc, GO = ka(), YO = 256, QO = GO(function(e, t) {
  return qO(e, YO, void 0, void 0, void 0, t);
}), ZO = QO, KO = on, JO = Dr, XO = Ge, ek = Nr, tk = Yp, nk = Wn, rk = cn;
function sk(e) {
  return XO(e) ? KO(e, nk) : ek(e) ? [e] : JO(tk(rk(e)));
}
var ak = sk, ik = {
  ary: AO,
  assign: rp,
  clone: nS,
  curry: kp,
  forEach: Xo,
  isArray: Ge,
  isError: PO,
  isFunction: Sr,
  isWeakMap: BO,
  iteratee: VO,
  keys: tc,
  rearg: ZO,
  toInteger: ps,
  toPath: ak
}, ok = NO, ck = ik;
function lk(e, t, n) {
  return ok(ck, e, t, n);
}
var Fe = lk, Di, Fu;
function vn() {
  return Fu || (Fu = 1, Di = {
    cap: !1,
    curry: !1,
    fixed: !1,
    immutable: !1,
    rearg: !1
  }), Di;
}
var dk = Fe, Qm = dk("capitalize", qo, vn());
Qm.placeholder = Le();
var uk = Qm;
const fr = /* @__PURE__ */ oe(uk);
var fk = Fe, hk = fk("chunk", Kh);
hk.placeholder = Le();
var pk = Fe, Zm = pk("cloneDeep", yp, vn());
Zm.placeholder = Le();
var mk = Zm;
const gk = /* @__PURE__ */ oe(mk);
var wk = Fe, Km = wk("compact", xp, vn());
Km.placeholder = Le();
var vk = Km;
const Dt = /* @__PURE__ */ oe(vk);
var yk = Fe, xk = yk("concat", yS);
xk.placeholder = Le();
var bk = Fe, Jm = bk("filter", Kp);
Jm.placeholder = Le();
var jk = Jm;
const Ck = /* @__PURE__ */ oe(jk);
var Nk = Fe, Xm = Nk("find", Jp);
Xm.placeholder = Le();
var Dk = Xm;
const vo = /* @__PURE__ */ oe(Dk);
var Sk = Fe, eg = Sk("get", xc);
eg.placeholder = Le();
var $k = eg;
const tg = /* @__PURE__ */ oe($k);
var Ak = Fe, Ek = Ak("groupBy", em);
Ek.placeholder = Le();
var Ik = Fe, ng = Ik("intersectionWith", am);
ng.placeholder = Le();
var _k = ng;
const Bu = /* @__PURE__ */ oe(_k);
var Tk = Fe, rg = Tk("isEqual", im);
rg.placeholder = Le();
var Rk = rg;
const Mk = /* @__PURE__ */ oe(Rk);
var Pk = Fe, sg = Pk("isFunction", Sr, vn());
sg.placeholder = Le();
var Ok = sg;
const kc = /* @__PURE__ */ oe(Ok);
var kk = Fe, Lk = kk("keys", An, vn());
Lk.placeholder = Le();
var Fk = Fe, Bk = Fk("last", Ma, vn());
Bk.placeholder = Le();
var Uk = Fe, zk = Uk("map", lm);
zk.placeholder = Le();
var Hk = Fe, Wk = Hk("mapValues", dm);
Wk.placeholder = Le();
var Si, Uu;
function Vk() {
  if (Uu)
    return Si;
  Uu = 1;
  var e = xs, t = Wo;
  function n(r, s) {
    return s.length < 2 ? r : e(r, t(s, 0, -1));
  }
  return Si = n, Si;
}
var $i, zu;
function qk() {
  if (zu)
    return $i;
  zu = 1;
  var e = Or, t = Ma, n = Vk(), r = Wn;
  function s(a, o) {
    return o = e(o, a), a = n(a, o), a == null || delete a[r(t(o))];
  }
  return $i = s, $i;
}
var Ai, Hu;
function Gk() {
  if (Hu)
    return Ai;
  Hu = 1;
  var e = Cc;
  function t(n) {
    return e(n) ? void 0 : n;
  }
  return Ai = t, Ai;
}
var Ei, Wu;
function Yk() {
  if (Wu)
    return Ei;
  Wu = 1;
  var e = on, t = vs, n = qk(), r = Or, s = Tr, a = Gk(), o = ka(), c = sc, l = 1, d = 2, u = 4, h = o(function(f, p) {
    var m = {};
    if (f == null)
      return m;
    var C = !1;
    p = e(p, function(g) {
      return g = r(g, f), C || (C = g.length > 1), g;
    }), s(f, c(f), m), C && (m = t(m, l | d | u, a));
    for (var y = p.length; y--; )
      n(m, p[y]);
    return m;
  });
  return Ei = h, Ei;
}
var Qk = Fe, ag = Qk("omit", Yk());
ag.placeholder = Le();
var Zk = ag;
const as = /* @__PURE__ */ oe(Zk);
var Kk = Fe, Jk = Kk("orderBy", Cm);
Jk.placeholder = Le();
var Xk = Fe, ig = Xk("partition", Nm);
ig.placeholder = Le();
var eL = ig;
const Vu = /* @__PURE__ */ oe(eL);
var Ii, qu;
function tL() {
  if (qu)
    return Ii;
  qu = 1;
  var e = ym, t = Qp;
  function n(r, s) {
    return e(r, s, function(a, o) {
      return t(r, o);
    });
  }
  return Ii = n, Ii;
}
var _i, Gu;
function nL() {
  if (Gu)
    return _i;
  Gu = 1;
  var e = tL(), t = ka(), n = t(function(r, s) {
    return r == null ? {} : e(r, s);
  });
  return _i = n, _i;
}
var rL = Fe, sL = rL("pick", nL());
sL.placeholder = Le();
var Ti, Yu;
function aL() {
  if (Yu)
    return Ti;
  Yu = 1;
  var e = Qo, t = ka(), n = cc, r = $p, s = Ge, a = Ap, o = "Expected a function", c = 8, l = 32, d = 128, u = 256;
  function h(f) {
    return t(function(p) {
      var m = p.length, C = m, y = e.prototype.thru;
      for (f && p.reverse(); C--; ) {
        var g = p[C];
        if (typeof g != "function")
          throw new TypeError(o);
        if (y && !w && r(g) == "wrapper")
          var w = new e([], !0);
      }
      for (C = w ? C : m; ++C < m; ) {
        g = p[C];
        var x = r(g), S = x == "wrapper" ? n(g) : void 0;
        S && a(S[0]) && S[1] == (d | c | l | u) && !S[4].length && S[9] == 1 ? w = w[r(S[0])].apply(w, S[3]) : w = g.length == 1 && a(g) ? w[x]() : w.thru(g);
      }
      return function() {
        var N = arguments, v = N[0];
        if (w && N.length == 1 && s(v))
          return w.plant(v).value();
        for (var b = 0, j = m ? p[b].apply(this, N) : v; ++b < m; )
          j = p[b].call(this, j);
        return j;
      };
    });
  }
  return Ti = h, Ti;
}
var Ri, Qu;
function iL() {
  if (Qu)
    return Ri;
  Qu = 1;
  var e = aL(), t = e();
  return Ri = t, Ri;
}
var oL = Fe, cL = oL("flow", iL());
cL.placeholder = Le();
var Mi, Zu;
function lL() {
  if (Zu)
    return Mi;
  Zu = 1;
  var e = vs, t = Zp, n = 1;
  function r(s, a) {
    return t(s, e(a, n));
  }
  return Mi = r, Mi;
}
var dL = Fe, uL = dL("matchesProperty", lL());
uL.placeholder = Le();
var Pi, Ku;
function fL() {
  if (Ku)
    return Pi;
  Ku = 1;
  var e = vm;
  function t(n, r, s) {
    return n == null ? n : e(n, r, s);
  }
  return Pi = t, Pi;
}
var hL = Fe, og = hL("set", fL());
og.placeholder = Le();
var pL = og;
const Ju = /* @__PURE__ */ oe(pL);
var mL = Fe, gL = mL("sortBy", Dm);
gL.placeholder = Le();
var Oi, Xu;
function wL() {
  if (Xu)
    return Oi;
  Xu = 1;
  var e = gn, t = St, n = "[object RegExp]";
  function r(s) {
    return t(s) && e(s) == n;
  }
  return Oi = r, Oi;
}
var ki, ef;
function vL() {
  if (ef)
    return ki;
  ef = 1;
  var e = wL(), t = Rr, n = Aa, r = n && n.isRegExp, s = r ? t(r) : e;
  return ki = s, ki;
}
var Li, tf;
function yL() {
  if (tf)
    return Li;
  tf = 1;
  var e = Ah, t = Eh, n = Vo, r = hs, s = vL(), a = Oh, o = cn, c = 4294967295;
  function l(d, u, h) {
    return h && typeof h != "number" && r(d, u, h) && (u = h = void 0), h = h === void 0 ? c : h >>> 0, h ? (d = o(d), d && (typeof u == "string" || u != null && !s(u)) && (u = e(u), !u && n(d)) ? t(a(d), 0, h) : d.split(u, h)) : [];
  }
  return Li = l, Li;
}
var xL = Fe, bL = xL("split", yL());
bL.placeholder = Le();
var Fi, nf;
function jL() {
  if (nf)
    return Fi;
  nf = 1;
  var e = cn;
  function t(n) {
    return e(n).toLowerCase();
  }
  return Fi = t, Fi;
}
var CL = Fe, cg = CL("toLower", jL(), vn());
cg.placeholder = Le();
var NL = cg;
const hr = /* @__PURE__ */ oe(NL);
var DL = Fe, lg = DL("uniq", Sm, vn());
lg.placeholder = Le();
var SL = lg;
const aa = /* @__PURE__ */ oe(SL);
var $L = Fe, dg = $L("uniqWith", $m);
dg.placeholder = Le();
var AL = dg;
const EL = /* @__PURE__ */ oe(AL);
var IL = Fe, ug = IL("values", R6, vn());
ug.placeholder = Le();
var _L = ug;
const TL = /* @__PURE__ */ oe(_L);
function ye(e, t = !1) {
  if (!e)
    return;
  const n = lv(e, "UTC");
  return t && n.getHours() === 0 && n.getMinutes() === 0 && n.getSeconds() === 0 ? wr(n, "M/d/yyyy", { timeZone: "UTC" }) : wr(un(e), "M/d/yyyy");
}
const RL = (e) => {
  const t = ["P", "yyyyMMddHHmm"];
  for (let n = 0; n < t.length; n += 1) {
    const r = ro(e, t[n], /* @__PURE__ */ new Date());
    if (no(r))
      return r;
  }
  return e;
};
function ML(e) {
  if (!e)
    return;
  const t = RL(e);
  return t instanceof Date ? sv(t, { representation: "date" }) : t;
}
function PL(e) {
  if (!e)
    return "Unknown";
  const t = Intl.DateTimeFormat().resolvedOptions().timeZone;
  let r = wr(e, "M/d/yyyy, h:mma zzz", { timeZone: t });
  return r = r.replace(" AM", "AM").replace(" PM", "PM"), r;
}
function OL(e) {
  if (!e)
    return;
  const t = e.substring(4, 6), n = e.substring(6, 8), r = e.substring(0, 4);
  return `${t}/${n}/${r}`;
}
function pr(e) {
  if (e)
    return e.toISOString().split("T")[0];
}
function La(e) {
  if (!e)
    return;
  const n = e.replace(/\D/g, "").match(/^(\d{3})(\d{3})(\d{4})$/);
  return n ? `${n[1]}-${n[2]}-${n[3]}` : e;
}
function kL(e) {
  if (e && /^\d+$/.test(e) && e.length >= 8) {
    let t = "";
    try {
      t = wr(ro(e.substring(0, 8), "yyyyMMdd", /* @__PURE__ */ new Date()), "P");
    } catch (n) {
    }
    if (e.length === 14)
      try {
        t += ` ${wr(ro(e.substring(9, 15), "kkmmss", /* @__PURE__ */ new Date()), "kk:mm:ss")}`;
      } catch (n) {
      }
    return t;
  }
  return e;
}
function LL(e) {
  const { value: t, unit: n } = e;
  return fg([t, n]).join(" ");
}
function FL(e) {
  return `${e}`.length <= 11 ? e * 1e3 : e;
}
function kr(e) {
  if (!e)
    return;
  const t = typeof e == "number" ? new Date(FL(e)).toISOString() : e, n = t.substring(8, 10), r = t.substring(5, 7), s = t.substring(0, 4);
  return `${r}/${n}/${s}`;
}
function BL(e, t) {
  if (e)
    return wr(new Date(e), t);
}
function UL(e) {
  var r;
  const { start: t, end: n } = e;
  return !t && !n ? "" : !t || !n ? (r = ye(t != null ? t : n)) != null ? r : "" : `${ye(t)} - ${ye(n)}`;
}
function zL(e) {
  var a, o, c;
  const { low: t, high: n } = e;
  if ((t == null ? void 0 : t.value) === void 0 && (n == null ? void 0 : n.value) === void 0)
    return "";
  const r = (a = t == null ? void 0 : t.unit) != null ? a : n == null ? void 0 : n.unit, s = r ? ` ${r}` : "";
  return (t == null ? void 0 : t.value) === void 0 || (n == null ? void 0 : n.value) === void 0 ? `${(c = (o = t == null ? void 0 : t.value) != null ? o : n == null ? void 0 : n.value) != null ? c : ""}${s}` : t.unit !== void 0 && n.unit !== void 0 && t.unit !== n.unit ? `${t.value} ${t.unit} - ${n.value} ${n.unit}` : `${t.value} - ${n.value}${s}`;
}
function HL(e) {
  const { value: t, unit: n } = e;
  return fg([t, n]).join(" ");
}
const fg = (e) => Ck(WL, e);
function WL(e) {
  return e || e === 0;
}
const GZ = "urn:oid:2.16.840.1.113883.5.4", VL = "http://terminology.hl7.org/CodeSystem/basic-resource-type", qL = "http://terminology.hl7.org/CodeSystem/condition-category", yo = "http://terminology.hl7.org/CodeSystem/condition-clinical", hg = "http://terminology.hl7.org/CodeSystem/condition-ver-status", GL = "http://terminology.hl7.org/CodeSystem/diagnosis-role", YL = "http://terminology.hl7.org/CodeSystem/v2-0074", YZ = "http://terminology.hl7.org/CodeSystem/v3-MaritalStatus", rf = "http://terminology.hl7.org/CodeSystem/v3-NullFlavor", QZ = "http://terminology.hl7.org/3.1.0/CodeSystem-v3-DataOperation.html", ZZ = "http://terminology.hl7.org/CodeSystem/provenance-participant-type", KZ = "http://terminology.hl7.org/CodeSystem/v2-0131", JZ = "https://www.hl7.org/fhir/codesystem-task-status.html", sf = "https://www.hcup-us.ahrq.gov/toolssoftware/ccsr/dxccsr.jsp", On = "http://www.hcup-us.ahrq.gov/toolssoftware/chronic_icd10/chronic_icd10.jsp", QL = "http://www.ama-assn.org/go/cpt", ZL = "http://hl7.org/fhir/sid/cvx", Os = "http://terminology.hl7.org/CodeSystem/cmshcc", KL = "http://hl7.org/fhir/sid/icd-9", JL = "http://hl7.org/fhir/sid/icd-9-cm", af = "http://hl7.org/fhir/sid/icd-10", xo = "http://hl7.org/fhir/sid/icd-10-cm", is = "http://www.nlm.nih.gov/research/umls/rxnorm", Yt = "http://loinc.org", XL = "http://hl7.org/fhir/sid/ndc", os = "http://snomed.info/sct", yt = "https://zusapi.com/summary", XZ = "https://zusapi.com/builder_id", Lc = "https://zusapi.com/created-at", pg = "https://zusapi.com/lens", Fa = "https://zusapi.com/summary", En = "https://zusapi.com/accesscontrol/owner", eK = "https://zusapi.com/practitioner_id", zs = "https://zusapi.com/profile/action", Ln = "https://zusapi.com/thirdparty/source", yr = "https://zusapi.com/fhir/identifier/universal-id", Fc = "https://zusapi.com/fhir/tag/upi-record-type", tK = "https://zusapi.com/user_type", xr = "https://zusapi.com/terminology/enrichment", Bc = "https://zusapi.com/lens/extension/aggregatedFrom", e9 = "https://zusapi.com/lens/id", mg = "https://zusapi.com/lens/extension/medicationLastFillDate", gg = "https://zusapi.com/lens/extension/medicationLastPrescribedDate", wg = "https://zusapi.com/lens/extension/medicationQuantity", vg = "https://zusapi.com/lens/extension/medicationDaysSupply", yg = "https://zusapi.com/lens/extension/medicationRefills", xg = "https://zusapi.com/lens/extension/medicationLastPrescriber", t9 = "https://zusapi.com/lens/extension/relatedBinaries", Uc = "https://zusapi.com/ctw-component-library/extension/lensAggregatedFrom", nK = "https://fhir.athena.io/sid/ah-patient";
function bo(e) {
  return n9(e) && // Exclude resource types that extend "Resource" and not "DomainResource".
  e.resourceType !== "Binary" && e.resourceType !== "Bundle";
}
function n9(e) {
  return typeof e == "object" && e !== null && "resourceType" in e;
}
class Qe {
  constructor(t, n, r) {
    ne(this, "resource");
    ne(this, "includedResources");
    ne(this, "basicResources");
    ne(this, "optimisticIsRead");
    ne(this, "optimisticIsDismissed");
    this.resource = t, this.includedResources = n, this.basicResources = r;
  }
  // Returns the aggregated from resource ids for summary resources.
  get aggregatedFromIds() {
    var t;
    if (bo(this.resource)) {
      const n = Ue(
        this.resource.extension,
        (r) => r.url === Bc || r.url === Uc
      );
      return Ee((t = n == null ? void 0 : n.extension) == null ? void 0 : t.map((r) => {
        var s, a;
        return (a = (s = r.valueReference) == null ? void 0 : s.reference) == null ? void 0 : a.split("/")[1];
      }));
    }
    return [];
  }
  get createdAt() {
    var t, n;
    return (n = Ue((t = this.resource.meta) == null ? void 0 : t.extension, { url: Lc })) == null ? void 0 : n.valueInstant;
  }
  get createdAtDisplay() {
    return ye(this.createdAt);
  }
  get lastUpdated() {
    var t;
    return ((t = this.resource.meta) == null ? void 0 : t.lastUpdated) || this.createdAt;
  }
  get id() {
    return this.resource.id || "";
  }
  // key is used to uniquely identify rows in our resource table
  get key() {
    return this.id;
  }
  get versionId() {
    var t;
    return ((t = this.resource.meta) == null ? void 0 : t.versionId) || "";
  }
  get isDismissed() {
    if (this.optimisticIsDismissed !== void 0)
      return this.optimisticIsDismissed;
    const t = this.getLatestAction(["archive", "unarchive"]);
    return fn(t == null ? void 0 : t.code.coding, {
      system: zs,
      code: "archive"
    });
  }
  // Special key for filtering. See utils/filters.ts.
  get isHidden() {
    return this.isDismissed;
  }
  // Optimistically toggle the isDismiss state.
  // This is useful to be able to change the state of the UI
  // without having to wait for the toggleRead API call.
  optimisticToggleIsDismiss() {
    this.optimisticIsDismissed = !this.isDismissed;
  }
  get isRead() {
    if (this.optimisticIsRead !== void 0)
      return this.optimisticIsRead;
    const t = this.getLatestAction(["read", "unread"]);
    return fn(t == null ? void 0 : t.code.coding, {
      system: zs,
      code: "read"
    });
  }
  // Optimistically toggle the isRead state.
  // This is useful to be able to change the state of the UI
  // without having to wait for the toggleRead API call.
  optimisticToggleIsRead() {
    this.optimisticIsRead = !this.isRead;
  }
  // Returns true if this resource is a summary/lens resource.
  get isSummaryResource() {
    var t;
    return Ue((t = this.resource.meta) == null ? void 0 : t.tag, { system: yt }) !== void 0;
  }
  get isExternalNetworkData() {
    var t, n, r;
    return (r = (n = (t = this.resource.meta) == null ? void 0 : t.tag) == null ? void 0 : n.some((s) => s.system === Ln)) != null ? r : !1;
  }
  // If the data came from a third party data source then return that name
  get externalNetworkSourceName() {
    var t, n, r;
    return (r = (n = (t = this.resource.meta) == null ? void 0 : t.tag) == null ? void 0 : n.find((s) => s.system === Ln)) == null ? void 0 : r.code;
  }
  get patientUPID() {
    var t;
    if (bo(this.resource))
      return (t = Ue(this.resource.extension, { url: yr })) == null ? void 0 : t.valueString;
  }
  get resourceType() {
    return this.resource.resourceType;
  }
  get resourceTypeTitle() {
    return Dc(this.resourceType);
  }
  get basics() {
    return this.basicResources;
  }
  set basics(t) {
    this.basicResources = t;
  }
  // Returns the latest Basic resource that has a code that matches
  // one of profileActions.
  // In practice, there should only be a single Basic resource, but
  // we need to handle the case where there may be several.
  getLatestAction(t) {
    const n = nt(this.basics, "meta.lastUpdated", "desc");
    return Ue(
      n,
      (r) => fn(
        r.code.coding,
        (s) => {
          var a;
          return s.system === zs && t.includes((a = s.code) != null ? a : "");
        }
      )
    );
  }
  // Returns true if this resource is enriched with additional data
  // from Zus enrichment.
  isEnriched() {
    return JSON.stringify(this.resource).includes(xr);
  }
  // Returns true if this resource is owned by the specified builder.
  ownedByBuilder(t) {
    var s, a, o, c, l;
    if ((a = (s = this.resource.meta) == null ? void 0 : s.tag) != null && a.some((d) => d.system === Ln))
      return !1;
    const n = (c = (o = this.resource.meta) == null ? void 0 : o.tag) == null ? void 0 : c.find((d) => d.system === En), r = (l = n == null ? void 0 : n.code) == null ? void 0 : l.split("/");
    return (r == null ? void 0 : r.length) !== 2 ? !1 : r[1] === t;
  }
  // Returns a string that would setup this model.
  //   E.g. "new ConditionModel({...resource})"
  // Helpful for debugging / console logging.
  // This way we get copyable code for the model
  // instead of "[object Object]".
  toString() {
    return `new ${this.constructor.name}(${JSON.stringify(this.resource, null, 2)}
)`;
  }
}
const Ie = (e, t) => {
  var s, a, o, c, l;
  if (t && (e != null && e.coding)) {
    const d = e.coding.find(
      (u) => u.system === t && u.display && !u.extension
    );
    if (d && d.display)
      return d.display;
  }
  const n = (s = e == null ? void 0 : e.coding) == null ? void 0 : s.find((d) => d.display), r = (a = e == null ? void 0 : e.coding) == null ? void 0 : a.find((d) => d.code);
  return (l = (c = (o = e == null ? void 0 : e.text) != null ? o : n == null ? void 0 : n.display) != null ? c : r == null ? void 0 : r.code) != null ? l : "";
}, r9 = (e) => {
  var n;
  if (e != null && e.text)
    return e.text;
  const t = Ee((n = e == null ? void 0 : e.coding) == null ? void 0 : n.map((r) => r.display))[0];
  return t != null ? t : "";
};
function tn(e, t) {
  return Ue(t == null ? void 0 : t.coding, { system: e });
}
function jo(e, t) {
  return bc(t == null ? void 0 : t.coding, {
    system: e
  });
}
function zc(e, t, n) {
  return fn(
    n == null ? void 0 : n.coding,
    (r) => {
      var s;
      return r.system === e && t.includes((s = r.code) != null ? s : "");
    }
  );
}
function ia(e, t) {
  return Ue(t == null ? void 0 : t.coding, {
    system: e,
    extension: [{ url: xr }]
  });
}
function of(e, t) {
  return bc(t == null ? void 0 : t.coding, {
    system: e,
    extension: [{ url: xr }]
  });
}
function s9(e, t) {
  return Ue(t == null ? void 0 : t.coding, {
    extension: [{ url: xr, valueString: e }]
  });
}
const Co = (e, t) => {
  for (let n = 0; n < e.length; n += 1) {
    const r = e[n];
    if (r.checkForEnrichment) {
      const s = ia(r.system, t);
      if (s)
        return s;
    } else {
      const s = tn(r.system, t);
      if (s)
        return s;
    }
  }
};
class a9 {
  constructor(t) {
    ne(this, "resource");
    this.resource = t;
  }
  get display() {
    return Ie(this.resource.details) || this.resource.diagnostics || `${this.resource.code} error`;
  }
  get severity() {
    return this.resource.severity;
  }
}
class bg extends Qe {
  constructor() {
    super(...arguments);
    ne(this, "kind", "OperationOutcome");
  }
  // Condense the errors into one string.
  get display() {
    return this.resource.issue.filter((r) => r.severity !== "warning").map((r) => {
      let s = "";
      if (r.location && r.location.length > 0) {
        const a = r.location[0];
        s += `${a} -- `;
      }
      return `${s}${r.diagnostics}`;
    }).join("; ");
  }
  // Get the models of each issue in this outcome.
  get issues() {
    return this.resource.issue.map((n) => new a9(n));
  }
  get title() {
    return this.display;
  }
}
function Hc(e) {
  return typeof e == "object" && e !== null ? "response" in e && "config" in e : !1;
}
function i9(e) {
  if (typeof e == "object" && e !== null && "response" in e && typeof e.response == "object" && e.response !== null && "data" in e.response && typeof e.response.data == "object" && e.response.data !== null) {
    const { data: t } = e.response;
    return "message" in t && typeof t.message == "string" && "name" in t && typeof t.name == "string" && "statusCode" in t && typeof t.statusCode == "number";
  }
  return !1;
}
const jg = (e, t) => {
  const { data: n, status: r } = t.response;
  let s = "";
  return Gm(n) && (s = new bg(n).display), { title: e, status: r, statusText: s };
}, Cg = "ctw-toast-container", Ng = "ctw-toast-container-drawer", o9 = ({ type: e, title: t, body: n, options: r }) => Bn({ type: e, title: t, body: n, options: r, containerId: Ng }), Bn = ({
  type: e,
  title: t,
  body: n,
  options: r,
  containerId: s = Cg
}) => {
  const a = R({
    closeOnClick: !1,
    draggable: !1,
    // Auto close all toasts after 4 seconds, except for error toasts.
    autoClose: e === "error" ? void 0 : 4e3,
    containerId: s
  }, r), o = /* @__PURE__ */ i.jsxs("div", { className: "ctw-toast", children: [
    t && /* @__PURE__ */ i.jsx("div", { className: "ctw-font-medium", children: t }),
    n && /* @__PURE__ */ i.jsx("div", { children: n })
  ] });
  switch (e) {
    case "success":
      Bs.success(o, X(R({}, a), {
        icon: /* @__PURE__ */ i.jsx(me, { icon: gh, className: "ctw-h-5 ctw-text-success-main" })
      }));
      break;
    case "info":
      Bs.info(o, X(R({}, a), {
        icon: !1
      }));
      break;
    case "error":
      Bs.error(o, X(R({}, a), {
        icon: /* @__PURE__ */ i.jsx(me, { icon: sh, className: "ctw-h-5 ctw-text-error-main" })
      }));
      break;
    default:
      throw new Error(`Unknown toast type: ${e}`);
  }
}, Wc = "https://zusapi.com/builder_id", Dg = "https://zusapi.com/builder_name", Sg = "https://zusapi.com/practitioner_id", c9 = "https://zusapi.com/is_super_org", Vc = "https://zusapi.com/email", Bi = "https://zusapi.com/user_id", $g = "https://zusapi.com/user_type", l9 = 500;
function mn(e) {
  try {
    return hv(e);
  } catch (t) {
    return {};
  }
}
function d9(e) {
  return mn(e)[$g];
}
function u9(e) {
  return mn(e)[Wc];
}
function f9(e) {
  const t = mn(e).exp;
  return !t || Number.isNaN(t) ? 0 : t;
}
function h9(e) {
  return mn(e)[Sg];
}
function qc(e) {
  return mn(e)[Vc];
}
function Gc(e) {
  return e ? f9(e) * 1e3 > Date.now() + l9 : !1;
}
function cf(e = "") {
  return Gc(e) && !!qc(e);
}
function p9(e, t) {
  const n = Gc(e) ? "Only user tokens are allowed" : "This token has expired";
  Bn({
    type: "error",
    title: "Warning",
    body: `Invalid auth token: ${n}`,
    options: {
      toastId: t
    }
  });
}
const lf = {
  service: "ctw-component-library",
  clientToken: "pub7f1b01887ceb412fd989f5e08cf60d9a",
  applicationId: "44011d8b-3aa4-4672-9c7b-ee23ddac16b5"
}, df = {
  service: "ctw-component-library",
  clientToken: "pub29b659b1cd402a88d57c4f8c923c1eea",
  applicationId: "48fec1f8-b187-492a-afdd-e809cc6b3b82"
};
let Ag = "", Hs;
typeof window != "undefined" && (Ag = window.location.origin, Hs = window.document.body);
const uf = 200, ff = /https?:\/\/(localhost|\d+\.\d+\.\d+\.\d+)/i.test(Ag);
let hf = !1;
const mt = class mt {
  static get telemetryIsAvailable() {
    return !!(this.environment && this.isInitialized);
  }
  /**
   * We need to normalize environment name in order to effectively use template
   * variables on dashboards in Datadog. Otherwise, users of the dashboard would
   * need to know to select all variations of an environment.
   */
  static setEnv(t) {
    this.environment = t.toLowerCase(), ["dev", "development"].includes(this.environment) && (this.environment = "dev"), ["prod", "production"].includes(this.environment) && (this.environment = "prod");
  }
  static init(t, n = "unknown", r = !1, s = {
    version: "unknown"
  }) {
    this.datadogLoggingEnabled = r, this.setEnv(t), this.setEHR(n), this.setDDConfig(s), !this.telemetryIsAvailable && r && (qr.init(R(X(R({}, ff ? df : lf), {
      env: this.environment,
      forwardConsoleLogs: [],
      // No console logs to datadog.
      forwardErrorsToLogs: !0,
      site: "datadoghq.com"
    }), s)), this.shouldSkipSendingMetrics() || er.init(R(X(R({}, ff ? df : lf), {
      site: "datadoghq.com",
      allowedTracingUrls: [],
      // No allowed tracing urls
      defaultPrivacyLevel: "mask",
      env: this.environment,
      sessionReplaySampleRate: 20,
      sessionSampleRate: 100,
      trackLongTasks: !0,
      trackResources: !0,
      trackUserInteractions: !0
    }), s))), !hf && Hs && (Hs.addEventListener("click", (a) => {
      const { target: o, isTrusted: c } = a;
      if (!(c && o instanceof Element))
        return;
      const l = this.closestHTMLElement(o);
      l instanceof HTMLElement && this.processHTMLEvent(l, "zusTelemetryClick");
    }), Hs.addEventListener("focusin", (a) => {
      const { target: o, isTrusted: c } = a;
      c && o instanceof HTMLElement && this.processHTMLEvent(o, "zusTelemetryFocus");
    }), hf = !0), this.isInitialized = !0, this.accessToken || setTimeout(() => {
      this.flushUnauthorizedAnalyticBuffer();
    }, uf);
  }
  static setDDConfig(t) {
    this.ddConfig = t;
  }
  static setEHR(t) {
    this.setGlobalContextProperty("ehr", t), this.ehr = t;
  }
  static setBuilder(t) {
    this.setGlobalContextProperty("builderId", t);
  }
  static setPatientID(t, n = "") {
    this.setGlobalContextProperty("patientContext", {
      patientId: t,
      systemUrl: n
    });
  }
  static setPatientUPID(t) {
    this.setGlobalContextProperty("patientUPID", t);
  }
  static setUser(t) {
    if (t && (this.accessToken = t, this.validateAccessToken()), this.accessToken) {
      const n = mn(this.accessToken);
      Pn.setSessionUserId(n[Bi]);
      const r = {
        id: n[Bi],
        type: n[$g],
        email: n[Vc],
        practitionerId: n[Sg],
        builderName: n[Dg],
        builderId: n[Wc],
        isSuperOrg: n[c9]
      };
      this.datadogLoggingEnabled && (qr.setUser(r), er.setUser(r));
    }
  }
  static clearUser() {
    this.accessToken = "", qr.setUser({});
  }
  // Validate the access token and clear it if it has expired
  static validateAccessToken() {
    return Gc(this.accessToken) ? !0 : (this.accessToken && (this.logger.warn("Clearing Telemetry.accessToken because it has expired"), this.accessToken = "", this.flushUnauthorizedAnalyticBuffer()), !1);
  }
  static logError(t, n) {
    let r;
    try {
      r = JSON.stringify(t.stack);
    } catch (o) {
      r = "Cannot stringify error";
    }
    const s = {
      stack: t.stack,
      message: t.message,
      jsonifiedError: r,
      additionalInfo: n
    };
    if (t instanceof dn)
      return this.logger.error(t.message, {
        error: X(R({}, s), {
          statusCode: t.statusCode
        })
      }), er.addError(t), t;
    if (t instanceof Oa)
      return this.logger.error(t.message, {
        error: X(R({}, s), {
          queryKeys: t.otherQueryKeys,
          identifier: t.identifier,
          requestErrors: t.requestErrors,
          responseErrors: t.responseErrors
        })
      }), er.addError(t), t;
    const a = new Error(t.message);
    return this.logger.error(a.message, {
      error: R({}, s)
    }), er.addError(t), a;
  }
  static logFhirError(t, n) {
    const r = jg(n, t);
    this.logger.error(n, r);
  }
  static trackInteraction(t, n = {}) {
    this.reportActiveSession().catch((r) => mt.logError(r)), this.analyticsEvent(t, n).catch((r) => mt.logError(r));
  }
  static setGlobalContextProperty(t, n) {
    this.datadogLoggingEnabled && (qr.setGlobalContextProperty(t, n), er.setGlobalContextProperty(t, n));
  }
  /**
   * Metrics names are alphanumeric, lowercase, seperated by only "." or "_"
   */
  static normalizeMetricName(t) {
    return t.split(".").map(_8).join(".").replace(/[^a-z0-9_.]/gi, "");
  }
  /*
   * In dev/test environments we should skip sending any metrics
   */
  static shouldSkipSendingMetrics() {
    return !this.environment || process.env.NODE_ENV !== "test" && this.isLocalHost();
  }
  static isLocalHost() {
    return /(localhost|127\.0\.0\.1)/.test(window.location.origin);
  }
  static deferAnalyticEvent(t, n = {}) {
    this.unauthorizedAnalyticBuffer.push({ name: t, properties: n });
  }
  static deferMetricEvent(t, n, r, s = []) {
    this.unauthorizedMetricBuffer.push({ type: t, metric: n, value: r, additionalTags: s });
  }
  static flushUnauthorizedAnalyticBuffer() {
    return V(this, null, function* () {
      if (!this.validateAccessToken()) {
        setTimeout(() => {
          this.flushUnauthorizedAnalyticBuffer();
        }, uf);
        return;
      }
      try {
        this.unauthorizedMetricBuffer.length && (yield Promise.all(
          this.unauthorizedMetricBuffer.map(
            ({ type: t, metric: n, value: r, additionalTags: s }) => this.reportMetric(t, n, r, s)
          )
        ));
      } catch (t) {
        console.warn("[Telemetry] Failed to flush unauthorized metric buffer");
      }
      try {
        this.unauthorizedAnalyticBuffer.length && (yield Promise.all(
          this.unauthorizedAnalyticBuffer.map(
            ({ name: t, properties: n }) => this.analyticsEvent(t, n)
          )
        ));
      } catch (t) {
        console.warn("[Telemetry] Failed to flush unauthorized analytics buffer");
      }
      this.unauthorizedMetricBuffer = [], this.unauthorizedAnalyticBuffer = [];
    });
  }
  /**
   * Report a metric to CTW
   */
  static reportMetric(a, o, c) {
    return V(this, arguments, function* (t, n, r, s = []) {
      var u;
      if (this.shouldSkipSendingMetrics())
        return;
      if (this.validateAccessToken(), !this.accessToken) {
        this.deferMetricEvent(t, n, r, s);
        return;
      }
      const l = this.normalizeMetricName(n), d = Ee([
        `service:${(u = this.ddConfig) != null && u.service ? this.ddConfig.service : "ctw-component-library"}`,
        `env:${this.environment}`,
        this.ehr ? `ehr:${this.ehr}` : void 0,
        ...s
      ]);
      try {
        yield rt(`${sa(this.environment)}/report/metric`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${this.accessToken}`
          },
          body: JSON.stringify({ name: l, type: t, tags: d, value: r }),
          mode: "cors"
        });
      } catch (h) {
        mt.logError(h, {
          errorMessage: "error reporting metric",
          metric: {
            type: t,
            tags: d,
            value: r
          }
        });
      }
    });
  }
  /**
   * Report User analytic events
   */
  static analyticsEvent(r) {
    return V(this, arguments, function* (t, n = {}) {
      var s;
      if (!this.shouldSkipSendingMetrics()) {
        if (!this.accessToken) {
          this.deferAnalyticEvent(t, n);
          return;
        }
        try {
          const a = {
            event: t,
            metadata: X(R({}, n), {
              ehr: this.ehr || void 0,
              version: (s = this.ddConfig) == null ? void 0 : s.version
            })
          };
          yield rt(`${sa(this.environment)}/report/analytic`, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${this.accessToken}`
            },
            // Base64 encode the event name and user information
            body: JSON.stringify(a),
            mode: "cors"
          });
        } catch (a) {
        }
      }
    });
  }
  static countMetric(t, n = 1, r = []) {
    return mt.reportMetric("increment", t, n, r);
  }
  static histogramMetric(t, n, r = []) {
    return mt.reportMetric("histogram", t, n, r);
  }
  static timeMetric(t, n = []) {
    const r = (/* @__PURE__ */ new Date()).getTime();
    return function() {
      const a = (/* @__PURE__ */ new Date()).getTime();
      return mt.reportMetric("timing", t, a - r, n);
    };
  }
  static processHTMLEvent(t, n, r) {
    var o;
    let s = null;
    if (r)
      s = t;
    else {
      let c = t, l = 5;
      for (; !s && l > 0 && c; )
        c.dataset[n] && (s = c), c = c.parentElement, l -= 1;
    }
    const a = (o = s == null ? void 0 : s.dataset[n]) != null ? o : r;
    s && a && this.trackInteraction(a);
  }
  static closestHTMLElement(t) {
    return !t || t instanceof HTMLElement ? t : t.parentElement instanceof HTMLElement ? t.parentElement : this.closestHTMLElement(t.parentNode);
  }
  static reportActiveSession() {
    return V(this, null, function* () {
      if (Pn.isActive() || this.shouldSkipSendingMetrics())
        return;
      const t = mn(this.accessToken);
      xe(t) ? Pn.clearSessionLastActiveTimestamp() : (Pn.setSessionUserId(t[Bi]), Pn.setSessionLastActiveTimestamp());
    });
  }
};
ne(mt, "accessToken", ""), ne(mt, "datadogLoggingEnabled", !1), ne(mt, "unauthorizedAnalyticBuffer", []), ne(mt, "unauthorizedMetricBuffer", []), ne(mt, "logger", qr.logger), ne(mt, "environment", ""), ne(mt, "ehr", "unknown"), ne(mt, "ddConfig", {
  version: "unknown"
}), ne(mt, "isInitialized", !1);
let $e = mt;
const Yc = (e, t, n = []) => (...r) => V(void 0, null, function* () {
  let s;
  try {
    return s = $e.timeMetric(t, n), yield e(...r);
  } catch (a) {
    throw s = void 0, a;
  } finally {
    s == null || s();
  }
});
function m9(e, t) {
  const n = new Oa(t, e);
  $e.logError(n);
}
const In = new dv({
  defaultOptions: {
    queries: {
      retry: !1,
      // NOTE: Stale time must be kept less than what we'd expect auth token
      // expiration to be. This ensures that if the token expires and we go to
      // fetch a fresh one, we don't get a stale token from react-query cache.
      staleTime: 1e3 * 30,
      // 30s.
      refetchOnWindowFocus: !1
    }
  },
  queryCache: new uv({
    onError: m9
  })
}), Qc = { "Zus-Request-Source": "component-library" }, g9 = ["/xml", "/xhtml+xml", "application/xml", "text/xml"], w9 = ["/pdf"], v9 = ["/tif", "/tiff"], y9 = ["/jpg", "/jpeg", "/png", "/apng", "/avif", "/gif", "/webp", "/svg+xml"];
function rt(e, t) {
  return V(this, null, function* () {
    var a;
    const n = (a = t == null ? void 0 : t.headers) != null ? a : {}, r = t != null ? t : {};
    r.headers = R(R({}, Qc), n);
    const s = yield fetch(e, r);
    return yield b9(s), { data: yield x9(s), headers: s.headers };
  });
}
const x9 = (e) => V(void 0, null, function* () {
  const t = e.headers.get("content-type");
  return t != null && t.includes("json") ? e.json() : t != null && t.includes("text") ? e.text() : [...g9, ...w9, ...v9, ...y9].some(
    (n) => t == null ? void 0 : t.includes(n)
  ) ? e.blob() : e.json();
});
function b9(e) {
  return V(this, null, function* () {
    if (!e.ok) {
      let t, n = e.statusText;
      const r = e.headers.get("content-type");
      if (r != null && r.includes("json") && (t = yield e.json(), n = JSON.stringify(t)), t && "detail" in t)
        throw new Error(t.detail);
      switch (e.status) {
        case 401:
          throw new dn(e, n);
        case 403:
          throw new dn(e, n);
        case 404:
          throw new dn(e, n);
        default:
          throw new dn(e, e.statusText);
      }
    }
  });
}
const Zc = (e, t, n, r = 1) => V(void 0, null, function* () {
  try {
    return yield e();
  } catch (s) {
    if (r > t)
      throw s;
    return yield qm(n * oi(2, r)), Zc(e, t, n, r + 1);
  }
});
function j9(e, t, n, r) {
  const s = R({}, Qc);
  n && (s["Zus-Account"] = n);
  const a = new ed({
    baseUrl: gO(e),
    bearerToken: t,
    customHeaders: s
  }), o = R({}, s);
  r && Object.assign(o, r);
  const c = new ed({
    baseUrl: `${Vm(e)}/proxy/fhir`,
    bearerToken: t,
    customHeaders: o
  });
  return {
    fhirClient: a,
    fhirWriteBackClient: c
  };
}
const oa = (e) => (
  // Cast because the function that finds and omits arrays produces an unknown.
  C9(e)
), C9 = (e) => {
  if (Array.isArray(e))
    return e.length === 0 ? void 0 : e.map(oa);
  if (e !== null && typeof e == "object") {
    const t = e;
    return Object.entries(t).forEach(([n, r]) => {
      r == null ? delete t[n] : t[n] = oa(r), t.reference && typeof t.resource == "object" && delete t.resource;
    }), t;
  }
  return e;
}, No = (e) => (
  // Cast because the function that finds and omits arrays produces an unknown.
  N9(e)
), N9 = (e) => {
  const t = /_[^_]+__(\w+)/;
  if (Array.isArray(e))
    return e.map(No);
  if (e !== null && typeof e == "object") {
    const n = e;
    return Object.entries(n).forEach(([r, s]) => {
      if (t.test(r)) {
        const a = r.match(t);
        a && (delete n[r], n[a[1]] = s);
      }
      s == null ? delete n[r] : n[r] = No(s);
    }), n;
  }
  return e;
};
function D9(e) {
  return !!(e && typeof e == "object" && "preventDefault" in e);
}
const S9 = (e) => /\d/.test(String(e)), Kc = (e) => e == null || Number.isNaN(e) || typeof e == "object" && Object.keys(e).length === 0 || typeof e == "string" && e.trim().length === 0;
function $9(e) {
  return th(e);
}
const jt = 500, A9 = 7, Re = (e) => {
  const t = `${Kt(e.env, "fqs")}/query`;
  return new Cv(t, {
    errorPolicy: "all",
    headers: X(R({}, Qc), {
      authorization: `Bearer ${e.authToken}`
    })
  });
};
function dt(e, t, n) {
  return V(this, null, function* () {
    const r = R({}, n);
    "first" in r && typeof r.first == "number" && r.first > jt && (r.first = jt);
    const { data: s, errors: a } = yield e.rawRequest(t, r), o = No(s);
    if (a) {
      const c = Kc(s);
      if ($e.logger.error(
        c ? "FQS request failed" : "FQS request partially failed, proceeding with returned data",
        {
          errors: a.slice(0, 10),
          errorsTruncated: a.length > 10
        }
      ), c)
        throw a;
    }
    return { data: o };
  });
}
function Ut(a, o, c, l) {
  return V(this, arguments, function* (e, t, n, r, s = A9) {
    if (!xe(ln(r, "sort")))
      throw new Error(
        "'sort' variable not allowed in fqsRequestAll; FQS does not support sorting with pagination"
      );
    let d = 0, u = !0;
    const h = [];
    let f = "";
    do {
      const p = X(R({}, r), {
        // Some queries require 'sort', but if it is set to anything besides an empty object, fqs pagination breaks!
        sort: {},
        cursor: f
      }), m = yield dt(e, t, p);
      h.push(m);
      const C = ln(m, ["data", n, "pageInfo", "endCursor"], "");
      u = f !== C && ln(m, ["data", n, "pageInfo", "hasNextPage"], !1), f = C, d += 1;
    } while (s > d && u);
    return $e.countMetric("fqs_request_all", 1, [
      `pages_fetched:${d}`,
      `has_next_page:${u}`,
      `query_type:${n}`
    ]), h.reduce(
      (p, m) => {
        const C = ln(p, ["data", n, "edges"], []), y = ln(m, ["data", n, "edges"], []);
        return X(R({}, p), {
          data: {
            [n]: {
              edges: C.concat(y)
            }
          }
        });
      },
      { data: { [n]: { edges: [] } } }
    );
  });
}
function E9(e, t) {
  return (n, r) => rt(`${Kt(e, "fqs")}/${n}`, X(R({}, r), {
    headers: R({
      Authorization: `Bearer ${t}`
    }, r.headers)
  }));
}
function I9(e) {
  return Object.values(e).map((n) => n.edges.map((r) => r.node)).flat();
}
function rK(e) {
  return Object.values(e).flat();
}
function Xe() {
  const e = tt(Wm), t = Pc(), n = Te(e);
  if (he(() => {
    n.current = e;
  }, [e]), e === void 0)
    throw new Error("useCTW must be used within a CTWProvider");
  const r = vt(() => V(this, null, function* () {
    var d, u, h;
    const s = yield t(), a = n.current || e, { fhirClient: o, fhirWriteBackClient: c } = j9(
      a.env,
      s,
      a.builderId,
      a.resourceSaveHeaders
    );
    return {
      authToken: s,
      headers: a.headers,
      fhirClient: o,
      fhirWriteBackClient: c,
      env: a.env,
      userType: (d = d9(s)) != null ? d : void 0,
      builderId: (h = (u = a.builderId) != null ? u : u9(s)) != null ? h : "",
      contextBuilderId: a.builderId,
      fetchFromFqs: E9(a.env, s),
      onResourceSave: (f, p, m) => {
        a.onResourceSave && a.onResourceSave(f, p, m);
      }
    };
  }), [e, t]);
  return {
    env: e.env,
    getRequestContext: r,
    featureFlags: e.featureFlags,
    allowSmallBreakpointCCDAViewer: e.allowSmallBreakpointCCDAViewer === !0
  };
}
function _9(e, t, n, r = !0, s = void 0) {
  const { getRequestContext: a } = Xe();
  return mh({
    queryKey: [e, ...t],
    queryFn: () => V(this, null, function* () {
      const o = yield a();
      return n(o, t);
    }),
    staleTime: s,
    enabled: r
  });
}
function Jt(e, t, n, r = !0, s = void 0) {
  return _9(
    e,
    t,
    Yc(n, "query_request_timing", [`query_key:${e}`]),
    r,
    s
  );
}
const T9 = "ai_feedback", R9 = "ai_chart_review_interactive", M9 = "ai_chart_review_summary", P9 = "ai_search", O9 = "allergy_history", k9 = "binaris_by_id", Eg = "binary", L9 = "builder_config", F9 = "builder_patients_by_upid", B9 = "patient_care_team", U9 = "ccda_patient", z9 = "condition_history", H9 = "patient_data_indicators", W9 = "ehr_backfill_request", V9 = "matched_patients", q9 = "matched_patients_including_current_builder", Ig = "medication_history", G9 = "on_demand_lens_api", Jc = "patient", Y9 = "patient_care_gaps", _g = "patients_list_fqs", Q9 = "patient_search", Z9 = "patient_allergies", Tg = "patient_binary_id", K9 = "patient_builder_encounters", Xc = "patient_builder_medications", Rg = "patient_summary_conditions", Mg = "patient_builder_conditions", J9 = "patient_diagnostic_reports", X9 = "patient_documents", eF = "patient_episodes_of_care", Pg = "patient_history_details", tF = "patient_history_list", nF = "patient_immunizations", rF = "patient_medication_dispense", sF = "patient_subscription", aF = "patient_summary_encounters", iF = "patient_service_requests", oF = "patient_appointments", el = "patient_summary_medications", cF = "patient_vitals", lF = "provenance";
function dF(e, t) {
  return Jt(
    W9,
    [e, t],
    (n) => V(this, null, function* () {
      const { data: r } = yield rt(
        `${Vm(n.env)}/backfill-request`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${n.authToken}`
          },
          body: JSON.stringify({
            data: {
              type: "backfill-request",
              attributes: {
                ignoreRateLimit: !1
              },
              relationships: {
                builder: {
                  data: {
                    type: "auth/builder",
                    id: n.builderId
                  }
                },
                patient: {
                  data: {
                    type: "fhir/Patient",
                    identifierSystemURL: e,
                    identifierValue: t
                  }
                }
              }
            }
          })
        }
      );
      return r;
    }),
    !!e && !!t
  );
}
const uF = 2e4;
function fF(e, t, n, r) {
  return V(this, null, function* () {
    const s = Re(e), a = `query GetLastUpdated {
      ${t}(id: "${n}") {
        meta {
          lastUpdated
        }
      }
    }`, o = Date.parse(r);
    let c = 0, l = 0;
    const d = Date.now();
    do {
      yield qm(100 * oi(2, c)), c += 1;
      try {
        const u = yield s.request(a);
        l = Date.parse(String(ln(u, `${t}.meta.lastUpdated`)));
      } catch (u) {
      }
    } while ((Number.isNaN(l) || l < o) && Date.now() - d < uF);
    return l >= o;
  });
}
function Ba(e, t) {
  return V(this, null, function* () {
    var c;
    const n = !!e.id, { fhirWriteBackClient: r } = t, s = Fn(e);
    let a = "create", o;
    try {
      return n ? (a = "update", o = yield r.update({
        resourceType: e.resourceType,
        id: e.id,
        body: oa(e),
        headers: {
          "ctw-write-provenance": "true"
        }
      })) : (o = yield r.create({
        resourceType: e.resourceType,
        body: oa(e),
        headers: {
          "ctw-write-provenance": "true"
        }
      }), Hc(o) || (s.id = o.id)), t.onResourceSave(s, a), e.resourceType !== "Basic" && bo(o) && o.id && ((c = o.meta) != null && c.lastUpdated) && (yield fF(
        t,
        e.resourceType,
        o.id,
        o.meta.lastUpdated
      )), o;
    } catch (l) {
      throw $e.logError(l), l;
    }
  });
}
const hF = (e, t, n) => V(void 0, null, function* () {
  const r = yield n(), s = Fn(e.resource);
  s.gender = t.gender, s.birthDate = pr(t.dateOfBirth), s.name = [
    {
      use: "official",
      family: t.lastName,
      given: [t.firstName]
    }
  ], s.address = [
    {
      line: [t.address],
      city: t.city,
      state: t.state,
      postalCode: t.zipCode
    }
  ];
  const a = [];
  t.phone && a.push({ system: "phone", value: t.phone }), t.email && a.push({ system: "email", value: t.email }), s.telecom = a;
  const o = yield Ba(
    s,
    r
  );
  return yield In.invalidateQueries([Jc]), o;
});
class pF extends Qe {
  constructor() {
    super(...arguments);
    ne(this, "kind", "Organization");
  }
  get name() {
    return this.resource.name;
  }
  get phone() {
    var r;
    const n = (r = this.resource.telecom) == null ? void 0 : r.find((s) => s.system === "phone");
    return La(n == null ? void 0 : n.value);
  }
  get title() {
    var n;
    return (n = this.name) != null ? n : "Unknown Organization";
  }
}
function Pe(e, t, n, r) {
  var s, a;
  if (r) {
    if (r.resource)
      return r.resource;
    if ((s = r.reference) != null && s.startsWith("#")) {
      let o = Ue(t, {
        id: r.reference.substring(1),
        // Remove preceding # when looking up contained resource.
        resourceType: e
      });
      return o || (o = Ue(t, {
        resource: {
          id: r.reference.substring(1),
          // Remove preceding # when looking up contained resource.
          resourceType: e
        }
      }), o ? o.resource : void 0);
    }
    if (r.reference && ((a = n == null ? void 0 : n[r.reference]) == null ? void 0 : a.resourceType) === e)
      return n[r.reference];
  }
}
function mF(e) {
  return e ? e.split("/").pop() : void 0;
}
function gF(e, t) {
  return t ? e.filter(
    (n) => t.every(
      (r) => {
        var s, a;
        return (a = (s = n.meta) == null ? void 0 : s.tag) == null ? void 0 : a.some(
          (o) => o.system === r.system && o.code === r.code
        );
      }
    )
  ) : e;
}
const wF = [
  { text: "Annulled", code: "A" },
  { text: "Divorced", code: "D" },
  { text: "Interlocutory", code: "I" },
  { text: "Legally Separated", code: "L" },
  { text: "Married", code: "M" },
  { text: "Polygamous", code: "P" },
  { text: "Never Married", code: "S" },
  { text: "Domestic Partner", code: "T" },
  { text: "unmarried", code: "U" },
  { text: "Widowed", code: "W" }
];
class zt extends Qe {
  constructor() {
    super(...arguments);
    ne(this, "kind", "Patient");
  }
  get active() {
    return this.resource.active;
  }
  get contact() {
    return this.resource.contact;
  }
  get dob() {
    return ye(this.resource.birthDate);
  }
  get age() {
    if (!this.resource.birthDate)
      return;
    const n = un(this.resource.birthDate);
    return ph(/* @__PURE__ */ new Date(), n);
  }
  findIdentifier(n) {
    var r;
    if (n)
      return (r = Ue(this.resource.identifier, { system: n })) == null ? void 0 : r.value;
  }
  get gender() {
    return this.resource.gender;
  }
  get maritalStatus() {
    var s, a, o;
    const n = (o = (a = (s = this.resource.maritalStatus) == null ? void 0 : s.coding) == null ? void 0 : a[0]) == null ? void 0 : o.code, r = wF.find((c) => c.code === n);
    return r == null ? void 0 : r.text;
  }
  get organization() {
    const n = Pe(
      "Organization",
      this.resource.contained,
      this.includedResources,
      this.resource.managingOrganization
    );
    if (n)
      return new pF(n, this.includedResources);
  }
  get organizationDisplayName() {
    return this.organization ? this.organization.name : this.externalNetworkSourceName;
  }
  get use() {
    return this.bestName.use;
  }
  get officialOrUsualIdentifier() {
    var n, r;
    return ((n = Ue(this.resource.identifier, { use: "official" })) == null ? void 0 : n.value) || ((r = Ue(this.resource.identifier, { use: "usual" })) == null ? void 0 : r.value) || "";
  }
  get UPID() {
    var n;
    return (n = Ue(this.resource.identifier, {
      system: yr
    })) == null ? void 0 : n.value;
  }
  getPhoneNumber(n) {
    const r = { system: "phone" };
    n && (r.use = n);
    const s = Ue(this.resource.telecom, r);
    return La(s == null ? void 0 : s.value);
  }
  // Gets first "phone" telecom.
  get phoneNumber() {
    return this.getPhoneNumber();
  }
  get email() {
    var n;
    return (n = Ue(this.resource.telecom, { system: "email" })) == null ? void 0 : n.value;
  }
  /*
    ADDRESS STUFF
  */
  get bestHomeAddress() {
    return Ue(this.resource.address, { use: "home" }) || Ue(this.resource.address, (n) => !n.use);
  }
  // Returns first home address or first address without "use" set.
  // This way we return a home address if there is one, or another address
  // but making sure not to return a work address here.
  get homeAddress() {
    return Fn(this.bestHomeAddress);
  }
  /*
    NAME STUFF
  */
  // Returns the best name to use for this patient.
  // Priority is "official" without an end date, then "official", then "usual", then first name provided.
  get bestName() {
    (!this.resource.name || this.resource.name.length === 0) && (this.resource.name = [{ use: "official" }]);
    const n = this.resource.name.find(
      (a) => a.use === "official" && (!a.period || !a.period.end)
    ), r = this.resource.name.find((a) => a.use === "official"), s = this.resource.name.find((a) => a.use === "usual");
    return n || r || s || this.resource.name[0] || // We'll always have at least one!
    {};
  }
  get additionalNames() {
    if (this.bestName.given && this.bestName.given.length > 1) {
      const [, ...n] = this.bestName.given;
      return n.join(" ");
    }
  }
  // Returns "First Last" which is similar to a reference display.
  get display() {
    return [this.firstName, this.lastName].filter((n) => n).join(" ");
  }
  get displayFull() {
    return [this.givenName, this.lastName].filter((n) => n).join(" ");
  }
  get firstName() {
    var n;
    return ((n = this.bestName.given) == null ? void 0 : n[0]) || "";
  }
  get givenName() {
    var n;
    return ((n = this.bestName.given) == null ? void 0 : n.join(" ")) || "";
  }
  // Returns "Last, First" or just "First" or just "Last" or "" when
  // neither are available.
  get fullName() {
    return [this.lastName, this.firstName].filter((n) => n).join(", ");
  }
  get lastName() {
    return this.bestName.family;
  }
  get nickname() {
    var r;
    const n = Ue(this.resource.name, { use: "nickname" });
    return (r = n == null ? void 0 : n.given) == null ? void 0 : r.join(" ");
  }
  get prefix() {
    var n;
    return (n = this.bestName.prefix) == null ? void 0 : n.join(" ");
  }
  get suffix() {
    var n;
    return (n = this.bestName.suffix) == null ? void 0 : n.join(" ");
  }
  get isTestPatient() {
    return !this.resource.meta || !this.resource.meta.security ? !1 : this.resource.meta.security.filter(
      (n) => n.system === "http://terminology.hl7.org/CodeSystem/v3-ActReason" && n.code === "HTEST"
    ).length > 0;
  }
  get title() {
    return this.display;
  }
}
function vF(e) {
  var t, n;
  return e.onsetAge ? LL(e.onsetAge) : e.onsetDateTime ? ye(e.onsetDateTime) : e.onsetPeriod ? ye(e.onsetPeriod.start) : e.onsetRange ? ye((n = (t = e.onsetRange.low) == null ? void 0 : t.value) == null ? void 0 : n.toString()) : kL(e.onsetString);
}
class Og extends Qe {
  constructor() {
    super(...arguments);
    ne(this, "kind", "Allergy");
  }
  get categories() {
    var n;
    return (n = this.resource.category) == null ? void 0 : n.join(", ");
  }
  get codeText() {
    var n;
    return (n = this.resource.code) == null ? void 0 : n.text;
  }
  get resourceTypeTitle() {
    return this.resource.resourceType.slice(0, 7);
  }
  get clinicalStatus() {
    return Ie(this.resource.clinicalStatus);
  }
  get display() {
    return qe(Ie(this.resource.code));
  }
  get lowercaseDisplay() {
    var n;
    return ((n = this.display) == null ? void 0 : n.toLocaleLowerCase()) || "";
  }
  get manifestations() {
    var r;
    const n = [];
    return (r = this.resource.reaction) == null || r.forEach(
      (s) => s.manifestation.forEach(
        (a) => n.push(Ie(a))
      )
    ), n.join(", ");
  }
  get patientOrganizationName() {
    const n = Pe(
      "Patient",
      this.resource.contained,
      this.includedResources,
      this.resource.patient
    );
    if (n)
      return new zt(n, this.includedResources).organizationDisplayName;
  }
  get note() {
    let n;
    return this.resource.note && (n = this.resource.note.map((r) => Ie(r)).join(", ")), n;
  }
  get severity() {
    var n;
    return (n = this.resource.reaction) == null ? void 0 : n[0].severity;
  }
  get knownCodings() {
    const n = Ee(
      yF.map((r) => tn(r.system, this.resource.code))
    );
    return wn(n, (r, s) => r.system === s.system);
  }
  get onset() {
    return vF(this.resource);
  }
  get recordedDate() {
    return ye(this.resource.recordedDate);
  }
  get title() {
    var n;
    return (n = this.display) != null ? n : "Unknown Allergy";
  }
  get type() {
    var n;
    return (n = this.resource.type) != null ? n : "";
  }
}
const yF = [
  { system: is },
  { system: XL },
  { system: os }
];
class Lr extends Qe {
  constructor() {
    super(...arguments);
    ne(this, "kind", "Practitioner");
  }
  get fullName() {
    var s, a;
    const n = (s = this.resource.name) == null ? void 0 : s[0];
    return [(a = n == null ? void 0 : n.given) != null && a.length ? n.given[0] : "", n == null ? void 0 : n.family].filter((o) => o).join(" ");
  }
  get title() {
    return this.fullName;
  }
}
const xF = {
  INF: {
    fullName: "Certain Infectious and Parasitic Diseases",
    shortName: "Infectious and Parasitic Diseases"
  },
  NEO: { fullName: "Neoplasms", shortName: "Neoplasms" },
  BLD: {
    fullName: "Diseases of the Blood and Blood Forming Organs and Certain Disorders Involving the Immune Mechanism",
    shortName: "Blood Diseases"
  },
  END: {
    fullName: "Endocrine, Nutritional and Metabolic Diseases",
    shortName: "Endocrine, Nutritional and Metabolic"
  },
  MBD: {
    fullName: "Mental, Behavioral and Neurodevelopmental Disorders",
    shortName: "Mental and Behavioral"
  },
  NVS: {
    fullName: "Diseases of the Nervous System",
    shortName: "Nervous System"
  },
  EYE: {
    fullName: "Diseases of the Eye and Adnexa",
    shortName: "Eye and Adnexa"
  },
  EAR: {
    fullName: "Diseases of the Ear and Mastoid Process",
    shortName: "Ear and Mastoid Process"
  },
  CIR: {
    fullName: "Diseases of the Circulatory System",
    shortName: "Circulatory System"
  },
  RSP: {
    fullName: "Diseases of the Respiratory System",
    shortName: "Respiratory System"
  },
  DIG: {
    fullName: "Diseases of the Digestive System",
    shortName: "Digestive System"
  },
  SKN: {
    fullName: "Diseases of the Skin and Subcutaneous Tissue",
    shortName: "Skin and Subcutaneous Tissue"
  },
  MUS: {
    fullName: "Diseases of the Musculoskeletal System and Connective Tissue",
    shortName: "Musculoskeletal System"
  },
  GEN: {
    fullName: "Diseases of the Genitourinary System",
    shortName: "Genitourinary System"
  },
  PRG: {
    fullName: "Pregnancy, Childbirth and the Puerperium",
    shortName: "Pregnancy & Childbirth"
  },
  PNL: {
    fullName: "Certain Conditions Originating in the Perinatal Period",
    shortName: "Perinatal Conditions"
  },
  MAL: {
    fullName: "Congenital Malformations, Deformations and Chromosomal Abnormalities",
    shortName: "Malformations and Chromosomal Abnormalities"
  },
  SYM: {
    fullName: "Symptoms, Signs and Abnormal Clinical and Laboratory Findings",
    shortName: "Clinical Findings"
  },
  INJ: {
    fullName: "Injury, Poisoning and Certain Other Consequences of External Causes",
    shortName: "External Causes Injury"
  },
  EXT: {
    fullName: "External Causes of Morbidity",
    shortName: "External Morbidity"
  },
  FAC: {
    fullName: "Factors Influencing Health Status and Contact with Health Services",
    shortName: "Health Status Influences"
  },
  XXX: {
    fullName: "Unacceptable principal diagnosis (inpatient data) or first-listed diagnosis (outpatient data)",
    shortName: "Unacceptable principal diagnosis"
  }
};
function kg(e) {
  return V(this, null, function* () {
    const t = h9(e.authToken);
    return t ? {
      reference: `Practitioner/${t}`,
      type: "Practitioner"
    } : {
      display: qc(e.authToken)
    };
  });
}
function Lg(e) {
  return Fn(e);
}
const Fg = (e) => {
  let t = "", n = "";
  switch (e) {
    case "Active":
      t = "confirmed", n = "active";
      break;
    case "Inactive":
      t = "confirmed", n = "inactive";
      break;
    case "Pending":
      t = "unconfirmed", n = "active";
      break;
    case "Refuted":
      t = "refuted", n = "inactive";
      break;
    case "Entered in Error":
      t = "entered-in-error";
      break;
    default:
      throw Error("status is should be of type ConditionStatus");
  }
  return bm(
    R({
      verificationStatus: {
        coding: [
          {
            system: hg,
            code: t
          }
        ]
      }
    }, n && {
      clinicalStatus: {
        coding: [{ system: yo, code: n }]
      }
    }),
    dM
  );
}, Bg = (e, t, n, r) => V(void 0, null, function* () {
  var c, l, d, u, h, f;
  const s = yield r(), a = X(R(R(X(R({
    resourceType: "Condition",
    id: n.id,
    recorder: yield kg(s)
  }, Fg(n.status)), {
    // Set category to problem list when creating a condition.
    category: n.id && e ? e.resource.category : [
      {
        coding: [
          {
            system: qL,
            code: "problem-list-item",
            display: "Problem List Item"
          }
        ]
      }
    ],
    // Keep all existing codings when editing a condition.
    code: n.id && e ? e.codings : {
      coding: [
        {
          system: n.condition.system,
          code: n.condition.code,
          display: n.condition.display
        }
      ],
      text: n.condition.display
    }
  }), n.abatement && {
    abatementDateTime: pr(n.abatement)
  }), n.onset && { onsetDateTime: pr(n.onset) }), {
    recordedDate: pr(/* @__PURE__ */ new Date()),
    subject: { type: "Patient", reference: `Patient/${t}` },
    note: n.note ? [{ text: n.note }] : void 0
  });
  n.type === "Chronic" ? (l = (c = a.code) == null ? void 0 : c.coding) == null || l.push({
    system: On,
    code: "C",
    display: "Chronic"
  }) : n.type === "Acute" ? (u = (d = a.code) == null ? void 0 : d.coding) == null || u.push({
    system: On,
    code: "A",
    display: "Acute"
  }) : n.type === "Chronic and acute" && ((f = (h = a.code) == null ? void 0 : h.coding) == null || f.push({
    system: On,
    code: "B",
    display: "Both"
  }));
  const o = yield Ba(a, s);
  return yield In.invalidateQueries([
    Rg,
    Mg
  ]), o;
}), Do = [
  { system: os, checkForEnrichment: !0 },
  { system: af, checkForEnrichment: !0 },
  { system: os },
  { system: af },
  { system: xo },
  { system: KL },
  { system: JL }
];
function bF(e) {
  const t = R({
    resourceType: "Condition",
    subject: {
      type: "Patient",
      reference: `Patient/${e}`
    }
  }, Fg("Active"));
  return Lg(t);
}
class Ug extends Qe {
  constructor() {
    super(...arguments);
    ne(this, "kind", "Condition");
    // Used by summary conditions to indicate that there's a matching
    // builder condition for this summary condition.
    ne(this, "syncedWithRecord", !1);
  }
  get abatement() {
    var n, r, s;
    return this.resource.abatementAge ? (n = this.resource.abatementAge.value) == null ? void 0 : n.toString() : this.resource.abatementDateTime ? ye(this.resource.abatementDateTime) : this.resource.abatementPeriod ? ye(this.resource.abatementPeriod.start) : this.resource.abatementRange ? ye((s = (r = this.resource.abatementRange.low) == null ? void 0 : r.value) == null ? void 0 : s.toString()) : this.resource.abatementString;
  }
  get active() {
    var r;
    const n = Ue((r = this.resource.clinicalStatus) == null ? void 0 : r.coding, {
      system: yo
    });
    return n != null && n.code ? ["active", "recurrence", "relapse"].includes(n.code) : !1;
  }
  get asserter() {
    var n;
    return (n = this.resource.asserter) == null ? void 0 : n.display;
  }
  get bodySites() {
    var n;
    return ((n = this.resource.bodySite) == null ? void 0 : n.map((r) => Ie(r))) || [];
  }
  // Returns the first category text or display.
  get category() {
    var n, r;
    return (r = Ee(
      (n = this.resource.category) == null ? void 0 : n.map((s) => r9(s))
    )[0]) != null ? r : "";
  }
  get ccsChapter() {
    var r;
    const n = this.ccsChapterCode;
    return n ? (r = xF[n]) == null ? void 0 : r.shortName : "Uncategorized";
  }
  get ccsChapterCode() {
    var n, r;
    return (r = (n = tn(sf, this.resource.code)) == null ? void 0 : n.code) == null ? void 0 : r.slice(0, 3);
  }
  get ccsGrouping() {
    var n;
    return (n = tn(sf, this.resource.code)) == null ? void 0 : n.display;
  }
  get clinicalStatus() {
    return Ie(this.resource.clinicalStatus);
  }
  get clinicalStatusCode() {
    var n, r;
    return (r = Ue((n = this.resource.clinicalStatus) == null ? void 0 : n.coding, {
      system: yo
    })) == null ? void 0 : r.code;
  }
  get codings() {
    return this.resource.code;
  }
  get chronic() {
    return this.isSummaryResource ? tn(On, this.resource.code) : ia(On, this.resource.code);
  }
  get display() {
    var n, r;
    return qe(
      (r = (n = Co(Do, this.resource.code)) == null ? void 0 : n.display) != null ? r : Ie(this.resource.code)
    );
  }
  get title() {
    var n;
    return (n = this.display) != null ? n : "Condition";
  }
  get type() {
    var r;
    const n = ((r = tn(On, this.resource.code)) == null ? void 0 : r.display) || "Unknown";
    return n.toLocaleLowerCase() === "both" ? "Chronic and acute" : n;
  }
  // Standardize the type display as to not end up with so many useless type categories to filter on
  get typeDisplay() {
    var s;
    const n = tn(On, this.resource.code), r = this.type;
    return ["UNK", "U", "NULL", "N"].includes((s = n == null ? void 0 : n.code) != null ? s : "") || /^(not applicable|unknown)/i.test(r) ? "Unknown, not applicable" : r;
  }
  get encounter() {
    var n;
    return (n = this.resource.encounter) == null ? void 0 : n.display;
  }
  get hccEnrichment() {
    return this.isSummaryResource ? tn(Os, this.resource.code) : ia(Os, this.resource.code);
  }
  get hccEnrichments() {
    return this.isSummaryResource ? jo(Os, this.resource.code) : of(Os, this.resource.code);
  }
  get icd10CMEnrichments() {
    return this.isSummaryResource ? jo(xo, this.resource.code) : of(xo, this.resource.code);
  }
  get knownCodings() {
    return pf(this.resource.code);
  }
  // Returns true if any of the known codings match between
  // this condition and the passed in condition or object with select fields from condition.
  knownCodingsMatch(n) {
    return UR(
      this.knownCodings,
      pf(n),
      (r, s) => r.code === s.code && r.system === s.system
    ).length > 0;
  }
  get notes() {
    var n;
    return ((n = this.resource.note) == null ? void 0 : n.map((r) => r.text)) || [];
  }
  get onset() {
    var n, r, s;
    return this.resource.onsetAge ? (n = this.resource.onsetAge.value) == null ? void 0 : n.toString() : this.resource.onsetDateTime ? ye(this.resource.onsetDateTime) : this.resource.onsetPeriod ? ye(this.resource.onsetPeriod.start) : this.resource.onsetRange ? ye((s = (r = this.resource.onsetRange.low) == null ? void 0 : r.value) == null ? void 0 : s.toString()) : OL(this.resource.onsetString);
  }
  get patientOrganizationName() {
    const n = Pe(
      "Patient",
      this.resource.contained,
      this.includedResources,
      this.resource.subject
    );
    if (n)
      return new zt(n, this.includedResources).organizationDisplayName;
  }
  get preferredCoding() {
    return Co(Do, this.resource.code);
  }
  get recordedDate() {
    return ye(this.resource.recordedDate);
  }
  get recorded() {
    return ye(this.resource.recordedDate);
  }
  get recorder() {
    var s;
    const n = this.resource.recorder, r = Pe(
      "Practitioner",
      this.resource.contained,
      this.includedResources,
      n
    );
    return r ? new Lr(r).fullName : (s = this.resource.recorder) == null ? void 0 : s.display;
  }
  get severity() {
    return Ie(this.resource.severity);
  }
  get stages() {
    var n;
    return ((n = this.resource.stage) == null ? void 0 : n.map((r) => {
      const s = Ie(r.summary), a = Ie(r.type);
      return `Summary: ${s}, Type: ${a}`;
    })) || [];
  }
  get displayStatus() {
    function n(a) {
      switch (a) {
        case "active":
        case "recurrence":
        case "relapse":
          return "Active";
        case "inactive":
        case "remission":
        case "resolved":
          return "Inactive";
        default:
          return "";
      }
    }
    function r(a) {
      switch (a) {
        case "confirmed":
          return "confirmed";
        case "unconfirmed":
        case "provisional":
        case "differential":
          return "unconfirmed";
        case "refuted":
          return "refuted";
        case "entered-in-error":
          return "entered-in-error";
        default:
          return "";
      }
    }
    if (this.isSummaryResource)
      return n(this.clinicalStatusCode) || "Unknown";
    switch (r(this.verificationStatusCode) + n(this.clinicalStatusCode).toLowerCase()) {
      case "unconfirmedactive":
        return "Pending";
      case "unconfirmedinactive":
      case "refutedactive":
        return "Unknown";
      case "confirmedinactive":
        return "Inactive";
      case "confirmedactive":
        return "Active";
      case "refutedinactive":
        return "Refuted";
      case "entered-in-error":
        return "Entered in Error";
      default:
        return "Unknown";
    }
  }
  get subjectID() {
    var r;
    const [, n] = ((r = this.resource.subject.reference) == null ? void 0 : r.split("/")) || [];
    return n || "";
  }
  get verificationStatus() {
    return Ie(this.resource.verificationStatus);
  }
  get verificationStatusCode() {
    var n, r;
    return (r = Ue((n = this.resource.verificationStatus) == null ? void 0 : n.coding, {
      system: hg
    })) == null ? void 0 : r.code;
  }
}
const jF = [
  "Active",
  "Inactive",
  "Entered in Error",
  "Pending",
  "Refuted",
  "Unknown"
], CF = ["Active", "Inactive", "Unknown"];
function pf(e) {
  const t = Ee(
    Do.map((n) => n.checkForEnrichment ? ia(n.system, e) : tn(n.system, e))
  );
  return wn(t, (n, r) => n.system === r.system);
}
const NF = "34133-9", zg = [
  "not available",
  "no known",
  "no information",
  "none",
  "no reason",
  "no active",
  "no clinical",
  "not on file",
  "no data",
  "no instructions",
  "no medical",
  "no assessment",
  "no physical",
  "no history",
  "no review",
  "no goals",
  "no health",
  "no discharge",
  "no transcribed"
], qn = {
  key: "showHidden",
  // Special key for filtering. See utils/filters.ts.
  type: "tag",
  belowDivider: !0,
  display: ({ listView: e }) => e ? "show dismissed records" : "dismissed records",
  icon: Bo,
  toggleDisplay: "hide dismissed records",
  toggleIcon: Uo
}, DF = "https://zusapi.com/thirdparty/source", SF = (e, t) => {
  var r, s;
  const n = (s = (r = e.meta) == null ? void 0 : r.tag) == null ? void 0 : s.find((a) => a.system === DF);
  return t.includes((n == null ? void 0 : n.code) || "");
}, tl = (e) => SF(e, ["commonwell", "carequality"]), $F = "https://zusapi.com/created-at", AF = /* @__PURE__ */ new Date("2023-03-08T05:00:00.000Z"), EF = (e) => {
  var n, r;
  const t = (r = (n = e.meta) == null ? void 0 : n.extension) == null ? void 0 : r.filter((s) => s.url === $F);
  return (t == null ? void 0 : t.length) !== 1 || !t[0].valueInstant ? null : new Date(t[0].valueInstant);
}, IF = (e) => {
  const t = EF(e);
  return t ? t < AF : !0;
}, _F = (e) => {
  const t = [], n = Dn(e, (r) => r.binaryId);
  return Object.keys(n).forEach((r) => {
    r ? t.push(nt(n[r], "category.length", "desc")[0]) : t.push(...n[r]);
  }), t;
};
function ca(e) {
  return e.category.length < 2;
}
const TF = (e) => {
  var n;
  const t = new hn(e);
  return ((n = t.contentType) == null ? void 0 : n.startsWith("image/")) || t.contentType === "application/pdf";
};
function Hg(e) {
  const t = e.displayContent;
  return t ? zg.some(
    (n) => t.length < 500 && t.toLowerCase().includes(n)
  ) : !0;
}
const RF = (e) => {
  const t = _F(e), n = (s) => t.find((a) => a.id === s.id), r = e.filter(
    (s) => [n, IF, TF].some((a) => a(s.resource)) && tl(s.resource) && !s.isZusGeneratedReciprocityDocument
  );
  return wn(r, (s, a) => bs(mf(s), mf(a)));
}, mf = (e) => [
  e.encounterDate,
  e.dateCreated,
  e.custodian,
  e.title
];
function MF() {
  return [
    qn,
    {
      key: "contentType",
      display: "Type",
      type: "checkbox",
      values: [
        { name: "CDA", key: "application/xml" },
        { name: "PDF", key: "application/pdf" },
        { name: "PNG", key: "image/png" },
        { name: "JPEG", key: "image/jpeg" },
        { name: "TIFF", key: "image/tiff" }
      ]
    }
  ];
}
const PF = [
  "2.16.840.1.113883.3.3126.2.3.25726.",
  "2.16.840.1.113883.3.9206.2."
], OF = "surescripts";
class hn extends Qe {
  constructor(n, r, s) {
    super(n, void 0, s);
    ne(this, "kind", "Document");
    this.relatedDocuments = r;
  }
  get status() {
    return this.resource.status;
  }
  get binaryId() {
    const n = this.resource.content[0].attachment.url;
    if (n)
      return n.split("/").pop();
  }
  get contentType() {
    return this.resource.content[0].attachment.contentType;
  }
  get isImage() {
    var n, r;
    return (r = (n = this.contentType) == null ? void 0 : n.startsWith("image/")) != null ? r : !1;
  }
  get isPdf() {
    return this.contentType === "application/pdf";
  }
  // Simply checking for XML or HTML is not *really* enough to determine if a document is a CDA.
  // But it's the best we have for now (short of fetching and inspecting the binary).
  // We used to check specifically for Commonwell and Carequality documents, but a better
  // approach for now is to exclude SureScripts XML documents.
  get isCDA() {
    return (this.contentType === "application/xml" || this.contentType === "text/html") && this.externalNetworkSourceName !== OF;
  }
  get docStatus() {
    return this.resource.docStatus;
  }
  get category() {
    var s, a, o;
    const n = (a = (s = this.relatedDocuments) == null ? void 0 : s.flatMap((c) => c.category)) != null ? a : [], r = (o = this.resource.category) != null ? o : [];
    return ht(r.concat(n));
  }
  get resourceTypeTitle() {
    return "Document";
  }
  get title() {
    return this.resource.description ? this.resource.description : this.resource.content.length > 0 && this.resource.content[0].attachment.title ? this.resource.content[0].attachment.title : this.loincDisplay || "Unknown";
  }
  get dateCreated() {
    return kr(
      this.resource.date || this.resource.content[0].attachment.creation
    );
  }
  // This indicates that the document was originally created by Zus for reciprocity
  // to the network. These *should* generally be filtered out during the DA process,
  // but this is a safety check so that we don't display any in the UI in case they
  // were loaded in error or before the DA process was updated.
  get isZusGeneratedReciprocityDocument() {
    return PF.some(
      (n) => {
        var r, s;
        return (s = (r = this.resource.masterIdentifier) == null ? void 0 : r.system) == null ? void 0 : s.includes(n);
      }
    );
  }
  get isClinicalSummary() {
    var n, r, s;
    return (s = (r = (n = this.resource.type) == null ? void 0 : n.coding) == null ? void 0 : r.some((a) => a.code === NF)) != null ? s : !1;
  }
  get contextPeriodStartDate() {
    var n, r;
    return ye((r = (n = this.resource.context) == null ? void 0 : n.period) == null ? void 0 : r.start);
  }
  get contextPeriodEndDate() {
    var n, r;
    return ye((r = (n = this.resource.context) == null ? void 0 : n.period) == null ? void 0 : r.end);
  }
  get encounterDate() {
    if (this.isClinicalSummary || !this.isExternalNetworkData)
      return;
    const n = this.contextPeriodStartDate, r = this.contextPeriodEndDate;
    if (n && r && n !== r)
      return `${n} - ${r}`;
    if (n)
      return n;
    if (r)
      return r;
  }
  get custodian() {
    var r, s;
    const n = (r = Pe(
      "Organization",
      this.resource.contained,
      this.includedResources,
      this.resource.custodian
    )) == null ? void 0 : r.name;
    return ((s = this.resource.custodian) == null ? void 0 : s.display) || n;
  }
  get loincDisplay() {
    var s, a;
    const r = Ee([this.resource.type, ...this.category]).find(
      (o) => {
        var c;
        return (c = o.coding) == null ? void 0 : c.some((l) => l.system === Yt && l.code);
      }
    );
    return ((a = (s = r == null ? void 0 : r.coding) == null ? void 0 : s[0]) == null ? void 0 : a.display) || (r == null ? void 0 : r.text);
  }
  get displayContent() {
    var n;
    if ((n = this.resource.text) != null && n.div)
      return this.resource.text.div;
    if (this.resource.content[0].attachment.data && this.resource.content[0].attachment.contentType === "text/plain")
      return atob(this.resource.content[0].attachment.data);
  }
  get sectionDocuments() {
    var n;
    return (n = this.relatedDocuments) == null ? void 0 : n.filter((r) => ca(r) && !Hg(r));
  }
}
function kF(e, t, n) {
  return V(this, null, function* () {
    const r = n.map((a) => a.replace(`${t}/`, "")), s = Re(e);
    return In.fetchQuery([lF, t, r], () => V(this, null, function* () {
      const a = yield s.request(
        LF(t, r)
      );
      return Object.values(a).reduce((o, c) => (o.push(...c.ProvenanceList), o), []);
    }));
  });
}
function LF(e, t) {
  return Ae`
    query GetProvenances() {
      ${t.map((n, r) => FF(e, n, r)).join(`
`)}
    }
  `;
}
function FF(e, t, n) {
  return `
    provenance${n}: ${e}(id: "${t}") {
      ProvenanceList(_reference: "target") {
        id
        meta {
          tag {
            system
            code
          }
        }
        target {
          reference
        }
        entity {
          role
          what {
            reference
          }
        }
      }
    }
  `;
}
function nl(e, t) {
  return V(this, null, function* () {
    if (t.length === 0)
      return [];
    const n = ht(t.map((r) => `${r.resourceType}/${r.id}`));
    return t[0].resourceType === "Practitioner" ? [] : kF(e, t[0].resourceType, n);
  });
}
function Wg(e) {
  var t;
  if (e && e.length > 0) {
    let n = "";
    for (let r = 0; r < e.length; r += 1) {
      const s = (t = e[r].entity) == null ? void 0 : t.find((a) => a.what.reference !== void 0);
      if (s && s.what.reference) {
        n = s.what.reference;
        break;
      }
    }
    if (n)
      return n.split("/")[1];
  }
}
const Vg = {
  "17856-6": "a1c",
  "2345-7": "glucose",
  "4548-4": "a1c",
  "4549-2": "a1c",
  "18262-6": "Cholesterol in LDL [Mass/volume] in Serum or Plasma by Direct assay",
  "13457-7": "Cholesterol in LDL [Mass/volume] in Serum or Plasma by Direct assay",
  "2089-1": "Cholesterol in LDL [Mass/volume] in Serum or Plasma by Direct assay",
  "39469-2": "Cholesterol in LDL [Mass/volume] in Serum or Plasma by Direct assay",
  "46985-8": "Cholesterol in LDL [Mass/volume] in Serum or Plasma by Direct assay",
  "2093-3": "Cholesterol [Mass/volume] in Serum or Plasma",
  "48620-9": "Cholesterol [Mass/volume] in Serum or Plasma",
  "35200-5": "Cholesterol [Mass/volume] in Serum or Plasma",
  "2085-9": "Cholesterol in HDL [Mass/volume] in Serum or Plasma",
  "2086-7": "Cholesterol in HDL [Mass/volume] in Serum or Plasma",
  "49130-8": "Cholesterol in HDL [Mass/volume] in Serum or Plasma",
  "9832-7": "Cholesterol in HDL [Mass/volume] in Serum or Plasma",
  "2571-8": "Triglyceride [Mass/volume] in Serum or Plasma",
  "12951-0": "Triglyceride [Mass/volume] in Serum or Plasma",
  "3043-7": "Triglyceride [Mass/volume] in Serum or Plasma",
  "14927-8": "Triglyceride [Mass/volume] in Serum or Plasma",
  "3048-6": "Triglyceride [Mass/volume] in Serum or Plasma",
  "3049-4": "Triglyceride [Mass/volume] in Serum or Plasma",
  "48643-1": "Glomerular filtration rate/1.73 sq M.predicted among blacks [Volume Rate/Area] in Serum, Plasma or Blood by Creatinine-based formula (MDRD)",
  "33914-3": "Glomerular filtration rate/1.73 sq M.predicted among blacks [Volume Rate/Area] in Serum, Plasma or Blood by Creatinine-based formula (MDRD)",
  "77147-7": "Glomerular filtration rate/1.73 sq M.predicted among blacks [Volume Rate/Area] in Serum, Plasma or Blood by Creatinine-based formula (MDRD)",
  "50044-7": "Glomerular filtration rate/1.73 sq M.predicted among blacks [Volume Rate/Area] in Serum, Plasma or Blood by Creatinine-based formula (MDRD)",
  "70969-1": "Glomerular filtration rate/1.73 sq M.predicted among blacks [Volume Rate/Area] in Serum, Plasma or Blood by Creatinine-based formula (MDRD)",
  "48642-3": "Glomerular filtration rate/1.73 sq M.predicted among blacks [Volume Rate/Area] in Serum, Plasma or Blood by Creatinine-based formula (MDRD)",
  "88294-4": "Glomerular filtration rate/1.73 sq M.predicted among blacks [Volume Rate/Area] in Serum, Plasma or Blood by Creatinine-based formula (MDRD)",
  "88293-6": "Glomerular filtration rate/1.73 sq M.predicted among blacks [Volume Rate/Area] in Serum, Plasma or Blood by Creatinine-based formula (MDRD)",
  "62238-1": "Glomerular filtration rate/1.73 sq M.predicted among blacks [Volume Rate/Area] in Serum, Plasma or Blood by Creatinine-based formula (MDRD)",
  "69405-9": "Glomerular filtration rate/1.73 sq M.predicted among blacks [Volume Rate/Area] in Serum, Plasma or Blood by Creatinine-based formula (MDRD)",
  "2160-0": "Creatinine [Mass/volume] in Serum or Plasma",
  "3094-0": "Urea nitrogen [Mass/volume] in Serum or Plasma",
  "2823-3": "Potassium [Moles/volume] in Serum or Plasma",
  "19123-9": "Magnesium [Mass/volume] in Serum or Plasma",
  "3016-3": "Thyrotropin [Units/volume] in Serum or Plasma",
  "11580-8": "Thyrotropin [Units/volume] in Serum or Plasma",
  "3024-7": "Thyroxine (T4) free [Mass/volume] in Serum or Plasma",
  "3040-3": "Lipase [Enzymatic activity/volume] in Serum or Plasma",
  "2777-1": "Phosphate [Mass/volume] in Serum or Plasma",
  "10839-9": "Troponin I.cardiac [Mass/volume] in Serum or Plasma"
};
class rl extends Qe {
  constructor(n, r, s, a) {
    super(n, s, a);
    ne(this, "kind", "Observation");
    ne(this, "binaryId");
    ne(this, "diagnosticReport");
    ne(this, "provenance");
    ne(this, "trendData");
    this.provenance = r, this.binaryId = Wg(this.provenance);
  }
  get category() {
    var n;
    return Ie((n = this.resource.category) == null ? void 0 : n[0]);
  }
  get display() {
    var r;
    const n = (r = this.resource.code.coding) == null ? void 0 : r.find(
      (s) => s.display !== "unknown" && s.display
    );
    return n ? n.display || n.code : Ie(this.resource.code);
  }
  get effectiveStart() {
    return ye(this.effectiveStartRaw);
  }
  get effectiveStartRaw() {
    var n;
    return ((n = this.resource.effectivePeriod) == null ? void 0 : n.start) || this.resource.effectiveDateTime;
  }
  get identifier() {
    var n, r;
    return (r = (n = this.resource.identifier) == null ? void 0 : n[0].value) != null ? r : "";
  }
  get performer() {
    var n;
    return (n = this.resource.performer) == null ? void 0 : n[0].display;
  }
  get value() {
    return this.resource.valueBoolean !== void 0 ? this.resource.valueBoolean ? "true" : "false" : this.resource.valueCodeableConcept ? Ie(this.resource.valueCodeableConcept) : this.resource.valueDateTime ? this.resource.valueDateTime : this.resource.valueInteger !== void 0 ? String(this.resource.valueInteger) : this.resource.valuePeriod ? UL(this.resource.valuePeriod) : this.resource.valueQuantity ? HL(this.resource.valueQuantity) : this.resource.valueRange ? zL(this.resource.valueRange) : this.resource.valueString ? this.resource.valueString : this.resource.valueTime ? this.resource.valueTime : "";
  }
  get unit() {
    var n;
    return (n = this.resource.valueQuantity) == null ? void 0 : n.unit;
  }
  get valueString() {
    var n;
    return this.resource.valueString || ((n = this.resource.valueQuantity) == null ? void 0 : n.value);
  }
  get interpretation() {
    var s;
    const n = [
      "n",
      "noinformation",
      "normal",
      "na",
      "(normal)",
      "unknown",
      "not applicable",
      "temporarily unavailable",
      "nml",
      "norm",
      "*"
    ], r = Ie((s = this.resource.interpretation) == null ? void 0 : s[0]).toLowerCase();
    if (!n.includes(r))
      return r;
  }
  get notes() {
    var n, r;
    return (r = (n = this.resource.note) == null ? void 0 : n[0].text) != null ? r : "";
  }
  get referenceRange() {
    var n;
    return (n = this.resource.referenceRange) == null ? void 0 : n[0].text;
  }
  get trends() {
    return this.trendData;
  }
  setTrends(n) {
    var s;
    const r = Ee(
      (s = this.resource.code.coding) == null ? void 0 : s.filter((a) => a.code && a.system === Yt).map((a) => Vg[a.code])
    );
    this.trendData = Ee(ht(r.flatMap((a) => n[a])));
  }
  get acceptedInterpretations() {
    var n;
    switch (Ie((n = this.resource.interpretation) == null ? void 0 : n[0]).toLowerCase()) {
      case "high":
      case "low":
      case "hi":
      case "abn":
      case "(high)":
      case "(low)":
      case "abnormal":
      case "a":
      case "l":
      case "h":
      case "above high normal":
      case "crit":
      case "below low normal":
      case "high alert":
      case "(abnormal)":
      case "abnormal alert":
      case "abnormal low":
      case "abnormal high":
      case "low alert":
      case "pos":
      case "no reference range":
      case "positive":
      case "(positive)":
      case "(critical high)":
      case "(critical low)":
      case "critical high":
      case "critical low":
      case "c":
        return "ctw-text-caution-text ctw-bg-caution-light ctw-inline-flex ctw-rounded-xl ctw-font-medium ctw-text-sm ctw-p-1 ctw-px-3";
      default:
        return "ctw-text-content-black ctw-bg-bg-light ctw-inline-flex ctw-rounded-xl ctw-leading-5 ctw-font-medium ctw-text-sm ctw-p-1 ctw-px-3";
    }
  }
  /**
   * Return true if the provided diagnostic and trend combination are incorrectly coded,
   * and therefore should not be displayed in the trends.
   *
   * https://zeushealth.atlassian.net/browse/CDEV-310
   */
  get isIncorrectlyCodedGlucose() {
    var n, r;
    if (this.diagnosticReport) {
      const s = (n = this.diagnosticReport.resource.code.coding) == null ? void 0 : n.some((o) => {
        var l;
        const c = (l = o.display) == null ? void 0 : l.toLowerCase().indexOf("a1c");
        return o.system === Yt && o.code === "4548-4" || o.system === QL && o.code === "83036" || c !== void 0 && c > -1;
      }), a = (r = this.resource.code.coding) == null ? void 0 : r.some(
        (o) => o.system === Yt && o.code === "2345-7"
      );
      return s && a;
    }
    return !1;
  }
  get title() {
    var n;
    return (n = this.display) != null ? n : "Unknown Observation";
  }
}
class qg extends Qe {
  constructor(n, r, s) {
    var a;
    super(n, r, s);
    ne(this, "kind", "DiagnosticReport");
    ne(this, "observationModels");
    ne(this, "_effectiveStart");
    this.observationModels = Ee(
      (a = this.resource.result) == null ? void 0 : a.map((o) => {
        const c = (
          // @ts-ignore: The FHIR spec doesn't support this customized result field that now has the
          // observation resource and not only just a reference.
          o.resource || Pe("Observation", n.contained, r, o)
        );
        if (c) {
          const l = new rl(c);
          return l.diagnosticReport = this, l;
        }
      })
    );
  }
  get category() {
    var s, a, o, c, l;
    const n = Ie((s = this.resource.category) == null ? void 0 : s[0]) || this.reportCategory;
    if (n)
      return n;
    const r = Ie((a = this.resource.category) == null ? void 0 : a[0]);
    return (l = (c = Pe("Observation", void 0, this.includedResources, (o = this.resource.result) == null ? void 0 : o[0])) == null ? void 0 : c.category) != null ? l : `No display value found ${r ? " for " : ""}${r}`;
  }
  get coding() {
    return gf(this.resource.code.coding) || wf(this.resource.code.coding);
  }
  get displayName() {
    var n, r;
    return ((n = gf(this.resource.code.coding)) == null ? void 0 : n.display) || ((r = wf(this.resource.code.coding)) == null ? void 0 : r.display) || Ie(this.resource.code);
  }
  get effectiveStart() {
    var n, r;
    return this._effectiveStart || (this._effectiveStart = ye(
      ((n = this.resource.effectivePeriod) == null ? void 0 : n.start) || this.resource.effectiveDateTime
    ) || vf(
      (r = this.resource.result) == null ? void 0 : r.map(
        (s) => Pe("Observation", void 0, this.includedResources, s)
      )
    )), this._effectiveStart;
  }
  get effectiveEnd() {
    var n, r, s;
    return (n = this.resource.effectivePeriod) != null && n.end ? ye(this.resource.effectivePeriod.end) : this.effectiveStart || BF(
      (r = this.resource.result) == null ? void 0 : r.map(
        (a) => Pe("Observation", void 0, this.includedResources, a)
      )
    ) || vf(
      (s = this.resource.result) == null ? void 0 : s.map(
        (a) => Pe("Observation", void 0, this.includedResources, a)
      )
    );
  }
  get identifier() {
    var n, r;
    return (r = (n = this.resource.identifier) == null ? void 0 : n[0].value) != null ? r : "";
  }
  get details() {
    if (!this.results.length)
      return "";
    const n = this.results.length > 1 ? "results" : "result";
    let r = `${this.results.length} ${n}`;
    return this.hasTrends && (r += ", result trend available"), r;
  }
  get hasTrends() {
    return this.observations.some((n) => n.trends && n.trends.length > 1);
  }
  get performer() {
    var n, r;
    return ((n = this.organization) == null ? void 0 : n.display) || ((r = this.resource.performer) == null ? void 0 : r[0].display);
  }
  get organization() {
    var r;
    const n = (r = this.resource.performer) != null ? r : [];
    return Ue(n, { type: "Organization" });
  }
  get reportCategory() {
    var n, r;
    return (r = (n = Co(
      [{ system: YL }, { system: os }],
      this.resource.code
    )) == null ? void 0 : n.display) != null ? r : Ie(this.resource.code);
  }
  get results() {
    var n;
    return (n = this.resource.result) != null ? n : [];
  }
  get observations() {
    return this.observationModels;
  }
  get title() {
    return this.displayName;
  }
}
const gf = (e) => {
  if (e)
    return e.find(
      (t) => t.extension && t.extension.find(
        (n) => n.valueString === "LOINC Standardization" && n.url === "https://zusapi.com/terminology/enrichment"
      ) && t.display && t.system !== "http://terminology.hl7.org/CodeSystem/v3-NullFlavor"
    );
}, wf = (e) => {
  if (e)
    return e.filter((t) => t.system !== "http://terminology.hl7.org/CodeSystem/v3-NullFlavor").find((t) => t.display);
}, Gg = (e) => e ? e.filter((t) => t) : [], vf = (e) => Gg(e).map(
  (t) => {
    var n;
    return ye((n = t.effectivePeriod) == null ? void 0 : n.start) || ye(t.effectiveDateTime) || ye(t.effectiveInstant);
  }
).reduce(
  (t, n) => t ? n ? Date.parse(t) < Date.parse(n) ? t : n : t : n,
  void 0
), BF = (e) => Gg(e).map(
  (t) => {
    var n;
    return ye((n = t.effectivePeriod) == null ? void 0 : n.start) || ye(t.effectiveDateTime) || ye(t.effectiveInstant);
  }
).reduce(
  (t, n) => t ? n ? Date.parse(t) > Date.parse(n) ? t : n : t : n,
  void 0
), UF = {
  active: "Currently taking",
  "entered-in-error": "Never taken",
  "not-taken": "Prescribed, not taken",
  completed: "No longer taking",
  "on-hold": "On hold",
  intended: "Intend to take",
  stopped: "No longer taking"
};
function la(e, t) {
  if (e.medicationCodeableConcept)
    return e.medicationCodeableConcept;
  const n = Pe(
    "Medication",
    e.contained,
    t,
    e.medicationReference
  );
  return n == null ? void 0 : n.code;
}
function Ua(e, t) {
  var n;
  return (n = sl(e, t)) == null ? void 0 : n.code;
}
function sl(e, t) {
  var s, a;
  const n = la(e, t), r = (s = n == null ? void 0 : n.coding) == null ? void 0 : s.find(
    (o) => {
      var c;
      return (
        // must be an RxNorm code
        o.system === is && !((c = o.extension) != null && c.some((l) => l.url === xr))
      );
    }
  );
  return r || ((a = n == null ? void 0 : n.coding) == null ? void 0 : a.find(
    (o) => {
      var c;
      return (
        // must be an RxNorm code
        o.system === is && // must have no extensions
        ((c = o.extension) == null ? void 0 : c.some(
          (l) => l.url === xr && l.valueString === "Standardization"
        ))
      );
    }
  ));
}
function al(e, t) {
  var s, a, o, c, l;
  const n = sl(e, t);
  if (n != null && n.display)
    return n.display;
  const r = la(e, t);
  return r != null && r.text ? r.text : (l = (a = (s = r == null ? void 0 : r.coding) == null ? void 0 : s.find((d) => d.display)) == null ? void 0 : a.display) != null ? l : `${(o = r == null ? void 0 : r.coding) == null ? void 0 : o[0].code} (${(c = r == null ? void 0 : r.coding) == null ? void 0 : c[0].system})`;
}
function Yg(e, t) {
  var r, s, a;
  let n;
  switch (e.resourceType) {
    case "MedicationAdministration":
    case "MedicationDispense":
      n = (s = (r = e.performer) == null ? void 0 : r[0]) == null ? void 0 : s.actor;
      break;
    case "MedicationRequest":
      n = e.performer || ((a = e.dispenseRequest) == null ? void 0 : a.performer);
      break;
    case "MedicationStatement":
    default:
      return;
  }
  if (n != null && n.reference && n.type === "Organization")
    return Pe("Organization", e.contained, t, n);
}
function zF(e) {
  return ln(UF, e, "");
}
class da extends Qe {
  constructor() {
    super(...arguments);
    ne(this, "kind", "MedicationDispense");
  }
  get includedPerformer() {
    var s, a, o, c;
    const n = (a = (s = this.resource.performer) == null ? void 0 : s[0]) == null ? void 0 : a.actor, r = Pe(
      "Practitioner",
      this.resource.contained,
      this.includedResources,
      n
    );
    return r ? new Lr(r).fullName : (c = (o = this.resource.performer) == null ? void 0 : o[0]) == null ? void 0 : c.actor.display;
  }
  get performer() {
    return Yg(this.resource, this.includedResources);
  }
  get performerDetails() {
    var r, s, a, o, c;
    const { performer: n } = this;
    return {
      name: (r = n == null ? void 0 : n.name) != null ? r : "",
      address: (a = (s = n == null ? void 0 : n.address) == null ? void 0 : s[0].text) != null ? a : "",
      telecom: (c = (o = n == null ? void 0 : n.telecom) == null ? void 0 : o[0].value) != null ? c : ""
    };
  }
  get status() {
    return this.resource.status;
  }
  get quantityDisplay() {
    const { value: n, unit: r = "Unspecified" } = this.resource.quantity || {};
    return n !== void 0 ? `${n} (${r})` : void 0;
  }
  get rxNorm() {
    return Ua(this.resource, this.includedResources);
  }
  get supplied() {
    const { value: n, unit: r = "days" } = this.resource.daysSupply || {};
    return n ? `${n} ${r}` : void 0;
  }
  get medicationDisplayName() {
    return al(this.resource, this.includedResources);
  }
  get PMARefillNotPickedUp() {
    var n, r;
    return (r = (n = this.resource.extension) == null ? void 0 : n.find(
      (s) => s.url === "http://surescripts.net/fhir/CodeSystem/patient-notification-types"
    )) == null ? void 0 : r.valueString;
  }
  get alertTimeStamp() {
    var r, s;
    const n = (s = (r = this.resource.extension) == null ? void 0 : r.find(
      (a) => a.url === "http://surescripts.net/fhir/CodeSystem/notification-generated-time"
    )) == null ? void 0 : s.valueInstant;
    return ye(n);
  }
  get title() {
    return this.medicationDisplayName;
  }
  get whenHandedOver() {
    return ye(this.resource.whenHandedOver);
  }
  get whenPrepared() {
    return ye(this.resource.whenPrepared);
  }
}
class So extends Qe {
  constructor() {
    super(...arguments);
    ne(this, "kind", "MedicationAdministration");
  }
  get dosageDisplay() {
    const { text: n, dose: r } = this.resource.dosage || {};
    return n || Dt([r == null ? void 0 : r.value, r == null ? void 0 : r.unit]).join(" ");
  }
  get dosageRoute() {
    const { route: n } = this.resource.dosage || {};
    return n == null ? void 0 : n.text;
  }
  get effectivePeriod() {
    const { start: n, end: r } = this.resource.effectivePeriod || {};
    return {
      start: n ? ye(n) : "",
      end: r ? ye(r) : ""
    };
  }
  get title() {
    return al(this.resource, this.includedResources);
  }
}
class $o extends Qe {
  constructor() {
    super(...arguments);
    ne(this, "kind", "MedicationRequest");
  }
  get authoredOn() {
    return ye(this.resource.authoredOn);
  }
  get includedRequester() {
    var s;
    const n = this.resource.requester, r = Pe(
      "Practitioner",
      this.resource.contained,
      this.includedResources,
      n
    );
    return r ? new Lr(r).fullName : (s = this.resource.requester) == null ? void 0 : s.display;
  }
  get medicationDisplayName() {
    return al(this.resource, this.includedResources);
  }
  get pharmacy() {
    var s, a, o;
    const n = ((s = this.resource.dispenseRequest) == null ? void 0 : s.performer) || {}, r = Pe(
      "Organization",
      this.resource.contained,
      this.includedResources,
      n
    );
    if (r) {
      const c = (a = r.telecom) == null ? void 0 : a[0].value, { city: l, state: d, postalCode: u, text: h, line: f = [] } = ((o = r.address) == null ? void 0 : o[0]) || {}, p = Dt([l, `${d} ${u}`]).join(", ");
      return {
        telecom: c,
        name: r.name,
        address: h != null ? h : Dt([f, p]).join(`
`)
      };
    }
    return { name: n.display };
  }
  get rxNorm() {
    return Ua(this.resource, this.includedResources);
  }
  get title() {
    return this.medicationDisplayName;
  }
}
class Ot extends Qe {
  constructor() {
    super(...arguments);
    ne(this, "kind", "MedicationStatement");
    ne(this, "builderPatientRxNormStatus");
  }
  get activeIngredient() {
    const n = la(this.resource, this.includedResources), r = s9("ActiveIngredient", n);
    return r == null ? void 0 : r.display;
  }
  get aggregatedFrom() {
    const n = vo(
      (r) => r.url === Bc || r.url === Uc,
      this.resource.extension
    );
    return n != null && n.extension ? Dt(n.extension.map(tg("valueReference"))) : Dt(this.resource.derivedFrom);
  }
  get basedOn() {
    var n, r;
    return (r = (n = this.resource.basedOn) == null ? void 0 : n[0]) == null ? void 0 : r.type;
  }
  get category() {
    return Ie(this.resource.category);
  }
  get context() {
    var n;
    return (n = this.resource.context) == null ? void 0 : n.display;
  }
  get dateAsserted() {
    return ye(this.resource.dateAsserted);
  }
  set dateAsserted(n) {
    n instanceof Date ? this.resource.dateAsserted = pr(n) : this.resource.dateAsserted = n;
  }
  get derivedFrom() {
    var n;
    return ((n = this.resource.derivedFrom) == null ? void 0 : n.map(({ display: r }) => r || "")) || [];
  }
  get display() {
    return Ie(
      la(this.resource, this.includedResources),
      is
    );
  }
  get sortDisplay() {
    return hr(this.display);
  }
  get dosage() {
    var n, r;
    return (r = (n = this.resource.dosage) == null ? void 0 : n[0]) == null ? void 0 : r.text;
  }
  get effectiveStart() {
    var n;
    return ye((n = this.resource.effectivePeriod) == null ? void 0 : n.start);
  }
  get identifier() {
    var n, r;
    return (r = (n = this.resource.identifier) == null ? void 0 : n[0]) == null ? void 0 : r.value;
  }
  set informationSource(n) {
    this.resource.informationSource = n;
  }
  get medicationReference() {
    var n;
    return (n = this.resource.medicationReference) == null ? void 0 : n.display;
  }
  get notesDisplay() {
    var n;
    return ((n = this.resource.note) == null ? void 0 : n.map(({ text: r }) => r)) || [];
  }
  get partOf() {
    var n, r;
    return (r = (n = this.resource.partOf) == null ? void 0 : n[0]) == null ? void 0 : r.display;
  }
  get patientStatus() {
    var n, r;
    return zF((r = this.builderPatientRxNormStatus) == null ? void 0 : r[(n = this.rxNorm) != null ? n : ""]);
  }
  get resourceTypeTitle() {
    return "Medication";
  }
  get rxNorm() {
    return Ua(this.resource, this.includedResources);
  }
  /**
   * Get RxNorm coding with "display" defaulting to this Med-Statement label.
   */
  get rxNormCodeableConcept() {
    var r;
    const n = sl(this.resource, this.includedResources);
    return X(R({}, n != null ? n : {}), {
      display: (r = n == null ? void 0 : n.display) != null ? r : this.display
    });
  }
  get reason() {
    var n;
    return Ie((n = this.resource.reasonCode) == null ? void 0 : n[0]);
  }
  get reasonReference() {
    return this.resource.reasonReference;
  }
  get isInactive() {
    return !["active", "intended", "unknown"].includes(this.status);
  }
  get status() {
    return this.resource.status;
  }
  get displayStatus() {
    return this.isDismissed ? "Dismissed" : fr(this.resource.status);
  }
  get statusReason() {
    var n;
    return Ie((n = this.resource.statusReason) == null ? void 0 : n[0]);
  }
  get subjectID() {
    var r;
    const [, n] = ((r = this.resource.subject.reference) == null ? void 0 : r.split("/")) || [];
    return n || "";
  }
  get patient() {
    const n = Pe(
      "Patient",
      this.resource.contained,
      this.includedResources,
      this.resource.subject
    );
    if (n)
      return new zt(n, this.includedResources);
  }
  // lens extensions
  get lastFillDate() {
    var n, r;
    return ye(
      (r = (n = this.resource.extension) == null ? void 0 : n.find((s) => s.url === mg)) == null ? void 0 : r.valueDateTime
    );
  }
  get quantity() {
    var a, o;
    const n = (o = (a = this.resource.extension) == null ? void 0 : a.find(
      (c) => c.url === wg
    )) == null ? void 0 : o.valueQuantity, { value: r, unit: s = "Unspecified" } = n || {};
    return r !== void 0 ? `${r} (${s})` : void 0;
  }
  get daysSupply() {
    var n, r, s, a;
    return (a = (s = (r = (n = this.resource.extension) == null ? void 0 : n.find((o) => o.url === vg)) == null ? void 0 : r.valueQuantity) == null ? void 0 : s.value) == null ? void 0 : a.toString();
  }
  get refills() {
    var n, r, s;
    return (s = (r = (n = this.resource.extension) == null ? void 0 : n.find((a) => a.url === yg)) == null ? void 0 : r.valueUnsignedInt) == null ? void 0 : s.toString();
  }
  get lastPrescriber() {
    var a, o;
    const n = (o = (a = this.resource.extension) == null ? void 0 : a.find(
      (c) => c.url === xg
    )) == null ? void 0 : o.valueReference;
    if (!(n != null && n.reference))
      return;
    const r = n.reference.split("/")[0];
    if (!r)
      return;
    const s = Pe(
      r,
      this.resource.contained,
      this.includedResources,
      n
    );
    if (s != null && s.name) {
      if (typeof s.name == "string")
        return s.name;
      const { family: c, given: l = [] } = s.name[0];
      return Dt([c, l[0]]).join(", ");
    }
    return n.display;
  }
  get lastPrescribedDate() {
    var n, r;
    return ye(
      (r = (n = this.resource.extension) == null ? void 0 : n.find((s) => s.url === gg)) == null ? void 0 : r.valueDateTime
    );
  }
  get lastActivityDate() {
    const { lastPrescribedDate: n, lastFillDate: r } = this, s = Dt([n, r]).map((o) => new Date(o));
    if (s.length === 0)
      return;
    const a = av(s);
    return ye(a.toISOString());
  }
  get title() {
    return this.display;
  }
}
class HF extends Qe {
  constructor() {
    super(...arguments);
    ne(this, "kind", "Medication");
  }
  get performer() {
    var n;
    return (n = Yg(this.resource, this.includedResources)) == null ? void 0 : n.name;
  }
  get status() {
    return this.resource.status;
  }
  get dosage() {
    var n, r, s;
    switch (this.resource.resourceType) {
      case "MedicationStatement":
        return (r = (n = this.resource.dosage) == null ? void 0 : n[0]) == null ? void 0 : r.text;
      case "MedicationAdministration":
        return new So(this.resource, this.includedResources).dosageDisplay;
      case "MedicationDispense":
      case "MedicationRequest":
        return Ie((s = this.resource.dosageInstruction) == null ? void 0 : s[0]);
      default:
        return "";
    }
  }
  get date() {
    var n, r, s, a, o, c, l, d, u;
    switch (this.resource.resourceType) {
      case "MedicationStatement":
        return (r = this.resource.dateAsserted) != null ? r : (n = this.resource.effectivePeriod) == null ? void 0 : n.start;
      case "MedicationAdministration":
        return (s = this.resource.effectivePeriod) == null ? void 0 : s.start;
      case "MedicationDispense":
        return (a = this.resource.whenHandedOver) != null ? a : this.resource.whenPrepared;
      case "MedicationRequest":
        return (u = this.resource.authoredOn) != null ? u : (d = (l = (c = (o = this.resource.dosageInstruction) == null ? void 0 : o[0].timing) == null ? void 0 : c.repeat) == null ? void 0 : l.boundsPeriod) == null ? void 0 : d.start;
      default:
        return "";
    }
  }
  get dateLocal() {
    return ye(this.date);
  }
  get patient() {
    const n = Pe(
      "Patient",
      this.resource.contained,
      this.includedResources,
      this.resource.subject
    );
    if (n)
      return new zt(n, this.includedResources);
  }
  /**
   * This accessor will try to get the prescriber for the underlying medication
   * models resource. Depending on the type of fhir resource, it will delegate
   * the work to a more specific fhir/model/*.ts class before simply grabbing
   * the `display` property from an actor/performer/requester. If all else
   * should fail, the accessor returns an empty string.
   */
  get prescriber() {
    switch (this.resource.resourceType) {
      case "MedicationStatement":
        return new Ot(this.resource, this.includedResources).lastPrescriber;
      case "MedicationDispense":
        return new da(this.resource, this.includedResources).includedPerformer;
      case "MedicationRequest":
        return new $o(this.resource, this.includedResources).includedRequester;
      default:
        return;
    }
  }
  get title() {
    switch (this.resource.resourceType) {
      case "MedicationStatement":
        return new Ot(this.resource, this.includedResources).title;
      case "MedicationAdministration":
        return new So(this.resource, this.includedResources).title;
      case "MedicationDispense":
        return new da(this.resource, this.includedResources).title;
      case "MedicationRequest":
        return new $o(this.resource, this.includedResources).title;
      default:
        return "Unknown Medication";
    }
  }
}
const WF = (e) => typeof e == "string" ? e === rf : (e == null ? void 0 : e.system) === rf;
class za extends Qe {
  constructor(n, r, s, a) {
    super(n, s, a);
    ne(this, "kind", "Encounter");
    ne(this, "docsAndNotes", []);
    ne(this, "provenance");
    ne(this, "relatedEncounter");
    // Used by summary resources to indicate there's a matching
    // builder condition for this summary.
    ne(this, "syncedWithRecord", !1);
    this.provenance = r;
  }
  get binaryIds() {
    var a;
    const n = Wg(this.provenance), r = Ue(this.resource.extension, {
      url: t9
    }), s = (a = r == null ? void 0 : r.extension) == null ? void 0 : a.map(
      (o) => {
        var c, l;
        return (l = (c = o.valueReference) == null ? void 0 : c.reference) == null ? void 0 : l.split("/").pop();
      }
    );
    return Ee([n].concat(s));
  }
  setClinicalNotesFromDocumentPool(n) {
    this.docsAndNotes = this.findNotesFromDocumentPool(n);
  }
  // Get docs and notes from a pool of all documents for that patient (we can't query by encounter)
  findNotesFromDocumentPool(n = []) {
    const r = /* @__PURE__ */ new Map();
    n.filter((a) => {
      var c, l, d;
      const o = ((d = (l = (c = a.resource.context) == null ? void 0 : c.encounter) == null ? void 0 : l[0]) == null ? void 0 : d.reference) === `Encounter/${this.id}`;
      return a.binaryId && tl(a.resource) && this.binaryIds.includes(a.binaryId) || o;
    }).forEach((a) => {
      var o;
      r.set(
        a.binaryId,
        ((o = r.get(a.binaryId)) != null ? o : []).concat(a)
      );
    });
    const s = [];
    return r.forEach((a, o) => {
      var d;
      if (!o)
        return;
      const c = a.filter((u) => !ca(u)), l = c.length === 1 ? c[0] : (d = a.find((u) => u.title)) != null ? d : a[0];
      s.push(
        new hn(
          l.resource,
          a.filter((u) => u.id !== l.id)
        )
      );
    }), s;
  }
  get lastUpdated() {
    var n, r, s, a;
    return ((n = this.resource.meta) == null ? void 0 : n.lastUpdated) || ((a = (s = (r = this.resource.meta) == null ? void 0 : r.extension) == null ? void 0 : s.find((o) => o.url === Lc)) == null ? void 0 : a.valueDateTime);
  }
  get patient() {
    const n = Pe("Patient", void 0, void 0, this.resource.subject);
    return n ? new zt(n) : void 0;
  }
  // Get the notes, excluding summary documents (sections only)
  get clinicalNotes() {
    return this.docsAndNotes.flatMap((n) => {
      var r;
      return (r = n.sectionDocuments) != null ? r : [n];
    });
  }
  get diagnoses() {
    var n;
    return [
      ...Ee(
        ht(
          (n = this.resource.diagnosis) == null ? void 0 : n.map((r) => {
            var a;
            const s = Pe(
              "Condition",
              void 0,
              void 0,
              r.condition
            );
            return s ? (a = s.code) == null ? void 0 : a.text : r.condition.display;
          })
        )
      )
    ];
  }
  get dischargeDisposition() {
    var n;
    return Ie((n = this.resource.hospitalization) == null ? void 0 : n.dischargeDisposition);
  }
  get isHospitalEncounter() {
    return this.typeCodings.some((n) => n.code === "IMP" || n.code === "EMER");
  }
  get location() {
    var n;
    return Ee(
      (n = this.resource.location) == null ? void 0 : n.map((r) => {
        const s = Pe(
          "Location",
          void 0,
          void 0,
          r.location
        );
        return s ? s.name : r.location.display;
      })
    );
  }
  get practitionersDisplay() {
    return this.practitioners.join(", ");
  }
  get practitioners() {
    var n;
    return Ee(
      ht(
        (n = this.resource.participant) == null ? void 0 : n.map((r) => {
          var a;
          const s = Pe(
            "Practitioner",
            void 0,
            void 0,
            r.individual
          );
          return s ? new Lr(s).fullName : (a = r.individual) == null ? void 0 : a.display;
        })
      )
    );
  }
  get periodEnd() {
    var n;
    return ye((n = this.resource.period) == null ? void 0 : n.end);
  }
  get periodStart() {
    var n;
    return ye((n = this.resource.period) == null ? void 0 : n.start);
  }
  get dateDisplay() {
    return this.periodStart !== this.periodEnd && this.periodEnd ? `${this.periodStart} - ${this.periodEnd}` : this.periodStart;
  }
  get reason() {
    var r;
    const n = Ee((r = this.resource.reasonCode) == null ? void 0 : r.map((s) => Ie(s)));
    return n.length ? n.filter((s) => s !== "unknown").join(", ") : void 0;
  }
  get status() {
    return this.resource.status;
  }
  get typeCodings() {
    var n;
    return Ee((n = this.resource.type) == null ? void 0 : n.flatMap((r) => r.coding));
  }
  get locationType() {
    var r;
    const n = (r = this.resource.location) == null ? void 0 : r.flatMap((s) => {
      var o;
      const a = Pe("Location", void 0, void 0, s.location);
      return (o = a == null ? void 0 : a.type) == null ? void 0 : o.map((c) => Ie(c));
    }).map((s) => ["not indicated", "unknown", "noinformation", "null"].includes(hr(String(s))) ? "unknown" : s);
    return Ee(ht(n));
  }
  get locationPhysicalType() {
    var s;
    const n = Ee(
      (s = this.resource.location) == null ? void 0 : s.map((a) => {
        const o = Pe("Location", void 0, void 0, a.location);
        return Ie(o == null ? void 0 : o.physicalType);
      })
    ), r = ht(n).filter((a) => {
      switch (a) {
        case "URGENT_CARE":
          return "Urgent Care";
        case "Not Indicated":
        case "Unknown":
        case "NoInformation":
        case "No Information":
        case "Building":
        case void 0:
          return "Unknown";
        default:
          return a;
      }
    });
    return r.length ? r[0] : "Unknown";
  }
  get title() {
    return this.typeDisplay;
  }
  get classDisplay() {
    var o;
    const { system: n, code: r = "", display: s = "" } = this.resource.class;
    return WF(n) ? "" : (o = {
      AMB: "Ambulatory",
      IMP: "Inpatient",
      EMER: "Emergency",
      HH: "Home Health",
      OBSENC: "Observation",
      VR: "Virtual",
      PRENC: "Pre-Admission"
    }[r.toUpperCase()]) != null ? o : fr(s);
  }
  get typeDisplay() {
    var a, o;
    const { text: n, coding: r = [] } = (o = (a = this.resource.type) == null ? void 0 : a[0]) != null ? o : {}, s = r.map((c) => c.display);
    return [n, ...s].filter((c) => !!c).join(", ");
  }
}
const yf = "https://zusapi.com/lens/extension/dischargeNarrative", VF = "https://zusapi.com/lens/extension/preferredDischargeNarrative", qF = "https://zusapi.com/lens/extension/dischargeDisposition", GF = "https://zusapi.com/lens/extension/dischargeLocation", YF = "https://zusapi.com/lens/extension/admittingLocation", Rn = (e, t) => {
  var n;
  return (n = e.extension) == null ? void 0 : n.find((r) => r.url === t);
};
class QF extends Qe {
  constructor(n, r, s, a) {
    super(n, s, a);
    ne(this, "kind", "EpisodeOfCareModel");
    ne(this, "binaryId");
    ne(this, "provenance");
    ne(this, "relatedEncounters");
    this.provenance = r;
  }
  get key() {
    return this.resource.id || "";
  }
  get lastUpdated() {
    var n, r, s, a;
    return ((n = this.resource.meta) == null ? void 0 : n.lastUpdated) || ((a = (s = (r = this.resource.meta) == null ? void 0 : r.extension) == null ? void 0 : s.find((o) => o.url === Lc)) == null ? void 0 : a.valueDateTime);
  }
  get patient() {
    const n = Pe("Patient", void 0, void 0, this.resource.patient);
    return n ? new zt(n) : void 0;
  }
  get diagnoses() {
    var n;
    return Dt(
      aa(
        (n = this.resource.diagnosis) == null ? void 0 : n.map((r) => {
          var a;
          const s = Pe("Condition", void 0, void 0, r.condition);
          return (a = s == null ? void 0 : s.code) == null ? void 0 : a.text;
        })
      )
    );
  }
  diagnosesForRole(n) {
    var s;
    const r = (s = this.resource.diagnosis) == null ? void 0 : s.filter(
      (a) => zc(GL, [n], a.role)
    );
    return Dt(
      aa(
        r == null ? void 0 : r.map((a) => {
          var l;
          const o = Pe("Condition", void 0, void 0, a.condition);
          return (l = jo(os, o == null ? void 0 : o.code)[0]) == null ? void 0 : l.display;
        })
      )
    );
  }
  get class() {
    var r;
    const n = Rn(
      this.resource,
      "https://zusapi.com/lens/extension/encounterClass"
    );
    return qe((r = n == null ? void 0 : n.valueCoding) == null ? void 0 : r.display);
  }
  get classCode() {
    var r, s, a;
    const n = Rn(
      this.resource,
      "https://zusapi.com/lens/extension/encounterClass"
    );
    return (a = (s = (r = n == null ? void 0 : n.valueCoding) == null ? void 0 : r.code) == null ? void 0 : s.toUpperCase()) != null ? a : "";
  }
  get dischargeDisposition() {
    const n = Rn(this.resource, qF);
    return Ie(n == null ? void 0 : n.valueCodeableConcept);
  }
  get location() {
    var r;
    const n = Rn(this.resource, GF);
    return ((r = n == null ? void 0 : n.valueReference) == null ? void 0 : r.display) || this.admittingLocation;
  }
  get admittingLocation() {
    var r;
    const n = Rn(this.resource, YF);
    return (r = n == null ? void 0 : n.valueReference) == null ? void 0 : r.display;
  }
  // TODO: once https://zeushealth.atlassian.net/browse/DAU-288 is done we can likely remove this
  // logic to treat midnight UTC as a date only
  get periodEnd() {
    var n;
    return ye((n = this.resource.period) == null ? void 0 : n.end, !0);
  }
  get periodStart() {
    var n;
    return ye((n = this.resource.period) == null ? void 0 : n.start, !0);
  }
  get dateDisplay() {
    return this.periodStart !== this.periodEnd && this.periodEnd ? `${this.periodStart} - ${this.periodEnd}` : this.periodStart;
  }
  get status() {
    switch (this.resource.status) {
      case "active":
        return "Active";
      case "finished":
        return "Discharged";
      default:
        return this.resource.status;
    }
  }
  get dischargeBinaryIds() {
    var r;
    const n = Rn(this.resource, yf);
    return Dt(
      (r = n == null ? void 0 : n.extension) == null ? void 0 : r.map((s) => {
        var a, o;
        return (o = (a = s.valueReference) == null ? void 0 : a.reference) == null ? void 0 : o.substring(7);
      })
    );
  }
  get preferredDischargeBinaryIds() {
    var s, a;
    const r = ((a = (s = Rn(this.resource, yf)) == null ? void 0 : s.extension) != null ? a : []).filter(
      (o) => {
        var c, l;
        return (l = (c = o.valueReference) == null ? void 0 : c.extension) == null ? void 0 : l.some(
          (d) => d.url === VF && d.valueBoolean === !0
        );
      }
    );
    return Dt(r.map((o) => {
      var c, l;
      return (l = (c = o.valueReference) == null ? void 0 : c.reference) == null ? void 0 : l.substring(7);
    }));
  }
  get title() {
    return `${this.dateDisplay} - ${this.class}`;
  }
}
const Gn = Ae`
  fragment Basic on Basic {
    id
    resourceType
    meta {
      lastUpdated
    }
    code {
      coding {
        code
        display
        system
      }
    }
    author {
      display
    }
  }
`, Xt = Ae`
  fragment Coding on Coding {
    code
    display
    system
    extension {
      url
      valueString
    }
  }
`, ZF = Ae`
  fragment Encounter on Encounter {
    id
    resourceType
    extension {
      url
      valueString
    }
    status
    priority {
      text
      coding {
        code
        display
        system
      }
    }
  }
`, Ha = Ae`
  fragment Practitioner on Practitioner {
    id
    resourceType
    extension {
      url
      valueString
    }
    name {
      family
      given
      prefix
      suffix
      text
      use
    }
    qualification {
      code {
        text
        coding {
          code
          display
          system
        }
      }
      period {
        start
        end
      }
    }
  }
`, KF = Ae`
  fragment ServiceRequest on ServiceRequest {
    id
    resourceType
    status
    intent
    subject {
      reference
    }
    identifier {
      system
      value
    }
    requester {
      reference
      identifier {
        system
        value
      }
      display
    }
    reasonCode {
      text
    }
    authoredOn
    category {
      text
    }
    performer {
      reference
      identifier {
        system
        value
      }
      display
    }
    locationReference {
      reference
      display
    }
  }
`, JF = Ae`
  fragment Appointment on Appointment {
    id
    resourceType
    status
    participant {
      actor {
        reference
        identifier {
          system
          value
        }
        display
      }
      status
    }
    basedOn {
      reference
    }
    start
    end
    serviceType {
      text
    }
    appointmentType {
      text
    }
    serviceCategory {
      text
    }
    specialty {
      text
    }
  }
`;
Ae`
  fragment MedicationRequest on MedicationRequest {
    id
    resourceType
    extension {
      url
      valueString
    }
    status
    intent
  }
`;
const Fr = Ae`
  fragment Patient on Patient {
    id
    resourceType
    meta {
      extension {
        url
        valueString
        valueInstant
      }
      tag {
        system
        code
      }
    }
    active
    identifier {
      use
      system
      value
    }
    contact {
      address {
        city
        country
        district
        line
        period {
          start
          end
        }
        postalCode
        state
        text
        type
        use
      }
      gender
      name {
        family
        given
        prefix
        suffix
        text
        use
      }
      organization {
        display
        identifier {
          value
        }
        type
      }
    }
    birthDate
    gender
    maritalStatus {
      text
      coding {
        code
        display
        system
      }
    }
    telecom {
      use
      value
      system
    }
    address {
      city
      country
      district
      line
      period {
        start
        end
      }
      postalCode
      state
      text
      type
      use
    }
    name {
      family
      given
      prefix
      suffix
      text
      use
    }
    managingOrganization {
      resource {
        ...Organization
      }
    }
  }
`, Wa = Ae`
  fragment Reference on Reference {
    id
    extension {
      url
      valueString
    }
    reference
    type
    identifier {
      id
      system
      value
    }
    display
  }
`, Qg = Ae`
  fragment Observation on Observation {
    id
    resourceType
    extension {
      url
      valueString
    }
    status
    category {
      text
      coding {
        code
        display
        system
        extension {
          url
          valueString
        }
      }
    }
    effectivePeriod {
      start
      end
    }
    effectiveDateTime
    referenceRange {
      text
    }
    code {
      text
      coding {
        code
        display
        system
        extension {
          url
          valueString
        }
      }
    }
    valueQuantity {
      comparator
      unit
      value
      system
      code
    }
    valueCodeableConcept {
      text
      coding {
        system
        code
        display
      }
    }
    valueString
    valueBoolean
    valueInteger
    valueRange {
      low {
        unit
        value
        system
        code
      }
      high {
        unit
        value
        system
        code
      }
    }
    valueRatio {
      numerator {
        comparator
        unit
        value
        system
        code
      }
      denominator {
        unit
        value
        system
        code
      }
    }
    valueTime
    valueDateTime
    valuePeriod {
      start
      end
    }
    interpretation {
      text
      coding {
        code
        display
        system
        extension {
          url
          valueString
        }
      }
    }
  }
`, Yn = Ae`
  fragment Organization on Organization {
    id
    resourceType
    extension {
      url
      valueString
    }
    name
    telecom {
      system
      value
      period {
        start
        end
      }
    }
    contact {
      purpose {
        text
        coding {
          code
          display
          system
          extension {
            url
            valueString
          }
        }
      }
      name {
        family
        given
        prefix
        suffix
        text
        use
      }
      telecom {
        system
        value
        period {
          start
          end
        }
      }
      address {
        type
        use
        text
        line
        city
        district
        state
        postalCode
        country
        period {
          start
          end
        }
      }
    }
  }
`, XF = Ae`
  ${Fr}
  ${Yn}

  query Patients(
    $upid: ID!
    $cursor: String!
    $sort: PatientSortParams!
    $first: Int!
    $filter: PatientFilterParams! = {}
  ) {
    PatientConnection(upid: $upid, after: $cursor, sort: $sort, first: $first, filter: $filter) {
      pageInfo {
        hasNextPage
      }
      edges {
        node {
          ...Patient
        }
      }
    }
  }
`, eB = Ae`
  ${Fr}
  ${Yn}

  query Patients(
    $builderID: ID!
    $cursor: String!
    $first: Int!
    $filter: PatientFilterParams! = {}
  ) {
    PatientConnection(
      builderID: $builderID
      after: $cursor
      first: $first
      filter: $filter
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          ...Patient
        }
      }
    }
  }
`;
function Un(e) {
  var t;
  return {
    type: "fqs",
    env: e.env,
    builderId: (t = e.contextBuilderId) != null ? t : e.builderId,
    authToken: e.authToken
  };
}
function br(e, t, n, r = !0) {
  return V(this, null, function* () {
    var l;
    const s = `${Kt(e.env, "fqs")}/rest`, a = new URLSearchParams(n), { data: o } = yield rt(`${s}/${t}?${a.toString()}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${e.authToken}`
      }
    }), c = ((l = o.entry) != null ? l : []).map((d) => d.resource);
    return r ? c.filter(
      (d) => {
        var u, h;
        return !((h = (u = d.meta) == null ? void 0 : u.tag) != null && h.some((f) => f.system === Ln));
      }
    ) : c;
  });
}
function tB(e, t, n) {
  return V(this, null, function* () {
    return br(e, t, X(R({}, n), {
      builderID: e.builderId
    }));
  });
}
function nB(e, t, n) {
  return V(this, null, function* () {
    const r = `${Kt(e.env, "fqs")}/rest`, { data: s } = yield rt(`${r}/${t}/${n}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${e.authToken}`
      }
    });
    return s;
  });
}
function Va(e, t) {
  const n = (a) => (o) => {
    const c = o[a];
    return !Cn(c) || !c ? 0 : new Date(c).getTime();
  }, r = [], s = [];
  return t.forEach((a) => {
    const { key: o, dir: c, isDate: l } = a;
    r.push((d) => Kc(d[o]), l ? n(o) : o), s.push("asc", c);
  }), nt(e, r, s);
}
function yn(e, t, n, r = !1) {
  const s = Cn(t) ? tg(t) : t;
  return r ? rB(e, s, n) : nt(e, t, n);
}
function rB(e, t, n) {
  return e.sort((r, s) => {
    const a = t(r), o = t(s);
    if (!a && !o)
      return 0;
    if (!a)
      return n === "asc" ? -1 : 1;
    if (!o)
      return n === "asc" ? 1 : -1;
    const c = new Date(a).getTime(), l = new Date(o).getTime();
    return n === "asc" ? c - l : l - c;
  }), e;
}
function Zg() {
  return Oe(
    F9,
    [],
    (e, t) => V(this, null, function* () {
      return Jg(e, t, {
        tag: {
          allmatch: [`${En}|builder/${e.builderId}`]
        }
      }).catch(() => [t]);
    })
  );
}
function Kg(e = { includeCurrentBuilder: !1 }) {
  const t = e.includeCurrentBuilder ? void 0 : (n) => ({
    tag: {
      nonematch: [`${En}|builder/${n.builderId}`]
    }
  });
  return Oe(
    e.includeCurrentBuilder ? q9 : V9,
    [],
    (n, r) => V(this, null, function* () {
      return Jg(n, r, t && t(n));
    })
  );
}
function Jg(r, s) {
  return V(this, arguments, function* (e, t, n = {}) {
    var d, u, h, f;
    const a = Re(e), o = (u = (d = n.tag) == null ? void 0 : d.allmatch) != null ? u : !1, { data: c } = yield dt(a, XF, {
      upid: t.UPID,
      cursor: "",
      first: jt,
      sort: {
        lastUpdated: "DESC"
      },
      filter: o ? n : X(R({}, n), {
        tag: X(R({}, n.tag), {
          nonematch: [yt, ...(f = (h = n.tag) == null ? void 0 : h.nonematch) != null ? f : []]
        })
      })
    });
    let l = c.PatientConnection.edges.map((p) => p.node);
    return o && (l = l.filter((p) => {
      var m, C;
      return !((C = (m = p.meta) == null ? void 0 : m.tag) != null && C.some((y) => y.system === Fa));
    })), l.filter(
      (p) => {
        var m, C;
        return !((C = (m = p.meta) == null ? void 0 : m.tag) != null && C.some(
          (y) => y.system === Fc && y.code === "universal"
        ));
      }
    ).map((p) => new zt(p));
  });
}
function il(e, t, n, r) {
  return V(this, null, function* () {
    var u;
    const s = {
      identifier: `${n}|${t}`,
      _count: "50"
    }, a = yield tB(Un(e), "Patient", s), o = gF(a, r);
    if (o.length === 0)
      throw new Error(
        `Failed to find patient information for patient from patientID ${t} with system ${n}`
      );
    const c = yn(o, "meta.lastUpdated", "desc", !0), l = (u = c.find((h) => {
      var f, p;
      return ((p = (f = h.name) == null ? void 0 : f.length) != null ? p : 0) > 0;
    })) != null ? u : c[0], d = new zt(l);
    return $e.setPatientUPID(d.UPID), d;
  });
}
function Xg(e, t) {
  return V(this, null, function* () {
    const n = yield nB(Un(e), "Patient", t), r = new zt(n);
    return $e.setPatientUPID(r.UPID), r;
  });
}
function sB(e, t) {
  return Jt(
    _g,
    [e, t],
    iB
  );
}
function aB(r) {
  return V(this, arguments, function* (e, t = [], n) {
    const [s] = t;
    if (!s)
      return [];
    const a = {
      _count: "100",
      builderID: e.builderId,
      [S9(s) ? "identifier" : "name"]: s
    };
    return (yield br(Un(e), "Patient", a, !0)).map((c) => new zt(c));
  });
}
function iB(n) {
  return V(this, arguments, function* (e, t = []) {
    const [r, s] = t, a = Re(e), { data: o } = yield dt(a, eB, {
      builderID: e.builderId,
      cursor: s,
      first: r,
      filter: {
        tag: {
          nonematch: ["https://zusapi.com/thirdparty/source", yt]
        }
      }
    });
    return {
      patients: o.PatientConnection.edges.map((l) => new zt(l.node)),
      pageInfo: o.PatientConnection.pageInfo
    };
  });
}
function Ui(e, t) {
  return Jt(
    G9,
    [e, t],
    (r) => V(this, null, function* () {
      const { data: s } = yield rt(`${Kt(r.env, "lens")}/jobs`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${r.authToken}`
        },
        body: JSON.stringify({
          upid: t,
          type: e
        }),
        mode: "cors"
      });
      return s;
    }),
    !!({
      conditions: !0,
      encounters: !0,
      medications: !0,
      transitions: !1
    }[e] && t)
  );
}
const oB = 1e3 * 60 * 5;
function sK({
  children: e,
  patientResourceID: t,
  patientUPID: n,
  patientID: r,
  systemURL: s,
  tags: a,
  onPatientSave: o,
  onResourceSave: c
}) {
  var u, h, f;
  const l = cB(
    n || r,
    n ? yr : s,
    t,
    a
  );
  dF(s, r), Ui("encounters", (u = l.data) == null ? void 0 : u.UPID), Ui("medications", (h = l.data) == null ? void 0 : h.UPID), Ui("conditions", (f = l.data) == null ? void 0 : f.UPID);
  const d = ke(
    () => ({
      patientResourceID: t,
      patientID: n || r,
      systemURL: n ? yr : s,
      tags: a,
      onPatientSave: o,
      onResourceSave: c,
      patient: l
    }),
    [
      t,
      r,
      n,
      s,
      a,
      o,
      c,
      l
    ]
  );
  return he(() => {
    r && s ? $e.setPatientID(r, s) : t && $e.setPatientID(t);
  }, [r, t, s]), /* @__PURE__ */ i.jsx(zm.Provider, { value: d, children: /* @__PURE__ */ i.jsx(pO, { children: e }) });
}
function Ze() {
  const e = tt(zm);
  if (!e)
    throw new Error("usePatient must be used within a PatientProvider");
  return e;
}
function cB(e, t, n, r) {
  return Jt(
    Jc,
    [n, e, t, r],
    (s) => lB(s, n, t, e, r),
    !!e || !!n,
    oB
  );
}
function lB(e, t, n, r, s) {
  return V(this, null, function* () {
    const a = n && r ? `${n}|${r}` : t;
    try {
      let o;
      if (n && r)
        o = yield Zc(
          () => il(e, r, n, s),
          5,
          2e3
        );
      else if (t)
        o = yield Xg(e, t);
      else
        throw new Error(
          "Must specify a patient ID and system URL or a patient FHIR resource ID to retrieve a patient."
        );
      return o.active === !1 && $e.logger.warn(`User accessing inactive patient: ${a}`), o;
    } catch (o) {
      const c = `Failed to get patient with ID ${a}`;
      throw $e.logError(o instanceof Error ? o : new Error(c), c), o;
    }
  });
}
function dB() {
  const { patientResourceID: e, patientID: t, systemURL: n, tags: r } = Ze(), s = vt(
    (a) => V(this, null, function* () {
      const o = n && t ? `${n}|${t}` : e;
      try {
        let c;
        if (n && t)
          c = yield il(
            a,
            t,
            n,
            r
          );
        else if (e)
          c = yield Xg(a, e);
        else
          throw new Error(
            "Must specify a patient ID and system URL or a patient FHIR resource ID to retrieve a patient."
          );
        return c.active === !1 && $e.logger.warn(`User accessing inactive patient: ${o}`), c;
      } catch (c) {
        const l = `Failed to get patient with ID ${o}`;
        throw $e.logError(c instanceof Error ? c : new Error(l), l), c;
      }
    }),
    [e, t, n, r]
  );
  return { patientResourceID: e, patientID: t, systemURL: n, tags: r, getPatient: s };
}
function aK(e) {
  const { getRequestContext: t } = Xe(), n = Ze(), { onPatientSave: r } = n;
  return vt(
    (s) => V(this, null, function* () {
      if (e)
        return r ? r(s) : hF(e, s, t);
      throw new Error("onPatientSave requires a patient");
    }),
    [r, e, t]
  );
}
function uB(e, t, n, r = !0) {
  var o, c;
  const { getRequestContext: s } = Xe(), { patient: a } = Ze();
  if (a.isSuccess && !a.data.UPID) {
    const l = a.data.resource.identifier;
    throw $e.logger.error("Patient does not have a UPID", { patientID: l }), new Error(`Patient with ID ${JSON.stringify(l)} does not have a UPID`);
  }
  return mh({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: [e, (o = a.data) == null ? void 0 : o.UPID, ...t],
    queryFn: () => V(this, null, function* () {
      const l = yield s();
      return n(l, a.data, t);
    }),
    enabled: !!((c = a.data) != null && c.UPID) && r
  });
}
function Oe(e, t, n, r = !0) {
  return uB(
    e,
    t,
    Yc(n, "query_request_timing", [`query_key:${e}`]),
    r
  );
}
const e0 = Ct({});
function t0() {
  return {
    Telemetry: $e,
    context: tt(e0)
  };
}
function Be() {
  var r;
  const e = tt(Fm), t = t0(), { patient: n } = Ze();
  return ke(
    () => ({
      // Helper to include patient UPID and optionally also the component name
      // with metadata when tracking interactions
      trackInteraction(s, a = {}) {
        var u;
        const d = a, { customMetadata: o = {} } = d, c = ct(d, ["customMetadata"]), l = R(R({}, o), c);
        return e.componentName && (l.componentName = e.componentName), (u = n.data) != null && u.UPID && (l.upid = n.data.UPID), t.Telemetry.trackInteraction(s, l);
      },
      analyticsEvent(s, a = {}) {
        return t.Telemetry.analyticsEvent(s, a);
      }
    }),
    [e.componentName, (r = n.data) == null ? void 0 : r.UPID, t.Telemetry]
  );
}
const fB = ({ title: e, humanReadable: t, id: n, isEmpty: r }) => {
  if (!t)
    return null;
  const a = Ch.sanitize(W6(t)).replace(/Â&nbsp;/g, " ");
  return /* @__PURE__ */ i.jsx(
    n0,
    {
      title: e,
      id: n,
      tableOfContentsId: _c,
      overrideDefaultHidden: r,
      children: /* @__PURE__ */ i.jsx(Nh, { content: a })
    }
  );
}, n0 = ({
  children: e,
  id: t,
  title: n,
  tableOfContentsId: r,
  overrideDefaultHidden: s
}) => {
  const [a, o] = Y(s), c = Te(null), l = wt(c), d = go(r), u = go(Ic), { trackInteraction: h } = Be(), f = () => {
    o(!a), h("toggle_document_section", {
      action: a ? "collapse_document_section" : "expand_document_section"
    });
  };
  return /* @__PURE__ */ i.jsxs("div", { className: "ctw-ccda-section-container", id: t, ref: c, children: [
    /* @__PURE__ */ i.jsxs(
      "div",
      {
        className: "ctw-ccda-section-header-wrapper",
        style: { top: l.md ? u : u + d },
        children: [
          /* @__PURE__ */ i.jsxs("button", { type: "button", className: "ctw-ccda-section-arrow", onClick: f, children: [
            /* @__PURE__ */ i.jsx("span", { className: "ctw-hidden", children: "hide" }),
            /* @__PURE__ */ i.jsx(
              me,
              {
                icon: jr,
                className: W("ctw-ml-auto ctw-w-4", { "ctw-transform ctw-rotate-[270deg]": a })
              }
            )
          ] }),
          /* @__PURE__ */ i.jsx("h3", { className: "ctw-text-sm ctw-uppercase", children: n })
        ]
      }
    ),
    !a && /* @__PURE__ */ i.jsx("div", { className: "ctw-section-display", children: e })
  ] });
}, hB = (e) => `<div xmlns="http://www.w3.org/1999/xhtml">${e}</div>`, Br = (e) => {
  const t = k.select("child::node()", e), n = t.map(
    (s) => k.select1("string(name())", s)
  ).filter(Boolean), r = t;
  return n.length !== 0 ? r.map(r0).join("") : "";
}, r0 = (e) => {
  switch (k.select1("string(name())", e)) {
    case "br":
      return "<br />";
    case "caption":
      return yB(e);
    case "content":
      return vB(e);
    case "list":
      return wB(e);
    case "paragraph":
      return gB(e);
    case "table":
      return pB(e);
    case "":
      return Qn(e);
    default:
      return;
  }
}, pB = (e) => {
  if (!e)
    return "";
  const t = k.select1("*[name()='thead']", e), n = k.select1("*[name()='tbody']", e), r = [];
  if (t) {
    const s = xB(t);
    s && r.push(s);
  }
  if (n) {
    const s = bB(n);
    s && r.push(s);
  }
  if (r.length > 0)
    return `<table>${r.join("")}</table>`;
}, mB = (e) => {
  if (!e)
    return "";
  const t = Br(e);
  if (t)
    return `<td>${t}</td>`;
  const n = Qn(e);
  if (n)
    return `<td>${n}</td>`;
}, Qn = (e) => e && k.select1("string()", e).trim().replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/&/g, "&amp;") || "", gB = (e) => {
  if (!e)
    return "";
  const t = Br(e);
  if (t)
    return `<p>${t}</p>`;
  const n = Qn(e);
  if (n)
    return `<p>${n}</p>`;
}, wB = (e) => {
  if (!e)
    return "";
  const t = k.select1("string(@listType)", e), r = k.select("*[name()='item']", e).map((s) => {
    const a = Br(s);
    if (a)
      return `<li>${a}</li>`;
    const o = Qn(s);
    if (o)
      return `<li>${o}</li>`;
  }).join("");
  return t === "ordered" ? `<ol>${r}</ol>` : `<ul>${r}</ul>`;
}, vB = (e) => {
  if (!e)
    return;
  const t = Br(e);
  if (t)
    return t;
  const n = Qn(e);
  if (n)
    return `<span>${n}</span>`;
}, yB = (e) => {
  if (!e)
    return;
  const t = Br(e);
  if (t)
    return t;
  const n = Qn(e);
  if (n)
    return `<h2>${n}</h2>`;
}, xB = (e) => {
  if (!e)
    return "";
  const t = k.select1("*[name()='tr']", e);
  if (t) {
    const n = s0(t);
    if (n)
      return `<thead>${n}</thead>`;
  }
}, bB = (e) => {
  if (!e)
    return "";
  const t = k.select("*[name()='tr']", e);
  if (t.length > 0) {
    const n = t.map(
      (r) => s0(r)
    );
    if (n.length > 0)
      return `<tbody>${n.join("")}</tbody>`;
  }
}, jB = (e) => {
  if (!e)
    return "";
  const t = Br(e);
  if (t)
    return `<th>${t}</th>`;
  const n = Qn(e);
  if (n)
    return `<th>${n}</th>`;
}, s0 = (e) => {
  if (!e)
    return "";
  const t = k.select("*[name()='th']", e);
  if (t.length > 0)
    return `<tr>${t.map((s) => jB(s)).join("")}</tr>`;
  const n = k.select("*[name()='td']", e);
  if (n.length > 0)
    return `<tr>${n.map((s) => mB(s)).join("")}</tr>`;
}, CB = (e) => {
  const t = k.select1("*[name()='text']", e);
  if (!t)
    return;
  const n = k.select("child::node()", t);
  if (xe(n))
    return;
  const r = n.map(r0).filter(Boolean).join("");
  return {
    status: "generated",
    div: hB(r)
  };
};
function NB(e, t) {
  return /* @__PURE__ */ De.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: t
  }, e), /* @__PURE__ */ De.createElement("path", {
    fillRule: "evenodd",
    d: "M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z",
    clipRule: "evenodd"
  }));
}
const DB = De.forwardRef(NB), SB = DB;
function $B(e, t) {
  return /* @__PURE__ */ De.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: t
  }, e), /* @__PURE__ */ De.createElement("path", {
    fillRule: "evenodd",
    d: "M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z",
    clipRule: "evenodd"
  }));
}
const AB = De.forwardRef($B), EB = AB;
function IB(e, t) {
  return /* @__PURE__ */ De.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: t
  }, e), /* @__PURE__ */ De.createElement("path", {
    fillRule: "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z",
    clipRule: "evenodd"
  }));
}
const _B = De.forwardRef(IB), cs = _B;
function TB(e, t) {
  return /* @__PURE__ */ De.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: t
  }, e), /* @__PURE__ */ De.createElement("path", {
    fillRule: "evenodd",
    d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
    clipRule: "evenodd"
  }));
}
const RB = De.forwardRef(TB), MB = RB;
function PB(e, t) {
  return /* @__PURE__ */ De.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: t
  }, e), /* @__PURE__ */ De.createElement("path", {
    fillRule: "evenodd",
    d: "M12.395 2.553a1 1 0 00-1.45-.385c-.345.23-.614.558-.822.88-.214.33-.403.713-.57 1.116-.334.804-.614 1.768-.84 2.734a31.365 31.365 0 00-.613 3.58 2.64 2.64 0 01-.945-1.067c-.328-.68-.398-1.534-.398-2.654A1 1 0 005.05 6.05 6.981 6.981 0 003 11a7 7 0 1011.95-4.95c-.592-.591-.98-.985-1.348-1.467-.363-.476-.724-1.063-1.207-2.03zM12.12 15.12A3 3 0 017 13s.879.5 2.5.5c0-1 .5-4 1.25-4.5.5 1 .786 1.293 1.371 1.879A2.99 2.99 0 0113 13a2.99 2.99 0 01-.879 2.121z",
    clipRule: "evenodd"
  }));
}
const OB = De.forwardRef(PB), kB = OB;
function LB(e, t) {
  return /* @__PURE__ */ De.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: t
  }, e), /* @__PURE__ */ De.createElement("path", {
    fillRule: "evenodd",
    d: "M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z",
    clipRule: "evenodd"
  }));
}
const FB = De.forwardRef(LB), BB = FB;
function UB(e, t) {
  return /* @__PURE__ */ De.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: t
  }, e), /* @__PURE__ */ De.createElement("path", {
    fillRule: "evenodd",
    d: "M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z",
    clipRule: "evenodd"
  }));
}
const zB = De.forwardRef(UB), HB = zB;
function WB(e, t) {
  return /* @__PURE__ */ De.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: t
  }, e), /* @__PURE__ */ De.createElement("path", {
    fillRule: "evenodd",
    d: "M5 2a1 1 0 011 1v1h1a1 1 0 010 2H6v1a1 1 0 01-2 0V6H3a1 1 0 010-2h1V3a1 1 0 011-1zm0 10a1 1 0 011 1v1h1a1 1 0 110 2H6v1a1 1 0 11-2 0v-1H3a1 1 0 110-2h1v-1a1 1 0 011-1zM12 2a1 1 0 01.967.744L14.146 7.2 17.5 9.134a1 1 0 010 1.732l-3.354 1.935-1.18 4.455a1 1 0 01-1.933 0L9.854 12.8 6.5 10.866a1 1 0 010-1.732l3.354-1.935 1.18-4.455A1 1 0 0112 2z",
    clipRule: "evenodd"
  }));
}
const VB = De.forwardRef(WB), a0 = VB;
function qB() {
  const { getRequestContext: e } = Xe(), [t, n] = Y(null);
  return he(() => {
    function r() {
      return V(this, null, function* () {
        const s = yield e(), a = mn(s.authToken);
        n({
          builderId: a[Wc],
          builderName: a[Dg],
          email: a[Vc],
          userId: a.sub
        });
      });
    }
    r();
  }, [e]), t;
}
const GB = "https://share.hsforms.com/10NmAPiu7Qd2OXbxAHnseiwcjai8", ol = ({
  buttonText: e,
  className: t = "ctw-link ctw-text-sm"
}) => {
  const { patient: n } = Ze(), r = qB(), s = new URLSearchParams();
  return n.data && n.data.id && n.data.UPID && (s.append("patientid", n.data.id), s.append("upid", n.data.UPID)), r && (s.append("builderid", r.builderId), s.append("buildername", r.builderName), s.append("email", r.email), s.append("userid", r.userId)), /* @__PURE__ */ i.jsx(
    "a",
    {
      href: `${GB}?${s.toString()}`,
      className: t,
      target: "_blank",
      rel: "noreferrer noopener",
      children: e
    }
  );
}, Nn = ({
  icon: e,
  title: t,
  message: n,
  titleSize: r = "xl",
  containerSpacing: s = "xl"
}) => {
  const a = { lg: "ctw-text-lg", xl: "ctw-text-xl" }[r], o = { sm: "ctw-space-y-1", xl: "ctw-space-y-6" }[s], c = { sm: "ctw-space-y-1", xl: "ctw-space-y-3" }[s];
  return /* @__PURE__ */ i.jsxs("div", { className: o, children: [
    /* @__PURE__ */ i.jsx("div", { className: "ctw-flex ctw-justify-center", children: e }),
    /* @__PURE__ */ i.jsxs("div", { className: W(c, "ctw-text-center ctw-text-base"), children: [
      /* @__PURE__ */ i.jsx("div", { className: W(a, "ctw-font-medium"), children: t }),
      /* @__PURE__ */ i.jsxs("div", { children: [
        n && /* @__PURE__ */ i.jsx("span", { children: n }),
        /* @__PURE__ */ i.jsxs("div", { children: [
          /* @__PURE__ */ i.jsx("span", { children: "If this problem persists " }),
          /* @__PURE__ */ i.jsx(ol, { buttonText: "contact support", className: "ctw-text-base ctw-link" }),
          "."
        ] })
      ] })
    ] })
  ] });
};
class YB extends nh {
  constructor() {
    super(...arguments);
    ne(this, "state", {
      hasError: !1
    });
  }
  static getDerivedStateFromError(n) {
    return { hasError: !0, error: n };
  }
  componentDidMount() {
    const { props: n } = this;
    n.name && $e.logger.info(`Loaded component ${n.name}`);
  }
  componentDidCatch(n, r) {
    const { props: s } = this;
    $e.logger.error(
      `Component failed to load: ${s.name}`,
      mo(X(R({}, r), {
        componentName: s.name,
        error: n
      }))
    );
  }
  render() {
    const { state: n, props: r } = this;
    return n.hasError ? /* @__PURE__ */ i.jsx("div", { className: "ctw-py-3", children: /* @__PURE__ */ i.jsx(
      Nn,
      {
        title: "An unexpected error occurred",
        message: "Try reloading the ZAP.",
        icon: /* @__PURE__ */ i.jsx(cs, { className: "ctw-h-16 ctw-text-content-light" })
      }
    ) }) : r.children;
  }
}
function He(e, t) {
  const n = va(
    (r, s) => gr(YB, { name: t }, gr(e, X(R({}, r), { ref: s })))
  );
  return n.displayName = `withErrorBoundary(${t})`, n;
}
const QB = [
  "Progress Notes",
  "Patient Instructions",
  "ED Notes",
  "Discharge Instructions",
  "H&P Notes",
  "Consult Notes",
  "Miscellaneous Notes"
], ZB = ({
  document: e,
  overridePatient: t
}) => {
  const r = k.select(
    "//*[name()='component']/*[name()='section']",
    e
  ).map((s, a) => {
    const o = String(k.select1("string(*[name()='title'])", s));
    let c = !1;
    const l = `${o}-${a}`;
    let d = k.select1("*[name()='text']", s);
    const u = d == null ? void 0 : d.textContent;
    if (u && u.length < 500 && (c = zg.some(
      (h) => u.length < 500 && u.toLowerCase().includes(h)
    )), QB.includes(o)) {
      const h = CB(s);
      if (!h)
        return { title: o, humanReadable: d, id: l, isEmpty: c };
      d = h.div;
    }
    return { title: o, humanReadable: d, id: l, isEmpty: c };
  });
  return /* @__PURE__ */ i.jsxs("div", { className: "print:ctw-min-h-full print:ctw-overflow-auto", id: "ccda-viewer", children: [
    /* @__PURE__ */ i.jsx(sO, { document: e, sections: r, overridePatient: t }),
    /* @__PURE__ */ i.jsx("div", { className: "ctw-flex ctw-flex-col", children: r.map(({ title: s, humanReadable: a, id: o, isEmpty: c }) => /* @__PURE__ */ i.jsx(
      fB,
      {
        title: s,
        id: o,
        humanReadable: a,
        isEmpty: c
      },
      `el-text-${o}`
    )) }),
    /* @__PURE__ */ i.jsx(
      n0,
      {
        title: "Demographic Details",
        id: "demographic-details",
        tableOfContentsId: _c,
        children: /* @__PURE__ */ i.jsx(P7, { document: e })
      }
    )
  ] });
}, KB = He(ZB);
var Ws = {};
function Et() {
  (typeof process == "undefined" || process.env.NODE_ENV == "development") && console.log.apply(console, arguments);
}
(function(e) {
  (function() {
    var t = function() {
      function a(o) {
        this.message = "JPEG error: " + o;
      }
      return a.prototype = new Error(), a.prototype.name = "JpegError", a.constructor = a, a;
    }(), n = function() {
      var a = new Uint8Array([
        0,
        1,
        8,
        16,
        9,
        2,
        3,
        10,
        17,
        24,
        32,
        25,
        18,
        11,
        4,
        5,
        12,
        19,
        26,
        33,
        40,
        48,
        41,
        34,
        27,
        20,
        13,
        6,
        7,
        14,
        21,
        28,
        35,
        42,
        49,
        56,
        57,
        50,
        43,
        36,
        29,
        22,
        15,
        23,
        30,
        37,
        44,
        51,
        58,
        59,
        52,
        45,
        38,
        31,
        39,
        46,
        53,
        60,
        61,
        54,
        47,
        55,
        62,
        63
      ]), o = 4017, c = 799, l = 3406, d = 2276, u = 1567, h = 3784, f = 5793, p = 2896;
      function m(N) {
        N == null && (N = {}), N.w == null && (N.w = -1), this.V = N.n, this.N = N.w;
      }
      function C(N, v) {
        for (var b = 0, j = [], D, $, _ = 16, L; _ > 0 && !N[_ - 1]; )
          _--;
        j.push({ children: [], index: 0 });
        var I = j[0];
        for (D = 0; D < _; D++) {
          for ($ = 0; $ < N[D]; $++) {
            for (I = j.pop(), I.children[I.index] = v[b]; I.index > 0; )
              I = j.pop();
            for (I.index++, j.push(I); j.length <= D; )
              j.push(L = { children: [], index: 0 }), I.children[I.index] = L.children, I = L;
            b++;
          }
          D + 1 < _ && (j.push(L = { children: [], index: 0 }), I.children[I.index] = L.children, I = L);
        }
        return j[0].children;
      }
      function y(N, v, b) {
        return 64 * ((N.P + 1) * v + b);
      }
      function g(N, v, b, j, D, $, _, L, I, A) {
        A == null && (A = !1);
        var M = b.m, G = b.Z, Z = v, Q = 0, T = 0, P = 0, E = 0, z, H = 0, te, q, B, F, U, J, fe = 0, re, ce, ge, we;
        function ue() {
          if (T > 0)
            return T--, Q >> T & 1;
          if (Q = N[v++], Q === 255) {
            var ie = N[v++];
            if (ie) {
              if (ie === 220 && A) {
                v += 2;
                var be = r(N, v);
                if (v += 2, be > 0 && be !== b.s)
                  throw new DNLMarkerError(
                    "Found DNL marker (0xFFDC) while parsing scan data",
                    be
                  );
              } else if (ie === 217) {
                if (A) {
                  var _e = H * 8;
                  if (_e > 0 && _e < b.s / 10)
                    throw new DNLMarkerError(
                      "Found EOI marker (0xFFD9) while parsing scan data, possibly caused by incorrect `scanLines` parameter",
                      _e
                    );
                }
                throw new EOIMarkerError("Found EOI marker (0xFFD9) while parsing scan data");
              }
              throw new t("unexpected marker");
            }
          }
          return T = 7, Q >>> 7;
        }
        function pe(ie) {
          for (var be = ie; ; ) {
            switch (be = be[ue()], typeof be) {
              case "number":
                return be;
              case "object":
                continue;
            }
            throw new t("invalid huffman sequence");
          }
        }
        function le(ie) {
          for (var be = 0; ie > 0; )
            be = be << 1 | ue(), ie--;
          return be;
        }
        function de(ie) {
          if (ie === 1)
            return ue() === 1 ? 1 : -1;
          var be = le(ie);
          return be >= 1 << ie - 1 ? be : be + (-1 << ie) + 1;
        }
        function Me(ie, be) {
          var _e = pe(ie.J), O = _e === 0 ? 0 : de(_e), K = 1;
          for (ie.D[be] = ie.Q += O; K < 64; ) {
            var ee = pe(ie.i), ae = ee & 15, se = ee >> 4;
            if (ae === 0) {
              if (se < 15)
                break;
              K += 16;
              continue;
            }
            K += se;
            var je = a[K];
            ie.D[be + je] = de(ae), K++;
          }
        }
        function Ye(ie, be) {
          var _e = pe(ie.J), O = _e === 0 ? 0 : de(_e) << I;
          ie.D[be] = ie.Q += O;
        }
        function Ke(ie, be) {
          ie.D[be] |= ue() << I;
        }
        function at(ie, be) {
          if (P > 0) {
            P--;
            return;
          }
          for (var _e = $, O = _; _e <= O; ) {
            var K = pe(ie.i), ee = K & 15, ae = K >> 4;
            if (ee === 0) {
              if (ae < 15) {
                P = le(ae) + (1 << ae) - 1;
                break;
              }
              _e += 16;
              continue;
            }
            _e += ae;
            var se = a[_e];
            ie.D[be + se] = de(ee) * (1 << I), _e++;
          }
        }
        function Ne(ie, be) {
          for (var _e = $, O = _, K = 0, ee, ae; _e <= O; ) {
            var se = be + a[_e], je = ie.D[se] < 0 ? -1 : 1;
            switch (E) {
              case 0:
                if (ae = pe(ie.i), ee = ae & 15, K = ae >> 4, ee === 0)
                  K < 15 ? (P = le(K) + (1 << K), E = 4) : (K = 16, E = 1);
                else {
                  if (ee !== 1)
                    throw new t("invalid ACn encoding");
                  z = de(ee), E = K ? 2 : 3;
                }
                continue;
              case 1:
              case 2:
                ie.D[se] ? ie.D[se] += je * (ue() << I) : (K--, K === 0 && (E = E === 2 ? 3 : 0));
                break;
              case 3:
                ie.D[se] ? ie.D[se] += je * (ue() << I) : (ie.D[se] = z << I, E = 0);
                break;
              case 4:
                ie.D[se] && (ie.D[se] += je * (ue() << I));
                break;
            }
            _e++;
          }
          E === 4 && (P--, P === 0 && (E = 0));
        }
        function ze(ie, be, _e, O, K) {
          var ee = _e / M | 0, ae = _e % M;
          H = ee * ie.A + O;
          var se = ae * ie.h + K, je = y(ie, H, se);
          be(ie, je);
        }
        function bt(ie, be, _e) {
          H = _e / ie.P | 0;
          var O = _e % ie.P, K = y(ie, H, O);
          be(ie, K);
        }
        var it = j.length;
        for (G ? $ === 0 ? J = L === 0 ? Ye : Ke : J = L === 0 ? at : Ne : J = Me, it === 1 ? ce = j[0].P * j[0].c : ce = M * b.R; fe <= ce; ) {
          var Vt = D ? Math.min(ce - fe, D) : ce;
          if (Vt > 0) {
            for (q = 0; q < it; q++)
              j[q].Q = 0;
            if (P = 0, it === 1)
              for (te = j[0], U = 0; U < Vt; U++)
                bt(te, J, fe), fe++;
            else
              for (U = 0; U < Vt; U++) {
                for (q = 0; q < it; q++)
                  for (te = j[q], ge = te.h, we = te.A, B = 0; B < we; B++)
                    for (F = 0; F < ge; F++)
                      ze(te, J, fe, B, F);
                fe++;
              }
          }
          if (T = 0, re = S(N, v), !re)
            break;
          if (re.u && (v = re.offset), re.M >= 65488 && re.M <= 65495)
            v += 2;
          else
            break;
        }
        return v - Z;
      }
      function w(N, v, b) {
        var j = N.$, D = N.D, $, _, L, I, A, M, G, Z, Q, T, P, E, z, H, te, q, B;
        if (!j)
          throw new t("missing required Quantization Table.");
        for (var F = 0; F < 64; F += 8) {
          if (Q = D[v + F], T = D[v + F + 1], P = D[v + F + 2], E = D[v + F + 3], z = D[v + F + 4], H = D[v + F + 5], te = D[v + F + 6], q = D[v + F + 7], Q *= j[F], !(T | P | E | z | H | te | q)) {
            B = f * Q + 512 >> 10, b[F] = B, b[F + 1] = B, b[F + 2] = B, b[F + 3] = B, b[F + 4] = B, b[F + 5] = B, b[F + 6] = B, b[F + 7] = B;
            continue;
          }
          T *= j[F + 1], P *= j[F + 2], E *= j[F + 3], z *= j[F + 4], H *= j[F + 5], te *= j[F + 6], q *= j[F + 7], $ = f * Q + 128 >> 8, _ = f * z + 128 >> 8, L = P, I = te, A = p * (T - q) + 128 >> 8, Z = p * (T + q) + 128 >> 8, M = E << 4, G = H << 4, $ = $ + _ + 1 >> 1, _ = $ - _, B = L * h + I * u + 128 >> 8, L = L * u - I * h + 128 >> 8, I = B, A = A + G + 1 >> 1, G = A - G, Z = Z + M + 1 >> 1, M = Z - M, $ = $ + I + 1 >> 1, I = $ - I, _ = _ + L + 1 >> 1, L = _ - L, B = A * d + Z * l + 2048 >> 12, A = A * l - Z * d + 2048 >> 12, Z = B, B = M * c + G * o + 2048 >> 12, M = M * o - G * c + 2048 >> 12, G = B, b[F] = $ + Z, b[F + 7] = $ - Z, b[F + 1] = _ + G, b[F + 6] = _ - G, b[F + 2] = L + M, b[F + 5] = L - M, b[F + 3] = I + A, b[F + 4] = I - A;
        }
        for (var U = 0; U < 8; ++U) {
          if (Q = b[U], T = b[U + 8], P = b[U + 16], E = b[U + 24], z = b[U + 32], H = b[U + 40], te = b[U + 48], q = b[U + 56], !(T | P | E | z | H | te | q)) {
            B = f * Q + 8192 >> 14, B < -2040 ? B = 0 : B >= 2024 ? B = 255 : B = B + 2056 >> 4, D[v + U] = B, D[v + U + 8] = B, D[v + U + 16] = B, D[v + U + 24] = B, D[v + U + 32] = B, D[v + U + 40] = B, D[v + U + 48] = B, D[v + U + 56] = B;
            continue;
          }
          $ = f * Q + 2048 >> 12, _ = f * z + 2048 >> 12, L = P, I = te, A = p * (T - q) + 2048 >> 12, Z = p * (T + q) + 2048 >> 12, M = E, G = H, $ = ($ + _ + 1 >> 1) + 4112, _ = $ - _, B = L * h + I * u + 2048 >> 12, L = L * u - I * h + 2048 >> 12, I = B, A = A + G + 1 >> 1, G = A - G, Z = Z + M + 1 >> 1, M = Z - M, $ = $ + I + 1 >> 1, I = $ - I, _ = _ + L + 1 >> 1, L = _ - L, B = A * d + Z * l + 2048 >> 12, A = A * l - Z * d + 2048 >> 12, Z = B, B = M * c + G * o + 2048 >> 12, M = M * o - G * c + 2048 >> 12, G = B, Q = $ + Z, q = $ - Z, T = _ + G, te = _ - G, P = L + M, H = L - M, E = I + A, z = I - A, Q < 16 ? Q = 0 : Q >= 4080 ? Q = 255 : Q >>= 4, T < 16 ? T = 0 : T >= 4080 ? T = 255 : T >>= 4, P < 16 ? P = 0 : P >= 4080 ? P = 255 : P >>= 4, E < 16 ? E = 0 : E >= 4080 ? E = 255 : E >>= 4, z < 16 ? z = 0 : z >= 4080 ? z = 255 : z >>= 4, H < 16 ? H = 0 : H >= 4080 ? H = 255 : H >>= 4, te < 16 ? te = 0 : te >= 4080 ? te = 255 : te >>= 4, q < 16 ? q = 0 : q >= 4080 ? q = 255 : q >>= 4, D[v + U] = Q, D[v + U + 8] = T, D[v + U + 16] = P, D[v + U + 24] = E, D[v + U + 32] = z, D[v + U + 40] = H, D[v + U + 48] = te, D[v + U + 56] = q;
        }
      }
      function x(N, v) {
        for (var b = v.P, j = v.c, D = new Int16Array(64), $ = 0; $ < j; $++)
          for (var _ = 0; _ < b; _++) {
            var L = y(v, $, _);
            w(v, L, D);
          }
        return v.D;
      }
      function S(N, v, b) {
        b == null && (b = v);
        var j = N.length - 1, D = b < v ? b : v;
        if (v >= j)
          return null;
        var $ = r(N, v);
        if ($ >= 65472 && $ <= 65534)
          return { u: null, M: $, offset: v };
        for (var _ = r(N, D); !(_ >= 65472 && _ <= 65534); ) {
          if (++D >= j)
            return null;
          _ = r(N, D);
        }
        return { u: $.toString(16), M: _, offset: D };
      }
      return m.prototype = {
        parse(N, v) {
          v == null && (v = {});
          var b = v.F, j = 0, D = null, $ = null, _, L, I = 0;
          function A() {
            var se = r(N, j);
            j += 2;
            var je = j + se - 2, Se = S(N, je, j);
            Se && Se.u && (je = Se.offset);
            var ve = N.subarray(j, je);
            return j += ve.length, ve;
          }
          function M(se) {
            for (var je = Math.ceil(se.o / 8 / se.X), Se = Math.ceil(se.s / 8 / se.B), ve = 0; ve < se.W.length; ve++) {
              Ne = se.W[ve];
              var ot = Math.ceil(Math.ceil(se.o / 8) * Ne.h / se.X), Nt = Math.ceil(Math.ceil(se.s / 8) * Ne.A / se.B), Mt = je * Ne.h, en = Se * Ne.A, Tn = 64 * en * (Mt + 1);
              Ne.D = new Int16Array(Tn), Ne.P = ot, Ne.c = Nt;
            }
            se.m = je, se.R = Se;
          }
          var G = [], Z = [], Q = [], T = r(N, j);
          if (j += 2, T !== 65496)
            throw new t("SOI not found");
          T = r(N, j), j += 2;
          e:
            for (; T !== 65497; ) {
              var P, E, z;
              switch (T) {
                case 65504:
                case 65505:
                case 65506:
                case 65507:
                case 65508:
                case 65509:
                case 65510:
                case 65511:
                case 65512:
                case 65513:
                case 65514:
                case 65515:
                case 65516:
                case 65517:
                case 65518:
                case 65519:
                case 65534:
                  var H = A();
                  T === 65504 && H[0] === 74 && H[1] === 70 && H[2] === 73 && H[3] === 70 && H[4] === 0 && (D = {
                    version: { d: H[5], T: H[6] },
                    K: H[7],
                    j: H[8] << 8 | H[9],
                    H: H[10] << 8 | H[11],
                    S: H[12],
                    I: H[13],
                    C: H.subarray(14, 14 + 3 * H[12] * H[13])
                  }), T === 65518 && H[0] === 65 && H[1] === 100 && H[2] === 111 && H[3] === 98 && H[4] === 101 && ($ = {
                    version: H[5] << 8 | H[6],
                    k: H[7] << 8 | H[8],
                    q: H[9] << 8 | H[10],
                    a: H[11]
                  });
                  break;
                case 65499:
                  var te = r(N, j), q;
                  j += 2;
                  for (var B = te + j - 2; j < B; ) {
                    var F = N[j++], U = new Uint16Array(64);
                    if (F >> 4)
                      if (F >> 4 === 1)
                        for (E = 0; E < 64; E++)
                          q = a[E], U[q] = r(N, j), j += 2;
                      else
                        throw new t("DQT - invalid table spec");
                    else
                      for (E = 0; E < 64; E++)
                        q = a[E], U[q] = N[j++];
                    G[F & 15] = U;
                  }
                  break;
                case 65472:
                case 65473:
                case 65474:
                  if (_)
                    throw new t("Only single frame JPEGs supported");
                  j += 2, _ = {}, _.G = T === 65473, _.Z = T === 65474, _.precision = N[j++];
                  var J = r(N, j), fe, re = 0, ce = 0;
                  j += 2, _.s = b || J, _.o = r(N, j), j += 2, _.W = [], _._ = {};
                  var ge = N[j++];
                  for (P = 0; P < ge; P++) {
                    fe = N[j];
                    var we = N[j + 1] >> 4, ue = N[j + 1] & 15;
                    re < we && (re = we), ce < ue && (ce = ue);
                    var pe = N[j + 2];
                    z = _.W.push({ h: we, A: ue, L: pe, $: null }), _._[fe] = z - 1, j += 3;
                  }
                  _.X = re, _.B = ce, M(_);
                  break;
                case 65476:
                  var le = r(N, j);
                  for (j += 2, P = 2; P < le; ) {
                    var de = N[j++], Me = new Uint8Array(16), Ye = 0;
                    for (E = 0; E < 16; E++, j++)
                      Ye += Me[E] = N[j];
                    var Ke = new Uint8Array(Ye);
                    for (E = 0; E < Ye; E++, j++)
                      Ke[E] = N[j];
                    P += 17 + Ye, (de >> 4 ? Z : Q)[de & 15] = C(Me, Ke);
                  }
                  break;
                case 65501:
                  j += 2, L = r(N, j), j += 2;
                  break;
                case 65498:
                  var at = ++I === 1 && !b, Ne;
                  j += 2;
                  var ze = N[j++], bt = [];
                  for (P = 0; P < ze; P++) {
                    var it = N[j++], Vt = _._[it];
                    Ne = _.W[Vt], Ne.index = it;
                    var ie = N[j++];
                    Ne.J = Q[ie >> 4], Ne.i = Z[ie & 15], bt.push(Ne);
                  }
                  var be = N[j++], _e = N[j++], O = N[j++];
                  try {
                    var K = g(N, j, _, bt, L, be, _e, O >> 4, O & 15, at);
                    j += K;
                  } catch (se) {
                    if (se instanceof DNLMarkerError)
                      return this.parse(N, { F: se.s });
                    if (se instanceof EOIMarkerError)
                      break e;
                    throw se;
                  }
                  break;
                case 65500:
                  j += 4;
                  break;
                case 65535:
                  N[j] !== 255 && j--;
                  break;
                default:
                  var ee = S(N, j - 2, j - 3);
                  if (ee && ee.u) {
                    j = ee.offset;
                    break;
                  }
                  if (j >= N.length - 1)
                    break e;
                  throw new t("JpegImage.parse - unknown marker: " + T.toString(16));
              }
              T = r(N, j), j += 2;
            }
          for (this.width = _.o, this.height = _.s, this.g = D, this.b = $, this.W = [], P = 0; P < _.W.length; P++) {
            Ne = _.W[P];
            var ae = G[Ne.L];
            ae && (Ne.$ = ae), this.W.push({
              index: Ne.index,
              e: x(_, Ne),
              l: Ne.h / _.X,
              t: Ne.A / _.B,
              P: Ne.P,
              c: Ne.c
            });
          }
          this.p = this.W.length;
        },
        Y(N, v, b) {
          b == null && (b = !1);
          var j = this.width / N, D = this.height / v, $, _, L, I, A, M, G, Z, Q, T, P = 0, E, z = this.W.length, H = N * v * z, te = new Uint8ClampedArray(H), q = new Uint32Array(N), B = 4294967288, F;
          for (G = 0; G < z; G++) {
            if ($ = this.W[G], _ = $.l * j, L = $.t * D, P = G, E = $.e, I = $.P + 1 << 3, _ !== F) {
              for (A = 0; A < N; A++)
                Z = 0 | A * _, q[A] = (Z & B) << 3 | Z & 7;
              F = _;
            }
            for (M = 0; M < v; M++)
              for (Z = 0 | M * L, T = I * (Z & B) | (Z & 7) << 3, A = 0; A < N; A++)
                te[P] = E[T + q[A]], P += z;
          }
          var U = this.V;
          if (!b && z === 4 && !U && (U = new Int32Array([-256, 255, -256, 255, -256, 255, -256, 255])), U)
            for (G = 0; G < H; )
              for (Z = 0, Q = 0; Z < z; Z++, G++, Q += 2)
                te[G] = (te[G] * U[Q] >> 8) + U[Q + 1];
          return te;
        },
        get f() {
          return this.b ? !!this.b.a : this.p === 3 ? this.N === 0 ? !1 : !(this.W[0].index === 82 && this.W[1].index === 71 && this.W[2].index === 66) : this.N === 1;
        },
        z: function(v) {
          for (var b, j, D, $ = 0, _ = v.length; $ < _; $ += 3)
            b = v[$], j = v[$ + 1], D = v[$ + 2], v[$] = b - 179.456 + 1.402 * D, v[$ + 1] = b + 135.459 - 0.344 * j - 0.714 * D, v[$ + 2] = b - 226.816 + 1.772 * j;
          return v;
        },
        O: function(v) {
          for (var b, j, D, $, _ = 0, L = 0, I = v.length; L < I; L += 4)
            b = v[L], j = v[L + 1], D = v[L + 2], $ = v[L + 3], v[_++] = -122.67195406894 + j * (-660635669420364e-19 * j + 437130475926232e-18 * D - 54080610064599e-18 * b + 48449797120281e-17 * $ - 0.154362151871126) + D * (-957964378445773e-18 * D + 817076911346625e-18 * b - 0.00477271405408747 * $ + 1.53380253221734) + b * (961250184130688e-18 * b - 0.00266257332283933 * $ + 0.48357088451265) + $ * (-336197177618394e-18 * $ + 0.484791561490776), v[_++] = 107.268039397724 + j * (219927104525741e-19 * j - 640992018297945e-18 * D + 659397001245577e-18 * b + 426105652938837e-18 * $ - 0.176491792462875) + D * (-778269941513683e-18 * D + 0.00130872261408275 * b + 770482631801132e-18 * $ - 0.151051492775562) + b * (0.00126935368114843 * b - 0.00265090189010898 * $ + 0.25802910206845) + $ * (-318913117588328e-18 * $ - 0.213742400323665), v[_++] = -20.810012546947 + j * (-570115196973677e-18 * j - 263409051004589e-19 * D + 0.0020741088115012 * b - 0.00288260236853442 * $ + 0.814272968359295) + D * (-153496057440975e-19 * D - 132689043961446e-18 * b + 560833691242812e-18 * $ - 0.195152027534049) + b * (0.00174418132927582 * b - 0.00255243321439347 * $ + 0.116935020465145) + $ * (-343531996510555e-18 * $ + 0.24165260232407);
          return v.subarray(0, _);
        },
        r: function(v) {
          for (var b, j, D, $ = 0, _ = v.length; $ < _; $ += 4)
            b = v[$], j = v[$ + 1], D = v[$ + 2], v[$] = 434.456 - b - 1.402 * D, v[$ + 1] = 119.541 - b + 0.344 * j + 0.714 * D, v[$ + 2] = 481.816 - b - 1.772 * j;
          return v;
        },
        U: function(v) {
          for (var b, j, D, $, _ = 0, L = 0, I = v.length; L < I; L += 4)
            b = v[L], j = v[L + 1], D = v[L + 2], $ = v[L + 3], v[_++] = 255 + b * (-6747147073602441e-20 * b + 8379262121013727e-19 * j + 2894718188643294e-19 * D + 0.003264231057537806 * $ - 1.1185611867203937) + j * (26374107616089405e-21 * j - 8626949158638572e-20 * D - 2748769067499491e-19 * $ - 0.02155688794978967) + D * (-3878099212869363e-20 * D - 3267808279485286e-19 * $ + 0.0686742238595345) - $ * (3361971776183937e-19 * $ + 0.7430659151342254), v[_++] = 255 + b * (13596372813588848e-20 * b + 924537132573585e-18 * j + 10567359618683593e-20 * D + 4791864687436512e-19 * $ - 0.3109689587515875) + j * (-23545346108370344e-20 * j + 2702845253534714e-19 * D + 0.0020200308977307156 * $ - 0.7488052167015494) + D * (6834815998235662e-20 * D + 15168452363460973e-20 * $ - 0.09751927774728933) - $ * (3189131175883281e-19 * $ + 0.7364883807733168), v[_++] = 255 + b * (13598650411385307e-21 * b + 12423956175490851e-20 * j + 4751985097583589e-19 * D - 36729317476630422e-22 * $ - 0.05562186980264034) + j * (16141380598724676e-20 * j + 9692239130725186e-19 * D + 7782692450036253e-19 * $ - 0.44015232367526463) + D * (5068882914068769e-22 * D + 0.0017778369011375071 * $ - 0.7591454649749609) - $ * (3435319965105553e-19 * $ + 0.7063770186160144);
          return v.subarray(0, _);
        },
        getData: function(N) {
          var v = N.width, b = N.height, j = N.forceRGB, D = N.isSourcePDF;
          if (this.p > 4)
            throw new t("Unsupported color mode");
          var $ = this.Y(v, b, D);
          if (this.p === 1 && j) {
            for (var _ = $.length, L = new Uint8ClampedArray(_ * 3), I = 0, A = 0; A < _; A++) {
              var M = $[A];
              L[I++] = M, L[I++] = M, L[I++] = M;
            }
            return L;
          } else {
            if (this.p === 3 && this.f)
              return this.z($);
            if (this.p === 4) {
              if (this.f)
                return j ? this.O($) : this.r($);
              if (j)
                return this.U($);
            }
          }
          return $;
        }
      }, m;
    }();
    function r(s, a) {
      return s[a] << 8 | s[a + 1];
    }
    e.JpegDecoder = n;
  })(), e.encodeImage = function(t, n, r, s) {
    var a = new Uint8Array(t), o = window && window.pako ? 8 : 1;
    o == 8 && (a = pako.deflate(a));
    var c = {
      t256: [n],
      t257: [r],
      t258: [8, 8, 8, 8],
      t259: [o],
      t262: [2],
      t273: [1e3],
      // strips offset
      t277: [4],
      t278: [r],
      /* rows per strip */
      t279: [a.length],
      // strip byte counts
      t282: [[72, 1]],
      t283: [[72, 1]],
      t284: [1],
      t286: [[0, 1]],
      t287: [[0, 1]],
      t296: [1],
      t305: ["Photopea (UTIF.js)"],
      t338: [1]
    };
    if (s)
      for (var l in s)
        c[l] = s[l];
    for (var d = new Uint8Array(e.encode([c])), u = new Uint8Array(1e3 + a.length), l = 0; l < d.length; l++)
      u[l] = d[l];
    for (var l = 0; l < a.length; l++)
      u[1e3 + l] = a[l];
    return u.buffer;
  }, e.encode = function(t) {
    var n = new Uint8Array(2e4), r = 4, s = e._binBE;
    n[0] = n[1] = 77, s.writeUshort(n, 2, 42);
    var a = 8;
    s.writeUint(n, r, a), r += 4;
    for (var o = 0; o < t.length; o++) {
      var c = e._writeIFD(s, e._types.basic, n, a, t[o]);
      a = c[1], o < t.length - 1 && (a & 3 && (a += 4 - (a & 3)), s.writeUint(n, c[0], a));
    }
    return n.slice(0, a).buffer;
  }, e.decode = function(t, n) {
    n == null && (n = { parseMN: !0, debug: !1 });
    var r = new Uint8Array(t), s = 0, a = e._binBE.readASCII(r, s, 2);
    s += 2;
    var o = a == "II" ? e._binLE : e._binBE;
    o.readUshort(r, s), s += 2;
    var c = o.readUint(r, s);
    s += 4;
    for (var l = []; ; ) {
      var d = o.readUshort(r, c), u = o.readUshort(r, c + 4);
      if (d != 0 && (u < 1 || 13 < u)) {
        Et("error in TIFF");
        break;
      }
      if (e._readIFD(o, r, c, l, 0, n), c = o.readUint(r, c + 2 + d * 12), c == 0)
        break;
    }
    return l;
  }, e.decodeImage = function(t, n, r) {
    if (!n.data) {
      var s = new Uint8Array(t), a = e._binBE.readASCII(s, 0, 2);
      if (n.t256 != null) {
        n.isLE = a == "II", n.width = n.t256[0], n.height = n.t257[0];
        var o = n.t259 ? n.t259[0] : 1, c = n.t266 ? n.t266[0] : 1;
        o == 7 && n.t258 && n.t258.length > 3 && (n.t258 = n.t258.slice(0, 3));
        var l = n.t258 ? n.t258[0] : 1, d = n.t277 ? n.t277[0] : 1, u = n.t284 ? n.t284[0] : 1;
        d != 3 && (u = 1), u == 2 && Et("PlanarConfiguration 2 should not be used!");
        var h = l * d;
        o == 1 && n.t279 != null && n.t278 && n.t262[0] == 32803 && (h = Math.round(n.t279[0] * 8 / (n.width * n.t278[0]))), n.t50885 && n.t50885[0] == 4 && (h = n.t258[0] * 3);
        var f = Math.ceil(n.width * h / 8) * 8, p = n.t273;
        (p == null || n.t322) && (p = n.t324);
        var m = n.t279;
        o == 1 && p.length == 1 && (m = [n.height * (f >>> 3)]), (m == null || n.t322) && (m = n.t325);
        var C = new Uint8Array(n.height * (f >>> 3)), y = 0;
        if (n.t322 != null) {
          var g = n.t322[0], w = n.t323[0], x = Math.floor((n.width + g - 1) / g), S = Math.floor((n.height + w - 1) / w), N = new Uint8Array(Math.ceil(g * w * h / 8) | 0);
          console.log("====", x, S);
          for (var v = 0; v < S; v++)
            for (var b = 0; b < x; b++) {
              var j = v * x + b;
              N.fill(0), e.decode._decompress(n, r, s, p[j], m[j], o, N, 0, c, g, w), o == 6 ? C = N : e._copyTile(
                N,
                Math.ceil(g * h / 8) | 0,
                w,
                C,
                Math.ceil(n.width * h / 8) | 0,
                n.height,
                Math.ceil(b * g * h / 8) | 0,
                v * w
              );
            }
          y = C.length * 8;
        } else {
          if (p == null)
            return;
          var D = n.t278 ? n.t278[0] : n.height;
          D = Math.min(D, n.height);
          for (var j = 0; j < p.length; j++) {
            if (u == 1) {
              var $ = Math.ceil(y / 8) | 0;
              e.decode._decompress(
                n,
                r,
                s,
                p[j],
                m[j],
                o,
                C,
                $,
                c,
                n.width,
                D
              );
            } else {
              var _ = new Uint8Array(n.width * D);
              e.decode._decompress(
                n,
                r,
                s,
                p[j],
                m[j],
                o,
                _,
                0,
                c,
                n.width,
                D
              );
              for (var L = Math.ceil(p.length / 3), $ = j % L * n.width * D * 3, I = Math.floor(j / L), A = 0; A < _.length; A++)
                C[$ + A * 3 + I] = _[A];
            }
            y += f * D;
          }
          y = Math.min(y, C.length * 8);
        }
        n.data = new Uint8Array(C.buffer, 0, Math.ceil(y / 8) | 0);
      }
    }
  }, e.decode._decompress = function(t, n, r, s, a, o, c, l, d, u, h) {
    if (t.t271 && t.t271[0] == "Panasonic" && (t.t45 && t.t45[0] == 6 ? o = 34316 : o == 34828 && (o = 1)), o == 1)
      for (var f = 0; f < a; f++)
        c[l + f] = r[s + f];
    else if (o == 2)
      e.decode._decodeG2(r, s, a, c, l, u, d);
    else if (o == 3)
      e.decode._decodeG3(
        r,
        s,
        a,
        c,
        l,
        u,
        d,
        t.t292 ? (t.t292[0] & 1) == 1 : !1
      );
    else if (o == 4)
      e.decode._decodeG4(r, s, a, c, l, u, d);
    else if (o == 5)
      e.decode._decodeLZW(r, s, a, c, l, 8);
    else if (o == 6)
      e.decode._decodeOldJPEG(t, r, s, a, c, l);
    else if (o == 7 || o == 34892)
      e.decode._decodeNewJPEG(t, r, s, a, c, l);
    else if (o == 8 || o == 32946) {
      var p = new Uint8Array(r.buffer, s + 2, a - 6), m = e._inflateRaw(p);
      l + m.length <= c.length && c.set(m, l);
    } else
      o == 9 ? e.decode._decodeVC5(r, s, a, c, l, t.t33422) : o == 32767 ? e.decode._decodeARW(t, r, s, a, c, l) : o == 32773 ? e.decode._decodePackBits(r, s, a, c, l) : o == 32809 ? e.decode._decodeThunder(r, s, a, c, l) : o == 34316 ? e.decode._decodePanasonic(t, r, s, a, c, l) : o == 34713 ? e.decode._decodeNikon(t, n, r, s, a, c, l) : o == 34676 ? e.decode._decodeLogLuv32(t, r, s, a, c, l) : Et("Unknown compression", o);
    var C = t.t284 ? t.t284[0] : 1, y = t.t258 ? Math.min(32, t.t258[0]) : 1, g = C == 2 ? 1 : t.t277 ? t.t277[0] : 1, w = y * g >>> 3, x = Math.ceil(y * g * u / 8);
    if (y == 16 && !t.isLE && t.t33422 == null)
      for (var S = 0; S < h; S++)
        for (var N = l + S * x, v = 1; v < x; v += 2) {
          var b = c[N + v];
          c[N + v] = c[N + v - 1], c[N + v - 1] = b;
        }
    if (t.t317 && t.t317[0] == 2)
      for (var S = 0; S < h; S++) {
        var j = l + S * x;
        if (y == 16)
          for (var f = w; f < x; f += 2) {
            var D = (c[j + f + 1] << 8 | c[j + f]) + (c[j + f - w + 1] << 8 | c[j + f - w]);
            c[j + f] = D & 255, c[j + f + 1] = D >>> 8 & 255;
          }
        else if (g == 3)
          for (var f = 3; f < x; f += 3)
            c[j + f] = c[j + f] + c[j + f - 3] & 255, c[j + f + 1] = c[j + f + 1] + c[j + f - 2] & 255, c[j + f + 2] = c[j + f + 2] + c[j + f - 1] & 255;
        else
          for (var f = w; f < x; f++)
            c[j + f] = c[j + f] + c[j + f - w] & 255;
      }
  }, e.decode._decodePanasonic = function(t, n, r, s, a, o) {
    var c = n.buffer, l = t.t2[0], d = t.t3[0], u = t.t10[0], h = t.t45[0], f = 0, p = 0, m = 0, C = 0, y = h == 6 ? new Uint32Array(18) : new Uint8Array(16), g, w, x, S = [0, 0], N = [0, 0], v, b = 0, j, D, $, _, L = new Uint8Array(16384), I = new Uint16Array(a.buffer);
    function A(ue) {
      if (m == 0) {
        var pe = new Uint8Array(c, r + p + 8184, 8200), le = new Uint8Array(c, r + p, 8184);
        L.set(pe), L.set(le, pe.length), p += 16384;
      }
      if (h == 5)
        for (g = 0; g < 16; g++)
          y[g] = L[m++], m &= 16383;
      else
        return m = m - ue & 131071, C = m >> 3 ^ 16368, (L[C] | L[C + 1] << 8) >> (m & 7) & ~(-1 << ue);
    }
    function M(ue) {
      return L[m + 15 - ue];
    }
    function G() {
      y[0] = M(0) << 6 | M(1) >> 2, y[1] = ((M(1) & 3) << 12 | M(2) << 4 | M(3) >> 4) & 16383, y[2] = M(3) >> 2 & 3, y[3] = (M(3) & 3) << 8 | M(4), y[4] = M(5) << 2 | M(6) >> 6, y[5] = (M(6) & 63) << 4 | M(7) >> 4, y[6] = M(7) >> 2 & 3, y[7] = (M(7) & 3) << 8 | M(8), y[8] = M(9) << 2 & 1020 | M(10) >> 6, y[9] = (M(10) << 4 | M(11) >> 4) & 1023, y[10] = M(11) >> 2 & 3, y[11] = (M(11) & 3) << 8 | M(12), y[12] = (M(13) << 2 & 1020 | M(14) >> 6) & 1023, y[13] = (M(14) << 4 | M(15) >> 4) & 1023, m += 16, C = 0;
    }
    function Z() {
      y[0] = M(0) << 4 | M(1) >> 4, y[1] = ((M(1) & 15) << 8 | M(2)) & 4095, y[2] = M(3) >> 6 & 3, y[3] = (M(3) & 63) << 2 | M(4) >> 6, y[4] = (M(4) & 63) << 2 | M(5) >> 6, y[5] = (M(5) & 63) << 2 | M(6) >> 6, y[6] = M(6) >> 4 & 3, y[7] = (M(6) & 15) << 4 | M(7) >> 4, y[8] = (M(7) & 15) << 4 | M(8) >> 4, y[9] = (M(8) & 15) << 4 | M(9) >> 4, y[10] = M(9) >> 2 & 3, y[11] = (M(9) & 3) << 6 | M(10) >> 2, y[12] = (M(10) & 3) << 6 | M(11) >> 2, y[13] = (M(11) & 3) << 6 | M(12) >> 2, y[14] = M(12) & 3, y[15] = M(13), y[16] = M(14), y[17] = M(15), m += 16, C = 0;
    }
    function Q() {
      S[0] = 0, S[1] = 0, N[0] = 0, N[1] = 0;
    }
    if (h == 7)
      throw h;
    if (h == 6) {
      var T = u == 12, P = T ? Z : G, E = T ? 14 : 11, z = T ? 128 : 512, H = T ? 2048 : 8192, te = T ? 16383 : 65535, q = T ? 4095 : 16383, B = l / E, F = B * 16, U = T ? 18 : 14;
      for (D = 0; D < d - 15; D += 16) {
        var J = Math.min(16, d - D), fe = F * J;
        for (L = new Uint8Array(c, r + f, fe), m = 0, f += fe, _ = 0, $ = 0; _ < J; _++, $ = 0) {
          b = (D + _) * l;
          for (var re = 0; re < B; re++)
            for (P(), Q(), x = 0, j = 0, g = 0; g < E; g++) {
              if (v = g & 1, g % 3 == 2) {
                var ce = C < U ? y[C++] : 0;
                ce == 3 && (ce = 4), j = z << ce, x = 1 << ce;
              }
              var ge = C < U ? y[C++] : 0;
              S[v] ? (ge *= x, j < H && N[v] > j && (ge += N[v] - j), N[v] = ge) : (S[v] = ge, ge ? N[v] = ge : ge = N[v]), I[b + $++] = ge - 15 <= te ? ge - 15 & te : ge + 2147483633 >> 31 & q;
            }
        }
      }
    } else if (h == 5) {
      var we = u == 12 ? 10 : 9;
      for (D = 0; D < d; D++)
        for ($ = 0; $ < l; $ += we)
          A(0), u == 12 ? (I[b++] = ((y[1] & 15) << 8) + y[0], I[b++] = 16 * y[2] + (y[1] >> 4), I[b++] = ((y[4] & 15) << 8) + y[3], I[b++] = 16 * y[5] + (y[4] >> 4), I[b++] = ((y[7] & 15) << 8) + y[6], I[b++] = 16 * y[8] + (y[7] >> 4), I[b++] = ((y[10] & 15) << 8) + y[9], I[b++] = 16 * y[11] + (y[10] >> 4), I[b++] = ((y[13] & 15) << 8) + y[12], I[b++] = 16 * y[14] + (y[13] >> 4)) : u == 14 && (I[b++] = y[0] + ((y[1] & 63) << 8), I[b++] = (y[1] >> 6) + 4 * y[2] + ((y[3] & 15) << 10), I[b++] = (y[3] >> 4) + 16 * y[4] + ((y[5] & 3) << 12), I[b++] = ((y[5] & 252) >> 2) + (y[6] << 6), I[b++] = y[7] + ((y[8] & 63) << 8), I[b++] = (y[8] >> 6) + 4 * y[9] + ((y[10] & 15) << 10), I[b++] = (y[10] >> 4) + 16 * y[11] + ((y[12] & 3) << 12), I[b++] = ((y[12] & 252) >> 2) + (y[13] << 6), I[b++] = y[14] + ((y[15] & 63) << 8));
    } else if (h == 4)
      for (D = 0; D < d; D++)
        for ($ = 0; $ < l; $++)
          g = $ % 14, v = g & 1, g == 0 && Q(), g % 3 == 2 && (x = 4 >> 3 - A(2)), N[v] ? (w = A(8), w != 0 && (S[v] -= 128 << x, (S[v] < 0 || x == 4) && (S[v] &= ~(-1 << x)), S[v] += w << x)) : (N[v] = A(8), (N[v] || g > 11) && (S[v] = N[v] << 4 | A(4))), I[b++] = S[$ & 1];
    else
      throw h;
  }, e.decode._decodeVC5 = function() {
    var t = [
      1,
      0,
      1,
      0,
      2,
      2,
      1,
      1,
      3,
      7,
      1,
      2,
      5,
      25,
      1,
      3,
      6,
      48,
      1,
      4,
      6,
      54,
      1,
      5,
      7,
      111,
      1,
      8,
      7,
      99,
      1,
      6,
      7,
      105,
      12,
      0,
      7,
      107,
      1,
      7,
      8,
      209,
      20,
      0,
      8,
      212,
      1,
      9,
      8,
      220,
      1,
      10,
      9,
      393,
      1,
      11,
      9,
      394,
      32,
      0,
      9,
      416,
      1,
      12,
      9,
      427,
      1,
      13,
      10,
      887,
      1,
      18,
      10,
      784,
      1,
      14,
      10,
      790,
      1,
      15,
      10,
      835,
      60,
      0,
      10,
      852,
      1,
      16,
      10,
      885,
      1,
      17,
      11,
      1571,
      1,
      19,
      11,
      1668,
      1,
      20,
      11,
      1669,
      100,
      0,
      11,
      1707,
      1,
      21,
      11,
      1772,
      1,
      22,
      12,
      3547,
      1,
      29,
      12,
      3164,
      1,
      24,
      12,
      3166,
      1,
      25,
      12,
      3140,
      1,
      23,
      12,
      3413,
      1,
      26,
      12,
      3537,
      1,
      27,
      12,
      3539,
      1,
      28,
      13,
      7093,
      1,
      35,
      13,
      6283,
      1,
      30,
      13,
      6331,
      1,
      31,
      13,
      6335,
      180,
      0,
      13,
      6824,
      1,
      32,
      13,
      7072,
      1,
      33,
      13,
      7077,
      320,
      0,
      13,
      7076,
      1,
      34,
      14,
      12565,
      1,
      36,
      14,
      12661,
      1,
      37,
      14,
      12669,
      1,
      38,
      14,
      13651,
      1,
      39,
      14,
      14184,
      1,
      40,
      15,
      28295,
      1,
      46,
      15,
      28371,
      1,
      47,
      15,
      25320,
      1,
      42,
      15,
      25336,
      1,
      43,
      15,
      25128,
      1,
      41,
      15,
      27300,
      1,
      44,
      15,
      28293,
      1,
      45,
      16,
      50259,
      1,
      48,
      16,
      50643,
      1,
      49,
      16,
      50675,
      1,
      50,
      16,
      56740,
      1,
      53,
      16,
      56584,
      1,
      51,
      16,
      56588,
      1,
      52,
      17,
      113483,
      1,
      61,
      17,
      113482,
      1,
      60,
      17,
      101285,
      1,
      55,
      17,
      101349,
      1,
      56,
      17,
      109205,
      1,
      57,
      17,
      109207,
      1,
      58,
      17,
      100516,
      1,
      54,
      17,
      113171,
      1,
      59,
      18,
      202568,
      1,
      62,
      18,
      202696,
      1,
      63,
      18,
      218408,
      1,
      64,
      18,
      218412,
      1,
      65,
      18,
      226340,
      1,
      66,
      18,
      226356,
      1,
      67,
      18,
      226358,
      1,
      68,
      19,
      402068,
      1,
      69,
      19,
      405138,
      1,
      70,
      19,
      405394,
      1,
      71,
      19,
      436818,
      1,
      72,
      19,
      436826,
      1,
      73,
      19,
      452714,
      1,
      75,
      19,
      452718,
      1,
      76,
      19,
      452682,
      1,
      74,
      20,
      804138,
      1,
      77,
      20,
      810279,
      1,
      78,
      20,
      810790,
      1,
      79,
      20,
      873638,
      1,
      80,
      20,
      873654,
      1,
      81,
      20,
      905366,
      1,
      82,
      20,
      905430,
      1,
      83,
      20,
      905438,
      1,
      84,
      21,
      1608278,
      1,
      85,
      21,
      1620557,
      1,
      86,
      21,
      1621582,
      1,
      87,
      21,
      1621583,
      1,
      88,
      21,
      1747310,
      1,
      89,
      21,
      1810734,
      1,
      90,
      21,
      1810735,
      1,
      91,
      21,
      1810863,
      1,
      92,
      21,
      1810879,
      1,
      93,
      22,
      3621725,
      1,
      99,
      22,
      3621757,
      1,
      100,
      22,
      3241112,
      1,
      94,
      22,
      3494556,
      1,
      95,
      22,
      3494557,
      1,
      96,
      22,
      3494622,
      1,
      97,
      22,
      3494623,
      1,
      98,
      23,
      6482227,
      1,
      102,
      23,
      6433117,
      1,
      101,
      23,
      6989117,
      1,
      103,
      23,
      6989119,
      1,
      105,
      23,
      6989118,
      1,
      104,
      23,
      7243449,
      1,
      106,
      23,
      7243512,
      1,
      107,
      24,
      13978233,
      1,
      111,
      24,
      12964453,
      1,
      109,
      24,
      12866232,
      1,
      108,
      24,
      14486897,
      1,
      113,
      24,
      13978232,
      1,
      110,
      24,
      14486896,
      1,
      112,
      24,
      14487026,
      1,
      114,
      24,
      14487027,
      1,
      115,
      25,
      25732598,
      1,
      225,
      25,
      25732597,
      1,
      189,
      25,
      25732596,
      1,
      188,
      25,
      25732595,
      1,
      203,
      25,
      25732594,
      1,
      202,
      25,
      25732593,
      1,
      197,
      25,
      25732592,
      1,
      207,
      25,
      25732591,
      1,
      169,
      25,
      25732590,
      1,
      223,
      25,
      25732589,
      1,
      159,
      25,
      25732522,
      1,
      235,
      25,
      25732579,
      1,
      152,
      25,
      25732575,
      1,
      192,
      25,
      25732489,
      1,
      179,
      25,
      25732573,
      1,
      201,
      25,
      25732472,
      1,
      172,
      25,
      25732576,
      1,
      149,
      25,
      25732488,
      1,
      178,
      25,
      25732566,
      1,
      120,
      25,
      25732571,
      1,
      219,
      25,
      25732577,
      1,
      150,
      25,
      25732487,
      1,
      127,
      25,
      25732506,
      1,
      211,
      25,
      25732548,
      1,
      125,
      25,
      25732588,
      1,
      158,
      25,
      25732486,
      1,
      247,
      25,
      25732467,
      1,
      238,
      25,
      25732508,
      1,
      163,
      25,
      25732552,
      1,
      228,
      25,
      25732603,
      1,
      183,
      25,
      25732513,
      1,
      217,
      25,
      25732587,
      1,
      168,
      25,
      25732520,
      1,
      122,
      25,
      25732484,
      1,
      128,
      25,
      25732562,
      1,
      249,
      25,
      25732505,
      1,
      187,
      25,
      25732504,
      1,
      186,
      25,
      25732483,
      1,
      136,
      25,
      25928905,
      1,
      181,
      25,
      25732560,
      1,
      255,
      25,
      25732500,
      1,
      230,
      25,
      25732482,
      1,
      135,
      25,
      25732555,
      1,
      233,
      25,
      25732568,
      1,
      222,
      25,
      25732583,
      1,
      145,
      25,
      25732481,
      1,
      134,
      25,
      25732586,
      1,
      167,
      25,
      25732521,
      1,
      248,
      25,
      25732518,
      1,
      209,
      25,
      25732480,
      1,
      243,
      25,
      25732512,
      1,
      216,
      25,
      25732509,
      1,
      164,
      25,
      25732547,
      1,
      140,
      25,
      25732479,
      1,
      157,
      25,
      25732544,
      1,
      239,
      25,
      25732574,
      1,
      191,
      25,
      25732564,
      1,
      251,
      25,
      25732478,
      1,
      156,
      25,
      25732546,
      1,
      139,
      25,
      25732498,
      1,
      242,
      25,
      25732557,
      1,
      133,
      25,
      25732477,
      1,
      162,
      25,
      25732515,
      1,
      213,
      25,
      25732584,
      1,
      165,
      25,
      25732514,
      1,
      212,
      25,
      25732476,
      1,
      227,
      25,
      25732494,
      1,
      198,
      25,
      25732531,
      1,
      236,
      25,
      25732530,
      1,
      234,
      25,
      25732529,
      1,
      117,
      25,
      25732528,
      1,
      215,
      25,
      25732527,
      1,
      124,
      25,
      25732526,
      1,
      123,
      25,
      25732525,
      1,
      254,
      25,
      25732524,
      1,
      253,
      25,
      25732523,
      1,
      148,
      25,
      25732570,
      1,
      218,
      25,
      25732580,
      1,
      146,
      25,
      25732581,
      1,
      147,
      25,
      25732569,
      1,
      224,
      25,
      25732533,
      1,
      143,
      25,
      25732540,
      1,
      184,
      25,
      25732541,
      1,
      185,
      25,
      25732585,
      1,
      166,
      25,
      25732556,
      1,
      132,
      25,
      25732485,
      1,
      129,
      25,
      25732563,
      1,
      250,
      25,
      25732578,
      1,
      151,
      25,
      25732501,
      1,
      119,
      25,
      25732502,
      1,
      193,
      25,
      25732536,
      1,
      176,
      25,
      25732496,
      1,
      245,
      25,
      25732553,
      1,
      229,
      25,
      25732516,
      1,
      206,
      25,
      25732582,
      1,
      144,
      25,
      25732517,
      1,
      208,
      25,
      25732558,
      1,
      137,
      25,
      25732543,
      1,
      241,
      25,
      25732466,
      1,
      237,
      25,
      25732507,
      1,
      190,
      25,
      25732542,
      1,
      240,
      25,
      25732551,
      1,
      131,
      25,
      25732554,
      1,
      232,
      25,
      25732565,
      1,
      252,
      25,
      25732475,
      1,
      171,
      25,
      25732493,
      1,
      205,
      25,
      25732492,
      1,
      204,
      25,
      25732491,
      1,
      118,
      25,
      25732490,
      1,
      214,
      25,
      25928904,
      1,
      180,
      25,
      25732549,
      1,
      126,
      25,
      25732602,
      1,
      182,
      25,
      25732539,
      1,
      175,
      25,
      25732545,
      1,
      141,
      25,
      25732559,
      1,
      138,
      25,
      25732537,
      1,
      177,
      25,
      25732534,
      1,
      153,
      25,
      25732503,
      1,
      194,
      25,
      25732606,
      1,
      160,
      25,
      25732567,
      1,
      121,
      25,
      25732538,
      1,
      174,
      25,
      25732497,
      1,
      246,
      25,
      25732550,
      1,
      130,
      25,
      25732572,
      1,
      200,
      25,
      25732474,
      1,
      170,
      25,
      25732511,
      1,
      221,
      25,
      25732601,
      1,
      196,
      25,
      25732532,
      1,
      142,
      25,
      25732519,
      1,
      210,
      25,
      25732495,
      1,
      199,
      25,
      25732605,
      1,
      155,
      25,
      25732535,
      1,
      154,
      25,
      25732499,
      1,
      244,
      25,
      25732510,
      1,
      220,
      25,
      25732600,
      1,
      195,
      25,
      25732607,
      1,
      161,
      25,
      25732604,
      1,
      231,
      25,
      25732473,
      1,
      173,
      25,
      25732599,
      1,
      226,
      26,
      51465122,
      1,
      116,
      26,
      51465123,
      0,
      1
    ], n, r, s, a = [3, 3, 3, 3, 2, 2, 2, 1, 1, 1], o = 24576, c = 16384, l = 8192, d = c | l;
    function u(x) {
      var S = x[1], N = x[0][S >>> 3] >>> 7 - (S & 7) & 1;
      return x[1]++, N;
    }
    function h(x, S) {
      if (n == null) {
        n = {};
        for (var N = 0; N < t.length; N += 4)
          n[t[N + 1]] = t.slice(N, N + 4);
      }
      for (var v = u(x), b = n[v]; b == null; )
        v = v << 1 | u(x), b = n[v];
      var j = b[3];
      j != 0 && (j = u(x) == 0 ? j : -j), S[0] = b[2], S[1] = j;
    }
    function f(x, S) {
      for (var N = 0; N < S; N++)
        (x & 1) == 1 && x++, x = x >>> 1;
      return x;
    }
    function p(x, S) {
      return x >> S;
    }
    function m(x, S, N, v, b, j) {
      S[N] = p(p(11 * x[b] - 4 * x[b + j] + x[b + j + j] + 4, 3) + x[v], 1), S[N + j] = p(p(5 * x[b] + 4 * x[b + j] - x[b + j + j] + 4, 3) - x[v], 1);
    }
    function C(x, S, N, v, b, j) {
      var D = x[b - j] - x[b + j], $ = x[b], _ = x[v];
      S[N] = p(p(D + 4, 3) + $ + _, 1), S[N + j] = p(p(-D + 4, 3) + $ - _, 1);
    }
    function y(x, S, N, v, b, j) {
      S[N] = p(p(5 * x[b] + 4 * x[b - j] - x[b - j - j] + 4, 3) + x[v], 1), S[N + j] = p(p(11 * x[b] - 4 * x[b - j] + x[b - j - j] + 4, 3) - x[v], 1);
    }
    function g(x) {
      return x = x < 0 ? 0 : x > 4095 ? 4095 : x, x = s[x] >>> 2, x;
    }
    function w(x, S, N, v, b, j) {
      v = new Uint16Array(v.buffer);
      var D = Date.now(), $ = e._binBE, _ = S + N, L, I, A, M, G, Z, Q, T, P, E;
      S += 4;
      for (var z = j[0] == 1; S < _; ) {
        var H = $.readShort(x, S), te = $.readUshort(x, S + 2);
        if (S += 4, H == 12)
          L = te;
        else if (H == 20)
          I = te;
        else if (H == 21)
          A = te;
        else if (H == 48)
          M = te;
        else if (H == 53)
          G = te;
        else if (H != 35) {
          if (H == 62)
            Z = te;
          else if (H != 101) {
            if (H == 109)
              Q = te;
            else if (H != 84) {
              if (H != 106) {
                if (H != 107) {
                  if (H != 108) {
                    if (H != 102) {
                      if (H == 104)
                        T = te;
                      else if (H != 105) {
                        var q = H < 0 ? -H : H, B = q & 65280, F = 0;
                        if (q & d && (q & l ? (F = te & 65535, F += (q & 255) << 16) : F = te & 65535), (q & o) == o) {
                          if (P == null) {
                            P = [];
                            for (var U = 0; U < 4; U++)
                              P[U] = new Int16Array((I >>> 1) * (A >>> 1));
                            E = new Int16Array((I >>> 1) * (A >>> 1)), r = new Int16Array(1024);
                            for (var U = 0; U < 1024; U++) {
                              var J = U - 512, fe = Math.abs(J), L = Math.floor(768 * fe * fe * fe / (255 * 255 * 255)) + fe;
                              r[U] = Math.sign(J) * L;
                            }
                            s = new Uint16Array(4096);
                            for (var re = 65536 - 1, U = 0; U < 4096; U++) {
                              var ce = U, ge = re * (Math.pow(113, ce / 4095) - 1) / 112;
                              s[U] = Math.min(ge, re);
                            }
                          }
                          var we = P[Z], ue = f(I, 1 + a[M]), pe = f(A, 1 + a[M]);
                          if (M == 0)
                            for (var le = 0; le < pe; le++)
                              for (var de = 0; de < ue; de++) {
                                var Me = S + (le * ue + de) * 2;
                                we[le * (I >>> 1) + de] = x[Me] << 8 | x[Me + 1];
                              }
                          else {
                            for (var Ye = [x, S * 8], Ke = [], at = 0, Ne = ue * pe, ze = [0, 0], bt = 0, te = 0; at < Ne; )
                              for (h(Ye, ze), bt = ze[0], te = ze[1]; bt > 0; )
                                Ke[at++] = te, bt--;
                            for (var it = (M - 1) % 3, Vt = it != 1 ? ue : 0, ie = it != 0 ? pe : 0, le = 0; le < pe; le++)
                              for (var be = (le + ie) * (I >>> 1) + Vt, _e = le * ue, de = 0; de < ue; de++)
                                we[be + de] = r[Ke[_e + de] + 512] * G;
                            if (it == 2) {
                              for (var T = I >>> 1, O = ue * 2, K = pe * 2, le = 0; le < pe; le++)
                                for (var de = 0; de < O; de++) {
                                  var U = le * 2 * T + de, ee = le * T + de, ae = pe * T + ee;
                                  le == 0 ? m(we, E, U, ae, ee, T) : le == pe - 1 ? y(we, E, U, ae, ee, T) : C(we, E, U, ae, ee, T);
                                }
                              var se = we;
                              we = E, E = se;
                              for (var le = 0; le < K; le++)
                                for (var de = 0; de < ue; de++) {
                                  var U = le * T + 2 * de, ee = le * T + de, ae = ue + ee;
                                  de == 0 ? m(we, E, U, ae, ee, 1) : de == ue - 1 ? y(we, E, U, ae, ee, 1) : C(we, E, U, ae, ee, 1);
                                }
                              var se = we;
                              we = E, E = se;
                              for (var je = [], Se = 2 - ~~((M - 1) / 3), ve = 0; ve < 3; ve++)
                                je[ve] = Q >> 14 - ve * 2 & 3;
                              var ot = je[Se];
                              if (ot != 0)
                                for (var le = 0; le < K; le++)
                                  for (var de = 0; de < O; de++) {
                                    var U = le * T + de;
                                    we[U] = we[U] << ot;
                                  }
                            }
                          }
                          if (M == 9 && Z == 3)
                            for (var Nt = P[0], Mt = P[1], en = P[2], Tn = P[3], le = 0; le < A; le += 2)
                              for (var de = 0; de < I; de += 2) {
                                var bn = le * I + de, Me = (le >>> 1) * (I >>> 1) + (de >>> 1), Is = Nt[Me], vw = Mt[Me] - 2048, yw = en[Me] - 2048, ql = Tn[Me] - 2048, Gl = (vw << 1) + Is, Yl = (yw << 1) + Is, Ql = Is + ql, Zl = Is - ql;
                                z ? (v[bn] = g(Ql), v[bn + 1] = g(Yl), v[bn + I] = g(Gl), v[bn + I + 1] = g(Zl)) : (v[bn] = g(Gl), v[bn + 1] = g(Ql), v[bn + I] = g(Zl), v[bn + I + 1] = g(Yl));
                              }
                          S += F * 4;
                        } else if (q == 16388)
                          S += F * 4;
                        else if (!(B == 8192 || B == 8448 || B == 9216))
                          throw q.toString(16);
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      console.log(Date.now() - D);
    }
    return w;
  }(), e.decode._decodeLogLuv32 = function(t, n, r, s, a, o) {
    for (var c = t.width, l = c * 4, d = 0, u = new Uint8Array(l); d < s; ) {
      for (var h = 0; h < l; ) {
        var f = n[r + d];
        if (d++, f < 128) {
          for (var p = 0; p < f; p++)
            u[h + p] = n[r + d + p];
          h += f, d += f;
        } else {
          f = f - 126;
          for (var p = 0; p < f; p++)
            u[h + p] = n[r + d];
          h += f, d++;
        }
      }
      for (var m = 0; m < c; m++)
        a[o + 0] = u[m], a[o + 1] = u[m + c], a[o + 2] = u[m + c * 2], a[o + 4] = u[m + c * 3], o += 6;
    }
  }, e.decode._ljpeg_diff = function(t, n, r) {
    var s = e.decode._getbithuff, a, o;
    return a = s(t, n, r[0], r), o = s(t, n, a, 0), o & 1 << a - 1 || (o -= (1 << a) - 1), o;
  }, e.decode._decodeARW = function(t, n, r, s, a, o) {
    var c = t.t256[0], l = t.t257[0], d = t.t258[0], u = t.isLE ? e._binLE : e._binBE, h = c * l == s || c * l * 1.5 == s;
    if (!h) {
      l += 8;
      var f = [r, 0, 0, 0], p = new Uint16Array(32770), m = [
        3857,
        3856,
        3599,
        3342,
        3085,
        2828,
        2571,
        2314,
        2057,
        1800,
        1543,
        1286,
        1029,
        772,
        771,
        768,
        514,
        513
      ], Q, C, y, $, D, g = 0, w = e.decode._ljpeg_diff;
      for (p[0] = 15, y = Q = 0; Q < 18; Q++)
        for (var x = 32768 >>> (m[Q] >>> 8), C = 0; C < x; C++)
          p[++y] = m[Q];
      for ($ = c; $--; )
        for (D = 0; D < l + 1; D += 2)
          if (D == l && (D = 1), g += w(n, f, p), D < l) {
            var S = g & 4095;
            e.decode._putsF(a, (D * c + $) * d, S << 16 - d);
          }
      return;
    }
    if (c * l * 1.5 == s) {
      for (var Q = 0; Q < s; Q += 3) {
        var N = n[r + Q + 0], v = n[r + Q + 1], b = n[r + Q + 2];
        a[o + Q] = v << 4 | N >>> 4, a[o + Q + 1] = N << 4 | b >>> 4, a[o + Q + 2] = b << 4 | v >>> 4;
      }
      return;
    }
    var j = new Uint16Array(16), D, $, _, L, I, A, M, G, Z, Q, T, P = new Uint8Array(c + 1);
    for (D = 0; D < l; D++) {
      for (var E = 0; E < c; E++)
        P[E] = n[r++];
      for (T = 0, $ = 0; $ < c - 30; T += 16) {
        for (L = 2047 & (_ = u.readUint(P, T)), I = 2047 & _ >>> 11, A = 15 & _ >>> 22, M = 15 & _ >>> 26, G = 0; G < 4 && 128 << G <= L - I; G++)
          ;
        for (Z = 30, Q = 0; Q < 16; Q++)
          Q == A ? j[Q] = L : Q == M ? j[Q] = I : (j[Q] = ((u.readUshort(P, T + (Z >> 3)) >>> (Z & 7) & 127) << G) + I, j[Q] > 2047 && (j[Q] = 2047), Z += 7);
        for (Q = 0; Q < 16; Q++, $ += 2) {
          var S = j[Q] << 1;
          e.decode._putsF(a, (D * c + $) * d, S << 16 - d);
        }
        $ -= $ & 1 ? 1 : 31;
      }
    }
  }, e.decode._decodeNikon = function(t, n, r, s, a, o, c) {
    var l = [
      [
        0,
        0,
        1,
        5,
        1,
        1,
        1,
        1,
        1,
        1,
        2,
        0,
        0,
        0,
        0,
        0,
        0,
        5,
        4,
        3,
        6,
        2,
        7,
        1,
        0,
        8,
        9,
        11,
        10,
        12
      ],
      [
        0,
        0,
        1,
        5,
        1,
        1,
        1,
        1,
        1,
        1,
        2,
        0,
        0,
        0,
        0,
        0,
        0,
        57,
        90,
        56,
        39,
        22,
        5,
        4,
        3,
        2,
        1,
        0,
        11,
        12,
        12
      ],
      [
        0,
        0,
        1,
        4,
        2,
        3,
        1,
        2,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        5,
        4,
        6,
        3,
        7,
        2,
        8,
        1,
        9,
        0,
        10,
        11,
        12
      ],
      [
        0,
        0,
        1,
        4,
        3,
        1,
        1,
        1,
        1,
        1,
        2,
        0,
        0,
        0,
        0,
        0,
        0,
        5,
        6,
        4,
        7,
        8,
        3,
        9,
        2,
        1,
        0,
        10,
        11,
        12,
        13,
        14
      ],
      [
        0,
        0,
        1,
        5,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        2,
        0,
        0,
        0,
        0,
        0,
        8,
        92,
        75,
        58,
        41,
        7,
        6,
        5,
        4,
        3,
        2,
        1,
        0,
        13,
        14
      ],
      [
        0,
        0,
        1,
        4,
        2,
        2,
        3,
        1,
        2,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        7,
        6,
        8,
        5,
        9,
        4,
        10,
        3,
        11,
        12,
        2,
        0,
        1,
        13,
        14
      ]
    ], d = t.t256[0], u = t.t257[0], h = t.t258[0], f = 0, p = 0, m = e.decode._make_decoder, C = e.decode._getbithuff, y = n[0].exifIFD.makerNote, g = y.t150 ? y.t150 : y.t140, w = 0;
    if (y.t147 && y.t147[0] == 2) {
      for (var x = Math.ceil(d / 10), S = x * 16, N = d * 3 >>> 1, v = 0; v < u; v++)
        for (var b = 0; b < x; b++)
          for (var G = 0; G < 15; G++)
            o[v * N + b * 15 + G] = r[s + v * S + b * 16 + G];
      return;
    }
    var j = g[w++], D = g[w++];
    (j == 73 || D == 88) && (w += 2110), j == 70 && (f = 2), h == 14 && (f += 3);
    for (var $ = [
      [0, 0],
      [0, 0]
    ], _ = t.isLE ? e._binLE : e._binBE, G = 0; G < 2; G++)
      for (var L = 0; L < 2; L++)
        $[G][L] = _.readShort(g, w), w += 2;
    var I = 1 << h & 32767, A = 0, M = _.readShort(g, w);
    w += 2, M > 1 && (A = Math.floor(I / (M - 1))), j == 68 && D == 32 && A > 0 && (p = _.readShort(g, 562));
    var G, Z, Q, T, P, E, z = [0, 0], H = m(l[f]), te = [s, 0, 0, 0];
    for (Z = 0; Z < u; Z++)
      for (p && Z == p && (H = m(l[f + 1])), Q = 0; Q < d; Q++) {
        G = C(r, te, H[0], H), T = G & 15, P = G >>> 4, E = (C(r, te, T - P, 0) << 1) + 1 << P >>> 1, E & 1 << T - 1 || (E -= (1 << T) - (P == 0 ? 1 : 0)), Q < 2 ? z[Q] = $[Z & 1][Q] += E : z[Q & 1] += E;
        var q = Math.min(Math.max(z[Q & 1], 0), (1 << h) - 1), B = (Z * d + Q) * h;
        e.decode._putsF(o, B, q << 16 - h);
      }
  }, e.decode._putsF = function(t, n, r) {
    r = r << 8 - (n & 7);
    var s = n >>> 3;
    t[s] |= r >>> 16, t[s + 1] |= r >>> 8, t[s + 2] |= r;
  }, e.decode._getbithuff = function(t, n, r, s) {
    var a = 0;
    e.decode._get_byte;
    var o, c = n[0], l = n[1], d = n[2], u = n[3];
    if (r == 0 || d < 0)
      return 0;
    for (; !u && d < r && (o = t[c++]) != -1 && !(u = a); )
      l = (l << 8) + o, d += 8;
    if (o = l << 32 - d >>> 32 - r, s ? (d -= s[o + 1] >>> 8, o = s[o + 1] & 255) : d -= r, d < 0)
      throw "e";
    return n[0] = c, n[1] = l, n[2] = d, n[3] = u, o;
  }, e.decode._make_decoder = function(t) {
    var n, r, s, a, o, c = [];
    for (n = 16; n != 0 && !t[n]; n--)
      ;
    var l = 17;
    for (c[0] = n, s = r = 1; r <= n; r++)
      for (a = 0; a < t[r]; a++, ++l)
        for (o = 0; o < 1 << n - r; o++)
          s <= 1 << n && (c[s++] = r << 8 | t[l]);
    return c;
  }, e.decode._decodeNewJPEG = function(t, n, r, s, a, o) {
    s = Math.min(s, n.length - r);
    var c = t.t347, l = c ? c.length : 0, d = new Uint8Array(l + s);
    if (c) {
      for (var u = 216, h = 217, f = 0, p = 0; p < l - 1 && !(c[p] == 255 && c[p + 1] == h); p++)
        d[f++] = c[p];
      var m = n[r], C = n[r + 1];
      (m != 255 || C != u) && (d[f++] = m, d[f++] = C);
      for (var p = 2; p < s; p++)
        d[f++] = n[r + p];
    } else
      for (var p = 0; p < s; p++)
        d[p] = n[r + p];
    if (t.t262[0] == 32803 || t.t259[0] == 7 && t.t262[0] == 34892) {
      var y = t.t258[0], g = e.LosslessJpegDecode(d), w = g[0], x = w.length;
      if (g[3] == 4 && t.t29456) {
        var S = w.slice(0);
        S.fill(0);
        for (var N = g[1], v = g[2], b = N * 2, j = 0; j < v; j++)
          for (var D = 0; D < N; D++) {
            var $ = j * N * 4 + D * 2, _ = $ + D * 2;
            S[$] = w[_], S[$ + 1] = w[_ + 1], S[$ + b] = w[_ + 2], S[$ + b + 1] = w[_ + 3];
          }
        w = S;
      }
      if (y == 16)
        if (t.isLE)
          for (var p = 0; p < x; p++)
            a[o + (p << 1)] = w[p] & 255, a[o + (p << 1) + 1] = w[p] >>> 8;
        else
          for (var p = 0; p < x; p++)
            a[o + (p << 1)] = w[p] >>> 8, a[o + (p << 1) + 1] = w[p] & 255;
      else if (y == 14 || y == 12 || y == 10)
        for (var L = 16 - y, p = 0; p < x; p++)
          e.decode._putsF(a, p * y, w[p] << L);
      else if (y == 8)
        for (var p = 0; p < x; p++)
          a[o + p] = w[p];
      else
        throw new Error("unsupported bit depth " + y);
    } else {
      var I = new e.JpegDecoder();
      I.parse(d);
      for (var A = I.getData({
        width: I.width,
        height: I.height,
        forceRGB: !0,
        isSourcePDF: !1
      }), p = 0; p < A.length; p++)
        a[o + p] = A[p];
    }
    t.t262[0] == 6 && (t.t262[0] = 2);
  }, e.decode._decodeOldJPEGInit = function(t, n, r, s) {
    var a = 216, o = 219, c = 196, l = 221, d = 192, u = 218, h = 0, f = 0, p, m, C = !1, y, g, w, x = t.t513, S = x ? x[0] : 0, N = t.t514, v = N ? N[0] : 0, b = t.t324 || t.t273 || x, j = t.t530, D = 0, $ = 0, _ = t.t277 ? t.t277[0] : 1, L = t.t515;
    if (b && (f = b[0], C = b.length > 1), !C) {
      if (n[r] == 255 && n[r + 1] == a)
        return { jpegOffset: r };
      if (x != null && (n[r + S] == 255 && n[r + S + 1] == a ? h = r + S : Et("JPEGInterchangeFormat does not point to SOI"), N == null ? Et("JPEGInterchangeFormatLength field is missing") : (S >= f || S + v <= f) && Et("JPEGInterchangeFormatLength field value is invalid"), h != null))
        return { jpegOffset: h };
    }
    if (j != null && (D = j[0], $ = j[1]), x != null && N != null)
      if (v >= 2 && S + v <= f) {
        for (n[r + S + v - 2] == 255 && n[r + S + v - 1] == a ? p = new Uint8Array(v - 2) : p = new Uint8Array(v), y = 0; y < p.length; y++)
          p[y] = n[r + S + y];
        Et(
          "Incorrect JPEG interchange format: using JPEGInterchangeFormat offset to derive tables"
        );
      } else
        Et("JPEGInterchangeFormat+JPEGInterchangeFormatLength > offset to first strip or tile");
    if (p == null) {
      var I = 0, A = [];
      A[I++] = 255, A[I++] = a;
      var M = t.t519;
      if (M == null)
        throw new Error("JPEGQTables tag is missing");
      for (y = 0; y < M.length; y++)
        for (A[I++] = 255, A[I++] = o, A[I++] = 0, A[I++] = 67, A[I++] = y, g = 0; g < 64; g++)
          A[I++] = n[r + M[y] + g];
      for (w = 0; w < 2; w++) {
        var G = t[w == 0 ? "t520" : "t521"];
        if (G == null)
          throw new Error((w == 0 ? "JPEGDCTables" : "JPEGACTables") + " tag is missing");
        for (y = 0; y < G.length; y++) {
          A[I++] = 255, A[I++] = c;
          var Z = 19;
          for (g = 0; g < 16; g++)
            Z += n[r + G[y] + g];
          for (A[I++] = Z >>> 8, A[I++] = Z & 255, A[I++] = y | w << 4, g = 0; g < 16; g++)
            A[I++] = n[r + G[y] + g];
          for (g = 0; g < Z; g++)
            A[I++] = n[r + G[y] + 16 + g];
        }
      }
      if (A[I++] = 255, A[I++] = d, A[I++] = 0, A[I++] = 8 + 3 * _, A[I++] = 8, A[I++] = t.height >>> 8 & 255, A[I++] = t.height & 255, A[I++] = t.width >>> 8 & 255, A[I++] = t.width & 255, A[I++] = _, _ == 1)
        A[I++] = 1, A[I++] = 17, A[I++] = 0;
      else
        for (y = 0; y < 3; y++)
          A[I++] = y + 1, A[I++] = y != 0 ? 17 : (D & 15) << 4 | $ & 15, A[I++] = y;
      L != null && L[0] != 0 && (A[I++] = 255, A[I++] = l, A[I++] = 0, A[I++] = 4, A[I++] = L[0] >>> 8 & 255, A[I++] = L[0] & 255), p = new Uint8Array(A);
    }
    var Q = -1;
    for (y = 0; y < p.length - 1; ) {
      if (p[y] == 255 && p[y + 1] == d) {
        Q = y;
        break;
      }
      y++;
    }
    if (Q == -1) {
      var T = new Uint8Array(p.length + 10 + 3 * _);
      T.set(p);
      var P = p.length;
      if (Q = p.length, p = T, p[P++] = 255, p[P++] = d, p[P++] = 0, p[P++] = 8 + 3 * _, p[P++] = 8, p[P++] = t.height >>> 8 & 255, p[P++] = t.height & 255, p[P++] = t.width >>> 8 & 255, p[P++] = t.width & 255, p[P++] = _, _ == 1)
        p[P++] = 1, p[P++] = 17, p[P++] = 0;
      else
        for (y = 0; y < 3; y++)
          p[P++] = y + 1, p[P++] = y != 0 ? 17 : (D & 15) << 4 | $ & 15, p[P++] = y;
    }
    if (n[f] == 255 && n[f + 1] == u) {
      var E = n[f + 2] << 8 | n[f + 3];
      for (m = new Uint8Array(E + 2), m[0] = n[f], m[1] = n[f + 1], m[2] = n[f + 2], m[3] = n[f + 3], y = 0; y < E - 2; y++)
        m[y + 4] = n[f + y + 4];
    } else {
      m = new Uint8Array(2 + 6 + 2 * _);
      var z = 0;
      if (m[z++] = 255, m[z++] = u, m[z++] = 0, m[z++] = 6 + 2 * _, m[z++] = _, _ == 1)
        m[z++] = 1, m[z++] = 0;
      else
        for (y = 0; y < 3; y++)
          m[z++] = y + 1, m[z++] = y << 4 | y;
      m[z++] = 0, m[z++] = 63, m[z++] = 0;
    }
    return { jpegOffset: r, tables: p, sosMarker: m, sofPosition: Q };
  }, e.decode._decodeOldJPEG = function(t, n, r, s, a, o) {
    var c, l, d, u, h, f = e.decode._decodeOldJPEGInit(t, n, r, s);
    if (f.jpegOffset != null)
      for (l = r + s - f.jpegOffset, u = new Uint8Array(l), c = 0; c < l; c++)
        u[c] = n[f.jpegOffset + c];
    else {
      for (d = f.tables.length, u = new Uint8Array(d + f.sosMarker.length + s + 2), u.set(f.tables), h = d, u[f.sofPosition + 5] = t.height >>> 8 & 255, u[f.sofPosition + 6] = t.height & 255, u[f.sofPosition + 7] = t.width >>> 8 & 255, u[f.sofPosition + 8] = t.width & 255, (n[r] != 255 || n[r + 1] != SOS) && (u.set(f.sosMarker, h), h += sosMarker.length), c = 0; c < s; c++)
        u[h++] = n[r + c];
      u[h++] = 255, u[h++] = EOI;
    }
    var p = new e.JpegDecoder();
    p.parse(u);
    var m = p.getData({
      width: p.width,
      height: p.height,
      forceRGB: !0,
      isSourcePDF: !1
    }), C = p.width * p.height;
    if (t.t262 && t.t262[0] == 1)
      for (var c = 0; c < C; c++)
        a[o + c] = m[c * 3];
    else
      for (var c = 0; c < m.length; c++)
        a[o + c] = m[c];
    t.t262 && t.t262[0] == 6 && (t.t262[0] = 2);
  }, e.decode._decodePackBits = function(t, n, r, s, a) {
    for (var o = new Int8Array(t.buffer), c = new Int8Array(s.buffer), l = n + r; n < l; ) {
      var d = o[n];
      if (n++, d >= 0 && d < 128)
        for (var u = 0; u < d + 1; u++)
          c[a] = o[n], a++, n++;
      if (d >= -127 && d < 0) {
        for (var u = 0; u < -d + 1; u++)
          c[a] = o[n], a++;
        n++;
      }
    }
    return a;
  }, e.decode._decodeThunder = function(t, n, r, s, a) {
    for (var o = [0, 1, 0, -1], c = [0, 1, 2, 3, 0, -3, -2, -1], l = n + r, d = a * 2, u = 0; n < l; ) {
      var h = t[n], f = h >>> 6, p = h & 63;
      if (n++, f == 3 && (u = p & 15, s[d >>> 1] |= u << 4 * (1 - d & 1), d++), f == 0)
        for (var m = 0; m < p; m++)
          s[d >>> 1] |= u << 4 * (1 - d & 1), d++;
      if (f == 2)
        for (var m = 0; m < 2; m++) {
          var C = p >>> 3 * (1 - m) & 7;
          C != 4 && (u += c[C], s[d >>> 1] |= u << 4 * (1 - d & 1), d++);
        }
      if (f == 1)
        for (var m = 0; m < 3; m++) {
          var C = p >>> 2 * (2 - m) & 3;
          C != 2 && (u += o[C], s[d >>> 1] |= u << 4 * (1 - d & 1), d++);
        }
    }
  }, e.decode._dmap = {
    1: 0,
    "011": 1,
    "000011": 2,
    "0000011": 3,
    "010": -1,
    "000010": -2,
    "0000010": -3
  }, e.decode._lens = function() {
    var t = function(d, u, h, f) {
      for (var p = 0; p < u.length; p++)
        d[u[p]] = h + p * f;
    }, n = "00110101,000111,0111,1000,1011,1100,1110,1111,10011,10100,00111,01000,001000,000011,110100,110101,101010,101011,0100111,0001100,0001000,0010111,0000011,0000100,0101000,0101011,0010011,0100100,0011000,00000010,00000011,00011010,00011011,00010010,00010011,00010100,00010101,00010110,00010111,00101000,00101001,00101010,00101011,00101100,00101101,00000100,00000101,00001010,00001011,01010010,01010011,01010100,01010101,00100100,00100101,01011000,01011001,01011010,01011011,01001010,01001011,00110010,00110011,00110100", r = "0000110111,010,11,10,011,0011,0010,00011,000101,000100,0000100,0000101,0000111,00000100,00000111,000011000,0000010111,0000011000,0000001000,00001100111,00001101000,00001101100,00000110111,00000101000,00000010111,00000011000,000011001010,000011001011,000011001100,000011001101,000001101000,000001101001,000001101010,000001101011,000011010010,000011010011,000011010100,000011010101,000011010110,000011010111,000001101100,000001101101,000011011010,000011011011,000001010100,000001010101,000001010110,000001010111,000001100100,000001100101,000001010010,000001010011,000000100100,000000110111,000000111000,000000100111,000000101000,000001011000,000001011001,000000101011,000000101100,000001011010,000001100110,000001100111", s = "11011,10010,010111,0110111,00110110,00110111,01100100,01100101,01101000,01100111,011001100,011001101,011010010,011010011,011010100,011010101,011010110,011010111,011011000,011011001,011011010,011011011,010011000,010011001,010011010,011000,010011011", a = "0000001111,000011001000,000011001001,000001011011,000000110011,000000110100,000000110101,0000001101100,0000001101101,0000001001010,0000001001011,0000001001100,0000001001101,0000001110010,0000001110011,0000001110100,0000001110101,0000001110110,0000001110111,0000001010010,0000001010011,0000001010100,0000001010101,0000001011010,0000001011011,0000001100100,0000001100101", o = "00000001000,00000001100,00000001101,000000010010,000000010011,000000010100,000000010101,000000010110,000000010111,000000011100,000000011101,000000011110,000000011111";
    n = n.split(","), r = r.split(","), s = s.split(","), a = a.split(","), o = o.split(",");
    var c = {}, l = {};
    return t(c, n, 0, 1), t(c, s, 64, 64), t(c, o, 1792, 64), t(l, r, 0, 1), t(l, a, 64, 64), t(l, o, 1792, 64), [c, l];
  }(), e.decode._decodeG4 = function(t, n, r, s, a, o, c) {
    for (var l = e.decode, d = n << 3, u = 0, h = "", f = [], p = [], m = 0; m < o; m++)
      p.push(0);
    p = l._makeDiff(p);
    for (var C = 0, y = 0, g = 0, w = 0, x = 0, S = 0, N = "", v = 0, b = Math.ceil(o / 8) * 8; d >>> 3 < n + r; ) {
      g = l._findDiff(p, C + (C == 0 ? 0 : 1), 1 - x), w = l._findDiff(p, g, x);
      var j = 0;
      if (c == 1 && (j = t[d >>> 3] >>> 7 - (d & 7) & 1), c == 2 && (j = t[d >>> 3] >>> (d & 7) & 1), d++, h += j, N == "H") {
        if (l._lens[x][h] != null) {
          var D = l._lens[x][h];
          h = "", u += D, D < 64 && (l._addNtimes(f, u, x), C += u, x = 1 - x, u = 0, v--, v == 0 && (N = ""));
        }
      } else
        h == "0001" && (h = "", l._addNtimes(f, w - C, x), C = w), h == "001" && (h = "", N = "H", v = 2), l._dmap[h] != null && (y = g + l._dmap[h], l._addNtimes(f, y - C, x), C = y, h = "", x = 1 - x);
      f.length == o && N == "" && (l._writeBits(f, s, a * 8 + S * b), x = 0, S++, C = 0, p = l._makeDiff(f), f = []);
    }
  }, e.decode._findDiff = function(t, n, r) {
    for (var s = 0; s < t.length; s += 2)
      if (t[s] >= n && t[s + 1] == r)
        return t[s];
  }, e.decode._makeDiff = function(t) {
    var n = [];
    t[0] == 1 && n.push(0, 1);
    for (var r = 1; r < t.length; r++)
      t[r - 1] != t[r] && n.push(r, t[r]);
    return n.push(t.length, 0, t.length, 1), n;
  }, e.decode._decodeG2 = function(t, n, r, s, a, o, c) {
    for (var l = e.decode, d = n << 3, u = 0, h = "", f = [], p = 0, m = 0, C = Math.ceil(o / 8) * 8; d >>> 3 < n + r; ) {
      var y = 0;
      c == 1 && (y = t[d >>> 3] >>> 7 - (d & 7) & 1), c == 2 && (y = t[d >>> 3] >>> (d & 7) & 1), d++, h += y, u = l._lens[p][h], u != null && (l._addNtimes(f, u, p), h = "", u < 64 && (p = 1 - p), f.length == o && (l._writeBits(f, s, a * 8 + m * C), f = [], m++, p = 0, d & 7 && (d += 8 - (d & 7)), u >= 64 && (d += 8)));
    }
  }, e.decode._decodeG3 = function(t, n, r, s, a, o, c, l) {
    for (var d = e.decode, u = n << 3, h = 0, f = "", p = [], m = [], C = 0; C < o; C++)
      p.push(0);
    for (var y = 0, g = 0, w = 0, x = 0, S = 0, N = -1, v = "", b = 0, j = !0, D = Math.ceil(o / 8) * 8; u >>> 3 < n + r; ) {
      w = d._findDiff(m, y + (y == 0 ? 0 : 1), 1 - S), x = d._findDiff(m, w, S);
      var $ = 0;
      if (c == 1 && ($ = t[u >>> 3] >>> 7 - (u & 7) & 1), c == 2 && ($ = t[u >>> 3] >>> (u & 7) & 1), u++, f += $, j) {
        if (d._lens[S][f] != null) {
          var _ = d._lens[S][f];
          f = "", h += _, _ < 64 && (d._addNtimes(p, h, S), S = 1 - S, h = 0);
        }
      } else if (v == "H") {
        if (d._lens[S][f] != null) {
          var _ = d._lens[S][f];
          f = "", h += _, _ < 64 && (d._addNtimes(p, h, S), y += h, S = 1 - S, h = 0, b--, b == 0 && (v = ""));
        }
      } else
        f == "0001" && (f = "", d._addNtimes(p, x - y, S), y = x), f == "001" && (f = "", v = "H", b = 2), d._dmap[f] != null && (g = w + d._dmap[f], d._addNtimes(p, g - y, S), y = g, f = "", S = 1 - S);
      f.endsWith("000000000001") && (N >= 0 && d._writeBits(p, s, a * 8 + N * D), l && (c == 1 && (j = (t[u >>> 3] >>> 7 - (u & 7) & 1) == 1), c == 2 && (j = (t[u >>> 3] >>> (u & 7) & 1) == 1), u++), f = "", S = 0, N++, y = 0, m = d._makeDiff(p), p = []);
    }
    p.length == o && d._writeBits(p, s, a * 8 + N * D);
  }, e.decode._addNtimes = function(t, n, r) {
    for (var s = 0; s < n; s++)
      t.push(r);
  }, e.decode._writeBits = function(t, n, r) {
    for (var s = 0; s < t.length; s++)
      n[r + s >>> 3] |= t[s] << 7 - (r + s & 7);
  }, e.decode._decodeLZW = e.decode._decodeLZW = function() {
    var t, n, r, s, a = 0, o = 0, c = 0, l = 0, d = function() {
      var g = t >>> 3, w = n[g] << 16 | n[g + 1] << 8 | n[g + 2], x = w >>> 24 - (t & 7) - o & (1 << o) - 1;
      return t += o, x;
    }, u = new Uint32Array(4096 * 4), h = 0, f = function(g) {
      if (g != h) {
        h = g, c = 1 << g, l = c + 1;
        for (var w = 0; w < l + 1; w++)
          u[4 * w] = u[4 * w + 3] = w, u[4 * w + 1] = 65535, u[4 * w + 2] = 1;
      }
    }, p = function(g) {
      o = g + 1, a = l + 1;
    }, m = function(g) {
      for (var w = g << 2, x = u[w + 2], S = s + x - 1; w != 65535; )
        r[S--] = u[w], w = u[w + 1];
      s += x;
    }, C = function(g, w) {
      var x = a << 2, S = g << 2;
      u[x] = u[(w << 2) + 3], u[x + 1] = S, u[x + 2] = u[S + 2] + 1, u[x + 3] = u[S + 3], a++, a + 1 == 1 << o && o != 12 && o++;
    }, y = function(g, w, x, S, N, v) {
      t = w << 3, n = g, r = S, s = N;
      var b = w + x << 3, j = 0, D = 0;
      for (f(v), p(v); t < b && (j = d()) != l; ) {
        if (j == c) {
          if (p(v), j = d(), j == l)
            break;
          m(j);
        } else
          j < a ? (m(j), C(D, j)) : (C(D, D), m(a - 1));
        D = j;
      }
      return s;
    };
    return y;
  }(), e.tags = {}, e._types = function() {
    var t = new Array(250);
    t.fill(0), t = t.concat([
      0,
      0,
      0,
      0,
      4,
      3,
      3,
      3,
      3,
      3,
      0,
      0,
      3,
      0,
      0,
      0,
      3,
      0,
      0,
      2,
      2,
      2,
      2,
      4,
      3,
      0,
      0,
      3,
      4,
      4,
      3,
      3,
      5,
      5,
      3,
      2,
      5,
      5,
      0,
      0,
      0,
      0,
      4,
      4,
      0,
      0,
      3,
      3,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      2,
      2,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      2,
      2,
      3,
      5,
      5,
      3,
      0,
      3,
      3,
      4,
      4,
      4,
      3,
      4,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      3,
      3,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      7,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      4,
      4,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      3,
      3,
      5,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      7,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0
    ]);
    var n = {
      33432: 2,
      33434: 5,
      33437: 5,
      34665: 4,
      34850: 3,
      34853: 4,
      34855: 3,
      34864: 3,
      34866: 4,
      36864: 7,
      36867: 2,
      36868: 2,
      37121: 7,
      37377: 10,
      37378: 5,
      37380: 10,
      37381: 5,
      37383: 3,
      37384: 3,
      37385: 3,
      37386: 5,
      37510: 7,
      37520: 2,
      37521: 2,
      37522: 2,
      40960: 7,
      40961: 3,
      40962: 4,
      40963: 4,
      40965: 4,
      41486: 5,
      41487: 5,
      41488: 3,
      41985: 3,
      41986: 3,
      41987: 3,
      41988: 5,
      41989: 3,
      41990: 3,
      41993: 3,
      41994: 3,
      41995: 7,
      41996: 3,
      42032: 2,
      42033: 2,
      42034: 5,
      42036: 2,
      42037: 2,
      59932: 7
    };
    return {
      basic: {
        main: t,
        rest: n
      },
      gps: {
        main: [1, 2, 5, 2, 5, 1, 5, 5, 0, 9],
        rest: { 18: 2, 29: 2 }
      }
    };
  }(), e._readIFD = function(t, n, r, s, a, o) {
    var c = t.readUshort(n, r);
    r += 2;
    var l = {};
    o.debug && Et("   ".repeat(a), s.length - 1, ">>>----------------");
    for (var d = 0; d < c; d++) {
      var u = t.readUshort(n, r);
      r += 2;
      var h = t.readUshort(n, r);
      r += 2;
      var f = t.readUint(n, r);
      r += 4;
      var p = t.readUint(n, r);
      r += 4;
      var m = [];
      if (h == 1 || h == 7) {
        var C = f < 5 ? r - 4 : p;
        C + f > n.buffer.byteLength && (f = n.buffer.byteLength - C), m = new Uint8Array(n.buffer, C, f);
      }
      if (h == 2) {
        var y = f < 5 ? r - 4 : p, g = n[y], w = Math.max(0, Math.min(f - 1, n.length - y));
        g < 128 || w == 0 ? m.push(t.readASCII(n, y, w)) : m = new Uint8Array(n.buffer, y, w);
      }
      if (h == 3)
        for (var x = 0; x < f; x++)
          m.push(t.readUshort(n, (f < 3 ? r - 4 : p) + 2 * x));
      if (h == 4 || h == 13)
        for (var x = 0; x < f; x++)
          m.push(t.readUint(n, (f < 2 ? r - 4 : p) + 4 * x));
      if (h == 5 || h == 10)
        for (var S = h == 5 ? t.readUint : t.readInt, x = 0; x < f; x++)
          m.push([S(n, p + x * 8), S(n, p + x * 8 + 4)]);
      if (h == 8)
        for (var x = 0; x < f; x++)
          m.push(t.readShort(n, (f < 3 ? r - 4 : p) + 2 * x));
      if (h == 9)
        for (var x = 0; x < f; x++)
          m.push(t.readInt(n, (f < 2 ? r - 4 : p) + 4 * x));
      if (h == 11)
        for (var x = 0; x < f; x++)
          m.push(t.readFloat(n, p + x * 4));
      if (h == 12)
        for (var x = 0; x < f; x++)
          m.push(t.readDouble(n, p + x * 8));
      if (f != 0 && m.length == 0) {
        if (Et(u, "unknown TIFF tag type: ", h, "num:", f), d == 0)
          return;
        continue;
      }
      if (o.debug && Et("   ".repeat(a), u, h, e.tags[u], m), l["t" + u] = m, !(u == 330 && l.t272 && l.t272[0] == "DSLR-A100")) {
        if (u == 330 || u == 34665 || u == 34853 || u == 50740 && t.readUshort(n, t.readUint(m, 0)) < 300 || u == 61440) {
          for (var N = u == 50740 ? [t.readUint(m, 0)] : m, v = [], x = 0; x < N.length; x++)
            e._readIFD(t, n, N[x], v, a + 1, o);
          u == 330 && (l.subIFD = v), u == 34665 && (l.exifIFD = v[0]), u == 34853 && (l.gpsiIFD = v[0]), u == 50740 && (l.dngPrvt = v[0]), u == 61440 && (l.fujiIFD = v[0]);
        }
      }
      if (u == 37500 && o.parseMN) {
        var b = m;
        if (t.readASCII(b, 0, 5) == "Nikon")
          l.makerNote = e.decode(b.slice(10).buffer)[0];
        else if (t.readASCII(b, 0, 5) == "OLYMP" || t.readASCII(b, 0, 9) == "OM SYSTEM") {
          var j = [8208, 8224, 8240, 8256, 8272], D = [];
          e._readIFD(t, b, b[1] == 77 ? 16 : b[5] == 85 ? 12 : 8, D, a + 1, o);
          for (var $ = l.makerNote = D.pop(), x = 0; x < j.length; x++) {
            var _ = "t" + j[x];
            $[_] != null && ($[_].length == 1 ? e._readIFD(t, b, $[_][0], D, a + 1, o) : e._readIFD(t, $[_], 0, D, a + 1, o), $[_] = D.pop());
          }
          $.t12288 && (e._readIFD(t, $.t12288, 0, D, a + 1, o), $.t12288 = D.pop());
        } else if (t.readUshort(n, p) < 300 && t.readUshort(n, p + 4) <= 12) {
          var D = [];
          e._readIFD(t, n, p, D, a + 1, o), l.makerNote = D[0];
        }
      }
    }
    return s.push(l), o.debug && Et("   ".repeat(a), "<<<---------------"), r;
  }, e._writeIFD = function(t, n, r, s, a) {
    var o = Object.keys(a), c = o.length;
    a.exifIFD && c--, a.gpsiIFD && c--, t.writeUshort(r, s, c), s += 2;
    for (var l = s + c * 12 + 4, d = 0; d < o.length; d++) {
      var u = o[d];
      if (!(u == "t34665" || u == "t34853")) {
        u == "exifIFD" && (u = "t34665"), u == "gpsiIFD" && (u = "t34853");
        var h = parseInt(u.slice(1)), f = n.main[h];
        if (f == null && (f = n.rest[h]), f == null || f == 0)
          throw new Error("unknown type of tag: " + h);
        var p = a[u];
        if (h == 34665) {
          var m = e._writeIFD(t, n, r, l, a.exifIFD);
          p = [l], l = m[1];
        }
        if (h == 34853) {
          var m = e._writeIFD(t, e._types.gps, r, l, a.gpsiIFD);
          p = [l], l = m[1];
        }
        f == 2 && (p = p[0] + "\0");
        var C = p.length;
        t.writeUshort(r, s, h), s += 2, t.writeUshort(r, s, f), s += 2, t.writeUint(r, s, C), s += 4;
        var y = [-1, 1, 1, 2, 4, 8, 0, 1, 0, 4, 8, 0, 8][f] * C, g = s;
        if (y > 4 && (t.writeUint(r, s, l), g = l), f == 1 || f == 7)
          for (var w = 0; w < C; w++)
            r[g + w] = p[w];
        else if (f == 2)
          t.writeASCII(r, g, p);
        else if (f == 3)
          for (var w = 0; w < C; w++)
            t.writeUshort(r, g + 2 * w, p[w]);
        else if (f == 4)
          for (var w = 0; w < C; w++)
            t.writeUint(r, g + 4 * w, p[w]);
        else if (f == 5 || f == 10)
          for (var x = f == 5 ? t.writeUint : t.writeInt, w = 0; w < C; w++) {
            var S = p[w], N = S[0], v = S[1];
            if (N == null)
              throw "e";
            x(r, g + 8 * w, N), x(r, g + 8 * w + 4, v);
          }
        else if (f == 9)
          for (var w = 0; w < C; w++)
            t.writeInt(r, g + 4 * w, p[w]);
        else if (f == 12)
          for (var w = 0; w < C; w++)
            t.writeDouble(r, g + 8 * w, p[w]);
        else
          throw f;
        y > 4 && (y += y & 1, l += y), s += 4;
      }
    }
    return [s, l];
  }, e.toRGBA8 = function(t, n) {
    function r(se) {
      return se < 31308e-7 ? 12.92 * se : 1.055 * Math.pow(se, 1 / 2.4) - 0.055;
    }
    var s = t.width, a = t.height, o = s * a, c = t.data, l = new Uint8Array(o * 4), d = t.t262 ? t.t262[0] : 2, u = t.t258 ? Math.min(32, t.t258[0]) : 1;
    t.t262 == null && u == 1 && (d = 0);
    var h = t.t277 ? t.t277[0] : t.t258 ? t.t258.length : [1, 1, 3, 1, 1, 4, 3][d], f = t.t339 ? t.t339[0] : null;
    if (d == 1 && u == 32 && f != 3)
      throw "e";
    var p = Math.ceil(h * u * s / 8);
    if (d == 0) {
      n = 1 / 256;
      for (var m = 0; m < a; m++) {
        var C = m * p, y = m * s;
        if (u == 1)
          for (var g = 0; g < s; g++) {
            var w = y + g << 2, x = c[C + (g >> 3)] >> 7 - (g & 7) & 1;
            l[w] = l[w + 1] = l[w + 2] = (1 - x) * 255, l[w + 3] = 255;
          }
        if (u == 4)
          for (var g = 0; g < s; g++) {
            var w = y + g << 2, x = c[C + (g >> 1)] >> 4 - 4 * (g & 1) & 15;
            l[w] = l[w + 1] = l[w + 2] = (15 - x) * 17, l[w + 3] = 255;
          }
        if (u == 8)
          for (var g = 0; g < s; g++) {
            var w = y + g << 2, x = c[C + g];
            l[w] = l[w + 1] = l[w + 2] = 255 - x, l[w + 3] = 255;
          }
        if (u == 16)
          for (var g = 0; g < s; g++) {
            var w = y + g << 2, S = C + 2 * g, x = c[S + 1] << 8 | c[S];
            l[w] = l[w + 1] = l[w + 2] = Math.min(255, 255 - ~~(x * n)), l[w + 3] = 255;
          }
      }
    } else if (d == 1) {
      n == null && (n = 1 / 256);
      for (var N = c.length & 3 ? null : new Float32Array(c.buffer), m = 0; m < a; m++) {
        var C = m * p, y = m * s;
        if (u == 1)
          for (var g = 0; g < s; g++) {
            var w = y + g << 2, x = c[C + (g >> 3)] >> 7 - (g & 7) & 1;
            l[w] = l[w + 1] = l[w + 2] = x * 255, l[w + 3] = 255;
          }
        if (u == 2)
          for (var g = 0; g < s; g++) {
            var w = y + g << 2, x = c[C + (g >> 2)] >> 6 - 2 * (g & 3) & 3;
            l[w] = l[w + 1] = l[w + 2] = x * 85, l[w + 3] = 255;
          }
        if (u == 8)
          for (var g = 0; g < s; g++) {
            var w = y + g << 2, x = c[C + g * h];
            l[w] = l[w + 1] = l[w + 2] = x, l[w + 3] = 255;
          }
        if (u == 16)
          for (var g = 0; g < s; g++) {
            var w = y + g << 2, S = C + 2 * g, x = c[S + 1] << 8 | c[S];
            l[w] = l[w + 1] = l[w + 2] = Math.min(255, ~~(x * n)), l[w + 3] = 255;
          }
        if (u == 32)
          for (var g = 0; g < s; g++) {
            var w = y + g << 2, S = (C >>> 2) + g, x = N[S];
            l[w] = l[w + 1] = l[w + 2] = ~~(0.5 + 255 * x), l[w + 3] = 255;
          }
      }
    } else if (d == 2)
      if (u == 8) {
        if (h == 1)
          for (var g = 0; g < o; g++)
            l[4 * g] = l[4 * g + 1] = l[4 * g + 2] = c[g], l[4 * g + 3] = 255;
        if (h == 3)
          for (var g = 0; g < o; g++) {
            var w = g << 2, v = g * 3;
            l[w] = c[v], l[w + 1] = c[v + 1], l[w + 2] = c[v + 2], l[w + 3] = 255;
          }
        if (h >= 4)
          for (var g = 0; g < o; g++) {
            var w = g << 2, v = g * h;
            l[w] = c[v], l[w + 1] = c[v + 1], l[w + 2] = c[v + 2], l[w + 3] = c[v + 3];
          }
      } else if (u == 16) {
        if (h == 4)
          for (var g = 0; g < o; g++) {
            var w = g << 2, v = g * 8 + 1;
            l[w] = c[v], l[w + 1] = c[v + 2], l[w + 2] = c[v + 4], l[w + 3] = c[v + 6];
          }
        if (h == 3)
          for (var g = 0; g < o; g++) {
            var w = g << 2, v = g * 6 + 1;
            l[w] = c[v], l[w + 1] = c[v + 2], l[w + 2] = c[v + 4], l[w + 3] = 255;
          }
      } else if (u == 32) {
        for (var b = new Float32Array(c.buffer), j = 0, g = 0; g < b.length; g++)
          j = Math.min(j, b[g]);
        if (j < 0)
          for (var g = 0; g < c.length; g += 4) {
            var D = c[g];
            c[g] = c[g + 3], c[g + 3] = D, D = c[g + 1], c[g + 1] = c[g + 2], c[g + 2] = D;
          }
        for (var $ = [], g = 0; g < 65536; g++)
          $.push(r(g / 65535));
        for (var g = 0; g < b.length; g++) {
          var _ = Math.max(0, Math.min(1, b[g]));
          b[g] = $[~~(0.5 + _ * 65535)];
        }
        if (h == 3)
          for (var g = 0; g < o; g++) {
            var w = g << 2, v = g * 3;
            l[w] = ~~(0.5 + b[v] * 255), l[w + 1] = ~~(0.5 + b[v + 1] * 255), l[w + 2] = ~~(0.5 + b[v + 2] * 255), l[w + 3] = 255;
          }
        else if (h == 4)
          for (var g = 0; g < o; g++) {
            var w = g << 2, v = g * 4;
            l[w] = ~~(0.5 + b[v] * 255), l[w + 1] = ~~(0.5 + b[v + 1] * 255), l[w + 2] = ~~(0.5 + b[v + 2] * 255), l[w + 3] = ~~(0.5 + b[v + 3] * 255);
          }
        else
          throw h;
      } else
        throw u;
    else if (d == 3)
      for (var L = t.t320, I = 1 << u, A = u == 8 && h > 1 && t.t338 && t.t338[0] != 0, m = 0; m < a; m++)
        for (var M = 0; M < s; M++) {
          var g = m * s + M, w = g << 2, G = 0, Z = m * p;
          if (u == 1)
            G = c[Z + (M >>> 3)] >>> 7 - (M & 7) & 1;
          else if (u == 2)
            G = c[Z + (M >>> 2)] >>> 6 - 2 * (M & 3) & 3;
          else if (u == 4)
            G = c[Z + (M >>> 1)] >>> 4 - 4 * (M & 1) & 15;
          else if (u == 8)
            G = c[Z + M * h];
          else
            throw u;
          l[w] = L[G] >> 8, l[w + 1] = L[I + G] >> 8, l[w + 2] = L[I + I + G] >> 8, l[w + 3] = A ? c[Z + M * h + 1] : 255;
        }
    else if (d == 5)
      for (var Q = h > 4 ? 1 : 0, g = 0; g < o; g++) {
        var w = g << 2, T = g * h;
        if (window.UDOC) {
          var P = c[T], E = c[T + 1], z = c[T + 2], H = c[T + 3], te = UDOC.C.cmykToRgb([P * (1 / 255), E * (1 / 255), z * (1 / 255), H * (1 / 255)]);
          l[w] = ~~(0.5 + 255 * te[0]), l[w + 1] = ~~(0.5 + 255 * te[1]), l[w + 2] = ~~(0.5 + 255 * te[2]);
        } else {
          var P = 255 - c[T], E = 255 - c[T + 1], z = 255 - c[T + 2], H = (255 - c[T + 3]) * (1 / 255);
          l[w] = ~~(P * H + 0.5), l[w + 1] = ~~(E * H + 0.5), l[w + 2] = ~~(z * H + 0.5);
        }
        l[w + 3] = 255 * (1 - Q) + c[T + 4] * Q;
      }
    else if (d == 6 && t.t278)
      for (var q = t.t278[0], m = 0; m < a; m += q)
        for (var g = m * s, B = q * s, F = 0; F < B; F++) {
          var w = 4 * (g + F), T = 3 * g + 4 * (F >>> 1), z = c[T + (F & 1)], U = c[T + 2] - 128, J = c[T + 3] - 128, fe = z + ((J >> 2) + (J >> 3) + (J >> 5)), re = z - ((U >> 2) + (U >> 4) + (U >> 5)) - ((J >> 1) + (J >> 3) + (J >> 4) + (J >> 5)), ce = z + (U + (U >> 1) + (U >> 2) + (U >> 6));
          l[w] = Math.max(0, Math.min(255, fe)), l[w + 1] = Math.max(0, Math.min(255, re)), l[w + 2] = Math.max(0, Math.min(255, ce)), l[w + 3] = 255;
        }
    else if (d == 8) {
      if (h != 3 || u != 16)
        throw "e";
      for (var ge = new Uint16Array(c.buffer), we = new Int16Array(c.buffer), E = [
        3.1338561,
        -1.6168667,
        -0.4906146,
        -0.9787684,
        1.9161415,
        0.033454,
        0.0719453,
        -0.2289914,
        1.4052427
      ], m = 0; m < a; m++)
        for (var M = 0; M < s; M++) {
          var g = m * s + M, w = g * 4, v = g * 3, ue = ge[v] * (100 / 65535), pe = we[v + 1] * (255 / 65535), ce = we[v + 2] * (255 / 65535), le = 903.3, de = 8856e-6, Me = (ue + 16) / 116, Ye = Me * Me * Me, Ke = Me - ce / 200, at = Ke * Ke * Ke, Ne = pe / 500 + Me, ze = Ne * Ne * Ne, bt = at > de ? at : (116 * Ke - 16) / le, it = Ye > de ? Ye : (116 * Me - 16) / le, Vt = ze > de ? ze : (116 * Ne - 16) / le, ie = Vt * (96.42 / 100), z = it * (100 / 100), be = bt * (82.49 / 100);
          l[w] = Math.max(0, Math.min(255, r(ie * E[0] + z * E[1] + be * E[2]) * 255)), l[w + 1] = Math.max(0, Math.min(255, r(ie * E[3] + z * E[4] + be * E[5]) * 255)), l[w + 2] = Math.max(0, Math.min(255, r(ie * E[6] + z * E[7] + be * E[8]) * 255)), l[w + 3] = 255;
        }
    } else if (d == 32845)
      for (var m = 0; m < a; m++)
        for (var M = 0; M < s; M++) {
          var T = (m * s + M) * 6, w = (m * s + M) * 4, ue = c[T + 1] << 8 | c[T], ue = Math.pow(2, (ue + 0.5) / 256 - 64), _e = (c[T + 3] + 0.5) / 410, O = (c[T + 5] + 0.5) / 410, K = 9 * _e / (6 * _e - 16 * O + 12), ee = 4 * O / (6 * _e - 16 * O + 12), ae = ue, ie = K * ae / ee, z = ae, be = (1 - K - ee) * ae / ee, fe = 2.69 * ie - 1.276 * z - 0.414 * be, re = -1.022 * ie + 1.978 * z + 0.044 * be, ce = 0.061 * ie - 0.224 * z + 1.163 * be;
          l[w] = r(Math.min(fe, 1)) * 255, l[w + 1] = r(Math.min(re, 1)) * 255, l[w + 2] = r(Math.min(ce, 1)) * 255, l[w + 3] = 255;
        }
    else
      Et("Unknown Photometric interpretation: " + d);
    return l;
  }, e.replaceIMG = function(t) {
    t == null && (t = document.getElementsByTagName("img"));
    for (var n = ["tif", "tiff", "dng", "cr2", "nef"], r = 0; r < t.length; r++) {
      var s = t[r], a = s.getAttribute("src");
      if (a != null) {
        var o = a.split(".").pop().toLowerCase();
        if (n.indexOf(o) != -1) {
          var c = new XMLHttpRequest();
          e._xhrs.push(c), e._imgs.push(s), c.open("GET", a), c.responseType = "arraybuffer", c.onload = e._imgLoaded, c.send();
        }
      }
    }
  }, e._xhrs = [], e._imgs = [], e._imgLoaded = function(t) {
    var n = e._xhrs.indexOf(t.target), r = e._imgs[n];
    e._xhrs.splice(n, 1), e._imgs.splice(n, 1), r.setAttribute("src", e.bufferToURI(t.target.response));
  }, e.bufferToURI = function(t) {
    var n = e.decode(t), r = n, s = 0, a = r[0];
    n[0].subIFD && (r = r.concat(n[0].subIFD));
    for (var o = 0; o < r.length; o++) {
      var c = r[o];
      if (!(c.t258 == null || c.t258.length < 3)) {
        var l = c.t256 * c.t257;
        l > s && (s = l, a = c);
      }
    }
    e.decodeImage(t, a, n);
    var d = e.toRGBA8(a), u = a.width, h = a.height, f = document.createElement("canvas");
    f.width = u, f.height = h;
    var p = f.getContext("2d"), m = new ImageData(new Uint8ClampedArray(d.buffer), u, h);
    return p.putImageData(m, 0, 0), f.toDataURL();
  }, e._binBE = {
    nextZero: function(t, n) {
      for (; t[n] != 0; )
        n++;
      return n;
    },
    readUshort: function(t, n) {
      return t[n] << 8 | t[n + 1];
    },
    readShort: function(t, n) {
      var r = e._binBE.ui8;
      return r[0] = t[n + 1], r[1] = t[n + 0], e._binBE.i16[0];
    },
    readInt: function(t, n) {
      var r = e._binBE.ui8;
      return r[0] = t[n + 3], r[1] = t[n + 2], r[2] = t[n + 1], r[3] = t[n + 0], e._binBE.i32[0];
    },
    readUint: function(t, n) {
      var r = e._binBE.ui8;
      return r[0] = t[n + 3], r[1] = t[n + 2], r[2] = t[n + 1], r[3] = t[n + 0], e._binBE.ui32[0];
    },
    readASCII: function(t, n, r) {
      for (var s = "", a = 0; a < r; a++)
        s += String.fromCharCode(t[n + a]);
      return s;
    },
    readFloat: function(t, n) {
      for (var r = e._binBE.ui8, s = 0; s < 4; s++)
        r[s] = t[n + 3 - s];
      return e._binBE.fl32[0];
    },
    readDouble: function(t, n) {
      for (var r = e._binBE.ui8, s = 0; s < 8; s++)
        r[s] = t[n + 7 - s];
      return e._binBE.fl64[0];
    },
    writeUshort: function(t, n, r) {
      t[n] = r >> 8 & 255, t[n + 1] = r & 255;
    },
    writeInt: function(t, n, r) {
      var s = e._binBE.ui8;
      e._binBE.i32[0] = r, t[n + 3] = s[0], t[n + 2] = s[1], t[n + 1] = s[2], t[n + 0] = s[3];
    },
    writeUint: function(t, n, r) {
      t[n] = r >> 24 & 255, t[n + 1] = r >> 16 & 255, t[n + 2] = r >> 8 & 255, t[n + 3] = r >> 0 & 255;
    },
    writeASCII: function(t, n, r) {
      for (var s = 0; s < r.length; s++)
        t[n + s] = r.charCodeAt(s);
    },
    writeDouble: function(t, n, r) {
      e._binBE.fl64[0] = r;
      for (var s = 0; s < 8; s++)
        t[n + s] = e._binBE.ui8[7 - s];
    }
  }, e._binBE.ui8 = new Uint8Array(8), e._binBE.i16 = new Int16Array(e._binBE.ui8.buffer), e._binBE.i32 = new Int32Array(e._binBE.ui8.buffer), e._binBE.ui32 = new Uint32Array(e._binBE.ui8.buffer), e._binBE.fl32 = new Float32Array(e._binBE.ui8.buffer), e._binBE.fl64 = new Float64Array(e._binBE.ui8.buffer), e._binLE = {
    nextZero: e._binBE.nextZero,
    readUshort: function(t, n) {
      return t[n + 1] << 8 | t[n];
    },
    readShort: function(t, n) {
      var r = e._binBE.ui8;
      return r[0] = t[n + 0], r[1] = t[n + 1], e._binBE.i16[0];
    },
    readInt: function(t, n) {
      var r = e._binBE.ui8;
      return r[0] = t[n + 0], r[1] = t[n + 1], r[2] = t[n + 2], r[3] = t[n + 3], e._binBE.i32[0];
    },
    readUint: function(t, n) {
      var r = e._binBE.ui8;
      return r[0] = t[n + 0], r[1] = t[n + 1], r[2] = t[n + 2], r[3] = t[n + 3], e._binBE.ui32[0];
    },
    readASCII: e._binBE.readASCII,
    readFloat: function(t, n) {
      for (var r = e._binBE.ui8, s = 0; s < 4; s++)
        r[s] = t[n + s];
      return e._binBE.fl32[0];
    },
    readDouble: function(t, n) {
      for (var r = e._binBE.ui8, s = 0; s < 8; s++)
        r[s] = t[n + s];
      return e._binBE.fl64[0];
    },
    writeUshort: function(t, n, r) {
      t[n] = r & 255, t[n + 1] = r >> 8 & 255;
    },
    writeInt: function(t, n, r) {
      var s = e._binBE.ui8;
      e._binBE.i32[0] = r, t[n + 0] = s[0], t[n + 1] = s[1], t[n + 2] = s[2], t[n + 3] = s[3];
    },
    writeUint: function(t, n, r) {
      t[n] = r >>> 0 & 255, t[n + 1] = r >>> 8 & 255, t[n + 2] = r >>> 16 & 255, t[n + 3] = r >>> 24 & 255;
    },
    writeASCII: e._binBE.writeASCII
  }, e._copyTile = function(t, n, r, s, a, o, c, l) {
    for (var d = Math.min(n, a - c), u = Math.min(r, o - l), h = 0; h < u; h++)
      for (var f = (l + h) * a + c, p = h * n, m = 0; m < d; m++)
        s[f + m] = t[p + m];
  }, e._inflateRaw = function() {
    var t = {};
    return t.H = {}, t.H.N = function(n, r) {
      var s = Uint8Array, a = 0, o = 0, c = 0, l = 0, d = 0, u = 0, h = 0, f = 0, p = 0, m, C;
      if (n[0] == 3 && n[1] == 0)
        return r || new s(0);
      var y = t.H, g = y.b, w = y.e, x = y.R, S = y.n, N = y.A, v = y.Z, b = y.m, j = r == null;
      for (j && (r = new s(n.length >>> 2 << 5)); a == 0; ) {
        if (a = g(n, p, 1), o = g(n, p + 1, 2), p += 3, o == 0) {
          p & 7 && (p += 8 - (p & 7));
          var D = (p >>> 3) + 4, $ = n[D - 4] | n[D - 3] << 8;
          j && (r = t.H.W(r, f + $)), r.set(new s(n.buffer, n.byteOffset + D, $), f), p = D + $ << 3, f += $;
          continue;
        }
        if (j && (r = t.H.W(r, f + (1 << 17))), o == 1 && (m = b.J, C = b.h, u = 512 - 1, h = 32 - 1), o == 2) {
          c = w(n, p, 5) + 257, l = w(n, p + 5, 5) + 1, d = w(n, p + 10, 4) + 4, p += 14;
          for (var _ = 1, L = 0; L < 38; L += 2)
            b.Q[L] = 0, b.Q[L + 1] = 0;
          for (var L = 0; L < d; L++) {
            var I = w(n, p + L * 3, 3);
            b.Q[(b.X[L] << 1) + 1] = I, I > _ && (_ = I);
          }
          p += 3 * d, S(b.Q, _), N(b.Q, _, b.u), m = b.w, C = b.d, p = x(b.u, (1 << _) - 1, c + l, n, p, b.v);
          var A = y.V(b.v, 0, c, b.C);
          u = (1 << A) - 1;
          var M = y.V(b.v, c, l, b.D);
          h = (1 << M) - 1, S(b.C, A), N(b.C, A, m), S(b.D, M), N(b.D, M, C);
        }
        for (; ; ) {
          var G = m[v(n, p) & u];
          p += G & 15;
          var Z = G >>> 4;
          if (!(Z >>> 8))
            r[f++] = Z;
          else {
            if (Z == 256)
              break;
            var Q = f + Z - 254;
            if (Z > 264) {
              var T = b.q[Z - 257];
              Q = f + (T >>> 3) + w(n, p, T & 7), p += T & 7;
            }
            var P = C[v(n, p) & h];
            p += P & 15;
            var E = P >>> 4, z = b.c[E], H = (z >>> 4) + g(n, p, z & 15);
            for (p += z & 15; f < Q; )
              r[f] = r[f++ - H], r[f] = r[f++ - H], r[f] = r[f++ - H], r[f] = r[f++ - H];
            f = Q;
          }
        }
      }
      return r.length == f ? r : r.slice(0, f);
    }, t.H.W = function(n, r) {
      var s = n.length;
      if (r <= s)
        return n;
      var a = new Uint8Array(s << 1);
      return a.set(n, 0), a;
    }, t.H.R = function(n, r, s, a, o, c) {
      for (var l = t.H.e, d = t.H.Z, u = 0; u < s; ) {
        var h = n[d(a, o) & r];
        o += h & 15;
        var f = h >>> 4;
        if (f <= 15)
          c[u] = f, u++;
        else {
          var p = 0, m = 0;
          f == 16 ? (m = 3 + l(a, o, 2), o += 2, p = c[u - 1]) : f == 17 ? (m = 3 + l(a, o, 3), o += 3) : f == 18 && (m = 11 + l(a, o, 7), o += 7);
          for (var C = u + m; u < C; )
            c[u] = p, u++;
        }
      }
      return o;
    }, t.H.V = function(n, r, s, a) {
      for (var o = 0, c = 0, l = a.length >>> 1; c < s; ) {
        var d = n[c + r];
        a[c << 1] = 0, a[(c << 1) + 1] = d, d > o && (o = d), c++;
      }
      for (; c < l; )
        a[c << 1] = 0, a[(c << 1) + 1] = 0, c++;
      return o;
    }, t.H.n = function(n, r) {
      for (var s = t.H.m, a = n.length, o, c, l, d, u, h = s.j, d = 0; d <= r; d++)
        h[d] = 0;
      for (d = 1; d < a; d += 2)
        h[n[d]]++;
      var f = s.K;
      for (o = 0, h[0] = 0, c = 1; c <= r; c++)
        o = o + h[c - 1] << 1, f[c] = o;
      for (l = 0; l < a; l += 2)
        u = n[l + 1], u != 0 && (n[l] = f[u], f[u]++);
    }, t.H.A = function(n, r, s) {
      for (var a = n.length, o = t.H.m, c = o.r, l = 0; l < a; l += 2)
        if (n[l + 1] != 0)
          for (var d = l >> 1, u = n[l + 1], h = d << 4 | u, f = r - u, p = n[l] << f, m = p + (1 << f); p != m; ) {
            var C = c[p] >>> 15 - r;
            s[C] = h, p++;
          }
    }, t.H.l = function(n, r) {
      for (var s = t.H.m.r, a = 15 - r, o = 0; o < n.length; o += 2) {
        var c = n[o] << r - n[o + 1];
        n[o] = s[c] >>> a;
      }
    }, t.H.M = function(n, r, s) {
      s = s << (r & 7);
      var a = r >>> 3;
      n[a] |= s, n[a + 1] |= s >>> 8;
    }, t.H.I = function(n, r, s) {
      s = s << (r & 7);
      var a = r >>> 3;
      n[a] |= s, n[a + 1] |= s >>> 8, n[a + 2] |= s >>> 16;
    }, t.H.e = function(n, r, s) {
      return (n[r >>> 3] | n[(r >>> 3) + 1] << 8) >>> (r & 7) & (1 << s) - 1;
    }, t.H.b = function(n, r, s) {
      return (n[r >>> 3] | n[(r >>> 3) + 1] << 8 | n[(r >>> 3) + 2] << 16) >>> (r & 7) & (1 << s) - 1;
    }, t.H.Z = function(n, r) {
      return (n[r >>> 3] | n[(r >>> 3) + 1] << 8 | n[(r >>> 3) + 2] << 16) >>> (r & 7);
    }, t.H.i = function(n, r) {
      return (n[r >>> 3] | n[(r >>> 3) + 1] << 8 | n[(r >>> 3) + 2] << 16 | n[(r >>> 3) + 3] << 24) >>> (r & 7);
    }, t.H.m = function() {
      var n = Uint16Array, r = Uint32Array;
      return {
        K: new n(16),
        j: new n(16),
        X: [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15],
        S: [
          3,
          4,
          5,
          6,
          7,
          8,
          9,
          10,
          11,
          13,
          15,
          17,
          19,
          23,
          27,
          31,
          35,
          43,
          51,
          59,
          67,
          83,
          99,
          115,
          131,
          163,
          195,
          227,
          258,
          999,
          999,
          999
        ],
        T: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          1,
          1,
          1,
          1,
          2,
          2,
          2,
          2,
          3,
          3,
          3,
          3,
          4,
          4,
          4,
          4,
          5,
          5,
          5,
          5,
          0,
          0,
          0,
          0
        ],
        q: new n(32),
        p: [
          1,
          2,
          3,
          4,
          5,
          7,
          9,
          13,
          17,
          25,
          33,
          49,
          65,
          97,
          129,
          193,
          257,
          385,
          513,
          769,
          1025,
          1537,
          2049,
          3073,
          4097,
          6145,
          8193,
          12289,
          16385,
          24577,
          65535,
          65535
        ],
        z: [
          0,
          0,
          0,
          0,
          1,
          1,
          2,
          2,
          3,
          3,
          4,
          4,
          5,
          5,
          6,
          6,
          7,
          7,
          8,
          8,
          9,
          9,
          10,
          10,
          11,
          11,
          12,
          12,
          13,
          13,
          0,
          0
        ],
        c: new r(32),
        J: new n(512),
        _: [],
        h: new n(32),
        $: [],
        w: new n(32768),
        C: [],
        v: [],
        d: new n(32768),
        D: [],
        u: new n(512),
        Q: [],
        r: new n(32768),
        s: new r(286),
        Y: new r(30),
        a: new r(19),
        t: new r(15e3),
        k: new n(65536),
        g: new n(32768)
      };
    }(), function() {
      for (var n = t.H.m, r = 32768, s = 0; s < r; s++) {
        var a = s;
        a = (a & 2863311530) >>> 1 | (a & 1431655765) << 1, a = (a & 3435973836) >>> 2 | (a & 858993459) << 2, a = (a & 4042322160) >>> 4 | (a & 252645135) << 4, a = (a & 4278255360) >>> 8 | (a & 16711935) << 8, n.r[s] = (a >>> 16 | a << 16) >>> 17;
      }
      function o(c, l, d) {
        for (; l-- != 0; )
          c.push(0, d);
      }
      for (var s = 0; s < 32; s++)
        n.q[s] = n.S[s] << 3 | n.T[s], n.c[s] = n.p[s] << 4 | n.z[s];
      o(n._, 144, 8), o(n._, 255 - 143, 9), o(n._, 279 - 255, 7), o(n._, 287 - 279, 8), t.H.n(n._, 9), t.H.A(n._, 9, n.J), t.H.l(n._, 9), o(n.$, 32, 5), t.H.n(n.$, 5), t.H.A(n.$, 5, n.h), t.H.l(n.$, 5), o(n.Q, 19, 0), o(n.C, 286, 0), o(n.D, 30, 0), o(n.v, 320, 0);
    }(), t.H.N;
  }(), e.LosslessJpegDecode = function() {
    var t, n;
    function r() {
      return t[n++];
    }
    function s() {
      return t[n++] << 8 | t[n++];
    }
    function a(g) {
      for (var w = r(), x = [0, 0, 0, 255], S = [], N = 8, v = 0; v < 16; v++)
        S[v] = r();
      for (var v = 0; v < 16; v++)
        for (var b = 0; b < S[v]; b++) {
          var j = o(x, 0, v + 1, 1);
          x[j + 3] = r();
        }
      var D = new Uint8Array(1 << N);
      g[w] = [new Uint8Array(x), D];
      for (var v = 0; v < 1 << N; v++) {
        for (var $ = N, _ = v, L = 0, I = 0; x[L + 3] == 255 && $ != 0; )
          I = _ >> --$ & 1, L = x[L + I];
        D[v] = L;
      }
    }
    function o(g, w, x, S) {
      if (g[w + 3] != 255)
        return 0;
      if (x == 0)
        return w;
      for (var N = 0; N < 2; N++) {
        g[w + N] == 0 && (g[w + N] = g.length, g.push(0, 0, S, 255));
        var v = o(g, g[w + N], x - 1, S + 1);
        if (v != 0)
          return v;
      }
      return 0;
    }
    function c(g) {
      for (var w = g.c, x = g.f; w < 25 && g.d < g.a; ) {
        var S = g.data[g.d++];
        S == 255 && !g.b && g.d++, x = x << 8 | S, w += 8;
      }
      if (w < 0)
        throw "e";
      g.c = w, g.f = x;
    }
    function l(g, w) {
      return w.c < g && c(w), w.f >> (w.c -= g) & 65535 >> 16 - g;
    }
    function d(g, w) {
      var x = g[0], S = 0, N = 255, v = 0;
      w.c < 16 && c(w);
      var b = w.f >> w.c - 8 & 255;
      for (S = g[1][b], N = x[S + 3], w.c -= x[S + 2]; N == 255; )
        v = w.f >> --w.c & 1, S = x[S + v], N = x[S + 3];
      return N;
    }
    function u(g, w) {
      return g < 32768 >> 16 - w && (g += -(1 << w) + 1), g;
    }
    function h(g, w) {
      var x = d(g, w);
      if (x == 0)
        return 0;
      if (x == 16)
        return -32768;
      var S = l(x, w);
      return u(S, x);
    }
    function f(g, w, x, S, N, v) {
      for (var b = 0, j = 0; j < v; j++) {
        for (var D = j * w, $ = 0; $ < w; $ += N) {
          b++;
          for (var _ = 0; _ < N; _++)
            g[D + $ + _] = h(S[_], x);
        }
        if (x.e != 0 && b % x.e == 0 && j != 0) {
          for (var L = x.d, I = x.data; I[L] != 255 || !(208 <= I[L + 1] && I[L + 1] <= 215); )
            L--;
          x.d = L + 2, x.f = 0, x.c = 0;
        }
      }
    }
    function p(g, w) {
      return u(l(g, w), g);
    }
    function m(g, w, x, S, N) {
      for (var v = t.length - n, b = 0; b < v; b += 4) {
        var j = t[n + b];
        t[n + b] = t[n + b + 3], t[n + b + 3] = j;
        var j = t[n + b + 1];
        t[n + b + 1] = t[n + b + 2], t[n + b + 2] = j;
      }
      for (var D = 0; D < N; D++)
        for (var $ = 32768, _ = 32768, L = 0; L < w; L += 2) {
          var I = d(S, x), A = d(S, x);
          I != 0 && ($ += p(I, x)), A != 0 && (_ += p(A, x)), g[D * w + L] = $ & 65535, g[D * w + L + 1] = _ & 65535;
        }
    }
    function C(g) {
      if (t = g, n = 0, s() != 65496)
        throw "e";
      for (var w = [], x = 0, S = 0, N = 0, v = [], b = [], j = [], D = 0, $ = 0, _ = 0; ; ) {
        var L = s();
        if (L == 65535) {
          n--;
          continue;
        }
        var I = s();
        if (L == 65475) {
          S = r(), $ = s(), _ = s(), D = r();
          for (var A = 0; A < D; A++) {
            var M = r(), G = r(), Z = r();
            if (Z != 0)
              throw "e";
            w[M] = [A, G >> 4, G & 15];
          }
        } else if (L == 65476)
          for (var Q = n + I - 2; n < Q; )
            a(b);
        else if (L == 65498) {
          n++;
          for (var A = 0; A < D; A++) {
            var T = r(), P = w[T];
            j[P[0]] = b[r() >>> 4], v[P[0]] = P.slice(1);
          }
          x = r(), n += 2;
          break;
        } else
          L == 65501 ? N = s() : n += I - 2;
      }
      var E = S > 8 ? Uint16Array : Uint8Array, z = new E($ * _ * D), H = { c: 0, f: 0, b: x == 8, d: n, data: t, a: t.length, e: N };
      if (H.b)
        m(z, _ * D, H, j[0], $);
      else {
        for (var te = [], q = 0, B = 0, A = 0; A < D; A++) {
          var F = v[A], U = F[0], J = F[1];
          U > q && (q = U), J > B && (B = J), te.push(U * J);
        }
        if (q != 1 || B != 1) {
          if (D != 3 || te[1] != 1 || te[2] != 1 || q != 2 || B != 1 && B != 2)
            throw "e";
          for (var fe = [], re = 0, A = 0; A < D; A++) {
            for (var ce = 0; ce < te[A]; ce++)
              fe.push(j[A]);
            re += te[A];
          }
          var ge = _ / q, we = $ / B, ue = ge * we;
          f(z, ge * re, H, fe, re, we), y(z, x, ge, we, re - 2, re, re, S);
          var pe = new Uint16Array(ue * te[0]);
          if (q == 2 && B == 2) {
            for (var A = 0; A < ue; A++)
              pe[4 * A] = z[6 * A], pe[4 * A + 1] = z[6 * A + 1], pe[4 * A + 2] = z[6 * A + 2], pe[4 * A + 3] = z[6 * A + 3];
            y(pe, x, ge * 4, we, 0, 1, 1, S);
            for (var A = 0; A < ue; A++)
              z[6 * A] = pe[4 * A], z[6 * A + 1] = pe[4 * A + 1], z[6 * A + 2] = pe[4 * A + 2], z[6 * A + 3] = pe[4 * A + 3];
          }
          if (q == 2 && B == 1) {
            for (var A = 0; A < ue; A++)
              pe[2 * A] = z[4 * A], pe[2 * A + 1] = z[4 * A + 1];
            y(pe, x, ge * 2, we, 0, 1, 1, S);
            for (var A = 0; A < ue; A++)
              z[4 * A] = pe[2 * A], z[4 * A + 1] = pe[2 * A + 1];
          }
          for (var le = z.slice(0), J = 0; J < $; J++)
            if (B == 2)
              for (var U = 0; U < _; U++) {
                var de = (J * _ + U) * D, Me = ((J >>> 1) * ge + (U >>> 1)) * re, Ye = (J & 1) * 2 + (U & 1);
                z[de] = le[Me + Ye], z[de + 1] = le[Me + 4], z[de + 2] = le[Me + 5];
              }
            else
              for (var U = 0; U < _; U++) {
                var de = (J * _ + U) * D, Me = (J * ge + (U >>> 1)) * re, Ye = U & 1;
                z[de] = le[Me + Ye], z[de + 1] = le[Me + 2], z[de + 2] = le[Me + 3];
              }
        } else if (f(z, _ * D, H, j, D, $), N == 0)
          y(z, x, _, $, 0, D, D, S);
        else
          for (var Ke = Math.floor(N / _), J = 0; J < $; J += Ke) {
            var at = z.slice(J * _ * D, (J + Ke) * _ * D);
            y(at, x, _, Ke, 0, D, D, S), z.set(at, J * _ * D);
          }
      }
      return [z, _, $, D];
    }
    function y(g, w, x, S, N, v, b, j) {
      for (var D = x * b, $ = N; $ < v; $++)
        g[$] += 1 << j - 1;
      for (var _ = b; _ < D; _ += b)
        for (var $ = N; $ < v; $++)
          g[_ + $] += g[_ + $ - b];
      for (var L = 1; L < S; L++) {
        for (var I = L * D, $ = N; $ < v; $++)
          g[I + $] += g[I + $ - D];
        for (var _ = b; _ < D; _ += b)
          for (var $ = N; $ < v; $++) {
            var A = I + _ + $, M = A - D, G = g[A - b], Z = 0;
            if (w == 0)
              Z = 0;
            else if (w == 1)
              Z = G;
            else if (w == 2)
              Z = g[M];
            else if (w == 3)
              Z = g[M - b];
            else if (w == 4)
              Z = G + (g[M] - g[M - b]);
            else if (w == 5)
              Z = G + (g[M] - g[M - b] >>> 1);
            else if (w == 6)
              Z = g[M] + (G - g[M - b] >>> 1);
            else if (w == 7)
              Z = G + g[M] >>> 1;
            else
              throw w;
            g[A] += Z;
          }
      }
    }
    return C;
  }(), function() {
    var t = 0, n = 1, r = 2, s = 3, a = 4, o = 5, c = 6, l = 7, d = 8, u = 9, h = 10, f = 11, p = 12, m = 13, C = 14, y = 15, g = 16, w = 17, x = 18;
    function S(T) {
      var P = e._binBE.readUshort, E = {
        b: P(T, 0),
        i: T[2],
        C: T[3],
        u: T[4],
        q: P(T, 5),
        k: P(T, 7),
        e: P(T, 9),
        l: P(T, 11),
        s: T[13],
        d: P(T, 14)
      };
      if (E.b != 18771 || E.i > 1 || E.q < 6 || E.q % 6 || E.e < 768 || E.e % 24 || E.l != 768 || E.k < E.l || E.k % E.l || E.k - E.e >= E.l || E.s > 16 || E.s != E.k / E.l || E.s != Math.ceil(E.e / E.l) || E.d != E.q / 6 || E.u != 12 && E.u != 14 && E.u != 16 || E.C != 16 && E.C != 0)
        throw "Invalid data";
      if (E.i == 0)
        throw "Not implemented. We need this file!";
      return E.h = E.C == 16, E.m = (E.h ? E.l * 2 / 3 : E.l >>> 1) | 0, E.A = E.m + 2, E.f = 64, E.g = (1 << E.u) - 1, E.n = 4 * E.u, E;
    }
    function N(T, P) {
      var E = new Array(P.s), z = 4 * P.s, H = 16 + z;
      z & 12 && (H += 16 - (z & 12));
      for (var te = 0, q = 16; te < P.s; q += 4) {
        var B = e._binBE.readUint(T, q);
        E[te] = T.slice(H, H + B), E[te].j = 0, E[te].a = 0, H += B, te++;
      }
      if (H != T.length)
        throw "Invalid data";
      return E;
    }
    function v(T, P) {
      for (var E = -P[4], z = 0; E <= P[4]; z++, E++)
        T[z] = E <= -P[3] ? -4 : E <= -P[2] ? -3 : E <= -P[1] ? -2 : E < -P[0] ? -1 : E <= P[0] ? 0 : E < P[1] ? 1 : E < P[2] ? 2 : E < P[3] ? 3 : 4;
    }
    function b(T, P, E) {
      var z = [P, 3 * P + 18, 5 * P + 67, 7 * P + 276, E];
      T.o = P, T.w = (z[4] + 2 * P) / (2 * P + 1) + 1 | 0, T.v = Math.ceil(Math.log2(T.w)), T.t = 9, v(T.c, z);
    }
    function j(T) {
      var P = { c: new Int8Array(2 << T.u) };
      return b(P, 0, T.g), P;
    }
    function D(T) {
      for (var P = [[], [], []], E = Math.max(2, T.w + 32 >>> 6), z = 0; z < 3; z++)
        for (var H = 0; H < 41; H++)
          P[z][H] = [E, 1];
      return P;
    }
    function $(T) {
      for (var P = -1, E = 0; !E; P++)
        E = T[T.j] >>> 7 - T.a & 1, T.a++, T.a &= 7, T.a || T.j++;
      return P;
    }
    function _(T, P) {
      var E = 0, z = 8 - T.a;
      if (T.j, T.a, P) {
        if (P >= z)
          do
            E <<= z, P -= z, E |= T[T.j] & (1 << z) - 1, T.j++, z = 8;
          while (P >= 8);
        P && (E <<= P, z -= P, E |= T[T.j] >>> z & (1 << P) - 1), T.a = 8 - z;
      }
      return E;
    }
    function L(T, P) {
      var E = 0;
      if (P < T)
        for (; E <= 14 && P << ++E < T; )
          ;
      return E;
    }
    function I(T, P, E, z, H, te, q, B) {
      B == null && (B = 0);
      var F = te + 1, U = F % 2, J = 0, fe, re, ce = z[H], ge = z[H - 1], we = z[H - 2][F], ue = ge[F - 1], pe = ge[F], le = ge[F + 1], de = ce[F - 1], Me = ce[F + 1], Ye = Math.abs, Ke, at, Ne, ze;
      if (U && (Ke = Ye(le - pe), at = Ye(we - pe), Ne = Ye(ue - pe)), U) {
        if (ze = Ke > Ne && at < Ke ? we + ue : Ke < Ne && at < Ne ? we + le : le + ue, ze = ze + 2 * pe >>> 2, B) {
          ce[F] = ze;
          return;
        }
        fe = P.t * P.c[T.g + pe - we] + P.c[T.g + ue - pe];
      } else
        ze = pe > ue && pe > le || pe < ue && pe < le ? Me + de + 2 * pe >>> 2 : de + Me >>> 1, fe = P.t * P.c[T.g + pe - ue] + P.c[T.g + ue - de];
      re = Ye(fe);
      var bt = $(E);
      if (bt < T.n - P.v - 1) {
        var it = L(q[re][0], q[re][1]);
        J = _(E, it) + (bt << it);
      } else
        J = _(E, P.v) + 1;
      J = J & 1 ? -1 - (J >>> 1) : J >>> 1, q[re][0] += Ye(J), q[re][1] == T.f && (q[re][0] >>>= 1, q[re][1] >>>= 1), q[re][1]++, ze = fe < 0 ? ze - J : ze + J, T.i && (ze < 0 ? ze += P.w : ze > T.g && (ze -= P.w)), ce[F] = ze >= 0 ? Math.min(ze, T.g) : 0;
    }
    function A(T, P, E) {
      for (var z = T[0].length, H = P; H <= E; H++)
        T[H][0] = T[H - 1][1], T[H][z - 1] = T[H - 1][z - 2];
    }
    function M(T) {
      A(T, l, p), A(T, r, a), A(T, y, w);
    }
    function G(T, P, E, z, H, te, q, B, F, U, J, fe, re) {
      for (var ce = 0, ge = 1, we = H < m && H > a; ge < T.m; )
        ce < T.m && (I(T, P, E, z, H, ce, q[F], T.h && (we && U || !we && (J || (ce & fe) == re))), I(T, P, E, z, te, ce, q[F], T.h && (!we && U || we && (J || (ce & fe) == re))), ce += 2), ce > 8 && (I(T, P, E, z, H, ge, B[F]), I(T, P, E, z, te, ge, B[F]), ge += 2);
      M(z);
    }
    function Z(T, P, E, z, H, te) {
      G(T, P, E, z, r, l, H, te, 0, 0, 1, 0, 8), G(T, P, E, z, d, y, H, te, 1, 0, 1, 0, 8), G(T, P, E, z, s, u, H, te, 2, 1, 0, 3, 0), G(T, P, E, z, h, g, H, te, 0, 0, 0, 3, 2), G(T, P, E, z, a, f, H, te, 1, 0, 0, 3, 2), G(T, P, E, z, p, w, H, te, 2, 1, 0, 3, 0);
    }
    function Q(T, P, E, z, H, te) {
      var q = te.length, B = T.l;
      H + 1 == T.s && (B = T.e - H * T.l);
      for (var F = 6 * T.e * z + H * T.l, U = 0; U < 6; U++) {
        for (var J = 0; J < B; J++) {
          var fe = te[U % q][J % q], re;
          fe == 0 ? re = r + (U >>> 1) : fe == 2 ? re = y + (U >>> 1) : re = l + U;
          var ce = T.h ? (J * 2 / 3 & 2147483646 | J % 3 & 1) + (J % 3 >>> 1) : J >>> 1;
          P[F + J] = E[re][ce + 1];
        }
        F += T.e;
      }
    }
    e._decompressRAF = function(T, P) {
      var E = S(T), z = N(T, E), H = j(E), te = new Int16Array(E.e * E.q);
      P == null && (P = E.h ? [
        [1, 1, 0, 1, 1, 2],
        [1, 1, 2, 1, 1, 0],
        [2, 0, 1, 0, 2, 1],
        [1, 1, 2, 1, 1, 0],
        [1, 1, 0, 1, 1, 2],
        [0, 2, 1, 2, 0, 1]
      ] : [
        [0, 1],
        [3, 2]
      ]);
      for (var q = [
        [t, s],
        [n, a],
        [o, f],
        [c, p],
        [m, g],
        [C, w]
      ], B = [], F = 0; F < x; F++)
        B[F] = new Uint16Array(E.A);
      for (var U = 0; U < E.s; U++) {
        for (var J = D(H), fe = D(H), F = 0; F < x; F++)
          for (var re = 0; re < E.A; re++)
            B[F][re] = 0;
        for (var ce = 0; ce < E.d; ce++) {
          Z(E, H, z[U], B, J, fe);
          for (var F = 0; F < 6; F++)
            for (var re = 0; re < E.A; re++)
              B[q[F][0]][re] = B[q[F][1]][re];
          Q(E, te, B, ce, U, P);
          for (var F = r; F < x; F++)
            if ([o, c, m, C].indexOf(F) == -1)
              for (var re = 0; re < E.A; re++)
                B[F][re] = 0;
          M(B);
        }
      }
      return te;
    };
  }();
})(Ws);
function JB(e, t = 0) {
  const n = Ws.decode(e);
  if (n.length <= t)
    throw new Error("Tiff page number requested is out of bounds");
  const r = n[t];
  "t270" in r && Array.isArray(r.t270) || (r.t270 = [""]), Ws.decodeImage(e, r);
  const s = Ws.toRGBA8(n[0]), a = document.createElement("canvas");
  a.width = r.width, a.height = r.height;
  const o = a.getContext("2d");
  if (!o)
    throw new Error("Could not get 2d context");
  const c = o.createImageData(a.width, a.height);
  return c.data.set(s), o.putImageData(c, 0, 0), {
    dataUrl: a.toDataURL(),
    description: `${r.t270[0]}`,
    pageCount: n.length
  };
}
const Zn = ({ header: e, children: t, className: n }) => /* @__PURE__ */ i.jsxs("div", { className: W("ctw-alert-bg ctw-rounded-md ctw-bg-error-bg", n), children: [
  /* @__PURE__ */ i.jsx(cs, { className: "ctw-h-5 ctw-flex-none ctw-text-error-icon" }),
  /* @__PURE__ */ i.jsxs("div", { className: "ctw-space-y-2", children: [
    /* @__PURE__ */ i.jsx("div", { className: "ctw-font-medium ctw-text-error-text", children: e }),
    t && /* @__PURE__ */ i.jsx("div", { className: "ctw-text-error-message", children: t })
  ] })
] }), iK = ({ header: e, children: t, className: n }) => /* @__PURE__ */ i.jsxs("div", { className: W("ctw-alert-bg ctw-rounded-md ctw-bg-caution-bg", n), children: [
  /* @__PURE__ */ i.jsx(MB, { className: "ctw-h-5 ctw-flex-none ctw-text-caution-icon" }),
  /* @__PURE__ */ i.jsxs("div", { className: "ctw-space-y-2", children: [
    /* @__PURE__ */ i.jsx("div", { className: "ctw-font-medium ctw-text-caution-text", children: e }),
    t && /* @__PURE__ */ i.jsx("div", { className: "ctw-text-caution-text", children: t })
  ] })
] }), an = ({ className: e }) => /* @__PURE__ */ i.jsxs(
  "svg",
  {
    className: W("ctw-inline ctw-h-4 ctw-w-4 ctw-animate-spin", e),
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    children: [
      /* @__PURE__ */ i.jsx(
        "circle",
        {
          className: "ctw-opacity-25",
          cx: "12",
          cy: "12",
          r: "10",
          stroke: "currentColor",
          strokeWidth: "4"
        }
      ),
      /* @__PURE__ */ i.jsx(
        "path",
        {
          className: "ctw-opacity-75",
          fill: "currentColor",
          d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        }
      )
    ]
  }
), Je = ({
  className: e = "ctw-text-sm",
  iconClass: t,
  message: n = "Loading..."
}) => /* @__PURE__ */ i.jsxs("div", { className: W("ctw-space-x-2 ctw-flex ctw-items-center  ctw-m-auto", e), children: [
  /* @__PURE__ */ i.jsx(an, { className: t }),
  n && /* @__PURE__ */ i.jsx("span", { className: "ctw-italic", children: n })
] });
const xf = ["/xml", "/xhtml+xml", "application/xml", "text/xml"], bf = ["/tif", "/tiff"], XB = ["/jpg", "/jpeg", "/png", "/apng", "/avif", "/gif", "/webp", "/svg+xml"], Jr = (e, t) => e.some((n) => t.includes(n)), eU = ({ data: e, blob: t, contentType: n, overridePatient: r }) => {
  const [s, a] = Y();
  he(() => {
    Jr(bf, n) && V(void 0, null, function* () {
      a(yield t.arrayBuffer());
    });
  }, [t, n]);
  const o = ke(() => {
    if (Jr(bf, n))
      return /* @__PURE__ */ i.jsx(tU, { data: s });
    if (Jr(XB, n)) {
      const c = URL.createObjectURL(t);
      return /* @__PURE__ */ i.jsx(
        "img",
        {
          src: c,
          alt: "",
          className: "ctw-h-full ctw-max-h-[95vh] ctw-w-auto ctw-object-contain"
        }
      );
    }
    if (n.includes("/pdf"))
      return /* @__PURE__ */ i.jsx(nU, { data: t });
    if (Jr(xf, n)) {
      const c = new tv({
        locator: {},
        errorHandler: () => null
      }).parseFromString(e, n);
      if (k.select1("//*[name()='patientRole']", c))
        return c;
    }
  }, [n, e, s, t]);
  return /* @__PURE__ */ i.jsx(i.Fragment, { children: o && Jr(xf, n) ? /* @__PURE__ */ i.jsx(KB, { document: o, overridePatient: r }) : /* @__PURE__ */ i.jsx("div", { className: "ctw-space-y-4 ctw-w-full", children: /* @__PURE__ */ i.jsx(
    "div",
    {
      className: o ? "ctw-flex ctw-flex-col ctw-p-4 ctw-items-center" : "ctw-ccda-base64-binary-text",
      children: o != null ? o : e
    }
  ) }) });
};
function tU({ data: e }) {
  if (!e)
    return /* @__PURE__ */ i.jsx(Je, {});
  const { dataUrl: t, description: n } = JB(e);
  return /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
    /* @__PURE__ */ i.jsx("img", { src: t, alt: n, className: "ctw-h-full ctw-max-h-[95vh] ctw-w-auto" }),
    /* @__PURE__ */ i.jsx("p", { className: "ctw-text-sm ctw-text-content-lighter ctw-leading-relaxed", children: n })
  ] });
}
function nU({ data: e }) {
  try {
    const t = URL.createObjectURL(e);
    return /* @__PURE__ */ i.jsx("div", { className: "ctw-pdf-viewer ctw-min-w-full ctw-w-[450px] sm:ctw-w-[645px] md:ctw-w-[750px] lg:ctw-w-[960px]", children: /* @__PURE__ */ i.jsx(Xw, { fileUrl: t }) });
  } catch (t) {
    return console.warn(t), /* @__PURE__ */ i.jsx(Zn, { header: "Error loading PDF", children: "Unable to preview this PDF file in the web browser." });
  }
}
function rU(e, t) {
  const n = URL.createObjectURL(e), r = document.createElement("a");
  r.href = n, r.download = t || "", document.body.appendChild(r), r.click(), document.body.removeChild(r), setTimeout(() => {
    URL.revokeObjectURL(n);
  }, 100);
}
const zi = ({
  children: e,
  onClose: t,
  actions: n,
  patient: r,
  binaryId: s
}) => /* @__PURE__ */ i.jsxs("div", { className: "ctw-text-lg ctw-w-full", children: [
  /* @__PURE__ */ i.jsx(
    aO,
    {
      onClose: t,
      actions: n,
      overridePatient: r,
      binaryId: s
    }
  ),
  e
] });
function i0({ className: e }) {
  return /* @__PURE__ */ i.jsx(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "3.75 1.5 12.5 17.5",
      xmlns: "http://www.w3.org/2000/svg",
      className: e,
      children: /* @__PURE__ */ i.jsx(
        "path",
        {
          d: "M6 2H11V6C11 6.5625 11.4375 7 12 7H16V16C16 17.125 15.0938 18 14 18H6C4.875 18 4 17.125 4 16V4C4 2.90625 4.875 2 6 2ZM12 2L16 6H12V2ZM7.5 10C7.21875 10 7 10.25 7 10.5C7 10.7812 7.21875 11 7.5 11H12.5C12.75 11 13 10.7812 13 10.5C13 10.25 12.75 10 12.5 10H7.5ZM7.5 12C7.21875 12 7 12.25 7 12.5C7 12.7812 7.21875 13 7.5 13H12.5C12.75 13 13 12.7812 13 12.5C13 12.25 12.75 12 12.5 12H7.5ZM7.5 14C7.21875 14 7 14.25 7 14.5C7 14.7812 7.21875 15 7.5 15H12.5C12.75 15 13 14.7812 13 14.5C13 14.25 12.75 14 12.5 14H7.5Z"
        }
      )
    }
  );
}
function sU({ className: e }) {
  return /* @__PURE__ */ i.jsx(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "3.75 1.5 12.5 17.5",
      xmlns: "http://www.w3.org/2000/svg",
      className: e,
      children: /* @__PURE__ */ i.jsx(
        "path",
        {
          d: "M6 2H11V6C11 6.5625 11.4375 7 12 7H16V16C16 17.125 15.0938 18 14 18H6C4.875 18 4 17.125 4 16V4C4 2.90625 4.875 2 6 2ZM12 2L16 6H12V2ZM8 10C8 9.46875 7.53125 9 7 9C6.4375 9 6 9.46875 6 10C6 10.5625 6.4375 11 7 11C7.53125 11 8 10.5625 8 10ZM10.75 11V11.0312C10.5625 11.0312 10.4062 11.0938 10.3125 11.2188L8.8125 13.4375L8.40625 12.75C8.3125 12.5938 8.15625 12.5 8 12.5C7.8125 12.5 7.65625 12.5938 7.5625 12.75L6.0625 15.25C5.96875 15.4062 5.96875 15.5938 6.0625 15.75C6.125 15.9062 6.3125 16 6.5 16H8H9.5H10.75H13.5C13.6875 16 13.8438 15.9062 13.9375 15.75C14 15.5938 14 15.375 13.9062 15.2188L11.1562 11.2188C11.0625 11.0938 10.9062 11 10.75 11Z"
        }
      )
    }
  );
}
function aU({ className: e }) {
  return /* @__PURE__ */ i.jsx(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "3.75 1.5 12.5 17.5",
      xmlns: "http://www.w3.org/2000/svg",
      className: e,
      children: /* @__PURE__ */ i.jsx(
        "path",
        {
          d: "M6 2H11V6C11 6.5625 11.4375 7 12 7H16V16C16 17.125 15.0938 18 14 18H6C4.875 18 4 17.125 4 16V4C4 2.90625 4.875 2 6 2ZM12 2L16 6H12V2ZM6 9C5.71875 9 5.5 9.25 5.5 9.5V12V13.5C5.5 13.7812 5.71875 14 6 14C6.25 14 6.5 13.7812 6.5 13.5V12.5H6.75C7.6875 12.5 8.5 11.7188 8.5 10.75C8.5 9.8125 7.6875 9 6.75 9H6ZM6.75 11.5H6.5V10H6.75C7.15625 10 7.5 10.3438 7.5 10.75C7.5 11.1875 7.15625 11.5 6.75 11.5ZM9 9.5V13.5C9 13.7812 9.21875 14 9.5 14H10.25C11.0625 14 11.75 13.3438 11.75 12.5V10.5C11.75 9.6875 11.0625 9 10.25 9H9.5C9.21875 9 9 9.25 9 9.5ZM10 13V10H10.25C10.5 10 10.75 10.25 10.75 10.5V12.5C10.75 12.7812 10.5 13 10.25 13H10ZM13 9C12.7188 9 12.5 9.25 12.5 9.5V11.5V13.5C12.5 13.7812 12.7188 14 13 14C13.25 14 13.5 13.7812 13.5 13.5V12H14.5C14.75 12 15 11.7812 15 11.5C15 11.25 14.75 11 14.5 11H13.5V10H14.5C14.75 10 15 9.78125 15 9.5C15 9.25 14.75 9 14.5 9H13Z"
        }
      )
    }
  );
}
const iU = /^image\//i, oU = /^application\/.*(pdf|fdf)$/i;
function cl({
  contentType: e,
  className: t = "ctw-fill-current ctw-w-4 ctw-h-4"
}) {
  return iU.test(e) ? /* @__PURE__ */ i.jsx(sU, { className: t }) : oU.test(e) ? /* @__PURE__ */ i.jsx(aU, { className: t }) : /* @__PURE__ */ i.jsx(i0, { className: t });
}
function ll(e, t) {
  for (let n = 0; n < e.length; n += 1) {
    const r = e[n];
    if (fn(r.target, (a) => {
      var o;
      return (o = a.reference) == null ? void 0 : o.includes(t);
    }) && tl(r)) {
      const a = Ue(r.entity, { role: "source" });
      if (a != null && a.what.reference)
        return a.what.reference.split("/")[1];
    }
  }
}
function cU(e, t, n) {
  return V(this, null, function* () {
    var r, s;
    if (t instanceof hn)
      return t.binaryId;
    if (!t)
      return null;
    if (t instanceof hn)
      return (r = t.binaryId) != null ? r : null;
    if (n && !t.isSummaryResource) {
      const a = yield nl(e, [t]);
      return (s = ll(a, t.id)) != null ? s : null;
    }
    return null;
  });
}
function o0(e, t, n) {
  return Oe(
    Tg,
    [e, t],
    (r) => cU(r, e, t),
    n
  );
}
function lU(e) {
  return V(this, null, function* () {
    const t = new FileReader();
    return new Promise((n, r) => {
      t.readAsDataURL(e), t.onload = () => {
        var l, d;
        const s = (d = (l = t.result) == null ? void 0 : l.toString().split(",")[1]) != null ? d : "", a = atob(s), o = new Uint8Array(a.length);
        for (let u = 0; u < a.length; u += 1)
          o[u] = a.charCodeAt(u);
        const c = new TextDecoder().decode(o);
        n(c);
      }, t.onerror = (s) => {
        r(s);
      };
    });
  });
}
function dU(e, t) {
  return V(this, null, function* () {
    const { data: n, headers: r } = yield e.fetchFromFqs(`Binary/${t}`, {
      method: "GET"
    });
    if (n instanceof Blob)
      return {
        binary: {
          blob: n,
          data: yield lU(n),
          contentType: r.get("Content-Type") || "unknown",
          resourceType: "Binary"
        }
      };
    throw new Error("Response from FQS was not a Blob");
  });
}
const uU = (e) => Jt(
  Eg,
  [e],
  (t) => V(void 0, null, function* () {
    return dl(t, e);
  }),
  !0
), dl = Yc(dU, "query_request_timing", [
  `query_key:${Eg}`
]);
function fU(e, t) {
  return V(this, null, function* () {
    var s, a;
    const n = yield e.fetchFromFqs(`rest/Binary/${t}`, {
      method: "GET",
      headers: {
        Accept: "application/fhir+json"
      }
    }), r = (a = Ue((s = n.data.meta) == null ? void 0 : s.extension, {
      url: yr
    })) == null ? void 0 : a.valueString;
    if (r)
      return il(e, r, yr);
  });
}
function hU(e, t) {
  return Jt(
    U9,
    [e],
    (n) => V(this, null, function* () {
      return fU(n, e);
    }),
    t
  );
}
const pU = ({ binaryId: e, fileName: t, onClose: n, patient: r }) => {
  const { data: s, isLoading: a } = uU(e);
  return /* @__PURE__ */ i.jsx(
    mU,
    {
      isLoading: a,
      rawBinary: s == null ? void 0 : s.binary,
      fileName: t,
      binaryId: e,
      onClose: n,
      patient: r
    }
  );
}, mU = ({
  isLoading: e,
  rawBinary: t,
  fileName: n,
  onClose: r,
  patient: s,
  binaryId: a
}) => {
  const o = hU(a, !s), c = Te(null), l = Jw({
    documentTitle: n,
    removeAfterPrint: !0
  }), d = o.data || s;
  if (e)
    return /* @__PURE__ */ i.jsx(zi, { onClose: r, patient: d, binaryId: a, children: /* @__PURE__ */ i.jsx(Je, { className: "ctw-p-12 ctw-flex ctw-justify-center" }) });
  if (!(t != null && t.data))
    return /* @__PURE__ */ i.jsx(zi, { onClose: r, patient: d, binaryId: a, children: /* @__PURE__ */ i.jsx(Zn, { header: "Unable to view document", className: "ctw-justify-center", children: "The document could not be loaded." }) });
  const u = /* @__PURE__ */ i.jsx(
    gU,
    {
      fileName: n,
      contentType: t.contentType,
      blob: t.blob,
      handlePrint: l,
      contentToPrint: c
    }
  );
  return /* @__PURE__ */ i.jsx(
    "div",
    {
      className: "ctw-ccda-container ctw-ccda-styles",
      ref: c,
      "data-testid": "ccda-viewer",
      id: "ccda-viewer",
      children: /* @__PURE__ */ i.jsx(
        zi,
        {
          onClose: r,
          actions: u,
          patient: d,
          binaryId: a,
          children: /* @__PURE__ */ i.jsx(
            eU,
            {
              data: t.data,
              blob: t.blob,
              contentType: t.contentType,
              fileName: n,
              onClose: r,
              overridePatient: d
            }
          )
        }
      )
    }
  );
};
function gU({
  fileName: e,
  contentType: t,
  blob: n,
  handlePrint: r,
  contentToPrint: s
}) {
  const a = vt(
    (o) => {
      o.stopPropagation(), rU(n, e);
    },
    [n, e]
  );
  return /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-justify-items-start ctw-space-x-2 ctw-ml-0 print:ctw-hidden ", children: [
    /* @__PURE__ */ i.jsx(
      "button",
      {
        "aria-label": "Download",
        type: "button",
        className: "ctw-btn-clear ctw-link ctw-flex ctw-items-center ctw-space-x-2",
        onClick: a,
        children: /* @__PURE__ */ i.jsx(cl, { contentType: t, className: "ctw-w-5 ctw-h-5 ctw-fill-white" })
      }
    ),
    /* @__PURE__ */ i.jsx(
      "button",
      {
        "aria-label": "Print",
        type: "button",
        className: "ctw-btn-clear ctw-link ctw-items-center",
        onClick: () => {
          r(null, () => s.current);
        },
        children: /* @__PURE__ */ i.jsx(me, { icon: Aw, className: "ctw-h-4 ctw-w-4 ctw-text-white" })
      }
    )
  ] });
}
function wU() {
  return [qn];
}
function vU(e) {
  switch (e) {
    case "Patient":
      return [...bU];
    case "Condition":
      return [...xU, ...jf];
    case "MedicationStatement":
      return [...yU, ...jf];
    case "Coverage":
    case "AllergyIntolerance":
    case "CareTeam":
    case "DocumentReference":
    case "Encounter":
    case "Immunization":
    case "MedicationAdministration":
    case "MedicationDispense":
    case "MedicationRequest":
    default:
      return [];
  }
}
const yU = [`${pg}|ActiveMedications`], xU = [`${pg}|ChronicConditions`], bU = [`${Fc}|universal`], jf = [`${yt}|Common`], ul = Ae`
  ${Xt}
  ${Yn}
  ${Fr}
  ${ZF}
  ${Ha}
  ${Gn}
  query Allergies(
    $upid: ID!
    $cursor: String!
    $sort: AllergyIntoleranceSortParams!
    $filter: AllergyIntoleranceFilterParams! = {}
    $first: Int!
  ) {
    AllergyIntoleranceConnection(
      upid: $upid
      after: $cursor
      sort: $sort
      filter: $filter
      first: $first
    ) {
      pageInfo {
        hasNextPage
      }
      edges {
        node {
          id
          resourceType
          BasicList(_reference: "subject") {
            ...Basic
          }
          meta {
            tag {
              system
              code
              display
            }
          }
          clinicalStatus {
            text
            coding {
              ...Coding
            }
          }
          extension {
            url
            valueString
          }
          verificationStatus {
            text
            coding {
              ...Coding
            }
          }
          type
          category
          criticality
          code {
            text
            coding {
              ...Coding
            }
          }
          patient {
            reference
            resource {
              ... on Patient {
                ...Patient
                managingOrganization {
                  resource {
                    ... on Organization {
                      name
                    }
                  }
                }
              }
            }
          }
          encounter {
            reference
            resource {
              ...Encounter
            }
          }
          onsetDateTime
          onsetAge {
            value
            unit
            system
            code
          }
          onsetPeriod {
            start
            end
          }
          recordedDate
          recorder {
            reference
            resource {
              ...Practitioner
            }
          }
          lastOccurrence
          note {
            text
            time
          }
          reaction {
            substance {
              text
              coding {
                ...Coding
              }
            }
            manifestation {
              text
              coding {
                ...Coding
              }
            }
            onset
            severity
            note {
              text
              time
            }
          }
        }
      }
    }
  }
`, jU = `subject {
      reference
      resource {
        ... on Patient {
          ...Patient
          managingOrganization {
            resource {
              ... on Organization {
                name
              }
            }
          }
        }
      }
    }`, CU = `  
    ${Xt}
    ${Fr}
    ${Yn}
    ${Gn}
    ${Ha}
    fragment Condition on Condition {
      id
      resourceType
      BasicList(_reference: "subject") {
        ...Basic
      }
      meta {
        tag {
          system
          code
        }
        versionId
      }
      extension {
        url
        valueString
        extension {
          url
          valueReference {
            id
            type
            reference
          }
        }
      }
      ${jU}
      abatementAge {
        value
      }
      abatementDateTime
      abatementPeriod {
        start
      }
      abatementRange {
        low {
          value
        }
      }
      abatementString
      clinicalStatus {
        coding {
          ...Coding
        }
      }
      asserter {
        display
      }
      bodySite {
        text
        coding {
          ...Coding
        }
      }
      category {
        text
        coding {
          ...Coding
        }
      }
      code {
        coding {
          ...Coding
        }
      }
      encounter {
        display
      }
      evidence {
        code {
          coding {
            ...Coding
          }
        }
      }
      verificationStatus {
        coding {
          ...Coding
        }
      }
      note {
        text
      }
      onsetAge {
        value
      }
      onsetDateTime
      onsetPeriod {
        start
      }
      onsetRange {
        low {
          value
        }
      }
      onsetString
      recordedDate
      recorder {
        display
        reference
        resource {
          ...Practitioner
        }
      }
      severity {
        coding {
          ...Coding
        }
      }
      stage {
        summary {
          coding {
            ...Coding
          }
        }
        type {
          coding {
            ...Coding
          }
        }
      }
    }
  `, fl = Ae`
  ${CU}
  query SummaryConditions(
    $upid: ID!
    $cursor: String!
    $filter: ConditionFilterParams! = {}
    $sort: ConditionSortParams!
    $first: Int!
  ) {
    ConditionConnection(upid: $upid, after: $cursor, filter: $filter, sort: $sort, first: $first) {
      pageInfo {
        hasNextPage
      }
      edges {
        node {
          ...Condition
        }
      }
    }
  }
`, NU = Ae`
  fragment Condition on Condition {
    id
    resourceType
    meta {
      tag {
        system
        code
      }
    }
    code {
      text
      coding {
        system
        code
        display
      }
    }
  }
`, DU = Ae`
  ${NU}
  query FirstPartyConditions(
    $upid: ID!
    $cursor: String!
    $filter: ConditionFilterParams! = {}
    $sort: ConditionSortParams!
    $first: Int!
  ) {
    ConditionConnection(upid: $upid, after: $cursor, filter: $filter, sort: $sort, first: $first) {
      pageInfo {
        hasNextPage
      }
      edges {
        node {
          ...Condition
        }
      }
    }
  }
`;
function c0({
  resourceType: e,
  model: t,
  queryKey: n,
  valuesToDedupeOn: r,
  getHistoryEntry: s,
  getFiltersFQS: a,
  clientSideFiltersFQS: o
}) {
  return Oe(
    n,
    [t],
    (c, l) => V(this, null, function* () {
      return AU(
        e,
        t,
        c,
        l,
        r,
        s,
        o,
        a == null ? void 0 : a(t)
      );
    }),
    !0
  );
}
function SU(e, t) {
  const n = nt(e, ["isEnriched"], "desc");
  return wn(n, (r, s) => bs(t(r), t(s)));
}
function $U(e) {
  switch (e) {
    case "Condition":
      return fl;
    case "AllergyIntolerance":
      return ul;
    default:
      throw new Error(`Resource type to FQS query not implemented yet for ${e}`);
  }
}
function AU(e, t, n, r, s, a, o, c) {
  return V(this, null, function* () {
    try {
      const l = Re(n), d = c || o ? I9(
        yield l.request($U(e), {
          upid: r.UPID,
          cursor: "",
          first: 1e3,
          sort: {
            lastUpdated: "DESC"
          },
          filter: c
        })
      ) : [t.resource];
      let u = EU(d, e);
      o && (u = o(t, u));
      const h = t.constructor, f = u.map((C) => new h(C)), p = SU(f, s).map(a), m = yield nl(n, f);
      return p.forEach((C) => {
        C.binaryId = ll(m, C.id);
      }), p;
    } catch (l) {
      throw $e.logError(
        l,
        `Failed fetching ${e} history for patient via FQS: ${r.UPID}}`
      );
    }
  });
}
function EU(e, t) {
  return e.filter((n) => !n.meta || !n.meta.tag ? !0 : !(n.meta.tag.filter(
    (s) => vU(t).includes(`${s.system}|${s.code}`)
  ).length > 0));
}
function IU(e) {
  return c0({
    resourceType: "AllergyIntolerance",
    model: e,
    queryKey: O9,
    valuesToDedupeOn: RU,
    getHistoryEntry: TU,
    clientSideFiltersFQS: _U
  });
}
function _U(e, t) {
  const n = e.knownCodings.map((r) => `${r.system}|${r.code}`);
  return t.filter((r) => {
    var c, l, d;
    const s = (l = (c = r.code) == null ? void 0 : c.coding) == null ? void 0 : l.map((u) => `${u.system}|${u.code}`), a = e.codeText && ((d = r.code) == null ? void 0 : d.text) === e.codeText;
    return (s == null ? void 0 : s.some((u) => n.includes(u))) || a;
  });
}
function TU(e) {
  const t = [
    { label: "Status", value: e.clinicalStatus },
    { label: "Type", value: qe(e.type) },
    { label: "Onset", value: e.onset },
    { label: "Reaction", value: qe(e.manifestations) },
    { label: "Severity", value: qe(e.severity) },
    { label: "Note", value: e.note }
  ];
  return {
    id: e.id,
    date: e.recordedDate,
    versionId: e.versionId,
    title: e.patientOrganizationName,
    details: t
  };
}
const RU = (e) => [
  e.recordedDate,
  e.patientOrganizationName,
  e.clinicalStatus,
  e.onset,
  e.manifestations,
  e.severity,
  e.note,
  e.knownCodings.map((t) => [t.system, t.code])
], l0 = {
  display: "Name (A-Z)",
  sorts: [{ key: "lowercaseDisplay", dir: "asc" }]
}, MU = [
  l0,
  {
    display: "Date (New to Old)",
    sorts: [{ key: "recordedDate", dir: "desc", isDate: !0 }]
  },
  {
    display: "Date (Old to New)",
    sorts: [{ key: "recordedDate", dir: "asc", isDate: !0 }]
  },
  {
    display: "Name (Z-A)",
    sorts: [{ key: "lowercaseDisplay", dir: "desc" }]
  }
];
const PU = 3, OU = 6, Ao = (e, t) => {
  if (!e || t >= OU || e instanceof Boolean || e instanceof String)
    return e;
  if (e.type === "table")
    return kU(e);
  const n = Object.hasOwn(e, "props") ? e.props : {};
  if (n.content) {
    const o = Nv(n.content, {});
    return Ao(o, t + 1);
  }
  if (!n.children)
    return e;
  const s = (Array.isArray(n.children) ? n.children : [n.children]).map(
    (o) => Ao(o, t + 1)
  ), a = Fn(e);
  return a.props ? (s.length === 1 && s[0] ? a.props.children = s[0] : a.props.children = s, a) : e;
}, kU = (e) => {
  var l;
  if (!Array.isArray((l = e.props) == null ? void 0 : l.children))
    return e;
  const t = e.props.children.filter((d) => d.type === "thead");
  if (t.length !== 1)
    return e;
  const n = t[0], r = e.props.children.filter((d) => d.type === "tbody");
  if (r.length !== 1)
    return e;
  const s = r[0];
  let a = [];
  if (Array.isArray(n.props.children) ? a = n.props.children : n.props.children.type === "tr" && Array.isArray(n.props.children.props.children) ? a = n.props.children.props.children : a = [n.props.children.props.children], a.length < PU)
    return e;
  const o = Array.isArray(s.props.children) ? s.props.children : [s.props.children];
  if (!o.length)
    return e;
  const c = o.reduce((d, u, h) => {
    const p = (Array.isArray(u.props.children) ? u.props.children : [u.props.children]).reduce((m, C, y) => {
      const g = a[y];
      return [
        ...m,
        // eslint-disable-next-line react/no-array-index-key
        /* @__PURE__ */ i.jsxs("div", { children: [
          /* @__PURE__ */ i.jsx("p", { className: "ctw-font-medium", children: g.props.children }),
          /* @__PURE__ */ i.jsx("p", { children: C.props.children })
        ] }, `cell-${h}-${y}`)
      ];
    }, []);
    return o.length - 1 > h && p.push(
      /* @__PURE__ */ i.jsx(
        "div",
        {
          className: "ctw-note-transposed-row-separator"
        },
        `transpose-separator-${h}`
      )
    ), [...d, ...p];
  }, []);
  return /* @__PURE__ */ i.jsx("div", { className: "ctw-note-transposed", children: c });
}, Ur = ({
  details: e,
  documentButton: t,
  hideEmpty: n = !0,
  hideHeader: r = !1,
  className: s = "ctw-rounded-lg ctw-bg-bg-lighter ctw-space-y-2 ctw-px-2 ctw-py-4 sm:ctw-px-4"
}) => {
  const [a, o] = Y(
    e.map(() => /* @__PURE__ */ i.jsx("div", { children: "Loading Note..." }))
  );
  return he(() => {
    const c = e.map(
      (l) => l.transposeTables ? Ao(l.value, 0) : l.value
    );
    o(c);
  }, [e]), /* @__PURE__ */ i.jsxs("dl", { className: s, children: [
    !r && /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-justify-between ctw-space-x-2 ctw-text-sm ctw-uppercase ctw-text-content-light", children: [
      /* @__PURE__ */ i.jsx("div", { className: "ctw-title-container", children: "Details" }),
      /* @__PURE__ */ i.jsx("div", { className: "ctw-flex", children: t })
    ] }),
    a.length > 0 && e.map((c, l) => {
      if (n && !c.value && c.value !== 0)
        return /* @__PURE__ */ i.jsx("div", {}, l);
      const d = a[l];
      return c.label ? /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
        c.beginsNewSection && /* @__PURE__ */ i.jsx("hr", {}),
        /* @__PURE__ */ i.jsxs("div", { className: "ctw-text-gray-900 ctw-flex ctw-items-baseline", children: [
          /* @__PURE__ */ i.jsx("dt", { className: "ctw-w-1/3 ctw-flex-shrink-0 ctw-font-medium", children: c.label }),
          /* @__PURE__ */ i.jsx("dd", { className: "ctw-m-0 ctw-w-full", children: d })
        ] }, c.label)
      ] }) : (
        // eslint-disable-next-line react/no-array-index-key
        /* @__PURE__ */ i.jsx("div", { className: "ctw-text-gray-900 ctw-flex ctw-items-baseline", children: /* @__PURE__ */ i.jsx("div", { className: "ctw-m-0 ctw-w-full", children: d }) }, l)
      );
    })
  ] });
}, d0 = ({
  date: e,
  title: t,
  subtitle: n,
  isDetailShown: r,
  analyticsInteraction: s,
  analyticsActionExpand: a,
  analyticsActionCollapse: o,
  hasDocument: c = !1,
  setIsDetailShown: l
}) => {
  const { trackInteraction: d } = Be();
  return /* @__PURE__ */ i.jsx(
    "button",
    {
      type: "button",
      "aria-label": "details",
      onClick: () => {
        l(!r), d(s, {
          action: r ? o : a
        });
      },
      className: "ctw-btn-clean",
      children: /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-items-center ctw-justify-between ctw-rounded-lg ctw-bg-bg-white ctw-p-3 ctw-text-left ctw-outline ctw-outline-1 ctw-outline-bg-dark", children: [
        /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-space-x-3", children: [
          /* @__PURE__ */ i.jsx("div", { className: "ctw-min-w-[5rem]", children: e != null ? e : /* @__PURE__ */ i.jsx("span", { className: "ctw-text-content-lighter", children: "Unknown" }) }),
          (t || n) && /* @__PURE__ */ i.jsxs("div", { children: [
            /* @__PURE__ */ i.jsx("div", { className: "ctw-font-semibold ctw-text-content-black", children: t }),
            /* @__PURE__ */ i.jsx("div", { className: "ctw-text-content-light", children: n })
          ] }),
          !t && !n && e && /* @__PURE__ */ i.jsx("div", { className: "ctw-text-content-lighter", children: "Unknown" })
        ] }),
        /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-items-center ctw-space-x-3", children: [
          c && /* @__PURE__ */ i.jsx(me, { icon: ah, className: "ctw-h-5 ctw-text-content-light" }),
          /* @__PURE__ */ i.jsx("div", { className: "ctw-justify-right ctw-flex", children: /* @__PURE__ */ i.jsx(
            me,
            {
              icon: zo,
              className: W("ctw-h-3 ctw-w-3 ctw-text-content-lighter", {
                "ctw-rotate-90": r
              })
            }
          ) })
        ] })
      ] })
    }
  );
}, hl = ({
  isOpen: e,
  onAfterClosed: t,
  children: n,
  className: r,
  id: s,
  closeOnEscapeOrBackdrop: a = !1,
  onClose: o,
  showCloseIcon: c = !1
}) => /* @__PURE__ */ i.jsx(kn, { appear: !0, show: e, as: sn, children: /* @__PURE__ */ i.jsxs(
  Ys,
  {
    as: "div",
    className: "ctw-relative ctw-z-[10100]",
    onClose: () => {
      a && (o == null || o());
    },
    children: [
      /* @__PURE__ */ i.jsx(
        kn.Child,
        {
          as: sn,
          enter: "ctw-ease-out ctw-duration-300",
          enterFrom: "ctw-opacity-0",
          enterTo: "ctw-opacity-100",
          leave: "ctw-ease-in ctw-duration-200",
          leaveFrom: "ctw-opacity-100",
          leaveTo: "ctw-opacity-0",
          afterLeave: t,
          children: /* @__PURE__ */ i.jsx("div", { className: "ctw-fixed ctw-inset-0  ctw-transition-opacity", children: /* @__PURE__ */ i.jsx("div", { className: "ctw-h-full ctw-w-full ctw-bg-content-light ctw-opacity-75" }) })
        }
      ),
      /* @__PURE__ */ i.jsx("div", { className: "ctw-fixed ctw-inset-0 ctw-overflow-auto", id: s, children: /* @__PURE__ */ i.jsx("div", { className: "ctw-min-h-full ctw-items-center ctw-p-10 max-lg:ctw-p-4 max-sm:ctw-p-0", children: /* @__PURE__ */ i.jsx(
        kn.Child,
        {
          as: sn,
          enter: "ctw-ease-out ctw-duration-300",
          enterFrom: "ctw-opacity-0 ctw-scale-95",
          enterTo: "ctw-opacity-100 ctw-scale-100",
          leave: "ctw-ease-in ctw-duration-200",
          leaveFrom: "ctw-opacity-100 ctw-scale-100",
          leaveTo: "ctw-opacity-0 ctw-scale-95",
          children: /* @__PURE__ */ i.jsxs(
            Ys.Panel,
            {
              className: W(
                "ctw-mr-auto ctw-ml-auto ctw-w-fit ctw-max-w-lg ctw-transform ctw-rounded-lg ctw-bg-white ctw-p-6 ctw-shadow-xl",
                r
              ),
              children: [
                c && /* @__PURE__ */ i.jsx(
                  "button",
                  {
                    type: "button",
                    "aria-label": "Close",
                    className: W(
                      "ctw-w-5 ctw-h-5",
                      "ctw-text-content-lighter hover:ctw-text-content-light",
                      "ctw-flex ctw-justify-center ctw-items-center",
                      "ctw-absolute ctw-right-3 ctw-top-3"
                    ),
                    onClick: o,
                    children: /* @__PURE__ */ i.jsx(me, { icon: Fo, className: "" })
                  }
                ),
                /* @__PURE__ */ i.jsx("div", { className: "ctw-flex ctw-h-full ctw-flex-col ctw-space-y-6", children: n })
              ]
            }
          )
        }
      ) }) })
    ]
  }
) });
function Cs(e) {
  const { openModal: t } = Mc();
  return (n, r) => {
    t({
      component: (s) => /* @__PURE__ */ i.jsx(LU, R({ fileName: r, binaryId: n, patient: e }, s))
    });
  };
}
const LU = (a) => {
  var o = a, { binaryId: e, fileName: t, onClose: n, patient: r } = o, s = ct(o, ["binaryId", "fileName", "onClose", "patient"]);
  return /* @__PURE__ */ i.jsx(
    hl,
    X(R({}, s), {
      onClose: n,
      closeOnEscapeOrBackdrop: !0,
      id: K7,
      className: "!ctw-p-0 ctw-min-w-full !ctw-max-w-3xl",
      children: /* @__PURE__ */ i.jsx("div", { className: "ctw-w-full ctw-items-center", children: /* @__PURE__ */ i.jsx(pU, { patient: r, binaryId: e, fileName: t, onClose: n }) })
    })
  );
}, FU = (e, t = "application/pdf") => {
  const n = atob(e);
  let { length: r } = e;
  const s = new Uint8Array(r);
  for (; r; )
    r -= 1, s[r] = n.charCodeAt(r);
  return new Blob([s], { type: t });
};
function BU() {
  const [e, t] = Y(!1), [n, r] = Y(), { getRequestContext: s } = Xe();
  return { downloadBinaryById: vt(
    (o, c) => {
      t(!0), r(void 0), (() => V(this, null, function* () {
        var u, h, f;
        let d = null;
        try {
          const p = yield s(), { binary: m } = yield dl(p, o);
          let C;
          try {
            C = FU((u = m.data) != null ? u : "", m.contentType);
          } catch (y) {
            C = new Blob([(h = m.data) != null ? h : ""], { type: m.contentType });
          }
          d = document.createElement("a"), d.href = window.URL.createObjectURL(C), d.download = c, document.body.appendChild(d), d.click();
        } catch (p) {
          r(p instanceof Error ? p.message : `${p}`), console.error(`Error downloading binary file: ${p}`);
        } finally {
          t(!1), (f = d == null ? void 0 : d.parentNode) == null || f.removeChild(d);
        }
      }))();
    },
    [s]
  ), isDownloading: e, error: n };
}
const UU = 460, zr = ({
  binaryId: e,
  contentType: t = "",
  documentTitle: n = "Source Document",
  forceInModal: r = !1,
  text: s = "Source Document",
  telemetryTarget: a = "none",
  showContentTypeIcon: o = !0
}) => {
  const c = Cs(), { allowSmallBreakpointCCDAViewer: l, featureFlags: d } = Xe(), { trackInteraction: u } = Be(), { downloadBinaryById: h, error: f, isDownloading: p } = BU(), [m, C] = Y(window.innerWidth);
  if (he(() => {
    window.addEventListener("resize", () => C(window.innerWidth));
  }, []), !e)
    return null;
  const y = !l && m < UU, g = y && !p ? "Download" : "", w = !y && !r && (d == null ? void 0 : d.openCCDAInNewTab);
  return /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
    f && /* @__PURE__ */ i.jsx(Zn, { header: f }),
    w ? /* @__PURE__ */ i.jsxs(
      "a",
      {
        "aria-label": "Open in new tab",
        href: `/ccda/${e}`,
        className: "ctw-link ctw-whitespace-nowrap ctw-space-x-2 ctw-align-top ctw-leading-6 ctw-inline-flex ctw-items-center",
        rel: "noopener noreferrer",
        target: "_blank",
        children: [
          /* @__PURE__ */ i.jsx("span", { className: "ctw-normal-case", children: s }),
          /* @__PURE__ */ i.jsx(me, { icon: ih, className: "ctw-h-3" })
        ]
      }
    ) : /* @__PURE__ */ i.jsxs(
      "button",
      {
        type: "button",
        className: "ctw-btn-clear ctw-link ctw-flex ctw-items-center ctw-space-x-2",
        disabled: p,
        onClick: () => {
          y ? (h(e, n), u("download_document", { target: a })) : (c(e, n), u("open_source_document", { target: a }));
        },
        children: [
          o && /* @__PURE__ */ i.jsx(cl, { contentType: t }),
          /* @__PURE__ */ i.jsxs("span", { className: "ctw-block ctw-min-w-9", children: [
            p ? /* @__PURE__ */ i.jsx(Je, { className: "ctw-h-3", message: "Downloading" }) : g,
            " ",
            s
          ] })
        ]
      }
    )
  ] });
}, zU = ({
  binaryId: e,
  date: t,
  details: n,
  hideEmpty: r,
  subtitle: s,
  title: a,
  resourceTypeTitle: o
}) => {
  const [c, l] = Y(!1);
  return /* @__PURE__ */ i.jsxs("div", { className: "ctw-space-y-1", children: [
    /* @__PURE__ */ i.jsx(
      d0,
      {
        date: t,
        title: a,
        subtitle: s,
        isDetailShown: c,
        setIsDetailShown: l,
        hasDocument: !!e,
        analyticsInteraction: "toggle_history_entry",
        analyticsActionExpand: "expand_history_entry",
        analyticsActionCollapse: "collapse_history_entry"
      }
    ),
    c && /* @__PURE__ */ i.jsx(
      Ur,
      {
        details: n,
        hideEmpty: r,
        documentButton: /* @__PURE__ */ i.jsx(
          zr,
          {
            binaryId: e,
            documentTitle: o,
            telemetryTarget: "history_entry"
          }
        )
      }
    )
  ] });
}, HU = 20;
function pl({
  limit: e = HU,
  getHistory: t,
  model: n
}) {
  var u;
  const r = t && t(n), s = (u = r == null ? void 0 : r.data) != null ? u : [], [a, o] = Y(!e || s.length <= e), { resourceTypeTitle: c } = n, l = nt(
    s,
    [
      // Convert the date string to a Date object so that it sorts correctly.
      (h) => h.date ? new Date(h.date) : "",
      // desc
      // We want to promote entries with a source document to the top.
      (h) => !!h.binaryId,
      // desc
      "title",
      // asc
      "subtitle",
      // asc
      "versionId"
      // desc
    ],
    ["desc", "desc", "asc", "asc", "desc"]
  ), d = a || !e ? l : l.slice(0, e);
  return r && r.isLoading ? /* @__PURE__ */ i.jsx(Je, { message: "Loading history..." }) : /* @__PURE__ */ i.jsxs("div", { className: "ctw-space-y-4", children: [
    /* @__PURE__ */ i.jsx("div", { className: "ctw-text-lg ctw-font-semibold", children: "History" }),
    d.map((h, f) => (
      // We can have multiple items with the same condition id
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ i.jsx("div", { children: /* @__PURE__ */ i.jsx(
        zU,
        {
          id: h.id,
          date: h.date,
          title: h.title,
          subtitle: h.subtitle,
          details: h.details,
          hideEmpty: h.hideEmpty,
          binaryId: h.binaryId,
          resourceTypeTitle: c
        }
      ) }, `${h.id}-${f}`)
    )),
    !a && /* @__PURE__ */ i.jsx("div", { className: "ctw-text-center", children: /* @__PURE__ */ i.jsxs("button", { type: "button", className: "ctw-btn-primary", onClick: () => o(!0), children: [
      "Load ",
      l.length - e,
      " More"
    ] }) })
  ] });
}
function u0(e, t, n, r) {
  return V(this, null, function* () {
    if (!t.id)
      throw new Error(`Tried to ${r} a resource that hasn't been created yet.`);
    if (t.ownedByBuilder(n.builderId))
      throw new Error(`Tried to ${r} a patient record resource.`);
    const s = {
      resourceType: "Basic",
      id: e == null ? void 0 : e.id,
      code: {
        coding: [
          {
            system: VL,
            code: "adminact",
            display: "Administrative Activity"
          },
          {
            system: zs,
            code: r
          }
        ]
      },
      subject: {
        reference: `${t.resourceType}/${t.id}`,
        type: t.resourceType
      },
      author: yield kg(n)
    };
    if (!(yield Ba(s, n)).id)
      throw new Error(`Failed to ${r} resource with id of ${t.id}`);
  });
}
function f0(e, t) {
  return V(this, null, function* () {
    const n = e.getLatestAction(["archive", "unarchive"]), r = e.isDismissed ? "unarchive" : "archive";
    e.optimisticToggleIsDismiss(), yield u0(n, e, t, r);
  });
}
function WU(e, t) {
  return V(this, null, function* () {
    const n = e.getLatestAction(["read", "unread"]), r = e.isRead ? "unread" : "read";
    e.optimisticToggleIsRead(), yield u0(n, e, t, r);
  });
}
function h0() {
  const { getRequestContext: e } = Xe(), [t, n] = Y(!1);
  return {
    toggleDismiss: vt((s) => V(this, null, function* () {
      n(!0), yield f0(s, yield e()), Bn({
        type: "info",
        title: `${s.title} ${s.isDismissed ? "dismissed" : "restored"}.`
      }), n(!1);
    }), []),
    isLoading: t
  };
}
function Hr() {
  const { getRequestContext: e } = Xe(), [t, n] = Y(!1);
  return {
    toggleRead: vt((s) => V(this, null, function* () {
      const a = yield e();
      a.env === "production" && a.userType !== "builder" || (n(!0), yield WU(s, yield e()), n(!1));
    }), []),
    isLoading: t
  };
}
function VU({
  children: e,
  items: t,
  onItemSelect: n,
  buttonClassName: r,
  isOpen: s,
  side: a,
  align: o = "start"
}) {
  const [c, l] = Y(s);
  return /* @__PURE__ */ i.jsx(wh, { children: /* @__PURE__ */ i.jsxs(
    qt.Root,
    {
      modal: !1,
      open: c,
      onOpenChange: (d) => l(d),
      children: [
        /* @__PURE__ */ i.jsx(qt.Trigger, { className: W(r), "aria-label": "dropdown", children: e }),
        /* @__PURE__ */ i.jsx(
          qt.Content,
          {
            align: o,
            side: a,
            onFocusOutside: (d) => d.preventDefault(),
            className: "ctw-dropdown-action-menu ctw-bg-bg-white",
            collisionPadding: 10,
            children: t.map((d) => /* @__PURE__ */ i.jsx(
              qt.Item,
              {
                className: W("ctw-dropdown-action-menu-item ctw-bg-bg-white"),
                onClick: () => {
                  d.disabled || n({
                    key: d.key,
                    name: d.name,
                    value: !d.isSelected
                  });
                },
                children: /* @__PURE__ */ i.jsx(
                  "div",
                  {
                    className: W("ctw-flex ctw-w-full ctw-justify-between", {
                      "ctw-text-content-lighter": d.disabled,
                      "!ctw-text-content-black": !d.disabled
                    }),
                    children: d.display ? d.display : d.name
                  }
                )
              },
              d.key
            ))
          }
        )
      ]
    }
  ) });
}
function qU() {
  const { getRequestContext: e } = Xe(), [t, n] = Y();
  return he(() => {
    let r = !0;
    function s() {
      return V(this, null, function* () {
        const a = yield e();
        r && n(a);
      });
    }
    return s(), () => {
      r = !1;
    };
  }, [e]), t;
}
function ut() {
  const { getRequestContext: e } = Xe(), [t, n] = Y("");
  return he(() => {
    function r() {
      return V(this, null, function* () {
        const s = yield e();
        n(s.builderId);
      });
    }
    r();
  }, [e]), t;
}
var p0 = {}, qa = {};
qa.__esModule = !0;
qa.sharedRoot = void 0;
qa.sharedRoot = {
  fontFamily: 'Menlo, Monaco, "Courier New", monospace',
  fontFeatureSettings: '"liga" 0, "calt" 0',
  lineHeight: "1.5em",
  whiteSpace: "pre",
  margin: 0
};
(function(e) {
  e.__esModule = !0;
  var t = qa;
  e.default = {
    styles: {
      root: Object.assign({}, t.sharedRoot, { backgroundColor: "#f8f8f8" }),
      attribute: { color: "#333" },
      unquotedAttribute: { color: "#333" },
      string: { color: "#de1044" },
      nil: { color: "#008080" },
      number: { color: "#008080" },
      boolean: { color: "#008080" },
      punctuation: { color: "#333" }
    }
  };
})(p0);
const GU = /* @__PURE__ */ oe(p0);
const YU = Ct(void 0);
function m0({ children: e, containerId: t }) {
  return /* @__PURE__ */ i.jsxs(YU.Provider, { value: void 0, children: [
    /* @__PURE__ */ i.jsx(
      bv,
      {
        position: "bottom-left",
        autoClose: 4e4,
        hideProgressBar: !0,
        closeOnClick: !0,
        rtl: !1,
        limit: 1,
        transition: jv,
        pauseOnFocusLoss: !0,
        pauseOnHover: !0,
        theme: "colored",
        enableMultiContainer: !0,
        containerId: t || Cg
      }
    ),
    e
  ] });
}
const ua = "ctw-transform ctw-transition ctw-ease-in-out ctw-duration-300";
function et({
  isOpen: e,
  onClose: t,
  onAfterClosed: n,
  onOpen: r,
  onAfterOpen: s,
  children: a,
  className: o,
  showCloseFooter: c,
  title: l,
  disableCloseOnBlur: d = !1
}) {
  return /* @__PURE__ */ i.jsx(kn.Root, { show: e, as: sn, children: /* @__PURE__ */ i.jsxs(
    Ys,
    {
      as: "div",
      className: W("ctw-drawer ctw-relative ctw-z-[10000]", o),
      onClose: () => {
        d || t();
      },
      "data-testid": "drawer",
      children: [
        /* @__PURE__ */ i.jsx(
          kn.Child,
          {
            as: sn,
            enter: ua,
            enterFrom: "ctw-opacity-0",
            enterTo: "ctw-opacity-100",
            leave: ua,
            leaveFrom: "ctw-opacity-100",
            leaveTo: "ctw-opacity-0",
            afterLeave: n,
            beforeEnter: r,
            afterEnter: s,
            children: /* @__PURE__ */ i.jsx("div", { className: "ctw-fixed ctw-inset-0  ctw-transition-opacity", children: /* @__PURE__ */ i.jsx("div", { className: "ctw-h-full ctw-w-full ctw-bg-content-light ctw-opacity-75" }) })
          }
        ),
        /* @__PURE__ */ i.jsx(QU, { onClose: t, showCloseFooter: c, title: l, children: /* @__PURE__ */ i.jsx(m0, { containerId: Ng, children: a }) })
      ]
    }
  ) });
}
function QU({
  children: e,
  onClose: t,
  showCloseFooter: n,
  title: r
}) {
  const { trackInteraction: s } = Be(), a = Te(null), o = wt(a);
  return /* @__PURE__ */ i.jsx("div", { ref: a, className: "ctw-fixed ctw-inset-0 ctw-overflow-hidden", children: /* @__PURE__ */ i.jsx("div", { className: "ctw-absolute ctw-inset-0 ctw-overflow-hidden", children: /* @__PURE__ */ i.jsx(
    "div",
    {
      className: W(
        "ctw-pointer-events-none ctw-fixed ctw-inset-y-0 ctw-right-0 ctw-flex ctw-max-w-full",
        {
          "ctw-pl-10": !o.sm
        }
      ),
      children: /* @__PURE__ */ i.jsx(
        kn.Child,
        {
          as: sn,
          enter: ua,
          enterFrom: "ctw-translate-x-full",
          enterTo: "ctw-translate-x-0",
          leave: ua,
          leaveFrom: "ctw-translate-x-0",
          leaveTo: "ctw-translate-x-full",
          children: /* @__PURE__ */ i.jsx(Ys.Panel, { className: "ctw-pointer-events-auto ctw-w-screen ctw-max-w-xl", children: /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-h-full ctw-flex-col ctw-bg-white ctw-shadow-xl", children: [
            r && /* @__PURE__ */ i.jsx(JU, { children: r }),
            e,
            n && /* @__PURE__ */ i.jsx(et.Footer, { children: /* @__PURE__ */ i.jsx(
              et.CloseButton,
              {
                label: "Close",
                onClose: () => {
                  t(), s("close_drawer", {
                    target: "footer_close_icon"
                  });
                }
              }
            ) })
          ] }) })
        }
      )
    }
  ) }) });
}
const ZU = ({ children: e }) => {
  const t = Te(null), n = wt(t);
  return /* @__PURE__ */ i.jsx(
    "div",
    {
      ref: t,
      className: W("ctw-footer ctw-border-default ctw-border-t", {
        "ctw-p-6": !n.sm,
        "ctw-p-3": n.sm
      }),
      children: e
    }
  );
}, KU = ({ label: e, onClose: t }) => /* @__PURE__ */ i.jsx("button", { type: "button", className: "ctw-btn-clear !ctw-px-4 !ctw-py-2", onClick: t, children: e }), JU = ({ children: e }) => {
  const t = Te(null), n = wt(t);
  return /* @__PURE__ */ i.jsx(
    "div",
    {
      ref: t,
      className: W("ctw-header ctw-border-default ctw-border-b", {
        "ctw-p-6": !n.sm,
        "ctw-p-3": n.sm
      }),
      children: e
    }
  );
}, XU = ({ children: e }) => {
  const t = Te(null), n = wt(t);
  return /* @__PURE__ */ i.jsx(
    "div",
    {
      ref: t,
      className: W("ctw-flex ctw-h-full ctw-flex-col ctw-overflow-y-auto ctw-px-6", {
        "ctw-py-6": !n.sm,
        "ctw-py-3": n.sm
      }),
      children: e
    }
  );
};
et.Body = XU;
et.Footer = ZU;
et.CloseButton = KU;
function ez() {
  const { openDrawer: e } = Vn();
  return (t, n) => {
    e({
      component: (r) => /* @__PURE__ */ i.jsx(tz, R({ name: t, resource: n }, r)),
      trackingMetadata: { action: "view_fhir" }
    });
  };
}
function Cf({ name: e = "View FHIR", resource: t }) {
  const n = ez();
  return /* @__PURE__ */ i.jsx(
    "button",
    {
      type: "button",
      "aria-label": e,
      className: "ctw-btn-default",
      onClick: () => {
        n(e, t);
      },
      children: /* @__PURE__ */ i.jsx("span", { className: "ctw-relative ctw-inline-block ctw-w-4 ctw-pr-4 ctw-align-middle", children: /* @__PURE__ */ i.jsx(kB, { className: "ctw-absolute -ctw-top-2.5 ctw-left-0 ctw-h-4" }) })
    }
  );
}
function tz({ resource: e, isOpen: t, onClose: n, className: r, name: s }) {
  return /* @__PURE__ */ i.jsx(
    et,
    {
      className: W(r, "ctw-view-fhir"),
      title: s,
      isOpen: t,
      onClose: n,
      showCloseFooter: !0,
      children: /* @__PURE__ */ i.jsx(et.Body, { children: /* @__PURE__ */ i.jsx("div", { className: "ctw-text-sm react-json-pre-wrapper", children: /* @__PURE__ */ i.jsx(Iv, { value: e, theme: GU }) }) })
    }
  );
}
const nz = {
  type: "logger",
  log(e) {
    this.output("log", e);
  },
  warn(e) {
    this.output("warn", e);
  },
  error(e) {
    this.output("error", e);
  },
  output(e, t) {
    console && console[e] && console[e].apply(console, t);
  }
};
class fa {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.init(t, n);
  }
  init(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.prefix = n.prefix || "i18next:", this.logger = t || nz, this.options = n, this.debug = n.debug;
  }
  log() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "log", "", !0);
  }
  warn() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "warn", "", !0);
  }
  error() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "error", "");
  }
  deprecate() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    return this.forward(n, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(t, n, r, s) {
    return s && !this.debug ? null : (typeof t[0] == "string" && (t[0] = `${r}${this.prefix} ${t[0]}`), this.logger[n](t));
  }
  create(t) {
    return new fa(this.logger, R({
      prefix: `${this.prefix}:${t}:`
    }, this.options));
  }
  clone(t) {
    return t = t || this.options, t.prefix = t.prefix || this.prefix, new fa(this.logger, t);
  }
}
var rn = new fa();
class Ga {
  constructor() {
    this.observers = {};
  }
  on(t, n) {
    return t.split(" ").forEach((r) => {
      this.observers[r] = this.observers[r] || [], this.observers[r].push(n);
    }), this;
  }
  off(t, n) {
    if (this.observers[t]) {
      if (!n) {
        delete this.observers[t];
        return;
      }
      this.observers[t] = this.observers[t].filter((r) => r !== n);
    }
  }
  emit(t) {
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), s = 1; s < n; s++)
      r[s - 1] = arguments[s];
    this.observers[t] && [].concat(this.observers[t]).forEach((o) => {
      o(...r);
    }), this.observers["*"] && [].concat(this.observers["*"]).forEach((o) => {
      o.apply(o, [t, ...r]);
    });
  }
}
function Xr() {
  let e, t;
  const n = new Promise((r, s) => {
    e = r, t = s;
  });
  return n.resolve = e, n.reject = t, n;
}
function Nf(e) {
  return e == null ? "" : "" + e;
}
function rz(e, t, n) {
  e.forEach((r) => {
    t[r] && (n[r] = t[r]);
  });
}
function ml(e, t, n) {
  function r(o) {
    return o && o.indexOf("###") > -1 ? o.replace(/###/g, ".") : o;
  }
  function s() {
    return !e || typeof e == "string";
  }
  const a = typeof t != "string" ? [].concat(t) : t.split(".");
  for (; a.length > 1; ) {
    if (s())
      return {};
    const o = r(a.shift());
    !e[o] && n && (e[o] = new n()), Object.prototype.hasOwnProperty.call(e, o) ? e = e[o] : e = {};
  }
  return s() ? {} : {
    obj: e,
    k: r(a.shift())
  };
}
function Df(e, t, n) {
  const {
    obj: r,
    k: s
  } = ml(e, t, Object);
  r[s] = n;
}
function sz(e, t, n, r) {
  const {
    obj: s,
    k: a
  } = ml(e, t, Object);
  s[a] = s[a] || [], r && (s[a] = s[a].concat(n)), r || s[a].push(n);
}
function ha(e, t) {
  const {
    obj: n,
    k: r
  } = ml(e, t);
  if (n)
    return n[r];
}
function az(e, t, n) {
  const r = ha(e, n);
  return r !== void 0 ? r : ha(t, n);
}
function g0(e, t, n) {
  for (const r in t)
    r !== "__proto__" && r !== "constructor" && (r in e ? typeof e[r] == "string" || e[r] instanceof String || typeof t[r] == "string" || t[r] instanceof String ? n && (e[r] = t[r]) : g0(e[r], t[r], n) : e[r] = t[r]);
  return e;
}
function rr(e) {
  return e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var iz = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
function oz(e) {
  return typeof e == "string" ? e.replace(/[&<>"'\/]/g, (t) => iz[t]) : e;
}
const cz = [" ", ",", "?", "!", ";"];
function lz(e, t, n) {
  t = t || "", n = n || "";
  const r = cz.filter((o) => t.indexOf(o) < 0 && n.indexOf(o) < 0);
  if (r.length === 0)
    return !0;
  const s = new RegExp(`(${r.map((o) => o === "?" ? "\\?" : o).join("|")})`);
  let a = !s.test(e);
  if (!a) {
    const o = e.indexOf(n);
    o > 0 && !s.test(e.substring(0, o)) && (a = !0);
  }
  return a;
}
function pa(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ".";
  if (!e)
    return;
  if (e[t])
    return e[t];
  const r = t.split(n);
  let s = e;
  for (let a = 0; a < r.length; ++a) {
    if (!s || typeof s[r[a]] == "string" && a + 1 < r.length)
      return;
    if (s[r[a]] === void 0) {
      let o = 2, c = r.slice(a, a + o).join(n), l = s[c];
      for (; l === void 0 && r.length > a + o; )
        o++, c = r.slice(a, a + o).join(n), l = s[c];
      if (l === void 0)
        return;
      if (l === null)
        return null;
      if (t.endsWith(c)) {
        if (typeof l == "string")
          return l;
        if (c && typeof l[c] == "string")
          return l[c];
      }
      const d = r.slice(a + o).join(n);
      return d ? pa(l, d, n) : void 0;
    }
    s = s[r[a]];
  }
  return s;
}
function ma(e) {
  return e && e.indexOf("_") > 0 ? e.replace("_", "-") : e;
}
class Sf extends Ga {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      ns: ["translation"],
      defaultNS: "translation"
    };
    super(), this.data = t || {}, this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(t) {
    this.options.ns.indexOf(t) < 0 && this.options.ns.push(t);
  }
  removeNamespaces(t) {
    const n = this.options.ns.indexOf(t);
    n > -1 && this.options.ns.splice(n, 1);
  }
  getResource(t, n, r) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    const a = s.keySeparator !== void 0 ? s.keySeparator : this.options.keySeparator, o = s.ignoreJSONStructure !== void 0 ? s.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let c = [t, n];
    r && typeof r != "string" && (c = c.concat(r)), r && typeof r == "string" && (c = c.concat(a ? r.split(a) : r)), t.indexOf(".") > -1 && (c = t.split("."));
    const l = ha(this.data, c);
    return l || !o || typeof r != "string" ? l : pa(this.data && this.data[t] && this.data[t][n], r, a);
  }
  addResource(t, n, r, s) {
    let a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {
      silent: !1
    };
    const o = a.keySeparator !== void 0 ? a.keySeparator : this.options.keySeparator;
    let c = [t, n];
    r && (c = c.concat(o ? r.split(o) : r)), t.indexOf(".") > -1 && (c = t.split("."), s = n, n = c[1]), this.addNamespaces(n), Df(this.data, c, s), a.silent || this.emit("added", t, n, r, s);
  }
  addResources(t, n, r) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {
      silent: !1
    };
    for (const a in r)
      (typeof r[a] == "string" || Object.prototype.toString.apply(r[a]) === "[object Array]") && this.addResource(t, n, a, r[a], {
        silent: !0
      });
    s.silent || this.emit("added", t, n, r);
  }
  addResourceBundle(t, n, r, s, a) {
    let o = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {
      silent: !1
    }, c = [t, n];
    t.indexOf(".") > -1 && (c = t.split("."), s = r, r = n, n = c[1]), this.addNamespaces(n);
    let l = ha(this.data, c) || {};
    s ? g0(l, r, a) : l = R(R({}, l), r), Df(this.data, c, l), o.silent || this.emit("added", t, n, r);
  }
  removeResourceBundle(t, n) {
    this.hasResourceBundle(t, n) && delete this.data[t][n], this.removeNamespaces(n), this.emit("removed", t, n);
  }
  hasResourceBundle(t, n) {
    return this.getResource(t, n) !== void 0;
  }
  getResourceBundle(t, n) {
    return n || (n = this.options.defaultNS), this.options.compatibilityAPI === "v1" ? R({}, this.getResource(t, n)) : this.getResource(t, n);
  }
  getDataByLanguage(t) {
    return this.data[t];
  }
  hasLanguageSomeTranslations(t) {
    const n = this.getDataByLanguage(t);
    return !!(n && Object.keys(n) || []).find((s) => n[s] && Object.keys(n[s]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var w0 = {
  processors: {},
  addPostProcessor(e) {
    this.processors[e.name] = e;
  },
  handle(e, t, n, r, s) {
    return e.forEach((a) => {
      this.processors[a] && (t = this.processors[a].process(t, n, r, s));
    }), t;
  }
};
const $f = {};
class ga extends Ga {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    super(), rz(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], t, this), this.options = n, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = rn.create("translator");
  }
  changeLanguage(t) {
    t && (this.language = t);
  }
  exists(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    };
    if (t == null)
      return !1;
    const r = this.resolve(t, n);
    return r && r.res !== void 0;
  }
  extractFromKey(t, n) {
    let r = n.nsSeparator !== void 0 ? n.nsSeparator : this.options.nsSeparator;
    r === void 0 && (r = ":");
    const s = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator;
    let a = n.ns || this.options.defaultNS || [];
    const o = r && t.indexOf(r) > -1, c = !this.options.userDefinedKeySeparator && !n.keySeparator && !this.options.userDefinedNsSeparator && !n.nsSeparator && !lz(t, r, s);
    if (o && !c) {
      const l = t.match(this.interpolator.nestingRegexp);
      if (l && l.length > 0)
        return {
          key: t,
          namespaces: a
        };
      const d = t.split(r);
      (r !== s || r === s && this.options.ns.indexOf(d[0]) > -1) && (a = d.shift()), t = d.join(s);
    }
    return typeof a == "string" && (a = [a]), {
      key: t,
      namespaces: a
    };
  }
  translate(t, n, r) {
    if (typeof n != "object" && this.options.overloadTranslationOptionHandler && (n = this.options.overloadTranslationOptionHandler(arguments)), typeof n == "object" && (n = R({}, n)), n || (n = {}), t == null)
      return "";
    Array.isArray(t) || (t = [String(t)]);
    const s = n.returnDetails !== void 0 ? n.returnDetails : this.options.returnDetails, a = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator, {
      key: o,
      namespaces: c
    } = this.extractFromKey(t[t.length - 1], n), l = c[c.length - 1], d = n.lng || this.language, u = n.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (d && d.toLowerCase() === "cimode") {
      if (u) {
        const S = n.nsSeparator || this.options.nsSeparator;
        return s ? {
          res: `${l}${S}${o}`,
          usedKey: o,
          exactUsedKey: o,
          usedLng: d,
          usedNS: l,
          usedParams: this.getUsedParamsDetails(n)
        } : `${l}${S}${o}`;
      }
      return s ? {
        res: o,
        usedKey: o,
        exactUsedKey: o,
        usedLng: d,
        usedNS: l,
        usedParams: this.getUsedParamsDetails(n)
      } : o;
    }
    const h = this.resolve(t, n);
    let f = h && h.res;
    const p = h && h.usedKey || o, m = h && h.exactUsedKey || o, C = Object.prototype.toString.apply(f), y = ["[object Number]", "[object Function]", "[object RegExp]"], g = n.joinArrays !== void 0 ? n.joinArrays : this.options.joinArrays, w = !this.i18nFormat || this.i18nFormat.handleAsObject;
    if (w && f && (typeof f != "string" && typeof f != "boolean" && typeof f != "number") && y.indexOf(C) < 0 && !(typeof g == "string" && C === "[object Array]")) {
      if (!n.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const S = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(p, f, X(R({}, n), {
          ns: c
        })) : `key '${o} (${this.language})' returned an object instead of string.`;
        return s ? (h.res = S, h.usedParams = this.getUsedParamsDetails(n), h) : S;
      }
      if (a) {
        const S = C === "[object Array]", N = S ? [] : {}, v = S ? m : p;
        for (const b in f)
          if (Object.prototype.hasOwnProperty.call(f, b)) {
            const j = `${v}${a}${b}`;
            N[b] = this.translate(j, X(R({}, n), {
              joinArrays: !1,
              ns: c
            })), N[b] === j && (N[b] = f[b]);
          }
        f = N;
      }
    } else if (w && typeof g == "string" && C === "[object Array]")
      f = f.join(g), f && (f = this.extendTranslation(f, t, n, r));
    else {
      let S = !1, N = !1;
      const v = n.count !== void 0 && typeof n.count != "string", b = ga.hasDefaultValue(n), j = v ? this.pluralResolver.getSuffix(d, n.count, n) : "", D = n.ordinal && v ? this.pluralResolver.getSuffix(d, n.count, {
        ordinal: !1
      }) : "", $ = n[`defaultValue${j}`] || n[`defaultValue${D}`] || n.defaultValue;
      !this.isValidLookup(f) && b && (S = !0, f = $), this.isValidLookup(f) || (N = !0, f = o);
      const L = (n.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && N ? void 0 : f, I = b && $ !== f && this.options.updateMissing;
      if (N || S || I) {
        if (this.logger.log(I ? "updateKey" : "missingKey", d, l, o, I ? $ : f), a) {
          const Z = this.resolve(o, X(R({}, n), {
            keySeparator: !1
          }));
          Z && Z.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let A = [];
        const M = this.languageUtils.getFallbackCodes(this.options.fallbackLng, n.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && M && M[0])
          for (let Z = 0; Z < M.length; Z++)
            A.push(M[Z]);
        else
          this.options.saveMissingTo === "all" ? A = this.languageUtils.toResolveHierarchy(n.lng || this.language) : A.push(n.lng || this.language);
        const G = (Z, Q, T) => {
          const P = b && T !== f ? T : L;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(Z, l, Q, P, I, n) : this.backendConnector && this.backendConnector.saveMissing && this.backendConnector.saveMissing(Z, l, Q, P, I, n), this.emit("missingKey", Z, l, Q, f);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && v ? A.forEach((Z) => {
          this.pluralResolver.getSuffixes(Z, n).forEach((Q) => {
            G([Z], o + Q, n[`defaultValue${Q}`] || $);
          });
        }) : G(A, o, $));
      }
      f = this.extendTranslation(f, t, n, h, r), N && f === o && this.options.appendNamespaceToMissingKey && (f = `${l}:${o}`), (N || S) && this.options.parseMissingKeyHandler && (this.options.compatibilityAPI !== "v1" ? f = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${l}:${o}` : o, S ? f : void 0) : f = this.options.parseMissingKeyHandler(f));
    }
    return s ? (h.res = f, h.usedParams = this.getUsedParamsDetails(n), h) : f;
  }
  extendTranslation(t, n, r, s, a) {
    var o = this;
    if (this.i18nFormat && this.i18nFormat.parse)
      t = this.i18nFormat.parse(t, R(R({}, this.options.interpolation.defaultVariables), r), r.lng || this.language || s.usedLng, s.usedNS, s.usedKey, {
        resolved: s
      });
    else if (!r.skipInterpolation) {
      r.interpolation && this.interpolator.init(X(R({}, r), {
        interpolation: R(R({}, this.options.interpolation), r.interpolation)
      }));
      const d = typeof t == "string" && (r && r.interpolation && r.interpolation.skipOnVariables !== void 0 ? r.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let u;
      if (d) {
        const f = t.match(this.interpolator.nestingRegexp);
        u = f && f.length;
      }
      let h = r.replace && typeof r.replace != "string" ? r.replace : r;
      if (this.options.interpolation.defaultVariables && (h = R(R({}, this.options.interpolation.defaultVariables), h)), t = this.interpolator.interpolate(t, h, r.lng || this.language, r), d) {
        const f = t.match(this.interpolator.nestingRegexp), p = f && f.length;
        u < p && (r.nest = !1);
      }
      !r.lng && this.options.compatibilityAPI !== "v1" && s && s.res && (r.lng = s.usedLng), r.nest !== !1 && (t = this.interpolator.nest(t, function() {
        for (var f = arguments.length, p = new Array(f), m = 0; m < f; m++)
          p[m] = arguments[m];
        return a && a[0] === p[0] && !r.context ? (o.logger.warn(`It seems you are nesting recursively key: ${p[0]} in key: ${n[0]}`), null) : o.translate(...p, n);
      }, r)), r.interpolation && this.interpolator.reset();
    }
    const c = r.postProcess || this.options.postProcess, l = typeof c == "string" ? [c] : c;
    return t != null && l && l.length && r.applyPostProcessor !== !1 && (t = w0.handle(l, t, n, this.options && this.options.postProcessPassResolved ? R({
      i18nResolved: X(R({}, s), {
        usedParams: this.getUsedParamsDetails(r)
      })
    }, r) : r, this)), t;
  }
  resolve(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r, s, a, o, c;
    return typeof t == "string" && (t = [t]), t.forEach((l) => {
      if (this.isValidLookup(r))
        return;
      const d = this.extractFromKey(l, n), u = d.key;
      s = u;
      let h = d.namespaces;
      this.options.fallbackNS && (h = h.concat(this.options.fallbackNS));
      const f = n.count !== void 0 && typeof n.count != "string", p = f && !n.ordinal && n.count === 0 && this.pluralResolver.shouldUseIntlApi(), m = n.context !== void 0 && (typeof n.context == "string" || typeof n.context == "number") && n.context !== "", C = n.lngs ? n.lngs : this.languageUtils.toResolveHierarchy(n.lng || this.language, n.fallbackLng);
      h.forEach((y) => {
        this.isValidLookup(r) || (c = y, !$f[`${C[0]}-${y}`] && this.utils && this.utils.hasLoadedNamespace && !this.utils.hasLoadedNamespace(c) && ($f[`${C[0]}-${y}`] = !0, this.logger.warn(`key "${s}" for languages "${C.join(", ")}" won't get resolved as namespace "${c}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), C.forEach((g) => {
          if (this.isValidLookup(r))
            return;
          o = g;
          const w = [u];
          if (this.i18nFormat && this.i18nFormat.addLookupKeys)
            this.i18nFormat.addLookupKeys(w, u, g, y, n);
          else {
            let S;
            f && (S = this.pluralResolver.getSuffix(g, n.count, n));
            const N = `${this.options.pluralSeparator}zero`, v = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (f && (w.push(u + S), n.ordinal && S.indexOf(v) === 0 && w.push(u + S.replace(v, this.options.pluralSeparator)), p && w.push(u + N)), m) {
              const b = `${u}${this.options.contextSeparator}${n.context}`;
              w.push(b), f && (w.push(b + S), n.ordinal && S.indexOf(v) === 0 && w.push(b + S.replace(v, this.options.pluralSeparator)), p && w.push(b + N));
            }
          }
          let x;
          for (; x = w.pop(); )
            this.isValidLookup(r) || (a = x, r = this.getResource(g, y, x, n));
        }));
      });
    }), {
      res: r,
      usedKey: s,
      exactUsedKey: a,
      usedLng: o,
      usedNS: c
    };
  }
  isValidLookup(t) {
    return t !== void 0 && !(!this.options.returnNull && t === null) && !(!this.options.returnEmptyString && t === "");
  }
  getResource(t, n, r) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return this.i18nFormat && this.i18nFormat.getResource ? this.i18nFormat.getResource(t, n, r, s) : this.resourceStore.getResource(t, n, r, s);
  }
  getUsedParamsDetails() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const n = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], r = t.replace && typeof t.replace != "string";
    let s = r ? t.replace : t;
    if (r && typeof t.count != "undefined" && (s.count = t.count), this.options.interpolation.defaultVariables && (s = R(R({}, this.options.interpolation.defaultVariables), s)), !r) {
      s = R({}, s);
      for (const a of n)
        delete s[a];
    }
    return s;
  }
  static hasDefaultValue(t) {
    const n = "defaultValue";
    for (const r in t)
      if (Object.prototype.hasOwnProperty.call(t, r) && n === r.substring(0, n.length) && t[r] !== void 0)
        return !0;
    return !1;
  }
}
function Hi(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
class Af {
  constructor(t) {
    this.options = t, this.supportedLngs = this.options.supportedLngs || !1, this.logger = rn.create("languageUtils");
  }
  getScriptPartFromCode(t) {
    if (t = ma(t), !t || t.indexOf("-") < 0)
      return null;
    const n = t.split("-");
    return n.length === 2 || (n.pop(), n[n.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(n.join("-"));
  }
  getLanguagePartFromCode(t) {
    if (t = ma(t), !t || t.indexOf("-") < 0)
      return t;
    const n = t.split("-");
    return this.formatLanguageCode(n[0]);
  }
  formatLanguageCode(t) {
    if (typeof t == "string" && t.indexOf("-") > -1) {
      const n = ["hans", "hant", "latn", "cyrl", "cans", "mong", "arab"];
      let r = t.split("-");
      return this.options.lowerCaseLng ? r = r.map((s) => s.toLowerCase()) : r.length === 2 ? (r[0] = r[0].toLowerCase(), r[1] = r[1].toUpperCase(), n.indexOf(r[1].toLowerCase()) > -1 && (r[1] = Hi(r[1].toLowerCase()))) : r.length === 3 && (r[0] = r[0].toLowerCase(), r[1].length === 2 && (r[1] = r[1].toUpperCase()), r[0] !== "sgn" && r[2].length === 2 && (r[2] = r[2].toUpperCase()), n.indexOf(r[1].toLowerCase()) > -1 && (r[1] = Hi(r[1].toLowerCase())), n.indexOf(r[2].toLowerCase()) > -1 && (r[2] = Hi(r[2].toLowerCase()))), r.join("-");
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? t.toLowerCase() : t;
  }
  isSupportedCode(t) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (t = this.getLanguagePartFromCode(t)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(t) > -1;
  }
  getBestMatchFromCodes(t) {
    if (!t)
      return null;
    let n;
    return t.forEach((r) => {
      if (n)
        return;
      const s = this.formatLanguageCode(r);
      (!this.options.supportedLngs || this.isSupportedCode(s)) && (n = s);
    }), !n && this.options.supportedLngs && t.forEach((r) => {
      if (n)
        return;
      const s = this.getLanguagePartFromCode(r);
      if (this.isSupportedCode(s))
        return n = s;
      n = this.options.supportedLngs.find((a) => {
        if (a === s)
          return a;
        if (!(a.indexOf("-") < 0 && s.indexOf("-") < 0) && a.indexOf(s) === 0)
          return a;
      });
    }), n || (n = this.getFallbackCodes(this.options.fallbackLng)[0]), n;
  }
  getFallbackCodes(t, n) {
    if (!t)
      return [];
    if (typeof t == "function" && (t = t(n)), typeof t == "string" && (t = [t]), Object.prototype.toString.apply(t) === "[object Array]")
      return t;
    if (!n)
      return t.default || [];
    let r = t[n];
    return r || (r = t[this.getScriptPartFromCode(n)]), r || (r = t[this.formatLanguageCode(n)]), r || (r = t[this.getLanguagePartFromCode(n)]), r || (r = t.default), r || [];
  }
  toResolveHierarchy(t, n) {
    const r = this.getFallbackCodes(n || this.options.fallbackLng || [], t), s = [], a = (o) => {
      o && (this.isSupportedCode(o) ? s.push(o) : this.logger.warn(`rejecting language code not found in supportedLngs: ${o}`));
    };
    return typeof t == "string" && (t.indexOf("-") > -1 || t.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && a(this.formatLanguageCode(t)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && a(this.getScriptPartFromCode(t)), this.options.load !== "currentOnly" && a(this.getLanguagePartFromCode(t))) : typeof t == "string" && a(this.formatLanguageCode(t)), r.forEach((o) => {
      s.indexOf(o) < 0 && a(this.formatLanguageCode(o));
    }), s;
  }
}
let dz = [{
  lngs: ["ach", "ak", "am", "arn", "br", "fil", "gun", "ln", "mfe", "mg", "mi", "oc", "pt", "pt-BR", "tg", "tl", "ti", "tr", "uz", "wa"],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ["af", "an", "ast", "az", "bg", "bn", "ca", "da", "de", "dev", "el", "en", "eo", "es", "et", "eu", "fi", "fo", "fur", "fy", "gl", "gu", "ha", "hi", "hu", "hy", "ia", "it", "kk", "kn", "ku", "lb", "mai", "ml", "mn", "mr", "nah", "nap", "nb", "ne", "nl", "nn", "no", "nso", "pa", "pap", "pms", "ps", "pt-PT", "rm", "sco", "se", "si", "so", "son", "sq", "sv", "sw", "ta", "te", "tk", "ur", "yo"],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ["ay", "bo", "cgg", "fa", "ht", "id", "ja", "jbo", "ka", "km", "ko", "ky", "lo", "ms", "sah", "su", "th", "tt", "ug", "vi", "wo", "zh"],
  nr: [1],
  fc: 3
}, {
  lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ["ar"],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ["cs", "sk"],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ["csb", "pl"],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ["cy"],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ["fr"],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ["ga"],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ["gd"],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ["is"],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ["jv"],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ["kw"],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ["lt"],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ["lv"],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ["mk"],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ["mnk"],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ["mt"],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ["or"],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ["ro"],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ["sl"],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ["he", "iw"],
  nr: [1, 2, 20, 21],
  fc: 22
}], uz = {
  1: function(e) {
    return +(e > 1);
  },
  2: function(e) {
    return +(e != 1);
  },
  3: function(e) {
    return 0;
  },
  4: function(e) {
    return e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2;
  },
  5: function(e) {
    return e == 0 ? 0 : e == 1 ? 1 : e == 2 ? 2 : e % 100 >= 3 && e % 100 <= 10 ? 3 : e % 100 >= 11 ? 4 : 5;
  },
  6: function(e) {
    return e == 1 ? 0 : e >= 2 && e <= 4 ? 1 : 2;
  },
  7: function(e) {
    return e == 1 ? 0 : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2;
  },
  8: function(e) {
    return e == 1 ? 0 : e == 2 ? 1 : e != 8 && e != 11 ? 2 : 3;
  },
  9: function(e) {
    return +(e >= 2);
  },
  10: function(e) {
    return e == 1 ? 0 : e == 2 ? 1 : e < 7 ? 2 : e < 11 ? 3 : 4;
  },
  11: function(e) {
    return e == 1 || e == 11 ? 0 : e == 2 || e == 12 ? 1 : e > 2 && e < 20 ? 2 : 3;
  },
  12: function(e) {
    return +(e % 10 != 1 || e % 100 == 11);
  },
  13: function(e) {
    return +(e !== 0);
  },
  14: function(e) {
    return e == 1 ? 0 : e == 2 ? 1 : e == 3 ? 2 : 3;
  },
  15: function(e) {
    return e % 10 == 1 && e % 100 != 11 ? 0 : e % 10 >= 2 && (e % 100 < 10 || e % 100 >= 20) ? 1 : 2;
  },
  16: function(e) {
    return e % 10 == 1 && e % 100 != 11 ? 0 : e !== 0 ? 1 : 2;
  },
  17: function(e) {
    return e == 1 || e % 10 == 1 && e % 100 != 11 ? 0 : 1;
  },
  18: function(e) {
    return e == 0 ? 0 : e == 1 ? 1 : 2;
  },
  19: function(e) {
    return e == 1 ? 0 : e == 0 || e % 100 > 1 && e % 100 < 11 ? 1 : e % 100 > 10 && e % 100 < 20 ? 2 : 3;
  },
  20: function(e) {
    return e == 1 ? 0 : e == 0 || e % 100 > 0 && e % 100 < 20 ? 1 : 2;
  },
  21: function(e) {
    return e % 100 == 1 ? 1 : e % 100 == 2 ? 2 : e % 100 == 3 || e % 100 == 4 ? 3 : 0;
  },
  22: function(e) {
    return e == 1 ? 0 : e == 2 ? 1 : (e < 0 || e > 10) && e % 10 == 0 ? 2 : 3;
  }
};
const fz = ["v1", "v2", "v3"], hz = ["v4"], Ef = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};
function pz() {
  const e = {};
  return dz.forEach((t) => {
    t.lngs.forEach((n) => {
      e[n] = {
        numbers: t.nr,
        plurals: uz[t.fc]
      };
    });
  }), e;
}
class mz {
  constructor(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.languageUtils = t, this.options = n, this.logger = rn.create("pluralResolver"), (!this.options.compatibilityJSON || hz.includes(this.options.compatibilityJSON)) && (typeof Intl == "undefined" || !Intl.PluralRules) && (this.options.compatibilityJSON = "v3", this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.")), this.rules = pz();
  }
  addRule(t, n) {
    this.rules[t] = n;
  }
  getRule(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.shouldUseIntlApi())
      try {
        return new Intl.PluralRules(ma(t), {
          type: n.ordinal ? "ordinal" : "cardinal"
        });
      } catch (r) {
        return;
      }
    return this.rules[t] || this.rules[this.languageUtils.getLanguagePartFromCode(t)];
  }
  needsPlural(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = this.getRule(t, n);
    return this.shouldUseIntlApi() ? r && r.resolvedOptions().pluralCategories.length > 1 : r && r.numbers.length > 1;
  }
  getPluralFormsOfKey(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return this.getSuffixes(t, r).map((s) => `${n}${s}`);
  }
  getSuffixes(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    const r = this.getRule(t, n);
    return r ? this.shouldUseIntlApi() ? r.resolvedOptions().pluralCategories.sort((s, a) => Ef[s] - Ef[a]).map((s) => `${this.options.prepend}${n.ordinal ? `ordinal${this.options.prepend}` : ""}${s}`) : r.numbers.map((s) => this.getSuffix(t, s, n)) : [];
  }
  getSuffix(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const s = this.getRule(t, r);
    return s ? this.shouldUseIntlApi() ? `${this.options.prepend}${r.ordinal ? `ordinal${this.options.prepend}` : ""}${s.select(n)}` : this.getSuffixRetroCompatible(s, n) : (this.logger.warn(`no plural rule found for: ${t}`), "");
  }
  getSuffixRetroCompatible(t, n) {
    const r = t.noAbs ? t.plurals(n) : t.plurals(Math.abs(n));
    let s = t.numbers[r];
    this.options.simplifyPluralSuffix && t.numbers.length === 2 && t.numbers[0] === 1 && (s === 2 ? s = "plural" : s === 1 && (s = ""));
    const a = () => this.options.prepend && s.toString() ? this.options.prepend + s.toString() : s.toString();
    return this.options.compatibilityJSON === "v1" ? s === 1 ? "" : typeof s == "number" ? `_plural_${s.toString()}` : a() : this.options.compatibilityJSON === "v2" || this.options.simplifyPluralSuffix && t.numbers.length === 2 && t.numbers[0] === 1 ? a() : this.options.prepend && r.toString() ? this.options.prepend + r.toString() : r.toString();
  }
  shouldUseIntlApi() {
    return !fz.includes(this.options.compatibilityJSON);
  }
}
function If(e, t, n) {
  let r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ".", s = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, a = az(e, t, n);
  return !a && s && typeof n == "string" && (a = pa(e, n, r), a === void 0 && (a = pa(t, n, r))), a;
}
class gz {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = rn.create("interpolator"), this.options = t, this.format = t.interpolation && t.interpolation.format || ((n) => n), this.init(t);
  }
  init() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    t.interpolation || (t.interpolation = {
      escapeValue: !0
    });
    const n = t.interpolation;
    this.escape = n.escape !== void 0 ? n.escape : oz, this.escapeValue = n.escapeValue !== void 0 ? n.escapeValue : !0, this.useRawValueToEscape = n.useRawValueToEscape !== void 0 ? n.useRawValueToEscape : !1, this.prefix = n.prefix ? rr(n.prefix) : n.prefixEscaped || "{{", this.suffix = n.suffix ? rr(n.suffix) : n.suffixEscaped || "}}", this.formatSeparator = n.formatSeparator ? n.formatSeparator : n.formatSeparator || ",", this.unescapePrefix = n.unescapeSuffix ? "" : n.unescapePrefix || "-", this.unescapeSuffix = this.unescapePrefix ? "" : n.unescapeSuffix || "", this.nestingPrefix = n.nestingPrefix ? rr(n.nestingPrefix) : n.nestingPrefixEscaped || rr("$t("), this.nestingSuffix = n.nestingSuffix ? rr(n.nestingSuffix) : n.nestingSuffixEscaped || rr(")"), this.nestingOptionsSeparator = n.nestingOptionsSeparator ? n.nestingOptionsSeparator : n.nestingOptionsSeparator || ",", this.maxReplaces = n.maxReplaces ? n.maxReplaces : 1e3, this.alwaysFormat = n.alwaysFormat !== void 0 ? n.alwaysFormat : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const t = `${this.prefix}(.+?)${this.suffix}`;
    this.regexp = new RegExp(t, "g");
    const n = `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`;
    this.regexpUnescape = new RegExp(n, "g");
    const r = `${this.nestingPrefix}(.+?)${this.nestingSuffix}`;
    this.nestingRegexp = new RegExp(r, "g");
  }
  interpolate(t, n, r, s) {
    let a, o, c;
    const l = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
    function d(m) {
      return m.replace(/\$/g, "$$$$");
    }
    const u = (m) => {
      if (m.indexOf(this.formatSeparator) < 0) {
        const w = If(n, l, m, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(w, void 0, r, X(R(R({}, s), n), {
          interpolationkey: m
        })) : w;
      }
      const C = m.split(this.formatSeparator), y = C.shift().trim(), g = C.join(this.formatSeparator).trim();
      return this.format(If(n, l, y, this.options.keySeparator, this.options.ignoreJSONStructure), g, r, X(R(R({}, s), n), {
        interpolationkey: y
      }));
    };
    this.resetRegExp();
    const h = s && s.missingInterpolationHandler || this.options.missingInterpolationHandler, f = s && s.interpolation && s.interpolation.skipOnVariables !== void 0 ? s.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (m) => d(m)
    }, {
      regex: this.regexp,
      safeValue: (m) => this.escapeValue ? d(this.escape(m)) : d(m)
    }].forEach((m) => {
      for (c = 0; a = m.regex.exec(t); ) {
        const C = a[1].trim();
        if (o = u(C), o === void 0)
          if (typeof h == "function") {
            const g = h(t, a, s);
            o = typeof g == "string" ? g : "";
          } else if (s && Object.prototype.hasOwnProperty.call(s, C))
            o = "";
          else if (f) {
            o = a[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${C} for interpolating ${t}`), o = "";
        else
          typeof o != "string" && !this.useRawValueToEscape && (o = Nf(o));
        const y = m.safeValue(o);
        if (t = t.replace(a[0], y), f ? (m.regex.lastIndex += o.length, m.regex.lastIndex -= a[0].length) : m.regex.lastIndex = 0, c++, c >= this.maxReplaces)
          break;
      }
    }), t;
  }
  nest(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, s, a, o;
    function c(l, d) {
      const u = this.nestingOptionsSeparator;
      if (l.indexOf(u) < 0)
        return l;
      const h = l.split(new RegExp(`${u}[ ]*{`));
      let f = `{${h[1]}`;
      l = h[0], f = this.interpolate(f, o);
      const p = f.match(/'/g), m = f.match(/"/g);
      (p && p.length % 2 === 0 && !m || m.length % 2 !== 0) && (f = f.replace(/'/g, '"'));
      try {
        o = JSON.parse(f), d && (o = R(R({}, d), o));
      } catch (C) {
        return this.logger.warn(`failed parsing options string in nesting for key ${l}`, C), `${l}${u}${f}`;
      }
      return delete o.defaultValue, l;
    }
    for (; s = this.nestingRegexp.exec(t); ) {
      let l = [];
      o = R({}, r), o = o.replace && typeof o.replace != "string" ? o.replace : o, o.applyPostProcessor = !1, delete o.defaultValue;
      let d = !1;
      if (s[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(s[1])) {
        const u = s[1].split(this.formatSeparator).map((h) => h.trim());
        s[1] = u.shift(), l = u, d = !0;
      }
      if (a = n(c.call(this, s[1].trim(), o), o), a && s[0] === t && typeof a != "string")
        return a;
      typeof a != "string" && (a = Nf(a)), a || (this.logger.warn(`missed to resolve ${s[1]} for nesting ${t}`), a = ""), d && (a = l.reduce((u, h) => this.format(u, h, r.lng, X(R({}, r), {
        interpolationkey: s[1].trim()
      })), a.trim())), t = t.replace(s[0], a), this.regexp.lastIndex = 0;
    }
    return t;
  }
}
function wz(e) {
  let t = e.toLowerCase().trim();
  const n = {};
  if (e.indexOf("(") > -1) {
    const r = e.split("(");
    t = r[0].toLowerCase().trim();
    const s = r[1].substring(0, r[1].length - 1);
    t === "currency" && s.indexOf(":") < 0 ? n.currency || (n.currency = s.trim()) : t === "relativetime" && s.indexOf(":") < 0 ? n.range || (n.range = s.trim()) : s.split(";").forEach((o) => {
      if (!o)
        return;
      const [c, ...l] = o.split(":"), d = l.join(":").trim().replace(/^'+|'+$/g, "");
      n[c.trim()] || (n[c.trim()] = d), d === "false" && (n[c.trim()] = !1), d === "true" && (n[c.trim()] = !0), isNaN(d) || (n[c.trim()] = parseInt(d, 10));
    });
  }
  return {
    formatName: t,
    formatOptions: n
  };
}
function sr(e) {
  const t = {};
  return function(r, s, a) {
    const o = s + JSON.stringify(a);
    let c = t[o];
    return c || (c = e(ma(s), a), t[o] = c), c(r);
  };
}
class vz {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.logger = rn.create("formatter"), this.options = t, this.formats = {
      number: sr((n, r) => {
        const s = new Intl.NumberFormat(n, R({}, r));
        return (a) => s.format(a);
      }),
      currency: sr((n, r) => {
        const s = new Intl.NumberFormat(n, X(R({}, r), {
          style: "currency"
        }));
        return (a) => s.format(a);
      }),
      datetime: sr((n, r) => {
        const s = new Intl.DateTimeFormat(n, R({}, r));
        return (a) => s.format(a);
      }),
      relativetime: sr((n, r) => {
        const s = new Intl.RelativeTimeFormat(n, R({}, r));
        return (a) => s.format(a, r.range || "day");
      }),
      list: sr((n, r) => {
        const s = new Intl.ListFormat(n, R({}, r));
        return (a) => s.format(a);
      })
    }, this.init(t);
  }
  init(t) {
    const r = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      interpolation: {}
    }).interpolation;
    this.formatSeparator = r.formatSeparator ? r.formatSeparator : r.formatSeparator || ",";
  }
  add(t, n) {
    this.formats[t.toLowerCase().trim()] = n;
  }
  addCached(t, n) {
    this.formats[t.toLowerCase().trim()] = sr(n);
  }
  format(t, n, r) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return n.split(this.formatSeparator).reduce((c, l) => {
      const {
        formatName: d,
        formatOptions: u
      } = wz(l);
      if (this.formats[d]) {
        let h = c;
        try {
          const f = s && s.formatParams && s.formatParams[s.interpolationkey] || {}, p = f.locale || f.lng || s.locale || s.lng || r;
          h = this.formats[d](c, p, R(R(R({}, u), s), f));
        } catch (f) {
          this.logger.warn(f);
        }
        return h;
      } else
        this.logger.warn(`there was no format function for ${d}`);
      return c;
    }, t);
  }
}
function yz(e, t) {
  e.pending[t] !== void 0 && (delete e.pending[t], e.pendingCount--);
}
class xz extends Ga {
  constructor(t, n, r) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    super(), this.backend = t, this.store = n, this.services = r, this.languageUtils = r.languageUtils, this.options = s, this.logger = rn.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = s.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = s.maxRetries >= 0 ? s.maxRetries : 5, this.retryTimeout = s.retryTimeout >= 1 ? s.retryTimeout : 350, this.state = {}, this.queue = [], this.backend && this.backend.init && this.backend.init(r, s.backend, s);
  }
  queueLoad(t, n, r, s) {
    const a = {}, o = {}, c = {}, l = {};
    return t.forEach((d) => {
      let u = !0;
      n.forEach((h) => {
        const f = `${d}|${h}`;
        !r.reload && this.store.hasResourceBundle(d, h) ? this.state[f] = 2 : this.state[f] < 0 || (this.state[f] === 1 ? o[f] === void 0 && (o[f] = !0) : (this.state[f] = 1, u = !1, o[f] === void 0 && (o[f] = !0), a[f] === void 0 && (a[f] = !0), l[h] === void 0 && (l[h] = !0)));
      }), u || (c[d] = !0);
    }), (Object.keys(a).length || Object.keys(o).length) && this.queue.push({
      pending: o,
      pendingCount: Object.keys(o).length,
      loaded: {},
      errors: [],
      callback: s
    }), {
      toLoad: Object.keys(a),
      pending: Object.keys(o),
      toLoadLanguages: Object.keys(c),
      toLoadNamespaces: Object.keys(l)
    };
  }
  loaded(t, n, r) {
    const s = t.split("|"), a = s[0], o = s[1];
    n && this.emit("failedLoading", a, o, n), r && this.store.addResourceBundle(a, o, r), this.state[t] = n ? -1 : 2;
    const c = {};
    this.queue.forEach((l) => {
      sz(l.loaded, [a], o), yz(l, t), n && l.errors.push(n), l.pendingCount === 0 && !l.done && (Object.keys(l.loaded).forEach((d) => {
        c[d] || (c[d] = {});
        const u = l.loaded[d];
        u.length && u.forEach((h) => {
          c[d][h] === void 0 && (c[d][h] = !0);
        });
      }), l.done = !0, l.errors.length ? l.callback(l.errors) : l.callback());
    }), this.emit("loaded", c), this.queue = this.queue.filter((l) => !l.done);
  }
  read(t, n, r) {
    let s = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : this.retryTimeout, o = arguments.length > 5 ? arguments[5] : void 0;
    if (!t.length)
      return o(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: t,
        ns: n,
        fcName: r,
        tried: s,
        wait: a,
        callback: o
      });
      return;
    }
    this.readingCalls++;
    const c = (d, u) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const h = this.waitingReads.shift();
        this.read(h.lng, h.ns, h.fcName, h.tried, h.wait, h.callback);
      }
      if (d && u && s < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, t, n, r, s + 1, a * 2, o);
        }, a);
        return;
      }
      o(d, u);
    }, l = this.backend[r].bind(this.backend);
    if (l.length === 2) {
      try {
        const d = l(t, n);
        d && typeof d.then == "function" ? d.then((u) => c(null, u)).catch(c) : c(null, d);
      } catch (d) {
        c(d);
      }
      return;
    }
    return l(t, n, c);
  }
  prepareLoading(t, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, s = arguments.length > 3 ? arguments[3] : void 0;
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), s && s();
    typeof t == "string" && (t = this.languageUtils.toResolveHierarchy(t)), typeof n == "string" && (n = [n]);
    const a = this.queueLoad(t, n, r, s);
    if (!a.toLoad.length)
      return a.pending.length || s(), null;
    a.toLoad.forEach((o) => {
      this.loadOne(o);
    });
  }
  load(t, n, r) {
    this.prepareLoading(t, n, {}, r);
  }
  reload(t, n, r) {
    this.prepareLoading(t, n, {
      reload: !0
    }, r);
  }
  loadOne(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    const r = t.split("|"), s = r[0], a = r[1];
    this.read(s, a, "read", void 0, void 0, (o, c) => {
      o && this.logger.warn(`${n}loading namespace ${a} for language ${s} failed`, o), !o && c && this.logger.log(`${n}loaded namespace ${a} for language ${s}`, c), this.loaded(t, o, c);
    });
  }
  saveMissing(t, n, r, s, a) {
    let o = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, c = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : () => {
    };
    if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(n)) {
      this.logger.warn(`did not save key "${r}" as the namespace "${n}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(r == null || r === "")) {
      if (this.backend && this.backend.create) {
        const l = X(R({}, o), {
          isUpdate: a
        }), d = this.backend.create.bind(this.backend);
        if (d.length < 6)
          try {
            let u;
            d.length === 5 ? u = d(t, n, r, s, l) : u = d(t, n, r, s), u && typeof u.then == "function" ? u.then((h) => c(null, h)).catch(c) : c(null, u);
          } catch (u) {
            c(u);
          }
        else
          d(t, n, r, s, c, l);
      }
      !t || !t[0] || this.store.addResource(t[0], n, r, s);
    }
  }
}
function _f() {
  return {
    debug: !1,
    initImmediate: !0,
    ns: ["translation"],
    defaultNS: ["translation"],
    fallbackLng: ["dev"],
    fallbackNS: !1,
    supportedLngs: !1,
    nonExplicitSupportedLngs: !1,
    load: "all",
    preload: !1,
    simplifyPluralSuffix: !0,
    keySeparator: ".",
    nsSeparator: ":",
    pluralSeparator: "_",
    contextSeparator: "_",
    partialBundledLanguages: !1,
    saveMissing: !1,
    updateMissing: !1,
    saveMissingTo: "fallback",
    saveMissingPlurals: !0,
    missingKeyHandler: !1,
    missingInterpolationHandler: !1,
    postProcess: !1,
    postProcessPassResolved: !1,
    returnNull: !1,
    returnEmptyString: !0,
    returnObjects: !1,
    joinArrays: !1,
    returnedObjectHandler: !1,
    parseMissingKeyHandler: !1,
    appendNamespaceToMissingKey: !1,
    appendNamespaceToCIMode: !1,
    overloadTranslationOptionHandler: function(t) {
      let n = {};
      if (typeof t[1] == "object" && (n = t[1]), typeof t[1] == "string" && (n.defaultValue = t[1]), typeof t[2] == "string" && (n.tDescription = t[2]), typeof t[2] == "object" || typeof t[3] == "object") {
        const r = t[3] || t[2];
        Object.keys(r).forEach((s) => {
          n[s] = r[s];
        });
      }
      return n;
    },
    interpolation: {
      escapeValue: !0,
      format: (e, t, n, r) => e,
      prefix: "{{",
      suffix: "}}",
      formatSeparator: ",",
      unescapePrefix: "-",
      nestingPrefix: "$t(",
      nestingSuffix: ")",
      nestingOptionsSeparator: ",",
      maxReplaces: 1e3,
      skipOnVariables: !0
    }
  };
}
function Tf(e) {
  return typeof e.ns == "string" && (e.ns = [e.ns]), typeof e.fallbackLng == "string" && (e.fallbackLng = [e.fallbackLng]), typeof e.fallbackNS == "string" && (e.fallbackNS = [e.fallbackNS]), e.supportedLngs && e.supportedLngs.indexOf("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), e;
}
function ks() {
}
function bz(e) {
  Object.getOwnPropertyNames(Object.getPrototypeOf(e)).forEach((n) => {
    typeof e[n] == "function" && (e[n] = e[n].bind(e));
  });
}
class ls extends Ga {
  constructor() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
    if (super(), this.options = Tf(t), this.services = {}, this.logger = rn, this.modules = {
      external: []
    }, bz(this), n && !this.isInitialized && !t.isClone) {
      if (!this.options.initImmediate)
        return this.init(t, n), this;
      setTimeout(() => {
        this.init(t, n);
      }, 0);
    }
  }
  init() {
    var t = this;
    let n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0;
    typeof n == "function" && (r = n, n = {}), !n.defaultNS && n.defaultNS !== !1 && n.ns && (typeof n.ns == "string" ? n.defaultNS = n.ns : n.ns.indexOf("translation") < 0 && (n.defaultNS = n.ns[0]));
    const s = _f();
    this.options = R(R(R({}, s), this.options), Tf(n)), this.options.compatibilityAPI !== "v1" && (this.options.interpolation = R(R({}, s.interpolation), this.options.interpolation)), n.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = n.keySeparator), n.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = n.nsSeparator);
    function a(u) {
      return u ? typeof u == "function" ? new u() : u : null;
    }
    if (!this.options.isClone) {
      this.modules.logger ? rn.init(a(this.modules.logger), this.options) : rn.init(null, this.options);
      let u;
      this.modules.formatter ? u = this.modules.formatter : typeof Intl != "undefined" && (u = vz);
      const h = new Af(this.options);
      this.store = new Sf(this.options.resources, this.options);
      const f = this.services;
      f.logger = rn, f.resourceStore = this.store, f.languageUtils = h, f.pluralResolver = new mz(h, {
        prepend: this.options.pluralSeparator,
        compatibilityJSON: this.options.compatibilityJSON,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), u && (!this.options.interpolation.format || this.options.interpolation.format === s.interpolation.format) && (f.formatter = a(u), f.formatter.init(f, this.options), this.options.interpolation.format = f.formatter.format.bind(f.formatter)), f.interpolator = new gz(this.options), f.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, f.backendConnector = new xz(a(this.modules.backend), f.resourceStore, f, this.options), f.backendConnector.on("*", function(p) {
        for (var m = arguments.length, C = new Array(m > 1 ? m - 1 : 0), y = 1; y < m; y++)
          C[y - 1] = arguments[y];
        t.emit(p, ...C);
      }), this.modules.languageDetector && (f.languageDetector = a(this.modules.languageDetector), f.languageDetector.init && f.languageDetector.init(f, this.options.detection, this.options)), this.modules.i18nFormat && (f.i18nFormat = a(this.modules.i18nFormat), f.i18nFormat.init && f.i18nFormat.init(this)), this.translator = new ga(this.services, this.options), this.translator.on("*", function(p) {
        for (var m = arguments.length, C = new Array(m > 1 ? m - 1 : 0), y = 1; y < m; y++)
          C[y - 1] = arguments[y];
        t.emit(p, ...C);
      }), this.modules.external.forEach((p) => {
        p.init && p.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, r || (r = ks), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const u = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      u.length > 0 && u[0] !== "dev" && (this.options.lng = u[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((u) => {
      this[u] = function() {
        return t.store[u](...arguments);
      };
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((u) => {
      this[u] = function() {
        return t.store[u](...arguments), t;
      };
    });
    const l = Xr(), d = () => {
      const u = (h, f) => {
        this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), l.resolve(f), r(h, f);
      };
      if (this.languages && this.options.compatibilityAPI !== "v1" && !this.isInitialized)
        return u(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, u);
    };
    return this.options.resources || !this.options.initImmediate ? d() : setTimeout(d, 0), l;
  }
  loadResources(t) {
    let r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ks;
    const s = typeof t == "string" ? t : this.language;
    if (typeof t == "function" && (r = t), !this.options.resources || this.options.partialBundledLanguages) {
      if (s && s.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0))
        return r();
      const a = [], o = (c) => {
        if (!c || c === "cimode")
          return;
        this.services.languageUtils.toResolveHierarchy(c).forEach((d) => {
          d !== "cimode" && a.indexOf(d) < 0 && a.push(d);
        });
      };
      s ? o(s) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((l) => o(l)), this.options.preload && this.options.preload.forEach((c) => o(c)), this.services.backendConnector.load(a, this.options.ns, (c) => {
        !c && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), r(c);
      });
    } else
      r(null);
  }
  reloadResources(t, n, r) {
    const s = Xr();
    return t || (t = this.languages), n || (n = this.options.ns), r || (r = ks), this.services.backendConnector.reload(t, n, (a) => {
      s.resolve(), r(a);
    }), s;
  }
  use(t) {
    if (!t)
      throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!t.type)
      throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return t.type === "backend" && (this.modules.backend = t), (t.type === "logger" || t.log && t.warn && t.error) && (this.modules.logger = t), t.type === "languageDetector" && (this.modules.languageDetector = t), t.type === "i18nFormat" && (this.modules.i18nFormat = t), t.type === "postProcessor" && w0.addPostProcessor(t), t.type === "formatter" && (this.modules.formatter = t), t.type === "3rdParty" && this.modules.external.push(t), this;
  }
  setResolvedLanguage(t) {
    if (!(!t || !this.languages) && !(["cimode", "dev"].indexOf(t) > -1))
      for (let n = 0; n < this.languages.length; n++) {
        const r = this.languages[n];
        if (!(["cimode", "dev"].indexOf(r) > -1) && this.store.hasLanguageSomeTranslations(r)) {
          this.resolvedLanguage = r;
          break;
        }
      }
  }
  changeLanguage(t, n) {
    var r = this;
    this.isLanguageChangingTo = t;
    const s = Xr();
    this.emit("languageChanging", t);
    const a = (l) => {
      this.language = l, this.languages = this.services.languageUtils.toResolveHierarchy(l), this.resolvedLanguage = void 0, this.setResolvedLanguage(l);
    }, o = (l, d) => {
      d ? (a(d), this.translator.changeLanguage(d), this.isLanguageChangingTo = void 0, this.emit("languageChanged", d), this.logger.log("languageChanged", d)) : this.isLanguageChangingTo = void 0, s.resolve(function() {
        return r.t(...arguments);
      }), n && n(l, function() {
        return r.t(...arguments);
      });
    }, c = (l) => {
      !t && !l && this.services.languageDetector && (l = []);
      const d = typeof l == "string" ? l : this.services.languageUtils.getBestMatchFromCodes(l);
      d && (this.language || a(d), this.translator.language || this.translator.changeLanguage(d), this.services.languageDetector && this.services.languageDetector.cacheUserLanguage && this.services.languageDetector.cacheUserLanguage(d)), this.loadResources(d, (u) => {
        o(u, d);
      });
    };
    return !t && this.services.languageDetector && !this.services.languageDetector.async ? c(this.services.languageDetector.detect()) : !t && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(c) : this.services.languageDetector.detect(c) : c(t), s;
  }
  getFixedT(t, n, r) {
    var s = this;
    const a = function(o, c) {
      let l;
      if (typeof c != "object") {
        for (var d = arguments.length, u = new Array(d > 2 ? d - 2 : 0), h = 2; h < d; h++)
          u[h - 2] = arguments[h];
        l = s.options.overloadTranslationOptionHandler([o, c].concat(u));
      } else
        l = R({}, c);
      l.lng = l.lng || a.lng, l.lngs = l.lngs || a.lngs, l.ns = l.ns || a.ns, l.keyPrefix = l.keyPrefix || r || a.keyPrefix;
      const f = s.options.keySeparator || ".";
      let p;
      return l.keyPrefix && Array.isArray(o) ? p = o.map((m) => `${l.keyPrefix}${f}${m}`) : p = l.keyPrefix ? `${l.keyPrefix}${f}${o}` : o, s.t(p, l);
    };
    return typeof t == "string" ? a.lng = t : a.lngs = t, a.ns = n, a.keyPrefix = r, a;
  }
  t() {
    return this.translator && this.translator.translate(...arguments);
  }
  exists() {
    return this.translator && this.translator.exists(...arguments);
  }
  setDefaultNamespace(t) {
    this.options.defaultNS = t;
  }
  hasLoadedNamespace(t) {
    let n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const r = n.lng || this.resolvedLanguage || this.languages[0], s = this.options ? this.options.fallbackLng : !1, a = this.languages[this.languages.length - 1];
    if (r.toLowerCase() === "cimode")
      return !0;
    const o = (c, l) => {
      const d = this.services.backendConnector.state[`${c}|${l}`];
      return d === -1 || d === 2;
    };
    if (n.precheck) {
      const c = n.precheck(this, o);
      if (c !== void 0)
        return c;
    }
    return !!(this.hasResourceBundle(r, t) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || o(r, t) && (!s || o(a, t)));
  }
  loadNamespaces(t, n) {
    const r = Xr();
    return this.options.ns ? (typeof t == "string" && (t = [t]), t.forEach((s) => {
      this.options.ns.indexOf(s) < 0 && this.options.ns.push(s);
    }), this.loadResources((s) => {
      r.resolve(), n && n(s);
    }), r) : (n && n(), Promise.resolve());
  }
  loadLanguages(t, n) {
    const r = Xr();
    typeof t == "string" && (t = [t]);
    const s = this.options.preload || [], a = t.filter((o) => s.indexOf(o) < 0);
    return a.length ? (this.options.preload = s.concat(a), this.loadResources((o) => {
      r.resolve(), n && n(o);
    }), r) : (n && n(), Promise.resolve());
  }
  dir(t) {
    if (t || (t = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language)), !t)
      return "rtl";
    const n = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], r = this.services && this.services.languageUtils || new Af(_f());
    return n.indexOf(r.getLanguagePartFromCode(t)) > -1 || t.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
    return new ls(t, n);
  }
  cloneInstance() {
    let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ks;
    const r = t.forkResourceStore;
    r && delete t.forkResourceStore;
    const s = X(R(R({}, this.options), t), {
      isClone: !0
    }), a = new ls(s);
    return (t.debug !== void 0 || t.prefix !== void 0) && (a.logger = a.logger.clone(t)), ["store", "services", "language"].forEach((c) => {
      a[c] = this[c];
    }), a.services = R({}, this.services), a.services.utils = {
      hasLoadedNamespace: a.hasLoadedNamespace.bind(a)
    }, r && (a.store = new Sf(this.store.data, s), a.services.resourceStore = a.store), a.translator = new ga(a.services, s), a.translator.on("*", function(c) {
      for (var l = arguments.length, d = new Array(l > 1 ? l - 1 : 0), u = 1; u < l; u++)
        d[u - 1] = arguments[u];
      a.emit(c, ...d);
    }), a.init(s, n), a.translator.options = s, a.translator.backendConnector.services.utils = {
      hasLoadedNamespace: a.hasLoadedNamespace.bind(a)
    }, a;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const st = ls.createInstance();
st.createInstance = ls.createInstance;
st.createInstance;
st.dir;
st.init;
st.loadResources;
st.reloadResources;
st.use;
st.changeLanguage;
st.getFixedT;
st.t;
st.exists;
st.setDefaultNamespace;
st.hasLoadedNamespace;
st.loadNamespaces;
st.loadLanguages;
function jz() {
  if (console && console.warn) {
    for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
      t[n] = arguments[n];
    typeof t[0] == "string" && (t[0] = `react-i18next:: ${t[0]}`), console.warn(...t);
  }
}
const Rf = {};
function Eo() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  typeof t[0] == "string" && Rf[t[0]] || (typeof t[0] == "string" && (Rf[t[0]] = /* @__PURE__ */ new Date()), jz(...t));
}
const v0 = (e, t) => () => {
  if (e.isInitialized)
    t();
  else {
    const n = () => {
      setTimeout(() => {
        e.off("initialized", n);
      }, 0), t();
    };
    e.on("initialized", n);
  }
};
function Mf(e, t, n) {
  e.loadNamespaces(t, v0(e, n));
}
function Pf(e, t, n, r) {
  typeof n == "string" && (n = [n]), n.forEach((s) => {
    e.options.ns.indexOf(s) < 0 && e.options.ns.push(s);
  }), e.loadLanguages(t, v0(e, r));
}
function Cz(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  const r = t.languages[0], s = t.options ? t.options.fallbackLng : !1, a = t.languages[t.languages.length - 1];
  if (r.toLowerCase() === "cimode")
    return !0;
  const o = (c, l) => {
    const d = t.services.backendConnector.state[`${c}|${l}`];
    return d === -1 || d === 2;
  };
  return n.bindI18n && n.bindI18n.indexOf("languageChanging") > -1 && t.services.backendConnector.backend && t.isLanguageChangingTo && !o(t.isLanguageChangingTo, e) ? !1 : !!(t.hasResourceBundle(r, e) || !t.services.backendConnector.backend || t.options.resources && !t.options.partialBundledLanguages || o(r, e) && (!s || o(a, e)));
}
function Nz(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  return !t.languages || !t.languages.length ? (Eo("i18n.languages were undefined or empty", t.languages), !0) : t.options.ignoreJSONStructure !== void 0 ? t.hasLoadedNamespace(e, {
    lng: n.lng,
    precheck: (s, a) => {
      if (n.bindI18n && n.bindI18n.indexOf("languageChanging") > -1 && s.services.backendConnector.backend && s.isLanguageChangingTo && !a(s.isLanguageChangingTo, e))
        return !1;
    }
  }) : Cz(e, t, n);
}
const Dz = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, Sz = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, $z = (e) => Sz[e], Az = (e) => e.replace(Dz, $z);
let Io = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: Az
};
function Ez() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  Io = R(R({}, Io), e);
}
function Iz() {
  return Io;
}
let y0;
function _z(e) {
  y0 = e;
}
function Tz() {
  return y0;
}
const Rz = {
  type: "3rdParty",
  init(e) {
    Ez(e.options.react), _z(e);
  }
}, Mz = Ct();
class Pz {
  constructor() {
    this.usedNamespaces = {};
  }
  addUsedNamespaces(t) {
    t.forEach((n) => {
      this.usedNamespaces[n] || (this.usedNamespaces[n] = !0);
    });
  }
  getUsedNamespaces() {
    return Object.keys(this.usedNamespaces);
  }
}
const Oz = (e, t) => {
  const n = Te();
  return he(() => {
    n.current = t ? n.current : e;
  }, [e, t]), n.current;
};
function kz(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    i18n: n
  } = t, {
    i18n: r,
    defaultNS: s
  } = tt(Mz) || {}, a = n || r || Tz();
  if (a && !a.reportNamespaces && (a.reportNamespaces = new Pz()), !a) {
    Eo("You will need to pass in an i18next instance by using initReactI18next");
    const x = (N, v) => typeof v == "string" ? v : v && typeof v == "object" && typeof v.defaultValue == "string" ? v.defaultValue : Array.isArray(N) ? N[N.length - 1] : N, S = [x, {}, !1];
    return S.t = x, S.i18n = {}, S.ready = !1, S;
  }
  a.options.react && a.options.react.wait !== void 0 && Eo("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  const o = R(R(R({}, Iz()), a.options.react), t), {
    useSuspense: c,
    keyPrefix: l
  } = o;
  let d = e || s || a.options && a.options.defaultNS;
  d = typeof d == "string" ? [d] : d || ["translation"], a.reportNamespaces.addUsedNamespaces && a.reportNamespaces.addUsedNamespaces(d);
  const u = (a.isInitialized || a.initializedStoreOnce) && d.every((x) => Nz(x, a, o));
  function h() {
    return a.getFixedT(t.lng || null, o.nsMode === "fallback" ? d : d[0], l);
  }
  const [f, p] = Y(h);
  let m = d.join();
  t.lng && (m = `${t.lng}${m}`);
  const C = Oz(m), y = Te(!0);
  he(() => {
    const {
      bindI18n: x,
      bindI18nStore: S
    } = o;
    y.current = !0, !u && !c && (t.lng ? Pf(a, t.lng, d, () => {
      y.current && p(h);
    }) : Mf(a, d, () => {
      y.current && p(h);
    })), u && C && C !== m && y.current && p(h);
    function N() {
      y.current && p(h);
    }
    return x && a && a.on(x, N), S && a && a.store.on(S, N), () => {
      y.current = !1, x && a && x.split(" ").forEach((v) => a.off(v, N)), S && a && S.split(" ").forEach((v) => a.store.off(v, N));
    };
  }, [a, m]);
  const g = Te(!0);
  he(() => {
    y.current && !g.current && p(h), g.current = !1;
  }, [a, l]);
  const w = [f, a, u];
  if (w.t = f, w.i18n = a, w.ready = u, u || !u && !c)
    return w;
  throw new Promise((x) => {
    t.lng ? Pf(a, t.lng, d, () => x()) : Mf(a, d, () => x());
  });
}
const Kn = () => kz(["main", "glossary"]), Lz = {
  en: {
    glossary: {
      condition_one: "condition",
      condition_other: "conditions"
    },
    main: {
      "resource.add": "Add {{resource}}",
      "resource.edit": "Edit {{resource}}",
      "resource.history.heading": "{{resource}} history",
      "resource.history.loading": "Loading {{resource}} history...",
      "resource.remove.body": "This will remove {{resourceName}} from this patient's {{resource}} list.",
      "resource.remove.heading": "Remove this {{resource}}?",
      "resource.unnamed": "unnamed {{resource}}",
      "resourceTable.add": "Add",
      "resourceTable.preview": "Open",
      "resourceTable.read": "Mark as Viewed",
      "resourceTable.unread": "Mark as New",
      "resourceTable.dismiss": "Dismiss",
      "resourceTable.restore": "Restore",
      "zap.tabs.medicationsOutside": "medications",
      "zap.tabs.conditions": "$t(glossary:condition_other) list",
      "zap.tabs.conditionsOutside": "outside $t(glossary:condition_other)",
      "zap.tabs.conditionsAll": "$t(glossary:condition_other)",
      commonwell: "EHR Network",
      surescripts: "Pharmacy Data",
      bamboo: "ADT",
      collective: "ADT",
      quest: "Labs"
    }
  }
};
st.use(Rz).init({
  ns: ["glossary", "main"],
  returnNull: !1,
  defaultNS: ["main", "glossary"],
  resources: Lz,
  lng: "en",
  // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
  interpolation: {
    escapeValue: !1
    // react already safes from xss
  }
});
const Ya = ({
  onWritebackStart: e,
  onWritebackEnd: t,
  rowActions: n,
  enableDismissAndReadActions: r,
  isInFooter: s = !1
}) => {
  const { featureFlags: a } = Xe(), [o, c] = Y("card"), l = Fz(
    e != null ? e : () => {
    },
    t != null ? t : () => {
    },
    r
  );
  return ({ record: d, onSuccess: u, stacked: h = !1 }) => {
    var C, y;
    const f = (C = l(d)) != null ? C : [], p = (y = n == null ? void 0 : n(d)) != null ? y : [], m = [...f, ...p];
    return !m.length && !(a != null && a.enableViewFhirButton) ? null : h ? /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-space-x-2", children: [
      (a == null ? void 0 : a.enableViewFhirButton) && /* @__PURE__ */ i.jsx(Cf, { resource: d.resource }),
      m.length > 0 && /* @__PURE__ */ i.jsx(
        VU,
        {
          align: "end",
          buttonClassName: W("ctw-bg-transparent ctw-border-none ctw-bg-blue ctw-p-0"),
          onItemSelect: (g) => {
            const w = m.filter(
              (x) => x.text === g.key
            )[0];
            c(w.text), setTimeout(() => {
              w.onClick(d, u);
            }, 1);
          },
          items: m.map((g) => {
            var w, x;
            return {
              key: g.text,
              name: g.text,
              display: (x = (w = g.render) == null ? void 0 : w.call(g, { record: d, onSuccess: u, stacked: h })) != null ? x : g.text,
              isSelected: o === g.text,
              disabled: g.disabled
            };
          }),
          children: /* @__PURE__ */ i.jsxs("div", { className: "ctw-btn-primary ctw-flex ctw-items-center ctw-space-x-2 !ctw-py-0 ctw-font-normal", children: [
            /* @__PURE__ */ i.jsx("span", { className: "!ctw-border-r-1 ctw-mr-1.5 ctw-divide-bg-light ctw-border-0 ctw-border-solid ctw-py-2 ctw-pr-4 !ctw-text-white", children: "select action" }),
            /* @__PURE__ */ i.jsx(
              me,
              {
                icon: s ? Ew : jr,
                className: "ctw-w-2 !ctw-text-white"
              }
            )
          ] })
        }
      )
    ] }) : /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-space-x-2", children: [
      (a == null ? void 0 : a.enableViewFhirButton) && /* @__PURE__ */ i.jsx(Cf, { resource: d.resource }),
      m.map(({ text: g, testId: w, onClick: x, disabled: S = !1, className: N, render: v }) => {
        var b;
        return /* @__PURE__ */ i.jsx(
          "button",
          {
            type: "button",
            disabled: S,
            className: W(N, "ctw-row-action"),
            "data-testid": w,
            onClick: () => {
              x(d, u);
            },
            children: (b = v == null ? void 0 : v({ record: d, onSuccess: u, stacked: h })) != null ? b : g
          },
          g
        );
      })
    ] });
  };
};
function Fz(e, t, n = !1) {
  const r = ut(), { t: s } = Kn(), a = qU(), { trackInteraction: o } = Be(), { isLoading: c, toggleDismiss: l } = h0(), { isLoading: d, toggleRead: u } = Hr();
  return (h) => {
    const f = h.isDismissed ? s("resourceTable.restore") : s("resourceTable.dismiss"), p = h.isRead ? s("resourceTable.unread") : s("resourceTable.read"), m = (a == null ? void 0 : a.env) === "production" && a.userType !== "builder";
    return !n || h.ownedByBuilder(r) ? [] : [
      {
        className: "ctw-btn-default",
        disabled: c || d,
        text: f,
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        onClick: () => V(this, null, function* () {
          o("toggle_record_archive", {
            action: h.isDismissed ? "restore" : "dismiss"
          });
          try {
            const C = h.isDismissed ? "restore" : "dismiss-single";
            e(C, h.id), yield l(h), t(C, h.id, !1);
          } catch (C) {
            t(
              "dismiss-single",
              h.id,
              !0,
              C instanceof Error ? C.message : String(C)
            );
            return;
          }
          h.isRead || (yield u(h));
        }),
        render() {
          return /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex", children: [
            c && /* @__PURE__ */ i.jsx(an, { className: "ctw-mx-4 ctw-align-middle" }),
            !c && f
          ] });
        }
      },
      {
        className: "ctw-btn-default",
        disabled: m || c || d,
        text: p,
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        onClick: () => V(this, null, function* () {
          h.isRead ? o("toggle_record_read", { action: "mark_as_unread" }) : o("toggle_record_read", { action: "mark_as_read" }), yield u(h);
        }),
        render() {
          return /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex", children: [
            d && /* @__PURE__ */ i.jsx(an, { className: "ctw-mx-4 ctw-align-middle" }),
            !d && p
          ] });
        }
      }
    ];
  };
}
const Bz = ({ columns: e }) => /* @__PURE__ */ i.jsx("colgroup", { children: e.map((t, n) => {
  var r;
  return /* @__PURE__ */ i.jsx(
    "col",
    {
      className: t.className,
      width: t.widthPercent ? `${t.widthPercent}%` : void 0,
      style: {
        minWidth: t.minWidth,
        width: t.width
      }
    },
    (r = t.title) != null ? r : n
  );
}) }), Uz = ({ columns: e }) => /* @__PURE__ */ i.jsx("thead", { children: /* @__PURE__ */ i.jsx("tr", { children: e.map((t, n) => {
  var r;
  return /* @__PURE__ */ i.jsx("th", { className: "ctw-group", scope: "col", children: /* @__PURE__ */ i.jsx("div", { className: "ctw-flex ctw-items-center ctw-space-x-2", children: /* @__PURE__ */ i.jsx("div", { children: t.title }) }) }, (r = t.title) != null ? r : n);
}) }) }), zz = ({
  column: e,
  record: t
}) => {
  const n = e.dataIndex ? t[e.dataIndex] : void 0;
  return /* @__PURE__ */ i.jsx(
    "td",
    {
      className: W(
        "ctw-text-content-black",
        e.className,
        // Added ctw-break-words because AbdominalReallyLongWordThatShouldBReakButDoeskadjlkajflkajsf doesn't wrap correclty without it.
        "ctw-hyphens-auto ctw-break-words"
      ),
      children: e.render ? e.render(t) : n
    }
  );
}, Of = ({
  children: e,
  colSpan: t
}) => /* @__PURE__ */ i.jsx("tr", { children: /* @__PURE__ */ i.jsx("td", { className: "ctw-table-full-length-row", colSpan: t, children: e }) });
function gl() {
  return /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-justify-center ctw-items-center ctw-space-x-2 ctw-py-9 ctw-px-4", children: [
    /* @__PURE__ */ i.jsx("span", { children: "Loading..." }),
    /* @__PURE__ */ i.jsx(an, {})
  ] });
}
const Hz = ({
  records: e,
  columns: t,
  isLoading: n,
  emptyMessage: r,
  handleRowClick: s,
  canClickRow: a = () => !0,
  onRightClick: o,
  RowActions: c,
  getRowClassName: l,
  stacked: d
}) => {
  const { trackInteraction: u } = Be();
  return n ? /* @__PURE__ */ i.jsx(Of, { colSpan: t.length, children: /* @__PURE__ */ i.jsx(gl, {}) }) : e.length === 0 ? /* @__PURE__ */ i.jsx(Of, { colSpan: t.length, children: /* @__PURE__ */ i.jsx("span", { className: "ctw-empty-message -ctw-mt-3.5 sm:ctw-mt-0", children: r }) }) : /* @__PURE__ */ i.jsx(i.Fragment, { children: e.map((h) => /* @__PURE__ */ i.jsxs(
    "tr",
    {
      className: W(
        "table-row ctw-group ctw-relative ctw-mx-px",
        dr(l) ? l(h) : "",
        {
          "ctw-cursor-pointer hover:ctw-bg-bg-lighter": dr(s) && a(h)
        }
      ),
      onClick: ({ target: f, metaKey: p, ctrlKey: m }) => {
        if (!(f instanceof HTMLElement && f.querySelectorAll("button").length)) {
          if (dr(o) && (p || m)) {
            o(h);
            return;
          }
          s && (s(h), u("click_row"));
        }
      },
      children: [
        t.map((f, p) => {
          var m;
          return /* @__PURE__ */ i.jsx(
            zz,
            {
              column: f,
              record: h
            },
            `${h.key}_${(m = f.title) != null ? m : p}`
          );
        }),
        c && // Add onClick here to prevent clicks from propagating to
        // the to the tr's onClick for onRowClick.
        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/click-events-have-key-events
        /* @__PURE__ */ i.jsx(
          "td",
          {
            "aria-label": "row-actions",
            className: "ctw-table-row-actions group-hover:ctw-visible",
            onClick: (f) => f.stopPropagation(),
            children: /* @__PURE__ */ i.jsx(c, { record: h, stacked: d })
          }
        )
      ]
    },
    h.key
  )) });
}, ds = 10, x0 = ({ total: e, count: t, changeCount: n }) => {
  const r = t >= e || e === 0, s = e > ds;
  return /* @__PURE__ */ i.jsxs("div", { className: "ctw-pagination !ctw-mt-1 sm:!ctw-mt-2", children: [
    /* @__PURE__ */ i.jsxs("div", { className: "ctw-text-gray-600 ctw-text-sm", children: [
      "Showing ",
      /* @__PURE__ */ i.jsx("span", { className: "ctw-font-medium", children: Math.min(t, e) }),
      " of",
      " ",
      /* @__PURE__ */ i.jsx("span", { className: "ctw-font-medium", children: e }),
      " records"
    ] }),
    (!r || s) && /* @__PURE__ */ i.jsxs("div", { className: "ctw-leading-5", children: [
      !r && /* @__PURE__ */ i.jsx(
        "button",
        {
          type: "button",
          className: "ctw-btn-clear ctw-link ctw-whitespace-nowrap",
          onClick: () => n(e),
          children: "Show All"
        }
      ),
      r && s && /* @__PURE__ */ i.jsx(
        "button",
        {
          type: "button",
          className: "ctw-btn-clear ctw-link ctw-whitespace-nowrap",
          onClick: () => n(ds),
          children: "Clear"
        }
      )
    ] })
  ] });
}, wl = ({
  className: e,
  columns: t,
  records: n,
  isLoading: r = !1,
  emptyMessage: s = "No records found",
  showTableHead: a = !0,
  stacked: o,
  handleRowClick: c,
  canClickRow: l,
  onRightClick: d,
  RowActions: u,
  getRowClassName: h,
  hidePagination: f = !1,
  pageSize: p = ds,
  children: m
}) => {
  const C = Te(null), y = Te(null), [g, w] = Y(!1), [x, S] = Y(!1), [N, v] = Y(p), b = wt(C), j = () => {
    const $ = y.current, _ = C.current;
    if ($ && _) {
      w($.scrollLeft > 0);
      const L = $.scrollLeft + $.clientWidth;
      S(L < _.clientWidth);
    }
  };
  he(() => {
    const $ = y.current;
    return j(), $ == null || $.addEventListener("scroll", j), window.addEventListener("resize", j), () => {
      $ == null || $.removeEventListener("scroll", j), window.removeEventListener("resize", j);
    };
  }, [y, r]);
  const D = !r && n.length > 0;
  return he(() => {
    v(f && D ? n.length : p);
  }, [n, p, f, D]), /* @__PURE__ */ i.jsxs(
    "div",
    {
      className: W("ctw-scrollable-pass-through-height ctw-space-y-4", {
        "ctw-table-stacked": o
      }),
      children: [
        /* @__PURE__ */ i.jsx(
          "div",
          {
            className: W("ctw-table-container ctw-scrollable-pass-through-height", e, {
              "ctw-table-scroll-left-shadow": g,
              "ctw-table-scroll-right-shadow": x
            }),
            children: /* @__PURE__ */ i.jsx("div", { className: W("ctw-scrollbar ctw-scrollable-content"), ref: y, children: /* @__PURE__ */ i.jsxs("table", { ref: C, children: [
              D && /* @__PURE__ */ i.jsx(Bz, { columns: t }),
              a && D && /* @__PURE__ */ i.jsx(Uz, { columns: t }),
              /* @__PURE__ */ i.jsx("tbody", { className: W({ "ctw-h-[7rem]": n.length === 0 }), children: /* @__PURE__ */ i.jsx(
                Hz,
                {
                  getRowClassName: h,
                  records: n.slice(0, N),
                  handleRowClick: c,
                  canClickRow: l,
                  onRightClick: d,
                  RowActions: u,
                  columns: t,
                  isLoading: r,
                  emptyMessage: s,
                  stacked: b.sm
                }
              ) })
            ] }) })
          }
        ),
        !f && !r && /* @__PURE__ */ i.jsx(x0, { total: n.length, count: N, changeCount: v }),
        m
      ]
    }
  );
};
const b0 = ({
  className: e,
  columns: t,
  data: n,
  emptyMessage: r,
  isLoading: s = !1,
  onRowClick: a,
  onRightClick: o,
  rowActions: c,
  showTableHead: l,
  enableDismissAndReadActions: d,
  hidePagination: u = !1,
  children: h
}) => {
  const f = Te(null), p = wt(f), m = ut(), C = typeof l == "boolean" ? l : !p.sm, { toggleRead: y } = Hr(), g = Ya({
    rowActions: c,
    enableDismissAndReadActions: d
  }), w = a ? (x) => V(void 0, null, function* () {
    !x.isRead && d && !x.ownedByBuilder(m) && y(x), a(x);
  }) : void 0;
  return /* @__PURE__ */ i.jsx(
    "div",
    {
      ref: f,
      className: W(e, "ctw-scrollable-pass-through-height ctw-resource-table"),
      children: /* @__PURE__ */ i.jsx(
        wl,
        {
          getRowClassName: (x) => ({
            "ctw-tr-dismissed": x.isDismissed,
            "ctw-tr-unread": d && !x.ownedByBuilder(m) && !x.isRead
          }),
          showTableHead: C,
          stacked: p.sm,
          emptyMessage: r,
          isLoading: s,
          records: n,
          RowActions: g,
          columns: t,
          handleRowClick: w,
          onRightClick: o,
          hidePagination: u,
          children: h
        }
      )
    }
  );
}, Tt = ({
  className: e,
  columns: t,
  data: n,
  emptyMessage: r,
  isLoading: s = !1,
  onRowClick: a,
  rowActions: o,
  onRightClick: c,
  showTableHead: l,
  enableDismissAndReadActions: d,
  hidePagination: u = !1
}) => {
  const { patient: h } = Ze(), f = h.isLoading || !!h.data && s;
  return /* @__PURE__ */ i.jsx(
    b0,
    {
      className: e,
      columns: t,
      data: n,
      emptyMessage: r,
      isLoading: f,
      onRowClick: a,
      showTableHead: l,
      rowActions: o,
      onRightClick: c,
      enableDismissAndReadActions: d,
      hidePagination: u
    }
  );
}, Wz = ({ className: e }) => /* @__PURE__ */ i.jsx(
  "svg",
  {
    className: e,
    fill: "currentColor",
    width: "56",
    height: "50",
    viewBox: "0 0 56 50",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ i.jsx(
      "path",
      {
        d: "M13.2344 0.5H42.7656C45.9375 0.5 48.7812 2.6875 49.5469 5.85938L55.7812 30.7969C55.8906 31.3438 56 31.8906 56 32.4375V42.5C56 46.4375 52.8281 49.5 49 49.5H7C3.0625 49.5 0 46.4375 0 42.5V32.4375C0 31.8906 0 31.3438 0.109375 30.7969L6.34375 5.85938C7.21875 2.6875 9.95312 0.5 13.2344 0.5ZM13.2344 7.5L7.98438 28.5H13.5625C14.875 28.5 16.0781 29.2656 16.625 30.4688L18.2656 33.6406C18.8125 34.8438 20.0156 35.5 21.3281 35.5H34.5625C35.875 35.5 37.0781 34.8438 37.625 33.6406L39.2656 30.4688C39.8125 29.2656 41.0156 28.5 42.3281 28.5H48.0156L42.7656 7.5H13.2344Z",
        fill: "#9CA3AF"
      }
    )
  }
), Vz = ({ className: e }) => /* @__PURE__ */ i.jsx(
  "svg",
  {
    className: e,
    fill: "currentColor",
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ i.jsx(
      "path",
      {
        d: "M24 48C37.2188 48 48 37.3125 48 24C48 10.7812 37.2188 0 24 0C10.6875 0 0 10.7812 0 24C0 37.3125 10.6875 48 24 48ZM24 12C25.2188 12 26.25 13.0312 26.25 14.25V24.75C26.25 26.0625 25.2188 27 24 27C22.6875 27 21.75 26.0625 21.75 24.75V14.25C21.75 13.0312 22.6875 12 24 12ZM27 33C27 34.6875 25.5938 36 24 36C22.3125 36 21 34.6875 21 33C21 31.4062 22.3125 30 24 30C25.5938 30 27 31.4062 27 33Z",
        fill: "#9CA3AF"
      }
    )
  }
);
function vl() {
  return tt(Rc).ctwThemeRef;
}
function j0(e, t, n) {
  const r = gk(e), s = t.map((a) => a.id);
  return r.forEach((a) => {
    const o = (
      // Check if aggregated from ids match any builder ids.
      a.aggregatedFromIds.some(
        (c) => s.find((l) => l === c)
      ) || (n ? n(a, t) : !1)
    );
    a.syncedWithRecord = o;
  }), r;
}
const yl = (e, t) => bc(
  e,
  (n) => {
    var r;
    return fn((r = n.meta) == null ? void 0 : r.tag, {
      system: En,
      code: `builder/${t}`
    });
  }
);
function Qa(e = !0) {
  const t = Oe(
    Rg,
    [],
    Qz,
    e
  ), n = Oe(
    Mg,
    [],
    Yz,
    e
  ), r = ke(() => {
    var a, o;
    const s = j0(
      (a = t.data) != null ? a : [],
      (o = n.data) != null ? o : [],
      (c, l) => l.some((d) => c.knownCodingsMatch(d.code))
    );
    return qz(s);
  }, [t.data, n.data]);
  return X(R({}, t), {
    isLoading: t.isLoading || n.isLoading,
    data: r
  });
}
function qz(e) {
  const t = iv(/* @__PURE__ */ new Date(), 5);
  return e.filter((n) => {
    var r;
    return !["FAC", "XXX"].includes((r = n.ccsChapterCode) != null ? r : "");
  }).filter(
    // Filter out low quality conditions
    (n) => {
      var r, s, a;
      return n.ccsChapterCode !== "SYM" || !["A", "U", "N"].includes((s = (r = n.chronic) == null ? void 0 : r.code) != null ? s : "") || ov(new Date((a = n.recordedDate) != null ? a : ""), t);
    }
  );
}
function C0(e) {
  return e.map((t) => new Ug(t, void 0, t.BasicList));
}
function Gz(e) {
  return nt(
    e.filter((t) => {
      var n;
      return ((n = t.resource.asserter) == null ? void 0 : n.type) !== "Patient";
    }),
    ["resource.recordedDate", "display"],
    ["desc"]
  );
}
function xl(e, t, n) {
  return V(this, null, function* () {
    const r = Re(e), { data: s } = yield Ut(
      r,
      fl,
      "ConditionConnection",
      {
        upid: t.UPID,
        cursor: "",
        first: 500,
        sort: {},
        filter: {
          ids: {
            anymatch: n
          }
        }
      }
    ), a = s.ConditionConnection.edges.map((o) => o.node);
    return C0(a);
  });
}
function Yz(e, t) {
  return V(this, null, function* () {
    const n = Re(e), { data: r } = yield Ut(
      n,
      DU,
      "ConditionConnection",
      {
        upid: t.UPID,
        cursor: "",
        first: 1e3,
        filter: {
          tag: {
            nonematch: [yt, Ln]
            // TODO: There's a bug in FQS that doesn't allow filtering with nonematch AND allmatch.
            // Uncomment the line below once https://zeushealth.atlassian.net/browse/DRT-249 is resolved.
            // allmatch: [`${SYSTEM_ZUS_OWNER}|builder/${requestContext.builderId}`],
          }
        }
      }
    );
    let s = r.ConditionConnection.edges.map((a) => a.node);
    return s = yl(
      s,
      e.contextBuilderId || e.builderId
    ), s;
  });
}
function Qz(e, t) {
  return V(this, null, function* () {
    const n = Re(e), { data: r } = yield Ut(
      n,
      fl,
      "ConditionConnection",
      {
        upid: t.UPID,
        cursor: "",
        first: 1e3,
        filter: {
          tag: {
            allmatch: [
              `${Fa}|Common`,
              `${En}|builder/${Oc(e.env)}`
            ]
          }
        }
      }
    ), s = r.ConditionConnection.edges.map((c) => c.node), a = C0(s);
    return Gz(a);
  });
}
function _t(e) {
  const { openDrawer: t } = Vn();
  return (n, r, s, a) => {
    const o = s ? `${s}-${Date.now()}` : Date.now().toString();
    t({
      component: (c) => /* @__PURE__ */ i.jsx(
        Jz,
        X(R(R({
          model: n,
          resourceId: s,
          resourceType: a
        }, e), c), {
          onClose: () => {
            var l;
            c.onClose(), (l = e.onAfterClosed) == null || l.call(e);
          }
        }),
        o
      ),
      trackingMetadata: R({ resourceType: n == null ? void 0 : n.resourceType }, r)
    });
  };
}
const Zz = (e, t, n, r) => V(void 0, null, function* () {
  if (!n)
    return null;
  switch (r) {
    case "Condition":
      return xl(e, t, [n]);
    default:
      return null;
  }
});
function Kz(e, t) {
  const { data: n, isLoading: r, isError: s } = Oe(
    Tg,
    [e, t],
    (o, c) => Zz(o, c, e, t),
    !!e && !!t
  );
  return { data: n == null ? void 0 : n[0], isLoading: r, isError: s };
}
function Jz({
  className: e,
  details: t,
  getSourceDocument: n,
  header: r,
  isOpen: s,
  model: a,
  onClose: o,
  onAfterClosed: c,
  rowActions: l,
  enableDismissAndReadActions: d,
  subHeader: u,
  renderChild: h,
  onOpen: f,
  resourceId: p,
  resourceType: m,
  renderResourceActions: C
}) {
  var D;
  const y = vl(), g = wt(y), { data: w, isLoading: x, isError: S } = Kz(p, m), N = a ? !1 : x, v = a || w;
  let b = null;
  he(() => {
    v && (f == null || f(v));
  }, [f, v]);
  const j = Ya({
    rowActions: l,
    enableDismissAndReadActions: d,
    isInFooter: !0
  });
  return v && (b = j({
    record: v,
    onSuccess: o,
    stacked: g.xs
  })), /* @__PURE__ */ i.jsxs(
    et,
    {
      className: e,
      title: (D = (v == null ? void 0 : v.resourceTypeTitle) || m) != null ? D : "",
      isOpen: s,
      onClose: o,
      onAfterClosed: c,
      children: [
        /* @__PURE__ */ i.jsx(et.Body, { children: /* @__PURE__ */ i.jsx(
          Xz,
          {
            model: v,
            isError: S,
            getSourceDocument: n,
            isLoading: N,
            details: t,
            header: r,
            subHeader: u,
            renderChild: h,
            onClose: o
          }
        ) }),
        /* @__PURE__ */ i.jsx(et.Footer, { children: /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-justify-between ctw-gap-4", children: [
          /* @__PURE__ */ i.jsx(et.CloseButton, { onClose: o, label: "Close" }),
          v && C && /* @__PURE__ */ i.jsx("div", { className: "ctw-flex-1 ctw-flex ctw-items-center ctw-justify-end", children: C(v) }),
          b
        ] }) })
      ]
    }
  );
}
function Xz({
  model: e,
  getSourceDocument: t,
  isLoading: n,
  isError: r,
  details: s,
  header: a,
  subHeader: o,
  renderChild: c,
  onClose: l
}) {
  var p;
  const d = vl(), u = wt(d), h = !!t || !!e, f = o0(e, t, h);
  return r ? /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-items-center ctw-flex-col ctw-space-y-6", children: [
    /* @__PURE__ */ i.jsx(
      Nn,
      {
        icon: /* @__PURE__ */ i.jsx(Vz, { className: "ctw-h-16 ctw-text-content-light ctw-space-x-1" }),
        title: "An unexpected error occurred",
        message: ""
      }
    ),
    /* @__PURE__ */ i.jsx("button", { type: "button", className: "ctw-btn-primary ctw-w-fit", onClick: () => l(), children: "Close" })
  ] }) : n ? /* @__PURE__ */ i.jsx(
    Je,
    {
      message: "Loading content...",
      className: "ctw-text-content-light ctw-flex-col ctw-space-y-2 !ctw-m-0 ctw-pt-3",
      iconClass: "ctw-w-5 ctw-h-5"
    }
  ) : e ? /* @__PURE__ */ i.jsxs("div", { className: "ctw-space-y-6", children: [
    /* @__PURE__ */ i.jsxs("div", { className: "ctw-space-y-2", children: [
      /* @__PURE__ */ i.jsx("div", { className: W(u.xs ? "ctw-text-2xl" : "ctw-text-3xl"), children: a(e) }),
      o && /* @__PURE__ */ i.jsx("div", { children: o(e) })
    ] }),
    f.isLoading && !h ? /* @__PURE__ */ i.jsx(Je, { message: "Loading data..." }) : /* @__PURE__ */ i.jsx(
      Ur,
      {
        details: s(e),
        documentButton: !(e instanceof hn) || !f.data ? void 0 : /* @__PURE__ */ i.jsx(
          zr,
          {
            contentType: e instanceof hn ? e.contentType : "",
            binaryId: f.data,
            forceInModal: e instanceof hn && !((p = e.contentType) != null && p.includes("xml")),
            documentTitle: e.resourceTypeTitle,
            telemetryTarget: "resource_details_drawer"
          }
        )
      }
    ),
    c && c(e)
  ] }) : /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-items-center ctw-flex-col ctw-space-y-6", children: [
    /* @__PURE__ */ i.jsx(
      Nn,
      {
        icon: /* @__PURE__ */ i.jsx(Wz, { className: "ctw-h-16 ctw-text-content-light ctw-space-x-1" }),
        title: "No record found",
        message: "Check the link and try again."
      }
    ),
    /* @__PURE__ */ i.jsx("button", { type: "button", className: "ctw-btn-primary ctw-w-fit", onClick: () => l(), children: "Close" })
  ] });
}
function bl({ children: e, icon: t }) {
  return /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-items-center ctw-space-x-3", children: [
    t && /* @__PURE__ */ i.jsx(
      me,
      {
        icon: t,
        className: "ctw-mb-[2px] ctw-w-4 ctw-text-content-lighter"
      }
    ),
    /* @__PURE__ */ i.jsx("div", { children: e })
  ] });
}
function jl({
  children: e,
  className: t,
  items: n,
  onItemSelect: r,
  type: s,
  buttonClassName: a,
  pinnedActions: o = [],
  isOpen: c
}) {
  const l = vl(), [d, u] = Y(c);
  return /* @__PURE__ */ i.jsx(wh, { children: /* @__PURE__ */ i.jsxs(
    qt.Root,
    {
      modal: !1,
      open: d,
      onOpenChange: (h) => u(h),
      children: [
        /* @__PURE__ */ i.jsx(qt.Trigger, { className: W(a), "aria-label": "dropdown", children: e }),
        /* @__PURE__ */ i.jsx(qt.Portal, { container: l.current, children: /* @__PURE__ */ i.jsxs(
          qt.Content,
          {
            align: "start",
            onFocusOutside: (h) => h.preventDefault(),
            className: W(t, "ctw-dropdown-action-menu ctw-bg-bg-white"),
            collisionPadding: 10,
            children: [
              n.map((h) => /* @__PURE__ */ i.jsx(
                qt.Item,
                {
                  className: W("ctw-dropdown-action-menu-item ctw-bg-bg-white"),
                  onClick: (f) => {
                    s === "checkbox" && f.preventDefault(), r({
                      key: h.key,
                      name: h.name,
                      value: !h.isSelected
                    });
                  },
                  children: /* @__PURE__ */ i.jsx(
                    eH,
                    {
                      inputType: s,
                      menuItem: h,
                      onClick: r
                    }
                  )
                },
                h.key
              )),
              o.length > 0 && /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
                /* @__PURE__ */ i.jsx(qt.Separator, { className: "ctw-dropdown-separator" }),
                o.map((h) => /* @__PURE__ */ i.jsx(
                  qt.Item,
                  {
                    onClick: () => h.action(),
                    className: W(h.className, "ctw-dropdown-action-menu-item"),
                    children: /* @__PURE__ */ i.jsx(bl, { icon: h.icon, children: h.name })
                  },
                  h.name
                ))
              ] })
            ]
          }
        ) })
      ]
    }
  ) });
}
const eH = ({ inputType: e, menuItem: t, onClick: n }) => {
  switch (e) {
    case "checkbox":
      return /* @__PURE__ */ i.jsx("div", { children: /* @__PURE__ */ i.jsxs(
        "label",
        {
          htmlFor: t.name,
          className: "ctw-flex ctw-cursor-pointer ctw-items-center ctw-space-x-3",
          children: [
            /* @__PURE__ */ i.jsx(
              "input",
              {
                type: "checkbox",
                className: "ctw-m-0 ctw-mb-px ctw-w-4",
                name: t.name,
                onClick: (r) => {
                  n({
                    key: t.key,
                    name: t.name,
                    value: !t.isSelected
                  }), r.stopPropagation();
                },
                checked: !!t.isSelected,
                onChange: (r) => {
                  r.stopPropagation();
                }
              }
            ),
            t.display ? t.display : /* @__PURE__ */ i.jsx("span", { children: t.name })
          ]
        }
      ) });
    case "select":
      return /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-w-full ctw-justify-between", children: [
        /* @__PURE__ */ i.jsx("span", { className: W({ "ctw-font-semibold": t.isSelected }), children: t.display ? t.display : t.name }),
        t.isSelected && /* @__PURE__ */ i.jsx(
          me,
          {
            icon: oh,
            className: "ctw-inline-block ctw-h-4 ctw-stroke-0 ctw-align-middle ctw-text-primary-dark"
          }
        )
      ] });
    default:
      return /* @__PURE__ */ i.jsx("div", { children: t.name });
  }
}, tH = ({
  className: e,
  defaultView: t,
  onChange: n,
  options: r
}) => {
  var l;
  const s = (l = r.find((d) => d.display === t)) != null ? l : r[0], [a, o] = Y(s), { trackInteraction: c } = Be();
  return /* @__PURE__ */ i.jsx(
    jl,
    {
      type: "select",
      buttonClassName: W(e, "ctw-bg-transparent ctw-border-none ctw-p-0"),
      onItemSelect: (d) => {
        const u = r.filter((h) => h.display === d.key)[0];
        n(u), o(u), c("change_view", { value: u.display });
      },
      items: r.map((d) => ({
        key: d.display,
        name: d.display,
        isSelected: a.display === d.display
      })),
      children: /* @__PURE__ */ i.jsxs("div", { className: "ctw-btn-default ctw-flex ctw-items-center ctw-space-x-2", children: [
        /* @__PURE__ */ i.jsx("span", { className: "ctw-mr-1.5 ctw-w-full ctw-font-normal", children: a.display }),
        /* @__PURE__ */ i.jsx(me, { icon: jr, className: "ctw-ml-auto ctw-w-2" })
      ] })
    }
  );
};
function N0({ display: e }, t) {
  return /* @__PURE__ */ i.jsx(i.Fragment, { children: kc(e) ? e(t) : e });
}
function Wi(e, t, n) {
  return t.reduce((r, s) => {
    const a = e.find((o) => o.key === s);
    return a ? X(R({}, r), {
      [a.key]: R({
        key: a.key,
        type: a.type,
        selected: a.type === "tag" ? !0 : n[a.key]
      }, (a.type === "checkbox" || a.type === "tag") && a.predicate ? { predicate: a.predicate } : null)
    }) : r;
  }, {});
}
function kf(e) {
  return Object.keys(e).reduce((t, n) => {
    const r = e[n];
    if (typeof r != "undefined") {
      const { type: s } = r;
      return s === "tag" ? Ju(n, [], t) : Ju(n, r.selected, t);
    }
    return t;
  }, {});
}
const nH = "ctw-flex ctw-items-center ctw-max-w-[15rem] ctw-space-x-2 ctw-capitalize ctw-text-content-black ctw-bg-bg-dark ctw-text-sm ctw-rounded ctw-py-2 ctw-px-3 ctw-relative ctw-cursor-pointer ctw-border-0 ctw-border-transparent ctw-whitespace-nowrap ctw-mb-2 ctw-mr-2";
function rH({
  filter: e,
  filterValues: t,
  isOpen: n,
  onRemove: r,
  onChange: s
}) {
  const a = t != null ? t : [], o = nt(
    e.values.map((l) => ({
      key: Cn(l) ? l : l.key,
      name: Cn(l) ? l : l.name,
      display: Cn(l) ? void 0 : l.display,
      isSelected: a.includes(Cn(l) ? l : l.key)
    })),
    ["display", "name"],
    ["asc", "asc"]
  ), c = o.filter((l) => l.isSelected).map((l) => l.display || l.name || l.key);
  return /* @__PURE__ */ i.jsxs(
    jl,
    {
      className: "ctw-max-h-[17.25rem] ctw-overflow-y-auto",
      isOpen: n,
      items: o,
      type: "checkbox",
      pinnedActions: Dt([
        r ? {
          icon: ya,
          name: "Remove Filter",
          action: r
        } : null
      ]),
      buttonClassName: W(e.className, nH),
      onItemSelect: (l) => s(l.key, l.value),
      children: [
        /* @__PURE__ */ i.jsxs("div", { className: "ctw-truncate ctw-font-medium ctw-text-content-black", children: [
          N0(e, { active: !0 }),
          c.length > 0 && /* @__PURE__ */ i.jsxs("span", { className: "ctw-font-normal", children: [
            ": ",
            c.join(", ")
          ] })
        ] }),
        /* @__PURE__ */ i.jsx(me, { icon: jr, className: "ctw-w-2" })
      ]
    }
  );
}
const Cl = va(
  ({
    useBasicStyles: e = !1,
    btnClassName: t,
    children: n,
    className: r,
    optionsClassName: s,
    items: a,
    defaultIndex: o = 0,
    selectedIndex: c,
    onChange: l
  }, d) => {
    var p;
    const [u, h] = Y(o), f = (p = a[u]) != null ? p : {
      display: "Choose a selection"
    };
    return he(() => {
      c !== void 0 && h(c);
    }, [c]), /* @__PURE__ */ i.jsx("div", { className: W(r, "ctw-relative ctw-inline-block"), ref: d, children: /* @__PURE__ */ i.jsxs(
      Ts,
      {
        value: u,
        onChange: (m) => {
          const C = a[m];
          C.divider || (l(m, C), h(m));
        },
        children: [
          /* @__PURE__ */ i.jsxs(
            Ts.Button,
            {
              className: W(
                t,
                !e && "focus-visible:ctw-outline-primary-dark",
                "ctw-relative ctw-cursor-pointer ctw-justify-between ctw-space-x-2 ctw-border-0 ctw-border-transparent"
              ),
              children: [
                n || Lf(f, { listView: !1 }),
                !e && /* @__PURE__ */ i.jsx(me, { icon: jr, className: "ctw-h-4" })
              ]
            }
          ),
          /* @__PURE__ */ i.jsx(Ts.Options, { className: W(s, "ctw-list-box"), children: a.map((m, C) => m.divider ? /* @__PURE__ */ i.jsx("div", { className: "ctw-border-top" }, "divider") : /* @__PURE__ */ i.jsx(Ts.Option, { value: C, as: sn, children: ({ active: y, selected: g }) => /* @__PURE__ */ i.jsxs(
            "li",
            {
              className: W(
                "ctw-flex ctw-cursor-pointer ctw-justify-between ctw-px-3 ctw-py-2",
                "hover:ctw-bg-bg-lighter",
                m.className,
                {
                  "ctw-text-medium": y || g,
                  "ctw-text-content-black": !(y || g),
                  "ctw-bg-bg-lighter": y
                }
              ),
              children: [
                /* @__PURE__ */ i.jsx(
                  "span",
                  {
                    className: W("ctw-inline-flex ctw-whitespace-nowrap ctw-align-middle", {
                      "ctw-font-semibold": g && !e
                    }),
                    children: Lf(m, {
                      active: y,
                      selected: g,
                      listView: !0
                    })
                  }
                ),
                !e && g && !m.key.startsWith("_") && /* @__PURE__ */ i.jsx("span", { className: "ctw-inline-flex ctw-pb-0.5", children: /* @__PURE__ */ i.jsx(
                  me,
                  {
                    icon: oh,
                    className: "ctw-inline-block ctw-h-4 ctw-stroke-0 ctw-align-middle ctw-text-primary-dark"
                  }
                ) })
              ]
            }
          ) }, m.key)) })
        ]
      }
    ) });
  }
);
function Lf(e, t) {
  return e.divider ? null : /* @__PURE__ */ i.jsx(bl, { icon: e.icon, children: dr(e.display) ? e.display(t) : e.display });
}
const sH = "ctw-flex ctw-items-center ctw-capitalize ctw-text-content-black ctw-bg-bg-dark ctw-text-sm ctw-rounded ctw-py-2 ctw-px-3 ctw-relative ctw-cursor-pointer ctw-border-0 ctw-border-transparent ctw-whitespace-nowrap ctw-mb-2 ctw-mr-2", D0 = (e) => kc(e) ? e({ active: !1 }) : e, aH = (e, t, n) => ({
  key: t,
  display: ({ listView: r, filter: s }) => r ? /* @__PURE__ */ i.jsx(bl, { icon: n, children: e }) : s && D0(s.display)
}), Vi = aH("remove filter", "_remove", ya);
function iH({
  filter: e,
  filterValues: t,
  onChange: n,
  onRemove: r
}) {
  const a = [...e.values.map((c) => Cn(c) ? c : c.name).sort(), Vi], o = typeof t == "string" ? a.indexOf(t) : -1;
  return /* @__PURE__ */ i.jsx(
    Cl,
    {
      selectedIndex: o,
      defaultIndex: a.length - 1,
      btnClassName: sH,
      optionsClassName: "ctw-capitalize",
      className: "ctw-max-h-[17.25rem] ctw-overflow-y-auto",
      items: a.map((c) => ({
        // eslint-disable-next-line react/no-unstable-nested-components
        display: ({ listView: l }) => c === Vi ? c.display({ listView: l, filter: e }) : l ? /* @__PURE__ */ i.jsx("span", { className: "ctw-whitespace-nowrap", children: c }) : /* @__PURE__ */ i.jsxs("div", { className: "ctw-truncate ctw-font-medium ctw-text-content-black", children: [
          D0(e.display),
          /* @__PURE__ */ i.jsxs("span", { className: "ctw-font-normal", children: [
            ": ",
            c
          ] })
        ] }),
        key: Cn(c) ? c : c.key,
        className: W("ctw-capitalize", {
          "ctw-border ctw-capitalize ctw-border-solid ctw-border-divider-light ctw-border-0 ctw-border-t": c === Vi
        })
      })),
      onChange: (c, l) => {
        l.key === "_remove" ? r() : l.key === "_reset" ? n("", !1) : n(l.key, !0);
      }
    }
  );
}
const oH = "ctw-flex ctw-items-center ctw-max-w-[15rem] ctw-capitalize ctw-text-content-black ctw-bg-bg-dark ctw-text-sm ctw-rounded ctw-py-2 ctw-px-3 ctw-relative ctw-cursor-pointer ctw-border-0 ctw-border-transparent ctw-whitespace-nowrap ctw-mb-2 ctw-mr-2";
function cH({ filter: e, onRemove: t }) {
  return /* @__PURE__ */ i.jsxs(
    "button",
    {
      type: "button",
      className: W(oH, e.className, "ctw-space-x-2"),
      onClick: t,
      children: [
        /* @__PURE__ */ i.jsx("div", { children: N0(e, { active: !0 }) }),
        /* @__PURE__ */ i.jsx(me, { icon: Iw, className: "ctw-w-2 ctw-text-content-light" })
      ]
    },
    e.key
  );
}
function lH({
  onRemove: e,
  filter: t,
  filterValues: n,
  isOpen: r,
  updateSelectedFilterValues: s
}) {
  const a = () => e(t.key);
  switch (t.type) {
    case "tag":
      return /* @__PURE__ */ i.jsx(cH, { filter: t, onRemove: a });
    case "select":
      return /* @__PURE__ */ i.jsx(
        iH,
        {
          filter: t,
          filterValues: n,
          onRemove: a,
          onChange: s
        }
      );
    case "checkbox":
      return /* @__PURE__ */ i.jsx(
        rH,
        {
          isOpen: r,
          filter: t,
          filterValues: n,
          onRemove: a,
          onChange: s
        }
      );
    default:
      throw new Error("ActiveFilterItem has invalid filter type");
  }
}
const _o = ["_remove", "_reset"], dH = (e) => e.filter((t) => !_o.includes(t)), uH = ({
  className: e,
  onChange: t,
  filters: n,
  defaultFilters: r = {},
  selected: s
}) => {
  const [a, o] = Y(), { trackInteraction: c } = Be();
  he(() => {
    if (n.some(({ key: v }) => _o.includes(v)))
      throw new Error(`Filters should not use keys ${_o.join(", ")}`);
  }, [n]);
  const l = Object.keys(s), d = kf(s), u = () => {
    t({}), c("change_filter", { action: "clear" });
  }, h = () => {
    const v = kf(r);
    t(Wi(n, Object.keys(v), v)), c("change_filter", { action: "reset" });
  }, f = (v) => {
    const b = l.includes(v);
    b || o(v);
    const j = dH(
      b ? l.filter((D) => D !== v) : aa(l.concat(v))
    );
    t(Wi(n, j, d)), c("change_filter", { action: b ? "deselect" : "select", value: v });
  }, p = (v, b, j) => {
    var L;
    let D;
    const $ = n.find((I) => I.key === v), _ = (L = d[v]) != null ? L : [];
    if (j)
      D = X(R({}, d), {
        [v]: ($ == null ? void 0 : $.type) === "checkbox" ? aa(_.concat(b)) : b
      });
    else if (Array.isArray(_)) {
      const I = _.filter((A) => A !== b);
      D = R({}, d), I.length > 0 ? D[v] = I : D = as(v, D);
    } else
      D = as(v, d);
    t(Wi(n, l, D));
  }, m = (v) => {
    const b = l.includes(v.key);
    return {
      display: b && v.toggleDisplay ? v.toggleDisplay : v.display,
      icon: b && v.toggleIcon ? v.toggleIcon : v.icon,
      key: v.key,
      className: W("ctw-capitalize", v.className)
    };
  }, [C, y] = Vu(
    ({ key: v }) => l.includes(v),
    n
  ), g = C.filter((v) => v.toggleDisplay), [w, x] = Vu(
    (v) => !v.belowDivider,
    [...y, ...g]
  );
  Kc(r) || x.push({
    display: "reset filters",
    icon: _w,
    key: "_reset",
    type: "tag"
  }), x.push({
    display: "remove all filters",
    icon: ya,
    key: "_remove",
    type: "tag"
  });
  const S = w.length && x.length ? [{ divider: !0 }] : [], N = [
    ...w.map(m),
    ...S,
    ...x.map(m)
  ];
  return /* @__PURE__ */ i.jsxs(
    "div",
    {
      className: W(
        e,
        "ctw-items-left ctw-relative ctw-flex ctw-flex-col ctw-flex-wrap sm:ctw-flex-row sm:ctw-items-center"
      ),
      children: [
        C.map((v) => /* @__PURE__ */ i.jsx(
          lH,
          {
            isOpen: a === v.key,
            filter: v,
            filterValues: d[v.key],
            onRemove: f,
            updateSelectedFilterValues: (b, j) => p(v.key, b, j)
          },
          v.key
        )),
        /* @__PURE__ */ i.jsx(
          Cl,
          {
            useBasicStyles: !0,
            btnClassName: "!ctw-text-content-light ctw-btn-clear !ctw-font-normal",
            className: "ctw-mr-[calc(15rem-88px)]",
            items: N,
            onChange: (v, b) => {
              switch (b.key) {
                case "_remove":
                  return u();
                case "_reset":
                  return h();
                default:
                  return f(b.key);
              }
            },
            children: /* @__PURE__ */ i.jsxs("div", { className: "ctw-mb-2 ctw-flex ctw-items-center ctw-space-x-1 ctw-p-2", children: [
              /* @__PURE__ */ i.jsx(me, { icon: Tw, className: "ctw-w-4" }),
              /* @__PURE__ */ i.jsx("span", { children: "Add Filters" })
            ] })
          }
        )
      ]
    }
  );
}, fH = ({
  className: e,
  defaultSort: t,
  onChange: n,
  options: r
}) => {
  const [s, a] = Y(t), { trackInteraction: o } = Be();
  return /* @__PURE__ */ i.jsx(
    jl,
    {
      className: "ctw-max-h-[17.25rem] ctw-overflow-y-auto",
      type: "select",
      buttonClassName: W(e, "ctw-bg-transparent ctw-border-none ctw-p-0"),
      onItemSelect: (c) => {
        const l = r.filter((d) => d.display === c.key)[0];
        n(l), o("sort", {
          value: c.key,
          dir: l.sorts[0].dir
        }), a(l);
      },
      items: r.map((c) => ({
        key: c.display,
        name: c.display,
        isSelected: s.display === c.display
      })),
      children: /* @__PURE__ */ i.jsxs("div", { className: "ctw-btn-default ctw-flex ctw-items-center ctw-space-x-2", children: [
        /* @__PURE__ */ i.jsxs("span", { className: "ctw-mr-1.5 ctw-w-full", children: [
          "Sort: ",
          /* @__PURE__ */ i.jsx("span", { className: "ctw-font-normal", children: s.display })
        ] }),
        /* @__PURE__ */ i.jsx(me, { icon: jr, className: "ctw-ml-auto ctw-w-2" })
      ] })
    }
  );
}, Ht = ({
  action: e,
  className: t,
  filterOptions: n,
  sortOptions: r,
  viewOptions: s
}) => !s && !r && !n && !e ? null : /* @__PURE__ */ i.jsxs(
  "div",
  {
    className: W(
      t,
      "ctw-flex ctw-flex-col-reverse ctw-items-start ctw-justify-items-end ctw-pt-2 sm:ctw-flex-row sm:ctw-pt-1.5"
    ),
    children: [
      /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-w-full ctw-flex-col ctw-flex-wrap ctw-gap-x-2 sm:ctw-flex-row", children: [
        s && /* @__PURE__ */ i.jsx(
          tH,
          {
            className: W(s.className, "ctw-mb-2"),
            defaultView: s.defaultView,
            onChange: s.onChange,
            options: s.options
          }
        ),
        r && /* @__PURE__ */ i.jsx(
          fH,
          {
            className: W(r.className, "ctw-mb-2"),
            defaultSort: r.defaultSort,
            onChange: r.onChange,
            options: r.options
          }
        ),
        n && n.filters.length > 0 && /* @__PURE__ */ i.jsx(uH, R({}, n))
      ] }),
      /* @__PURE__ */ i.jsx("div", { className: "ctw-mb-2 ctw-ml-0 ctw-w-full ctw-whitespace-nowrap ctw-px-2 sm:ctw-mb-0 sm:ctw-ml-auto sm:ctw-w-auto", children: e })
    ]
  }
), kt = ({
  className: e,
  color: t,
  content: n,
  noFlex: r = !1,
  size: s = "sm"
}) => {
  const a = {
    primary: "ctw-bg-primary-light ctw-text-primary-main",
    // green
    info: "ctw-bg-info-light !ctw-text-info-text",
    // blue
    notification: "ctw-bg-notification-light ctw-text-notification-main",
    // purple
    muted: "ctw-bg-bg-light ctw-text-content-black",
    // grey
    caution: "ctw-bg-caution-light ctw-text-caution-text"
    // yellow
  }[t], o = {
    xs: "ctw-text-xs ctw-px-1.5 ctw-py-0.5",
    sm: "ctw-text-xs ctw-px-2 ctw-leading-5"
  }[s];
  return /* @__PURE__ */ i.jsx(
    "span",
    {
      className: W(
        e,
        a,
        o,
        "ctw-rounded-full ctw-whitespace-nowrap !ctw-font-medium hover:!ctw-no-underline",
        !r && "ctw-inline-flex"
      ),
      children: n
    }
  );
};
function Sn(o) {
  var c = o, {
    children: e,
    content: t,
    open: n,
    defaultOpen: r,
    onOpenChange: s
  } = c, a = ct(c, [
    "children",
    "content",
    "open",
    "defaultOpen",
    "onOpenChange"
  ]);
  return t ? (
    // Wrap in parent div, this fixes issue where parent's
    // may set space classes that would affect our position.
    /* @__PURE__ */ i.jsx("div", { className: "ctw-tooltip-wrapper", children: /* @__PURE__ */ i.jsx(Yr.Provider, { children: /* @__PURE__ */ i.jsxs(
      Yr.Root,
      {
        delayDuration: 0,
        open: n,
        defaultOpen: r,
        onOpenChange: s,
        children: [
          /* @__PURE__ */ i.jsx(Yr.Trigger, { asChild: !0, children: /* @__PURE__ */ i.jsx("div", { className: "ctw-cursor-pointer ctw-inline", children: e }) }),
          /* @__PURE__ */ i.jsxs(
            Yr.Content,
            X(R({
              side: "bottom",
              align: "center",
              className: "ctw-max-w-[193px] ctw-rounded ctw-bg-icon-default ctw-p-2 ctw-text-sm ctw-text-center ctw-text-white ctw-TooltipContent"
            }, a), {
              children: [
                t,
                /* @__PURE__ */ i.jsx(Yr.Arrow, { className: "ctw-fill-icon-default" })
              ]
            })
          )
        ]
      }
    ) }) })
  ) : /* @__PURE__ */ i.jsx(i.Fragment, { children: e });
}
const Wt = ({
  title: e,
  subTitle: t,
  className: n,
  renderIcon: r
  // Add the renderIcon prop to be used within the component
}) => /* @__PURE__ */ i.jsxs("div", { className: n, children: [
  /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-justify-between ctw-space-x-1.5", children: [
    /* @__PURE__ */ i.jsx("div", { className: "ctw-font-medium group-hover:ctw-underline", children: e }),
    /* @__PURE__ */ i.jsx("div", { className: "ctw-flex ctw-flex-nowrap ctw-space-x-2", children: r })
  ] }),
  t ? /* @__PURE__ */ i.jsx("div", { children: t }) : null
] }), Lt = (e = !0, t = !1) => e && /* @__PURE__ */ i.jsx(Sn, { content: "Synced with record", children: /* @__PURE__ */ i.jsx(
  me,
  {
    className: `${t ? "ctw-text-success-main" : "ctw-text-content-light"} ctw-w-[14px] ctw-h-[14px]`,
    icon: t ? ch : gh
  }
) });
function hH(e) {
  return !e || ["not-known-to-builder", "unknown"].includes(e.state);
}
const pH = (e, t) => {
  const { state: n, message: r = "There was an error adding this record to the chart." } = e;
  switch (n) {
    case "known-to-builder-new":
      return Lt(!0, !0);
    case "in-progress":
      return /* @__PURE__ */ i.jsx(an, { className: "ctw-w-[14px] ctw-h-[14px]" });
    case "error":
      return /* @__PURE__ */ i.jsx(Sn, { content: r, children: /* @__PURE__ */ i.jsx(
        me,
        {
          className: "ctw-text-error-main ctw-w-[14px] ctw-h-[14px]",
          icon: Rw
        }
      ) });
    case "bulk-dismissed-new":
      return /* @__PURE__ */ i.jsx(Sn, { content: "Successfully dismissed", children: /* @__PURE__ */ i.jsx(
        me,
        {
          className: "ctw-text-content-light ctw-w-[14px] ctw-h-[14px]",
          icon: ch
        }
      ) });
    case "dismissed":
      return /* @__PURE__ */ i.jsx("input", { type: "checkbox", className: "ctw-w-4", checked: !1, disabled: !0 });
    case "known-to-builder":
      return Lt(!0);
    default:
      if (t) {
        const { isSelected: s, changeState: a } = t;
        return /* @__PURE__ */ i.jsx(S0, { isSelected: s, changeState: a });
      }
  }
}, S0 = ({ isSelected: e, changeState: t }) => /* @__PURE__ */ i.jsx(
  "input",
  {
    type: "checkbox",
    className: "ctw-w-4",
    onClick: (n) => {
      n.stopPropagation(), t(!e);
    },
    checked: e,
    onChange: (n) => {
      n.stopPropagation();
    }
  }
), $0 = (e, t, n) => e && /* @__PURE__ */ i.jsx("div", { "data-testid": "indicator", className: W(t), children: n ? /* @__PURE__ */ i.jsx("div", { className: "ctw-self-start", children: /* @__PURE__ */ i.jsx(Sn, { content: n, children: /* @__PURE__ */ i.jsx(kt, { color: "info", content: e, size: "xs", noFlex: !0 }) }) }) : /* @__PURE__ */ i.jsx(kt, { color: "info", content: e, size: "xs", noFlex: !0 }) }), mH = (e) => [
  {
    title: "Name",
    render: (n) => /* @__PURE__ */ i.jsx(
      Wt,
      {
        title: n.display,
        renderIcon: Lt(n.ownedByBuilder(e))
      }
    )
  },
  {
    title: "Last Updated",
    render: (n) => /* @__PURE__ */ i.jsx("div", { children: n.recordedDate ? /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
      /* @__PURE__ */ i.jsxs("div", { className: "ctw-text-sm ctw-font-normal", children: [
        "Last Updated: ",
        n.recordedDate
      ] }),
      /* @__PURE__ */ i.jsx("div", { children: n.patientOrganizationName })
    ] }) : /* @__PURE__ */ i.jsx("div", { children: n.patientOrganizationName }) })
  },
  {
    title: "Details",
    render: (n) => /* @__PURE__ */ i.jsx("div", { className: "ctw-font-normal", children: !!n.manifestations && n.manifestations !== "unknown" && /* @__PURE__ */ i.jsxs("div", { children: [
      "Reaction: ",
      qe(n.manifestations)
    ] }) })
  }
], A0 = ({ className: e }) => /* @__PURE__ */ i.jsxs(
  "svg",
  {
    width: "60",
    height: "60",
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: e,
    children: [
      /* @__PURE__ */ i.jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M26.75 8.5C15.0139 8.5 5.5 18.0139 5.5 29.75C5.5 41.486 15.0139 51 26.75 51C36.8532 51 45.3095 43.9493 47.4671 34.5H44.6876C43.6438 34.5 42.7098 33.8514 42.3451 32.8733C41.9805 31.8952 42.2619 30.7935 43.051 30.1102L49.1132 24.8602C50.0526 24.0466 51.447 24.0466 52.3864 24.8602L58.4486 30.1102C59.2377 30.7935 59.5191 31.8952 59.1545 32.8733C58.7898 33.8514 57.8558 34.5 56.812 34.5H53.0795C50.8381 47.0077 39.9026 56.5 26.75 56.5C11.9764 56.5 0 44.5236 0 29.75C0 14.9764 11.9764 3 26.75 3C33.9573 3 40.5038 5.85401 45.3115 10.4877C46.405 11.5417 46.4371 13.2826 45.3831 14.3761C44.3291 15.4697 42.5882 15.5017 41.4947 14.4478C37.6708 10.7622 32.4774 8.5 26.75 8.5Z",
          fill: "#9CA3AF"
        }
      ),
      /* @__PURE__ */ i.jsx(
        "path",
        {
          d: "M26.25 16.75C27.6307 16.75 28.75 17.8693 28.75 19.25V29.7145L36.0178 36.9822C36.9941 37.9585 36.9941 39.5415 36.0178 40.5178C35.0415 41.4941 33.4585 41.4941 32.4822 40.5178L24.4822 32.5178C24.0134 32.0489 23.75 31.413 23.75 30.75V19.25C23.75 17.8693 24.8693 16.75 26.25 16.75Z",
          fill: "#9CA3AF"
        }
      )
    ]
  }
), gH = /^(\+\d{1,2}\s?)?1?-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/, wH = /^\d{5}(-\d{4})?$/;
function vH(e) {
  return Ce.enum(
    [
      "AL",
      "AK",
      "AZ",
      "AR",
      "CA",
      "CO",
      "CT",
      "DE",
      "DC",
      "FL",
      "GA",
      "HI",
      "ID",
      "IL",
      "IN",
      "IA",
      "KS",
      "KY",
      "LA",
      "ME",
      "MD",
      "MA",
      "MI",
      "MN",
      "MS",
      "MO",
      "MT",
      "NE",
      "NV",
      "NH",
      "NJ",
      "NM",
      "NY",
      "NC",
      "ND",
      "OH",
      "OK",
      "OR",
      "PA",
      "RI",
      "SC",
      "SD",
      "TN",
      "TX",
      "UT",
      "VT",
      "VA",
      "WA",
      "WV",
      "WI",
      "WY"
    ],
    { required_error: e }
  );
}
function yH(e) {
  return e ? {
    alabama: "AL",
    alaska: "AK",
    arizona: "AZ",
    arkansas: "AR",
    california: "CA",
    colorado: "CO",
    connecticut: "CT",
    delaware: "DE",
    florida: "FL",
    georgia: "GA",
    hawaii: "HI",
    idaho: "ID",
    illinois: "IL",
    indiana: "IN",
    iowa: "IA",
    kansas: "KS",
    kentucky: "KY",
    louisiana: "LA",
    maine: "ME",
    maryland: "MD",
    massachusetts: "MA",
    michigan: "MI",
    minnesota: "MN",
    mississippi: "MS",
    missouri: "MO",
    montana: "MT",
    nebraska: "NE",
    nevada: "NV",
    "new hampshire": "NH",
    "new jersey": "NJ",
    "new mexico": "NM",
    "new york": "NY",
    "north carolina": "NC",
    "north dakota": "ND",
    ohio: "OH",
    oklahoma: "OK",
    oregon: "OR",
    pennsylvania: "PA",
    "rhode island": "RI",
    "south carolina": "SC",
    "south dakota": "SD",
    tennessee: "TN",
    texas: "TX",
    utah: "UT",
    vermont: "VT",
    virginia: "VA",
    washington: "WA",
    "west virginia": "WV",
    wisconsin: "WI",
    wyoming: "WY"
  }[e.toLowerCase()] || e.toUpperCase() : "";
}
const xH = (e, t) => {
  var n, r, s, a, o, c, l, d, u, h, f, p, m, C, y;
  return [
    {
      label: "treating-provider",
      render: () => /* @__PURE__ */ i.jsx("div", { className: "ctw-font-medium", children: "Who is the treating provider for this patient?" })
    },
    {
      label: "Practitioner Name",
      field: "name",
      value: "",
      readonly: !1
    },
    {
      label: "NPI",
      field: "npi",
      value: "",
      readonly: !1
    },
    [
      {
        label: "Zus patient ID",
        hidden: !0,
        field: "id",
        value: (n = e == null ? void 0 : e.id) != null ? n : "",
        readonly: !0
      },
      {
        label: "Role",
        field: "role",
        value: "Medical practitioner (SNOMED 158965000)",
        hidden: !0
      }
    ],
    ...t ? [
      {
        label: "patient-information",
        render: () => /* @__PURE__ */ i.jsxs("div", { children: [
          /* @__PURE__ */ i.jsx("div", { className: "ctw-font-medium", children: "Is the patient information below correct and up-to-date?" }),
          /* @__PURE__ */ i.jsx("div", { children: "Complete as many fields as possible to increase matching results." })
        ] })
      },
      {
        label: "First Name",
        field: "firstName",
        value: (r = e == null ? void 0 : e.firstName) != null ? r : "",
        readonly: !1
      },
      {
        label: "Last Name",
        field: "lastName",
        value: (s = e == null ? void 0 : e.lastName) != null ? s : "",
        readonly: !1
      },
      [
        {
          label: "Date of Birth",
          field: "dateOfBirth",
          value: (a = e == null ? void 0 : e.dob) != null ? a : "",
          readonly: !1
        },
        {
          label: "Gender",
          field: "gender",
          value: (o = e == null ? void 0 : e.gender) != null ? o : "",
          readonly: !1
        }
      ],
      {
        label: "Address",
        field: "address",
        value: (d = (l = (c = e == null ? void 0 : e.homeAddress) == null ? void 0 : c.line) == null ? void 0 : l.join(", ")) != null ? d : "",
        readonly: !1
      },
      {
        label: "City",
        field: "city",
        value: (h = (u = e == null ? void 0 : e.homeAddress) == null ? void 0 : u.city) != null ? h : "",
        readonly: !1
      },
      [
        {
          label: "State",
          field: "state",
          value: yH((f = e == null ? void 0 : e.homeAddress) == null ? void 0 : f.state),
          readonly: !1
        },
        {
          label: "Zip",
          field: "zipCode",
          value: (m = (p = e == null ? void 0 : e.homeAddress) == null ? void 0 : p.postalCode) != null ? m : "",
          readonly: !1
        }
      ],
      {
        label: "Phone",
        field: "phone",
        value: (C = e == null ? void 0 : e.phoneNumber) != null ? C : "",
        readonly: !1
      },
      {
        label: "Email",
        field: "email",
        value: (y = e == null ? void 0 : e.email) != null ? y : "",
        readonly: !1
      }
    ] : []
  ];
}, E0 = Ce.object({
  name: Ce.string({
    required_error: "Practitioner name must be specified."
  }),
  npi: Ce.string({
    required_error: "NPI must be specified."
  }).length(10),
  role: Ce.enum(["Medical practitioner (SNOMED 158965000)"]).optional(),
  id: Ce.string().optional()
  // patient id (hidden field on form)
});
E0.merge(
  Ce.object({
    firstName: Ce.string({
      required_error: "First name must be specified."
    }),
    lastName: Ce.string({
      required_error: "Last name must be specified."
    }),
    dateOfBirth: Ce.date().min(/* @__PURE__ */ new Date("1900"), { message: "Date of birth is invalid." }).max(/* @__PURE__ */ new Date(), { message: "Date of birth cannot be a future date." }),
    gender: Ce.enum(["-", "male", "female", "other", "unknown"]),
    address: Ce.string({
      required_error: "Address must be specified."
    }),
    city: Ce.string({
      required_error: "City must be specified."
    }),
    state: vH("State must be specified."),
    zipCode: Ce.string({
      required_error: "Zip code must be specified."
    }).regex(wH, {
      message: "Zip code is invalid."
    }),
    phone: Ce.string().regex(gH, { message: "Phone number is invalid." }).optional(),
    email: Ce.string().email({ message: "Email address is invalid." }).optional()
  })
);
const bH = ({ submitting: e }) => /* @__PURE__ */ i.jsxs(
  "button",
  {
    type: "submit",
    disabled: e,
    className: W("ctw-btn-primary ctw-save-button ctw-w-28 ctw-whitespace-nowrap"),
    children: [
      e ? "Saving..." : "Save",
      e && /* @__PURE__ */ i.jsx(an, { className: "ctw-ml-2 ctw-text-white" })
    ]
  }
);
function jH(e) {
  return typeof e == "object" && e !== null ? "message" in e : !1;
}
const CH = (e, t) => {
  if (Hc(t))
    throw $e.logFhirError(t, e), jg(e, t);
  return jH(t) ? ($e.logError(t, `${e}: ${t.message}`), { title: e, statusText: t.message }) : ($e.logError(new Error(e)), { title: e });
}, Ff = (e) => {
  let t = [], n = !0;
  return Hc(e) && Gm(e.response.data) ? (t = new bg(e.response.data).issues.filter((r) => r.severity !== "warning").map((r) => r.display), n = !1) : i9(e) ? (t = [e.response.data.message], n = !1) : e instanceof Error && (t = [e.message], n = !1), { requestErrors: t, responseIsSuccess: n };
};
function I0(e, t, n, r) {
  var o;
  let s = t;
  for (; s instanceof ao || s instanceof Qs; )
    if (s = s instanceof ao ? s.shape : s instanceof Qs ? s._def.schema : null, s === null)
      throw new Error(`Could not find shape for key ${n}`);
  if (n.includes(".")) {
    let [c, ...l] = n.split(".");
    e[c] = (o = e[c]) != null ? o : {}, I0(e[c], s[c], l.join("."), r);
    return;
  }
  n.includes("[]") && (n = n.replace("[]", ""));
  const a = s[n];
  a && Vs(a, e, n, r);
}
function Vs(e, t, n, r) {
  let s;
  if (e instanceof vh || e instanceof _v)
    s = r;
  else if (e instanceof yh) {
    const a = Number(r);
    s = isNaN(a) ? r : a;
  } else if (e instanceof so) {
    const a = Date.parse(r);
    s = isNaN(a) ? r : new Date(a);
  } else if (e instanceof xh)
    s = r === "true" ? !0 : r === "false" ? !1 : !!r;
  else if (e instanceof Tv || e instanceof Rv)
    s = r;
  else if (e instanceof jh || e instanceof Mv) {
    Vs(e._def.innerType, t, n, r);
    return;
  } else if (e instanceof bh) {
    t[n] === void 0 && (t[n] = []), Vs(e.element, t, n, r);
    return;
  } else if (e instanceof Qs) {
    Vs(e._def.schema, t, n, r);
    return;
  } else if (e instanceof ao) {
    const a = JSON.parse(r);
    s = a, Object.entries(e.shape).forEach(([o, c]) => {
      s[o] || delete a[o];
    });
  } else if (e instanceof Pv)
    s = JSON.parse(r);
  else
    throw new Error(`Unexpected type ${e._def.typeName} for key ${n}`);
  Array.isArray(t[n]) ? t[n].push(s) : t[n] = s;
}
function NH(e) {
  return Symbol.iterator in Object(e);
}
function DH(e, t) {
  let n = {}, r;
  NH(e) ? r = Array.from(e) : r = Object.entries(e);
  for (const [o, c] of r)
    c !== "" && I0(n, t, o, c);
  const s = t.safeParse(n);
  if (s.success)
    return { success: !0, data: s.data, errors: void 0 };
  const a = {};
  return s.error.issues.forEach((o) => {
    const { message: c, path: l } = o, d = l[0];
    a.hasOwnProperty(d) ? a[d] = [...a[d], c] : a[d] = [c];
  }), { success: !1, data: void 0, errors: a };
}
function SH(e, t) {
  return V(this, null, function* () {
    return DH(e, t);
  });
}
function $H(e, t) {
  var r, s;
  if (t.options)
    return t.options;
  const n = e.shape[t.field];
  return (s = (n == null ? void 0 : n.options) || ((r = n == null ? void 0 : n.unwrap) == null ? void 0 : r.call(n).options)) == null ? void 0 : s.map((a) => ({
    label: a,
    value: a
  }));
}
function _0(e) {
  const t = e instanceof Qs ? e._def.schema : e, { shape: n } = t;
  return function(r, s = {}) {
    const a = n[r.field];
    if (!a)
      throw new Error(`no such key: ${r.field}`);
    return T0(r, t, a);
  };
}
function T0(e, t, n) {
  var u, h, f, p;
  let r = "text", s, a, o, c;
  const l = $H(t, e);
  if (n instanceof vh)
    n.isEmail ? r = "email" : n.isURL && (r = "url"), o = (u = n.minLength) != null ? u : void 0, c = (h = n.maxLength) != null ? h : void 0, n._def.checks.find((m) => m.kind === "regex");
  else if (n instanceof yh)
    r = "number", s = (f = n.minValue) != null ? f : void 0, a = (p = n.maxValue) != null ? p : void 0;
  else if (n instanceof xh)
    r = "checkbox";
  else if (n instanceof so || n._def.innerType instanceof so)
    r = "date";
  else if (n instanceof bh)
    return T0(e, t, n.element);
  const d = {
    name: e.field,
    type: r,
    options: l
  };
  return n instanceof jh || (d["aria-required"] = !0), s && (d.min = s), a && (d.max = a), o && Number.isFinite(o) && (d.minLength = o), c && Number.isFinite(c) && (d.maxLength = c), d;
}
const AH = (u) => {
  var h = u, {
    action: e,
    closeOnSubmit: t = !1,
    onSubmit: n,
    onSubmitSuccess: r,
    onSubmitError: s,
    onClose: a,
    children: o,
    schema: c,
    errorHeader: l = "There was an error with your submission"
  } = h, d = ct(h, [
    "action",
    "closeOnSubmit",
    "onSubmit",
    "onSubmitSuccess",
    "onSubmitError",
    "onClose",
    "children",
    "schema",
    "errorHeader"
  ]);
  const [f, p] = Y(!1), [m, C] = Y(), { getRequestContext: y } = Xe(), { trackInteraction: g } = Be(), w = () => {
    C({}), p(!1);
  }, x = (S) => V(void 0, null, function* () {
    S.preventDefault(), C({}), p(!0);
    const N = S.target, v = Array.from(S.target.querySelectorAll("input")), b = {};
    if (v.forEach((I) => {
      I.checkValidity() || (b[I.name] = [`The value is not valid for ${I.name}`]);
    }), !xe(b)) {
      C({ formErrors: b }), p(!1);
      return;
    }
    const j = new FormData(N), D = yield SH(j, c);
    if (!D.success) {
      console.error("There was an error processing form data. formResult:", D), C({
        formErrors: D.errors,
        requestErrors: void 0
      }), p(!1);
      return;
    }
    let $, _ = !0, L;
    try {
      t && a(), n && n(), $ = yield e(D.data, y);
    } catch (I) {
      $e.logError(I), _ = !1, L = Ff(I).requestErrors;
    }
    if ($) {
      const I = Ff($);
      _ = I.responseIsSuccess, L = I.requestErrors;
    }
    _ ? (p(!1), t || a(), r && r()) : (C({
      formErrors: void 0,
      requestErrors: L
    }), p(!1), s && s((L == null ? void 0 : L.join(", ")) || "An error occurred"));
  });
  return /* @__PURE__ */ i.jsx(et, X(R({}, d), { onClose: a, onAfterClosed: w, disableCloseOnBlur: !0, children: /* @__PURE__ */ i.jsxs(
    "form",
    {
      className: "ctw-flex ctw-h-full ctw-flex-col ctw-overflow-y-auto",
      onSubmit: (S) => {
        x(S), g("submit_form");
      },
      noValidate: !0,
      children: [
        /* @__PURE__ */ i.jsx(et.Body, { children: /* @__PURE__ */ i.jsxs("div", { className: "ctw-space-y-4", children: [
          (m == null ? void 0 : m.requestErrors) && /* @__PURE__ */ i.jsx(Zn, { header: l, children: m.requestErrors.length === 1 ? m.requestErrors[0] : /* @__PURE__ */ i.jsx("ul", { className: "ctw-m-0 ctw-list-disc ctw-px-4", children: m.requestErrors.map((S) => /* @__PURE__ */ i.jsx("li", { children: S })) }) }),
          o(f, m == null ? void 0 : m.formErrors)
        ] }) }),
        /* @__PURE__ */ i.jsx(et.Footer, { children: /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-items-center ctw-justify-between", children: [
          /* @__PURE__ */ i.jsx(et.CloseButton, { label: "Cancel", onClose: a }),
          /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-items-center ctw-space-x-3", children: [
            ((m == null ? void 0 : m.requestErrors) || (m == null ? void 0 : m.formErrors)) && /* @__PURE__ */ i.jsx("div", { className: "ctw-text-sm ctw-font-medium ctw-text-error-text", children: "There was an error with your submission" }),
            /* @__PURE__ */ i.jsx(bH, { submitting: f })
          ] })
        ] }) })
      ]
    }
  ) }));
}, To = (l) => {
  var d = l, {
    errors: e,
    options: t,
    lines: n,
    defaultValue: r,
    readonly: s,
    hidden: a,
    render: o
  } = d, c = ct(d, [
    "errors",
    "options",
    "lines",
    "defaultValue",
    "readonly",
    "hidden",
    "render"
  ]);
  const u = c.type === "date" ? ML(r) : r, h = () => o ? o(s, X(R({}, c), { defaultValue: r, hidden: a })) : t ? /* @__PURE__ */ i.jsxs(
    "select",
    {
      "data-testid": `form-field-${c.name}`,
      className: W({ "ctw-error": e }, "ctw-listbox-button ctw-w-full"),
      name: c.name,
      id: c.name,
      disabled: c.disabled,
      defaultValue: u,
      children: [
        !t.some((f) => f.value === r) && /* @__PURE__ */ i.jsx("option", { value: r, disabled: !0, children: "Select one" }),
        t.map((f) => /* @__PURE__ */ i.jsx("option", { value: f.value, children: Dc(f.label) }, f.value))
      ]
    }
  ) : n ? /* @__PURE__ */ i.jsx(
    "textarea",
    {
      "data-testid": `form-field-${c.name}`,
      rows: n,
      className: W(
        { "ctw-error": e },
        "ctw-listbox-textarea ctw-w-full ctw-whitespace-pre-wrap"
      ),
      defaultValue: u,
      disabled: c.disabled,
      readOnly: s,
      name: c.name,
      id: c.name
    }
  ) : /* @__PURE__ */ i.jsx(
    "input",
    R(X(R({
      "data-testid": `form-field-${c.name}`
    }, c), {
      id: c.name,
      type: c.type,
      className: W({ "ctw-error": e }, "ctw-listbox-input ctw-w-full"),
      readOnly: s
    }), u ? { defaultValue: u } : {})
  );
  return o && a ? o(s, X(R({}, c), {
    defaultValue: r,
    hidden: a
  })) : a ? /* @__PURE__ */ i.jsx(
    "input",
    X(R({
      "data-testid": `form-field-${c.name}`
    }, c), {
      defaultValue: u,
      hidden: a
    })
  ) : /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
    /* @__PURE__ */ i.jsxs("div", { className: "ctw-relative", children: [
      h(),
      s && /* @__PURE__ */ i.jsx(BB, { className: "ctw-absolute ctw-right-3 ctw-top-1/2 ctw-h-4 ctw-w-4 ctw--translate-y-1/2 ctw-transform ctw-fill-content-lighter" }),
      e && /* @__PURE__ */ i.jsx("div", { className: "ctw-pointer-events-none ctw-absolute ctw-right-0 ctw-top-2 ctw-pr-4", children: /* @__PURE__ */ i.jsx(
        cs,
        {
          className: "ctw-h-5 ctw-w-5 ctw-text-error-main",
          "aria-hidden": "true"
        }
      ) })
    ] }),
    e && /* @__PURE__ */ i.jsx("div", { className: "ctw-text-xs ctw-italic ctw-text-error-text", children: e.length > 1 ? e.map((f) => /* @__PURE__ */ i.jsxs("div", { children: [
      "• ",
      f
    ] }, f)) : e[0] })
  ] });
}, EH = ({
  label: e,
  required: t,
  name: n
}) => /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-items-center ctw-justify-between", children: [
  /* @__PURE__ */ i.jsx("label", { htmlFor: n, className: "ctw-capitalize", children: e }),
  !t && /* @__PURE__ */ i.jsx("span", { className: "ctw-right-0 ctw-inline-block ctw-text-xs ctw-text-content-light", children: "Optional" }),
  t && /* @__PURE__ */ i.jsx(i.Fragment, { children: /* @__PURE__ */ i.jsx("div", { className: "ctw-flex-grow ctw-text-icon-default", children: "*" }) })
] }), Nl = (o) => {
  var c = o, {
    title: e,
    header: t,
    data: n = [],
    schema: r,
    action: s
  } = c, a = ct(c, [
    "title",
    "header",
    "data",
    "schema",
    "action"
  ]);
  const l = _0(r);
  return /* @__PURE__ */ i.jsx(AH, X(R({ title: e, action: s, schema: r }, a), { children: (d, u) => /* @__PURE__ */ i.jsxs("div", { className: "ctw-space-y-4", children: [
    t,
    /* @__PURE__ */ i.jsx("div", { className: "ctw-space-y-6", children: n.map((h) => {
      if (Ft(h))
        return /* @__PURE__ */ i.jsx(
          IH,
          {
            recordList: h,
            errors: u,
            submitting: d,
            schema: r
          },
          h[0].label
        );
      const { label: f, field: p, value: m, lines: C, readonly: y, hidden: g, render: w } = h;
      if (!p)
        return /* @__PURE__ */ i.jsx(To, { readonly: y, render: w, name: f }, f);
      const x = l(h, r);
      return g ? /* @__PURE__ */ gr(
        To,
        X(R({}, x), {
          key: f,
          lines: C,
          disabled: d,
          readonly: y,
          defaultValue: m,
          errors: u == null ? void 0 : u[p],
          hidden: g,
          render: w
        })
      ) : /* @__PURE__ */ i.jsx(
        R0,
        {
          entry: h,
          errors: u,
          props: x,
          submitting: d
        },
        h.label
      );
    }) })
  ] }) }));
}, IH = ({ recordList: e, errors: t, submitting: n, schema: r }) => {
  const s = _0(r);
  return /* @__PURE__ */ i.jsx("div", { className: "ctw-flex ctw-space-x-3", children: e.map((a) => /* @__PURE__ */ i.jsx(sn, { children: /* @__PURE__ */ i.jsx(
    R0,
    {
      entry: a,
      props: s(a, r),
      submitting: n,
      errors: t
    }
  ) }, a.label)) });
}, R0 = ({ entry: e, errors: t, props: n, submitting: r }) => {
  const { label: s, value: a, field: o, lines: c, readonly: l, hidden: d, render: u } = e, h = t == null ? void 0 : t[o];
  return /* @__PURE__ */ i.jsxs(
    "div",
    {
      className: W({
        "ctw-flex ctw-grow ctw-basis-0 ctw-flex-col ctw-space-y-1.5 ctw-text-sm ctw-font-medium ctw-text-content-black": !d
      }),
      children: [
        !d && /* @__PURE__ */ i.jsx(EH, { label: s, name: n.name, required: n["aria-required"] }),
        /* @__PURE__ */ gr(
          To,
          X(R({}, n), {
            key: s,
            lines: c,
            disabled: r,
            readonly: l,
            defaultValue: a,
            errors: h,
            hidden: d,
            render: u,
            "data-zus-telemetry-focus": s
          })
        )
      ]
    },
    s
  );
}, _H = (e, t) => V(void 0, null, function* () {
  const n = `${Pa(
    e.env
    // If patientID is empty, just pass any non-identifying string in url.
  )}/patient-history/jobs`, r = {
    data: {
      type: "patient-history/jobs",
      attributes: {
        requestConsent: !0,
        practitioner: {
          npi: t.npi,
          name: t.name,
          role: t.role.toLocaleLowerCase()
        }
      },
      relationships: {
        patient: {
          data: { type: "fhir/Patient", id: t.id }
        }
      }
    }
  };
  try {
    const { data: s } = yield rt(n, {
      method: "POST",
      headers: R({
        Authorization: `Bearer ${e.authToken}`
      }, e.contextBuilderId && {
        "Zus-Account": e.contextBuilderId
      }),
      body: JSON.stringify(r)
    });
    return yield s;
  } catch (s) {
    const a = s, o = "Error requesting patient history.";
    return $e.logError(a, o), new Error(a.message);
  }
}), TH = ({
  patient: e,
  header: t,
  isOpen: n,
  onClose: r,
  setClinicalHistoryExists: s
}) => {
  const a = (o, c) => V(void 0, null, function* () {
    const l = yield c(), d = yield _H(l, o);
    if ("errors" in d) {
      const u = [
        d.errors.map((h) => h.details)
      ];
      return new Error(u.join(", "));
    }
    return yield In.invalidateQueries([Pg]), s(!0), d;
  });
  return /* @__PURE__ */ i.jsx(
    Nl,
    {
      header: t,
      title: "Request Records",
      errorHeader: "Unable to request records",
      action: a,
      data: xH(e, !1),
      schema: E0,
      isOpen: n,
      onClose: r
    }
  );
};
function Ns() {
  var s;
  const { openDrawer: e } = Vn(), { getPatient: t } = dB(), { getRequestContext: n } = Xe(), r = P0();
  return {
    openHistoryRequestDrawer: () => V(this, null, function* () {
      let a;
      try {
        const o = yield n();
        a = yield t(o);
      } catch (o) {
        a = void 0;
      }
      e({
        component: (o) => /* @__PURE__ */ i.jsx(
          TH,
          R({
            setClinicalHistoryExists: () => {
            },
            header: /* @__PURE__ */ i.jsx("div", { className: "ctw-pt-0 ctw-text-base", children: "Request records from outside provider networks. To enable automatic updates, reach out to your admin." }),
            patient: a
          }, o)
        ),
        trackingMetadata: { action: "patient_history" }
      });
    }),
    isLoading: r.isLoading,
    isError: r.isError,
    details: (s = r.data) != null ? s : {}
  };
}
function M0(o) {
  return V(this, arguments, function* ({
    requestContext: e,
    count: t = 50,
    offset: n = 0,
    patientId: r,
    status: s,
    excludeFutureJobs: a
  }) {
    const c = new URL(`${Kt(e.env, "patient-history")}/jobs?`), l = bm(
      R({
        "page[count]": String(t),
        "page[offset]": String(n * t),
        "filter[builder-id]": e.contextBuilderId ? `${e.contextBuilderId}` : "",
        "filter[patient-id]": r ? `${r}` : "",
        "filter[status]": s ? `${s}` : ""
      }, !!a && { "filter[targetDate][until]": Qt(Date.now(), "yyyy-MM-dd") }),
      (f) => !f
    ), d = new URLSearchParams([...Object.entries(l)]).toString(), u = new URL(`${c}${decodeURIComponent(d)}`), { data: h } = yield rt(u.href, {
      headers: R({
        Authorization: `Bearer ${e.authToken}`
      }, e.contextBuilderId && {
        "Zus-Account": e.contextBuilderId
      })
    });
    return h;
  });
}
function RH(e, t) {
  return V(this, null, function* () {
    const n = {}, r = t.map(
      (c) => V(this, [c], function* ({ id: o }) {
        return (
          // iterate over each patient and get the patient history details
          M0({
            requestContext: e,
            patientId: o
          })
        );
      })
    );
    return (yield Promise.all(r)).flatMap((o) => o.data).forEach((o) => {
      var l;
      const c = new Date(
        (l = o.attributes.targetDate) != null ? l : Number(o.attributes.lastUpdatedAt) * 1e3
      );
      switch (o.attributes.jobStatus) {
        case "queued":
        case "scheduled": {
          (!n.nextScheduledAt || c < n.nextScheduledAt) && (n.nextScheduledAt = c);
          break;
        }
        case "done":
        case "error": {
          (!n.latestCompleted || c > n.latestCompleted.targetDate) && (n.latestCompleted = {
            job: o,
            targetDate: c
          });
          break;
        }
        case "in_progress": {
          (!n.latestInProgress || c > n.latestInProgress.targetDate) && (n.latestInProgress = {
            job: o,
            targetDate: c
          });
          break;
        }
      }
    }), n;
  });
}
function P0() {
  var n;
  const e = Zg(), t = (n = e.data) == null ? void 0 : n.map((r) => r.id);
  return Oe(
    Pg,
    [t],
    (r, s) => V(this, null, function* () {
      var a;
      return RH(r, (a = e.data) != null ? a : [s]);
    }),
    !!e.data
  );
}
const qi = [
  "done",
  "skipped"
], Bf = [
  "error",
  "done_with_info"
];
class Dl {
  constructor(t, n) {
    ne(this, "kind", "PatientHistory");
    this.patient = t, this.historyInfo = n;
  }
  get key() {
    return this.historyInfo.id;
  }
  get providers() {
    return this.historyInfo.attributes.providers;
  }
  get targetDate() {
    var t;
    return kr(
      (t = this.historyInfo.attributes.targetDate) != null ? t : Number(this.historyInfo.attributes.lastUpdatedAt) * 1e3
    );
  }
  get createdAt() {
    return Qt(new Date(Number(this.historyInfo.attributes.createdAt) * 1e3), "M/d/yy h:mm a");
  }
  get lastUpdatedAt() {
    return Qt(
      new Date(Number(this.historyInfo.attributes.lastUpdatedAt) * 1e3),
      "M/d/yy h:mm a"
    );
  }
  static getDerivedProviderStatus(t) {
    const n = t.map((r) => r.status);
    return n.every((r) => qi.includes(r)) ? "complete" : n.every((r) => Bf.includes(r)) ? "failed" : n.every((r) => [...qi, ...Bf].includes(r)) ? "completeWithErrors" : n.some((r) => qi.includes(r)) ? "partiallyComplete" : "inProgress";
  }
}
function O0() {
  var r;
  const { isLoading: e, data: t = {} } = P0(), { patient: n } = Ze();
  return ke(() => {
    var d;
    const { latestCompleted: s, latestInProgress: a, nextScheduledAt: o } = t, c = !!s || !!a || !!o, { jobStatus: l } = (s == null ? void 0 : s.job.attributes) || {};
    return (d = n.data) != null && d.isTestPatient && !c ? {
      jobStatus: l,
      isLoading: !1,
      derivedStatus: "complete",
      lastCompletedDate: /* @__PURE__ */ new Date()
    } : s != null && s.job.attributes.jobStatus ? {
      jobStatus: l,
      isLoading: !1,
      derivedStatus: Dl.getDerivedProviderStatus(
        s.job.attributes.providers
      ),
      lastCompletedDate: s.targetDate
    } : {
      jobStatus: l,
      isLoading: n.isLoading || e,
      derivedStatus: void 0,
      lastCompletedDate: void 0
    };
  }, [t, e, (r = n.data) == null ? void 0 : r.isTestPatient, n.isLoading]);
}
function MH() {
  const { openModal: e } = Mc();
  return () => {
    e({
      component: (t) => /* @__PURE__ */ i.jsx(PH, R({}, t))
    });
  };
}
const PH = (n) => {
  var r = n, { onClose: e } = r, t = ct(r, ["onClose"]);
  const { openHistoryRequestDrawer: s } = Ns(), { isLoading: a, lastCompletedDate: o } = O0();
  let c = /* @__PURE__ */ i.jsxs("div", { children: [
    "Loading ",
    /* @__PURE__ */ i.jsx(an, {})
  ] });
  return a || (o ? c = /* @__PURE__ */ i.jsxs("span", { children: [
    "Records last updated ",
    kr(o.toISOString())
  ] }) : c = /* @__PURE__ */ i.jsx("span", { children: "Records never requested" })), /* @__PURE__ */ i.jsx(hl, X(R({}, t), { onClose: e, showCloseIcon: !0, children: /* @__PURE__ */ i.jsxs("div", { className: "ctw-w-[372px] ctw-space-y-6", children: [
    /* @__PURE__ */ i.jsxs("div", { className: "ctw-space-y-2", children: [
      /* @__PURE__ */ i.jsx("div", { className: "ctw-font-medium", children: c }),
      /* @__PURE__ */ i.jsx("div", { className: "ctw-text-sm", children: "Patient records are automatically updated when Zus thinks new information is available. If you feel that something is missing please let us know." })
    ] }),
    /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-justify-between", children: [
      /* @__PURE__ */ i.jsx(
        "button",
        {
          type: "button",
          onClick: () => {
            e();
          },
          className: "ctw-link",
          children: "Cancel"
        }
      ),
      /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-space-x-3", children: [
        /* @__PURE__ */ i.jsx(
          "button",
          {
            type: "button",
            onClick: () => {
              e(), s();
            },
            className: "ctw-btn-default !ctw-normal-case",
            children: "Request records"
          }
        ),
        /* @__PURE__ */ i.jsx(
          ol,
          {
            buttonText: "Report an issue",
            className: "ctw-btn-primary !ctw-normal-case"
          }
        )
      ] })
    ] })
  ] }) }));
}, OH = {
  id: "demo",
  description: "Demo Package",
  name: "Demo Package",
  meta: {
    freshmakerProviders: ["commonwell", "surescripts"],
    initialProviders: ["commonwell", "surescripts"],
    recurringProvidersWithInterval: [
      {
        intervalDays: 28,
        provider: "commonwell"
      }
    ],
    subscriptionProviders: ["bamboo", "collective", "quest", "surescripts"]
  },
  hasIntelligentRefresh: !1,
  hasRecurringInterval: !0,
  requiresManualRequests: !1
};
function kH(e, t, n) {
  return V(this, null, function* () {
    try {
      const r = new URLSearchParams({
        "filter[patient-id]": t.join(",")
      });
      return n && r.append("filter[status]", n), (yield rt(
        `${Kt(
          e.env,
          "zap-data-subscriptions"
        )}/enrollment-statuses?${r}`,
        {
          headers: {
            Authorization: `Bearer ${e.authToken}`,
            "Content-Type": "application/json"
          }
        }
      )).data;
    } catch (r) {
      throw CH("Failed fetching patient subscription", r);
    }
  });
}
function LH(e, t) {
  return V(this, null, function* () {
    return (yield rt(
      `${Kt(e.env, "zap-data-subscriptions")}/packages/${t}`,
      {
        headers: {
          Authorization: `Bearer ${e.authToken}`
        }
      }
    )).data;
  });
}
function Sl() {
  const e = Zg();
  return Oe(
    sF,
    [e.data],
    (t, n) => V(this, null, function* () {
      var p;
      const r = {
        patientId: n.id
      }, { data: s, errors: a } = yield kH(
        t,
        ((p = e.data) != null ? p : [n]).map(({ id: m }) => m),
        "active"
      );
      if ((s == null ? void 0 : s.length) === 0 || a)
        return n.isTestPatient && (r.package = OH), r;
      const c = yn(
        s,
        "attributes.createdAt",
        "desc",
        !0
      )[0].relationships.package.data.id, l = yield LH(t, c), { intelligentRefreshProviders: d, recurringProvidersWithInterval: u } = l.data.attributes.meta, h = d ? d.length > 0 : !1, f = u ? u.length > 0 : !1;
      return r.package = {
        id: c,
        description: l.data.attributes.description,
        name: l.data.attributes.name,
        meta: l.data.attributes.meta,
        hasIntelligentRefresh: h,
        hasRecurringInterval: f,
        requiresManualRequests: FH({
          packageId: c,
          hasIntelligentRefresh: h,
          hasRecurringInterval: f
        })
      }, r;
    }),
    !!e.data
  );
}
function FH(e) {
  return !e.packageId || !e.hasIntelligentRefresh && !e.hasRecurringInterval;
}
const k0 = ({
  className: e,
  displayText: t = "Request records",
  skipModal: n = !1
}) => {
  const r = MH(), { openHistoryRequestDrawer: s } = Ns(), a = Sl(), { trackInteraction: o } = Be();
  return /* @__PURE__ */ i.jsx(
    "button",
    {
      type: "button",
      className: W("ctw-btn-clear ctw-link ctw-text-sm !ctw-leading-5", e),
      onClick: () => {
        var c, l;
        n || (l = (c = a.data) == null ? void 0 : c.package) != null && l.requiresManualRequests ? s() : r(), o("request_records");
      },
      children: t
    }
  );
}, BH = (e) => {
  switch (e) {
    case "production":
      return {
        url: "https://unleash-proxy-prod.zusapi.com/proxy",
        clientKey: "MDE0NDU5NTQtNEIyNC00RUVGLUI4NDUtRTE3QjYyMUQ3NTAzCg=="
      };
    case "phitest":
    case "sandbox":
      return {
        url: "https://unleash-proxy.zusapi.com/proxy",
        clientKey: "Q0QwNUIxODgtQkFEMC00MTA2LUIwRDEtRDgwQ0FFRDBBMzBCCg=="
      };
    case "dev":
    default:
      return {
        url: "https://unleash-proxy-dev.zusapi.com/proxy",
        clientKey: "NTk3QkM3RTItMTU4Qi00NDYwLTlFQjQtNjMyQ0ZFMENBNkY1Cg=="
      };
  }
}, UH = (e) => {
  const t = mn(e), n = window.location.hostname.replace("localhost", "local");
  return {
    userId: t["https://zusapi.com/user_id"],
    properties: {
      builderId: t["https://zusapi.com/builder_id"],
      builderName: t["https://zusapi.com/builder_name"],
      userType: t["https://zusapi.com/user_type"],
      email: t["https://zusapi.com/email"],
      hostname: n
    }
  };
}, L0 = Ct({});
function zH({ env: e, children: t }) {
  const n = ke(
    () => new Dv(X(R({}, BH(e)), {
      refreshInterval: 15,
      // (in seconds)
      appName: "ctw-component-library",
      context: {}
    })),
    [e]
  );
  return /* @__PURE__ */ i.jsx(Sv, { unleashClient: n, startClient: !1, children: /* @__PURE__ */ i.jsx(HH, { unleashClient: n, children: t }) });
}
const HH = ({
  unleashClient: e,
  children: t
}) => {
  const n = $v(), r = Pc(), [s, a] = Y(), [o, c] = Y(), [l, d] = Y(!1), [u, h] = Y();
  return he(() => {
    (function() {
      return V(this, null, function* () {
        a(yield r());
      });
    })();
  }, [r]), he(() => {
    s && !o && function() {
      return V(this, null, function* () {
        e.on("ready", () => {
          d(!0), h(
            Object.fromEntries(
              e.getAllToggles().map((p) => [p.name, p.enabled])
            )
          );
        }), yield n(UH(s)), c(!0), yield e.start();
      });
    }();
  }, [
    s,
    e,
    o,
    l,
    u,
    n
  ]), u === void 0 ? /* @__PURE__ */ i.jsx(Je, {}) : /* @__PURE__ */ i.jsx(L0.Provider, { value: u, children: t });
};
function Gt(e) {
  return tt(L0)[e] || !1;
}
const xt = (e) => {
  var d;
  const t = Ns(), { patient: n } = Ze(), r = Gt("ctw-patient-history-form");
  if (n.isLoading || t.isLoading)
    return /* @__PURE__ */ i.jsx(gl, {});
  const s = !!((d = n.data) != null && d.isTestPatient), { latestInProgress: a, latestCompleted: o, nextScheduledAt: c } = t.details, l = !!o || !!a;
  return a && !o ? /* @__PURE__ */ i.jsxs("div", { className: "ctw-space-y-3", children: [
    /* @__PURE__ */ i.jsxs("div", { className: "ctw-space-y-6", children: [
      /* @__PURE__ */ i.jsx("div", { className: "ctw-flex ctw-justify-center", children: /* @__PURE__ */ i.jsx(an, { className: "ctw-h-12 ctw-w-12 ctw-text-icon-light" }) }),
      /* @__PURE__ */ i.jsx("div", { className: "ctw-text-center ctw-text-xl ctw-font-medium", children: "Retrieving records now" })
    ] }),
    /* @__PURE__ */ i.jsx("div", { className: "ctw-text-center ctw-text-base ctw-font-normal", children: "Please re-load the ZAP in a few minutes." })
  ] }) : s && !l ? /* @__PURE__ */ i.jsx("div", { className: "ctw-text-center ctw-text-xl ctw-font-medium", children: "This is a test patient with no records requested." }) : l ? /* @__PURE__ */ i.jsx(WH, R({}, e)) : /* @__PURE__ */ i.jsxs("div", { className: "ctw-space-y-3", children: [
    /* @__PURE__ */ i.jsxs("div", { className: "ctw-space-y-6", children: [
      /* @__PURE__ */ i.jsx("div", { className: "ctw-flex ctw-justify-center", children: /* @__PURE__ */ i.jsx(A0, { className: "ctw-h-16 ctw-text-icon-light" }) }),
      /* @__PURE__ */ i.jsx("div", { className: "ctw-text-center ctw-text-xl ctw-font-medium", children: c ? `Next scheduled request ${kr(c.toISOString())}` : "Records not requested yet" })
    ] }),
    r && /* @__PURE__ */ i.jsx("div", { className: "ctw-flex ctw-justify-center", children: /* @__PURE__ */ i.jsx(k0, { displayText: "Request records now", skipModal: !0 }) })
  ] });
};
function WH({ resourceName: e, hasZeroFilteredRecords: t }) {
  let n = Mw, r = `No ${e}`, s = "We didn't find any records for this patient.";
  const { trackInteraction: a } = Be();
  return a("empty_table"), t && (n = Pw, r = `No matching ${e} found`, s = "Try changing the filters."), /* @__PURE__ */ i.jsxs("div", { className: "ctw-space-y-3", children: [
    /* @__PURE__ */ i.jsxs("div", { className: "ctw-space-y-6", children: [
      /* @__PURE__ */ i.jsx("div", { className: "ctw-flex ctw-justify-center", children: /* @__PURE__ */ i.jsx(me, { icon: n, className: "ctw-h-16 ctw-text-icon-light" }) }),
      /* @__PURE__ */ i.jsx("div", { className: "ctw-text-center ctw-text-xl ctw-font-medium", children: r })
    ] }),
    /* @__PURE__ */ i.jsx("div", { className: "ctw-text-center ctw-text-base ctw-font-normal", children: s })
  ] });
}
function ft({
  children: e,
  componentName: t
}) {
  const n = ke(
    () => ({
      componentName: t
    }),
    [t]
  );
  return /* @__PURE__ */ i.jsx(Fm.Provider, { value: n, children: e });
}
const VH = (e, t) => {
  const n = yn(e, "recordedDate", "desc", !0), r = nt(n, (s) => s.ownedByBuilder(t), "desc");
  return $c(r, "lowercaseDisplay");
};
function $l(e = !0) {
  return Oe(
    Z9,
    [],
    qH,
    e
  );
}
function qH(e, t) {
  return V(this, null, function* () {
    const n = Re(e), { data: r } = yield dt(n, ul, {
      upid: t.UPID,
      cursor: "",
      first: 1e3,
      sort: {
        lastUpdated: "DESC"
      },
      filter: {
        tag: { nonematch: [yt] }
      }
    }), s = r.AllergyIntoleranceConnection.edges.map(
      (o) => new Og(o.node, void 0, o.node.BasicList)
    );
    return VH(s, e.builderId);
  });
}
function F0(e, t, n) {
  return V(this, null, function* () {
    const r = Re(e), { data: s } = yield dt(r, ul, {
      upid: t.UPID,
      cursor: "",
      first: 500,
      filter: {
        ids: { anymatch: n },
        tag: { nonematch: [yt] }
      },
      sort: {}
    });
    return s.AllergyIntoleranceConnection.edges.map((a) => new Og(a.node));
  });
}
const GH = (e, t) => {
  var s;
  if (!t)
    return e;
  const n = t.filter((a) => typeof a != "function"), r = (s = Ue(n, { key: "showHidden" })) == null ? void 0 : s.selected;
  return e.filter((a) => {
    const o = !!a.isHidden;
    return r || !o;
  });
}, Uf = (e, t) => {
  if (!t)
    return e;
  const n = t.filter((a) => typeof a == "function"), r = t.filter((a) => typeof a != "function");
  return n.reduce((a, o) => o(a), e).filter(
    (a) => Object.entries(r).every(([o, c]) => {
      const l = String(a[c.key]);
      switch (c.type) {
        case "checkbox":
          if (Ft(c.selected))
            return c.predicate ? c.selected.length === 0 ? !0 : c.predicate(c.selected, a) : c.selected.filter(
              (u) => Ee(ht(e.map((h) => h[c.key]))).includes(
                u
              )
            ).includes(l);
          break;
        case "select":
          return l === c.selected;
        case "tag":
          if (c.predicate)
            return c.predicate(c.selected, a);
          break;
      }
      return !0;
    })
  );
};
function Ro(e, t) {
  return Ee(ht(e.map((n) => String(n[t]))));
}
function YH(e, t) {
  !e || typeof window == "undefined" || localStorage.setItem(e, JSON.stringify(t));
}
function QH(e, t) {
  if (!e || typeof window == "undefined")
    return t;
  const n = localStorage.getItem(e);
  if (!n)
    return t;
  try {
    const r = JSON.parse(n);
    return R(R({}, t), r);
  } catch (r) {
    return t;
  }
}
function Rt({
  cacheKey: e,
  filterPredicates: t,
  defaultFilters: n,
  defaultSort: r,
  defaultView: s,
  viewOptions: a,
  records: o
}) {
  const { defaultView: c, defaultSort: l, defaultFilters: d } = ke(
    () => ZH(r, e, s, n),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  ), [u, h] = Y(c), [f, p] = Y(d != null ? d : {}), [m, C] = Y(l), [y, g] = Y(o != null ? o : []);
  function w(N) {
    h(N.display), Gi(e, N.display, m, f);
  }
  function x(N) {
    JH(N, t), p(N), Gi(e, u, m, N);
  }
  function S(N) {
    C(N), Gi(e, u, N, f);
  }
  return he(() => {
    var D;
    const N = KH(f, t);
    let v = GH(o != null ? o : [], N);
    v = Uf(v, N);
    const b = a == null ? void 0 : a.find(($) => $.display === u);
    v = Uf(v, (D = b == null ? void 0 : b.filters) != null ? D : []);
    const j = Va(v, m.sorts);
    g(j);
  }, [f, m, o, u]), {
    setFilters: x,
    setSort: S,
    defaultSort: l,
    viewOption: u,
    setViewOption: w,
    defaultView: c,
    data: y,
    filters: f,
    sortOption: m
  };
}
function ZH(e, t, n, r) {
  return QH(t, { defaultView: n, defaultSort: e, defaultFilters: r });
}
function Gi(e, t, n, r) {
  YH(e, { defaultView: t, defaultSort: n, defaultFilters: r });
}
function KH(e, t) {
  const n = Ee(Object.values(e != null ? e : {}));
  return e && n.forEach((r) => {
    (r.type === "checkbox" || r.type === "tag") && (t != null && t[r.key]) && (r.predicate = t[r.key]);
  }), n;
}
function JH(e, t) {
  const r = Ee(Object.values(e)).filter((s) => (s.type === "checkbox" || s.type === "tag") && s.predicate).filter((s) => !(t != null && t[s.key]));
  if (r.length > 0)
    throw new Error(
      `Missing predicate map for filters: ${r.map((s) => s.key).join(",")}`
    );
}
const Al = (e) => /* @__PURE__ */ i.jsx(pl, { getHistory: IU, model: e });
function XH({ className: e }) {
  var h;
  const t = $l(), { data: n, filters: r, setFilters: s, setSort: a, defaultSort: o } = Rt({
    cacheKey: "patient-allergies",
    defaultSort: l0,
    records: t.data
  }), c = ut(), d = !(((h = t.data) == null ? void 0 : h.length) === 0) && n.length === 0, u = _t({
    header: (f) => qe(f.display),
    details: El,
    renderChild: Al,
    getSourceDocument: !0,
    enableDismissAndReadActions: !0
  });
  return /* @__PURE__ */ i.jsx(ft, { componentName: "PatientAllergies", children: /* @__PURE__ */ i.jsxs("div", { className: W(e, "ctw-scrollable-pass-through-height"), children: [
    /* @__PURE__ */ i.jsx(
      Ht,
      {
        filterOptions: {
          onChange: s,
          filters: wU(),
          selected: r
        },
        sortOptions: {
          defaultSort: o,
          options: MU,
          onChange: a
        }
      }
    ),
    /* @__PURE__ */ i.jsx(
      Tt,
      {
        showTableHead: !0,
        isLoading: t.isLoading,
        data: n,
        columns: mH(c),
        onRowClick: u,
        enableDismissAndReadActions: !0,
        emptyMessage: /* @__PURE__ */ i.jsx(
          xt,
          {
            hasZeroFilteredRecords: d,
            resourceName: "allergies"
          }
        )
      }
    )
  ] }) });
}
const eW = He(XH, "PatientAllergies"), El = (e) => [
  { label: "Recorded Date", value: e.recordedDate },
  { label: "Recording Organization", value: e.patientOrganizationName },
  { label: "Status", value: e.clinicalStatus },
  { label: "Type", value: qe(e.type) },
  { label: "Onset", value: e.onset },
  { label: "Reaction", value: qe(e.manifestations) },
  { label: "Severity", value: qe(e.severity) },
  { label: "Note", value: e.note }
], Za = ({
  className: e = "ctw-fill-notification-icon",
  text: t
}) => t ? /* @__PURE__ */ i.jsx(kt, { content: t, className: e, color: "notification" }) : /* @__PURE__ */ i.jsx("svg", { height: 10, className: e, viewBox: "0 0 10 10", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ i.jsx("circle", { cx: "5", cy: "5", r: "5" }) }), Wr = ({ className: e, data: t }) => {
  var s;
  const n = ut();
  return ((s = t == null ? void 0 : t.filter(
    (a) => !a.isDismissed && !a.isRead && !a.ownedByBuilder(n)
  )) != null ? s : []).length > 0 ? /* @__PURE__ */ i.jsx(Za, { className: e }) : null;
}, oK = ({ className: e }) => {
  const t = $l();
  return /* @__PURE__ */ i.jsx(Wr, { className: e, data: t.data });
}, tW = [
  {
    widthPercent: 30,
    minWidth: 150,
    title: "Provider",
    render: (e) => /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
      /* @__PURE__ */ i.jsx("div", { children: e.practitionerName }),
      /* @__PURE__ */ i.jsx("div", { children: e.managingOrganization })
    ] })
  },
  {
    widthPercent: 20,
    minWidth: 150,
    title: "Role",
    render: (e) => /* @__PURE__ */ i.jsx("div", { children: e.role })
  },
  {
    widthPercent: 30,
    minWidth: 150,
    title: "Specialty",
    render: (e) => /* @__PURE__ */ i.jsx("div", { children: e.specialty })
  },
  {
    widthPercent: 20,
    minWidth: 150,
    title: "Last Updated",
    render: (e) => /* @__PURE__ */ i.jsx("div", { children: e.effectiveStartDate })
  }
], B0 = [
  {
    display: "Provider (A-Z)",
    sorts: [{ key: "practitionerName", dir: "asc" }]
  },
  {
    display: "Provider (Z-A)",
    sorts: [{ key: "practitionerName", dir: "desc" }]
  },
  {
    display: "Last Updated (Old to New)",
    sorts: [
      { key: "effectiveStartDate", dir: "asc", isDate: !0 },
      { key: "practitionerName", dir: "asc" }
    ]
  },
  {
    display: "Last Updated (New To Old)",
    sorts: [
      { key: "effectiveStartDate", dir: "desc", isDate: !0 },
      { key: "practitionerName", dir: "asc" }
    ]
  }
], nW = B0[3];
function es(e, t, n) {
  return (r) => r.filter((s) => Il(s, e, t, n));
}
function Il(e, t, n, r) {
  return r && !e[t] || cv(/* @__PURE__ */ new Date(), new Date(String(e[t]))) <= n;
}
function _n(e, t = !0) {
  const n = [
    {
      display: "Past 7 days",
      filters: [es(e, 7, t)]
    },
    {
      display: "Past 30 days",
      filters: [es(e, 30, t)]
    },
    {
      display: "Past 3 months",
      filters: [es(e, 90, t)]
    },
    {
      display: "Past 6 months",
      filters: [es(e, 180, t)]
    },
    {
      display: "Past year",
      filters: [es(e, 365, t)]
    },
    {
      display: "All time",
      filters: []
    }
  ];
  return {
    viewOptions: n,
    past7days: n[0],
    past30days: n[1],
    past3months: n[2],
    past6Months: n[3],
    pastYear: n[4],
    allTime: n[5]
  };
}
class rW extends Qe {
  constructor() {
    super(...arguments);
    ne(this, "kind", "CareTeam");
  }
  get categoryDisplay() {
    return Ie(this.resource.category ? this.resource.category[0] : void 0);
  }
  get status() {
    return this.resource.status;
  }
  get periodStart() {
    var n;
    return ye((n = this.resource.period) == null ? void 0 : n.start);
  }
  get periodEnd() {
    var n;
    return (n = this.resource.period) == null ? void 0 : n.end;
  }
  get particpants() {
    return this.resource.participant;
  }
  get phone() {
    var r;
    const n = (r = this.resource.telecom) == null ? void 0 : r.find((s) => s.system === "phone");
    return La(n == null ? void 0 : n.value);
  }
  get managingOrganization() {
    var n, r;
    return (r = (n = Ue(this.resource.participant, "onBehalfOf")) == null ? void 0 : n.onBehalfOf) == null ? void 0 : r.display;
  }
  get role() {
    var n, r;
    return Ie((r = (n = this.resource.participant) == null ? void 0 : n[0].role) == null ? void 0 : r[0]);
  }
  get practitionerQualification() {
    var s, a, o;
    const n = (a = (s = this.resource.participant) == null ? void 0 : s[0]) == null ? void 0 : a.member, r = Pe(
      "Practitioner",
      this.resource.contained,
      this.includedResources,
      n
    );
    if (r)
      return Ie(
        (o = new Lr(r).resource.qualification) == null ? void 0 : o[0].code
      );
  }
  get title() {
    var n;
    return `${(n = this.managingOrganization) != null ? n : "Unknown"} - ${this.role}`;
  }
  getPractitionerByID(n) {
    return Pe(
      "Practitioner",
      this.resource.contained,
      this.includedResources,
      n
    );
  }
}
class sW extends Qe {
  constructor(n, r) {
    super(r);
    ne(this, "kind", "CareTeamPractitioner");
    ne(this, "careTeam");
    this.careTeam = n;
  }
  get key() {
    return `${this.careTeam.id}_${this.id}`;
  }
  get practitionerName() {
    return new Lr(this.resource).fullName;
  }
  get effectiveStartDate() {
    return this.careTeam.periodStart;
  }
  get managingOrganization() {
    return this.careTeam.managingOrganization;
  }
  get role() {
    return this.careTeam.role;
  }
  get specialty() {
    return this.careTeam.practitionerQualification;
  }
  get status() {
    return this.careTeam.status;
  }
  get title() {
    return this.practitionerName;
  }
}
const aW = Ae`
  ${Xt}
  ${Ha}
  query CareTeams($upid: ID!, $cursor: String!, $sort: CareTeamSortParams!, $first: Int!) {
    CareTeamConnection(upid: $upid, after: $cursor, sort: $sort, first: $first) {
      pageInfo {
        hasNextPage
      }
      edges {
        node {
          id
          resourceType
          meta {
            extension {
              url
              valueInstant
            }
            tag {
              system
              code
            }
            versionId
          }
          extension {
            url
            valueString
          }
          status
          category {
            text
            coding {
              ...Coding
            }
          }
          name
          period {
            start
            end
          }
          participant {
            role {
              text
              coding {
                ...Coding
              }
            }
            member {
              reference
              resource {
                ...Practitioner
              }
            }
            onBehalfOf {
              reference
            }
          }
          reasonCode {
            text
            coding {
              ...Coding
            }
          }
          telecom {
            system
            value
            use
            period {
              start
              end
            }
          }
          note {
            text
          }
        }
      }
    }
  }
`;
function iW() {
  return Oe(B9, [], oW);
}
function oW(e, t) {
  return V(this, null, function* () {
    const n = Re(e), { data: r } = yield dt(n, aW, {
      upid: t.UPID,
      cursor: "",
      first: 1e3,
      sort: {
        lastUpdated: "DESC"
      },
      filter: {
        tag: { nonematch: [yt] }
      }
    }), s = r.CareTeamConnection.edges.map((o) => o.node);
    return cW(s);
  });
}
const cW = (e) => {
  const t = e.map((a) => new rW(a)), n = [];
  t.forEach(
    (a) => {
      var o;
      return (o = a.resource.participant) == null ? void 0 : o.forEach((c) => {
        var d;
        const l = a.getPractitionerByID(c.member);
        l != null && l.id && ((d = c.member) != null && d.reference) && n.push(new sW(a, l));
      });
    }
  );
  const r = n.filter((a) => a.practitionerName), s = nt(
    r,
    ["effectiveStartDate", "id"],
    ["desc", "desc"]
  );
  return wn(
    s,
    (a, o) => bs(zf(a), zf(o))
  );
}, zf = (e) => [
  e.practitionerName.toLocaleUpperCase()
];
function lW({ className: e }) {
  const t = Te(null), n = iW(), { viewOptions: r, allTime: s } = _n("effectiveStartDate"), { data: a, setSort: o, setViewOption: c, defaultSort: l, defaultView: d } = Rt({
    cacheKey: "patient-careteam",
    defaultSort: nW,
    viewOptions: r,
    records: n.data,
    defaultView: s.display
  }), u = _t({
    header: (p) => p.practitionerName,
    details: dW
  }), f = !(n.data && n.data.length === 0) && a.length === 0;
  return /* @__PURE__ */ i.jsx(ft, { componentName: "PatientCareTeam", children: /* @__PURE__ */ i.jsxs("div", { ref: t, className: W(e, "ctw-scrollable-pass-through-height"), children: [
    /* @__PURE__ */ i.jsx(
      Ht,
      {
        sortOptions: {
          defaultSort: l,
          options: B0,
          onChange: o
        },
        viewOptions: {
          onChange: c,
          options: r,
          defaultView: d
        }
      }
    ),
    /* @__PURE__ */ i.jsx(
      Tt,
      {
        isLoading: n.isLoading,
        data: a,
        emptyMessage: /* @__PURE__ */ i.jsx(
          xt,
          {
            hasZeroFilteredRecords: f,
            resourceName: "documents"
          }
        ),
        columns: tW,
        onRowClick: u
      }
    )
  ] }) });
}
const dW = (e) => [
  { label: "Organization", value: e.managingOrganization },
  { label: "Care Team", value: e.careTeam.categoryDisplay },
  { label: "Phone", value: e.careTeam.phone },
  { label: "Role", value: e.role },
  { label: "Specialty", value: e.specialty },
  { label: "Member Since", value: e.effectiveStartDate }
], uW = {
  type: "dismiss-bulk",
  action: (e, t, n) => V(void 0, null, function* () {
    yield Promise.all(
      n.map((r) => V(void 0, null, function* () {
        var s;
        r.preferredCoding && ((s = e.patient.data) != null && s.id) && (yield f0(r, yield t()));
      }))
    );
  })
}, fW = {
  type: "add",
  action: (e, t, n) => V(void 0, null, function* () {
    yield Promise.all(n.map((r) => V(void 0, null, function* () {
      var a;
      if (!r.preferredCoding || !((a = e.patient.data) != null && a.id))
        return;
      const s = {
        status: r.displayStatus,
        type: r.type,
        condition: r.preferredCoding,
        abatement: r.abatement ? new Date(r.abatement) : void 0,
        onset: r.onset ? new Date(r.onset) : void 0,
        note: r.notes.join("")
      };
      yield Bg(
        r,
        e.patient.data.id,
        s,
        t
      );
    })));
  })
}, hW = (e, t) => [
  {
    title: "Condition",
    render: (n) => /* @__PURE__ */ i.jsx("div", { children: n.display }),
    widthPercent: 35
  },
  {
    title: "Onset Date",
    render: (n) => /* @__PURE__ */ i.jsx("div", { children: n.onset }),
    widthPercent: 18
  },
  {
    title: "Status",
    render: (n) => /* @__PURE__ */ i.jsx("div", { children: n.displayStatus }),
    widthPercent: 18
  },
  {
    title: "Type",
    render: (n) => /* @__PURE__ */ i.jsx("div", { children: n.type }),
    widthPercent: 18
  },
  {
    title: "",
    render: (n) => /* @__PURE__ */ i.jsxs(
      "button",
      {
        type: "button",
        disabled: e["conditions-all"].length === 1,
        className: W("ctw-link ctw-space-x-1 ctw-di", {
          "ctw-text-content-lighter hover:ctw-text-content-lighter": e["conditions-all"].length === 1
        }),
        onClick: () => {
          const r = X(R({}, e), {
            "conditions-all": e["conditions-all"].filter(
              (s) => s.id !== n.id
            )
          });
          t(r);
        },
        children: [
          /* @__PURE__ */ i.jsx("span", { children: /* @__PURE__ */ i.jsx(me, { icon: ya, className: "ctw-w-4" }) }),
          /* @__PURE__ */ i.jsx("span", { children: "Remove" })
        ]
      }
    ),
    widthPercent: 18
  }
], U0 = ({ notes: e }) => /* @__PURE__ */ i.jsx("div", { className: "ctw-flex ctw-flex-col ctw-space-y-4", children: e.map((t, n) => (
  // eslint-disable-next-line react/no-array-index-key
  /* @__PURE__ */ i.jsx("div", { children: /* @__PURE__ */ i.jsx("div", { children: t }) }, t + n)
)) });
function pW(e) {
  return c0({
    resourceType: "Condition",
    model: e,
    queryKey: z9,
    valuesToDedupeOn: wW,
    getFiltersFQS: mW,
    getHistoryEntry: gW
  });
}
function mW(e) {
  const t = e.knownCodings.map((n) => `${n.system}|${n.code}`);
  if (t.length > 0)
    return {
      code: { anymatch: t }
    };
}
function gW(e) {
  const t = [
    {
      label: "Recorder",
      value: e.recorder
    },
    {
      label: "Clinical Status",
      value: qe(e.clinicalStatus)
    },
    {
      label: "Verification Status",
      value: qe(e.verificationStatus)
    },
    {
      label: "Category",
      value: Dc(e.category)
    },
    {
      label: "Note",
      value: e.notes.length !== 0 && /* @__PURE__ */ i.jsx(U0, { notes: e.notes })
    },
    {
      label: "Recorded Code(s)",
      value: /* @__PURE__ */ i.jsx("div", { className: "ctw-space-y-1", children: e.knownCodings.map((n) => /* @__PURE__ */ i.jsx("div", { children: n.display }, `${n.system}-${n.code}`)) })
    },
    {
      label: "Onset Date",
      value: e.onset
    },
    {
      label: "Abatement Date",
      value: e.abatement
    },
    {
      label: "Encounter",
      value: e.encounter
    }
  ];
  return {
    id: e.id,
    date: e.recordedDate,
    versionId: e.versionId,
    title: e.patientOrganizationName,
    details: t
  };
}
const wW = (e) => [
  e.recorder,
  e.clinicalStatus,
  e.verificationStatus,
  e.recordedDate,
  e.notes,
  e.category,
  e.onset,
  e.abatement,
  e.encounter,
  e.knownCodings.map((t) => [t.system, t.code])
], Mo = ({ codings: e }) => /* @__PURE__ */ i.jsx("div", { className: "ctw-flex ctw-flex-col ctw-space-y-4", children: e.map((t, n) => (
  // eslint-disable-next-line react/no-array-index-key
  /* @__PURE__ */ i.jsxs("div", { className: "ctw-space-x-1", children: [
    /* @__PURE__ */ i.jsx("span", { className: "ctw-font-semibold", children: t.code }),
    /* @__PURE__ */ i.jsx("span", { children: t.display })
  ] }, `${t.system}-${t.code}-${n}`)
)) }), vW = (e) => /* @__PURE__ */ i.jsx(pl, { getHistory: pW, model: e }), Ka = ({
  rowActions: e,
  enableDismissAndReadActions: t,
  onOpen: n,
  onAfterClosed: r
}) => _t({
  header: (s) => s.display,
  subHeader: (s) => s.ccsChapter,
  getSourceDocument: !0,
  details: (s) => [
    { label: "Latest Diagnosis", value: s.recordedDate },
    { label: "Recorder", value: s.recorder },
    {
      label: "Provider Organization",
      value: s.patientOrganizationName
    },
    { label: "Onset Date", value: s.onset },
    { label: "Type", value: qe(s.type) },
    { label: "Status", value: qe(s.displayStatus) },
    { label: "Abatement Date", value: s.abatement },
    {
      label: "ICD-10",
      value: s.icd10CMEnrichments.length ? /* @__PURE__ */ i.jsx(Mo, { codings: s.icd10CMEnrichments }) : null
    },
    {
      label: "HCC",
      value: s.hccEnrichments.length ? /* @__PURE__ */ i.jsx(Mo, { codings: s.hccEnrichments }) : null
    },
    {
      label: "Note",
      value: s.notes.length !== 0 && /* @__PURE__ */ i.jsx(U0, { notes: s.notes })
    }
  ],
  rowActions: e,
  renderChild: vW,
  enableDismissAndReadActions: t,
  onOpen: n,
  onAfterClosed: r
});
function Hf(e) {
  return (t) => t.filter((n) => e.includes(n.displayStatus));
}
const Ls = [
  {
    display: "Current",
    filters: [Hf(["Active", "Pending", "Unknown"])]
  },
  {
    display: "Past",
    filters: [Hf(["Inactive", "Refuted"])]
  },
  {
    display: "All",
    filters: [(e) => e]
  }
], z0 = {
  viewOptions: Ls,
  current: Ls[0],
  past: Ls[1],
  all: Ls[2]
}, Ja = Ct({
  selectedResources: {
    "conditions-all": []
  },
  setSelectedResources: () => {
  }
});
function Wf({
  selectedKey: e,
  resourceName: t,
  onWritebackStart: n,
  onWritebackEnd: r,
  bulkAction: s,
  columns: a
}) {
  const { openModal: o } = Mc();
  return () => {
    o({
      component: (c) => /* @__PURE__ */ i.jsx(
        bW,
        R({
          selectedKey: e,
          resourceName: t,
          onWritebackStart: n,
          onWritebackEnd: r,
          bulkAction: s,
          columns: a
        }, c)
      )
    });
  };
}
const yW = ({
  selectedKey: e,
  resourceName: t,
  onWritebackStart: n,
  onWritebackEnd: r,
  bulkAdd: s,
  bulkDismiss: a,
  columns: o
}) => {
  const { selectedResources: c, setSelectedResources: l } = tt(Ja), [d, u] = Y(!1), h = c[e], f = (y, g) => {
    u(!0), n(y, g);
  }, p = (y, g, w, x) => {
    u(!1), r(y, g, w, x);
  }, m = Wf({
    selectedKey: e,
    resourceName: t,
    onWritebackStart: f,
    onWritebackEnd: p,
    bulkAction: {
      type: "add",
      action: (y, g, w) => s.action(y, g, w).catch((x) => {
        throw Bn({
          type: "error",
          title: "Error encountered adding to chart.",
          body: "Try again or add it manually. Dismiss it to no longer see it in this list."
        }), x;
      })
    },
    columns: o
  }), C = Wf({
    selectedKey: e,
    resourceName: t,
    onWritebackStart: f,
    onWritebackEnd: p,
    bulkAction: {
      type: "dismiss-bulk",
      action: (y, g, w) => a.action(y, g, w).catch((x) => {
        throw Bn({
          type: "error",
          title: "Error encountered dismissing.",
          body: "Try again or dismiss it manually to no longer see it in this list."
        }), x;
      })
    },
    columns: o
  });
  return /* @__PURE__ */ i.jsx(
    kn,
    {
      show: h.length > 0,
      enter: "ctw-ease-out ctw-duration-200",
      enterFrom: "ctw-opacity-0 ctw-max-h-0",
      enterTo: "ctw-opacity-100 ctw-max-h-40",
      leave: "ctw-ease-out ctw-duration-100",
      leaveFrom: "ctw-opacity-100 ctw-max-h-40",
      leaveTo: "ctw-opacity-0 ctw-max-h-0",
      children: /* @__PURE__ */ i.jsxs("div", { className: "ctw-w-full ctw-flex ctw-justify-between ctw-bg-primary-light ctw-p-5", children: [
        /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-space-x-2 ctw-items-center", children: [
          /* @__PURE__ */ i.jsxs("div", { className: "ctw-space-x-0.5 ctw-font-light", children: [
            /* @__PURE__ */ i.jsx("span", { className: "ctw-font-semibold", children: h.length }),
            " ",
            /* @__PURE__ */ i.jsxs("span", { className: "ctw-lowercase", children: [
              t,
              h.length > 1 && "s",
              " ",
              d ? "syncing" : "selected",
              " "
            ] })
          ] }),
          /* @__PURE__ */ i.jsx(
            "button",
            {
              onClick: () => {
                l({ [e]: [] });
              },
              type: "button",
              className: "ctw-btn-clear ctw-link",
              disabled: d,
              children: "Deselect All"
            }
          )
        ] }),
        /* @__PURE__ */ i.jsxs("div", { className: "ctw-space-x-2", children: [
          /* @__PURE__ */ i.jsx(
            "button",
            {
              type: "button",
              className: "ctw-btn-default",
              onClick: () => C(),
              disabled: d,
              children: "Dismiss"
            }
          ),
          /* @__PURE__ */ i.jsx(
            "button",
            {
              type: "button",
              className: "ctw-btn-primary",
              onClick: () => m(),
              disabled: d,
              children: "Add to Chart"
            }
          )
        ] })
      ] })
    }
  );
}, xW = {
  add: {
    title: "Add to Chart",
    bodyText: "The following data will be imported to the chart:",
    btnText: "Add to Chart"
  },
  "dismiss-bulk": {
    title: "Dismiss from Chart",
    bodyText: "The following data will be dismissed from the chart:",
    btnText: "Dismiss"
  }
}, bW = (l) => {
  var d = l, {
    selectedKey: e,
    resourceName: t,
    onClose: n,
    onWritebackStart: r,
    onWritebackEnd: s,
    bulkAction: a,
    columns: o
  } = d, c = ct(d, [
    "selectedKey",
    "resourceName",
    "onClose",
    "onWritebackStart",
    "onWritebackEnd",
    "bulkAction",
    "columns"
  ]);
  var y;
  const { selectedResources: u, setSelectedResources: h } = tt(Ja), f = u[e], p = Ze(), { getRequestContext: m } = Xe(), C = (y = xW[a.type]) != null ? y : {
    title: "",
    bodyText: "",
    btnText: "Confirm"
  };
  return /* @__PURE__ */ i.jsxs(hl, X(R({ className: "!ctw-w-full !ctw-max-w-3xl" }, c), { onClose: n, showCloseIcon: !0, children: [
    /* @__PURE__ */ i.jsxs("div", { className: "ctw-space-y-3", children: [
      /* @__PURE__ */ i.jsx("h1", { className: "ctw-space-y-6 ctw-text-2xl ctw-font-medium", children: C.title }),
      /* @__PURE__ */ i.jsx("div", { className: "ctw-space-y-6 ctw-text-lg", children: C.bodyText })
    ] }),
    /* @__PURE__ */ i.jsx("div", { children: /* @__PURE__ */ i.jsx(
      Tt,
      {
        columns: o,
        data: f,
        emptyMessage: /* @__PURE__ */ i.jsx(
          xt,
          {
            hasZeroFilteredRecords: f.length === 0,
            resourceName: t
          }
        ),
        isLoading: !1
      }
    ) }),
    /* @__PURE__ */ i.jsxs("div", { className: "ctw-space-x-2 ctw-text-right", children: [
      /* @__PURE__ */ i.jsx("button", { type: "button", className: "ctw-btn-default", onClick: () => n(), children: "Cancel" }),
      /* @__PURE__ */ i.jsx(
        "button",
        {
          type: "button",
          className: "ctw-btn-primary",
          onClick: () => {
            f.forEach((g) => {
              r(a.type, g.id);
            }), n(), a.action(p, m, f).finally(() => {
              h({ [e]: [] });
            }).then(() => {
              f.forEach((g) => {
                s(a.type, g.id, !1);
              });
            }).catch((g) => {
              f.forEach((w) => {
                s(
                  a.type,
                  w.id,
                  !0,
                  g instanceof Error ? g.message : String(g)
                );
              });
            });
          },
          children: C.btnText
        }
      )
    ] })
  ] }));
};
const Vf = 320, jW = "ctw-min-w-[320px]", Ds = ({
  children: e,
  className: t,
  footerIcon: n,
  footerOnClick: r,
  footerText: s,
  hideFooter: a,
  icon: o,
  isLoading: c,
  noShadow: l,
  title: d,
  tooltipText: u,
  titleClassName: h,
  titleSize: f,
  dataTestId: p
}) => /* @__PURE__ */ i.jsxs(H0, { noShadow: l, className: t, dataTestId: p, children: [
  /* @__PURE__ */ i.jsx(
    W0,
    {
      icon: o,
      title: d,
      className: h,
      tooltipText: u,
      titleSize: f
    }
  ),
  c ? /* @__PURE__ */ i.jsx(Vr, { message: /* @__PURE__ */ i.jsx(Je, {}) }) : /* @__PURE__ */ i.jsx(V0, { children: e }),
  s && !a && /* @__PURE__ */ i.jsx(q0, { text: s, onClick: r, icon: n })
] }), H0 = ({
  children: e,
  className: t,
  noShadow: n,
  dataTestId: r
}) => /* @__PURE__ */ i.jsx(
  "div",
  {
    "data-testid": r,
    className: W(
      t,
      jW,
      { "ctw-shadow": !n },
      "ctw-max-h-[360px] ctw-min-h-[175px] ctw-rounded-lg ctw-border ctw-border-solid ctw-border-divider-main ctw-flex-col ctw-divide-y ctw-divide-solid ctw-divide-divider-main ctw-flex"
    ),
    children: e
  }
), W0 = ({
  icon: e,
  title: t,
  tooltipText: n,
  className: r,
  titleSize: s = "base"
}) => /* @__PURE__ */ i.jsxs(
  "div",
  {
    className: W(
      "ctw-rounded-t-lg ctw-flex ctw-justify-between ctw-items-center ctw-w-full ctw-py-2.5 ctw-px-3 ctw-space-x-2",
      r
    ),
    children: [
      e && ($9(e) ? /* @__PURE__ */ i.jsx("div", { children: e }) : /* @__PURE__ */ i.jsx(me, { icon: e, className: "ctw-w-5 ctw-h-5 ctw-text-content-lighter" })),
      /* @__PURE__ */ i.jsx(
        "div",
        {
          "data-testid": "overview-card-header",
          className: W("ctw-font-medium ctw-flex-auto ctw-text-content-black -ctw-mb-0.5", {
            "ctw-text-sm": s === "sm",
            "ctw-text-base": s === "base"
          }),
          children: t
        }
      ),
      n && /* @__PURE__ */ i.jsx("div", { className: "ctw-self-start", children: /* @__PURE__ */ i.jsx(Sn, { content: n, children: /* @__PURE__ */ i.jsx(
        me,
        {
          icon: Ho,
          className: "ctw-w-4 ctw-h-4 ctw-text-content-lighter ctw-block"
        }
      ) }) })
    ]
  }
), V0 = ({ children: e }) => /* @__PURE__ */ i.jsx(
  "div",
  {
    "data-testid": "overview-card-body",
    className: "ctw-grow ctw-flex-col ctw-flex ctw-w-full ctw-py-0 ctw-overflow-y-auto ctw-text-sm ctw-scrollbar",
    children: e
  }
), Vr = ({ message: e }) => /* @__PURE__ */ i.jsx("div", { className: "ctw-grow ctw-flex ctw-text-center ctw-justify-center ctw-items-center ctw-py-2 ctw-px-3 ctw-text-sm", children: /* @__PURE__ */ i.jsx("div", { children: e }) }), q0 = ({
  text: e,
  onClick: t,
  icon: n
}) => t ? /* @__PURE__ */ i.jsxs("button", { type: "button", className: "ctw-overview-btn-footer ctw-group", onClick: t, children: [
  e,
  /* @__PURE__ */ i.jsx(
    me,
    {
      icon: n != null ? n : Ow,
      className: "ctw-text-content-lighter ctw-button-arrow ctw-w-5 ctw-h-5 ctw-opacity-0 group-hover:ctw-opacity-100"
    }
  )
] }) : /* @__PURE__ */ i.jsx("div", { className: "ctw-overview-footer", children: e }), Ss = (h) => {
  var f = h, {
    children: e,
    data: t = [],
    emptyMessage: n,
    onRowClick: r,
    onSeeAllResources: s,
    hideFooter: a,
    trackingName: o,
    rowClassName: c,
    RowActions: l,
    dataTestId: d
  } = f, u = ct(f, [
    "children",
    "data",
    "emptyMessage",
    "onRowClick",
    "onSeeAllResources",
    "hideFooter",
    "trackingName",
    "rowClassName",
    "RowActions",
    "dataTestId"
  ]);
  const { trackInteraction: p } = Be(), m = ut(), { toggleRead: C } = Hr(), y = a || !s;
  function g(w) {
    r && (!w.isRead && !w.ownedByBuilder(m) && C(w), r(w), p("click_row", { target: o }));
  }
  return /* @__PURE__ */ i.jsx(
    Ds,
    X(R({
      hideFooter: y,
      footerOnClick: () => {
        p("see_all_of_resource", { target: o }), s == null || s();
      }
    }, u), {
      dataTestId: d,
      children: t.length === 0 ? /* @__PURE__ */ i.jsx(Vr, { message: n }) : t.map((w) => /* @__PURE__ */ i.jsxs(
        "div",
        {
          "data-testid": "resource-overview-row",
          className: W(
            "ctw-resource-overview-row ctw-py-1.5 ctw-px-3 ctw-group ctw-relative ctw-grouped",
            c,
            {
              "ctw-cursor-pointer hover:ctw-bg-bg-lighter": dr(r),
              "last:ctw-rounded-b-lg": y,
              "ctw-text-content-lighter": w.isDismissed
            }
          ),
          onKeyDown: (x) => {
            x.key === "Enter" && g(w);
          },
          onClick: () => g(w),
          children: [
            e(w),
            l && // Add onClick to prevent clicks from propagating to the row.
            // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/click-events-have-key-events
            /* @__PURE__ */ i.jsx(
              "div",
              {
                "aria-label": "row-actions",
                className: "ctw-row-actions group-hover:ctw-visible ctw-invisible ctw-absolute ctw-group ctw-resource-overview-actions",
                onClick: (x) => x.stopPropagation(),
                children: /* @__PURE__ */ i.jsx(l, { record: w })
              }
            )
          ]
        },
        w.key
      ))
    })
  );
};
function G0(e, t = [], n) {
  const r = ke(
    () => t.reduce(
      (a, o) => {
        var d;
        const c = e(o), l = (d = a[c]) != null ? d : [];
        return X(R({}, a), {
          [c]: l.concat(o)
        });
      },
      {}
    ),
    [t, e]
  ), s = ke(
    () => Object.keys(r).sort(
      (a, o) => n ? n.indexOf(a) - n.indexOf(o) : a.localeCompare(o)
    ),
    [r, n]
  );
  return { groupedRecords: r, sortedKeys: s };
}
const CW = (p) => {
  var m = p, {
    children: e,
    columnHeaders: t,
    data: n,
    enableDismissAndReadActions: r,
    groupBy: s,
    isLoading: a,
    rowActions: o,
    selectedResources: c,
    setSelectedResources: l,
    writebackStatuses: d,
    onWritebackStart: u,
    onWritebackEnd: h
  } = m, f = ct(m, [
    "children",
    "columnHeaders",
    "data",
    "enableDismissAndReadActions",
    "groupBy",
    "isLoading",
    "rowActions",
    "selectedResources",
    "setSelectedResources",
    "writebackStatuses",
    "onWritebackStart",
    "onWritebackEnd"
  ]);
  const { groupedRecords: C, sortedKeys: y } = G0(s, n), g = Ya({
    onWritebackStart: u,
    onWritebackEnd: h,
    rowActions: o,
    enableDismissAndReadActions: r
  }), [w, x] = Y(!1);
  return he(() => {
    x(!0), setTimeout(() => x(!1), 0);
  }, [C]), /* @__PURE__ */ i.jsx("div", { className: W("ctw-@container", { "ctw-inline-block": w }), children: /* @__PURE__ */ i.jsxs("div", { className: "ctw-space-y-2", children: [
    !a && /* @__PURE__ */ i.jsx("div", { className: "ctw-hidden @[640px]:ctw-flex ctw-mb-2 ctw-px-3 ctw-justify-between ctw-text-left ctw-font-medium ctw-text-sm ctw-text-content-black ctw-border-b-[1px] ctw-border-b-icon-light ctw-space-x-1.5", children: t == null ? void 0 : t.map((S, N) => {
      var v;
      return (
        // eslint-disable-next-line react/no-array-index-key
        /* @__PURE__ */ i.jsx("div", { className: W(S.className), children: ((v = S.render) == null ? void 0 : v.call(S)) || S.title }, N)
      );
    }) }),
    y.map((S) => {
      var D, $, _;
      const N = (D = C[S]) != null ? D : [], v = (_ = ($ = C[S]) == null ? void 0 : $.filter(
        (L) => hH(d == null ? void 0 : d[L.id])
      )) != null ? _ : [], b = l && v.length > 0, j = !!c && v.reduce((L, I) => L && c.includes(I), !0);
      return /* @__PURE__ */ i.jsx("div", { "data-testid": "resource-table-grouped", children: /* @__PURE__ */ i.jsx(
        Ss,
        X(R({
          className: "!ctw-min-h-0 !ctw-min-w-0 !ctw-text-sm",
          data: N,
          isLoading: a,
          noShadow: !0,
          title: S,
          titleSize: "sm",
          RowActions: g,
          icon: b && c && /* @__PURE__ */ i.jsx(
            S0,
            {
              isSelected: j,
              changeState: () => {
                l(
                  j ? c.filter((L) => {
                    var I;
                    return !((I = C[S]) != null && I.includes(L));
                  }) : [
                    ...c,
                    ...v.filter((L) => !c.includes(L))
                  ]
                );
              }
            }
          )
        }, f), {
          children: e
        })
      ) }, S);
    })
  ] }) });
}, Yi = "ctw-w-[27rem] @[1024px]:ctw-w-[30rem] ctw-text-sm ctw-hidden -ctw-ml-2 ", nn = {
  builderOwned: "ctw-text-sm ctw-w-[1.5rem] ctw-max-w-[1.5rem] ctw-min-w-[1.5rem]",
  displayName: "ctw-w-full ctw-flex-grow ctw-text-sm",
  latestDiagnosis: [Yi, "@[640px]:ctw-block @[640px]:ctw-ml-0"],
  onset: [Yi, "@[1024px]:ctw-block @[1024px]:ctw-ml-0"],
  type: [Yi, "ctw-text-ellipsis @[768px]:ctw-block @[768px]:ctw-ml-0"]
}, NW = [
  {
    className: nn.builderOwned
  },
  {
    className: nn.displayName,
    title: "Name"
  },
  {
    className: nn.latestDiagnosis,
    title: "Latest Diagnosis"
  },
  {
    className: nn.onset,
    render: () => /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-w-full ctw-justify-start ctw-space-x-2", children: [
      /* @__PURE__ */ i.jsx("div", { children: "Onset Date" }),
      /* @__PURE__ */ i.jsx("div", { className: "ctw-flex-grow ctw-content-start", children: /* @__PURE__ */ i.jsx(Sn, { content: "Earliest known onset or documented date", children: /* @__PURE__ */ i.jsx(
        me,
        {
          icon: Ho,
          className: "ctw-w-4 ctw-h-4 ctw-text-content-lighter"
        }
      ) }) })
    ] })
  },
  {
    className: nn.type,
    title: "Type"
  }
], DW = (e, t) => !e || !!t.hccEnrichment, Y0 = {
  showOnlyHcc: (e, t) => DW(e, t)
};
function SW(e, t, n) {
  const r = [
    qn,
    {
      key: "showOnlyHcc",
      type: "tag",
      belowDivider: !0,
      display: ({ listView: a }) => a ? "Show HCCs Only" : "HCCs Only",
      predicate: Y0.showOnlyHcc,
      icon: Bo,
      toggleDisplay: "show all",
      toggleIcon: Uo
    }
  ];
  let s = t ? [...jF.filter((a) => a !== "Entered in Error")] : [...CF];
  if (n)
    switch (n) {
      case "Current":
        s = Bu((a, o) => a === o, s, [
          "Active",
          "Pending",
          "Unknown"
        ]);
        break;
      case "Past":
        s = Bu((a, o) => a === o, s, [
          "Inactive",
          "Refuted"
        ]);
        break;
    }
  return r.push(
    {
      key: "displayStatus",
      type: "checkbox",
      icon: lh,
      display: "Status",
      // Create new array as these other ones are readonly.
      values: s
    },
    {
      key: "ccsChapter",
      type: "checkbox",
      icon: dh,
      display: "Category",
      values: Ro(e, "ccsChapter")
    },
    {
      key: "typeDisplay",
      type: "checkbox",
      icon: pv,
      display: "Type",
      values: Ro(e, "typeDisplay").sort((a, o) => {
        var u, h;
        const c = {
          acute: 4,
          chronic: 3,
          "chronic and acute": 2
        }, l = (u = c[a.toLowerCase()]) != null ? u : 0, d = (h = c[o.toLowerCase()]) != null ? h : 0;
        return l > d ? -1 : d > l ? 1 : 0;
      })
    }
  ), r;
}
const _l = ({
  options: e,
  isLoading: t,
  name: n,
  defaultValue: r = {},
  defaultSearchTerm: s = "",
  onSearchChange: a,
  readonly: o,
  onCustomSelectChange: c,
  renderCustomOption: l,
  placeholder: d = "Type to search",
  minInputLength: u = 3,
  enableSearchIcon: h = !1,
  usesSearchButton: f = !1
}) => {
  const [p, m] = Y(s || ""), [C, y] = Y(!1), [g, w] = Y({}), x = xe(g) ? r : g, S = y2(x) ? JSON.stringify(x) : x, N = vt(
    (j) => {
      j.length >= u && (a(j), m(j), y(!0)), e.filter((D) => D.label === j).length === 0 && w({});
    },
    [a, u, e]
  ), v = ke(() => xE(N, 300), [N]), b = (j) => {
    const D = j;
    D != null && D.value && (m(D.label), w(D.value), c == null || c(D.value));
  };
  return /* @__PURE__ */ i.jsx(cr, { onChange: b, value: p, disabled: o, children: ({ open: j }) => /* @__PURE__ */ i.jsxs("div", { className: "ctw-relative ctw-text-left", children: [
    /* @__PURE__ */ i.jsx(
      cr.Button,
      {
        as: "div",
        onClick: (D) => {
          (j || p.length === 0) && D9(D) && D.preventDefault();
        },
        children: /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-space-x-2", children: [
          /* @__PURE__ */ i.jsxs("div", { className: "ctw-relative ctw-grow", children: [
            h && /* @__PURE__ */ i.jsx("div", { className: "ctw-search-icon-wrapper", children: /* @__PURE__ */ i.jsx(U7, { className: "ctw-search-icon" }) }),
            /* @__PURE__ */ i.jsx(
              cr.Input,
              {
                className: W("ctw-listbox-input ctw-w-full", {
                  "ctw-pl-10": h
                }),
                onKeyDown: (D) => {
                  D.key === "Enter" && ((e.length === 0 || t) && D.preventDefault(), f && !C && (D.preventDefault(), N(p)));
                },
                onChange: (D) => {
                  f ? (m(D.target.value), y(!1)) : (D.persist(), v(D.target.value));
                },
                placeholder: d
              }
            )
          ] }),
          f && /* @__PURE__ */ i.jsx(
            "button",
            {
              type: "button",
              className: "ctw-btn-primary",
              onMouseDown: () => {
                N(p);
              },
              disabled: p.length < u || C,
              children: "Search"
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ i.jsx("input", { hidden: !0, name: n, value: S, readOnly: !0 }),
    /* @__PURE__ */ i.jsx(cr.Options, { className: "ctw-listbox ctw-absolute ctw-z-10 ctw-m-0 ctw-mt-1 ctw-max-h-60 ctw-w-full ctw-list-none ctw-overflow-auto ctw-rounded-md ctw-bg-white ctw-p-0 ctw-py-1 ctw-text-base ctw-shadow-lg ctw-ring-1 ctw-ring-opacity-5 focus:ctw-outline-none sm:ctw-text-sm", children: /* @__PURE__ */ i.jsx(
      $W,
      {
        options: e,
        query: p,
        isLoading: t,
        renderCustomOption: l,
        minInputLength: u,
        usesSearchButton: f,
        isSearchSubmitted: C
      }
    ) })
  ] }) });
}, $W = ({
  options: e,
  query: t,
  isLoading: n,
  renderCustomOption: r,
  minInputLength: s,
  usesSearchButton: a = !1,
  isSearchSubmitted: o = !0
}) => t.length === 0 ? /* @__PURE__ */ i.jsx(ar, { option: { value: "", label: "Type to search" } }) : n ? /* @__PURE__ */ i.jsx(ar, { option: { value: "", label: "Loading..." } }) : t.length < s ? /* @__PURE__ */ i.jsx(ar, { option: { value: "", label: "Please type at least three characters" } }) : a && !o ? /* @__PURE__ */ i.jsx(
  ar,
  {
    option: {
      value: "",
      label: `Type at least ${s} letters and click the Search button or Enter key`
    }
  }
) : e.length === 0 ? /* @__PURE__ */ i.jsx(
  ar,
  {
    option: {
      value: "",
      label: `No results found for search term '${t}'`
    }
  }
) : /* @__PURE__ */ i.jsx(i.Fragment, { children: e.map(
  (c, l) => {
    var d, u;
    return r ? /* @__PURE__ */ i.jsxs(sn, { children: [
      r(c),
      " "
    ] }, (d = c.key) != null ? d : `option-${l}`) : /* @__PURE__ */ i.jsx(ar, { option: c }, (u = c.key) != null ? u : `option-${l}`);
  }
) }), ar = ({ option: e }) => /* @__PURE__ */ i.jsx(
  cr.Option,
  {
    value: e,
    className: ({ active: t }) => `ctw-relative ctw-cursor-default ctw-select-none ctw-py-2 ctw-pl-4 ctw-pr-4 ${t ? "ctw-bg-primary-light ctw-text-primary-dark" : "ctw-text-content-black"}`,
    children: e.label
  }
), AW = (e, t) => V(void 0, null, function* () {
  const { authToken: n, contextBuilderId: r } = e, { data: s } = yield rt(
    `${wO(e.env)}?display=${t}`,
    {
      headers: R({
        Authorization: `Bearer ${n}`
      }, r && { "Zus-Account": r })
    }
  );
  return s.conditionsList;
}), EW = (r) => {
  var s = r, {
    defaultCoding: e,
    readonly: t
  } = s, n = ct(s, [
    "defaultCoding",
    "readonly"
  ]);
  const { getRequestContext: a } = Xe(), [o, c] = Y(!1), [l, d] = Y(), u = (h) => V(void 0, null, function* () {
    c(!0);
    const f = yield a(), p = yield AW(f, h);
    p && d(
      p.map((m) => ({
        value: m,
        label: m.display
      }))
    ), c(!1);
  });
  return /* @__PURE__ */ i.jsx(
    _l,
    {
      options: l || [],
      isLoading: o,
      name: `${n.name}`,
      defaultSearchTerm: n.defaultValue,
      readonly: t,
      onSearchChange: u,
      defaultValue: e
    }
  );
}, IW = ({ condition: e }) => [
  {
    label: st.t("glossary:condition_one"),
    field: "condition",
    value: e.display,
    readonly: !0,
    render: (t, n) => {
      var r;
      return /* @__PURE__ */ i.jsx(
        EW,
        X(R({
          readonly: t
        }, n), {
          defaultCoding: (r = e.preferredCoding) != null ? r : {}
        })
      );
    }
  },
  ..._W(e)
], _W = (e) => [
  {
    label: "subject",
    value: e.subjectID,
    field: "subjectID",
    readonly: !0,
    hidden: !0
  },
  {
    label: "Status",
    value: e.displayStatus === "Unknown" ? "Select One" : e.displayStatus,
    field: "status"
  },
  {
    label: "Type",
    value: e.type,
    field: "type"
  },
  {
    label: "Onset",
    value: e.onset,
    field: "onset"
  },
  {
    label: "Abatement",
    value: e.abatement,
    field: "abatement"
  },
  {
    label: "Note",
    value: e.notes,
    lines: 3,
    field: "note"
  }
], TW = Ce.object({
  id: Ce.string().optional(),
  subjectID: Ce.string({
    required_error: "Condition subjectID must be specified."
  }),
  status: Ce.enum(["Active", "Pending", "Inactive", "Refuted", "Entered In Error"]),
  type: Ce.enum(["Chronic", "Acute", "Chronic and acute", "Unknown"]),
  onset: Ce.date().max(/* @__PURE__ */ new Date(), { message: "Onset cannot be a future date." }).optional(),
  abatement: Ce.date().max(/* @__PURE__ */ new Date(), { message: "Abatement cannot be a future date." }).optional(),
  note: Ce.string().optional()
}), RW = (e, t) => {
  e.abatement && e.status !== "Inactive" && t.addIssue({
    code: nd.ZodIssueCode.custom,
    message: "Status must be inactive.",
    path: ["abatement"]
  }), e.abatement && e.onset && e.abatement < e.onset && t.addIssue({
    code: nd.ZodIssueCode.custom,
    message: "Abatement date must be after onset date.",
    path: ["abatement"]
  });
}, MW = TW.extend({
  condition: Ce.object({
    code: Ce.string({
      required_error: "Please choose a condition."
    }),
    // These are technically required but we mark them
    // as optional to avoid duplicative error messages.
    // The condition autocomplete will set us up so that
    // all three of these values are set.
    display: Ce.string().optional(),
    system: Ce.string().optional()
  })
}).superRefine((e, t) => RW(e, t));
function PW(e, t) {
  var o, c;
  const { t: n } = Kn(), { openDrawer: r } = Vn(), { patient: s } = Ze(), a = (c = (o = s.data) == null ? void 0 : o.id) != null ? c : "";
  return (l) => {
    const d = new Ug(
      l ? Lg(l.resource) : bF(a)
    );
    r({
      component: (u) => /* @__PURE__ */ i.jsx(
        Nl,
        R({
          title: n("resource.add", { resource: n("glossary:condition_one") }),
          schema: MW,
          errorHeader: "Unable to add condition to chart",
          closeOnSubmit: !0,
          onSubmit: () => {
            l != null && l.id && e(l.id);
          },
          onSubmitSuccess: () => {
            l != null && l.id && t(l.id, !1);
          },
          onSubmitError: (h) => {
            l != null && l.id && t(l.id, !0, h), Bn({
              type: "error",
              title: `Error adding ${l == null ? void 0 : l.display} to chart.`,
              body: h
            });
          },
          action: dE(Bg)(d, a),
          data: IW({ condition: d }),
          trackingMetadata: { action: "create_resource", resourceType: "condition" }
        }, u)
      )
    });
  };
}
function OW(e, t, n) {
  const { t: r } = Kn(), { toggleRead: s } = Hr(), { trackInteraction: a } = Be(), [o, c] = Y({}), l = PW(
    (d) => {
      t("add", d), c((u) => X(R({}, u), { [d]: !0 }));
    },
    (d, u, h) => {
      n("add", d, u, h), c((f) => X(R({}, f), { [d]: !1 }));
    }
  );
  return vt(
    (d) => e ? [] : !d.syncedWithRecord && !o[d.id] ? [
      {
        className: "ctw-btn-primary",
        text: r("resourceTable.add"),
        onClick: () => {
          d.isRead || s(d), l(d), a("add_to_record");
        }
      }
    ] : [],
    [e, l, r, s, a, o]
  );
}
const Tl = {
  display: "Last Diagnosed (New to Old)",
  sorts: [{ key: "recordedDate", dir: "desc", isDate: !0 }]
}, kW = {
  display: "Name (A-Z)",
  sorts: [{ key: "display", dir: "asc" }]
}, LW = [
  kW,
  {
    display: "Name (Z-A)",
    sorts: [{ key: "display", dir: "desc" }]
  },
  {
    display: "Category (A-Z)",
    sorts: [{ key: "ccsChapter", dir: "asc" }]
  },
  {
    display: "Category (Z-A)",
    sorts: [{ key: "ccsChapter", dir: "desc" }]
  },
  {
    display: "Type (A-Z)",
    sorts: [{ key: "typeDisplay", dir: "asc" }]
  },
  {
    display: "Type (Z-A)",
    sorts: [{ key: "typeDisplay", dir: "desc" }]
  },
  {
    display: "Last Diagnosed (Old to New)",
    sorts: [{ key: "recordedDate", dir: "asc", isDate: !0 }]
  },
  Tl
], FW = LW.filter(
  (e) => e.sorts[0].key !== "ccsChapter"
), Qi = (e) => {
  let t = "not-known-to-builder";
  return e.isDismissed ? t = "dismissed" : e.syncedWithRecord && (t = "known-to-builder"), t;
}, BW = ({
  className: e,
  readOnly: t = !1,
  conditionIdForDetailsDrawer: n,
  onOpenDetailsDrawer: r,
  onAfterDetailsDrawerClosed: s
}) => {
  const a = Qa(), { selectedResources: o, setSelectedResources: c } = tt(Ja), l = o["conditions-all"], [d, u] = Y(
    Object.fromEntries(
      a.data.map((A) => [
        A.id,
        {
          state: Qi(A)
        }
      ])
    )
  );
  he(() => {
    u((A) => {
      const M = R({}, A);
      return a.data.forEach((G) => {
        M[G.id] || (M[G.id] = {
          state: Qi(G)
        });
      }), M;
    });
  }, [a.data]);
  const h = (A, M) => {
    A === "dismiss-single" || A === "restore" || u((G) => X(R({}, G), { [M]: { state: "in-progress" } }));
  }, f = (A, M, G, Z) => {
    u((Q) => {
      if (G)
        return X(R({}, Q), { [M]: { state: "error", message: Z } });
      const T = a.data.find((P) => P.id === M);
      switch (A) {
        case "add":
          return X(R({}, Q), { [M]: { state: "known-to-builder-new" } });
        case "dismiss-bulk":
          return X(R({}, Q), { [M]: { state: "bulk-dismissed-new" } });
        case "dismiss-single":
          return X(R({}, Q), { [M]: { state: "dismissed" } });
        case "restore":
        default:
          return T ? X(R({}, Q), { [M]: { state: Qi(T) } }) : Q;
      }
    });
  }, p = OW(t, h, f), { viewOptions: m, current: C } = z0, {
    data: y,
    filters: g,
    setFilters: w,
    setSort: x,
    viewOption: S,
    setViewOption: N,
    defaultSort: v,
    defaultView: b
  } = Rt({
    cacheKey: "patient-conditions-all-grouped",
    defaultSort: Tl,
    viewOptions: m,
    filterPredicates: Y0,
    records: a.data,
    defaultView: C.display
  }), j = a.data.length === 0, D = !j && y.length === 0, $ = j || D, _ = Ka({
    rowActions: p,
    enableDismissAndReadActions: !0,
    onOpen: r,
    onAfterClosed: s
  });
  n && _(void 0, void 0, n, "Condition");
  const L = (A) => {
    c(X(R({}, o), {
      "conditions-all": [...l, A]
    }));
  }, I = (A) => {
    c(X(R({}, o), {
      "conditions-all": l.filter((M) => M.id !== A.id)
    }));
  };
  return /* @__PURE__ */ i.jsx(ft, { componentName: "PatientConditionsAll", children: /* @__PURE__ */ i.jsxs("div", { className: W(e, "ctw-scrollable-pass-through-height"), children: [
    /* @__PURE__ */ i.jsx(
      yW,
      {
        selectedKey: "conditions-all",
        resourceName: "condition",
        onWritebackStart: h,
        onWritebackEnd: f,
        bulkAdd: fW,
        bulkDismiss: uW,
        columns: hW(o, c)
      }
    ),
    /* @__PURE__ */ i.jsx(
      Ht,
      {
        viewOptions: {
          onChange: N,
          options: m,
          defaultView: b
        },
        sortOptions: {
          defaultSort: v,
          options: FW,
          onChange: x
        },
        filterOptions: {
          onChange: w,
          filters: SW(a.data, !0, S),
          selected: g
        }
      }
    ),
    $ && /* @__PURE__ */ i.jsx("div", { className: "ctw-my-16", children: /* @__PURE__ */ i.jsx(
      xt,
      {
        resourceName: "conditions",
        hasZeroFilteredRecords: D
      }
    ) }),
    !$ && /* @__PURE__ */ i.jsx(
      CW,
      {
        hideFooter: !0,
        data: y,
        onRowClick: _,
        isLoading: a.isLoading,
        trackingName: "condition",
        emptyMessage: "We didn't find any condition records for this patient.",
        rowClassName: "ctw-border-b ctw-border-border-lighter last:ctw-border-none",
        titleClassName: "!ctw-text-sm ctw-bg-bg-light ctw-text-content-light ctw-pb-1 ctw-pt-2",
        groupBy: (A) => A.ccsChapter || "Uncategorized",
        rowActions: p,
        columnHeaders: NW,
        enableDismissAndReadActions: !0,
        dataTestId: "patient-conditions-all-grouped",
        selectedResources: l,
        setSelectedResources: (A) => c({ "conditions-all": A }),
        writebackStatuses: d,
        onWritebackStart: h,
        onWritebackEnd: f,
        children: (A) => {
          var G;
          const M = (G = d[A.id]) != null ? G : { state: "unknown" };
          return /* @__PURE__ */ i.jsxs(
            "div",
            {
              className: "ctw-flex ctw-justify-between ctw-text-left ctw-text-base ctw-space-x-1.5 ctw-group ctw-relative",
              "data-testid": "patient-conditions-all-row",
              children: [
                /* @__PURE__ */ i.jsx("div", { className: W(nn.builderOwned), role: "cell", children: pH(M, {
                  isSelected: l.includes(A),
                  changeState: (Z) => {
                    Z ? L(A) : I(A);
                  }
                }) }),
                /* @__PURE__ */ i.jsx("div", { className: W(nn.displayName), role: "cell", children: /* @__PURE__ */ i.jsx(
                  Wt,
                  {
                    title: A.display,
                    renderIcon: $0(
                      xe(A.hccEnrichment) ? void 0 : "HCC",
                      "",
                      xe(A.hccEnrichment) ? void 0 : "Risk-adjusting condition"
                    )
                  }
                ) }),
                /* @__PURE__ */ i.jsxs(
                  "div",
                  {
                    className: W(nn.latestDiagnosis),
                    role: "cell",
                    children: [
                      /* @__PURE__ */ i.jsx("div", { children: A.recordedDate }),
                      /* @__PURE__ */ i.jsx("div", { children: A.recorder })
                    ]
                  }
                ),
                /* @__PURE__ */ i.jsx("div", { className: W(nn.onset), role: "cell", children: A.onset }),
                /* @__PURE__ */ i.jsx("div", { className: W(nn.type), role: "cell", children: A.typeDisplay })
              ]
            }
          );
        }
      }
    )
  ] }) });
}, UW = He(
  BW,
  "PatientConditionsAllGrouped"
);
function Rl(e, t) {
  return e.filter((n) => t.every((r) => r.predicate(n)));
}
const Q0 = (f) => {
  var p = f, {
    children: e,
    data: t = [],
    emptyMessage: n,
    onRowClick: r,
    onSeeAllResources: s,
    hideFooter: a,
    trackingName: o,
    rowClassName: c,
    groupBy: l,
    groupByKeyOrder: d,
    dataTestId: u
  } = p, h = ct(p, [
    "children",
    "data",
    "emptyMessage",
    "onRowClick",
    "onSeeAllResources",
    "hideFooter",
    "trackingName",
    "rowClassName",
    "groupBy",
    "groupByKeyOrder",
    "dataTestId"
  ]);
  const { trackInteraction: m } = Be(), C = ut(), { toggleRead: y } = Hr(), g = a || !s, { groupedRecords: w, sortedKeys: x } = G0(l, t, d);
  function S(N) {
    r && (!N.isRead && !N.ownedByBuilder(C) && y(N), r(N), m("click_row", { target: o }));
  }
  return /* @__PURE__ */ i.jsx(
    Ds,
    X(R({
      dataTestId: u,
      hideFooter: g,
      footerOnClick: () => {
        m("see_all_of_resource", { target: o }), s == null || s();
      }
    }, h), {
      children: t.length === 0 ? /* @__PURE__ */ i.jsx(Vr, { message: n }) : x.map((N) => {
        var v;
        return /* @__PURE__ */ i.jsxs("div", { "data-testid": "overview-group-row", children: [
          /* @__PURE__ */ i.jsx("div", { className: "ctw-uppercase ctw-text-xs ctw-bg-bg-light ctw-text-content-light ctw-pl-8 ctw-pb-1 ctw-pt-2", children: N }),
          ((v = w[N]) != null ? v : []).map((b) => /* @__PURE__ */ i.jsx(
            "div",
            {
              className: W("ctw-py-1.5 ctw-px-2", c, {
                "ctw-cursor-pointer hover:ctw-bg-bg-lighter": dr(r),
                "last:ctw-rounded-b-lg": g
              }),
              "data-testid": "resource-overview-row",
              onKeyDown: (j) => {
                j.key === "Enter" && S(b);
              },
              onClick: () => S(b),
              children: e(b)
            },
            b.key
          ))
        ] }, N);
      })
    })
  );
}, zW = ({ className: e }) => /* @__PURE__ */ i.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    className: e,
    fill: "currentColor",
    children: /* @__PURE__ */ i.jsx("path", { d: "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z" })
  }
), Jn = Ct({
  selectedZapTabIndex: 0,
  setSelectedTab: () => {
  },
  tabOrder: [],
  setTabOrder: () => []
});
class Z0 extends nh {
  constructor() {
    super(...arguments);
    ne(this, "name");
    ne(this, "state", {
      hasError: !1
    });
  }
  static getDerivedStateFromError(n) {
    return { hasError: !0, error: n };
  }
  componentDidCatch(n, r) {
    const { props: s } = this;
    $e.countMetric(`component.${s.title}.failure`), $e.logger.error(
      n.message,
      mo(X(R({}, r), {
        componentName: s.name,
        error: {
          stack: n.stack
        }
      }))
    );
  }
  setTab(n) {
    const { name: r, context: s } = this;
    this.context && s.setSelectedTab && n ? s.setSelectedTab(n) : $e.logger.error(
      "Unable to navigate to tab in ResourceCardErrorBoundary",
      mo({
        componentName: r
      })
    );
  }
  render() {
    const { state: n } = this, { title: r, footerTitle: s, children: a } = this.props;
    return n.hasError ? /* @__PURE__ */ i.jsxs(H0, { children: [
      /* @__PURE__ */ i.jsx(
        W0,
        {
          icon: uh,
          title: r,
          className: "",
          tooltipText: "tooltipText",
          titleSize: "base"
        }
      ),
      /* @__PURE__ */ i.jsx("div", { className: "ctw-py-4", children: /* @__PURE__ */ i.jsx(
        Nn,
        {
          title: "An unexpected error occurred",
          message: "Try reloading the ZAP.",
          icon: /* @__PURE__ */ i.jsx(zW, { className: "ctw-h-7 ctw-w-7  ctw-text-content-lighter" }),
          titleSize: "lg",
          containerSpacing: "sm"
        }
      ) }),
      /* @__PURE__ */ i.jsx(
        q0,
        {
          text: s,
          onClick: () => {
            const { tabToNavigateTo: o } = this.props;
            this.setTab(o || "");
          }
        }
      )
    ] }) : a;
  }
}
ne(Z0, "contextType", Jn);
function xn({
  component: e,
  name: t,
  trackView: n = !0,
  title: r = "",
  footerTitle: s = "",
  tabToNavigateTo: a
}) {
  const o = va(
    (c, l) => gr(
      Z0,
      { name: t, trackView: n, title: r, footerTitle: s, tabToNavigateTo: a || "" },
      gr(e, X(R({}, c), { ref: l }))
    )
  );
  return o.displayName = `withErrorBoundary(${t})`, o;
}
const K0 = "Conditions", J0 = "All Conditions", HW = () => [
  {
    key: "conditions",
    label: "chronic conditions or acute conditions with hcc",
    description: "chronic conditions or acute conditions with hcc",
    predicate: (e) => {
      var t, n;
      return ((t = e.chronic) == null ? void 0 : t.code) === "C" || ((n = e.chronic) == null ? void 0 : n.code) === "A" && !xe(e.hccEnrichment);
    }
  }
], WW = ({
  onSeeAllResources: e,
  onAfterDetailsDrawerClosed: t,
  onOpenDetailsDrawer: n,
  conditionIdForDetailsDrawer: r
}) => {
  const { current: s } = z0, a = Ka({
    enableDismissAndReadActions: !1,
    onAfterClosed: t,
    onOpen: n
  });
  r && a(void 0, void 0, r, "Condition");
  const { data: o, isLoading: c } = Qa(), { data: l } = Rt({
    defaultSort: Tl,
    viewOptions: [s],
    records: o,
    defaultView: s.display
  }), d = nt(
    Rl(l, HW()),
    (h) => h.display,
    "asc"
  ), u = o.length === 0;
  return /* @__PURE__ */ i.jsx(
    Q0,
    {
      groupBy: (h) => String(h.ccsChapter),
      onSeeAllResources: e,
      onRowClick: a,
      data: d,
      emptyMessage: u ? "We didn't find any condition records for this patient." : "There are no chronic conditions or acute HCCs for this patient.",
      footerText: J0,
      hideFooter: u,
      title: K0,
      tooltipText: "Chronic Conditions and acute HCCs",
      isLoading: c,
      icon: dh,
      trackingName: "conditions_overview",
      dataTestId: "conditions-overview",
      children: (h) => /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-justify-between ctw-text-left", children: [
        /* @__PURE__ */ i.jsx("div", { className: "ctw-w-[1.5rem] ctw-max-w-[1.5rem] ctw-min-w-[1.5rem] ctw-text-sm", children: Lt(h.syncedWithRecord) }),
        /* @__PURE__ */ i.jsx("div", { className: "ctw-w-full ctw-flex-grow ctw-text-sm", children: /* @__PURE__ */ i.jsx(
          Wt,
          {
            className: "ctw-w-full",
            title: /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
              h.display,
              " ",
              h.recordedDate && /* @__PURE__ */ i.jsxs("span", { className: "ctw-font-normal ctw-text-content-light ctw-text-xs ctw-whitespace-nowrap", children: [
                "[Last Dx ",
                BL(h.recordedDate, "yyyy"),
                "]"
              ] })
            ] }),
            renderIcon: $0(
              xe(h.hccEnrichment) ? void 0 : "HCC",
              "",
              xe(h.hccEnrichment) ? void 0 : "Risk-adjusting condition"
            )
          }
        ) })
      ] })
    }
  );
}, VW = xn({
  component: WW,
  name: "PatientConditionOverview",
  title: K0,
  footerTitle: J0,
  tabToNavigateTo: "conditions-all"
}), cK = ({ className: e }) => Qa().data.filter(
  (r) => !r.isDismissed && !r.isRead && !r.syncedWithRecord
).length > 0 ? /* @__PURE__ */ i.jsx(Za, { className: e }) : null;
const qW = (e) => [
  {
    title: "Diagnostic",
    widthPercent: 40,
    minWidth: 200,
    render: (t) => /* @__PURE__ */ i.jsx(
      Wt,
      {
        title: t.displayName,
        renderIcon: Lt(t.ownedByBuilder(e)),
        capitalizeTitle: !1
      }
    )
  },
  {
    title: "Date",
    dataIndex: "effectiveStart",
    widthPercent: 20,
    minWidth: 128
  },
  {
    widthPercent: 1,
    minWidth: 32,
    className: "ctw-trend-indicator-cell",
    render: (t) => t.hasTrends ? /* @__PURE__ */ i.jsx(me, { icon: fh }) : null
  },
  {
    title: "Details",
    dataIndex: "details",
    widthPercent: 39,
    minWidth: 200,
    className: "ctw-details-cell"
  }
];
function GW() {
  return [qn];
}
const X0 = [
  {
    display: "Date (New to Old)",
    sorts: [{ key: "effectiveStart", dir: "desc", isDate: !0 }]
  },
  {
    display: "Date (Old to New)",
    sorts: [{ key: "effectiveStart", dir: "asc", isDate: !0 }]
  },
  {
    display: "Name (A-Z)",
    sorts: [{ key: "displayName", dir: "asc" }]
  },
  {
    display: "Name (Z-A)",
    sorts: [{ key: "displayName", dir: "desc" }]
  }
], YW = X0[0], e1 = ({ className: e, result: t, interpretation: n }) => n ? /* @__PURE__ */ i.jsxs("div", { className: e, children: [
  t,
  " - ",
  n
] }) : /* @__PURE__ */ i.jsx("div", { className: e, children: t }), QW = ({ model: e }) => {
  const [t, n] = Y(!1), r = $s(), { trackInteraction: s } = Be();
  return /* @__PURE__ */ i.jsx(ft, { componentName: "ObservationTrends", children: /* @__PURE__ */ i.jsx("div", { className: "ctw-text-sm ctw-font-normal", children: !e.isIncorrectlyCodedGlucose && e.trends && e.trends.length > 1 && /* @__PURE__ */ i.jsxs("div", { className: "ctw-pt-2", children: [
    /* @__PURE__ */ i.jsxs(
      "button",
      {
        "aria-label": "trends",
        className: "ctw-btn-clear ctw-space-x-3",
        type: "button",
        onClick: () => {
          s("toggle_trend", {
            action: t ? "collapse_trend" : "expand_trend"
          }), n(!t);
        },
        children: [
          /* @__PURE__ */ i.jsx(me, { icon: fh }),
          /* @__PURE__ */ i.jsx("span", { children: "Trends" }),
          /* @__PURE__ */ i.jsx(
            me,
            {
              icon: zo,
              className: W("ctw-h-3 ctw-w-3 ctw-pr-1", {
                "ctw-rotate-90": t
              })
            }
          )
        ]
      }
    ),
    t && e.trends.map(
      (a) => !a.isIncorrectlyCodedGlucose && /* @__PURE__ */ i.jsxs(
        "div",
        {
          tabIndex: 0,
          role: "button",
          className: W("ctw-group/trends ctw-grid ctw-grid-cols-3 ctw-py-1 ctw-pl-4", {
            "ctw-cursor-pointer hover:ctw-bg-bg-lighter": a.diagnosticReport
          }),
          onClick: () => {
            a.diagnosticReport && (s("open_diagnostic_report", { target: "btn" }), r(a.diagnosticReport));
          },
          onKeyDown: (o) => {
            o.key === "Enter" && a.diagnosticReport && (s("open_diagnostic_report", { target: "enter_key" }), r(a.diagnosticReport));
          },
          children: [
            /* @__PURE__ */ i.jsx(
              "div",
              {
                className: W("ctw-relative ctw-w-24 ctw-text-sm", {
                  "ctw-font-semibold": a.id === e.id,
                  "group-hover/trends:ctw-underline": a.diagnosticReport
                }),
                children: a.effectiveStart
              }
            ),
            /* @__PURE__ */ i.jsx(
              e1,
              {
                result: a.value,
                interpretation: a.interpretation,
                className: W(`${a.acceptedInterpretations} ctw-w-fit`, {
                  "!ctw-font-semibold": a.id === e.id
                })
              }
            ),
            a.diagnosticReport && /* @__PURE__ */ i.jsx("div", { className: "ctw-justify-self-end", children: /* @__PURE__ */ i.jsx(
              me,
              {
                icon: kw,
                className: "ctw-invisible ctw-pr-2 ctw-text-content-lighter group-hover/trends:ctw-visible"
              }
            ) })
          ]
        },
        a.id
      )
    )
  ] }) }) });
}, ZW = () => [
  {
    title: "Component",
    render: (e) => /* @__PURE__ */ i.jsx("div", { className: "ctw-flex ctw-flex-wrap ctw-text-base", children: e.display })
  },
  {
    title: "Result",
    render: (e) => /* @__PURE__ */ i.jsx("div", { className: "ctw-flex", children: /* @__PURE__ */ i.jsxs("div", { className: "ctw-text-sm ctw-font-normal", children: [
      "Result:",
      " ",
      /* @__PURE__ */ i.jsx(
        e1,
        {
          interpretation: e.interpretation,
          result: e.value,
          className: e.acceptedInterpretations
        }
      )
    ] }) })
  },
  {
    title: "Reference Range",
    render: (e) => /* @__PURE__ */ i.jsx("div", { className: "ctw-flex ctw-text-sm ctw-font-normal", children: e.referenceRange && /* @__PURE__ */ i.jsxs("div", { className: "ctw-font-normal", children: [
      "Reference Range: ",
      e.referenceRange,
      " ",
      e.unit
    ] }) })
  },
  {
    title: "Trends",
    render: (e) => /* @__PURE__ */ i.jsx(QW, { model: e })
  }
], KW = ({ className: e, data: t }) => /* @__PURE__ */ i.jsxs("div", { className: e, children: [
  /* @__PURE__ */ i.jsx("div", { className: "ctw-text-base ctw-font-medium ctw-uppercase ctw-text-content-black", children: "Results" }),
  /* @__PURE__ */ i.jsx(
    Tt,
    {
      className: "ctw-patient-observation-details",
      columns: ZW(),
      data: t,
      emptyMessage: "There are no observations available.",
      hidePagination: !0
    }
  )
] }), JW = (e) => [
  {
    label: "Effective Date",
    value: e.effectiveStart
  },
  { label: "Organization", value: e.performer }
], XW = ({ diagnosticReport: e }) => {
  const [t, n] = Y([]), [r, s] = Y(!1), [a, o] = Y(), { getRequestContext: c } = Xe();
  return he(() => {
    function l() {
      return V(this, null, function* () {
        s(!0);
        const d = yield c(), u = yield nl(d, [e]);
        o(ll(u, e.id)), s(!1);
      });
    }
    l();
  }, [e, c]), he(() => {
    n(Ee(e.observations));
  }, [e]), /* @__PURE__ */ i.jsxs("div", { className: "ctw-space-y-6", children: [
    /* @__PURE__ */ i.jsx("div", { className: "ctw-text-2xl", children: e.displayName }),
    r ? /* @__PURE__ */ i.jsx(Je, { message: "Loading data..." }) : /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
      /* @__PURE__ */ i.jsx(
        Ur,
        {
          details: JW(e),
          documentButton: /* @__PURE__ */ i.jsx(
            zr,
            {
              binaryId: a,
              documentTitle: e.resourceTypeTitle,
              telemetryTarget: "observation_details"
            }
          )
        }
      ),
      /* @__PURE__ */ i.jsx(KW, { data: t })
    ] })
  ] });
}, eV = He(XW, "Observations");
function $s(e = !0) {
  const { openDrawer: t } = Vn();
  return (n) => {
    t({
      component: (r) => /* @__PURE__ */ i.jsx(
        tV,
        X(R({
          diagnosticReport: n
        }, r), {
          enableDismissAndReadActions: e
        })
      ),
      trackingMetadata: { action: "observations_details" }
    });
  };
}
function tV({
  className: e,
  diagnosticReport: t,
  enableDismissAndReadActions: n,
  isOpen: r,
  onClose: s
}) {
  const a = Ya({
    enableDismissAndReadActions: n
  });
  return /* @__PURE__ */ i.jsxs(et, { className: e, title: "Diagnostic Report", isOpen: r, onClose: s, children: [
    /* @__PURE__ */ i.jsx(et.Body, { children: /* @__PURE__ */ i.jsx(eV, { diagnosticReport: t }) }),
    /* @__PURE__ */ i.jsx(et.Footer, { children: /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-justify-between", children: [
      /* @__PURE__ */ i.jsx(et.CloseButton, { onClose: s, label: "Close" }),
      /* @__PURE__ */ i.jsx(a, { record: t, onSuccess: s })
    ] }) })
  ] });
}
const nV = (e) => {
  const t = e.filter((r) => r.diagnosticReport ? !r.isIncorrectlyCodedGlucose : !0).sort((r, s) => r.effectiveStartRaw ? !s.effectiveStartRaw || r.effectiveStartRaw > s.effectiveStartRaw ? -1 : r.effectiveStartRaw < s.effectiveStartRaw ? 1 : 0 : s.effectiveStartRaw ? 1 : 0), n = {};
  return t.forEach((r) => {
    var s;
    (s = r.resource.code.coding) == null || s.forEach((a) => {
      var o;
      if (a.code && a.system === Yt) {
        const c = Vg[a.code];
        c && (n[c] || (n[c] = []), (o = n[c]) == null || o.push(r));
      }
    });
  }), js(n, (r) => wn(r, (s, a) => s.id === a.id));
}, rV = Ae`result {
  reference
  display
  resource {
    ...Observation
  }
}
contained {
  resource {
    ...Observation
  }
}`, t1 = (e) => Ae`    
  ${Xt}
  ${Yn}
  ${Fr}
  ${Ha}
  ${Gn}
  ${e ? Qg : ""}
  query DiagnosticReports(
    $upid: ID!
    $cursor: String!
    $sort: DiagnosticReportSortParams!
    $filter: DiagnosticReportFilterParams!
    $first: Int!
  ) {
    DiagnosticReportConnection(
      upid: $upid
      after: $cursor
      filter: $filter
      sort: $sort
      first: $first
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          resourceType
          BasicList(_reference: "subject") {
            ...Basic
          }
          meta {
            extension {
              url
              valueInstant
            }
          }
          extension {
            url
            valueString
          }
          status
          category {
            text
            coding {
              ...Coding
            }
          }
          code {
            text
            coding {
              ...Coding
            }
          }
          subject {
            reference
            resource {
              ...Patient
            }
          }
          effectiveDateTime
          effectivePeriod {
            start
            end
          }
          issued
          conclusion
          performer {
            reference
            resource {
              ...Practitioner
            }
          }
          ${e ? rV : ""}
        }
      }
    }
  }
`;
function Xa(e = jt, t = !1, n = !0) {
  return Oe(
    J9,
    [e, t],
    // Only use the IDs in our key (fixes issue with ciruclar references).
    sV,
    n
  );
}
function n1(e = jt) {
  const t = Xa(e, !0), [n, r] = Y([]);
  he(() => {
    const c = t.data;
    if (t.isLoading)
      return;
    const l = (f) => [f.displayName, f.effectiveStart], d = wn(
      c,
      (f, p) => bs(l(f), l(p))
    ), u = d.flatMap((f) => f.observations), h = nV(u);
    u.forEach((f) => {
      f.setTrends(h);
    }), r(d);
  }, [t.data, t.isLoading]);
  const { isLoading: s } = t, { isError: a } = t, { isFetching: o } = t;
  return {
    isLoading: s,
    isError: a,
    isFetching: o,
    data: n
  };
}
function sV(r, s) {
  return V(this, arguments, function* (e, t, n = []) {
    const [a, o] = n;
    return (yield aV(
      e,
      t,
      a,
      o
    )).DiagnosticReportConnection.edges.map(
      (d) => new qg(d.node, void 0, d.node.BasicList)
    );
  });
}
function aV(e, t, n, r) {
  return V(this, null, function* () {
    const s = Re(e), { data: a } = yield Ut(
      s,
      t1(r),
      "DiagnosticReportConnection",
      {
        upid: t.UPID,
        cursor: "DiagnosticReportConnection",
        filter: {
          tag: { nonematch: [yt] }
        },
        first: n
      }
    );
    return a;
  });
}
function iV(r, s) {
  return V(this, arguments, function* (e, t, n = []) {
    const a = Re(e), { data: o } = yield Ut(
      a,
      t1(!0),
      "DiagnosticReportConnection",
      {
        upid: t.UPID,
        cursor: "",
        first: 1e3,
        filter: {
          ids: { anymatch: n },
          tag: { nonematch: [yt] }
        }
      }
    );
    return o.DiagnosticReportConnection.edges.map(
      (c) => new qg(c.node, void 0, c.node.BasicList)
    );
  });
}
function oV({ className: e }) {
  const t = n1(), { data: n, filters: r, setFilters: s, setSort: a, defaultSort: o } = Rt({
    cacheKey: "patient-diagnostic-reports",
    defaultSort: YW,
    records: t.data
  }), c = ut(), d = !(t.data.length === 0) && n.length === 0, u = $s();
  return /* @__PURE__ */ i.jsx(ft, { componentName: "PatientDiagnosticReports", children: /* @__PURE__ */ i.jsxs(
    "div",
    {
      className: W(e, "ctw-scrollable-pass-through-height", "ctw-diagnostic-reports"),
      children: [
        /* @__PURE__ */ i.jsx(
          Ht,
          {
            filterOptions: {
              onChange: s,
              filters: GW(),
              selected: r
            },
            sortOptions: {
              defaultSort: o,
              options: X0,
              onChange: a
            }
          }
        ),
        /* @__PURE__ */ i.jsx(
          Tt,
          {
            showTableHead: !0,
            isLoading: t.isLoading,
            data: n,
            columns: qW(c),
            onRowClick: u,
            enableDismissAndReadActions: !0,
            emptyMessage: /* @__PURE__ */ i.jsx(
              xt,
              {
                hasZeroFilteredRecords: d,
                resourceName: "diagnostics"
              }
            )
          }
        )
      ]
    }
  ) });
}
const cV = He(
  oV,
  "PatientDiagnosticReports"
), r1 = "Select Labs", s1 = "All Labs", Po = (e, t) => {
  var n;
  return ((n = t.coding) == null ? void 0 : n.code) && e.includes(t.coding.code);
}, a1 = (e, t) => e.displayName.toLowerCase().includes(t), lV = (e, t) => Po(e, t) || a1(t, "a1c") ? Po(e, t) ? t.displayName : "A1c" : t.displayName, dV = (e) => [
  {
    key: "a1c",
    label: "Filter by A1C",
    description: "Contains a1c in text or if it includes an a1c code",
    predicate: (t) => Po(e, t) || a1(t, "a1c")
  },
  {
    key: "cbc",
    label: "Filter by CBC",
    description: "Match lowercase “cbc” or “complete blood count” but not containing “cd4/cd8”",
    predicate: (t) => /cbc(?!.*cd4\/cd8)|complete blood count/.test(t.displayName.toLowerCase())
  },
  {
    key: "cmp",
    label: "Filter by CMP",
    description: "Match lowercase “cmp” or “bmp” or “metabolic panel”",
    predicate: (t) => ["cmp", "bmp", "metabolic panel"].includes(t.displayName.toLowerCase())
  }
], uV = () => Jt("a1cCodes", [], (e, t) => V(void 0, null, function* () {
  const { data: n } = yield rt(
    `${sa(e.env)}/api/terminology/valuesets/a1c`,
    {
      headers: {
        Authorization: `Bearer ${e.authToken}`,
        "content-type": "application/json"
      }
    }
  );
  return n;
})), fV = ({
  onSeeAllResources: e
}) => {
  const [t, n] = Y([]), [r, s] = Y([]), a = $s(!1), { data: o, isLoading: c } = n1(), l = ut(), d = uV();
  he(() => {
    d.data && d.data.content && n(d.data.content.map((h) => h.code));
  }, [d.data]), he(() => {
    if (t.length > 0) {
      const h = Ee(
        dV(t).flatMap((f) => o.filter(f.predicate)[0])
      );
      s(h);
    }
  }, [t, o]);
  const u = o.length === 0;
  return /* @__PURE__ */ i.jsx(
    Ss,
    {
      onSeeAllResources: e,
      onRowClick: a,
      data: r,
      emptyMessage: u ? "We didn't find any lab records for this patient." : "There are no metabolic or CBC panel and A1C labs for this patient.",
      footerText: s1,
      hideFooter: u,
      title: r1,
      tooltipText: "Most recent Metabolic or CBC Panel and A1C",
      isLoading: c || d.isLoading,
      icon: uh,
      trackingName: "labs_overview",
      dataTestId: "labs-overview",
      children: (h) => /* @__PURE__ */ i.jsxs("div", { children: [
        /* @__PURE__ */ i.jsx(
          Wt,
          {
            title: lV(t, h),
            renderIcon: Lt(h.ownedByBuilder(l))
          }
        ),
        /* @__PURE__ */ i.jsxs("div", { className: "ctw-font-normal", children: [
          "Recorded: ",
          h.effectiveStart
        ] })
      ] })
    }
  );
}, hV = xn({
  component: fV,
  name: "PatientDiagnosticReportsOverview",
  title: r1,
  footerTitle: s1,
  tabToNavigateTo: "diagnostic-reports"
});
function pV(e) {
  const t = Av(), n = Ev();
  if (n.flagsError)
    return { ready: !0 };
  if (!n.flagsReady && !n.flagsError)
    return { ready: !1 };
  const r = t.getVariant(e);
  return X(R({}, r), { ready: !0 });
}
function mV(e, t) {
  var n;
  if (e.ready && e.enabled && ((n = e.payload) == null ? void 0 : n.type) === "json" && e.payload.value)
    try {
      const r = t.safeParse(JSON.parse(e.payload.value));
      if (!r.success)
        console.error(r.error);
      else
        return r.data;
    } catch (r) {
      console.error(r);
    }
}
const i1 = "ctw-zap-alerts-dismissed", gV = {
  caution: {
    icon: Lw,
    iconColor: "ctw-text-caution-icon",
    iconHover: "hover:ctw-bg-caution-light",
    messageColor: "ctw-text-caution-text",
    linkHover: "hover:ctw-text-caution-textHover",
    bg: "ctw-bg-caution-bg"
  },
  info: {
    icon: Fw,
    iconColor: "ctw-text-info-icon",
    iconHover: "hover:ctw-bg-info-light",
    messageColor: "ctw-text-info-text",
    linkHover: "hover:ctw-text-info-textHover",
    bg: "ctw-bg-info-bg"
  }
}, wV = Ce.object({
  type: Ce.enum(["caution", "info"]),
  message: Ce.string(),
  link: Ce.string().optional()
});
function vV({ className: e, featureFlag: t }) {
  const [n, r] = Y(!1), s = Te(null), a = wt(s), o = pV(t), c = mV(o, wV), l = yV();
  if (!c || l.includes(o.name) || n)
    return null;
  const d = gV[c.type];
  function u() {
    l.push(o.name), localStorage.setItem(i1, JSON.stringify(l)), r(!0);
  }
  return /* @__PURE__ */ i.jsxs(
    "div",
    {
      ref: s,
      className: W(e, d.bg, "ctw-p-3 ctw-flex ctw-space-x-7 ctw-justify-between"),
      children: [
        /* @__PURE__ */ i.jsxs("div", { className: "ctw-space-x-3 ctw-flex ctw-flex-grow", children: [
          /* @__PURE__ */ i.jsx(
            me,
            {
              icon: d.icon,
              className: W(d.iconColor, "ctw-h-5 ctw-flex-none")
            }
          ),
          /* @__PURE__ */ i.jsxs(
            "div",
            {
              className: W(
                d.messageColor,
                "ctw-justify-between ctw-flex ctw-flex-grow ctw-text-sm ctw-font-medium",
                a.sm ? "ctw-flex-col ctw-space-y-2" : "ctw-space-x-3"
              ),
              children: [
                /* @__PURE__ */ i.jsx("div", { children: c.message }),
                c.link && /* @__PURE__ */ i.jsx(
                  "a",
                  {
                    href: c.link,
                    className: W(d.linkHover, "ctw-underline ctw-whitespace-nowrap"),
                    target: "_blank",
                    rel: "noreferrer",
                    children: "Learn More"
                  }
                )
              ]
            }
          )
        ] }),
        /* @__PURE__ */ i.jsx(
          me,
          {
            onClick: u,
            icon: Fo,
            className: W(
              d.iconColor,
              d.iconHover,
              "ctw-flex-none ctw-cursor-pointer ctw-w-[22px] ctw-h-[22px] -ctw-mb-0.5"
              // Negative bottom margin is to prevent the height from increasing the height of the aler box.
            )
          }
        )
      ]
    }
  );
}
function yV() {
  try {
    const e = localStorage.getItem(i1);
    return e ? JSON.parse(e) : [];
  } catch (e) {
    return [];
  }
}
const xV = ({ className: e }) => /* @__PURE__ */ i.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 60 60", fill: "none", className: e, children: [
  /* @__PURE__ */ i.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.5108 15.3194V20.4258H9.80861C5.97877 20.4258 3 23.511 3 27.2344V50.2135C3 54.0433 5.97877 57.0221 9.80861 57.0221H30.0649C27.5176 54.0467 25.9791 50.1821 25.9791 45.9581C25.9791 36.5574 33.5999 28.9366 43.0006 28.9366C45.7557 28.9366 48.3579 29.5912 50.6603 30.7533V27.2344C50.6603 23.511 47.5751 20.4258 43.8517 20.4258H42.1495V15.3194C42.1495 6.91499 35.2345 0 26.8301 0C18.3194 0 11.5108 6.91499 11.5108 15.3194ZM18.3194 20.4258V15.3194C18.3194 10.6385 22.0428 6.80861 26.8301 6.80861C31.5111 6.80861 35.3409 10.6385 35.3409 15.3194V20.4258H18.3194Z",
      fill: "#9CA3AF"
    }
  ),
  /* @__PURE__ */ i.jsx(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M28.5323 45.6744C28.5323 37.8926 34.9351 31.4898 42.8154 31.4898C50.5972 31.4898 57 37.8926 57 45.6744C57 53.5548 50.5972 59.859 42.8154 59.859C34.9351 59.859 28.5323 53.5548 28.5323 45.6744ZM49.0191 42.5203C49.6102 41.9293 49.6102 40.8457 49.0191 40.2547C48.4281 39.6637 47.3446 39.6637 46.7535 40.2547L43.2074 43.8994L39.5627 40.2547C38.9717 39.6637 37.8882 39.6637 37.2971 40.2547C36.7061 40.8457 36.7061 41.9293 37.2971 42.5203L40.9418 46.0665L37.2971 49.7111C36.7061 50.3022 36.7061 51.3857 37.2971 51.9767C37.8882 52.5677 38.9717 52.5677 39.5627 51.9767L43.2074 48.3321L46.7535 51.9767C47.3446 52.5677 48.4281 52.5677 49.0191 51.9767C49.6102 51.3857 49.6102 50.3022 49.0191 49.7111L45.3745 46.0665L49.0191 42.5203Z",
      fill: "#9CA3AF"
    }
  )
] }), bV = "data:image/svg+xml;base64,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";
const jV = va(
  ({ collapse: e }, t) => {
    var r, s, a, o;
    const { patient: n } = Ze();
    return /* @__PURE__ */ i.jsxs(
      "div",
      {
        className: W(
          "ctw-flex ctw-h-full ctw-text-content-black ctw-w-fit",
          e ? "ctw-px-4 ctw-py-3 ctw-space-x-1 ctw-items-end" : "ctw-flex-col ctw-px-5 ctw-py-2 ctw-whitespace-nowrap"
        ),
        ref: t,
        "data-testid": "ctw-zap-patient-header",
        children: [
          /* @__PURE__ */ i.jsx("div", { className: "ctw-flex ctw-font-medium", children: /* @__PURE__ */ i.jsxs("div", { className: "ctw-min-w-fit ctw-space-x-1", children: [
            /* @__PURE__ */ i.jsxs("span", { children: [
              (r = n.data) == null ? void 0 : r.givenName,
              " ",
              (s = n.data) == null ? void 0 : s.lastName
            ] }),
            ((a = n.data) == null ? void 0 : a.gender) && /* @__PURE__ */ i.jsxs("span", { children: [
              "(",
              n.data.gender[0].toUpperCase(),
              ")"
            ] })
          ] }) }),
          /* @__PURE__ */ i.jsx("div", { className: "ctw-text-sm ctw-whitespace-nowrap", children: ((o = n.data) == null ? void 0 : o.dob) && n.data.age !== void 0 && `${n.data.dob} (${n.data.age})` })
        ]
      }
    );
  }
), Ml = ({ className: e, hasData: t = !0 }) => /* @__PURE__ */ i.jsx(
  "span",
  {
    className: W(
      e,
      "ctw-relative ctw-bottom-1 ctw-break-keep ctw-text-[10px] ctw-uppercase",
      "ctw-text-black",
      { "ctw-text-content-lighter": !t }
    ),
    children: "beta"
  }
);
const CV = ({
  score: e,
  radioGroupName: t,
  selectedScore: n,
  onChange: r,
  itemText: s,
  className: a
}) => {
  const o = [mv, gv, wv, vv], c = () => {
    r(e);
  }, l = (d) => {
    d.key === "Enter" && r(e);
  };
  return /* @__PURE__ */ i.jsxs(
    "div",
    {
      className: W(a, "ctw-ai-feedback-item", { "ctw-bg-primary-light": n }),
      onClick: c,
      onKeyDown: l,
      children: [
        /* @__PURE__ */ i.jsx(
          "input",
          {
            className: "custom-radio",
            type: "radio",
            name: t,
            value: e,
            checked: n,
            onChange: () => r(e)
          }
        ),
        /* @__PURE__ */ i.jsx("div", { children: s }),
        /* @__PURE__ */ i.jsx(me, { icon: o[e - 1], className: "ctw-h-5 ctw-w-5" })
      ]
    }
  );
}, NV = ({
  title: e,
  radioGroupName: t,
  options: n,
  onChange: r
}) => {
  const [s, a] = Y(0), o = (l) => {
    r(l), a(l);
  }, c = n.map((l, d) => /* @__PURE__ */ i.jsx(
    CV,
    {
      score: d + 1,
      radioGroupName: t,
      itemText: l,
      selectedScore: s === d + 1,
      onChange: o,
      className: `ctw-p-4 ${d === 0 ? "ctw-rounded-b-lg" : ""} ${d === n.length - 1 ? "ctw-rounded-t-lg" : ""}`
    },
    `${t}-${l}`
  )).reverse();
  return /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
    /* @__PURE__ */ i.jsx("h3", { className: "ctw-font-medium", children: e }),
    /* @__PURE__ */ i.jsx("div", { children: c })
  ] });
};
const DV = ({ initialFeedback: e, onFeedbackUpdate: t }) => {
  const [n, r] = Y(e), s = (o) => (c) => {
    const { value: l } = c.target, d = X(R({}, n), {
      [o]: o.endsWith("Rating") ? Number(l) : l
    });
    r(d), t(d);
  }, a = [
    "Not useful at all",
    "Somewhat useful",
    "Mostly useful",
    "Very useful"
  ];
  return /* @__PURE__ */ i.jsxs("div", { className: "ctw-ai-feedback-form", children: [
    /* @__PURE__ */ i.jsx("div", { children: /* @__PURE__ */ i.jsx("h1", { className: "ctw-uppercase ctw-text-xs ctw-font-medium ctw-text-content-light ctw-py-2", children: "Share your feedback" }) }),
    /* @__PURE__ */ i.jsx(
      NV,
      {
        options: a,
        title: "How useful was this summary at getting you up to speed on this patient?",
        radioGroupName: "usefulnessRating",
        onChange: (o) => s("usefulnessRating")({ target: { value: o.toString() } })
      }
    ),
    /* @__PURE__ */ i.jsxs("div", { children: [
      /* @__PURE__ */ i.jsx("h3", { className: "ctw-font-medium", children: "Please provide any details you think might be helpful" }),
      /* @__PURE__ */ i.jsx(
        "textarea",
        {
          className: "ctw-listbox-textarea ctw-w-full ctw-whitespace-pre-wrap ctw-resize-none",
          value: n.usefulnessFeedback,
          name: "accuracy_textarea",
          onChange: s("usefulnessFeedback"),
          placeholder: "Type your answer here"
        }
      )
    ] }),
    /* @__PURE__ */ i.jsxs("div", { children: [
      /* @__PURE__ */ i.jsx("h3", { className: "ctw-font-medium", children: "Do you have any other feedback you like to share?" }),
      /* @__PURE__ */ i.jsx(
        "textarea",
        {
          className: "ctw-listbox-textarea ctw-w-full ctw-whitespace-pre-wrap ctw-resize-none",
          value: n.otherFeedback,
          onChange: s("otherFeedback"),
          placeholder: "Type your answer here"
        }
      )
    ] })
  ] });
}, SV = ({
  feedbackEnabled: e,
  onFeedbackClick: t,
  onClose: n
}) => {
  const r = e ? "ctw-btn-primary" : "ctw-btn-default";
  return /* @__PURE__ */ i.jsxs("div", { className: "ctw-ai-summary-drawer-footer", children: [
    /* @__PURE__ */ i.jsx("button", { type: "button", className: "ctw-btn-clear hover:ctw-underline", onClick: n, children: "Close" }),
    /* @__PURE__ */ i.jsx(
      "button",
      {
        type: "button",
        className: r,
        disabled: !e,
        onClick: t,
        children: "Submit Feedback"
      }
    )
  ] });
};
const $V = ({
  onSummaryClick: e,
  onFeedbackClick: t,
  isFeedbackEnabled: n
}) => /* @__PURE__ */ i.jsxs("div", { className: "ctw-ai-summary-drawer-header ctw-font-medium", children: [
  /* @__PURE__ */ i.jsxs("div", { className: "ctw-space-x-1 ctw-flex ctw-items-center ctw-space-x-1.5", children: [
    /* @__PURE__ */ i.jsx("span", { className: "ctw-inline-block", children: /* @__PURE__ */ i.jsx(a0, { className: "ctw-h-5 ctw-w-5 ctw-text-primary-main" }) }),
    /* @__PURE__ */ i.jsx("span", { className: "ctw-text-lg ctw-font-semibold", children: "GPS" }),
    /* @__PURE__ */ i.jsx("span", { className: "ctw-uppercase ctw-text-content-light ctw-text-[10px] ctw-font-thin ctw-self-baseline", children: "beta" })
  ] }),
  /* @__PURE__ */ i.jsxs("div", { className: "ctw-space-x-2", children: [
    /* @__PURE__ */ i.jsx("button", { type: "button", className: "ctw-ai-summary-drawer-btn", onClick: e, children: "Summary" }),
    /* @__PURE__ */ i.jsx(
      "button",
      {
        type: "button",
        className: "ctw-ai-summary-drawer-btn",
        onClick: t,
        disabled: n,
        children: "Give Feedback"
      }
    )
  ] })
] }), ts = ({ citation: e, openDetails: t }) => {
  const n = (r) => {
    r.key === "Enter" && (t == null || t());
  };
  return /* @__PURE__ */ i.jsxs(
    "span",
    {
      className: "ctw-flex-shrink-0 ctw-align-super ctw-text-xs ctw-text-primary-dark ctw-cursor-pointer",
      onClick: t,
      onKeyDown: n,
      children: [
        "[",
        e.id,
        "]"
      ]
    }
  );
};
function o1(e) {
  if (e === void 0)
    return;
  const t = Ch.sanitize(e);
  return /* @__PURE__ */ i.jsx("div", { className: "ctw-overflow-auto", children: /* @__PURE__ */ i.jsx(Nh, { content: t }) });
}
const AV = (r) => {
  var s = r, {
    summary: e,
    isDetailShownOnOpen: t = !1
  } = s, n = ct(s, [
    "summary",
    "isDetailShownOnOpen"
  ]);
  const [a, o] = Y(t);
  return /* @__PURE__ */ i.jsxs("div", { className: "ctw-space-y-1", children: [
    /* @__PURE__ */ i.jsx(
      c1,
      {
        summary: e,
        isDetailShown: a,
        setIsDetailShown: o,
        className: "ctw-space-x-4 ctw-rounded-lg ctw-bg-bg-white ctw-p-3 ctw-outline ctw-outline-1 ctw-outline-bg-dark"
      }
    ),
    a && /* @__PURE__ */ i.jsx(Ur, R({}, n))
  ] });
}, c1 = ({
  summary: e,
  isDetailShown: t,
  setIsDetailShown: n,
  className: r
}) => {
  const { trackInteraction: s } = Be();
  return /* @__PURE__ */ i.jsxs(
    "button",
    {
      type: "button",
      "aria-label": "details",
      className: W(
        r,
        "ctw-flex ctw-items-center ctw-justify-between ctw-space-x-4 ctw-text-left ctw-w-full"
      ),
      onClick: () => (s("toggle_note", {
        action: t ? "collapse_note" : "expand_note"
      }), n(!t)),
      children: [
        /* @__PURE__ */ i.jsx("div", { className: "ctw-flex ctw-grow ctw-space-x-3", children: e }),
        /* @__PURE__ */ i.jsx("div", { className: "ctw-flex ctw-items-center ctw-space-x-3", children: /* @__PURE__ */ i.jsx("div", { className: "ctw-justify-right ctw-flex", children: /* @__PURE__ */ i.jsx(
          me,
          {
            icon: zo,
            className: W("ctw-h-3 ctw-w-3 ctw-text-content-lighter", {
              "ctw-rotate-90": t
            })
          }
        ) }) })
      ]
    }
  );
}, l1 = Ae`
  ${Xt}
  ${Yn}
  ${Gn}
  query Documents(
    $upid: ID!
    $cursor: String!
    $sort: DocumentReferenceSortParams!
    $filter: DocumentReferenceFilterParams! = {}
    $first: Int!
  ) {
    DocumentReferenceConnection(
      upid: $upid
      after: $cursor
      sort: $sort
      filter: $filter
      first: $first
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          resourceType
          BasicList(_reference: "subject") {
            ...Basic
          }
          masterIdentifier {
            system
            use
            value
          }
          meta {
            extension {
              url
              valueInstant
            }
            tag {
              system
              code
            }
            versionId
          }
          extension {
            url
            valueString
          }
          status
          docStatus
          type {
            text
            coding {
              ...Coding
            }
          }
          text {
            id
            div
          }
          category {
            text
            coding {
              ...Coding
            }
          }
          date
          custodian {
            reference
            resource {
              ...Organization
            }
          }
          description
          content {
            attachment {
              contentType
              language
              data
              url
              size
              hash
              title
              creation
            }
            format {
              system
              version
              code
              display
            }
          }
          context {
            period {
              start
              end
            }
            encounter {
              reference
            }
          }
        }
      }
    }
  }
`;
function Pl(e = jt, t = !0) {
  const n = Gt("ctw-2284-documents"), { data: r, isError: s, isFetching: a, isLoading: o } = ei(e, t);
  return {
    data: ke(
      () => nt(
        n ? IV(r != null ? r : []) : RF(r != null ? r : []),
        "resource.content[0].attachment.creation",
        ["desc"]
      ),
      [r, n]
    ),
    isError: s,
    isFetching: a,
    isLoading: o
  };
}
function ei(e = jt, t = !0) {
  return Oe(
    X9,
    [e],
    EV,
    t
  );
}
function EV(r, s) {
  return V(this, arguments, function* (e, t, n = []) {
    const a = n[0], o = Re(e), { data: c } = yield Ut(
      o,
      l1,
      "DocumentReferenceConnection",
      {
        upid: t.UPID,
        cursor: "",
        first: a
      }
    );
    return c.DocumentReferenceConnection.edges.map(
      (l) => new hn(l.node, void 0, l.node.BasicList)
    );
  });
}
function d1(r, s) {
  return V(this, arguments, function* (e, t, n = []) {
    const a = Re(e), { data: o } = yield dt(a, l1, {
      upid: t.UPID,
      cursor: "",
      first: 1e3,
      filter: {
        ids: { anymatch: n },
        tag: { nonematch: [yt] }
      },
      sort: {
        lastUpdated: "DESC"
      }
    });
    return o.DocumentReferenceConnection.edges.map((c) => new hn(c.node));
  });
}
const IV = (e) => {
  const t = _V(e), n = (s) => t.find((a) => a.id === s.id), r = e.filter(
    (s) => s.isImage || s.isPdf || s.isCDA && n(s.resource) && !s.isZusGeneratedReciprocityDocument
  );
  return wn(r, (s, a) => bs(qf(s), qf(a)));
}, _V = (e) => {
  const t = [], n = Dn(e, (r) => r.binaryId);
  return Object.keys(n).forEach((r) => {
    r ? t.push(nt(n[r], "category.length", "desc")[0]) : t.push(...n[r]);
  }), t;
}, qf = (e) => [
  e.encounterDate,
  e.dateCreated,
  e.custodian,
  e.title
], TV = (e) => {
  var a;
  const t = ei(), { binaryId: n, id: r } = e, s = ca(e) ? [e] : Nc(
    (a = t.data) == null ? void 0 : a.filter(
      (o) => o.binaryId === n && !Hg(o) && ca(o)
    ),
    "title"
  );
  return /* @__PURE__ */ i.jsxs("div", { className: "ctw-space-y-4", children: [
    /* @__PURE__ */ i.jsx("div", { className: "ctw-text-lg ctw-font-semibold", children: "Notes" }),
    s.map((o, c) => /* @__PURE__ */ i.jsx(
      AV,
      {
        summary: o.title ? /* @__PURE__ */ i.jsx("div", { className: "ctw-font-semibold ctw-text-content-black", children: o.title }) : /* @__PURE__ */ i.jsx("div", { className: "ctw-text-content-lighter", children: "Unknown" }),
        hideEmpty: !1,
        details: [
          {
            value: o1(o.displayContent),
            transposeTables: !0
          }
        ],
        isDetailShownOnOpen: o.id === r
      },
      `${o.id}-${c}`
    ))
  ] });
}, Ol = ({
  rowActions: e
}) => _t({
  header: (t) => t.title,
  details: RV,
  rowActions: e,
  enableDismissAndReadActions: !0,
  renderChild: TV
}), RV = (e) => [
  { label: "Encounter Date", value: e.encounterDate },
  { label: "Date Retrieved", value: e.dateCreated },
  { label: "Author", value: e.custodian }
], MV = (e) => e.resourceType === "Bundle";
function PV(e) {
  var n;
  const t = {};
  return MV(e) && ((n = e.entry) == null || n.forEach((r) => {
    const { resource: s } = r;
    if (!s)
      return;
    const a = `${s.resourceType}/${s.id}`;
    t[a] = s;
  })), t;
}
const OV = Ae`
  ${Xt}
  query MedicationAdministrations(
    $upid: ID!
    $cursor: String!
    $filter: MedicationAdministrationFilterParams!
    $sort: MedicationAdministrationSortParams!
    $first: Int!
  ) {
    MedicationAdministrationConnection(
      upid: $upid
      after: $cursor
      filter: $filter
      sort: $sort
      first: $first
    ) {
      pageInfo {
        hasNextPage
      }
      edges {
        node {
          id
          resourceType
          extension {
            url
            valueString
          }
          dosage {
            text
            dose {
              value
              unit
            }
            route {
              text
              coding {
                ...Coding
              }
            }
          }
          effectivePeriod {
            start
            end
          }
        }
      }
    }
  }
`, u1 = Ae`
  ${Xt}
  query MedicationDispenses(
    $upid: ID!
    $cursor: String!
    $filter: MedicationDispenseFilterParams!
    $sort: MedicationDispenseSortParams!
    $first: Int!
  ) {
    MedicationDispenseConnection(
      upid: $upid
      after: $cursor
      filter: $filter
      sort: $sort
      first: $first
    ) {
      pageInfo {
        hasNextPage
      }
      edges {
        node {
          id
          resourceType
          extension {
            url
            valueString
            valueInstant
          }
          contained {
            resource {
              ... on Practitioner {
                id
                resourceType
                name {
                  family
                  given
                }
                address {
                  text
                }
                telecom {
                  value
                }
              }
              ... on Organization {
                id
                resourceType
                _organization__name: name
                telecom {
                  value
                }
                address {
                  city
                  state
                  postalCode
                  text
                  line
                }
              }
            }
          }
          performer {
            actor {
              id
              extension {
                url
                valueString
              }
              reference
              type
              identifier {
                id
                system
                value
              }
              display
              resource {
                ... on Organization {
                  id
                  resourceType
                  name
                  telecom {
                    value
                  }
                  address {
                    city
                    state
                    postalCode
                    text
                    line
                  }
                }
              }
            }
          }
          status
          quantity {
            value
            unit
          }
          medicationCodeableConcept {
            text
            coding {
              ...Coding
            }
          }
          daysSupply {
            value
            unit
          }
          whenHandedOver
          whenPrepared
        }
      }
    }
  }
`, kV = Ae`
  ${Xt}
  ${Wa}
  query MedicationRequests(
    $upid: ID!
    $cursor: String!
    $filter: MedicationRequestFilterParams!
    $sort: MedicationRequestSortParams!
    $first: Int!
  ) {
    MedicationRequestConnection(
      upid: $upid
      after: $cursor
      filter: $filter
      sort: $sort
      first: $first
    ) {
      pageInfo {
        hasNextPage
      }
      edges {
        node {
          id
          resourceType
          extension {
            url
            valueString
          }
          authoredOn
          contained {
            resource {
              ... on Practitioner {
                id
                resourceType
                name {
                  family
                  given
                }
                address {
                  text
                }
                telecom {
                  value
                }
              }
              ... on Organization {
                id
                resourceType
                _organization__name: name
                telecom {
                  value
                }
                address {
                  city
                  state
                  postalCode
                  text
                  line
                }
              }
            }
          }
          dispenseRequest {
            performer {
              id
              extension {
                url
                valueString
              }
              reference
              type
              identifier {
                id
                system
                value
              }
              display
              resource {
                ... on Organization {
                  id
                  resourceType
                  name
                  telecom {
                    value
                  }
                  address {
                    city
                    state
                    postalCode
                    text
                    line
                  }
                }
              }
            }
            numberOfRepeatsAllowed
            initialFill {
              quantity {
                value
                unit
              }
            }
          }
          dosageInstruction {
            text
            timing {
              repeat {
                boundsPeriod {
                  start
                }
              }
            }
          }
          medicationCodeableConcept {
            text
            coding {
              ...Coding
            }
          }
          performer {
            ...Reference
          }
          requester {
            id
            extension {
              url
              valueString
            }
            reference
            type
            identifier {
              id
              system
              value
            }
            display
            resource {
              ... on Practitioner {
                id
                resourceType
                name {
                  family
                  given
                }
                address {
                  text
                }
                telecom {
                  value
                }
              }
            }
          }
          status
        }
      }
    }
  }
`, ti = Ae`
  ${Xt}
  ${Wa}
  ${Gn}
  query MedicationStatements(
    $upid: ID!
    $cursor: String!
    $filter: MedicationStatementFilterParams!
    $sort: MedicationStatementSortParams!
    $first: Int!
  ) {
    MedicationStatementConnection(
      upid: $upid
      after: $cursor
      filter: $filter
      sort: $sort
      first: $first
    ) {
      pageInfo {
        hasNextPage
      }
      edges {
        node {
          id
          resourceType
          BasicList(_reference: "subject") {
            ...Basic
          }
          meta {
            tag {
              system
              code
            }
            versionId
          }
          extension {
            url
            extension {
              url
              valueReference {
                id
                type
                reference
              }
            }
            valueDateTime
            valueString
            valueReference {
              id
              type
              reference
              display
            }
            valueQuantity {
              unit
              value
            }
            valueUnsignedInt
          }
          basedOn {
            type
          }
          category {
            text
            coding {
              ...Coding
            }
          }
          contained {
            resource {
              ... on Practitioner {
                id
                resourceType
                name {
                  family
                  given
                }
              }
              ... on Organization {
                id
                resourceType
                _organization__name: name
              }
              ... on Medication {
                id
                resourceType
                code {
                  text
                  coding {
                    ...Coding
                  }
                }
              }
            }
          }
          context {
            display
          }
          dateAsserted
          derivedFrom {
            display
          }
          dosage {
            text
          }
          effectivePeriod {
            start
          }
          identifier {
            value
          }
          informationSource {
            type
          }
          medicationCodeableConcept {
            text
            coding {
              ...Coding
            }
          }
          medicationReference {
            display
          }
          note {
            text
          }
          partOf {
            display
          }
          reasonCode {
            text
            coding {
              ...Coding
            }
          }
          reasonReference {
            ...Reference
          }
          status
          statusReason {
            text
            coding {
              ...Coding
            }
          }
          subject {
            resource {
              ... on Patient {
                managingOrganization {
                  resource {
                    ... on Organization {
                      name
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
function LV(e, t) {
  return V(this, null, function* () {
    const n = {
      informationSourceNot: "Patient"
      // exclude medication statements where the patient is the information source
    }, r = Re(e), { data: s } = yield dt(
      r,
      ti,
      {
        upid: t.UPID,
        cursor: "",
        first: 1e3,
        sort: {
          lastUpdated: "DESC"
        },
        filter: {
          tag: {
            nonematch: [yt, `${Ln}`]
            // TODO: There's a bug in FQS that doesn't allow filtering with nonematch AND allmatch.
            // Uncomment the line below once https://zeushealth.atlassian.net/browse/DRT-249 is resolved.
            // allmatch: [`${SYSTEM_ZUS_OWNER}|builder/${requestContext.builderId}`],
          }
        }
      }
    );
    let a = s.MedicationStatementConnection.edges.map((l) => l.node);
    a = yl(
      a,
      e.contextBuilderId || e.builderId
    );
    const o = a.map((l) => new Ot(l, void 0, l.BasicList));
    return HV(o, n, !1);
  });
}
function FV(e, t, n) {
  return V(this, null, function* () {
    if (n === void 0 || n.length === 0)
      return { bundle: void 0, medications: [], basic: [] };
    const r = Re(e), { data: s } = yield dt(
      r,
      ti,
      {
        upid: t.UPID,
        cursor: "",
        first: 1e3,
        sort: {
          lastUpdated: "DESC"
        },
        filter: {
          ids: {
            anymatch: n
          }
        }
      }
    );
    return { bundle: void 0, medications: s.MedicationStatementConnection.edges.map((o) => o.node), basic: [] };
  });
}
function BV(e, t, n) {
  return V(this, null, function* () {
    if (n === void 0 || n.length === 0)
      return [];
    const r = Re(e), { data: s } = yield dt(
      r,
      OV,
      {
        upid: t.UPID,
        cursor: "",
        first: 1e3,
        sort: {
          lastUpdated: "DESC"
        },
        filter: {
          ids: {
            anymatch: n
          }
        }
      }
    );
    return s.MedicationAdministrationConnection.edges.map((a) => a.node);
  });
}
function UV(e, t, n) {
  return V(this, null, function* () {
    if (n === void 0 || n.length === 0)
      return [];
    const r = Re(e), { data: s } = yield dt(
      r,
      u1,
      {
        upid: t.UPID,
        cursor: "",
        first: 1e3,
        sort: {
          lastUpdated: "DESC"
        },
        filter: {
          ids: {
            anymatch: n
          }
        }
      }
    );
    return s.MedicationDispenseConnection.edges.map((a) => a.node);
  });
}
function zV(e, t, n) {
  return V(this, null, function* () {
    if (n === void 0 || n.length === 0)
      return [];
    const r = Re(e), { data: s } = yield dt(
      r,
      kV,
      {
        upid: t.UPID,
        cursor: "",
        first: 1e3,
        sort: {
          lastUpdated: "DESC"
        },
        filter: {
          ids: {
            anymatch: n
          }
        }
      }
    );
    return s.MedicationRequestConnection.edges.map((a) => a.node);
  });
}
function HV(e, t = {}, n = !1) {
  let r = e;
  return n && (r = r.filter((s) => s.rxNorm !== void 0)), t.informationSource && (r = r.filter(
    (s) => {
      var a;
      return ((a = s.informationSource) == null ? void 0 : a.type) === t.informationSource;
    }
  )), t.informationSourceNot && (r = r.filter(
    (s) => {
      var a;
      return ((a = s.informationSource) == null ? void 0 : a.type) !== t.informationSourceNot;
    }
  )), r;
}
function WV(e, t) {
  return V(this, null, function* () {
    const n = Re(e), { data: r } = yield dt(
      n,
      ti,
      {
        upid: t.UPID,
        cursor: "",
        first: 1e3,
        sort: {
          lastUpdated: "DESC"
        },
        filter: {
          tag: {
            allmatch: [
              `${Fa}|Common`,
              `${En}|builder/${Oc(e.env)}`
            ]
          }
        }
      }
    );
    return r.MedicationStatementConnection.edges.map((a) => a.node).map((a) => new Ot(a, void 0, a.BasicList));
  });
}
function f1(r, s) {
  return V(this, arguments, function* (e, t, n = []) {
    const a = Re(e), { data: o } = yield dt(
      a,
      ti,
      {
        upid: t.UPID,
        cursor: "",
        sort: {},
        first: 500,
        filter: {
          ids: {
            anymatch: n
          }
        }
      }
    );
    return o.MedicationStatementConnection.edges.map(
      (c) => new Ot(c.node, void 0, c.node.BasicList)
    );
  });
}
function lK(e, t) {
  const n = PV(t);
  return e.filter((r) => Ua(r, n) !== void 0);
}
function VV(e, t) {
  const n = e.filter(
    (s) => !t.some((a) => a.rxNorm === s.rxNorm)
  );
  return {
    builderMedications: t.map((s) => {
      var d, u;
      const a = vo((h) => h.rxNorm === s.rxNorm, e);
      if (!a)
        return s;
      const o = Fn(s.resource), c = [
        mg,
        gg,
        wg,
        vg,
        yg,
        xg
      ];
      o.extension = (d = a.resource.extension) == null ? void 0 : d.filter(
        (h) => c.includes(h.url)
      );
      const l = Fn(
        vo({ url: Bc }, a.resource.extension)
      );
      return l && (l.url = Uc, (u = o.extension) == null || u.push(l)), new Ot(o, s.includedResources, s.basics);
    }),
    otherProviderMedications: n
  };
}
function qV(e) {
  return Oe(
    Ig,
    [e == null ? void 0 : e.id],
    GV(e)
  );
}
function GV(e) {
  return (t, n) => V(this, null, function* () {
    if (!e)
      return { medications: [], includedResources: {} };
    try {
      const r = new Ot(e).aggregatedFrom, s = Dn(r, "type"), a = js(
        s,
        (f) => Ee(f.map((p) => {
          var m;
          return MR((m = p.reference) == null ? void 0 : m.split("/"));
        }))
      ), [
        o,
        c,
        l,
        d
      ] = yield Promise.all([
        FV(
          t,
          n,
          a.MedicationStatement
        ),
        BV(
          t,
          n,
          a.MedicationAdministration
        ),
        zV(
          t,
          n,
          a.MedicationRequest
        ),
        UV(
          t,
          n,
          a.MedicationDispense
        )
      ]);
      let u = Dt([
        ...o.medications,
        ...c,
        ...l,
        ...d
      ]).map((f) => new HF(f));
      return u = Nc(u, (f) => f.resource.id), { medications: yn(
        wn(
          u,
          (f, p) => f.date === p.date && f.resource.resourceType === p.resource.resourceType
        ),
        "date",
        "desc",
        !0
      ), includedResources: {} };
    } catch (r) {
      throw new Error(`Failed fetching medication history for medication ${e.id}: ${r}`);
    }
  });
}
function YV(e) {
  var n;
  const t = qV(e.resource);
  return {
    data: (n = t.data) == null ? void 0 : n.medications.map(QV),
    isLoading: t.isLoading
  };
}
function QV(e) {
  if (e.resourceType === "MedicationStatement")
    return ZV(e);
  if (e.resourceType === "MedicationRequest")
    return KV(e);
  if (e.resourceType === "MedicationDispense")
    return JV(e);
  if (e.resourceType === "MedicationAdministration")
    return XV(e);
  throw new Error(`Unknown medication resource type "${e.resourceType}"`);
}
function ZV(e) {
  var r, s;
  const t = e.resource, n = new Ot(t, e.includedResources);
  return {
    date: e.dateLocal,
    id: e.id,
    title: "Medication Reviewed",
    hideEmpty: !1,
    subtitle: (s = (r = n.patient) == null ? void 0 : r.organization) == null ? void 0 : s.name,
    details: [
      {
        label: "Status",
        value: qe(n.displayStatus)
      },
      {
        label: "Instructions",
        value: n.dosage
      }
    ]
  };
}
function KV(e) {
  const t = e.resource, { prescriber: n } = e, { name: r, address: s, telecom: a } = new $o(
    t,
    e.includedResources
  ).pharmacy, { numberOfRepeatsAllowed: o = "", initialFill: c } = t.dispenseRequest || {}, { value: l = "", unit: d = "" } = (c == null ? void 0 : c.quantity) || {};
  return {
    date: e.dateLocal,
    id: e.id,
    title: "Prescription Ordered",
    subtitle: n,
    hideEmpty: !1,
    details: [
      { label: "Quantity", value: [l, d].join(" ") },
      {
        label: "Refills Allowed",
        value: o
      },
      {
        label: "Instructions",
        value: e.dosage
      },
      { label: "Prescriber", value: n },
      {
        label: "Pharmacy",
        value: /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
          r && /* @__PURE__ */ i.jsx("div", { children: r }),
          s && /* @__PURE__ */ i.jsx("div", { children: s }),
          a && /* @__PURE__ */ i.jsxs("div", { children: [
            "T: ",
            a
          ] })
        ] })
      }
    ]
  };
}
function JV(e) {
  const t = e.resource, n = new da(t, e.includedResources), { quantityDisplay: r, supplied: s, performerDetails: a } = n, { name: o, address: c, telecom: l } = a;
  return {
    date: e.dateLocal,
    hideEmpty: !1,
    id: e.id,
    title: "Medication Filled",
    subtitle: Ee([r, s ? `${s} supplied` : null]).join(", "),
    details: [
      { label: "Quantity", value: r },
      {
        label: "Days supply",
        value: s
      },
      {
        label: "Pharmacy",
        value: /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
          o && /* @__PURE__ */ i.jsx("div", { children: o }),
          c && /* @__PURE__ */ i.jsx("div", { children: c }),
          l && /* @__PURE__ */ i.jsxs("div", { children: [
            "T: ",
            l
          ] })
        ] })
      }
    ]
  };
}
function XV(e) {
  const t = e.resource, n = new So(t, e.includedResources);
  return {
    id: e.id,
    date: e.dateLocal,
    hideEmpty: !1,
    title: "Medication Administered",
    subtitle: Ee([n.dosageDisplay, n.dosageRoute]).join(", "),
    details: [
      { label: "Dosage", value: n.dosageDisplay },
      {
        label: "Route",
        value: n.dosageRoute
      },
      {
        label: "Start Date",
        value: n.effectivePeriod.start
      },
      {
        label: "End Date",
        value: n.effectivePeriod.end
      }
    ]
  };
}
function h1(e, t) {
  return t.map((n) => ({
    label: e,
    value: n
  }));
}
const eq = (e) => /* @__PURE__ */ i.jsx(pl, { getHistory: YV, model: e }), As = ({
  rowActions: e,
  enableDismissAndReadActions: t
}) => _t({
  header: (n) => n.display,
  renderChild: eq,
  details: (n) => {
    var r;
    return [
      { label: "Status", value: n.displayStatus },
      { label: "Last Fill Date", value: n.lastFillDate },
      { label: "Quantity", value: n.quantity },
      { label: "Days Supply", value: n.daysSupply },
      { label: "Refills", value: n.refills },
      { label: "Instructions", value: n.dosage },
      { label: "Prescriber", value: (r = n.lastPrescriber) != null ? r : "n/a" },
      { label: "Last Prescribed Date", value: n.lastPrescribedDate },
      ...h1("Note", n.notesDisplay)
    ];
  },
  rowActions: e,
  enableDismissAndReadActions: t
}), tq = Ae`
  ${Qg}

  query Observations(
    $upid: ID!
    $cursor: String!
    $sort: ObservationSortParams!
    $filter: ObservationFilterParams!
    $first: Int!
  ) {
    ObservationConnection(
      upid: $upid
      after: $cursor
      filter: $filter
      sort: $sort
      first: $first
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          ...Observation
        }
      }
    }
  }
`;
function p1(e, t, n) {
  return V(this, null, function* () {
    const r = Re(e), { data: s } = yield Ut(
      r,
      tq,
      "ObservationConnection",
      {
        upid: t.UPID,
        cursor: "",
        first: 500,
        filter: {
          ids: {
            anymatch: n
          },
          tag: { nonematch: [yt] }
        }
      }
    );
    return s.ObservationConnection.edges.map(({ node: a }) => new rl(a));
  });
}
const nq = ({ resourceInfo: e, citation: t }) => {
  const { isLoading: n, isError: r, data: s } = Oe(
    "ResourceByTypeAndIDQuery",
    [e.resourceID, e.resourceType],
    (m, C) => {
      switch (e.resourceType) {
        case "AllergyIntolerance":
          return F0(m, C, [e.resourceID]);
        case "Condition":
          return xl(m, C, [e.resourceID]);
        case "DocumentReference":
          return d1(m, C, [e.resourceID]);
        case "MedicationStatement":
          return f1(m, C, [e.resourceID]);
        case "Observation":
          return p1(m, C, [e.resourceID]);
        default:
          return Promise.resolve(null);
      }
    }
  ), a = o0(s == null ? void 0 : s[0], !n, !0), o = Cs(), c = _t({
    header: (m) => qe(m.display),
    details: El,
    renderChild: Al,
    getSourceDocument: !0
  }), l = Ka({}), d = Ol({}), u = As({}), h = _t({
    header: (m) => qe(m.display),
    details: (m) => [
      { label: "Value", value: m.value },
      { label: "Effective Date", value: m.effectiveStart }
    ],
    getSourceDocument: !0
  });
  if (n || r || !s || !Array.isArray(s) || s.length === 0)
    return null;
  const f = s[0], p = "Source Document";
  switch (f.resourceType) {
    case "AllergyIntolerance": {
      const m = f;
      return /* @__PURE__ */ i.jsx(
        ts,
        {
          citation: t,
          openDetails: () => a.data ? o(a.data, p) : c(m)
        }
      );
    }
    case "Condition": {
      const m = f;
      return /* @__PURE__ */ i.jsx(
        ts,
        {
          citation: t,
          openDetails: () => a.data ? o(a.data, p) : l(m)
        }
      );
    }
    case "DocumentReference": {
      const m = f;
      return /* @__PURE__ */ i.jsx(
        ts,
        {
          citation: t,
          openDetails: () => m.binaryId ? o(m.binaryId, p) : d(m)
        }
      );
    }
    case "MedicationStatement": {
      const m = f;
      return /* @__PURE__ */ i.jsx(
        ts,
        {
          citation: t,
          openDetails: () => a.data ? o(a.data, p) : u(m)
        }
      );
    }
    case "Observation": {
      const m = f;
      return /* @__PURE__ */ i.jsx(
        ts,
        {
          citation: t,
          openDetails: () => a.data ? o(a.data, p) : h(m)
        }
      );
    }
    default:
      return null;
  }
}, m1 = ({ content: e, citations: t }) => {
  const n = e.split(/(\[\d+\]|<br>)/g);
  return !t || t.length === 0 ? /* @__PURE__ */ i.jsx("span", { children: e }) : /* @__PURE__ */ i.jsx("div", { children: n.map((r, s) => {
    const a = t.find((o) => `[${o.id}]` === r);
    if (a) {
      const o = {
        resourceID: a.source_id,
        resourceType: a.source_resource_type
      };
      return /* @__PURE__ */ i.jsx(
        nq,
        {
          resourceInfo: o,
          citation: a
        },
        s
      );
    }
    return r === "<br>" ? /* @__PURE__ */ i.jsx("br", {}, s) : /* @__PURE__ */ i.jsx("span", { children: r }, s);
  }) });
}, ni = (e, t) => ({}).VITE_LOCAL_AI_URL ? `${{}.VITE_LOCAL_AI_URL}${t}` : `${Kt(e, "api.ai")}${t}`, kl = (e) => e.replace(/\n/g, "<br>"), rq = 5, sq = 2e3, aq = (e, t, n) => V(void 0, null, function* () {
  const r = ni(
    e.env,
    `/patients/${t}/summaries/${n}`
  ), s = yield rt(r, {
    headers: {
      Authorization: `Bearer ${e.authToken}`,
      "Content-Type": "application/json"
    },
    method: "PUT"
  });
  return s.data.hpi = kl(s.data.hpi), s.data;
}), iq = (e, t, n) => V(void 0, null, function* () {
  const r = ni(
    e.env,
    `/patients/${t}/summaries/${n}`
  ), s = yield rt(r, {
    headers: {
      Authorization: `Bearer ${e.authToken}`,
      "Content-Type": "application/json"
    },
    method: "GET"
  });
  return s.data.hpi = kl(s.data.hpi), s.data;
}), oq = {
  hpi: "An error occurred while fetching the summary",
  citations: []
}, Oo = {
  hpi: "Summary not found",
  citations: []
}, g1 = (e) => {
  const [t, n] = Y(!1), { patient: r } = Ze(), { getRequestContext: s } = Xe(), {
    data: a,
    isLoading: o,
    error: c,
    refetch: l
  } = Oe(
    M9,
    [e],
    (u, h) => V(void 0, null, function* () {
      try {
        if (!h.UPID)
          return { hpi: "", citations: [] };
        const f = yield iq(u, h.UPID, e);
        return f.upid = h.UPID, f;
      } catch (f) {
        return f instanceof dn && f.statusCode === 404 ? Oo : oq;
      }
    })
  );
  return {
    document: a,
    isLoading: o,
    isGenerating: t,
    error: c,
    generateDocument: () => V(void 0, null, function* () {
      var u;
      n(!0);
      try {
        const h = yield s(), f = ((u = r.data) == null ? void 0 : u.UPID) || "unknown-upid";
        return yield aq(h, f, e), Zc(
          () => V(void 0, null, function* () {
            const p = yield l();
            if (p.data === Oo)
              throw new Error("Summary not found");
            return p;
          }),
          rq,
          sq
        );
      } catch (h) {
        throw $e.logger.error(
          "Error generating summary",
          c instanceof Error ? c : new Error(String(c))
        ), new Error("Error generating summary");
      } finally {
        n(!1);
      }
    })
  };
}, w1 = ({ document: e }) => e ? e === Oo ? /* @__PURE__ */ i.jsx(
  Nn,
  {
    title: "A summary is not available for this patient.",
    icon: /* @__PURE__ */ i.jsx(L7, { className: "ctw-h-16 ctw-text-content-light" })
  }
) : /* @__PURE__ */ i.jsxs("div", { className: "ctw-bg-bg-lighter ctw-p-4 ctw-rounded-lg", children: [
  /* @__PURE__ */ i.jsxs("span", { className: "ctw-uppercase ctw-text-xs ctw-text-content-light ctw-font-medium", children: [
    "Summary of all available information - ",
    PL(e.createdAt)
  ] }),
  /* @__PURE__ */ i.jsx(m1, { citations: e.citations, content: e.hpi }),
  /* @__PURE__ */ i.jsx("div", { className: "ctw-italic ctw-text-xs ctw-pt-2", children: "This health record summary is generated using AI technology and is intended for informational purposes only. While efforts have been made to ensure accuracy, the information provided may not capture all relevant details or updates." })
] }) : /* @__PURE__ */ i.jsx(Je, {}), cq = He(
  w1,
  "PrecomputedSummary"
), lq = () => ({
  createdAt: (/* @__PURE__ */ new Date()).toISOString(),
  userId: "unknown",
  upid: "unknown",
  content: "",
  citations: [],
  usefulnessRating: 0,
  usefulnessFeedback: "",
  otherFeedback: ""
}), dq = (e, t) => V(void 0, null, function* () {
  const n = ni(e.env, "/feedback"), r = (/* @__PURE__ */ new Date()).toISOString(), s = qc(e.authToken), a = X(R({}, t), {
    createdAt: r,
    userId: s
  });
  return (yield rt(n, {
    headers: {
      Authorization: `Bearer ${e.authToken}`,
      "Content-Type": "application/json"
    },
    method: "POST",
    body: JSON.stringify(a)
  })).data;
}), uq = (e) => {
  const [t, n] = Y(!1), r = Oe(
    T9,
    [JSON.stringify(e)],
    (a) => V(void 0, null, function* () {
      try {
        return yield dq(a, e);
      } catch (o) {
        throw new Error(`Failed to fetch feedback: ${o}`);
      }
    }),
    t
  ), s = vt(() => (n(!0), r.refetch()), [r]);
  return X(R({}, r), { triggerFeedback: s });
}, fq = ({
  onClose: e,
  summaryType: t,
  className: n,
  isOpen: r
}) => {
  var b;
  const [s, a] = Y(lq()), [o, c] = Y(!1), [l, d] = Y(!1), { patient: u } = Ze(), h = Te(null), f = Te(null);
  he(() => {
    var j;
    (j = u.data) != null && j.UPID && a(
      (D) => X(R({}, D), {
        upid: u.data.UPID
      })
    );
  }, [(b = u.data) == null ? void 0 : b.UPID]);
  const { document: p, generateDocument: m } = g1(t), { triggerFeedback: C } = uq(s), y = () => {
    h.current && h.current.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }, g = () => {
    h.current && f.current && h.current.scrollTo({
      top: f.current.offsetTop,
      behavior: "smooth"
    });
  }, w = (j) => {
    const D = X(R({}, j), {
      content: (p == null ? void 0 : p.hpi) || "",
      citations: (p == null ? void 0 : p.citations) || []
    });
    a(D), D.usefulnessRating > 0 && d(!0);
  }, x = () => {
    o9({ type: "success", title: "Feedback Sent!" }), C(), c(!0);
  }, S = () => {
    e();
  }, N = () => {
    m();
  }, v = o ? void 0 : /* @__PURE__ */ i.jsx(DV, { initialFeedback: s, onFeedbackUpdate: w });
  return /* @__PURE__ */ i.jsx("div", { children: /* @__PURE__ */ i.jsxs(et, { className: n, isOpen: r, onClose: e, children: [
    /* @__PURE__ */ i.jsx(
      $V,
      {
        onFeedbackClick: g,
        onSummaryClick: y,
        isFeedbackEnabled: o
      }
    ),
    /* @__PURE__ */ i.jsx(et.Body, { children: /* @__PURE__ */ i.jsxs("div", { ref: h, className: "ctw-ai-summary-drawer-content", children: [
      /* @__PURE__ */ i.jsx("div", { children: /* @__PURE__ */ i.jsx(
        w1,
        {
          onGenerateSummary: N,
          document: p
        }
      ) }),
      /* @__PURE__ */ i.jsx("div", { ref: f, children: v })
    ] }) }),
    /* @__PURE__ */ i.jsx(et.Footer, { children: /* @__PURE__ */ i.jsx(
      SV,
      {
        feedbackEnabled: !o && l,
        onClose: S,
        onFeedbackClick: x
      }
    ) })
  ] }) });
};
function hq() {
  const { openDrawer: e } = Vn();
  return (t, n) => {
    e({
      component: (r) => /* @__PURE__ */ i.jsx(
        fq,
        X(R({
          summaryType: "new_patient"
        }, r), {
          onClose: () => {
            r.onClose();
          }
        })
      ),
      trackingMetadata: R({ resourceType: t == null ? void 0 : t.resourceType }, n)
    });
  };
}
function qs(e) {
  const { condition: t, children: n } = e;
  return /* @__PURE__ */ i.jsx(i.Fragment, { children: t && n });
}
function pq({
  children: e,
  className: t,
  content: n,
  forceHorizontalTabs: r = !1,
  selectedZapTabIndex: s,
  setSelectedTab: a,
  tabOrder: o,
  topRightContent: c
}) {
  const l = Te(null), d = Te(null), u = Te(null), h = Te(null), f = wt(h), [p, m] = Y(n.length), C = Gt("ctw-hpi-interactive"), y = hq(), { trackInteraction: g } = Be(), [w, x] = Y({ 0: !0 });
  he(() => {
    var _, L;
    if (f.sm && !r) {
      m(0);
      return;
    }
    const b = h.current;
    if (!b)
      return;
    let { width: j } = b.getBoundingClientRect();
    l.current && (j -= l.current.getBoundingClientRect().width), d.current && (j -= d.current.getBoundingClientRect().width);
    const D = (L = (_ = u.current) == null ? void 0 : _.getBoundingClientRect().width) != null ? L : 0, $ = Array.from(b.querySelectorAll("button.ctw-tab"));
    m(
      $.filter((I, A) => (j -= I.getBoundingClientRect().width, A < $.length - 1 ? j >= D : j >= 0)).length
    );
  }, [f, r]), he(() => {
    g("open_tab", { value: o[0], customMetadata: { default: !0 } });
  }, []), he(() => {
    w[s] || x(X(R({}, w), { [s]: !0 }));
  }, [s, w]);
  const S = vt(
    (b) => {
      a(b), wq(), g("open_tab", { value: o[b] });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [g, o]
  ), N = !!c, v = n.slice(p);
  return /* @__PURE__ */ i.jsx(
    "div",
    {
      ref: h,
      className: W(t, "ctw-zap-tab-group ctw-scrollable-pass-through-height ctw-w-full"),
      children: /* @__PURE__ */ i.jsxs(Gr.Group, { selectedIndex: s, onChange: S, children: [
        /* @__PURE__ */ i.jsxs(
          "div",
          {
            className: W(
              "ctw-flex ctw-border-b ctw-border-divider-main, ctw-sticky ctw-z-50 ctw-top-0 ctw-bg-white",
              p === 0 ? "ctw-flex-col" : "ctw-items-end"
            ),
            children: [
              /* @__PURE__ */ i.jsx(jV, { collapse: p === 0, ref: d }),
              /* @__PURE__ */ i.jsxs(
                "div",
                {
                  className: W(
                    "ctw-w-full ctw-flex",
                    "ctw-border-divider-light ctw-border-default ctw-bg-white",
                    p === 0 && "ctw-bg-white ctw-underline-light ctw-border-t ctw-border-default ctw-border-divider-light ctw-justify-between"
                  ),
                  children: [
                    /* @__PURE__ */ i.jsxs(
                      Gr.List,
                      {
                        className: W(
                          "ctw-flex",
                          p === 0 && "after:ctw-bg-content-black",
                          p > 0 && "ctw-rounded-t-md ctw-border-t ctw-border-x ctw-border-divider-main"
                        ),
                        children: [
                          n.map(({ key: b, display: j }, D) => /* @__PURE__ */ i.jsx(
                            Gr,
                            {
                              className: ({ selected: $ }) => W(
                                [
                                  "ctw-tab ctw-whitespace-nowrap ctw-text-sm ctw-capitalize",
                                  "hover:after:ctw-bg-content-black",
                                  "focus-visible:ctw-outline-primary-dark focus-visible:after:ctw-bg-transparent"
                                ],
                                {
                                  "after:ctw-bg-content-black": $,
                                  "ctw-text-content-light": !$
                                },
                                { "ctw-invisible !ctw-absolute": D >= p }
                                // Still render tab so we can derive width.
                              ),
                              children: /* @__PURE__ */ i.jsx("div", { className: "ctw-divider-wrapper", children: j() })
                            },
                            b
                          )),
                          /* @__PURE__ */ i.jsx(qs, { condition: p < n.length, children: /* @__PURE__ */ i.jsx(
                            Cl,
                            {
                              ref: u,
                              selectedIndex: s - p,
                              btnClassName: W(
                                "ctw-more-tab ctw-text-sm ctw-whitespace-nowrap ctw-capitalize ctw-flex-shrink-0 ctw-h-full",
                                "hover:after:ctw-bg-content-black",
                                {
                                  "after:ctw-bg-content-black": s - p >= 0
                                }
                              ),
                              optionsClassName: W(
                                "ctw-tab-list ctw-capitalize",
                                !N && p > 2 && "ctw-right-0"
                                // Right-align dropdown if it is rightmost (and not leftmost)
                              ),
                              onChange: (b) => S(b + p),
                              items: v,
                              children: p !== 0 ? /* @__PURE__ */ i.jsx("span", { children: "More" }) : void 0
                            }
                          ) })
                        ]
                      }
                    ),
                    C && /* @__PURE__ */ i.jsx("div", { className: "ctw-flex ctw-pl-6 ctw-py-1", ref: l, children: /* @__PURE__ */ i.jsxs(
                      "button",
                      {
                        type: "button",
                        className: "ctw-px-5 ctw-flex ctw-space-x-1 ctw-flex-shrink-0 ctw-items-center ctw-whitespace-nowrap hover:ctw-bg-bg-lighter hover:ctw-rounded-md ctw-font-medium",
                        onClick: () => y(),
                        children: [
                          /* @__PURE__ */ i.jsx("span", { className: "ctw-inline-block", children: /* @__PURE__ */ i.jsx(a0, { className: "ctw-h-5 ctw-w-5 ctw-text-primary-main" }) }),
                          /* @__PURE__ */ i.jsx("span", { className: "ctw-text-lg ctw-text-content-black", children: "GPS" }),
                          /* @__PURE__ */ i.jsx(Ml, { hasData: !1 })
                        ]
                      }
                    ) })
                  ]
                }
              )
            ]
          }
        ),
        e,
        /* @__PURE__ */ i.jsx(Gr.Panels, { className: "ctw-scrollable-content ctw-bg-white ctw-px-4", children: n.map((b, j) => /* @__PURE__ */ i.jsx(
          Gr.Panel,
          {
            className: W("ctw-scrollable-pass-through-height"),
            unmount: !1,
            children: w[j] && b.render(f.sm)
          },
          b.key
        )) })
      ] })
    }
  );
}
function mq(e) {
  var a;
  const { selectedZapTabIndex: t, setSelectedTab: n, tabOrder: r } = tt(Jn), { patient: s } = Ze();
  return !((a = s.data) != null && a.UPID) || r.length === 0 ? null : /* @__PURE__ */ i.jsx(
    pq,
    X(R({}, e), {
      selectedZapTabIndex: t,
      setSelectedTab: n,
      tabOrder: r
    })
  );
}
const gq = He(mq, "TabGroup");
function wq() {
  typeof document != "undefined" && requestAnimationFrame(() => {
    document.activeElement instanceof HTMLElement && document.activeElement.blur();
  });
}
const vq = (e, t, n) => V(void 0, null, function* () {
  const r = ni(e.env, `/patients/${t}/summary`), s = n ? "POST" : "GET", a = n ? JSON.stringify(n) : void 0, o = yield rt(r, {
    headers: {
      Authorization: `Bearer ${e.authToken}`,
      "Content-Type": "application/json"
    },
    method: s,
    body: a
  });
  return o.data.hpi = kl(o.data.hpi), o.data.createdAt === "" ? o.data.createdAt = void 0 : o.data.createdAt = new Date(o.data.createdAt), o.data;
}), yq = (e, t) => Oe(
  R9,
  [],
  (n, r) => V(void 0, null, function* () {
    try {
      if (!e || !t || !r.UPID)
        return { hpi: "", citations: [], createdAt: /* @__PURE__ */ new Date() };
      const s = yield vq(n, r.UPID, {
        upid: r.UPID,
        reasonForVisit: e,
        specialty: t
      });
      return s.upid = r.UPID, s;
    } catch (s) {
      throw new Error(`Failed to fetch patient summary: ${s}`);
    }
  })
), xq = ({ className: e }) => {
  const [t, n] = Y(""), [r, s] = Y(""), { isLoading: a, isFetching: o, isRefetching: c, isError: l, data: d, refetch: u } = yq(
    t,
    r
  ), h = vt(
    (m) => {
      m.preventDefault(), u();
    },
    [u]
  ), f = W(
    "ctw-text-field",
    "ctw-text-field--full-width",
    "ctw-ml-3",
    "ctw-mr-3",
    "ctw-pl-2",
    "ctw-pr-2",
    "ctw-border",
    "ctw-border-gray-300",
    "ctw-rounded-md"
  ), p = a || o || c;
  return /* @__PURE__ */ i.jsxs("div", { className: "ctw-mt-1", children: [
    /* @__PURE__ */ i.jsxs("form", { className: "ctw-flex", onSubmit: (m) => h(m), children: [
      /* @__PURE__ */ i.jsx("span", { className: "ctw-align-middle ctw-pt-0.5", children: "Reason for Visit" }),
      /* @__PURE__ */ i.jsx(
        "input",
        {
          type: "text",
          name: "reasonForVisit",
          value: t,
          onChange: (m) => n(m.target.value),
          className: f
        }
      ),
      /* @__PURE__ */ i.jsx("span", { className: "ctw-align-middle ctw-pt-0.5", children: "Specialty" }),
      /* @__PURE__ */ i.jsx(
        "input",
        {
          type: "text",
          name: "specialty",
          value: r,
          onChange: (m) => s(m.target.value),
          className: f
        }
      ),
      /* @__PURE__ */ i.jsx(
        "button",
        {
          type: "submit",
          className: W(
            "ctw-font-bold",
            "ctw-border-2",
            "ctw-border-black",
            "ctw-rounded-md",
            "ctw-p-1"
          ),
          children: "Generate Draft Visit Note"
        }
      )
    ] }),
    /* @__PURE__ */ i.jsxs("div", { className: W(e, "ctw-scrollable-pass-through-height", "ctw-mt-2"), children: [
      p && /* @__PURE__ */ i.jsx(Je, {}),
      l && /* @__PURE__ */ i.jsx("div", { children: "Error" }),
      !p && (d == null ? void 0 : d.hpi) && /* @__PURE__ */ i.jsx(m1, { citations: d.citations, content: d.hpi })
    ] })
  ] });
}, bq = He(
  xq,
  "OnDemandSummaryComponent"
), jq = ({ className: e }) => {
  const t = Gt("ctw-hpi-interactive"), { document: n, isLoading: r, generateDocument: s } = g1("new_patient"), a = () => {
    s();
  };
  return t ? /* @__PURE__ */ i.jsx(bq, { className: e }) : r ? /* @__PURE__ */ i.jsx(Je, {}) : /* @__PURE__ */ i.jsx(cq, { onGenerateSummary: a, document: n });
}, Cq = He(
  jq,
  "PatientChartReviewComponent"
), v1 = ({ className: e, hasData: t = !0 }) => /* @__PURE__ */ i.jsx(
  "span",
  {
    className: W(
      e,
      "ctw-relative ctw-bottom-1 ctw-break-keep ctw-text-[10px] ctw-uppercase",
      "ctw-text-black",
      { "ctw-text-content-lighter": !t }
    ),
    children: "prototype"
  }
), Nq = Ae`
  ${KF}

  query ServiceRequests($upid: ID!) {
    ServiceRequestConnection(upid: $upid) {
      edges {
        node {
          ...ServiceRequest
        }
      }
    }
  }
`;
function y1(e, t) {
  return V(this, null, function* () {
    const n = Re(e), { data: r } = yield Ut(
      n,
      Nq,
      "ServiceRequestConnection",
      {
        upid: t.UPID,
        cursor: "",
        first: 500
      }
    );
    return r.ServiceRequestConnection.edges.map(({ node: s }) => s);
  });
}
const x1 = ["8480-6", "8479-8", "8459-0", "8460-8"], b1 = ["8462-4", "8453-3", "8454-1"], j1 = ["8867-4", "8893-0"], C1 = ["8310-5", "8331-1"], N1 = ["9279-1"], D1 = [
  "59408-5",
  "2710-2",
  "2711-0",
  "20564-1",
  "59418-4",
  "2709-4",
  "59416-8",
  "59408-5",
  "19224-5"
], S1 = ["8302-2", "8306-3", "8301-4", "3138-5"], $1 = ["29463-7", "3141-9", "79348-9"], A1 = ["39156-5", "41909-3"], E1 = ["9843-4", "8287-5", "1554118"], I1 = ["8665-2", "3145-0"], _1 = ["95627-6", "52500-6", "72514-3"], T1 = [
  ...x1,
  ...b1,
  ...j1,
  ...C1,
  ...N1,
  ...D1,
  ...S1,
  ...$1,
  ...A1,
  ...E1,
  ...I1,
  ..._1
], Zi = {
  "conditions-all": "ConditionConnection",
  allergies: "AllergyIntoleranceConnection",
  "diagnostic-reports": "DiagnosticReportConnection",
  documents: "DocumentReferenceConnection",
  encounters: "EncounterConnection",
  immunizations: "ImmunizationConnection",
  "medications-all": "MedicationStatementConnection",
  vitals: "ObservationConnection",
  sources: "PatientConnection",
  "contact-information": "PatientConnection",
  "care-team": "CareTeamConnection"
};
function Dq(e) {
  const t = e.map((s) => Gf.filter((a) => a.tabName === s)).filter(Boolean), n = e.filter((s) => Zi[s]);
  return Ae`
    query CombinedQuery(
      $upid: ID!
      $cursor: String!
      $first: Int!
      ${t.map((s) => s.map((a) => `$${a.name}: ${a.type}!`).join(`
`)).join(`
`)}
      ) {
      ${n.map((s) => {
    var o;
    const a = (o = Gf.find((c) => c.tabName === s)) == null ? void 0 : o.name;
    switch (s) {
      case "sources":
        return Sq(Zi[s], a);
      default:
        return $q(Zi[s], a);
    }
  }).join(`
`)}
    }
  `;
}
function Sq(e, t) {
  return `
    ${e}: PatientConnection(
      upid: $upid
      after: $cursor
      filter: $${t}
      ${t ? "first: $PatientFirst" : ""}
    ) {
      edges {
        node {
          id
          resourceType
          meta {
            tag {
              system
              code
            }
          }
        }
      }
    }
  `;
}
function $q(e, t) {
  return `
    ${e}: ${e}(
      upid: $upid
      after: $cursor
      first: $first
      ${t ? `filter: $${t}` : ""}
    ) {
      edges {
        node {
          id
          resourceType
        }
      }
    }
  `;
}
const Gf = [
  { tabName: "sources", name: "PatientFilter", type: "PatientFilterParams" },
  { tabName: "sources", name: "PatientFirst", type: "Int" },
  { tabName: "vitals", name: "ObservationFilter", type: "ObservationFilterParams" },
  { tabName: "immunizations", name: "ImmunizationFilter", type: "ImmunizationFilterParams" }
];
function Aq(e = jt, t = !0, n = []) {
  return Oe(
    H9,
    [e, n],
    (r, s) => V(this, null, function* () {
      return Eq(r, s, e, n);
    }),
    t
  );
}
function Eq(s, a) {
  return V(this, arguments, function* (e, t, n = jt, r = []) {
    const o = T1.map((h) => `${Yt}|${h}`), c = Re(e), l = Dq(r), d = yield y1(e, t), { data: u } = yield dt(c, l, {
      upid: t.UPID,
      cursor: "",
      first: n,
      PatientFirst: jt,
      PatientFilter: {
        tag: {
          nonematch: [`${En}|builder/${e.builderId}`]
        }
      },
      ObservationFilter: {
        code: {
          anymatch: o
        }
      },
      ImmunizationFilter: {
        status: {
          eq: "completed"
        }
      }
    });
    return X(R({}, u), { serviceRequests: d });
  });
}
const Iq = ({
  resource: e,
  text: t,
  isBeta: n,
  isPrototype: r
}) => {
  const a = R1().get(e);
  return /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
    /* @__PURE__ */ i.jsx(
      "span",
      {
        className: W("ctw-capitalize ctw-text-black", { "ctw-text-content-lighter": !a }),
        children: t
      }
    ),
    n && /* @__PURE__ */ i.jsx(Ml, { hasData: a }),
    r && /* @__PURE__ */ i.jsx(v1, { hasData: a })
  ] });
};
function R1(e) {
  Ze();
  const { tabOrder: n } = tt(Jn), r = e || n, s = Aq(
    1,
    r.length > 0,
    r
  ), a = /* @__PURE__ */ new Map();
  return r.forEach((o) => {
    a.set(o, !0);
  }), s.isLoading || r.forEach((o) => {
    const c = _q(o, s);
    c && c.length < 1 && a.set(o, !1);
  }), a;
}
const _q = (e, t) => {
  var n, r, s, a, o, c, l, d, u, h, f, p;
  switch (e) {
    case "conditions-all":
      return (n = t.data) == null ? void 0 : n.ConditionConnection.edges;
    case "allergies":
      return (r = t.data) == null ? void 0 : r.AllergyIntoleranceConnection.edges;
    case "diagnostic-reports":
      return (s = t.data) == null ? void 0 : s.DiagnosticReportConnection.edges;
    case "documents":
      return (a = t.data) == null ? void 0 : a.DocumentReferenceConnection.edges;
    case "contact-information":
      return (o = t.data) == null ? void 0 : o.PatientConnection.edges;
    case "referrals":
      return (c = t.data) == null ? void 0 : c.serviceRequests;
    case "encounters":
      return (l = t.data) == null ? void 0 : l.EncounterConnection.edges;
    case "immunizations":
      return (d = t.data) == null ? void 0 : d.ImmunizationConnection.edges;
    case "medications-all":
      return (u = t.data) == null ? void 0 : u.MedicationStatementConnection.edges;
    case "vitals":
      return (h = t.data) == null ? void 0 : h.ObservationConnection.edges;
    case "sources":
      return (f = t.data) == null ? void 0 : f.PatientConnection.edges.filter(
        (m) => {
          var C, y;
          return !((y = (C = m.node.meta) == null ? void 0 : C.tag) != null && y.some(
            (g) => g.system === Fc && g.code === "universal"
          ));
        }
      );
    case "care-team":
      return (p = t.data) == null ? void 0 : p.CareTeamConnection.edges;
    default:
      return [];
  }
}, Gs = ({
  className: e,
  commaDelimit: t = !1,
  items: n,
  limit: r,
  total: s,
  prefix: a
}) => {
  const o = [...n];
  a && (o[0] = `${a} ${o[0]}`);
  const c = Math.min(r, o.length);
  return /* @__PURE__ */ i.jsxs("div", { className: e, children: [
    o.slice(0, c).map((l, d) => /* @__PURE__ */ i.jsx(
      "div",
      {
        "data-after": d + 1 < c ? ", " : "",
        className: W(
          t && "ctw-relative ctw-inline-block after:ctw-content-[attr(data-after)]"
        ),
        children: l
      },
      l + d
    )),
    s > r && /* @__PURE__ */ i.jsxs("div", { className: W("ctw-font-medium", t && "ctw-inline-block ctw-has-more"), children: [
      "+ ",
      s - c,
      " more"
    ] })
  ] });
}, Tq = (e) => [
  {
    render: (t) => /* @__PURE__ */ i.jsx("div", { className: "ctw-flex ctw-flex-nowrap ctw-space-x-2", children: Lt(
      t.ownedByBuilder(e) || t.syncedWithRecord
    ) }),
    width: "25px"
  },
  {
    title: "Date",
    widthPercent: 10,
    minWidth: 120,
    dataIndex: "dateDisplay"
  },
  {
    title: "Class",
    render: (t) => /* @__PURE__ */ i.jsx(Wt, { title: t.classDisplay })
  },
  {
    title: "Location",
    render: (t) => {
      const n = t.locationType.filter((r) => r.toLocaleLowerCase() !== "unknown");
      return /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
        /* @__PURE__ */ i.jsx(Gs, { items: t.location, limit: 3, total: t.location.length }),
        n.length > 0 && /* @__PURE__ */ i.jsxs("div", { className: "ctw-pt-2", children: [
          "Speciality: ",
          n.join(", ")
        ] })
      ] });
    }
  },
  {
    title: "Provider",
    render: (t) => /* @__PURE__ */ i.jsx(
      Gs,
      {
        items: t.practitioners,
        limit: 2,
        total: t.practitioners.length,
        commaDelimit: !0
      }
    )
  },
  {
    width: "28px",
    render: (t) => t.clinicalNotes.map((r) => r.title).sort().length > 0 ? /* @__PURE__ */ i.jsx(me, { className: "ctw-w-4 ctw-text-content-lighter", icon: Bw }) : null
  },
  {
    title: "Details",
    render: (t) => {
      const { dischargeDisposition: n } = t, { diagnoses: r } = t;
      return /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
        r.length > 0 && /* @__PURE__ */ i.jsx(Gs, { items: r, limit: 3, total: r.length, commaDelimit: !0 }),
        n && /* @__PURE__ */ i.jsxs("div", { className: "ctw-pt-2", children: [
          "Discharge: ",
          n
        ] })
      ] });
    }
  }
], ko = [
  {
    name: "Assessments / Plans",
    key: ["51847-2", "18776-5"].join(",")
  },
  {
    name: "Diagnostic Narratives",
    key: ["34109-9", "30954-2"].join(",")
  },
  {
    name: "Discharge Summary",
    key: "18842-5"
  },
  {
    name: "History of Present Illness",
    key: "10164-2"
  },
  {
    name: "Reason for Visit",
    key: "29299-5"
  }
], or = {
  class: (e, t) => M1(e, t),
  location: (e, t) => Pq(e, t),
  locationType: (e, t) => kq(e, t),
  noteType: Lo,
  provider: (e, t) => Oq(e, t)
};
function Rq(e = []) {
  const t = [
    qn,
    {
      key: "class",
      type: "checkbox",
      predicate: or.class,
      display: "Class",
      values: Ee(ht(e.map((c) => c.classDisplay)))
    }
  ], n = ko.filter(
    (c) => e.some((l) => Lo([c.key], l))
  ), r = e.filter(
    (c) => !ko.some((l) => Lo([l.key], c))
  ).length > 0;
  (n.length > 0 || r) && t.push({
    key: "noteType",
    type: "checkbox",
    display: "Note Type",
    predicate: or.noteType,
    values: Ee([
      ...n,
      r ? {
        name: "Other",
        key: "other"
      } : void 0
    ])
  });
  const s = Ee(e.flatMap((c) => c.location));
  s.length > 0 && t.push({
    key: "location",
    type: "checkbox",
    display: "Location",
    predicate: or.location,
    values: ht(s.map(hr).toSorted((c, l) => c.localeCompare(l)))
  });
  const a = e.flatMap((c) => c.practitioners);
  a.length > 0 && t.push({
    key: "provider",
    type: "checkbox",
    display: "Provider",
    predicate: or.provider,
    values: ht(a.map(hr).toSorted((c, l) => c.localeCompare(l)))
  });
  const o = e.flatMap((c) => c.locationType).map(hr).filter((c) => c !== "unknown").toSorted((c, l) => c.localeCompare(l));
  return o.length > 0 && t.push({
    key: "locationType",
    type: "checkbox",
    display: "Location Type",
    predicate: or.locationType,
    values: ht(o.concat("unknown"))
  }), t;
}
function Ll(e) {
  const t = /* @__PURE__ */ new Map();
  return e.forEach((n, r) => {
    const s = JSON.stringify({
      upid: n.patientUPID,
      periodStart: n.periodStart || "",
      class: n.resource.class,
      type: n.resource.type,
      location: n.location.join(", ")
    }), a = t.get(s);
    n.patientUPID && n.periodStart && n.resource.type && n.location.length > 0 ? a ? a.push(n) : t.set(s, [n]) : t.set(s + r, [n]);
  }), Mq(t);
}
function Mq(e) {
  const t = [];
  return e.forEach((n) => {
    if (n.length === 1) {
      t.push(n[0]);
      return;
    }
    n.sort((s, a) => {
      const o = s.lastUpdated ? new Date(s.lastUpdated).valueOf() : 0, c = a.lastUpdated ? new Date(a.lastUpdated).valueOf() : 0;
      return o - c;
    });
    const r = n[0];
    if (n.length > 1) {
      const s = n.map((a) => a.resource);
      r.resource = s.reduce(
        (a, o) => $P(a, o)
      );
    }
    t.push(r);
  }), t;
}
function Lo(e, t) {
  if (e.length === 0)
    return !0;
  const n = e.flatMap((c) => c.split(",")), r = ko.flatMap((c) => c.key.split(",")), s = t, a = s.clinicalNotes.some(
    (c) => c.category.some(
      (l) => {
        var d;
        return (d = l.coding) == null ? void 0 : d.some(
          (u) => u.system === Yt && u.code && n.includes(u.code)
        );
      }
    )
  ), o = n.includes("other") && !s.clinicalNotes.some(
    (c) => c.category.some(
      (l) => {
        var d;
        return (d = l.coding) == null ? void 0 : d.some(
          (u) => u.system === Yt && u.code && r.includes(u.code)
        );
      }
    )
  );
  return a || o;
}
function M1(e, t) {
  return e.length === 0 ? !0 : e.includes(t.classDisplay);
}
function Pq(e, t) {
  return e.length === 0 ? !0 : t.location.some((n) => e.includes(n.toLowerCase()));
}
function Oq(e, t) {
  return e.length === 0 ? !0 : t.practitioners.some(
    (n) => e.includes(n.toLowerCase())
  );
}
function kq(e, t) {
  return e.length === 0 || e.includes("unknown") && t.locationType.length === 0 ? !0 : t.locationType.some((n) => e.includes(n.toLowerCase()));
}
const Lq = ({ entries: e }) => /* @__PURE__ */ i.jsxs("div", { className: "ctw-space-y-4", children: [
  /* @__PURE__ */ i.jsx("div", { className: "ctw-text-lg ctw-font-semibold", children: "Notes" }),
  e.map((t) => /* @__PURE__ */ i.jsx(Fq, { doc: t }, t.id))
] }), Fq = ({ doc: e }) => {
  var r, s;
  const { binaryId: t, title: n } = e;
  return /* @__PURE__ */ i.jsxs(
    "div",
    {
      className: "ctw-rounded-lg ctw-bg-bg-white ctw-p-3 ctw-text-left ctw-outline ctw-outline-1 ctw-outline-divider-main ctw-space-y-2",
      id: t,
      children: [
        /* @__PURE__ */ i.jsxs(
          "span",
          {
            className: W(
              "ctw-flex ctw-justify-between",
              ((r = e.sectionDocuments) == null ? void 0 : r.length) && "ctw-pb-2 ctw-border-b ctw-border-solid ctw-border-bg-dark"
            ),
            children: [
              /* @__PURE__ */ i.jsxs("span", { className: "ctw-inline-flex ctw-space-x-2 ctw-items-center", children: [
                /* @__PURE__ */ i.jsx("span", { className: "ctw-h-full ctw-mt-1", children: t && /* @__PURE__ */ i.jsx(i0, { className: "ctw-fill-content-lighter ctw-h-5" }) }),
                /* @__PURE__ */ i.jsx("span", { className: "ctw-text-base ctw-text-content-black ctw-font-medium", children: n })
              ] }),
              /* @__PURE__ */ i.jsx("span", { className: "ctw-space-y-2", children: /* @__PURE__ */ i.jsx(
                zr,
                {
                  binaryId: t,
                  text: "Open",
                  showContentTypeIcon: !1
                }
              ) })
            ]
          }
        ),
        (s = e.sectionDocuments) == null ? void 0 : s.map((a) => /* @__PURE__ */ i.jsx(Bq, { section: a }, a.id))
      ]
    },
    t
  );
}, Bq = ({ section: e }) => {
  const [t, n] = Y(!1);
  return /* @__PURE__ */ i.jsxs(
    "div",
    {
      className: W(
        t && "ctw-rounded-lg ctw-bg-bg-lighter ctw-px-4 ctw-divide-y ctw-border-y-divider-main"
      ),
      children: [
        /* @__PURE__ */ i.jsx(
          c1,
          {
            summary: /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
              e.title && /* @__PURE__ */ i.jsx("div", { children: e.title }),
              !e.title && /* @__PURE__ */ i.jsx("div", { className: "ctw-text-content-lighter", children: "Unknown" })
            ] }),
            isDetailShown: t,
            setIsDetailShown: n,
            className: W(
              "ctw-section-note-expandable",
              t ? "ctw-rounded-t-lg ctw-bg-bg-lighter" : "ctw-rounded-lg ctw-px-4"
            )
          }
        ),
        t && /* @__PURE__ */ i.jsx(
          Ur,
          {
            details: [
              {
                value: o1(e.displayContent),
                transposeTables: !0
              }
            ],
            hideEmpty: !1,
            className: "ctw-py-2 ctw-text-sm",
            hideHeader: !0
          }
        )
      ]
    },
    e.id
  );
};
function P1() {
  return _t({
    header: (e) => e.dateDisplay,
    getSourceDocument: !0,
    details: Uq,
    enableDismissAndReadActions: !0,
    renderChild: (e) => e.docsAndNotes.length > 0 && /* @__PURE__ */ i.jsx(Lq, { entries: e.docsAndNotes })
  });
}
const Uq = (e) => [
  { label: "Status", value: fr(e.status) },
  { label: "Class", value: fr(e.classDisplay) },
  { label: "Type", value: fr(e.typeDisplay) },
  { label: "Location", value: e.location.join(", ") },
  {
    label: "Providers",
    value: e.practitioners.length > 0 && /* @__PURE__ */ i.jsx("ul", { className: "ctw-m-0 ctw-list-disc ctw-pl-4", children: e.practitioners.map((t) => /* @__PURE__ */ i.jsx("li", { children: t }, t)) })
  },
  {
    label: "Location Type",
    value: (() => {
      const t = e.locationType.filter(
        (n) => n.toLowerCase() !== "unknown"
      );
      return t.length > 0 ? /* @__PURE__ */ i.jsx("ul", { className: "ctw-m-0 ctw-list-disc ctw-pl-4", children: t.filter((n) => n.toLowerCase() !== "unknown").map((n) => /* @__PURE__ */ i.jsx("li", { children: n }, n)) }) : null;
    })()
  },
  { label: "Reason", value: e.reason },
  {
    label: "Diagnoses",
    value: e.diagnoses.length > 0 && /* @__PURE__ */ i.jsx("ul", { className: "ctw-m-0 ctw-list-disc ctw-pl-4", children: e.diagnoses.map((t) => /* @__PURE__ */ i.jsx("li", { children: t }, t)) })
  },
  { label: "Discharge Disposition", value: e.dischargeDisposition }
], Fl = {
  display: "Date (New to Old)",
  sorts: [{ key: "periodStart", dir: "desc", isDate: !0 }]
}, zq = [
  Fl,
  {
    display: "Date (Old to New)",
    sorts: [{ key: "periodStart", dir: "asc", isDate: !0 }]
  }
], Hq = Ae`
  ${Xt}

  fragment CodeableConcept on CodeableConcept {
    text
    coding {
      ...Coding
    }
  }
`, Wq = Ae`
  ${Hq}
  ${Wa}
  ${Gn}

  fragment Encounter on Encounter {
    id
    resourceType
    BasicList(_reference: "subject") {
      ...Basic
    }
    meta {
      tag {
        system
        code
      }
      versionId
    }
    extension {
      url
      valueString
      extension {
        url
        valueReference {
          id
          type
          reference
        }
      }
    }
    status
    class {
      system
      version
      code
      display
    }
    type {
      ...CodeableConcept
    }
    serviceType {
      ...CodeableConcept
    }
    priority {
      ...CodeableConcept
    }
    diagnosis {
      condition {
        reference
        display
        resource {
          ... on Condition {
            code {
              coding {
                ...Coding
              }
              text
            }
          }
        }
      }
    }
    participant {
      individual {
        reference
        resource {
          ... on Practitioner {
            name {
              family
              given
            }
          }
        }
        display
      }
      type {
        ...CodeableConcept
      }
      period {
        start
        end
      }
    }
    period {
      start
      end
    }
    ProvenanceList(_reference: "target") {
      id
      entity {
        what {
          ...Reference
        }
      }
    }
    length {
      value
      unit
    }
    reasonCode {
      ...CodeableConcept
    }
    hospitalization {
      dischargeDisposition {
        ...CodeableConcept
      }
    }
    location {
      location {
        reference
        display
        resource {
          ... on Location {
            name
            type {
              ...CodeableConcept
            }
          }
        }
      }
      status
      period {
        start
        end
      }
    }
  }
`, Bl = Ae`
  ${Wq}
  query Encounters(
    $upid: ID!
    $cursor: String!
    $sort: EncounterSortParams!
    $first: Int!
    $filter: EncounterFilterParams! = {}
  ) {
    EncounterConnection(upid: $upid, after: $cursor, sort: $sort, first: $first, filter: $filter) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          ...Encounter
        }
      }
    }
  }
`;
function Vq(e, t) {
  return (n, r) => V(this, null, function* () {
    if (t !== void 0 && t.length === 0)
      return [];
    const s = Re(n), { data: a } = yield Ut(
      s,
      Bl,
      "EncounterConnection",
      {
        upid: r.UPID,
        cursor: "",
        first: e,
        // Optionally filter down to a specific set of encounters.
        filter: X(R({}, t ? {
          ids: { anymatch: t }
        } : {}), {
          tag: { nonematch: [yt] }
        })
      }
    ), o = a.EncounterConnection.edges.map((c) => c.node).map((c) => new za(c, c.ProvenanceList, void 0, c.BasicList));
    return Ll(o);
  });
}
function qq(e) {
  return (t, n) => V(this, null, function* () {
    const r = Re(t), { data: s } = yield Ut(
      r,
      Bl,
      "EncounterConnection",
      {
        upid: n.UPID,
        cursor: "",
        first: e,
        filter: {
          tag: {
            nonematch: [yt, Ln]
            // TODO: There's a bug in FQS that doesn't allow filtering with nonematch AND allmatch.
            // Uncomment the line below once https://zeushealth.atlassian.net/browse/DRT-249 is resolved.
            // allmatch: [`${SYSTEM_ZUS_OWNER}|builder/${requestContext.builderId}`],
          }
        }
      }
    );
    let a = s.EncounterConnection.edges.map((c) => c.node);
    a = yl(
      a,
      t.contextBuilderId || t.builderId
    );
    const o = a.map(
      (c) => new za(c, c.ProvenanceList, void 0, c.BasicList)
    );
    return Ll(o);
  });
}
function Gq(e) {
  return (t, n) => V(this, null, function* () {
    const r = Re(t), { data: s } = yield Ut(
      r,
      Bl,
      "EncounterConnection",
      {
        upid: n.UPID,
        cursor: "",
        first: e,
        filter: {
          tag: {
            allmatch: [
              `${Fa}|Common`,
              `${En}|builder/${Oc(t.env)}`
            ]
          }
        }
      }
    ), o = s.EncounterConnection.edges.map((c) => c.node).map(
      (c) => new za(c, c.ProvenanceList, void 0, c.BasicList)
    );
    return Ll(o);
  });
}
function Es(e = jt, t = !0) {
  const n = Oe(
    aF,
    [e],
    Gq(e),
    t
  ), r = Oe(
    K9,
    [e],
    qq(e),
    t
  ), s = ke(
    () => {
      var a, o;
      return j0((a = n.data) != null ? a : [], (o = r.data) != null ? o : []);
    },
    [n.data, r.data]
  );
  return X(R({}, n), {
    isLoading: n.isLoading && r.isLoading,
    data: s
  });
}
function O1(e = jt) {
  const t = ei(), n = Es(e), [r, s] = Y(
    []
  );
  he(() => {
    var u;
    const l = (u = t.data) != null ? u : [], d = n.data;
    l.length > 0 && d.forEach((h) => h.setClinicalNotesFromDocumentPool(l)), s([...d]);
  }, [t.data, n.data]);
  const a = t.isLoading || n.isLoading, o = t.isError || n.isError, c = t.isFetching || n.isFetching;
  return {
    isLoading: a,
    isError: o,
    isFetching: c,
    data: r
  };
}
function Yq({ className: e }) {
  const t = ut(), n = O1(), r = Te(null), { viewOptions: s, allTime: a } = _n("periodStart"), { data: o, filters: c, setFilters: l, setSort: d, setViewOption: u, defaultSort: h, defaultView: f } = Rt({
    cacheKey: "patient-encounters",
    viewOptions: s,
    defaultView: a.display,
    filterPredicates: or,
    defaultSort: Fl,
    records: n.data
  }), m = !(n.data.length === 0) && o.length === 0, C = P1();
  return /* @__PURE__ */ i.jsx(ft, { componentName: "PatientEncounters", children: /* @__PURE__ */ i.jsxs("div", { className: W(e, "ctw-scrollable-pass-through-height"), ref: r, children: [
    /* @__PURE__ */ i.jsx(
      Ht,
      {
        viewOptions: {
          onChange: u,
          options: s,
          defaultView: f
        },
        filterOptions: {
          onChange: l,
          filters: Rq(n.data),
          selected: c
        },
        sortOptions: {
          defaultSort: h,
          options: zq,
          onChange: d
        }
      }
    ),
    /* @__PURE__ */ i.jsx(
      Tt,
      {
        showTableHead: !0,
        isLoading: n.isLoading,
        columns: Tq(t),
        data: o,
        emptyMessage: /* @__PURE__ */ i.jsx(
          xt,
          {
            hasZeroFilteredRecords: m,
            resourceName: "encounters"
          }
        ),
        enableDismissAndReadActions: !0,
        onRowClick: (y) => {
          C(y, { target: "encounters" });
        }
      }
    )
  ] }) });
}
const Qq = He(Yq, "PatientEncounters");
function Ul(e, t) {
  const n = Ro(e, "lastPrescriber"), r = [];
  return t && r.push(qn), n.length > 1 && r.push({
    key: "lastPrescriber",
    type: "checkbox",
    icon: Uw,
    values: n,
    display: "prescriber"
  }), r;
}
const Zq = [
  {
    title: "Medication Name",
    render: (e) => /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
      /* @__PURE__ */ i.jsx("div", { className: "ctw-font-medium group-hover:ctw-underline", children: e.display }),
      /* @__PURE__ */ i.jsx("div", { className: "ctw-font-light", children: e.dosage })
    ] }),
    widthPercent: 35,
    minWidth: 270
  },
  {
    title: "Dispensed",
    render: (e) => /* @__PURE__ */ i.jsxs("div", { className: "ctw-stacked-concat", children: [
      e.quantity && /* @__PURE__ */ i.jsx("div", { children: e.quantity }),
      e.refills && /* @__PURE__ */ i.jsxs("div", { children: [
        e.refills,
        " refills"
      ] })
    ] }),
    widthPercent: 18,
    minWidth: 160
  },
  {
    title: "Last Filled",
    render: (e) => e.lastFillDate && /* @__PURE__ */ i.jsxs("div", { children: [
      /* @__PURE__ */ i.jsx("span", { className: "ctw-stacked-only", children: "Last Filled: " }),
      e.lastFillDate
    ] }),
    widthPercent: 18
  },
  {
    title: "Last Prescribed",
    render: (e) => {
      const { lastPrescribedDate: t, lastPrescriber: n } = e;
      return !t && !n ? null : /* @__PURE__ */ i.jsxs("div", { className: "ctw-stacked-concat", children: [
        /* @__PURE__ */ i.jsx("span", { className: "ctw-stacked-only", children: "Last Prescribed: " }),
        t && /* @__PURE__ */ i.jsx("div", { children: t }),
        n && /* @__PURE__ */ i.jsx("div", { children: n })
      ] });
    },
    widthPercent: 18,
    minWidth: 90
  }
], Kq = (e) => [
  {
    title: "Name",
    widthPercent: 40,
    minWidth: 320,
    render: (t) => /* @__PURE__ */ i.jsx(
      Wt,
      {
        title: t.display,
        capitalizeTitle: !1,
        subTitle: t.dosage,
        renderIcon: Lt(t.ownedByBuilder(e))
      }
    )
  },
  {
    title: "Dispensed",
    render: (t) => /* @__PURE__ */ i.jsxs("div", { className: "ctw-stacked-concat", children: [
      t.quantity && /* @__PURE__ */ i.jsx("div", { children: t.quantity }),
      t.refills && /* @__PURE__ */ i.jsxs("div", { children: [
        t.refills,
        " refills"
      ] })
    ] }),
    widthPercent: 18,
    minWidth: 160
  },
  {
    title: "Last Filled",
    render: (t) => t.lastFillDate && /* @__PURE__ */ i.jsxs("div", { children: [
      /* @__PURE__ */ i.jsx("span", { className: "ctw-stacked-only", children: "Last Filled: " }),
      t.lastFillDate
    ] }),
    widthPercent: 18
  },
  {
    title: "Last Prescribed",
    render: (t) => {
      const { lastPrescribedDate: n, lastPrescriber: r } = t;
      return !n && !r ? null : /* @__PURE__ */ i.jsxs("div", { className: "ctw-stacked-concat", children: [
        /* @__PURE__ */ i.jsx("span", { className: "ctw-stacked-only", children: "Last Prescribed: " }),
        n && /* @__PURE__ */ i.jsx("div", { children: n }),
        r && /* @__PURE__ */ i.jsx("div", { children: r })
      ] });
    },
    widthPercent: 18,
    minWidth: 90
  }
], ri = [
  {
    display: "Name (A-Z)",
    sorts: [{ key: "sortDisplay", dir: "asc" }]
  },
  {
    display: "Name (Z-A)",
    sorts: [{ key: "sortDisplay", dir: "desc" }]
  },
  {
    display: "Last Fill Date (Old to New)",
    sorts: [
      { key: "lastFillDate", dir: "asc", isDate: !0 },
      { key: "lastPrescribedDate", isDate: !0, dir: "asc" },
      { key: "sortDisplay", dir: "asc" }
    ]
  },
  {
    display: "Last Fill Date (New to Old)",
    sorts: [
      { key: "lastFillDate", dir: "desc", isDate: !0 },
      { key: "lastPrescribedDate", isDate: !0, dir: "desc" },
      { key: "sortDisplay", dir: "asc" }
    ]
  },
  {
    display: "Last Prescribed (Old to New)",
    sorts: [
      { key: "lastPrescribedDate", isDate: !0, dir: "asc" },
      { key: "lastPrescriber", dir: "asc" }
    ]
  },
  {
    display: "Last Prescribed (New to Old)",
    sorts: [
      { key: "lastPrescribedDate", isDate: !0, dir: "desc" },
      { key: "lastPrescriber", dir: "asc" }
    ]
  }
], k1 = ri[3], Jq = ri[0];
const L1 = ({
  action: e,
  className: t,
  query: n,
  rowActions: r,
  filters: s,
  defaultView: a,
  views: o,
  onOpenHistoryDrawer: c
}) => {
  var x;
  const l = As({ rowActions: r }), {
    data: d,
    filters: u,
    setFilters: h,
    setSort: f,
    setViewOption: p,
    defaultSort: m,
    defaultView: C
  } = Rt({
    cacheKey: "patient-medications-base",
    defaultSort: k1,
    viewOptions: o,
    records: n.data,
    defaultView: a.display
  }), g = !(((x = n.data) == null ? void 0 : x.length) === 0) && d.length === 0;
  function w(S) {
    c == null || c(), l(S);
  }
  return /* @__PURE__ */ i.jsxs("div", { className: W("ctw-scrollable-pass-through-height", t), children: [
    /* @__PURE__ */ i.jsx(
      Ht,
      {
        viewOptions: {
          onChange: p,
          defaultView: C,
          options: o
        },
        filterOptions: {
          onChange: h,
          filters: s,
          selected: u
        },
        sortOptions: {
          defaultSort: m,
          options: ri,
          onChange: f
        },
        action: e
      }
    ),
    /* @__PURE__ */ i.jsx(
      Tt,
      {
        className: "ctw-patient-medications",
        columns: Zq,
        data: d,
        emptyMessage: /* @__PURE__ */ i.jsx(
          xt,
          {
            hasZeroFilteredRecords: g,
            resourceName: "medications"
          }
        ),
        isLoading: n.isLoading,
        onRowClick: w,
        rowActions: r
      }
    )
  ] });
}, Xq = ["active", "unknown", "on-hold", "intended", "not-taken"], eG = ["completed", "stopped", "entered-in-error"], F1 = [
  {
    display: "Current",
    filters: [{ key: "status", type: "checkbox", selected: Xq }]
  },
  {
    display: "Past",
    filters: [{ key: "status", type: "checkbox", selected: eG }]
  },
  { display: "All", filters: [] }
], tG = F1[0];
function nG(e = !0) {
  return Oe(
    Xc,
    [],
    LV,
    e
  );
}
function rG(e = !0) {
  return Oe(
    el,
    [],
    WV,
    e
  );
}
function Xn(e = !0) {
  const [t, n] = Y([]), [r, s] = Y([]), [a, o] = Y([]), c = rG(e), l = nG(e);
  he(() => {
    var C, y;
    const f = (C = l.data) != null ? C : [];
    let p = (y = c.data) != null ? y : [];
    p = p.filter(
      (g) => g.aggregatedFrom.some((w) => w.type !== "MedicationAdministration")
    );
    const m = VV(p, f);
    n(m.builderMedications), s(m.otherProviderMedications), o([...m.builderMedications, ...m.otherProviderMedications]);
  }, [l.data, c.data]);
  const d = l.isLoading || c.isLoading, u = l.isError || c.isError, h = l.isFetching || c.isFetching;
  return {
    isLoading: d,
    isError: u,
    isFetching: h,
    builderMedications: t,
    otherProviderMedications: r,
    allMedications: a
  };
}
const sG = ({
  className: e,
  onOpenHistoryDrawer: t
}) => {
  const { builderMedications: n, isLoading: r } = Xn();
  return /* @__PURE__ */ i.jsx(
    L1,
    {
      className: e,
      query: { data: n, isLoading: r },
      filters: Ul(n, !1),
      views: F1,
      defaultView: tG,
      onOpenHistoryDrawer: t
    }
  );
}, aG = He(
  sG,
  "PatientMedications"
), iG = (e, t) => V(void 0, null, function* () {
  const { authToken: n, contextBuilderId: r } = e, { data: s } = yield rt(
    `${vO(e.env)}?display=${t}`,
    {
      headers: R({
        Authorization: `Bearer ${n}`
      }, r && { "Zus-Account": r })
    }
  );
  return s.data;
}), oG = (r) => {
  var s = r, {
    defaultCoding: e,
    readonly: t
  } = s, n = ct(s, [
    "defaultCoding",
    "readonly"
  ]);
  const { getRequestContext: a } = Xe(), [o, c] = Y(!1), [l, d] = Y(), u = (h) => V(void 0, null, function* () {
    c(!0);
    const f = yield a(), p = yield iG(f, h);
    p && d(
      p.map((m) => ({
        value: m,
        label: m.display
      }))
    ), c(!1);
  });
  return /* @__PURE__ */ i.jsx(
    _l,
    {
      options: l || [],
      isLoading: o,
      name: `${n.name}`,
      defaultSearchTerm: n.defaultValue,
      readonly: t,
      onSearchChange: u,
      defaultValue: e
    }
  );
}, cG = (e) => [
  {
    label: "Subject",
    value: e.subjectID,
    field: "subjectID",
    hidden: !0
  },
  {
    label: "Date Asserted",
    value: Qt(/* @__PURE__ */ new Date(), "P"),
    field: "dateAsserted",
    hidden: !0
  },
  {
    label: "Medication",
    field: "medication",
    value: e.display,
    render: (t, n) => /* @__PURE__ */ i.jsx(
      oG,
      X(R({
        readonly: t
      }, n), {
        defaultCoding: e.rxNormCodeableConcept
      })
    )
  },
  {
    label: "Latest Status",
    value: hr(e.status),
    field: "status"
  },
  {
    label: "Instructions",
    value: e.dosage,
    field: "dosage"
  }
], lG = Ce.object({
  subjectID: Ce.string({ required_error: "Patient must be specified." }),
  dateAsserted: Ce.date({ required_error: "Date asserted is required." }),
  medication: Ce.object({
    code: Ce.string({
      required_error: "Please choose a medication."
    }),
    // These are technically required but we mark them
    // as optional to avoid duplicative error messages.
    // The condition autocomplete will set us up so that
    // all three of these values are set.
    display: Ce.string().optional(),
    system: Ce.string().optional()
  }),
  dosage: Ce.string().optional(),
  status: Ce.enum([
    "active",
    "completed",
    "entered-in-error",
    "intended",
    "not-taken",
    "on-hold",
    "stopped",
    "unknown"
  ])
}), dG = [
  Jc,
  el,
  Xc
], uG = (e, t) => V(void 0, null, function* () {
  const n = R({
    resourceType: "MedicationStatement",
    status: e.status,
    dateAsserted: pr(e.dateAsserted),
    subject: { type: "Patient", reference: `Patient/${e.subjectID}` },
    medicationCodeableConcept: {
      text: e.medication.display,
      coding: [
        {
          system: is,
          code: e.medication.code
        }
      ]
    }
  }, e.dosage && {
    dosage: [
      {
        text: e.dosage
      }
    ]
  }), r = new Ot(n), s = yield Ba(
    r.resource,
    yield t()
  );
  return yield Promise.all(dG.map((a) => V(void 0, null, function* () {
    return In.invalidateQueries([a]);
  }))), s;
});
function B1() {
  const { openDrawer: e } = Vn();
  return (t) => {
    e({
      trackingMetadata: { action: "add_medication" },
      component: (n) => /* @__PURE__ */ i.jsx(fG, R({ medication: t.resource }, n))
    });
  };
}
const fG = ({ isOpen: e, onClose: t, medication: n }) => {
  var c, l;
  const { patient: r } = Ze(), s = {
    reference: `Patient/${(c = r.data) == null ? void 0 : c.id}`,
    display: (l = r.data) == null ? void 0 : l.display
  };
  let a;
  n ? a = new Ot(X(R({}, n), {
    subject: s,
    dateAsserted: Qt(/* @__PURE__ */ new Date(), "yyyy-MM-dd")
  })) : a = new Ot({
    resourceType: "MedicationStatement",
    status: "active",
    subject: s,
    dateAsserted: Qt(/* @__PURE__ */ new Date(), "yyyy-MM-dd")
  });
  const o = cG(a);
  return /* @__PURE__ */ i.jsx(
    Nl,
    {
      title: "Add Medication",
      action: uG,
      errorHeader: "Unable to add medication to chart",
      data: o,
      schema: lG,
      isOpen: e,
      onClose: t
    }
  );
};
function hG({
  className: e,
  readOnly: t,
  onAddToRecord: n
}) {
  const r = ut(), s = Xn(), { viewOptions: a, past6Months: o } = _n("lastActivityDate"), { data: c, filters: l, setFilters: d, setSort: u, setViewOption: h, defaultSort: f, defaultView: p } = Rt({
    cacheKey: "patient-medications-all",
    defaultSort: k1,
    viewOptions: a,
    defaultView: o.display,
    records: s.allMedications
  }), C = !(s.allMedications.length === 0) && c.length === 0, y = /* @__PURE__ */ i.jsx(xt, { hasZeroFilteredRecords: C, resourceName: "medications" }), g = U1(n), w = As({
    rowActions: t ? void 0 : g,
    enableDismissAndReadActions: !0
  });
  return /* @__PURE__ */ i.jsx(ft, { componentName: "PatientMedicationsAll", children: /* @__PURE__ */ i.jsxs("div", { className: W(e, "ctw-scrollable-pass-through-height"), children: [
    /* @__PURE__ */ i.jsx(
      Ht,
      {
        filterOptions: {
          onChange: d,
          filters: Ul(s.allMedications, !0),
          selected: l
        },
        sortOptions: {
          defaultSort: f,
          options: ri,
          onChange: u
        },
        viewOptions: {
          onChange: h,
          options: a,
          defaultView: p
        }
      }
    ),
    /* @__PURE__ */ i.jsx(
      Tt,
      {
        showTableHead: !0,
        isLoading: s.isLoading,
        data: c,
        columns: Kq(r),
        onRowClick: w,
        rowActions: t ? void 0 : g,
        enableDismissAndReadActions: !0,
        emptyMessage: y
      }
    )
  ] }) });
}
const pG = He(
  hG,
  "PatientMedicationsAll"
);
function U1(e) {
  const { t } = Kn(), n = ut(), r = B1(), { toggleRead: s } = Hr();
  return (a) => a.ownedByBuilder(n) ? [] : [
    {
      text: t("resourceTable.add"),
      className: "ctw-btn-primary",
      onClick: () => {
        a.isRead || s(a), e ? e(a) : r(a);
      }
    }
  ];
}
const mG = ({
  className: e,
  onAddToRecord: t,
  readOnly: n = !1,
  onOpenHistoryDrawer: r
}) => {
  const { otherProviderMedications: s, isLoading: a } = Xn(), o = wG(t), { viewOptions: c, past6Months: l } = _n("lastActivityDate");
  return /* @__PURE__ */ i.jsx(ft, { componentName: "PatientMedicationsOutside", children: /* @__PURE__ */ i.jsx(
    L1,
    {
      className: e,
      query: { data: s, isLoading: a },
      filters: Ul(s, !0),
      rowActions: n ? void 0 : o,
      views: c,
      defaultView: l,
      onOpenHistoryDrawer: r
    }
  ) });
}, gG = He(
  mG,
  "PatientMedicationsOutside"
);
function wG(e) {
  const { t } = Kn(), { trackInteraction: n } = Be(), r = B1(), { isLoading: s, toggleDismiss: a } = h0();
  return (o) => {
    const c = o.isDismissed ? t("resourceTable.restore") : t("resourceTable.dismiss");
    return [
      {
        text: c,
        className: "ctw-btn-default",
        disabled: s,
        onClick: () => V(this, null, function* () {
          yield a(o);
        }),
        render() {
          return /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex", children: [
            s && /* @__PURE__ */ i.jsx(an, { className: "ctw-mx-4 ctw-align-middle" }),
            !s && c
          ] });
        }
      },
      {
        text: t("resourceTable.add"),
        className: "ctw-btn-primary ctw-ml-1 ctw-capitalize",
        testId: "add-to-record",
        disabled: s,
        onClick: () => {
          e ? e(o) : r(o), n("add_to_record");
        }
      }
    ];
  };
}
const vG = () => {
  const e = Sl();
  if (e.isLoading)
    return /* @__PURE__ */ i.jsx(Je, {});
  if (e.isError)
    return /* @__PURE__ */ i.jsx(Zn, { header: "Error loading data" });
  const t = e.data.package;
  return t ? /* @__PURE__ */ i.jsxs("div", { className: "ctw-font-semibold", children: [
    "Enrolled in ",
    t.name
  ] }) : null;
};
function lr(e) {
  const { text: t, date: n, className: r } = e;
  let s = null;
  if (yG(e)) {
    const { icon: a, tooltip: o } = e, c = th(a) ? Dw(a, {
      className: W("history-request-form-icon ctw-h-4", a.props.className)
    }) : /* @__PURE__ */ i.jsx(
      me,
      {
        icon: a,
        className: "history-request-form-icon ctw-h-4"
      }
    );
    s = /* @__PURE__ */ i.jsx(Sn, { content: o, children: c });
  }
  return /* @__PURE__ */ i.jsxs("div", { className: W("ctw-flex ctw-items-center ctw-space-x-1", r), children: [
    /* @__PURE__ */ i.jsx("span", { children: t }),
    n && /* @__PURE__ */ i.jsx("span", { children: kr(n.toISOString()) }),
    s
  ] });
}
function yG(e) {
  return "icon" in e;
}
const xG = ({ className: e }) => {
  const { isLoading: t, lastCompletedDate: n, derivedStatus: r } = O0();
  return t ? null : r === "complete" ? /* @__PURE__ */ i.jsx(lr, { text: "Last updated", date: n, className: e }) : r === "completeWithErrors" ? /* @__PURE__ */ i.jsx(
    lr,
    {
      text: "Last updated",
      date: n,
      className: e,
      icon: /* @__PURE__ */ i.jsx(me, { icon: zw, className: "ctw-text-caution-icon" }),
      tooltip: "There was an error fetching some records for this patient"
    }
  ) : r === "failed" ? /* @__PURE__ */ i.jsx(
    lr,
    {
      text: "Last request failed",
      date: n,
      className: W(e, "ctw-text-error-main"),
      icon: sh,
      tooltip: "There was an error fetching records for this patient"
    }
  ) : /* @__PURE__ */ i.jsx(lr, { text: "Records never requested" });
}, bG = ({
  hideRequestRecords: e = !1
}) => {
  var p;
  const { isError: t, isLoading: n, details: r } = Ns(), a = (p = Sl().data) == null ? void 0 : p.package, o = a ? a.requiresManualRequests : !0;
  if (t)
    return /* @__PURE__ */ i.jsx("div", { className: "ctw-text-center ctw-text-sm", children: "Unable to load patient history" });
  if (n)
    return /* @__PURE__ */ i.jsx(an, { className: "ctw-w-full" });
  const { latestInProgress: c, latestCompleted: l, nextScheduledAt: d } = r, h = (c && Dl.getDerivedProviderStatus(c.job.attributes.providers)) === "partiallyComplete" ? "Current request partially complete" : "Request in-progress", f = !!l || !c && !d;
  return /* @__PURE__ */ i.jsx("div", { className: "ctw-@container", children: /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-justify-between ctw-text-sm ctw-font-medium ctw-flex-col ctw-space-y-1.5 @[365px]:ctw-flex-row @[365px]:ctw-space-y-0", children: [
    /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-flex-col ctw-space-y-1.5", children: [
      c && /* @__PURE__ */ i.jsx(
        lr,
        {
          text: h,
          icon: /* @__PURE__ */ i.jsx(A0, { className: "ctw-flex-none ctw-w-auto" }),
          tooltip: "Patient records are being retrieved"
        }
      ),
      !c && d && /* @__PURE__ */ i.jsx(lr, { text: "Request scheduled", date: d }),
      f && /* @__PURE__ */ i.jsx(xG, {}, "patient-history-last-completed")
    ] }),
    !e && /* @__PURE__ */ i.jsx("div", { children: /* @__PURE__ */ i.jsx(k0, { skipModal: o }) })
  ] }) });
}, z1 = "Records Provided by Zus Health", jG = ({
  hideRequestRecords: e = !1
}) => {
  const t = Ns();
  return /* @__PURE__ */ i.jsx(
    Ds,
    {
      icon: /* @__PURE__ */ i.jsx("img", { src: Pm, alt: "Zus", className: "ctw-h-5" }),
      title: z1,
      footerIcon: rh,
      isLoading: t.isLoading,
      dataTestId: "zus-information-card",
      children: t.isError ? /* @__PURE__ */ i.jsx(Vr, { message: "Unable to load patient history information" }) : /* @__PURE__ */ i.jsxs("div", { className: "ctw-space-y-2 ctw-my-3", children: [
        /* @__PURE__ */ i.jsxs("div", { className: "ctw-px-3 ctw-space-y-1.5", children: [
          /* @__PURE__ */ i.jsx(vG, {}),
          /* @__PURE__ */ i.jsx(bG, { hideRequestRecords: e })
        ] }),
        /* @__PURE__ */ i.jsx("div", { className: "ctw-bg-divider-light ctw-h-px" }),
        /* @__PURE__ */ i.jsxs("div", { className: "ctw-space-y-1.5 ctw-px-3 ctw-font-medium", children: [
          /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-justify-between", children: [
            /* @__PURE__ */ i.jsx("div", { children: "Have feedback or need support?" }),
            /* @__PURE__ */ i.jsx(
              ol,
              {
                buttonText: "Let us know",
                className: "ctw-link ctw-text-sm ctw-block ctw-whitespace-nowrap"
              }
            )
          ] }),
          /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-justify-between", children: [
            /* @__PURE__ */ i.jsx("div", { children: "Learn more about the ZAP" }),
            /* @__PURE__ */ i.jsx(
              "a",
              {
                href: "https://clinicalguide.zushealth.com/docs/getting-started",
                className: "ctw-link ctw-text-sm ctw-block ctw-whitespace-nowrap",
                target: "_blank",
                rel: "noreferrer noopener",
                children: "Clinical Guide"
              }
            )
          ] })
        ] })
      ] })
    }
  );
}, CG = xn({
  component: jG,
  name: "ZusInformationCard",
  title: z1,
  footerTitle: "Zus Health"
});
class NG extends Qe {
  constructor() {
    super(...arguments);
    ne(this, "kind", "MeasureReport");
  }
  get measureName() {
    switch (this.resource.measure) {
      case "http://zusapi.com/fhir/Measure/8432f825-78c4-4d54-8cb4-8b7dafdce581":
        return "Controlling Blood Pressure";
      default:
        return this.resource.measure;
    }
  }
  // This presumes that our MeasureReport resources are individual reports and  will just
  // have one group.  If that changes, this will need to be updated.
  get inDenominator() {
    var r, s, a;
    const n = (s = (r = this.resource.group) == null ? void 0 : r[0].population) == null ? void 0 : s.find(
      (o) => {
        var c, l;
        return (l = (c = o.code) == null ? void 0 : c.coding) == null ? void 0 : l.some((d) => d.code === "denominator");
      }
    );
    return ((a = n == null ? void 0 : n.count) != null ? a : 0) > 0;
  }
  // This presumes that our MeasureReport resources are individual reports and  will just
  // have one group.  If that changes, this will need to be updated.
  get inNumerator() {
    var r, s, a;
    const n = (s = (r = this.resource.group) == null ? void 0 : r[0].population) == null ? void 0 : s.find(
      (o) => {
        var c, l;
        return (l = (c = o.code) == null ? void 0 : c.coding) == null ? void 0 : l.some((d) => d.code === "numerator");
      }
    );
    return ((a = n == null ? void 0 : n.count) != null ? a : 0) > 0;
  }
  get title() {
    return `Measure Report: ${this.measureName}`;
  }
  get date() {
    const n = this.resource.date;
    return n ? Qt(new Date(n), "M/d/yyyy") : "";
  }
}
const DG = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
function SG() {
  return Oe(Y9, [], $G);
}
function $G(e, t) {
  return V(this, null, function* () {
    var d;
    const n = yield br(
      Un(e),
      "MeasureReport",
      {
        upid: (d = t.UPID) != null ? d : ""
      }
    ), r = n.map((u) => u.measure.split("/").pop() || "").filter((u) => DG.test(u)), a = {
      _id: [...new Set(r)].join(",")
    }, o = yield br(
      Un(e),
      "Measure",
      a
    ), c = new Map(
      o.map((u) => [u.id || "", u.title || ""])
    );
    return n.map((u) => {
      var p;
      const h = new NG(u), f = (p = u.measure.split("/").pop()) != null ? p : "";
      return {
        title: c.get(f) || "Unknown Measure",
        closed: h.inDenominator && h.inNumerator,
        reportDate: h.date
      };
    }).sort(
      // Sort by title first, then by report date
      (u, h) => u.title.localeCompare(h.title) || Date.parse(h.reportDate) - Date.parse(u.reportDate)
    );
  });
}
function AG(e) {
  let t = Dn(e, (r) => r.title);
  t = js(
    t,
    (r) => r.sort((s, a) => Date.parse(a.reportDate) - Date.parse(s.reportDate))
  );
  const n = ur(t, (r) => r[0]);
  return Nc(n, (r) => r.title);
}
const H1 = "Care Gaps", EG = () => {
  const { data: e, isLoading: t } = SG(), n = AG(e || []);
  return /* @__PURE__ */ i.jsx(
    Ds,
    {
      icon: Hw,
      title: H1,
      dataTestId: "care-gaps-card",
      isLoading: t,
      children: /* @__PURE__ */ i.jsx(V0, { children: n.length === 0 ? /* @__PURE__ */ i.jsx(Vr, { message: "This patient has no currently open gaps in care." }) : /* @__PURE__ */ i.jsx("div", { className: "ctw-px-3 ctw-font-medium", children: n.map((r) => (
        // We're using a bottom border as a divider between gaps, but we don't need it on the last one.
        /* @__PURE__ */ i.jsx("div", { className: "last:ctw-border-none ctw-border-b ctw-border-divider-main ctw-py-3", children: /* @__PURE__ */ i.jsx(IG, { gap: r }, r.title) })
      )) }) })
    }
  );
}, IG = ({ gap: e }) => /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-flex-col ctw-space-y-2 ctw-text-sm", children: [
  /* @__PURE__ */ i.jsx("div", { className: "ctw-font-medium", children: e.title }),
  /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-gap-1 ctw-items-center ctw-font-normal", children: [
    "Status",
    " ",
    /* @__PURE__ */ i.jsx(kt, { color: e.closed ? "muted" : "caution", content: e.closed ? "Closed" : "Open" })
  ] }),
  /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-gap-1 ctw-items-center ctw-font-normal", children: [
    "Report Date: ",
    e.reportDate
  ] })
] }), _G = xn({
  component: EG,
  name: "CareGapsCard",
  title: H1,
  footerTitle: "Care Gaps"
}), W1 = "ED & IP Visits", V1 = "All Encounters", TG = ({
  onSeeAllResources: e
}) => {
  const t = ut(), n = O1(), r = P1(), s = Va(n.data, Fl.sorts), a = Rl(s, RG()), o = n.data.length === 0;
  return /* @__PURE__ */ i.jsx(
    Ss,
    {
      icon: hh,
      title: W1,
      data: a,
      emptyMessage: o ? "We didn't find any encounter records for this patient." : "There are no emergency or inpatient visits within the past year for this patient.",
      onRowClick: (c) => {
        r(c, { target: "overview" });
      },
      onSeeAllResources: e,
      footerText: V1,
      hideFooter: o,
      isLoading: n.isLoading,
      tooltipText: "Emergency and inpatient visits from the past year.",
      trackingName: "encounters_overview",
      dataTestId: "encounters-overview",
      children: (c) => /* @__PURE__ */ i.jsx(
        Wt,
        {
          title: `${c.dateDisplay} - ${c.typeDisplay}`,
          subTitle: /* @__PURE__ */ i.jsxs("div", { className: "ctw-space-y-0.5", children: [
            c.location.length && /* @__PURE__ */ i.jsx("div", { className: "ctw-font-normal", children: c.location.join(", ") }),
            c.clinicalNotes.length > 0 ? /* @__PURE__ */ i.jsxs("div", { className: "ctw-text-sm ctw-font-normal ctw-pt-1 ctw-flex ctw-space-x-1.5 ctw-items-center", children: [
              /* @__PURE__ */ i.jsx(
                me,
                {
                  className: "ctw-w-4 ctw-text-content-lighter",
                  icon: yv
                }
              ),
              /* @__PURE__ */ i.jsxs("div", { children: [
                c.clinicalNotes.length,
                " ",
                c.clinicalNotes.length === 1 ? "note" : "notes"
              ] })
            ] }) : void 0
          ] }),
          renderIcon: Lt(
            c.ownedByBuilder(t) || c.syncedWithRecord
          )
        }
      )
    }
  );
}, RG = () => [
  {
    key: "emergency",
    label: "Filter for emergency encounters",
    description: "Is an emergency or a hospitalization.",
    predicate: (e) => M1(["Emergency", "Inpatient"], e)
  },
  {
    key: "recent",
    label: "Filter for recent encounters",
    description: "Began within the past year.",
    predicate: (e) => Il(e, "periodStart", 365, !1)
  }
], MG = xn({
  component: TG,
  name: "EncountersOverviewCard",
  title: W1,
  footerTitle: V1,
  tabToNavigateTo: "encounters"
}), Yf = {
  overviewCards: {
    conditions: { enabled: !0 },
    referrals: { enabled: !0 },
    medications: { enabled: !0 },
    diagnostics: { enabled: !0 },
    encounters: { enabled: !0 },
    episodesOfCare: { enabled: !1 },
    vitals: { enabled: !0 },
    packages: { enabled: !0 },
    careGaps: { enabled: !0 }
  }
};
function q1() {
  const e = ut();
  return Jt(
    L9,
    [e],
    (t) => V(this, null, function* () {
      try {
        const { data: n } = yield rt(
          `${sa(t.env)}/api/builders/${t.builderId}/config`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${t.authToken}`
            },
            mode: "cors"
          }
        );
        return wm({}, Yf, n);
      } catch (n) {
        return Yf;
      }
    }),
    !!e
  );
}
function G1({ patient: e, className: t }) {
  const { data: n } = q1();
  if (!e)
    return null;
  const r = e.findIdentifier(n == null ? void 0 : n.systemMRN);
  return /* @__PURE__ */ i.jsxs("div", { className: t, children: [
    e.dob,
    e.age !== void 0 && ` (${e.age})`,
    r && /* @__PURE__ */ i.jsxs("span", { children: [
      ", ",
      r
    ] })
  ] });
}
class PG extends Qe {
  constructor() {
    super(...arguments);
    ne(this, "kind", "Binary");
  }
  get title() {
    return `Binary: ${this.resource.id}`;
  }
}
function OG(e) {
  return Jt(k9, [e], (t) => V(this, null, function* () {
    if (!e.length)
      return [];
    const n = yield br(
      Un(t),
      "Binary",
      {
        _id: e.join(",")
      },
      !1
    );
    return nt(
      n.map((r) => new PG(r)),
      "createdAt",
      "desc"
    );
  }));
}
function kG(e = !1) {
  return _t({
    header: (t) => e && t.patient && t.patientUPID ? /* @__PURE__ */ i.jsx(
      UG,
      {
        patient: t.patient,
        patientUPID: t.patientUPID,
        linkToPatient: e
      }
    ) : /* @__PURE__ */ i.jsx(zG, { episodeOfCare: t }),
    subHeader: (t) => e ? /* @__PURE__ */ i.jsx(G1, { patient: t.patient }) : t.location,
    getSourceDocument: !1,
    details: LG,
    renderChild: (t) => /* @__PURE__ */ i.jsx(FG, { model: t }),
    enableDismissAndReadActions: !0
  });
}
const LG = (e) => {
  const t = e.diagnosesForRole("AD"), n = e.diagnosesForRole("DD");
  return [
    { label: "Start Date", value: e.periodStart },
    { label: "End Date", value: e.periodEnd },
    { label: "Type", value: e.class },
    { label: "Location", value: e.location },
    {
      label: "Admitting Diagnosis",
      value: t.length > 0 ? /* @__PURE__ */ i.jsx(Qf, { diagnosis: t }) : void 0
    },
    {
      label: "Discharge Diagnosis",
      value: n.length > 0 ? /* @__PURE__ */ i.jsx(Qf, { diagnosis: n }) : void 0
    },
    { label: "Discharge Disposition", value: e.dischargeDisposition }
  ];
};
function FG({ model: e }) {
  var r;
  const t = OG(e.dischargeBinaryIds);
  if (e.dischargeBinaryIds.length === 0)
    return null;
  if (t.isLoading)
    return /* @__PURE__ */ i.jsx(Je, { message: "Loading documents" });
  const n = e.preferredDischargeBinaryIds;
  return /* @__PURE__ */ i.jsxs("div", { className: "ctw-space-y-4", children: [
    /* @__PURE__ */ i.jsx("h4", { className: "ctw-text-lg ctw-font-semibold", children: "Documents" }),
    (r = t.data) == null ? void 0 : r.map((s) => /* @__PURE__ */ i.jsx(
      BG,
      {
        binary: s,
        patient: e.patient,
        preferred: n.includes(s.id)
      },
      s.id
    ))
  ] });
}
function BG({
  binary: e,
  patient: t,
  preferred: n
}) {
  const r = Cs(t), { trackInteraction: s } = Be(), a = e.createdAt ? Qt(new Date(e.createdAt), "M/d/yyyy") : "", o = e.createdAt ? Qt(new Date(e.createdAt), "h:mma") : "";
  return /* @__PURE__ */ i.jsx(i.Fragment, { children: /* @__PURE__ */ i.jsx(
    "button",
    {
      type: "button",
      className: "ctw-btn-clean ctw-group",
      onClick: () => {
        r(e.id, "Encounter Summary"), s("view_adt_discharge_summary", { resourceType: "EpisodeOfCare" });
      },
      children: /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-items-center ctw-justify-between ctw-rounded-lg ctw-bg-bg-white ctw-p-3 ctw-text-left ctw-outline ctw-outline-1 ctw-outline-bg-dark ctw-text-content-black", children: [
        /* @__PURE__ */ i.jsxs("div", { className: "ctw-space-x-10 ctw-flex", children: [
          /* @__PURE__ */ i.jsxs("div", { className: "ctw-w-24", children: [
            /* @__PURE__ */ i.jsx("div", { className: "ctw-font-medium", children: o }),
            /* @__PURE__ */ i.jsx("div", { children: a })
          ] }),
          /* @__PURE__ */ i.jsxs("div", { children: [
            /* @__PURE__ */ i.jsx("div", { className: "ctw-font-medium group-hover:ctw-underline", children: "Encounter Summary " }),
            n && /* @__PURE__ */ i.jsx(kt, { color: "muted", content: "Notes" })
          ] })
        ] }),
        /* @__PURE__ */ i.jsx(
          me,
          {
            icon: ss,
            className: "ctw-w-5 ctw-h-5 ctw-text-content-light ctw-justify-self-end"
          }
        )
      ] })
    }
  ) });
}
function UG({ patient: e, patientUPID: t, linkToPatient: n }) {
  const { display: r, gender: s } = e;
  return /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-justify-between", children: [
    r,
    s ? ` (${s[0].toUpperCase()})` : "",
    n && /* @__PURE__ */ i.jsxs(
      "a",
      {
        "aria-label": "Open in new tab",
        href: `/patients/${t}`,
        className: "ctw-btn-clear ctw-link ctw-flex ctw-items-center ctw-space-x-2",
        rel: "noopener noreferrer",
        target: "_blank",
        tabIndex: 0,
        children: [
          /* @__PURE__ */ i.jsx(me, { icon: ih, className: "ctw-h-3" }),
          /* @__PURE__ */ i.jsx("span", { className: "ctw-normal-case", children: "Go To Profile" })
        ]
      }
    )
  ] });
}
function zG({ episodeOfCare: e }) {
  return /* @__PURE__ */ i.jsx("div", { className: "ctw-flex ctw-justify-between", children: e.title });
}
function Qf({ diagnosis: e }) {
  return e.length === 1 ? /* @__PURE__ */ i.jsx("span", { children: e[0] }) : /* @__PURE__ */ i.jsx("ul", { className: "ctw-list-disc ctw-list-inside", children: e.map((t) => /* @__PURE__ */ i.jsx("li", { children: t }, t)) });
}
const HG = Ae`
  fragment EpisodeOfCare on EpisodeOfCare {
    id
    resourceType
    extension {
      url
      extension {
        url
        valueReference {
          id
          type
          reference
          display
          extension {
            url
            valueString
            valueBoolean
          }
        }
        valueString
      }
      valueString
      valueReference {
        id
        type
        reference
        display
      }
      valueCodeableConcept {
        coding {
          system
          code
          display
        }
        text
      }
      valueCoding {
        code
        display
        system
        userSelected
        version
      }
    }
    meta {
      extension {
        url
      }
      security {
        system
        code
      }
      tag {
        system
        code
      }
      lastUpdated
    }
    period {
      start
      end
    }
    identifier {
      system
      value
      type {
        text
        coding {
          system
          code
          display
        }
      }
    }
    status
    diagnosis {
      role {
        coding {
          system
          code
          display
        }
      }
      condition {
        id
        type
        reference
        resource {
          ... on Condition {
            id
            resourceType
            code {
              text
              coding {
                display
                code
                system
                extension {
                  url
                  valueString
                }
              }
            }
          }
        }
      }
    }
  }
`, WG = Ae`
  ${HG}

  query EpisodeOfCare(
    $upid: ID!
    $cursor: String!
    $first: Int!
    $filter: EpisodeOfCareFilterParams!
  ) {
    EpisodeOfCareConnection(upid: $upid, after: $cursor, first: $first, filter: $filter) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...EpisodeOfCare
        }
      }
    }
  }
`;
function VG() {
  return Oe(
    eF,
    [],
    (e, t) => V(this, null, function* () {
      const n = Re(e), { data: r } = yield dt(
        n,
        WG,
        {
          upid: t.UPID,
          cursor: "",
          first: jt,
          sort: {
            lastUpdated: "DESC"
          },
          filter: {
            tag: {
              allmatch: ["https://zusapi.com/summary|TransitionsOfCare"]
            }
          }
        }
      );
      return r.EpisodeOfCareConnection.edges.map((o) => o.node).map((o) => new QF(o, []));
    })
  );
}
const Y1 = "ED & IP Visits", Q1 = "All Encounters", qG = ({
  onSeeAllResources: e
}) => {
  var o;
  const t = kG(), n = VG(), r = Va((o = n.data) != null ? o : [], [
    { key: "periodStart", dir: "desc", isDate: !0 }
    // Newest first.
  ]), s = Rl(r, GG()), a = s.length === 0;
  return /* @__PURE__ */ i.jsx(
    Ss,
    {
      icon: hh,
      title: Y1,
      data: s,
      emptyMessage: a ? "We didn't find any emergency or inpatient records for this patient." : "No emergency or inpatient visits found within the past year.",
      onRowClick: (c) => {
        t(c);
      },
      onSeeAllResources: e,
      footerText: Q1,
      hideFooter: a,
      isLoading: n.isLoading,
      tooltipText: "Emergency and inpatient visits from the past year.",
      trackingName: "episodes_of_care_overview",
      dataTestId: "episodes-of-care-overview",
      children: (c) => {
        const l = c.dischargeBinaryIds;
        return /* @__PURE__ */ i.jsx(
          Wt,
          {
            title: `${c.dateDisplay} - ${c.class}`,
            subTitle: /* @__PURE__ */ i.jsxs("div", { className: "ctw-space-y-0.5", children: [
              c.location && /* @__PURE__ */ i.jsx("div", { className: "ctw-font-normal", children: c.location }),
              l.length > 0 ? /* @__PURE__ */ i.jsxs("div", { className: "ctw-text-sm ctw-font-normal ctw-pt-1 ctw-flex ctw-space-x-1.5 ctw-items-center", children: [
                /* @__PURE__ */ i.jsx(
                  me,
                  {
                    className: "ctw-w-4 ctw-text-content-lighter",
                    icon: ss
                  }
                ),
                /* @__PURE__ */ i.jsxs("div", { children: [
                  l.length,
                  " ",
                  l.length === 1 ? "document" : "documents"
                ] })
              ] }) : void 0
            ] })
          }
        );
      }
    }
  );
}, GG = () => [
  {
    key: "emergency",
    label: "Filter for emergency episodes",
    description: "Is an emergency or a hospitalization.",
    predicate: (e) => ["EMER", "IMP"].includes(e.classCode)
  },
  {
    key: "recent",
    label: "Filter for recent episodes",
    description: "Began within the past year.",
    predicate: (e) => Il(e, "periodStart", 365, !1)
  }
], YG = xn({
  component: qG,
  name: "EpisodeOfCareOverviewCard",
  title: Y1,
  footerTitle: Q1,
  tabToNavigateTo: "encounters"
}), zl = Ct({
  props: {},
  setProps: () => {
  }
}), Z1 = "Medications", K1 = "All Medications", QG = ({
  onSeeAllResources: e
}) => {
  var h, f, p;
  const t = ut(), n = Xn(), { props: r } = tt(zl), s = U1((h = r["medications-all"]) == null ? void 0 : h.onAddToRecord), a = (p = (f = r["medications-all"]) == null ? void 0 : f.readOnly) != null ? p : !1, o = As({
    rowActions: a ? void 0 : s,
    enableDismissAndReadActions: !1
  }), { past6Months: c } = _n("lastActivityDate", !1), { data: l } = Rt({
    defaultSort: Jq,
    // Alphabetical
    viewOptions: [c],
    defaultView: c.display,
    records: n.allMedications
  }), d = TL(
    Dn(l, (m) => m.activeIngredient)
  ).map((m) => nt(m, "lastActivityDate", "desc")[0]), u = n.allMedications.length === 0;
  return /* @__PURE__ */ i.jsx(
    Ss,
    {
      onSeeAllResources: e,
      onRowClick: o,
      data: d,
      emptyMessage: u ? "We didn't find any medication records for this patient." : "There are no medications with prescriptions or fills within the past 6 months for this patient.",
      footerText: K1,
      hideFooter: u,
      title: Z1,
      tooltipText: "Medications with prescriptions or fills within the last 6 months",
      isLoading: n.isLoading,
      icon: Ww,
      trackingName: "medications_overview",
      dataTestId: "medications-overview",
      children: (m) => /* @__PURE__ */ i.jsx(
        Wt,
        {
          title: m.display,
          renderIcon: Lt(m.ownedByBuilder(t))
        }
      )
    }
  );
}, ZG = xn({
  component: QG,
  name: "PatientMedicationOverview",
  title: Z1,
  footerTitle: K1,
  tabToNavigateTo: "medications-all"
}), KG = ({
  binaryId: e,
  date: t,
  details: n,
  hideEmpty: r,
  subtitle: s,
  title: a,
  resourceTypeTitle: o
}) => {
  const [c, l] = Y(!1);
  return /* @__PURE__ */ i.jsxs("div", { className: "ctw-space-y-1", children: [
    /* @__PURE__ */ i.jsx(
      d0,
      {
        date: t,
        title: a,
        subtitle: s,
        isDetailShown: c,
        setIsDetailShown: l,
        hasDocument: !!e,
        analyticsInteraction: "toggle_related_document_entry",
        analyticsActionExpand: "expand_related_document_entry",
        analyticsActionCollapse: "collapse_related_document_entry"
      }
    ),
    c && /* @__PURE__ */ i.jsx(
      Ur,
      {
        details: n,
        hideEmpty: r,
        documentButton: /* @__PURE__ */ i.jsx(
          zr,
          {
            binaryId: e,
            documentTitle: o,
            telemetryTarget: "related_document_entry"
          }
        )
      }
    )
  ] });
}, JG = 20;
function XG({
  limit: e = JG,
  getRelatedDocuments: t,
  referral: n
}) {
  var u;
  const r = t && t(n), s = (u = r == null ? void 0 : r.data) != null ? u : [], [a, o] = Y(!e || s.length <= e), { resourceTypeTitle: c } = n, l = nt(
    s,
    [
      // Convert the date string to a Date object so that it sorts correctly.
      (h) => h.date ? new Date(h.date) : "",
      // desc
      // We want to promote entries with a source document to the top.
      (h) => !!h.binaryId,
      // desc
      "title",
      // asc
      "subtitle",
      // asc
      "versionId"
      // desc
    ],
    ["desc", "desc", "asc", "asc", "desc"]
  ), d = a || !e ? l : l.slice(0, e);
  return r ? r.isLoading ? /* @__PURE__ */ i.jsx(Je, { message: "Loading documents..." }) : d.length === 0 ? /* @__PURE__ */ i.jsx(i.Fragment, {}) : /* @__PURE__ */ i.jsxs("div", { className: "ctw-space-y-4", children: [
    /* @__PURE__ */ i.jsx("div", { className: "ctw-text-lg ctw-font-semibold", children: "Documents" }),
    d.map((h) => /* @__PURE__ */ i.jsx("div", { children: /* @__PURE__ */ i.jsx(
      KG,
      {
        id: h.id,
        date: h.date,
        title: h.title,
        subtitle: h.subtitle,
        details: h.details,
        hideEmpty: h.hideEmpty,
        binaryId: h.binaryId,
        resourceTypeTitle: c
      }
    ) }, h.id)),
    !a && /* @__PURE__ */ i.jsx("div", { className: "ctw-text-center", children: /* @__PURE__ */ i.jsxs("button", { type: "button", className: "ctw-btn-primary", onClick: () => o(!0), children: [
      "Load ",
      l.length - e,
      " More"
    ] }) })
  ] }) : /* @__PURE__ */ i.jsx(i.Fragment, {});
}
function eY(e) {
  return {
    date: e.encounterDate,
    id: e.id,
    title: e.title,
    hideEmpty: !1,
    subtitle: e.custodian,
    details: [
      {
        label: "Status",
        value: qe(e.status)
      },
      {
        label: "Category",
        value: e.category.length > 0 ? e.category.map((t) => qe(t.text)).join(", ") : "Unknown"
      }
    ]
  };
}
function J1(e) {
  var t;
  return {
    data: ((t = e.encounter) == null ? void 0 : t.docsAndNotes.map(eY)) || [],
    isLoading: !1
  };
}
const tY = (e) => /* @__PURE__ */ i.jsx(
  XG,
  {
    limit: 10,
    getRelatedDocuments: J1,
    referral: e
  }
), X1 = () => _t({
  header: (e) => e.referredPractitionerName,
  subHeader: (e) => `${e.referredPracticeName} ${e.referredPracticePhoneNumber || ""}`,
  details: (e) => {
    var t, n, r;
    return Ee([
      {
        label: "Status",
        value: /* @__PURE__ */ i.jsx(
          kt,
          {
            color: e.status === "acknowledged" ? "muted" : "primary",
            content: Am(e.status === "acknowledged" ? "closed" : "open")
          }
        )
      },
      ...e.referredPractitioners.map((s, a) => ({
        label: e.referredPractitioners.length === 1 ? "Referred Provider" : `Referred Provider ${a + 1}`,
        value: /* @__PURE__ */ i.jsxs("div", { className: "ctw-leading-tight", children: [
          s.name || "Unknown",
          s.practiceName && /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
            /* @__PURE__ */ i.jsx("br", {}),
            s.practiceName
          ] }),
          s.phoneNumber && /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
            /* @__PURE__ */ i.jsx("br", {}),
            s.phoneNumber
          ] })
        ] })
      })),
      {
        beginsNewSection: !0,
        label: "Ordered",
        value: (t = e.referredAt) == null ? void 0 : t.toLocaleDateString()
      },
      e.status === "scheduled" && {
        label: "Scheduled By",
        value: /* @__PURE__ */ i.jsxs("div", { className: "ctw-leading-tight", children: [
          e.referredPracticeName,
          e.referredPracticePhoneNumber && /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
            /* @__PURE__ */ i.jsx("br", {}),
            e.referredPracticePhoneNumber
          ] })
        ] })
      },
      {
        label: "Ordered By",
        value: /* @__PURE__ */ i.jsxs("div", { className: "ctw-leading-tight", children: [
          e.referringPractitionerName || "Unknown",
          e.referringPracticeName && /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
            /* @__PURE__ */ i.jsx("br", {}),
            e.referringPracticeName
          ] }),
          e.referringPracticePhoneNumber && /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
            /* @__PURE__ */ i.jsx("br", {}),
            e.referringPracticePhoneNumber
          ] })
        ] })
      },
      e.status === "scheduled" && {
        label: "Scheduled",
        value: (n = e.scheduledAt) == null ? void 0 : n.toLocaleDateString()
      },
      e.status === "scheduled" && {
        label: "Scheduled by",
        value: /* @__PURE__ */ i.jsxs("div", { className: "ctw-leading-tight", children: [
          e.referredPracticeName && /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
            /* @__PURE__ */ i.jsx("br", {}),
            e.referringPracticeName
          ] }),
          e.referringPracticePhoneNumber && /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
            /* @__PURE__ */ i.jsx("br", {}),
            e.referringPracticePhoneNumber
          ] })
        ] })
      },
      ["pending-acknowledgement", "acknowledged"].includes(e.status) && {
        label: "Completed",
        value: (r = e.completedAt) == null ? void 0 : r.toLocaleDateString()
      },
      ["pending-acknowledgement", "acknowledged"].includes(e.status) && {
        label: "Completed By",
        value: e.referredPractitionerName || "Unknown"
      },
      { label: "Reason", value: e.reason }
    ]);
  },
  renderChild: (e) => tY(e),
  getSourceDocument: !1,
  enableDismissAndReadActions: !1
}), nY = Ae`
  ${JF}

  query Appointments($upid: ID!) {
    AppointmentConnection(upid: $upid) {
      edges {
        node {
          ...Appointment
        }
      }
    }
  }
`;
function rY(e, t) {
  return V(this, null, function* () {
    const n = Re(e), { data: r } = yield Ut(
      n,
      nY,
      "AppointmentConnection",
      {
        upid: t.UPID,
        cursor: "",
        first: 500
      }
    );
    return r.AppointmentConnection.edges.map(({ node: s }) => s);
  });
}
class sY extends Qe {
  constructor() {
    super(...arguments);
    ne(this, "kind", "Appointment");
  }
  get title() {
    var n, r, s, a, o;
    return ((n = this.resource.appointmentType) == null ? void 0 : n.text) || ((r = this.resource.serviceType) == null ? void 0 : r[0].text) || ((s = this.resource.serviceCategory) == null ? void 0 : s[0].text) || ((a = this.resource.specialty) == null ? void 0 : a[0].text) || ((o = this.resource.reasonCode) == null ? void 0 : o[0].text) || "Appointment";
  }
}
class aY extends Qe {
  constructor(n, r, s, a, o) {
    super(n);
    ne(this, "kind", "Referral");
    ne(this, "patientModel");
    ne(this, "appointmentResource");
    ne(this, "encounterResource");
    ne(this, "documentPool", []);
    this.documentPool = o || [], this.patientModel = r, this.appointmentResource = s, this.appointmentResource && (this.encounterResource = a);
  }
  get patient() {
    return this.patientModel;
  }
  get appointment() {
    return this.appointmentResource ? new sY(this.appointmentResource) : void 0;
  }
  get encounter() {
    const n = this.encounterResource ? new za(this.encounterResource, []) : void 0;
    return n && n.setClinicalNotesFromDocumentPool(this.documentPool), n;
  }
  get resourceTypeTitle() {
    return "Referral";
  }
  get title() {
    var n;
    return ((n = this.resource.category) == null ? void 0 : n[0].text) || "Referral";
  }
  get referringPracticeName() {
    return this.patient.organizationDisplayName;
  }
  get referringPractitionerName() {
    var n;
    return (n = this.resource.requester) == null ? void 0 : n.display;
  }
  get referringPracticePhoneNumber() {
    var n;
    return (n = this.patient.organization) == null ? void 0 : n.phone;
  }
  get referredAt() {
    const n = this.resource.occurrenceDateTime || this.resource.authoredOn;
    return n ? un(n) : void 0;
  }
  get scheduledAt() {
    var n;
    return (n = this.appointmentResource) != null && n.start ? un(this.appointmentResource.start) : void 0;
  }
  get referredPractitioners() {
    return (this.resource.performer || []).map((n, r) => {
      var s, a;
      return {
        name: n.display,
        practiceName: (a = (s = this.resource.locationReference) == null ? void 0 : s[r]) == null ? void 0 : a.display,
        // TODO: fetch from location reference?
        phoneNumber: void 0
      };
    });
  }
  get referredPractitionerName() {
    return this.referredPractitioners[0].name;
  }
  get referredPracticeName() {
    return this.referredPractitioners[0].practiceName;
  }
  get referredPracticePhoneNumber() {
    return this.referredPractitioners[0].phoneNumber;
  }
  get completedAt() {
    var r, s, a;
    const n = (a = (r = this.appointmentResource) == null ? void 0 : r.end) != null ? a : (s = this.appointmentResource) == null ? void 0 : s.start;
    return n ? un(n) : void 0;
  }
  get acknowledged() {
    return !1;
  }
  get status() {
    return this.appointment ? this.encounter ? this.acknowledged ? "acknowledged" : "pending-acknowledgement" : "scheduled" : "ordered";
  }
  get reason() {
    var n;
    return ((n = this.resource.reasonCode) == null ? void 0 : n[0].text) || "Unknown";
  }
}
const iY = (e, t) => e.getDate() === t.getDate() && e.getMonth() === t.getMonth() && e.getFullYear() === t.getFullYear(), oY = (e, t) => t.find(
  (n) => {
    var r;
    return (r = n.basedOn) == null ? void 0 : r.some(
      (s) => s.reference === `ServiceRequest/${e.id}`
    );
  }
), cY = (e, t) => t.find(
  (n) => {
    var r;
    return e.start && ((r = n.period) == null ? void 0 : r.start) && iY(un(n.period.start), un(e.start));
  }
), ew = () => {
  const { patient: e } = Ze(), t = Oe(
    iF,
    [],
    y1
  ), n = Oe(
    oF,
    [],
    rY
  ), r = ei(), s = Es();
  if (t.isLoading || e.isLoading || n.isLoading || r.isLoading || s.isLoading)
    return {
      isLoading: !0,
      data: []
    };
  const a = e.data === void 0 ? [] : (t.data || []).filter((o) => o.status === "active").map((o) => {
    const c = oY(
      o,
      n.data || []
    ), l = c ? cY(
      c,
      s.data.map((d) => d.resource)
    ) : void 0;
    return new aY(
      o,
      e.data,
      c,
      l,
      r.data
    );
  });
  return {
    isLoading: !1,
    data: nt(
      a,
      [(o) => o.status, (o) => o.referredAt],
      ["desc", "desc"]
    )
  };
}, tw = "Referrals", nw = "All Referrals", lY = ({ referral: e }) => {
  const t = J1(e), n = t.isLoading ? [] : t.data;
  return n.length === 0 && ["fulfilled", "acknowledged"].includes(e.status) ? /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-gap-1 ctw-items-center", children: [
    /* @__PURE__ */ i.jsx(me, { className: "ctw-w-4 ctw-text-content-lighter", icon: ss }),
    /* @__PURE__ */ i.jsx("div", { className: "ctw-text-content-lighter", children: "No documents available" })
  ] }) : n.length > 0 ? /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-gap-1 ctw-items-center", children: [
    /* @__PURE__ */ i.jsx(me, { className: "ctw-w-4 ctw-text-content-lighter", icon: ss }),
    /* @__PURE__ */ i.jsx("div", { children: "Documents available" })
  ] }) : /* @__PURE__ */ i.jsx(i.Fragment, {});
}, dY = ({
  onSeeAllResources: e
}) => {
  const t = ew(), n = X1();
  return /* @__PURE__ */ i.jsx(
    Q0,
    {
      groupBy: (r) => r.status === "acknowledged" ? "past" : "current",
      groupByKeyOrder: ["open", "closed"],
      onSeeAllResources: e,
      onRowClick: n,
      data: t.data,
      emptyMessage: "We didn't find any referrals for this patient.",
      footerText: nw,
      title: tw,
      tooltipText: "Referrals for the patient",
      isLoading: t.isLoading,
      icon: Vw,
      trackingName: "referrals_overview",
      dataTestId: "referrals-overview",
      children: (r) => {
        var s, a, o;
        return /* @__PURE__ */ i.jsxs("div", { className: "ctw-px-[1.5rem] ctw-pt-2 ctw-border-t", children: [
          /* @__PURE__ */ i.jsx("div", { className: "ctw-font-medium", children: r.referredPractitionerName }),
          /* @__PURE__ */ i.jsxs("div", { children: [
            r.referredPracticeName,
            " ",
            r.referredPracticePhoneNumber || ""
          ] }),
          /* @__PURE__ */ i.jsx("hr", { className: "ctw-my-1" }),
          /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-gap-1", children: [
            /* @__PURE__ */ i.jsx(me, { className: "ctw-w-4 ctw-text-content-lighter", icon: xv }),
            /* @__PURE__ */ i.jsxs("div", { children: [
              "Ordered ",
              (s = r.referredAt) == null ? void 0 : s.toLocaleDateString(),
              " by",
              " ",
              r.referringPractitionerName || "Unknown"
            ] })
          ] }),
          ["scheduled", "pending-acknowledgement", "acknowledged"].includes(r.status) && /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-gap-1", children: [
            /* @__PURE__ */ i.jsx(me, { className: "ctw-w-4 ctw-text-content-lighter", icon: td }),
            /* @__PURE__ */ i.jsxs("div", { children: [
              "Scheduled ",
              (a = r.scheduledAt) == null ? void 0 : a.toLocaleDateString(),
              " by",
              " ",
              r.referredPracticeName || "Unknown"
            ] })
          ] }),
          ["pending-acknowledgement", "acknowledged"].includes(r.status) && /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-gap-1", children: [
            /* @__PURE__ */ i.jsx(me, { className: "ctw-w-4 ctw-text-content-lighter", icon: td }),
            /* @__PURE__ */ i.jsxs("div", { children: [
              "Completed ",
              (o = r.completedAt) == null ? void 0 : o.toLocaleDateString(),
              " by",
              " ",
              r.referredPracticeName || "Unknown"
            ] })
          ] }),
          /* @__PURE__ */ i.jsx(lY, { referral: r })
        ] });
      }
    }
  );
}, uY = xn({
  component: dY,
  name: "PatientReferralsOverview",
  title: tw,
  footerTitle: nw,
  tabToNavigateTo: "referrals"
});
class fY {
  constructor(t, n) {
    ne(this, "vitals");
    ne(this, "encounter");
    this.vitals = t, this.encounter = n;
  }
  get key() {
    var t, n;
    return ((t = this.encounter) == null ? void 0 : t.id) || ((n = this.vitals[0]) == null ? void 0 : n.id) || "";
  }
  get date() {
    return ye(this.dateTime);
  }
  // Our dateTime is based on the encounter date, if available, or the first vital date.
  get dateTime() {
    var t;
    return this.encounter ? (t = this.encounter.resource.period) == null ? void 0 : t.start : this.vitals[0].effectiveStartRaw;
  }
  get binaryId() {
    var t, n;
    return (t = this.encounter) != null && t.docsAndNotes.length ? this.encounter.docsAndNotes[0].binaryId : (n = this.vitals.find((r) => r.binaryId)) == null ? void 0 : n.binaryId;
  }
  get bmi() {
    return this.getVital(A1, { precision: 0 });
  }
  get bloodPressure() {
    const t = this.getVital(x1, { precision: 0 }), n = this.getVital(b1, { precision: 0 });
    if (t || n)
      return `${t || ""} / ${n || ""}`;
  }
  get headCircumference() {
    return this.getVital(E1, { precision: 1, unit: !0 });
  }
  get height() {
    return this.getVital(S1, { precision: 1, unit: !0 });
  }
  // Special key for filtering. See utils/filters.ts.
  get isHidden() {
    var t;
    return !!((t = this.encounter) != null && t.isHospitalEncounter);
  }
  get lmp() {
    return this.getVital(I1);
  }
  get location() {
    var t;
    return (t = this.encounter) == null ? void 0 : t.location.join(", ");
  }
  get oxygenSaturation() {
    return this.getVital(D1, { precision: 1 });
  }
  get pain() {
    return this.getVital(_1, { precision: 0 });
  }
  get pulse() {
    return this.getVital(j1, { precision: 0 });
  }
  get respiratoryRate() {
    return this.getVital(N1, { precision: 0 });
  }
  get temperature() {
    return this.getVital(C1, { precision: 1, unit: !0 });
  }
  get typeDisplay() {
    var t;
    return (t = this.encounter) == null ? void 0 : t.typeDisplay;
  }
  get weight() {
    return this.getVital($1, { precision: 1, unit: !0 });
  }
  getVital(t, n) {
    var s;
    const r = hY(this.vitals, t);
    if (r) {
      const a = gY(r.value, { precision: (s = n == null ? void 0 : n.precision) != null ? s : 0 });
      return n != null && n.unit ? mY(a, r.unit) : String(a);
    }
    return pY(this.vitals, t);
  }
}
function hY(e, t) {
  var a, o, c;
  const n = e.filter(
    (l) => zc(Yt, t, l.resource.code) && l.resource.valueQuantity && l.resource.valueQuantity.value !== void 0
  );
  if (n.length === 0)
    return;
  const r = n.map((l) => {
    var d;
    return (d = l.resource.valueQuantity) == null ? void 0 : d.unit;
  });
  return ht(r).length === 1 ? {
    value: n6(n.map((l) => {
      var d;
      return ((d = l.resource.valueQuantity) == null ? void 0 : d.value) || 0;
    })) / n.length,
    unit: (o = (a = n[0]) == null ? void 0 : a.resource.valueQuantity) == null ? void 0 : o.unit
  } : (c = yn(n, (l) => l.effectiveStartRaw, "desc", !0)[0]) == null ? void 0 : c.resource.valueQuantity;
}
function pY(e, t) {
  var s;
  const n = e.filter(
    (a) => zc(Yt, t, a.resource.code) && a.value !== ""
  );
  return n.length === 0 || (s = yn(n, (a) => a.effectiveStartRaw, "desc", !0)[0]) == null ? void 0 : s.value;
}
function mY(e, t) {
  return e !== void 0 && t !== void 0 ? `${e} ${t}` : String(e);
}
function gY(e, t) {
  if (e !== void 0)
    return $8(e, t.precision);
}
const wY = Ae`
  ${Wa}

  query Vitals(
    $upid: ID!
    $cursor: String!
    $sort: ObservationSortParams!
    $filter: ObservationFilterParams!
    $first: Int!
  ) {
    ObservationConnection(
      upid: $upid
      after: $cursor
      filter: $filter
      sort: $sort
      first: $first
    ) {
      pageInfo {
        hasNextPage
      }
      edges {
        node {
          id
          resourceType
          encounter {
            reference
          }
          code {
            text
            coding {
              code
              display
              system
              extension {
                url
                valueString
              }
            }
          }
          effectivePeriod {
            start
            end
          }
          effectiveDateTime
          ProvenanceList(_reference: "target") {
            id
            entity {
              what {
                ...Reference
              }
            }
          }
          valueQuantity {
            comparator
            unit
            value
            system
            code
          }
          valueCodeableConcept {
            text
            coding {
              system
              code
              display
            }
          }
          valueString
          valueBoolean
          valueInteger
          valueRange {
            low {
              unit
              value
              system
              code
            }
            high {
              unit
              value
              system
              code
            }
          }
          valueRatio {
            numerator {
              comparator
              unit
              value
              system
              code
            }
            denominator {
              unit
              value
              system
              code
            }
          }
          valueTime
          valueDateTime
          valuePeriod {
            start
            end
          }
        }
      }
    }
  }
`;
function Hl() {
  return Oe(cF, [], vY);
}
function vY(e, t) {
  return V(this, null, function* () {
    const n = yield yY(e, t);
    if (n.length === 0)
      return [];
    const r = yield xY(n, e, t);
    return bY(n, r);
  });
}
function yY(e, t) {
  return V(this, null, function* () {
    const n = T1.map((o) => `${Yt}|${o}`), r = Re(e), { data: s } = yield dt(r, wY, {
      upid: t.UPID,
      cursor: "",
      first: jt,
      sort: {
        lastUpdated: "DESC"
      },
      filter: {
        code: {
          anymatch: n
        }
      }
    });
    return s.ObservationConnection.edges.map(
      ({ node: o }) => new rl(o, o.ProvenanceList)
    ).filter((o) => o.value !== "");
  });
}
function xY(e, t, n) {
  const r = ht(
    e.map((a) => {
      var o;
      return (o = a.resource.encounter) == null ? void 0 : o.reference;
    })
  ), s = Ee(r.map(mF));
  return Vq(jt, s)(t, n);
}
function bY(e, t) {
  const n = Dn(e, (s) => s.effectiveStart), r = Dn(t, "periodStart");
  return Object.entries(n).map(([s, a]) => {
    var l;
    const o = nt(
      r[s],
      (d) => {
        var u;
        return (u = d.resource.period) == null ? void 0 : u.start;
      },
      "desc"
    ), c = (l = o.find((d) => d.typeDisplay !== "Unknown")) != null ? l : o[0];
    return new fY(a, c);
  });
}
const jY = [
  { title: "BP", dataIndex: "bloodPressure" },
  { title: "HR", dataIndex: "pulse" },
  { title: "Temp", dataIndex: "temperature" },
  { title: "RR", dataIndex: "respiratoryRate" },
  { title: "SpO2", dataIndex: "oxygenSaturation" },
  { title: "Ht/Lt", dataIndex: "height" },
  { title: "Wt", dataIndex: "weight" },
  { title: "BMI", dataIndex: "bmi" },
  { title: "HC", dataIndex: "headCircumference" },
  { title: "LMP", dataIndex: "lmp" },
  { title: "Pain", dataIndex: "pain" }
], CY = ["HC", "LMP", "Pain"];
function NY() {
  const { data: e, isLoading: t } = Hl();
  return ke(() => {
    if (t || !(e != null && e.length))
      return {
        isLoading: t,
        data: []
      };
    const n = nt(e, (s) => s.dateTime, "desc");
    return {
      isLoading: !1,
      data: jY.map((s) => {
        const a = n.find((l) => l[s.dataIndex]), o = a == null ? void 0 : a[s.dataIndex], c = a == null ? void 0 : a.date;
        return {
          vital: s.title,
          value: o,
          date: c
        };
      }).filter(
        (s) => !CY.includes(s.vital) || s.value !== void 0
      )
    };
  }, [e, t]);
}
const rw = "Most Recent Vitals", sw = "All Vitals", DY = ({
  onSeeAllResources: e
}) => {
  const { trackInteraction: t } = Be(), { data: n, isLoading: r } = Hl(), s = NY();
  return /* @__PURE__ */ i.jsx(
    Ds,
    {
      icon: qw,
      isLoading: r,
      title: rw,
      tooltipText: "Displays most recent available recorded vitals",
      footerText: sw,
      hideFooter: r || (n == null ? void 0 : n.length) === 0,
      footerOnClick: () => {
        t("see_all_of_resource", { target: "vitals_overview" }), e();
      },
      dataTestId: "patient-vitals-overview",
      children: !n || n.length === 0 ? /* @__PURE__ */ i.jsx(Vr, { message: "No vitals records found." }) : s.data.map((a) => /* @__PURE__ */ i.jsxs(
        "div",
        {
          className: "ctw-py-1.5 ctw-px-3 ctw-flex ctw-space-x-3",
          "data-testid": "overview-row",
          children: [
            /* @__PURE__ */ i.jsx("div", { className: "ctw-font-medium ctw-w-14", children: a.vital }),
            /* @__PURE__ */ i.jsx("div", { className: "ctw-text-right ctw-w-[7.25rem]", children: a.value }),
            /* @__PURE__ */ i.jsx("div", { className: "ctw-text-right ctw-w-[5.25rem]", children: a.date ? a.date : /* @__PURE__ */ i.jsx("span", { className: "ctw-text-content-lighter", children: "N/A" }) })
          ]
        },
        a.vital
      ))
    }
  );
}, SY = xn({
  component: DY,
  name: "PatientVitalsOverview",
  title: rw,
  footerTitle: sw,
  tabToNavigateTo: "vitals"
}), $Y = ({
  className: e,
  hideRequestRecords: t = !1,
  tabsToUseToDetermineIfDataExists: n,
  onSeeAllResources: r,
  onAfterDetailsDrawerClosed: s,
  onOpenDetailsDrawer: a,
  conditionIdForDetailsDrawer: o
}) => {
  const c = Te(null), [l, d] = Y(1), u = wt(c), { tabOrder: h } = tt(Jn), f = R1(
    n || h
  ), p = q1(), m = Gt("ctw-referrals"), C = Gt("ctw-care-gaps-overview"), y = 12, g = Array.from(f.values()).some((N) => N);
  if (Tc(() => {
    const N = Math.floor(
      (u.width - Vf) / (Vf + y)
    );
    d(Math.max(1 + N, 1));
  }, [u]), !g)
    return /* @__PURE__ */ i.jsx("div", { className: W(e, "ctw-scrollable-pass-through-height ctw-pt-8"), children: /* @__PURE__ */ i.jsx("div", { className: "ctw-text-center", children: /* @__PURE__ */ i.jsx(xt, { resourceName: "overview", hasZeroFilteredRecords: !0 }) }) });
  if (p.isLoading)
    return /* @__PURE__ */ i.jsx("div", { className: W(e, "ctw-scrollable-pass-through-height ctw-pt-8"), children: /* @__PURE__ */ i.jsx("div", { className: "ctw-text-center", children: /* @__PURE__ */ i.jsx("span", { className: "ctw-font-medium", children: "Loading..." }) }) });
  const { overviewCards: w = {} } = p.data || {}, x = (N) => {
    var v;
    return ((v = w[N]) == null ? void 0 : v.enabled) !== !1;
  }, S = [
    x("conditions") && /* @__PURE__ */ i.jsx(
      VW,
      {
        onSeeAllResources: () => r("conditions"),
        onAfterDetailsDrawerClosed: s,
        onOpenDetailsDrawer: a,
        conditionIdForDetailsDrawer: o
      },
      "conditions"
    ),
    x("referrals") && m && /* @__PURE__ */ i.jsx(
      uY,
      {
        onSeeAllResources: () => r("referrals")
      },
      "referrals"
    ),
    x("medications") && /* @__PURE__ */ i.jsx(ZG, { onSeeAllResources: () => r("medications") }),
    x("diagnostics") && /* @__PURE__ */ i.jsx(
      hV,
      {
        onSeeAllResources: () => r("diagnostics")
      }
    ),
    x("encounters") && /* @__PURE__ */ i.jsx(MG, { onSeeAllResources: () => r("encounters") }),
    x("episodesOfCare") && /* @__PURE__ */ i.jsx(YG, { onSeeAllResources: () => r("encounters") }),
    x("vitals") && /* @__PURE__ */ i.jsx(SY, { onSeeAllResources: () => r("vitals") }),
    x("zusInformation") && /* @__PURE__ */ i.jsx(CG, { hideRequestRecords: t }),
    x("careGaps") && C && /* @__PURE__ */ i.jsx(_G, {})
  ].filter(Boolean);
  return /* @__PURE__ */ i.jsx("div", { className: e, ref: c, children: /* @__PURE__ */ i.jsx(Ov, { gutter: `${y}px`, columnsCount: l, children: S }) });
}, AY = He($Y, "PatientOverview"), EY = ({
  hideRequestRecords: e = !1
}) => {
  const { setSelectedTab: t } = tt(Jn);
  function n(r) {
    switch (r) {
      case "conditions":
        t("conditions-all");
        break;
      case "referrals":
        t("referrals");
        break;
      case "medications":
        t("medications-all");
        break;
      case "diagnostics":
        t("diagnostic-reports");
        break;
      case "encounters":
        t("encounters");
        break;
      case "vitals":
        t("vitals");
        break;
    }
  }
  return /* @__PURE__ */ i.jsx(
    AY,
    {
      className: "ctw-pt-5",
      onSeeAllResources: n,
      hideRequestRecords: e
    }
  );
}, IY = He(EY, "PatientOverview"), Ki = (e, t) => {
  var n, r;
  return (r = (n = t.resource.meta) == null ? void 0 : n.tag) != null && r.find((s) => s.code === `builder/${e}`) ? "internal" : "external";
}, _Y = (e, t) => ({
  // Reduce an array of `CanonicalPhone` records from the given patient records.
  phones: Object.values(
    t.reduce(
      (n, r) => [
        ...n,
        ...(r.resource.telecom || []).filter((s) => s.system === "phone" && !xe(s.value)).map((s) => {
          var a;
          return {
            key: (s.value || "").replace(/\D/g, "").trim(),
            rank: (a = s.period) != null && a.end ? 0 : 1,
            tags: [Ki(e, r)],
            uses: [s.use || "unknown"],
            value: (s.value || "").replace(/\D/g, "").trim(),
            sources: [r.organizationDisplayName || "Unknown"]
          };
        })
      ],
      []
    ).reduce((n, r) => {
      const s = R({}, n);
      return Object.hasOwn(n, r.value) ? s[r.value] = {
        key: r.value,
        rank: n[r.value].rank + r.rank,
        tags: [.../* @__PURE__ */ new Set([...n[r.value].tags, ...r.tags])],
        value: r.value,
        uses: [.../* @__PURE__ */ new Set([...n[r.value].uses, ...r.uses])],
        sources: [.../* @__PURE__ */ new Set([...n[r.value].sources, ...r.sources])]
      } : s[r.value] = r, s;
    }, {})
    // Sort records descending by `rank`
  ).sort((n, r) => r.rank - n.rank),
  // Reduce an array of `CanonicalEmail` records from the given patient records.
  emails: Object.values(
    t.reduce(
      (n, r) => [
        ...n,
        ...(r.resource.telecom || []).filter((s) => s.system === "email" && !xe(s.value)).map((s) => {
          var a;
          return {
            key: (s.value || "").trim(),
            rank: (a = s.period) != null && a.end ? 0 : 1,
            tags: [Ki(e, r)],
            value: (s.value || "").trim(),
            sources: [r.organizationDisplayName || "Unknown"]
          };
        })
      ],
      []
    ).reduce((n, r) => {
      const s = R({}, n);
      return Object.hasOwn(n, r.value) ? s[r.value] = {
        key: r.value,
        rank: n[r.value].rank + r.rank,
        tags: [.../* @__PURE__ */ new Set([...n[r.value].tags, ...r.tags])],
        value: r.value,
        sources: [.../* @__PURE__ */ new Set([...n[r.value].sources, ...r.sources])]
      } : s[r.value] = r, s;
    }, {})
    // Sort records descending by `rank`
  ).sort((n, r) => r.rank - n.rank),
  // Reduce an array of `CanonicalAddress` records from the given patient records.
  addresses: Object.values(
    t.reduce(
      (n, r) => [
        ...n,
        ...(r.resource.address || []).filter(
          (s) => !xe(s.city) && !xe(s.country) && !xe(s.postalCode) && !xe(s.state) && !xe(s.line)
        ).map((s) => {
          var a;
          return {
            key: JSON.stringify(s, Object.keys(s).sort()),
            rank: (a = s.period) != null && a.end ? 0 : 1,
            tags: [Ki(e, r)],
            city: s.city || "Unknown",
            country: s.country || "Unknown",
            line: Array.isArray(s.line) ? s.line : ["Unknown"],
            postalCode: s.postalCode || "Unknown",
            state: s.state || "Unknown",
            sources: [r.organizationDisplayName || "Unknown"]
          };
        })
      ],
      []
    ).reduce((n, r) => {
      const s = R({}, n), a = JSON.stringify(r, Object.keys(r).sort());
      return Object.hasOwn(n, a) ? s[a] = X(R({}, r), {
        rank: n[a].rank + r.rank,
        tags: [.../* @__PURE__ */ new Set([...n[a].tags, ...r.tags])],
        sources: [.../* @__PURE__ */ new Set([...n[a].sources, ...r.sources])]
      }) : s[a] = r, s;
    }, {})
    // Sort records descending by `rank`
  ).sort((n, r) => r.rank - n.rank)
}), Ji = ({ children: e, className: t }) => {
  const n = Te(null), r = () => {
    var a;
    const s = ((a = n.current) == null ? void 0 : a.textContent) || "";
    navigator.clipboard.writeText(s).then(() => {
      Bn({
        type: "info",
        title: `Copied to clipboard: '${s}'`
      });
    });
  };
  return /* @__PURE__ */ i.jsxs(
    "button",
    {
      onClick: r,
      type: "button",
      className: W(
        t,
        "ctw-flex ctw-gap-1 ctw-items-center ctw-border ctw-border-transparent hover:ctw-border-content-lighter ctw-rounded-md ctw-px-1"
      ),
      children: [
        /* @__PURE__ */ i.jsx("div", { ref: n, children: e }),
        /* @__PURE__ */ i.jsx(me, { icon: Gw, className: "ctw-h-4 ctw-w-4 ctw-text-content-lighter" })
      ]
    }
  );
};
function Xi({ emptyStateMessage: e, entries: t, limit: n }) {
  const [r, s] = Y(!1), a = r || !n ? t : t.slice(0, n);
  return /* @__PURE__ */ i.jsxs("div", { className: "ctw-space-y-4", children: [
    /* @__PURE__ */ i.jsxs("div", { className: "ctw-divide-y ctw-rounded-lg ctw-border", children: [
      a.length > 0 && a.map((o) => /* @__PURE__ */ i.jsx("dl", { className: "ctw-space-y-2 ctw-p-4", children: o.data.map(({ label: c, value: l }, d) => /* @__PURE__ */ i.jsxs(
        "div",
        {
          className: "ctw-text-gray-900 ctw-flex ctw-items-baseline ctw-space-x-4",
          children: [
            /* @__PURE__ */ i.jsxs("dt", { className: "ctw-w-1/3 ctw-flex-shrink-0 ctw-font-medium", children: [
              c,
              ":"
            ] }),
            /* @__PURE__ */ i.jsx("dd", { className: "ctw-flex-grow", children: l || "" })
          ]
        },
        c + d
      )) }, o.id)),
      a.length === 0 && e ? /* @__PURE__ */ i.jsx("div", { className: "ctw-w-full ctw-h-full ctw-flex ctw-items-center ctw-justify-center ctw-py-5 ctw-px-5", children: /* @__PURE__ */ i.jsx("div", { children: e }) }) : /* @__PURE__ */ i.jsx(i.Fragment, {})
    ] }),
    !r && n && t.length > n && /* @__PURE__ */ i.jsx("div", { className: "ctw-text-center", children: /* @__PURE__ */ i.jsxs("button", { type: "button", className: "link-primary", onClick: () => s(!0), children: [
      "Load ",
      t.length - n,
      " More"
    ] }) })
  ] });
}
const TY = ({ className: e }) => {
  const t = ut(), n = Kg({
    includeCurrentBuilder: !0
  });
  if (!n.data)
    return /* @__PURE__ */ i.jsx(Je, {});
  const r = _Y(t, n.data);
  return /* @__PURE__ */ i.jsx(ft, { componentName: "ContactInformation", children: /* @__PURE__ */ i.jsx("div", { className: W(e, "ctw-scrollable-pass-through-height ctw-pt-5"), children: /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-flex-col ctw-justify-between ctw-gap-5", children: [
    /* @__PURE__ */ i.jsxs("div", { "data-testid": "phone-numbers", children: [
      /* @__PURE__ */ i.jsx(eo, { children: "Phone Numbers" }),
      /* @__PURE__ */ i.jsx(
        Xi,
        {
          emptyStateMessage: "No phone numbers found.",
          limit: 1,
          entries: r.phones.map((s) => ({
            id: "phone_numbers",
            data: [
              {
                label: "Phone Number",
                value: /* @__PURE__ */ i.jsx(Ji, { className: "ctw-font-medium", children: La(s.value) })
              },
              {
                label: "Designations",
                value: /* @__PURE__ */ i.jsx("div", { className: "ctw-flex ctw-gap-2", children: s.uses.map((a) => /* @__PURE__ */ i.jsx(kt, { color: "muted", content: a }, a)) })
              },
              {
                label: "Sources",
                value: /* @__PURE__ */ i.jsx(to, { canonicalContact: s })
              }
            ]
          }))
        }
      )
    ] }),
    /* @__PURE__ */ i.jsxs("div", { "data-testid": "email-addresses", children: [
      /* @__PURE__ */ i.jsx(eo, { children: "Email Addresses" }),
      /* @__PURE__ */ i.jsx(
        Xi,
        {
          emptyStateMessage: "No email addresses found.",
          limit: 1,
          entries: r.emails.map((s) => ({
            id: "email_addresses",
            data: [
              {
                label: "Email Address",
                value: /* @__PURE__ */ i.jsx(Ji, { className: "ctw-font-medium", children: s.value })
              },
              {
                label: "Sources",
                value: /* @__PURE__ */ i.jsx(to, { canonicalContact: s })
              }
            ]
          }))
        }
      )
    ] }),
    /* @__PURE__ */ i.jsxs("div", { "data-testid": "addresses", children: [
      /* @__PURE__ */ i.jsx(eo, { children: "Addresses" }),
      /* @__PURE__ */ i.jsx(
        Xi,
        {
          emptyStateMessage: "No addresses found.",
          limit: 1,
          entries: r.addresses.map((s) => ({
            id: "addresses",
            data: [
              {
                label: "Address",
                value: /* @__PURE__ */ i.jsx(Ji, { className: "ctw-font-medium", children: `${s.line.join(" ")}, ${s.city}, ${s.state} ${s.postalCode}, ${s.country}` })
              },
              {
                label: "Sources",
                value: /* @__PURE__ */ i.jsx(to, { canonicalContact: s })
              }
            ]
          }))
        }
      )
    ] })
  ] }) }) });
}, eo = ({ children: e }) => /* @__PURE__ */ i.jsx("h2", { className: "ctw-text-base ctw-font-medium ctw-uppercase ctw-text-content-black", children: e }), to = ({ canonicalContact: e }) => /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-gap-2", children: [
  e.tags.map((t) => /* @__PURE__ */ i.jsx("div", { children: /* @__PURE__ */ i.jsx(kt, { color: t === "internal" ? "primary" : "info", content: t }) }, t)),
  /* @__PURE__ */ i.jsx(Sn, { content: e.sources.join(", "), children: /* @__PURE__ */ i.jsx(
    kt,
    {
      color: "muted",
      content: /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-gap-1 ctw-items-center ctw-justify-center", children: [
        /* @__PURE__ */ i.jsxs("div", { children: [
          e.sources.length,
          " sources"
        ] }),
        /* @__PURE__ */ i.jsx(
          me,
          {
            icon: Ho,
            className: "ctw-w-3 ctw-h-3 ctw-text-content-lighter"
          }
        )
      ] })
    }
  ) })
] }), RY = He(
  TY,
  "ContactInformation"
), aw = Ct({
  id: ""
});
function MY({ children: e, id: t = "" }) {
  const n = ke(
    () => ({
      id: t
    }),
    [t]
  );
  return /* @__PURE__ */ i.jsx(aw.Provider, { value: n, children: e });
}
const PY = (e) => {
  const { analyticsEvent: t } = Be(), { id: n } = tt(aw), [r, s] = Y(!1), [a, o] = Y(!1), [c, l] = Y(!1), [d, u] = Y(), { getRequestContext: h } = Xe();
  return {
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    submit: (p) => V(void 0, null, function* () {
      const m = yield h();
      s(!0), l(!1), u(void 0);
      try {
        const C = JSON.stringify({
          query_id: n,
          feedback: p.feedback,
          rating: p.feedbackType,
          target: e
        });
        yield fetch(`${Kt(m.env, "search-poc")}/feedback`, {
          method: "POST",
          body: C,
          headers: {
            Authorization: `Bearer ${m.authToken}`,
            "Content-Type": "application/json",
            "Zus-Account": m.builderId
          }
        }), o(!0);
      } catch (C) {
        u(C.message), l(!0);
      } finally {
        s(!1), t("feedback", {
          value: "ai_search",
          feedbackType: p.feedbackType,
          target: e
        });
      }
    }),
    isSubmitting: r,
    isSubmitted: a,
    isError: c,
    errorMessage: d
  };
}, OY = ({ name: e }) => {
  const [t, n] = Y(!1), [r, s] = Y(!1), [a, o] = Y(""), [c, l] = Y(""), { submit: d, isSubmitting: u, isSubmitted: h, isError: f, errorMessage: p } = PY(e);
  he(() => {
    let x;
    return h && (s(!0), x = setTimeout(() => {
      s(!1);
    }, 2500)), () => clearTimeout(x);
  }, [h]);
  const m = () => {
    o("negative"), n(!0);
  }, C = () => {
    o("positive"), n(!1), d({
      feedback: "",
      feedbackType: "positive"
    });
  }, y = (x) => {
    l(x.target.value);
  }, g = () => {
    d({
      feedback: c,
      feedbackType: a
    });
  }, w = () => {
    n(!1), l(""), o(""), s(!1);
  };
  return u ? /* @__PURE__ */ i.jsxs("div", { children: [
    "Submitting feedback... ",
    /* @__PURE__ */ i.jsx(Je, {})
  ] }) : h ? r ? /* @__PURE__ */ i.jsx("div", { className: "ctw-patient-record-search-feedback", children: /* @__PURE__ */ i.jsx("span", { children: f ? `There was an error submitting your feedback; ${p}` : "Thank you for your feedback!" }) }) : null : /* @__PURE__ */ i.jsxs("div", { className: "ctw-patient-record-search-feedback", children: [
    !t && /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
      /* @__PURE__ */ i.jsx(
        "button",
        {
          type: "button",
          className: "ctw-btn ctw-btn-clear ctw-mr-0.5",
          onClick: C,
          children: /* @__PURE__ */ i.jsxs("span", { className: "ctw-inline-block ctw-h-4 ctw-w-4", children: [
            " ",
            /* @__PURE__ */ i.jsx(G7, { className: "ctw-stroke-black hover:ctw-fill-primary-light hover:ctw-stroke-primary-dark" })
          ] })
        }
      ),
      /* @__PURE__ */ i.jsx(
        "button",
        {
          type: "button",
          className: "ctw-btn ctw-btn-clear ctw-mr-0.5",
          onClick: m,
          children: /* @__PURE__ */ i.jsxs("span", { className: "ctw-inline-block ctw-h-4 ctw-w-4", children: [
            " ",
            /* @__PURE__ */ i.jsx(W7, { className: "ctw-stroke-black hover:ctw-fill-error-light hover:ctw-stroke-error-dark" })
          ] })
        }
      )
    ] }),
    t && /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
      /* @__PURE__ */ i.jsx(
        "input",
        {
          type: "text",
          placeholder: "Please provide more feedback...",
          className: "ctw-rounded-md ctw-border ctw-border-solid ctw-border-icon-light ctw-bg-bg-white ctw-px-3 ctw-py-2 ctw-pl-1.5 ctw-pr-1.5 ctw-text-sm ctw-shadow-sm",
          value: c,
          onChange: y,
          onKeyUp: (x) => {
            !x.metaKey && x.key === "Enter" && g(), x.key === "Escape" && w();
          }
        }
      ),
      /* @__PURE__ */ i.jsx("button", { type: "button", className: "ctw-btn ctw-btn-primary ctw-ml-3", onClick: g, children: "Submit" })
    ] })
  ] });
};
function ns({
  resource: e,
  heading: t,
  openDetails: n,
  label: r,
  text: s,
  details: a
}) {
  return /* @__PURE__ */ i.jsxs("div", { className: "ctw-patient-record-search-result", children: [
    /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-items-end ctw-justify-between", children: [
      /* @__PURE__ */ i.jsxs("span", { children: [
        /* @__PURE__ */ i.jsx(
          "button",
          {
            type: "button",
            className: "ctw-patient-record-search-result-btn",
            onClick: () => n == null ? void 0 : n(e),
            children: t
          }
        ),
        /* @__PURE__ */ i.jsx(kt, { color: "primary", content: r })
      ] }),
      /* @__PURE__ */ i.jsx(OY, { name: `${e.resourceType}/${e.id}` })
    ] }),
    /* @__PURE__ */ i.jsx("div", { className: "ctw-patient-record-search-text", children: s }),
    /* @__PURE__ */ i.jsx("div", { className: "ctw-patient-record-search-details", children: a == null ? void 0 : a.map((o) => /* @__PURE__ */ i.jsx("div", { "data-label": o.label, children: o.value }, o.label)) })
  ] });
}
function kY(e) {
  var h;
  const { document: t } = e, u = t, { resource: n } = u, r = ct(u, ["resource"]), s = r.metadata.resource_type, a = Ka({}), o = _t({
    header: (f) => qe(f.display),
    details: El,
    renderChild: Al,
    getSourceDocument: !0
  }), c = Ol({}), l = As({}), d = $s();
  switch (s) {
    case "AllergyIntolerance": {
      const f = n;
      return /* @__PURE__ */ i.jsx(
        ns,
        {
          heading: f.display,
          label: "Allergy",
          resource: f,
          openDetails: o,
          details: [
            { label: "Last Updated", value: f.recordedDate },
            { label: "Reaction", value: f.manifestations }
          ]
        }
      );
    }
    case "Condition": {
      const f = n;
      return /* @__PURE__ */ i.jsx(
        ns,
        {
          heading: f.display,
          label: "Condition",
          resource: f,
          openDetails: a,
          details: [
            {
              label: "Last Updated",
              value: f.recordedDate ? `${f.recordedDate} ${(h = f.recorder) != null ? h : ""}` : "Unknown"
            },
            {
              label: "Earliest Known Onset",
              value: f.onset
            }
          ]
        }
      );
    }
    case "DocumentReference": {
      const f = n;
      return /* @__PURE__ */ i.jsx(
        ns,
        {
          heading: f.title,
          label: "Document",
          resource: f,
          openDetails: c,
          text: r.page_content,
          details: [
            {
              label: "Encounter",
              value: f.encounterDate
            },
            {
              label: "Retrieved",
              value: f.dateCreated
            },
            {
              label: "Author",
              value: f.custodian
            }
          ]
        }
      );
    }
    case "MedicationStatement": {
      const f = n;
      return /* @__PURE__ */ i.jsx(
        ns,
        {
          heading: f.display,
          label: "Medication",
          resource: f,
          openDetails: l,
          details: [
            {
              label: "Dosage",
              value: f.dosage
            },
            {
              label: "Last Filled",
              value: f.lastFillDate
            },
            {
              label: "Last Prescribed",
              value: f.lastPrescribedDate ? `${f.lastPrescribedDate} ${f.lastPrescriber}` : void 0
            }
          ]
        }
      );
    }
    case "DiagnosticReport": {
      const f = n;
      return /* @__PURE__ */ i.jsx(
        ns,
        {
          heading: f.displayName,
          label: "Diagnostic Report",
          resource: f,
          openDetails: d,
          details: [
            {
              label: "Date",
              value: f.effectiveStart
            },
            {
              label: "",
              value: f.details
            }
          ]
        }
      );
    }
    default:
      return null;
  }
}
const iw = {
  id: "",
  query: "",
  response: "",
  results: [],
  total: 0
}, LY = {
  AllergyIntolerance: [],
  Condition: [],
  DocumentReference: [],
  MedicationStatement: [],
  DiagnosticReport: [],
  Observation: []
};
let FY = class {
  constructor(t) {
    ne(this, "response");
    ne(this, "resources", {
      AllergyIntolerance: {},
      Condition: {},
      DocumentReference: {},
      MedicationStatement: {},
      DiagnosticReport: {},
      Observation: {}
    });
    this.response = t;
  }
  get id() {
    return this.response.query_id;
  }
  get results() {
    return this.response.documents.map((t) => {
      const n = this.resources[t.metadata.resource_type][t.metadata.resource_id];
      return {
        upid: t.metadata.upid,
        page_content: t.page_content,
        document: X(R({}, t), {
          resource: n
        })
      };
    });
  }
  get filteredResults() {
    return this.results.filter((t) => {
      var n, r;
      return ["Condition", "MedicationStatement"].includes(t.document.metadata.resource_type) ? ((r = (n = t.document.resource) == null ? void 0 : n.resource.extension) != null ? r : []).some(({ url: a }) => a === e9) : !!t.document.resource;
    });
  }
  get queryString() {
    return this.response.query;
  }
  get responseString() {
    return this.response.response;
  }
  // Get a Map of all resource IDs from the search result by resource type
  get resourceIds() {
    const t = Dn(
      this.response.documents,
      (r) => r.metadata.resource_type
    ), n = R(R({}, LY), t);
    return js(
      n,
      (r) => r.map((s) => s.metadata.resource_id)
    );
  }
  // Set the resource models to their search results
  setResources(t) {
    this.resources.AllergyIntolerance = nr(t.allergies, "id"), this.resources.Condition = nr(t.conditions, "id"), this.resources.DocumentReference = nr(t.documents, "id"), this.resources.MedicationStatement = nr(t.medications, "id"), this.resources.DiagnosticReport = nr(t.diagnosticReports, "id"), this.resources.Observation = nr(t.observations, "id");
  }
};
function BY(e) {
  return Oe(
    P9,
    [e],
    (t, n) => V(this, null, function* () {
      const r = (s, a) => V(this, null, function* () {
        return s.length === 0 ? [] : a(t, n, ht(s));
      });
      if (e) {
        const s = ["keyword"];
        e.split(" ").length > 2 && s.push("semantic");
        const a = JSON.stringify({
          query: e,
          upid: n.UPID,
          include: s,
          n_results: 30,
          resource_types: [
            "AllergyIntolerance",
            "Condition",
            "DocumentReference",
            "MedicationStatement",
            "DiagnosticReport"
            // "Observation",
          ]
        }), { data: o } = yield rt(
          `${Kt(t.env, "search-poc")}/search`,
          {
            body: a,
            method: "POST",
            headers: {
              Authorization: `Bearer ${t.authToken}`,
              "Content-Type": "application/json",
              "Content-Length": a.length.toString(),
              "Zus-Account": t.builderId
            }
          }
        ), c = new FY(
          o
        ), {
          AllergyIntolerance: l,
          Condition: d,
          DocumentReference: u,
          MedicationStatement: h,
          DiagnosticReport: f,
          Observation: p
        } = c.resourceIds, m = yield r(l, F0), C = yield r(d, xl), y = yield r(u, d1), g = yield r(h, f1), w = yield r(p, p1), x = yield r(
          f,
          iV
        );
        return c.setResources({
          allergies: m,
          conditions: C,
          documents: y,
          medications: g,
          observations: w,
          diagnosticReports: x
        }), {
          id: c.id,
          query: c.queryString,
          response: c.responseString,
          results: c.filteredResults.sort(
            (S) => S.document.reason.search_type.includes("semantic") ? 1 : -1
          ),
          total: c.filteredResults.length
        };
      }
      return iw;
    })
  );
}
function UY({ className: e }) {
  const [t, n] = Y(ds), [r, s] = Y(""), [a, o] = Y(""), c = Te(null), l = wt(c), {
    data: d = iw,
    isFetching: u,
    isLoading: h,
    isError: f
  } = BY(a), { trackInteraction: p } = Be(), m = vt(
    (x) => {
      x.preventDefault();
      const S = r.trim();
      o(S), n(ds), p("search", { action: "patient-record-search" });
    },
    [r, p]
  ), C = (x) => {
    s(x.target.value);
  }, y = vt(() => {
    p("clear_search", { action: "patient-record-search" }), s(""), o("");
  }, [p]), g = !!a, w = d.results.length > 0;
  return /* @__PURE__ */ i.jsxs(
    "div",
    {
      className: W(
        e,
        "ctw-patient-record-search ctw-scrollable-pass-through-height ctw-space-x-0 ctw-space-y-2 ctw-text-base"
      ),
      children: [
        /* @__PURE__ */ i.jsxs("form", { className: "ctw-patient-record-search-input ctw-relative", onSubmit: m, children: [
          /* @__PURE__ */ i.jsx("div", { className: "ctw-search-icon-wrapper", children: /* @__PURE__ */ i.jsx(HB, { className: "ctw-search-icon" }) }),
          /* @__PURE__ */ i.jsx(
            "input",
            {
              ref: c,
              type: "text",
              className: "ctw-w-full ctw-overflow-hidden ctw-overflow-ellipsis ctw-whitespace-nowrap ctw-rounded-md ctw-border ctw-border-solid ctw-border-icon-light ctw-bg-bg-white ctw-px-3 ctw-py-2 ctw-pl-10 ctw-pr-8 ctw-text-sm ctw-shadow-sm",
              placeholder: l.xs ? "Search patient records." : "Search patient conditions, medications, diagnostics, documents and allergies.",
              name: "patientRecordSearch",
              value: r,
              onChange: C
            }
          ),
          /* @__PURE__ */ i.jsx(
            "button",
            {
              "aria-label": "clear search",
              type: "button",
              onClick: y,
              className: "ctw-clear-search-icon-wrapper",
              children: /* @__PURE__ */ i.jsx(Mm, { className: "ctw-clear-search-icon" })
            }
          )
        ] }),
        u || h ? /* @__PURE__ */ i.jsx("div", { className: "ctw-mt-3 ctw-flex ctw-justify-center ctw-space-x-1 ctw-align-middle", children: /* @__PURE__ */ i.jsx(Je, {}) }) : /* @__PURE__ */ i.jsx("div", { className: "ctw-patient-record-search-results-list ctw-scrollable-pass-through-height", children: /* @__PURE__ */ i.jsx("div", { className: "ctw-patient-record-search-results ctw-align-left ctw-ml-0", children: /* @__PURE__ */ i.jsxs(MY, { id: d.id, children: [
          /* @__PURE__ */ i.jsx(qs, { condition: f, children: /* @__PURE__ */ i.jsx("div", { className: "ctw-w-full", children: /* @__PURE__ */ i.jsx(Zn, { header: "Error", children: "There was an error running your search." }) }) }),
          /* @__PURE__ */ i.jsx(qs, { condition: g && !w && !f, children: /* @__PURE__ */ i.jsx("span", { className: "ctw-text-1xl ctw-text-content-dark ctw-block ctw-text-left ctw-font-medium", children: "Search did not find results." }) }),
          /* @__PURE__ */ i.jsxs(qs, { condition: g && w, children: [
            /* @__PURE__ */ i.jsxs("span", { className: "ctw-text-1xl ctw-text-content-dark ctw-block ctw-text-left ctw-font-medium", children: [
              "Found ",
              d.results.length,
              " results."
            ] }),
            d.results.slice(0, t).map((x, S) => (
              // eslint-disable-next-line react/no-array-index-key
              /* @__PURE__ */ i.jsx(kY, { document: x.document }, S)
            )),
            /* @__PURE__ */ i.jsx("div", { className: "ctw-mt-5", children: /* @__PURE__ */ i.jsx(x0, { total: d.results.length, count: t, changeCount: n }) })
          ] })
        ] }) }) })
      ]
    }
  );
}
const zY = He(
  (e) => /* @__PURE__ */ i.jsx(ft, { componentName: "PatientRecordSearch", children: /* @__PURE__ */ i.jsx(UY, R({}, e)) }),
  "PatientRecordSearch"
), HY = (e) => [
  {
    title: "Ordered",
    render: (n) => {
      var r;
      return /* @__PURE__ */ i.jsxs("div", { className: "ctw-leading-tight", children: [
        /* @__PURE__ */ i.jsx("span", { children: ((r = n.referredAt) == null ? void 0 : r.toLocaleDateString()) || "Unknown" }),
        n.referringPractitionerName && /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
          /* @__PURE__ */ i.jsx("br", {}),
          /* @__PURE__ */ i.jsxs("span", { className: "ctw-text-xs", children: [
            "by ",
            n.referringPractitionerName
          ] })
        ] })
      ] });
    }
  },
  {
    title: "Referred Provider",
    render: (n) => /* @__PURE__ */ i.jsxs("div", { className: "ctw-leading-tight", children: [
      /* @__PURE__ */ i.jsx("span", { children: n.referredPractitionerName || "Unknown" }),
      n.referredPracticeName && /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
        /* @__PURE__ */ i.jsx("br", {}),
        /* @__PURE__ */ i.jsx("span", { children: n.referredPracticeName })
      ] }),
      n.referredPracticePhoneNumber && /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
        /* @__PURE__ */ i.jsx("br", {}),
        /* @__PURE__ */ i.jsx("span", { children: n.referredPracticePhoneNumber })
      ] }),
      n.referredPractitioners.length > 1 && /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
        /* @__PURE__ */ i.jsx("br", {}),
        /* @__PURE__ */ i.jsxs("span", { className: "text-xs", children: [
          "+ ",
          n.referredPractitioners.length - 1,
          " More"
        ] })
      ] })
    ] })
  },
  {
    title: "Status",
    render: (n) => {
      var r;
      return /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-flex-col ctw-gap-1", children: [
        /* @__PURE__ */ i.jsxs("div", { className: "ctw-w-full ctw-flex ctw-items-center ctw-justify-between", children: [
          /* @__PURE__ */ i.jsx(
            kt,
            {
              color: n.status === "acknowledged" ? "muted" : "primary",
              content: Am(n.status === "acknowledged" ? "closed" : "open")
            }
          ),
          ((r = n.encounter) == null ? void 0 : r.docsAndNotes) && n.encounter.docsAndNotes.length === 0 && /* @__PURE__ */ i.jsx(me, { className: "ctw-w-4 ctw-text-content-lighter", icon: ss })
        ] }),
        ["pending-acknowledgement", "acknowledged"].includes(n.status) && n.completedAt && /* @__PURE__ */ i.jsx("div", { children: n.completedAt.toLocaleDateString() })
      ] });
    }
  },
  {
    title: "Appointment Details",
    render: (n) => /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-flex-col ctw-gap-1", children: [
      n.status === "scheduled" && /* @__PURE__ */ i.jsx("div", { className: "ctw-leading-tight", children: n.scheduledAt && /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
        /* @__PURE__ */ i.jsxs("span", { className: "ctw-whitespace-nowrap", children: [
          "Scheduled ",
          n.scheduledAt.toLocaleDateString()
        ] }),
        n.referredPracticeName && /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
          /* @__PURE__ */ i.jsx("br", {}),
          /* @__PURE__ */ i.jsxs("span", { className: "ctw-text-xs", children: [
            "by ",
            n.referredPracticeName
          ] })
        ] })
      ] }) }),
      ["pending-acknowledgement", "acknowledged"].includes(n.status) && /* @__PURE__ */ i.jsx("div", { className: "ctw-leading-tight", children: n.completedAt && /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
        /* @__PURE__ */ i.jsxs("span", { className: "ctw-whitespace-nowrap", children: [
          "Completed ",
          n.completedAt.toLocaleDateString()
        ] }),
        n.referredPracticeName && /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
          /* @__PURE__ */ i.jsx("br", {}),
          /* @__PURE__ */ i.jsxs("span", { className: "ctw-text-xs", children: [
            "by ",
            n.referredPracticeName
          ] })
        ] })
      ] }) })
    ] })
  }
], WY = ({ className: e }) => {
  ut();
  const t = ew(), n = X1();
  return /* @__PURE__ */ i.jsx(ft, { componentName: "PatientReferrals", children: /* @__PURE__ */ i.jsx(
    "div",
    {
      "data-testid": "referrals-table",
      className: W(e, "ctw-scrollable-pass-through-height"),
      children: /* @__PURE__ */ i.jsx(
        Tt,
        {
          showTableHead: !0,
          isLoading: t.isLoading,
          data: t.data,
          columns: HY(),
          onRowClick: n,
          enableDismissAndReadActions: !0,
          emptyMessage: /* @__PURE__ */ i.jsx(xt, { hasZeroFilteredRecords: !1, resourceName: "referrals" })
        }
      )
    }
  ) });
}, VY = He(WY, "Referrals"), qY = [
  {
    widthPercent: 10,
    minWidth: 128,
    title: "Date",
    render: (e) => /* @__PURE__ */ i.jsx("div", { children: e.createdAtDisplay })
  },
  {
    widthPercent: 30,
    title: "Source",
    render: (e) => /* @__PURE__ */ i.jsx("div", { className: "ctw-capitalize", children: e.organizationDisplayName })
  },
  {
    widthPercent: 30,
    title: "Patient Details",
    render: (e) => /* @__PURE__ */ i.jsxs("div", { className: "ctw-stacked-concat", children: [
      e.displayFull && /* @__PURE__ */ i.jsx("div", { children: e.displayFull }),
      !!(e.dob || e.age !== void 0 || e.gender) && /* @__PURE__ */ i.jsxs("div", { children: [
        /* @__PURE__ */ i.jsxs("span", { children: [
          e.dob,
          " (",
          e.age,
          ")"
        ] }),
        /* @__PURE__ */ i.jsxs("span", { children: [
          " ",
          qe(e.gender)
        ] })
      ] })
    ] })
  },
  {
    widthPercent: 40,
    title: "Contact Info",
    render: (e) => {
      var t, n, r, s;
      return /* @__PURE__ */ i.jsxs("div", { className: "ctw-stacked-concat", children: [
        e.phoneNumber && /* @__PURE__ */ i.jsx("div", { children: e.phoneNumber }),
        e.email && /* @__PURE__ */ i.jsx("div", { children: e.email }),
        ((t = e.homeAddress) == null ? void 0 : t.line) && /* @__PURE__ */ i.jsx("div", { children: e.homeAddress.line.join(" ") }),
        !xe(as("line", e.homeAddress)) && /* @__PURE__ */ i.jsx("div", { children: (n = e.homeAddress) != null && n.city || (r = e.homeAddress) != null && r.state || (s = e.homeAddress) != null && s.postalCode ? `${e.homeAddress.city} ${e.homeAddress.state}, ${e.homeAddress.postalCode}` : void 0 })
      ] });
    }
  }
];
function GY({ className: e }) {
  var c, l;
  const t = Te(null), { patient: n } = Ze(), r = Kg(), s = ((c = r.data) == null ? void 0 : c.length) === 0, a = $c(
    (l = r.data) != null ? l : [],
    (d) => [
      d.createdAtDisplay,
      d.organizationDisplayName,
      d.display,
      d.dob,
      d.age,
      d.gender,
      d.phoneNumber,
      d.email,
      d.homeAddress
    ].join("|")
    // Stringify the array to compare its contents
  ), o = yn(a, "createdAt", "desc");
  return n.data ? /* @__PURE__ */ i.jsx(ft, { componentName: "MatchedPatients", children: /* @__PURE__ */ i.jsx("div", { ref: t, className: W(e, "ctw-scrollable-pass-through-height"), children: /* @__PURE__ */ i.jsx(
    Tt,
    {
      isLoading: r.isLoading,
      data: o,
      emptyMessage: /* @__PURE__ */ i.jsx(xt, { hasZeroFilteredRecords: s, resourceName: "patients" }),
      columns: qY
    }
  ) }) }) : /* @__PURE__ */ i.jsx(Je, {});
}
const YY = He(GY, "MatchedPatients"), QY = [
  {
    title: "Date",
    widthPercent: 10,
    minWidth: 120,
    dataIndex: "date"
  },
  {
    title: "Type",
    render: (e) => /* @__PURE__ */ i.jsxs("div", { children: [
      /* @__PURE__ */ i.jsx("div", { className: "ctw-font-medium", children: e.type }),
      /* @__PURE__ */ i.jsx("div", { children: e.subtype })
    ] })
  },
  {
    title: "Actor",
    render: (e) => /* @__PURE__ */ i.jsx(i.Fragment, { children: e.actorDetails.map((t) => /* @__PURE__ */ i.jsx("div", { className: "ctw-capitalize", children: t.toLocaleLowerCase() }, t)) })
  },
  {
    title: "Modifiers",
    render: (e) => /* @__PURE__ */ i.jsx(
      Gs,
      {
        items: e.modifiers,
        limit: 3,
        total: e.modifiers.length
      }
    )
  }
];
function ZY(e) {
  const t = [];
  return t.push({
    key: "type",
    type: "checkbox",
    icon: lh,
    display: "Type",
    values: Dt(
      EL(
        Mk,
        e.map(
          (n) => n.type ? {
            key: n.type,
            name: n.type
          } : void 0
        )
      )
    )
  }), t;
}
const Zf = {
  type: {
    key: "type",
    selected: ["Diagnostic Report", "Encounter"],
    type: "checkbox"
  }
};
function KY() {
  return _t({
    header: (e) => `${e.periodStart} - ${e.periodEnd}`,
    subHeader: (e) => e.typeDisplay,
    getSourceDocument: !0,
    details: JY
  });
}
const JY = (e) => [
  { label: "Period Start", value: e.periodStart },
  { label: "Period End", value: e.periodEnd },
  { label: "Status", value: fr(e.status) },
  { label: "Class", value: e.classDisplay },
  {
    label: "Type",
    value: e.typeCodings.length ? /* @__PURE__ */ i.jsx(Mo, { codings: e.typeCodings }) : void 0
  },
  { label: "Location", value: e.location },
  { label: "Participants", value: e.practitionersDisplay },
  { label: "Reason", value: e.reason },
  { label: "Diagnosis", value: e.diagnoses.join(", ") },
  { label: "Discharge Disposition", value: e.dischargeDisposition }
], ow = {
  display: "Date (New to Old)",
  sorts: [{ key: "date", dir: "desc", isDate: !0 }]
}, XY = [
  ow,
  {
    display: "Date (Old to New)",
    sorts: [{ key: "date", dir: "asc", isDate: !0 }]
  }
];
class eQ extends Qe {
  constructor(n) {
    super(n);
    ne(this, "kind", "TimelineEvent");
    ne(this, "model");
    switch (n.resourceType) {
      case "Encounter":
        this.model = n;
        break;
      case "DiagnosticReport":
        this.model = n;
        break;
      default:
        throw new Error("This resource is not in type TimelineEvent");
    }
  }
  get date() {
    switch (this.model.kind) {
      case "Encounter":
        return this.model.periodStart;
      case "DiagnosticReport":
        return this.model.effectiveStart;
      default:
        return;
    }
  }
  get type() {
    switch (this.model.kind) {
      case "Encounter":
        return "Encounter";
      case "DiagnosticReport":
        return "Diagnostic Report";
      default:
        return;
    }
  }
  get subtype() {
    switch (this.model.kind) {
      case "Encounter":
        return this.model.typeDisplay;
      case "DiagnosticReport":
        return this.model.category;
      default:
        return;
    }
  }
  get actorDetails() {
    switch (this.model.kind) {
      case "Encounter":
        return Ee([this.model.practitionersDisplay, this.model.location.join(", ")]);
      case "DiagnosticReport":
        return Ee([this.model.performer]);
      default:
        return [];
    }
  }
  get modifiers() {
    switch (this.model.kind) {
      case "Encounter":
        return this.model.diagnoses;
      case "DiagnosticReport":
        return [
          this.model.results.length > 0 ? `${this.model.results.length} results available` : ""
        ];
      default:
        return [];
    }
  }
  get title() {
    return `${this.date} - ${this.type}`;
  }
}
function tQ() {
  const [e, t] = Y(), n = Es(), r = Xa(), s = [n, r];
  he(() => {
    const l = Ee(
      KT(s.map((d) => {
        var u;
        return (u = d.data) == null ? void 0 : u.map((h) => new eQ(h));
      }))
    );
    t(
      Va(l, [
        { dir: "desc", key: "date", isDate: !0 },
        { dir: "desc", key: "type" }
      ])
    );
  }, [n.data, r.data]);
  const a = fn(s, "isLoading"), o = fn(s, "isFetching"), c = fn(s, "isError");
  return {
    isFetching: o,
    isLoading: a,
    isError: c,
    data: e != null ? e : []
  };
}
function nQ({ className: e }) {
  const t = tQ(), n = Te(null), { viewOptions: r, past6Months: s } = _n("date"), { data: a, filters: o, setFilters: c, setSort: l, setViewOption: d, defaultSort: u, defaultView: h } = Rt({
    cacheKey: "patient-timeline",
    viewOptions: r,
    defaultView: s.display,
    defaultFilters: Zf,
    defaultSort: ow,
    records: t.data
  }), p = !(t.data.length === 0) && a.length === 0, m = KY(), C = $s();
  return /* @__PURE__ */ i.jsx(ft, { componentName: "PatientTimeline", children: /* @__PURE__ */ i.jsxs("div", { className: W(e, "ctw-scrollable-pass-through-height"), ref: n, children: [
    /* @__PURE__ */ i.jsx(
      Ht,
      {
        viewOptions: {
          onChange: d,
          options: r,
          defaultView: h
        },
        filterOptions: {
          onChange: c,
          defaultFilters: Zf,
          filters: ZY(t.data),
          selected: o
        },
        sortOptions: {
          defaultSort: u,
          options: XY,
          onChange: l
        }
      }
    ),
    /* @__PURE__ */ i.jsx(
      b0,
      {
        showTableHead: !1,
        isLoading: t.isLoading,
        data: a,
        emptyMessage: /* @__PURE__ */ i.jsx(
          xt,
          {
            hasZeroFilteredRecords: p,
            resourceName: "timeline records"
          }
        ),
        columns: QY,
        onRowClick: (y) => {
          switch (y.model.kind) {
            case "Encounter":
              m(y.model);
              break;
            case "DiagnosticReport":
              C(y.model);
              break;
          }
        }
      }
    )
  ] }) });
}
const rQ = [
  {
    key: "showHidden",
    // Special key for filtering. See utils/filters.ts.
    type: "tag",
    display: "show hospital results",
    icon: Bo,
    toggleDisplay: "hide hospital results",
    toggleIcon: Uo
  }
], cw = {
  display: "Date (New to Old)",
  sorts: [{ key: "dateTime", dir: "desc" }]
}, sQ = [
  cw,
  {
    display: "Date (Old to New)",
    sorts: [{ key: "dateTime", dir: "asc" }]
  }
], { past30days: aQ, past3months: iQ, past6Months: oQ, pastYear: cQ, allTime: lQ } = _n("date"), lw = {
  display: "5 Most Recent",
  filters: [(e) => yn(e, "date", "desc", !0).slice(0, 5)]
}, Kf = [
  lw,
  aQ,
  iQ,
  oQ,
  cQ,
  lQ
], dQ = lw;
function uQ(e = []) {
  const t = [
    { title: "Vital", dataIndex: "date" },
    { title: "Blood Pressure", shortTitle: "BP", dataIndex: "bloodPressure" },
    { title: "Pulse", shortTitle: "HR", dataIndex: "pulse" },
    { title: "Temperature", shortTitle: "Temp", dataIndex: "temperature" },
    { title: "Respiratory Rate", shortTitle: "RR", dataIndex: "respiratoryRate" },
    { title: "Oxygen Saturation", shortTitle: "SpO2", dataIndex: "oxygenSaturation" },
    { title: "Height/Length", shortTitle: "Ht/Lt", dataIndex: "height" },
    { title: "Weight", shortTitle: "Wt", dataIndex: "weight" },
    { title: "BMI", dataIndex: "bmi" }
  ];
  return e.some((n) => n.headCircumference !== void 0) && t.push({ title: "Head Circumference", shortTitle: "HC", dataIndex: "headCircumference" }), e.some((n) => n.lmp !== void 0) && t.push({ title: "LMP", dataIndex: "lmp" }), e.some((n) => n.pain !== void 0) && t.push({ title: "Pain", dataIndex: "pain" }), t.push(
    {
      title: "Source Document",
      shortTitle: "Source Doc",
      render: (n) => /* @__PURE__ */ i.jsx(
        zr,
        {
          binaryId: n.binaryId,
          telemetryTarget: "vital",
          text: "Source Doc",
          showContentTypeIcon: !1
        }
      )
    },
    { title: "Encounter Type", shortTitle: "Enc Type", dataIndex: "typeDisplay" },
    { title: "Location", dataIndex: "location" }
  ), t;
}
const fQ = ({
  className: e,
  rows: t,
  records: n,
  isLoading: r = !1,
  emptyMessage: s = "No records found"
}) => {
  const a = Te(null), o = Te(null), c = wt(a);
  return r ? /* @__PURE__ */ i.jsx(gl, {}) : Object.entries(n).length === 0 ? /* @__PURE__ */ i.jsx("div", { className: "ctw-flex ctw-justify-center", children: s }) : /* @__PURE__ */ i.jsx("div", { className: W("ctw-scrollable-pass-through-height ctw-space-y-4"), children: /* @__PURE__ */ i.jsx(
    "div",
    {
      ref: a,
      className: W("ctw-rotated-table-container ctw-scrollable-pass-through-height", e, {
        "ctw-rotated-table-small": c.md
      }),
      children: /* @__PURE__ */ i.jsx("div", { className: W("ctw-scrollbar ctw-scrollable-content"), ref: o, children: /* @__PURE__ */ i.jsxs("table", { children: [
        /* @__PURE__ */ i.jsxs("colgroup", { children: [
          /* @__PURE__ */ i.jsx("col", {}),
          n.map((l) => /* @__PURE__ */ i.jsx("col", {}, l.key))
        ] }),
        /* @__PURE__ */ i.jsx("tbody", { children: t.map((l) => {
          var d;
          return /* @__PURE__ */ i.jsxs("tr", { children: [
            /* @__PURE__ */ i.jsx("td", { className: "ctw-title-column", children: c.md && (d = l.shortTitle) != null ? d : l.title }),
            n.map((u) => {
              var h;
              if (l.dataIndex) {
                const f = u[l.dataIndex];
                return /* @__PURE__ */ i.jsx("td", { children: /* @__PURE__ */ i.jsx("div", { className: "ctw-flex ctw-items-center ctw-h-full", children: /* @__PURE__ */ i.jsx("div", { title: f, className: "ctw-rotated-table-truncate", children: f }) }) }, u.key);
              }
              return /* @__PURE__ */ i.jsx("td", { children: /* @__PURE__ */ i.jsx("div", { className: "ctw-flex ctw-items-center ctw-h-full", children: /* @__PURE__ */ i.jsx("div", { className: "ctw-rotated-table-truncate", children: (h = l.render) == null ? void 0 : h.call(l, u) }) }) }, u.key);
            })
          ] }, l.title);
        }) })
      ] }) })
    }
  ) });
}, hQ = ({ className: e }) => {
  const t = Hl(), [n, r] = Y([]), { data: s, filters: a, setFilters: o, setSort: c, setViewOption: l, defaultSort: d, defaultView: u } = Rt({
    cacheKey: "patient-vitals",
    viewOptions: Kf,
    defaultSort: cw,
    records: t.data,
    defaultView: dQ.display
  });
  return he(() => {
    t.isLoading || r(uQ(t.data));
  }, [t.data, t.isLoading]), /* @__PURE__ */ i.jsx(ft, { componentName: "PatientVitals", children: /* @__PURE__ */ i.jsxs("div", { className: "ctw-patient-vitals", children: [
    /* @__PURE__ */ i.jsx(
      Ht,
      {
        viewOptions: {
          onChange: l,
          options: Kf,
          defaultView: u
        },
        filterOptions: {
          onChange: o,
          filters: rQ,
          selected: a
        },
        sortOptions: {
          defaultSort: d,
          options: sQ,
          onChange: c
        }
      }
    ),
    /* @__PURE__ */ i.jsx(
      fQ,
      {
        className: e,
        records: s,
        rows: n,
        isLoading: t.isLoading,
        emptyMessage: /* @__PURE__ */ i.jsx(
          xt,
          {
            hasZeroFilteredRecords: t.data ? t.data.length > 0 : !1,
            resourceName: "vitals"
          }
        )
      }
    )
  ] }) });
}, pQ = (e) => [
  {
    widthPercent: 37,
    minWidth: 200,
    title: "Title",
    render: (t) => /* @__PURE__ */ i.jsx(
      Wt,
      {
        title: t.title,
        renderIcon: Lt(t.ownedByBuilder(e))
      }
    )
  },
  {
    widthPercent: 8,
    minWidth: 128,
    title: "Type",
    render: (t) => mQ(t)
  },
  {
    widthPercent: 15,
    minWidth: 128,
    title: "Encounter Date",
    dataIndex: "encounterDate"
  },
  {
    widthPercent: 16,
    minWidth: 128,
    title: "Date Retrieved",
    dataIndex: "dateCreated"
  },
  {
    widthPercent: 24,
    minWidth: 200,
    title: "Author",
    dataIndex: "custodian"
  }
], mQ = (e) => {
  var r, s, a;
  let t, n = "";
  return e.isCDA ? (t = ah, n = "CDA") : e.isImage ? (t = Yw, n = (a = (s = (r = e.contentType) == null ? void 0 : r.split("/")[1]) == null ? void 0 : s.toUpperCase()) != null ? a : "") : e.isPdf && (t = Qw, n = "PDF"), t ? /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-items-center ctw-space-x-2", children: [
    /* @__PURE__ */ i.jsx(
      me,
      {
        className: "ctw-text-content-light ctw-w-[14px] ctw-h-[14px]",
        icon: t,
        title: n
      }
    ),
    /* @__PURE__ */ i.jsx("span", { children: n })
  ] }) : /* @__PURE__ */ i.jsx(i.Fragment, {});
}, dw = [
  {
    display: "Name (A-Z)",
    sorts: [{ key: "title", dir: "asc" }]
  },
  {
    display: "Name (Z-A)",
    sorts: [{ key: "title", dir: "desc" }]
  },
  {
    display: "Date (Old to New)",
    sorts: [
      { key: "contextPeriodStartDate", dir: "asc", isDate: !0 },
      { key: "dateCreated", dir: "asc", isDate: !0 },
      { key: "title", dir: "asc" }
    ]
  },
  {
    display: "Date (New To Old)",
    sorts: [
      { key: "contextPeriodStartDate", dir: "desc", isDate: !0 },
      { key: "dateCreated", dir: "desc", isDate: !0 },
      { key: "title", dir: "asc" }
    ]
  }
], gQ = dw[3];
function wQ({ className: e, onAddToRecord: t }) {
  const n = ut(), r = Te(null), { featureFlags: s } = Xe(), a = Pl(), o = yQ(t), { viewOptions: c, allTime: l } = _n("dateCreated"), { data: d, filters: u, setFilters: h, setSort: f, setViewOption: p, defaultSort: m, defaultView: C } = Rt({
    cacheKey: "patient-documents",
    defaultSort: gQ,
    viewOptions: c,
    defaultView: l.display,
    records: a.data
  }), g = !(a.data.length === 0) && d.length === 0, w = Cs();
  return /* @__PURE__ */ i.jsx(ft, { componentName: "PatientDocuments", children: /* @__PURE__ */ i.jsxs("div", { ref: r, className: W(e, "ctw-scrollable-pass-through-height"), children: [
    /* @__PURE__ */ i.jsx(
      Ht,
      {
        filterOptions: {
          onChange: h,
          filters: MF(),
          selected: u
        },
        sortOptions: {
          defaultSort: m,
          options: dw,
          onChange: f
        },
        viewOptions: {
          onChange: p,
          options: c,
          defaultView: C
        }
      }
    ),
    /* @__PURE__ */ i.jsx(
      Tt,
      {
        isLoading: a.isLoading,
        data: d,
        emptyMessage: /* @__PURE__ */ i.jsx(
          xt,
          {
            hasZeroFilteredRecords: g,
            resourceName: "documents"
          }
        ),
        columns: pQ(n),
        onRightClick: (x) => {
          if (!x.binaryId || !(s != null && s.openCCDAInNewTab))
            return;
          const S = `/ccda/${x.binaryId}`;
          window.open(S, "_blank");
        },
        onRowClick: (x) => {
          x.binaryId && w(x.binaryId, x.resourceTypeTitle);
        },
        rowActions: o,
        enableDismissAndReadActions: !0
      }
    )
  ] }) });
}
const vQ = () => {
  const { t: e } = Kn(), t = Cs();
  return (n) => {
    const r = [];
    return n.binaryId && r.push({
      className: "ctw-btn-primary ctw-fill-white ctw-ml-1 ctw-capitalize",
      testId: "preview-document",
      text: e("resourceTable.preview"),
      render: () => {
        var s;
        return /* @__PURE__ */ i.jsxs("span", { className: "ctw-space-x-1.5", children: [
          /* @__PURE__ */ i.jsx("span", { className: "ctw-relative ctw-inline-block ctw-w-4 ctw-pr-4 ctw-align-middle", children: /* @__PURE__ */ i.jsx(
            cl,
            {
              contentType: (s = n.contentType) != null ? s : "",
              className: "ctw-absolute -ctw-top-2.5 ctw-left-0 ctw-w-4 ctw-h-4"
            }
          ) }),
          /* @__PURE__ */ i.jsx("span", { children: e("resourceTable.preview") })
        ] });
      },
      onClick: () => V(void 0, null, function* () {
        t(n.binaryId, n.resourceTypeTitle);
      })
    }), r;
  };
};
function yQ(e) {
  const { t } = Kn(), n = vQ(), { trackInteraction: r } = Be(), { getRequestContext: s } = Xe(), a = Ol({ rowActions: n });
  return (o) => {
    const { binaryId: c } = o, l = [];
    return l.push({
      className: "ctw-btn-default ctw-ml-1 ctw-capitalize",
      testId: "view-details",
      text: "View Details",
      onClick: () => {
        a(o);
      }
    }), c && e && l.push({
      className: "ctw-btn-primary ctw-ml-1 ctw-capitalize",
      testId: "add-to-record",
      text: t("resourceTable.add"),
      onClick: () => V(this, null, function* () {
        const { binary: d } = yield dl(yield s(), c);
        e(o, d), r("add_to_record");
      })
    }), l;
  };
}
const xQ = He(wQ, "PatientDocuments"), bQ = (e) => [
  {
    title: "Immunization",
    widthPercent: 60,
    minWidth: 320,
    render: (n) => /* @__PURE__ */ i.jsx(
      Wt,
      {
        title: n.description,
        renderIcon: Lt(n.ownedByBuilder(e))
      }
    )
  },
  {
    title: "Date Given",
    dataIndex: "occurrence"
  }
];
function jQ() {
  return [qn];
}
const uw = {
  display: "Name (A-Z)",
  sorts: [
    { key: "description", dir: "asc" },
    { key: "occurrence", dir: "desc", isDate: !0 }
  ]
}, CQ = [
  uw,
  {
    display: "Name (Z-A)",
    sorts: [
      { key: "description", dir: "desc" },
      { key: "occurrence", dir: "desc", isDate: !0 }
    ]
  },
  {
    display: "Date (New to Old)",
    sorts: [{ key: "occurrence", dir: "desc", isDate: !0 }]
  },
  {
    display: "Date (Old to New)",
    sorts: [{ key: "occurrence", dir: "asc", isDate: !0 }]
  }
], NQ = (e) => e != null && e.value ? `${e.value} ${e.unit}` : "";
class DQ extends Qe {
  constructor() {
    super(...arguments);
    ne(this, "kind", "Immunization");
  }
  get description() {
    return this.resource.vaccineCode.text;
  }
  get cvxCode() {
    const n = tn(ZL, this.resource.vaccineCode);
    return n == null ? void 0 : n.code;
  }
  // String used to define a unique instance of an immunization administered for a patient.
  get uniqueKey() {
    return `${this.cvxCode || this.description} - ${this.occurrence}`;
  }
  get doseQuantity() {
    return NQ(this.resource.doseQuantity);
  }
  get route() {
    return Ie(this.resource.route);
  }
  get site() {
    return Ie(this.resource.site);
  }
  get status() {
    return qe(this.resource.status);
  }
  get notesDisplay() {
    var n;
    return ((n = this.resource.note) == null ? void 0 : n.map(({ text: r }) => r)) || [];
  }
  get occurrence() {
    return this.resource.occurrenceDateTime ? ye(this.resource.occurrenceDateTime) : this.resource.occurrenceString;
  }
  get managingOrganization() {
    var s, a;
    const n = Pe(
      "Patient",
      this.resource.contained,
      this.includedResources,
      this.resource.patient
    ), r = (s = Pe(
      "Organization",
      this.resource.contained,
      this.includedResources,
      n == null ? void 0 : n.managingOrganization
    )) == null ? void 0 : s.name;
    return ((a = n == null ? void 0 : n.managingOrganization) == null ? void 0 : a.display) || r;
  }
  get title() {
    var n;
    return (n = this.description) != null ? n : "Unknown Immunization";
  }
}
const SQ = Ae`
  ${Xt}
  ${Yn}
  ${Fr}
  ${Gn}
  query Immunizations($upid: ID!, $cursor: String!, $sort: ImmunizationSortParams!, $first: Int!) {
    ImmunizationConnection(upid: $upid, after: $cursor, sort: $sort, first: $first) {
      pageInfo {
        hasNextPage
      }
      edges {
        node {
          id
          resourceType
          BasicList(_reference: "subject") {
            ...Basic
          }
          meta {
            tag {
              system
              code
            }
            versionId
          }
          extension {
            url
            valueString
          }
          status
          statusReason {
            text
            coding {
              ...Coding
            }
          }
          vaccineCode {
            text
            coding {
              ...Coding
            }
          }
          patient {
            reference
            resource {
              ... on Patient {
                ...Patient
                managingOrganization {
                  resource {
                    ... on Organization {
                      name
                    }
                  }
                }
              }
            }
          }
          occurrenceDateTime
          occurrenceString
          recorded
          lotNumber
          expirationDate
        }
      }
    }
  }
`;
function Wl(e = !0) {
  return Oe(
    nF,
    [],
    $Q,
    e
  );
}
function $Q(e, t) {
  return V(this, null, function* () {
    const n = Re(e), { data: r } = yield dt(n, SQ, {
      upid: t.UPID,
      cursor: "",
      first: 1e3,
      sort: {
        lastUpdated: "DESC"
      },
      filter: {
        tag: { nonematch: [yt] }
      }
    }), s = r.ImmunizationConnection.edges.map((o) => o.node);
    return AQ(s, e.builderId);
  });
}
const AQ = (e, t) => {
  const n = e.map(
    (a) => new DQ(a, void 0, a.BasicList)
  ), r = yn(
    n.filter((a) => a.status === "Completed"),
    "occurrence",
    "desc",
    !0
  ), s = nt(r, (a) => a.ownedByBuilder(t), "desc");
  return $c(s, "uniqueKey");
};
function EQ({ className: e }) {
  var h;
  const t = ut(), n = Wl(), { data: r, filters: s, setFilters: a, setSort: o, defaultSort: c } = Rt({
    cacheKey: "patient-immunizations",
    defaultSort: uw,
    records: n.data
  }), d = !(((h = n.data) == null ? void 0 : h.length) === 0) && r.length === 0, u = _t({
    header: (f) => f.description,
    details: _Q,
    getSourceDocument: !0,
    enableDismissAndReadActions: !0
  });
  return /* @__PURE__ */ i.jsx(ft, { componentName: "PatientImmunizations", children: /* @__PURE__ */ i.jsxs("div", { className: W(e, "ctw-scrollable-pass-through-height"), children: [
    /* @__PURE__ */ i.jsx(
      Ht,
      {
        filterOptions: {
          onChange: a,
          filters: jQ(),
          selected: s
        },
        sortOptions: {
          defaultSort: c,
          options: CQ,
          onChange: o
        }
      }
    ),
    /* @__PURE__ */ i.jsx(
      Tt,
      {
        showTableHead: !0,
        isLoading: n.isLoading,
        data: r,
        columns: bQ(t),
        onRowClick: u,
        enableDismissAndReadActions: !0,
        emptyMessage: /* @__PURE__ */ i.jsx(
          xt,
          {
            hasZeroFilteredRecords: d,
            resourceName: "immunizations"
          }
        )
      }
    )
  ] }) });
}
const IQ = He(
  EQ,
  "PatientImmunizations"
), _Q = (e) => [
  { label: "Date Given", value: e.occurrence },
  { label: "Recorded By", value: e.managingOrganization },
  { label: "Status", value: e.status },
  { label: "Dose Quantity", value: e.doseQuantity },
  { label: "Route", value: e.route },
  { label: "Site", value: e.site },
  { label: "Lot Number", value: e.resource.lotNumber },
  ...h1("Note", e.notesDisplay)
], TQ = {
  overview: (e) => ({
    key: "overview",
    display: () => /* @__PURE__ */ i.jsx(pt, { name: "overview" }),
    render: () => /* @__PURE__ */ i.jsx(IY, R({}, e))
  }),
  search: (e) => ({
    key: "search",
    display: () => /* @__PURE__ */ i.jsx(pt, { name: "search", beta: !0 }),
    render: () => /* @__PURE__ */ i.jsx(zY, R({ className: "ctw-pt-2" }, e))
  }),
  "conditions-all": (e = {}) => ({
    key: "conditions-all",
    display: () => /* @__PURE__ */ i.jsx(pt, { resource: "conditions-all", name: st.t("zap.tabs.conditionsAll") }),
    render: () => /* @__PURE__ */ i.jsx(UW, R({}, e))
  }),
  medications: (e = {}) => ({
    key: "medications",
    display: () => "medication list",
    render: () => /* @__PURE__ */ i.jsx(aG, R({}, e))
  }),
  "medications-outside": (e = {}) => ({
    key: "medications-outside",
    display: () => /* @__PURE__ */ i.jsx(pt, { name: st.t("zap.tabs.medicationsOutside") }),
    render: () => /* @__PURE__ */ i.jsx(gG, R({}, e))
  }),
  "medications-all": (e = {}) => ({
    key: "medications-all",
    display: () => /* @__PURE__ */ i.jsx(pt, { resource: "medications-all", name: "Medications" }),
    render: () => /* @__PURE__ */ i.jsx(pG, R({}, e))
  }),
  "diagnostic-reports": (e = {}) => ({
    key: "diagnostic-reports",
    display: () => /* @__PURE__ */ i.jsx(pt, { resource: "diagnostic-reports", name: "diagnostics" }),
    render: () => /* @__PURE__ */ i.jsx(cV, R({}, e))
  }),
  timeline: (e = {}) => ({
    key: "timeline",
    display: () => /* @__PURE__ */ i.jsx(pt, { resource: "timeline", name: "timeline" }),
    render: () => /* @__PURE__ */ i.jsx(nQ, R({}, e))
  }),
  encounters: (e = {}) => ({
    key: "encounters",
    display: () => /* @__PURE__ */ i.jsx(pt, { resource: "encounters", name: "Encounters & Notes" }),
    render: () => /* @__PURE__ */ i.jsx(Qq, R({}, e))
  }),
  referrals: (e = {}) => ({
    key: "referrals",
    display: () => /* @__PURE__ */ i.jsx(pt, { resource: "referrals", name: "referrals", beta: !0 }),
    render: () => /* @__PURE__ */ i.jsx(VY, R({}, e))
  }),
  documents: (e = {}) => ({
    key: "documents",
    display: () => /* @__PURE__ */ i.jsx(pt, { resource: "documents", name: "documents", beta: !0 }),
    render: () => /* @__PURE__ */ i.jsx(xQ, R({}, e))
  }),
  allergies: (e = {}) => ({
    key: "allergies",
    display: () => /* @__PURE__ */ i.jsx(pt, { resource: "allergies", name: "allergies" }),
    render: () => /* @__PURE__ */ i.jsx(eW, R({}, e))
  }),
  immunizations: (e = {}) => ({
    key: "immunizations",
    display: () => /* @__PURE__ */ i.jsx(pt, { resource: "immunizations", name: "immunizations" }),
    render: () => /* @__PURE__ */ i.jsx(IQ, R({}, e))
  }),
  "care-team": (e = {}) => ({
    key: "care-team",
    display: () => /* @__PURE__ */ i.jsx(pt, { resource: "care-team", name: "care team", beta: !0 }),
    render: () => /* @__PURE__ */ i.jsx(lW, R({}, e))
  }),
  "contact-information": (e = {}) => ({
    key: "contact-information",
    display: () => /* @__PURE__ */ i.jsx(pt, { resource: "contact-information", name: "contact information", beta: !0 }),
    render: () => /* @__PURE__ */ i.jsx(RY, R({}, e))
  }),
  sources: (e = {}) => ({
    key: "sources",
    display: () => /* @__PURE__ */ i.jsx(pt, { resource: "sources", name: "sources" }),
    render: () => /* @__PURE__ */ i.jsx(YY, R({}, e))
  }),
  vitals: (e = {}) => ({
    key: "vitals",
    display: () => /* @__PURE__ */ i.jsx(pt, { resource: "vitals", name: "vitals" }),
    render: () => /* @__PURE__ */ i.jsx(hQ, R({}, e))
  }),
  "chart-review": () => ({
    key: "chart-review",
    display: () => /* @__PURE__ */ i.jsx(pt, { name: "Chart Review (Generated)", prototype: !0 }),
    render: () => /* @__PURE__ */ i.jsx(Cq, {})
  })
};
function pt({ beta: e, prototype: t, name: n, resource: r }) {
  return /* @__PURE__ */ i.jsx("div", { className: "ctw-flex ctw-items-center ctw-space-x-3 ctw-pr-3", children: /* @__PURE__ */ i.jsx("div", { className: "ctw-flex ctw-items-center ctw-space-x-1 ctw-text-black", children: r ? /* @__PURE__ */ i.jsx(
    Iq,
    {
      text: n,
      resource: r,
      isBeta: e,
      isPrototype: t
    }
  ) : /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
    /* @__PURE__ */ i.jsx("span", { className: "ctw-capitalize ", children: n }),
    e && !t && /* @__PURE__ */ i.jsx(Ml, {}),
    !e && t && /* @__PURE__ */ i.jsx(v1, {})
  ] }) }) });
}
function RQ({ className: e, children: t }) {
  return /* @__PURE__ */ i.jsx("div", { className: W("ctw-container", e), children: t });
}
function fw(r) {
  var s = r, { className: e, children: t } = s, n = ct(s, ["className", "children"]);
  const a = Te(null), o = wt(a), c = W(e, {
    "ctw-stacked": o.sm
  });
  return /* @__PURE__ */ i.jsx("div", X(R({ className: c, ref: a }, n), { children: t }));
}
function hw({ className: e, title: t, children: n }) {
  return /* @__PURE__ */ i.jsxs("div", { className: W("ctw-heading-container", e), children: [
    t && /* @__PURE__ */ i.jsx("div", { className: "ctw-title", children: t }),
    n
  ] });
}
function Vl({ className: e, title: t, children: n }) {
  return /* @__PURE__ */ i.jsxs("div", { className: W("ctw-title-container", e), children: [
    t && /* @__PURE__ */ i.jsx("div", { className: "ctw-title", children: t }),
    n
  ] });
}
function MQ({ className: e, title: t, titleChildren: n, children: r }) {
  const s = !!(t || n);
  return /* @__PURE__ */ i.jsx("div", { className: W("ctw-body-container", e), children: /* @__PURE__ */ i.jsxs("div", { className: "ctw-space-y-3", children: [
    s && /* @__PURE__ */ i.jsx(Vl, { title: t, children: n }),
    r
  ] }) });
}
const uK = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Body: MQ,
  Heading: hw,
  StackedWrapper: fw,
  Title: Vl,
  Wrapper: RQ
}, Symbol.toStringTag, { value: "Module" })), PQ = [
  "allergies",
  "care-team",
  "chart-review",
  "conditions-all",
  "diagnostic-reports",
  "documents",
  "encounters",
  "referrals",
  "immunizations",
  "medications",
  "medications-outside",
  "medications-all",
  "search",
  "timeline",
  "overview",
  "contact-information",
  "sources",
  "vitals"
], si = [
  "overview",
  "search",
  "conditions-all",
  "medications-all",
  "diagnostic-reports",
  "vitals",
  "encounters",
  "referrals",
  "documents",
  "allergies",
  "immunizations",
  "care-team",
  "contact-information",
  "sources",
  "chart-review"
], OQ = ({
  forceHorizontalTabs: e = !1,
  allergiesProps: t,
  careTeamProps: n,
  conditionsAllProps: r,
  diagnosticReportsProps: s,
  documentsProps: a,
  immunizationsProps: o,
  referralsProps: c,
  medicationsProps: l,
  medicationsOutsideProps: d,
  medicationsAllProps: u,
  timelineProps: h,
  chartReviewProps: f,
  encounterProps: p,
  searchProps: m,
  contactInformationProps: C,
  sourcesProps: y,
  vitalsProps: g,
  resources: w = si,
  hideTitle: x = !1,
  title: S = "Outside Records",
  removeBranding: N = !1,
  removeRequestRecords: v = !1
}) => {
  const b = Gt("ctw-referrals"), j = Gt("ctw-contact-information"), D = Gt("ctw-patient-record-search"), $ = Gt("ctw-hpi"), _ = Gt("ctw-patient-history-form"), { tabOrder: L, setTabOrder: I } = tt(Jn), { setProps: A } = tt(zl), { patient: M } = Ze(), G = ke(
    () => ({
      allergies: t,
      "care-team": n,
      "conditions-all": r,
      "diagnostic-reports": s,
      documents: a,
      encounters: p,
      "chart-review": f,
      immunizations: o,
      referrals: c,
      medications: l,
      "medications-outside": d,
      "medications-all": u,
      timeline: h,
      overview: void 0,
      search: m,
      "contact-information": C,
      sources: y,
      vitals: g
    }),
    [
      t,
      n,
      f,
      r,
      s,
      a,
      p,
      o,
      c,
      l,
      d,
      u,
      h,
      m,
      C,
      y,
      g
    ]
  );
  he(() => {
    A(G);
    const P = w.filter(
      (E) => (E !== "referrals" || b) && (E !== "contact-information" || j) && (E !== "search" || D) && (E !== "chart-review" || $)
    );
    I(P);
  }, [
    w,
    I,
    A,
    G,
    b,
    j,
    D,
    $
  ]);
  const Z = ke(
    () => _ && !v,
    [_, v]
  ), Q = ke(
    () => (
      // Return tab content filtered down to our set of enabled tabs via tabOrder.
      // This also ensures it is in the same order as tabOrder which ensures that
      // setSelectedTab by name works correctly (tabs and content line up!).
      TR(L, w).map((P) => {
        var z;
        const E = (z = G[P]) != null ? z : {};
        return E.hideRequestRecords = !Z, TQ[P](E);
      })
    ),
    [L, w, G, Z]
  );
  if (M.isLoading)
    return /* @__PURE__ */ i.jsx(Je, { message: "Loading patient. This may take a minute if patient is being synced from EHR for the first time." });
  const T = M.error && typeof M.error == "object" && "statusCode" in M.error && M.error.statusCode === 401;
  return M.error && typeof M.error == "object" && "status" in M.error && M.error.status === 401 || T ? /* @__PURE__ */ i.jsx(
    Nn,
    {
      icon: /* @__PURE__ */ i.jsx(xV, { className: "ctw-h-16" }),
      title: "Not authorized",
      message: "Your account does not have access to this feature."
    }
  ) : !M.data || M.error ? /* @__PURE__ */ i.jsx(
    Nn,
    {
      icon: /* @__PURE__ */ i.jsx(cs, { className: "ctw-h-16 ctw-text-content-light" }),
      title: "Patient not found",
      message: "Try reloading the ZAP."
    }
  ) : M.data.active === !1 ? /* @__PURE__ */ i.jsx(
    Nn,
    {
      icon: /* @__PURE__ */ i.jsx(cs, { className: "ctw-h-16" }),
      title: "Inactive patient",
      message: "Follow your organization's guidelines to activate this patient in Zus."
    }
  ) : /* @__PURE__ */ i.jsx(ft, { componentName: "ZusAggregatedProfile", children: /* @__PURE__ */ i.jsxs("div", { className: "ctw-space-y-2", children: [
    /* @__PURE__ */ i.jsx(vV, { featureFlag: "ctw-zap-alert" }),
    /* @__PURE__ */ i.jsxs("div", { className: "ctw-zus-aggregated-profile ctw-scrollable-pass-through-height ctw-space-y-4", children: [
      /* @__PURE__ */ i.jsx(gq, { content: Q, forceHorizontalTabs: e }),
      !x && /* @__PURE__ */ i.jsx(
        Vl,
        {
          className: W(
            "ctw-border-b-0 ctw-border-l-0 ctw-border-r-0 ctw-border-t-2 ctw-border-solid ctw-border-divider-light ctw-bg-zap-headerBg ctw-px-4"
          ),
          children: /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-items-center ctw-space-x-1 ctw-py-3", children: [
            /* @__PURE__ */ i.jsx("h3", { className: "ctw-m-0 ctw-inline-block ctw-p-0  ctw-font-medium", children: S }),
            !N && /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-items-center ctw-space-x-2", children: [
              /* @__PURE__ */ i.jsx("span", { className: "ctw-text-sm ctw-font-light ctw-italic ctw-text-content-light", children: "Powered by" }),
              /* @__PURE__ */ i.jsx("img", { src: bV, alt: "Zus" })
            ] })
          ] })
        }
      )
    ] })
  ] }) });
}, kQ = He(
  OQ,
  "ZusAggregatedProfile"
), mr = 20, fK = ({
  className: e,
  resources: t = si,
  text: n
}) => [...pw(t).values()].some((a) => a) ? /* @__PURE__ */ i.jsx(Za, { className: e, text: n }) : null;
function hK(e = si) {
  return Ze(), [...pw(e).values()].reduce(
    (n, r) => r ? n + 1 : n,
    0
  );
}
function pw(e = si) {
  Ze();
  const t = ut(), n = $l(e.includes("allergies")), r = Qa(e.includes("conditions-all")), s = Xa(
    mr,
    void 0,
    e.includes("diagnostic-reports")
  ), a = Pl(
    mr,
    e.includes("documents")
  ), o = Es(
    mr,
    e.includes("encounters")
  ), c = Wl(e.includes("immunizations")), l = Xn(e.includes("medications")), d = /* @__PURE__ */ new Map();
  return PQ.forEach((u) => {
    d.set(u, !1);
  }), e.forEach((u) => {
    let h;
    if (u === "conditions-all") {
      r.data.some(
        (f) => !f.isDismissed && !f.isRead && !f.syncedWithRecord
      ) && d.set(u, !0);
      return;
    }
    switch (u) {
      case "allergies":
        h = n.data;
        break;
      case "diagnostic-reports":
        h = s.data;
        break;
      case "documents":
        h = a.data;
        break;
      case "encounters":
        h = o.data;
        break;
      case "immunizations":
        h = c.data;
        break;
      case "medications-all":
        h = l.allMedications;
        break;
      default:
        h = [];
    }
    h != null && h.some(
      (f) => !f.isDismissed && !f.isRead && !f.ownedByBuilder(t)
    ) && d.set(u, !0);
  }), d;
}
const pK = ({
  className: e
}) => {
  const t = Xa(mr);
  return /* @__PURE__ */ i.jsx(Wr, { className: e, data: t.data });
}, mK = ({ className: e }) => {
  const t = Pl(mr);
  return /* @__PURE__ */ i.jsx(Wr, { className: e, data: t.data });
}, gK = ({ className: e }) => {
  const t = Es(mr);
  return /* @__PURE__ */ i.jsx(Wr, { className: e, data: t.data });
}, wK = ({
  className: e
}) => {
  const t = Wl();
  return /* @__PURE__ */ i.jsx(Wr, { className: e, data: t.data });
}, LQ = () => [
  {
    title: "TimeStamp",
    render: (t) => t.alertTimeStamp
  },
  {
    title: "Medication",
    render: (t) => t.medicationDisplayName
  },
  {
    title: "Performer Details",
    render: (t) => t.performerDetails.name
  },
  {
    title: "Last Known Fill",
    render: (t) => t.whenHandedOver ? t.whenHandedOver : t.whenPrepared
  }
], FQ = (e) => e.map((t) => new da(t)).filter((t) => t.PMARefillNotPickedUp === "PMARefillNotPickedUp");
function BQ() {
  return Oe(
    rF,
    [],
    UQ
  );
}
function UQ(e, t) {
  return V(this, null, function* () {
    const n = Re(e), { data: r } = yield dt(
      n,
      u1,
      {
        upid: t.UPID,
        cursor: "",
        first: 1e3,
        sort: {
          lastUpdated: "DESC"
        },
        filter: {}
      }
    ), s = r.MedicationDispenseConnection.edges.map((a) => a.node);
    return FQ(s);
  });
}
function zQ({ className: e }) {
  var r, s;
  const t = BQ(), n = ((r = t.data) == null ? void 0 : r.length) === 0;
  return /* @__PURE__ */ i.jsx("div", { className: W(e, "ctw-scrollable-pass-through-height"), children: /* @__PURE__ */ i.jsx(
    Tt,
    {
      showTableHead: !0,
      isLoading: t.isLoading,
      data: (s = t.data) != null ? s : [],
      columns: LQ(),
      emptyMessage: /* @__PURE__ */ i.jsx(
        xt,
        {
          hasZeroFilteredRecords: n,
          resourceName: "medicationdispense"
        }
      )
    }
  ) });
}
const vK = He(
  zQ,
  "PatientMedicationDispense"
), yK = () => {
  const { otherProviderMedications: e = [] } = Xn();
  return e.filter(
    (n) => !(n.isDismissed || n.isInactive)
  ).length > 0 ? /* @__PURE__ */ i.jsx(Za, {}) : null;
}, xK = (e) => /* @__PURE__ */ i.jsx(
  kQ,
  X(R({
    hideTitle: !0,
    resources: ["medications", "medications-outside"]
  }, e), {
    medicationsProps: e,
    medicationsOutsideProps: e
  })
), bK = ({
  className: e
}) => {
  const t = Xn();
  return /* @__PURE__ */ i.jsx(Wr, { className: e, data: t.allMedications });
};
const HQ = [
  "queued",
  "scheduled",
  "in_progress",
  "done",
  "error"
];
function WQ() {
  const e = [];
  return e.push(
    {
      key: "status",
      type: "select",
      icon: Zw,
      values: HQ.map((t) => ({
        key: t,
        name: t.replaceAll("_", " ")
      })),
      display: "status"
    },
    {
      key: "future_jobs",
      type: "tag",
      icon: Kw,
      display: "Exclude Future Jobs"
    }
  ), e;
}
const Jf = {
  future_jobs: {
    key: "future_jobs",
    selected: !0,
    type: "tag"
  }
};
function VQ(e, t, n, r) {
  return Jt(
    tF,
    [e, t, n, r],
    (s) => V(this, null, function* () {
      try {
        const a = yield M0({
          requestContext: s,
          count: e,
          offset: t,
          status: n,
          excludeFutureJobs: r
        }), o = ht(
          Ee(a.data.map((u) => u.relationships.patient.data.id))
        );
        if (!o.length)
          return { total: 0, patients: [] };
        const l = (yield br(Un(s), "Patient", {
          _id: o.join(",")
        })).reduce(
          (u, h) => (h.id && (u[h.id] = new zt(h)), u),
          {}
        ), d = a.data.map(
          (u) => new Dl(l[u.relationships.patient.data.id], u)
        );
        return {
          hasNext: !!a.links.next,
          total: a.data.length,
          patients: d
        };
      } catch (a) {
        throw $e.logError(a, "Failed fetching patient history patients."), new Error(`Failed fetching patient history patients: ${a}`);
      }
    })
  );
}
const mw = ({
  setCurrentPage: e,
  currentPage: t,
  hasNext: n
}) => n || t > 1 ? /* @__PURE__ */ i.jsxs("div", { className: "ctw-simple-pagination ctw-flex ctw-justify-end ctw-space-x-3 ctw-px-6 ctw-py-3", children: [
  /* @__PURE__ */ i.jsx(
    Xf,
    {
      pageToNavigateTo: t - 1,
      setCurrentPage: e,
      className: W({ "ctw-invisible": t === 1 }),
      children: "Prev"
    }
  ),
  /* @__PURE__ */ i.jsx(
    Xf,
    {
      pageToNavigateTo: t + 1,
      setCurrentPage: e,
      className: W({ "ctw-invisible": !n }),
      children: "Next"
    }
  )
] }) : /* @__PURE__ */ i.jsx(i.Fragment, {}), Xf = ({
  pageToNavigateTo: e,
  setCurrentPage: t,
  children: n,
  className: r
}) => {
  const { trackInteraction: s } = Be();
  return /* @__PURE__ */ i.jsx(
    "button",
    {
      type: "button",
      className: W("ctw-btn-default", r),
      onClick: () => {
        t(e), s("change_page", {
          page: e
        });
      },
      children: n
    }
  );
}, jK = He(
  ({
    className: e,
    handleRowClick: t,
    pageSize: n = 10,
    title: r = "Patient History Request",
    includeBorder: s = !0
  }) => {
    const [a, o] = Y(1), [c, l] = Y([]), [d, u] = Y(), [h, f] = Y(!0), [p, m] = Y(
      Jf
    ), {
      data: { patients: C, total: y, hasNext: g } = {},
      isLoading: w,
      isFetching: x,
      isError: S
    } = VQ(n, a - 1, d, h), N = (v) => {
      var b, j;
      f(!!((b = v.future_jobs) != null && b.selected)), (j = v.status) != null && j.selected && typeof v.status.selected == "string" ? u(v.status.selected.split(" ").join("_")) : u(void 0), m(v);
    };
    return he(() => {
      !x && C && l(C.filter((v) => v.patient));
    }, [C, y, S, x]), he(() => {
      S && l([]);
    }, [S, x]), /* @__PURE__ */ i.jsx(ft, { componentName: "PatientHistoryTable", children: /* @__PURE__ */ i.jsxs(
      fw,
      {
        className: W(
          "ctw-patients-table-inputs",
          { "ctw-patients-border": s },
          e
        ),
        children: [
          r && /* @__PURE__ */ i.jsx(hw, { title: r }),
          /* @__PURE__ */ i.jsx(
            Ht,
            {
              filterOptions: {
                onChange: N,
                filters: WQ(),
                defaultFilters: Jf,
                selected: p
              },
              className: "ctw-ml-2"
            }
          ),
          /* @__PURE__ */ i.jsx("div", { className: "ctw-overflow-hidden", children: /* @__PURE__ */ i.jsx(
            wl,
            {
              records: c,
              columns: qQ,
              pageSize: n,
              handleRowClick: t,
              isLoading: w,
              hidePagination: !0,
              children: /* @__PURE__ */ i.jsx(
                mw,
                {
                  currentPage: a,
                  setCurrentPage: o,
                  hasNext: g
                }
              )
            }
          ) })
        ]
      }
    ) });
  },
  "PatientsHistoryTable"
), qQ = [
  {
    title: "Last Queried",
    render: (e) => /* @__PURE__ */ i.jsx("div", { children: e.lastUpdatedAt }),
    width: "140px"
  },
  {
    title: "Target Date",
    render: (e) => /* @__PURE__ */ i.jsx("div", { children: e.targetDate }),
    width: "125px"
  },
  {
    title: "Name",
    render: (e) => /* @__PURE__ */ i.jsx(YQ, { data: e })
  },
  {
    title: "Source",
    render: (e) => /* @__PURE__ */ i.jsx("div", { className: "ctw-space-y-2", children: e.providers.map(({ service: t }) => /* @__PURE__ */ i.jsx("div", { children: /* @__PURE__ */ i.jsx("div", { className: "ctw-w-fit  ctw-py-1	ctw-capitalize", children: GQ(t) }) }, `${e.historyInfo.id}-${t}`)) })
  },
  {
    title: "Status",
    render: (e) => /* @__PURE__ */ i.jsx("div", { className: "ctw-space-y-2", children: e.providers.map(({ service: t, status: n }) => /* @__PURE__ */ i.jsx("div", { children: /* @__PURE__ */ i.jsx("div", { className: "ctw-capitalize", children: /* @__PURE__ */ i.jsx(QQ, { status: n }) }) }, `${e.historyInfo.id}-${t}`)) }),
    width: "125px"
  }
];
function GQ(e) {
  switch (e) {
    case "commonwell":
      return "EHR Network - CommonWell";
    case "carequality":
      return "EHR Network - Carequality";
    case "surescripts":
      return "Medication History - Surescripts";
    default:
      return e;
  }
}
const YQ = ({ data: e }) => {
  var t;
  return /* @__PURE__ */ i.jsx("div", { className: "ctw-flex ctw-items-center", children: /* @__PURE__ */ i.jsxs("div", { children: [
    /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-space-x-1 ctw-font-medium", children: [
      /* @__PURE__ */ i.jsx("div", { className: "ctw-max-w-xs", children: e.patient.fullName }),
      ((t = e.patient.resource.gender) == null ? void 0 : t[0]) && /* @__PURE__ */ i.jsxs("div", { className: "ctw-uppercase", children: [
        "(",
        e.patient.resource.gender[0],
        ")"
      ] })
    ] }),
    /* @__PURE__ */ i.jsxs("div", { className: "ctw-text-content-lighter", children: [
      e.patient.dob,
      " (",
      e.patient.age,
      ")"
    ] })
  ] }) });
}, QQ = ({ status: e }) => {
  switch (e) {
    case "initialize":
    case "in_progress":
    case "unset":
      return /* @__PURE__ */ i.jsx(rs, { status: "In progress", className: "ctw-bg-bg-light ctw-text-content-light" });
    case "done":
      return /* @__PURE__ */ i.jsx(rs, { status: "Complete", className: "ctw-bg-success-light ctw-text-success-dark" });
    case "error":
    case "done_with_info":
      return /* @__PURE__ */ i.jsx(rs, { status: "Failed", className: "ctw-bg-error-light ctw-text-error-text" });
    case "skipped":
      return /* @__PURE__ */ i.jsx(rs, { status: "Skipped", className: "ctw-bg-caution-light ctw-text-caution-text" });
    default:
      return /* @__PURE__ */ i.jsx(rs, { status: e });
  }
}, rs = ({ status: e, className: t }) => /* @__PURE__ */ i.jsx("div", { className: W("ctw-w-fit ctw-rounded-2xl ctw-px-3 ctw-py-1 ctw-font-medium", t), children: e.split("_").join(" ") });
function ZQ(e) {
  return Jt(
    Q9,
    [e],
    aB,
    !!e
  );
}
const CK = He(({ onSearchClick: e }) => {
  const [t, n] = Y([]), [r, s] = Y(), { data: a, isFetching: o, isError: c } = ZQ(r);
  he(() => {
    a && n(a);
  }, [a, c, o]), he(() => {
    c && n([]);
  }, [c, o]);
  const l = nt(t, "lastName", "asc").map((d) => ({
    value: d,
    label: d.fullName,
    key: d.id
  }));
  return /* @__PURE__ */ i.jsx(
    _l,
    {
      enableSearchIcon: !0,
      options: l,
      readonly: !1,
      isLoading: o,
      name: "patient-search",
      onCustomSelectChange: e,
      renderCustomOption: (d) => /* @__PURE__ */ i.jsx(KQ, { option: d }),
      onSearchChange: (d) => {
        s(d), d !== r && n([]);
      },
      placeholder: "Search by patient last name, first and last name, or identifier",
      usesSearchButton: !0
    }
  );
}, "PatientsSearch"), KQ = ({ option: e }) => /* @__PURE__ */ i.jsxs(
  cr.Option,
  {
    value: e,
    className: ({ active: t }) => `ctw-relative ctw-flex ctw-cursor-default ctw-select-none ctw-space-x-2 ctw-py-2 ctw-pl-4 ctw-pr-4 ${t ? "ctw-bg-primary-light ctw-text-primary-dark" : "ctw-text-content-black"}`,
    children: [
      /* @__PURE__ */ i.jsxs("div", { className: "ctw-space-x-1", children: [
        /* @__PURE__ */ i.jsxs("span", { className: "ctw-font-medium", children: [
          e.value.lastName,
          ", "
        ] }),
        /* @__PURE__ */ i.jsx("span", { className: "ctw-font-medium", children: e.value.givenName }),
        /* @__PURE__ */ i.jsx("span", { className: "ctw-font-medium", children: e.value.gender && `(${e.value.gender[0].toUpperCase()})` })
      ] }),
      /* @__PURE__ */ i.jsx("div", { className: "ctw-font-medium", children: e.value.officialOrUsualIdentifier }),
      /* @__PURE__ */ i.jsxs("div", { className: "ctw-space-x-1", children: [
        /* @__PURE__ */ i.jsx("span", { children: e.value.dob }),
        e.value.age !== void 0 && /* @__PURE__ */ i.jsxs("span", { children: [
          "(",
          e.value.age,
          ")"
        ] })
      ] })
    ]
  }
), JQ = ({ patient: e }) => /* @__PURE__ */ i.jsx("div", { className: "ctw-flex ctw-items-center", children: /* @__PURE__ */ i.jsxs("div", { className: "ctw-ml-4", children: [
  /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-font-medium", children: [
    /* @__PURE__ */ i.jsx("div", { className: "ctw-max-w-xs", children: e.fullName }),
    e.gender && /* @__PURE__ */ i.jsxs("div", { className: "ctw-uppercase", children: [
      " (",
      e.gender[0],
      ")"
    ] })
  ] }),
  /* @__PURE__ */ i.jsx(G1, { patient: e, className: "ctw-text-content-lighter" })
] }) }), NK = () => In.invalidateQueries(), ai = (e) => In.invalidateQueries({ queryKey: e });
function XQ() {
  return ai([Xc]);
}
function eZ() {
  return ai([el]);
}
function tZ() {
  return ai([Ig]);
}
function DK() {
  return Promise.all([
    XQ(),
    eZ(),
    tZ()
  ]);
}
const SK = He(
  ({ handleRowClick: e, pageSize: t = 20 }) => {
    var u;
    const [n, r] = Y(1), [s, a] = Y([""]), { data: o, isLoading: c, isError: l } = sB(t, s[n - 1]), d = (u = o == null ? void 0 : o.patients) != null ? u : [];
    return l ? /* @__PURE__ */ i.jsx(Zn, { header: "Error", children: "Could not load list of patients." }) : /* @__PURE__ */ i.jsx(ft, { componentName: "PatientsTable", children: /* @__PURE__ */ i.jsx("div", { className: "ctw-overflow-hidden", children: /* @__PURE__ */ i.jsx(
      wl,
      {
        canClickRow: (h) => !!h.UPID,
        records: d,
        isLoading: c,
        columns: nZ,
        getRowClassName: (h) => h.UPID ? "" : "ctw-bg-bg-light [&_*]:ctw-text-content-light",
        handleRowClick: e,
        pageSize: t,
        hidePagination: !0,
        children: /* @__PURE__ */ i.jsx(
          mw,
          {
            setCurrentPage: (h) => {
              var p;
              const f = h - 1;
              if (h > n) {
                const m = [...s];
                m[f] = (p = o == null ? void 0 : o.pageInfo.endCursor) != null ? p : "", a(m);
              }
              r(h);
            },
            currentPage: n,
            hasNext: o == null ? void 0 : o.pageInfo.hasNextPage
          }
        )
      }
    ) }) });
  },
  "PatientsTable"
), nZ = [
  {
    title: "Name",
    render: (e) => /* @__PURE__ */ i.jsx(JQ, { patient: e })
  },
  {
    title: "Contact",
    render: ({ email: e, phoneNumber: t }) => /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
      /* @__PURE__ */ i.jsx("div", { className: "ctw-patients-table-inputs-email", children: e }),
      /* @__PURE__ */ i.jsx("div", { className: "ctw-patients-table-inputs-phone", children: t })
    ] })
  },
  {
    title: "Created",
    render: (e) => e.UPID ? kr(e.lastUpdated) : /* @__PURE__ */ i.jsx(kt, { color: "info", content: "In-Progress" })
  }
];
function $K() {
  return V(this, null, function* () {
    yield ai([_g]);
  });
}
const rZ = "ZusAggregatedProfileIFrameConfig", gw = "ZusAggregatedProfileIFrameReady", sZ = "ZusAggregatedProfileOnResourceSave", AK = "ZusAggregatedProfileOnPatientSave", aZ = "ZusAggregatedProfileOnAddToRecord", ww = "ZusAggregatedProfileConfigReceived", iZ = 5e3, oZ = (e) => {
  const { Telemetry: t, context: n } = t0(), { overrideIframeUrl: r } = e, s = Te(null), [a, o] = Y(!1), [c, l] = Y(!1), [d, u] = Y(!1), [h, f] = Y(!1), [p, m] = Y(r), [C, y] = Y(), { getRequestContext: g, featureFlags: w } = Xe(), x = Ze(), S = Lm(), { medicationsOutsideProps: N, medicationsAllProps: v } = e;
  if (d && !a)
    throw new Error(
      "The ZAP should have connected by now. Please try to refresh the ZAP. If this error persists please contact support."
    );
  he(() => {
    const j = (_) => V(void 0, [_], function* ({ data: $ }) {
      var L, I, A, M;
      if ($.type === aZ && typeof $.error != "string") {
        const G = new Ot(
          $.payload.resource,
          $.payload.includedResources
        ), Z = {
          id: $.id,
          type: $.type
        };
        try {
          switch ($.payload.component) {
            case "medications-outside":
              yield (L = N == null ? void 0 : N.onAddToRecord) == null ? void 0 : L.call(N, G);
              break;
            case "medications-all":
              yield (I = v == null ? void 0 : v.onAddToRecord) == null ? void 0 : I.call(v, G);
              break;
            default:
              Z.error = `Unhandled onAddToRecord for component: ${$.payload.component}`;
          }
        } catch (Q) {
          Z.error = Q instanceof Error ? Q.message : "Unknown error";
        }
        (M = (A = s.current) == null ? void 0 : A.contentWindow) == null || M.postMessage(Z, String(p)), t.logger.debug(
          "ZusAggregatedProfileIframe - Sent onAddToRecord message from parent frame"
        );
      }
    }), D = ($) => {
      t.logger.debug(
        "ZusAggregatedProfileIframe - Receiving onAddToRecord message in parent frame"
      ), j($);
    };
    return C && (t.logger.debug(
      "ZusAggregatedProfileIframe - Removed previous onAddToRecord listener from parent frame"
    ), window.removeEventListener("message", C)), window.addEventListener("message", D), t.logger.debug(
      "ZusAggregatedProfileIframe - Added onAddToRecord listener to parent frame"
    ), y(() => D), () => {
      t.logger.debug(
        "ZusAggregatedProfileIframe - Unmounting, removing onAddToRecord listener from parent frame"
      ), window.removeEventListener("message", D);
    };
  }, [
    N == null ? void 0 : N.readOnly,
    N == null ? void 0 : N.onAddToRecord,
    v == null ? void 0 : v.readOnly,
    v == null ? void 0 : v.onAddToRecord,
    p
  ]), Tc(() => {
    const j = ({ data: $ }) => {
      $.type === gw && (t.logger.debug(
        "ZusAggregatedProfileIframe - Receiving IFrameReady message in parent frame, setting hostedZapReady to true"
      ), o(!0)), $.type === ww && t.logger.debug(
        "ZusAggregatedProfileIframe - Receiving onConfigReceived message in parent frame"
      );
    };
    window.addEventListener("message", j), t.logger.debug(
      "ZusAggregatedProfileIframe - Added onMessageReady listener to parent frame"
    ), l(!0);
    const D = setTimeout(() => {
      u(!0);
    }, iZ);
    return () => {
      clearTimeout(D), t.logger.debug(
        "ZusAggregatedProfileIframe - Unmounting, removing onMessageReady listener from parent frame"
      ), window.removeEventListener("message", j);
    };
  }, []), he(() => {
    let j;
    V(void 0, null, function* () {
      j = yield g(), m(r != null ? r : mO(j.env));
    });
    const D = ({ data: $ }) => {
      if ($.type === sZ && typeof $.error != "string") {
        t.logger.debug(
          "ZusAggregatedProfileIframe - Receiving onMessageSave message in parent frame"
        );
        const { resource: _, action: L, error: I } = $.payload;
        j == null || j.onResourceSave(_, L, new Error(I));
      }
    };
    return window.addEventListener("message", D), t.logger.debug(
      "ZusAggregatedProfileIframe - Added onMessageSave listener to parent frame"
    ), () => {
      t.logger.debug(
        "ZusAggregatedProfileIframe - Unmounting, removing onMessageSave listener from parent frame"
      ), window.removeEventListener("message", D);
    };
  }, [t.logger, g, r]), he(() => {
    function j() {
      return V(this, null, function* () {
        var L, I, A, M;
        const D = yield g(), _ = {
          CTWProviderProps: {
            authToken: D.authToken,
            env: D.env,
            builderId: D.builderId,
            featureFlags: w,
            ehr: n.ehr,
            enableTelemetry: n.enableTelemetry,
            headers: D.headers,
            locals: S.locals,
            theme: X(R({}, S.theme), {
              iframe: S.iframeTheme
            })
          },
          PatientProviderProps: typeof x.patientResourceID == "string" ? {
            patientResourceID: x.patientResourceID
          } : {
            patientID: (L = x.patientID) != null ? L : "",
            systemURL: (I = x.systemURL) != null ? I : ""
          },
          ZusAggregatedProfileProps: X(R({}, e), {
            medicationsOutsideProps: as("onAddToRecord", N),
            medicationsAllProps: as("onAddToRecord", v)
          }),
          // todo: refactor this out. It is redundant with CTWProviderProps.theme.iframe but it's expected by the standalone ZAP.
          iframeTheme: S.iframeTheme
        };
        (M = (A = s.current) == null ? void 0 : A.contentWindow) == null || M.postMessage(
          { type: rZ, payload: _ },
          p
        ), t.logger.debug(
          "ZusAggregatedProfileIframe - Sent ZapIFrameConfig message from parent frame"
        ), f(!0);
      });
    }
    a && (t.logger.debug(
      "ZusAggregatedProfileIframe - Hosted ZAP is ready, preparing to send config from parent frame"
    ), j());
  }, [
    g,
    a,
    s,
    x.patientResourceID,
    x.patientID,
    x.systemURL,
    e,
    v,
    N,
    p,
    h,
    w,
    S.theme,
    S.locals,
    n.enableTelemetry,
    n.ehr,
    S.iframeTheme,
    t.logger
  ]);
  const b = ke(() => {
    const j = { ehr: void 0 };
    return n.builderId && (j.builderId = n.builderId), n.ehr && (j.ehr = n.ehr), new URLSearchParams(j);
  }, [n.ehr, n.builderId]);
  return !p || !c ? null : /* @__PURE__ */ i.jsx(
    "iframe",
    {
      ref: s,
      "data-testid": "iframe-zap",
      title: "zus-aggregated-profile",
      height: "100%",
      width: "100%",
      src: `${p}/v1?${b}`,
      className: "ctw-border-0"
    }
  );
}, EK = He(
  oZ,
  "ZusAggregatedProfileIFrame"
);
const IK = (r) => {
  var s = r, {
    items: e,
    className: t
  } = s, n = ct(s, [
    "items",
    "className"
  ]);
  return /* @__PURE__ */ i.jsx(
    "ul",
    {
      className: W("ctw-action-list ctw-rounded-lg", t, {
        "ctw-border-0": e.length === 0,
        "ctw-bg-bg-lighter": e.length > 0
      }),
      children: e.map((a) => /* @__PURE__ */ i.jsx(cZ, R({ item: a }, n), a.id))
    }
  );
}, cZ = ({
  item: e,
  onRowClick: t,
  onAction: n = () => {
  },
  onSecondaryAction: r,
  secondaryActionText: s,
  actionText: a = "Mark Complete",
  undoActionText: o = "Undo",
  onUndoAction: c,
  activeClassName: l = "active"
}) => /* @__PURE__ */ i.jsxs(
  "li",
  {
    role: "row",
    className: W(
      "ctw-action-list-item",
      "ctw-border-lighter ctw-flex ctw-cursor-pointer ctw-p-4",
      {
        [l]: !e.complete,
        undoable: kc(c)
      }
    ),
    onKeyDown: (d) => {
      d.key === "Enter" && d.currentTarget.click();
    },
    onClick: () => t == null ? void 0 : t(e),
    children: [
      /* @__PURE__ */ i.jsxs("div", { className: "ctw-action-list-item-content ctw-flex-grow", children: [
        /* @__PURE__ */ i.jsx("div", { className: "ctw-font-semibold", children: e.title }),
        e.subtitle && /* @__PURE__ */ i.jsx("div", { className: "ctw-font-light", children: e.subtitle })
      ] }),
      /* @__PURE__ */ i.jsxs("div", { className: "ctw-action-list-item-action", children: [
        !e.complete && /* @__PURE__ */ i.jsx(
          "button",
          {
            type: "button",
            className: "ctw-btn-primary",
            onClick: (d) => {
              d.stopPropagation(), n(e);
            },
            children: a
          }
        ),
        r && s && /* @__PURE__ */ i.jsx(
          "button",
          {
            type: "button",
            className: "ctw-btn-primary ctw-ml-1",
            onClick: (d) => {
              d.stopPropagation(), r(e);
            },
            children: s
          }
        ),
        e.complete && !!c && /* @__PURE__ */ i.jsx(
          "button",
          {
            type: "button",
            className: "ctw-btn-default",
            onClick: (d) => {
              d.stopPropagation(), c(e);
            },
            children: o
          }
        )
      ] })
    ]
  }
), _K = ({ className: e, includeZusText: t = !1 }) => /* @__PURE__ */ i.jsxs(
  "svg",
  {
    viewBox: t ? "0 0 47 24" : "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: e,
    children: [
      /* @__PURE__ */ i.jsx("title", { children: "Zus Health" }),
      /* @__PURE__ */ i.jsxs("g", { "clip-path": "url(#clip0_105_5210)", children: [
        /* @__PURE__ */ i.jsx(
          "path",
          {
            d: "M17.8781 17.222L12.2169 13.9545L16.2985 6.88471C16.3251 6.83922 16.3722 6.75608 16.2985 6.62745C16.2247 6.49882 16.1275 6.49882 16.0757 6.49882H7.91101V-0.0392151H16.0757C18.5322 -0.0392151 20.7314 1.2298 21.9596 3.35686C23.1879 5.48392 23.1879 8.02353 21.9596 10.1506L17.8781 17.2204V17.222Z",
            fill: "#008051"
          }
        ),
        /* @__PURE__ */ i.jsx(
          "path",
          {
            d: "M15.453 24H7.36357C4.9071 24 2.70788 22.731 1.47965 20.6039C0.251413 18.4769 0.251413 15.9372 1.47965 13.8102L5.56122 6.74039L11.2208 10.0078L7.13926 17.0776C7.11259 17.1231 7.06553 17.2063 7.13926 17.3349C7.21298 17.4635 7.31024 17.4635 7.362 17.4635H15.4514V24H15.453Z",
            fill: "#71B2C9"
          }
        ),
        t && /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
          /* @__PURE__ */ i.jsx(
            "path",
            {
              d: "M30.8098 10.4283C30.9211 10.4283 30.9619 10.4973 30.9619 10.5945V10.8988C30.9619 11.0369 30.976 11.12 30.838 11.3145L27.1862 16.3498H31.0874V17.1388H26.2325C26.1211 17.1388 26.0804 17.0839 26.0804 16.9867V16.6683C26.0804 16.5302 26.0662 16.4471 26.2043 16.2526L29.8294 11.2173H26.1353V10.4283H30.8113H30.8098Z",
              fill: "#008051"
            }
          ),
          /* @__PURE__ */ i.jsx(
            "path",
            {
              d: "M38.016 10.4283H38.9698V16.2526C38.9698 16.5161 38.8866 16.6808 38.6231 16.7922L37.9313 17.0683C37.6129 17.1922 37.4749 17.2204 37.1298 17.2204H35.0137C34.4882 17.2204 34.2529 17.1232 33.9486 16.8188L33.5894 16.4596C33.216 16.0863 33.1611 15.9483 33.1611 15.3255V10.4283H34.1149V15.3537C34.1149 15.5749 34.1556 15.6581 34.3219 15.8243L34.6403 16.1428C34.8207 16.309 34.8756 16.3373 35.1517 16.3373H37.0749C37.158 16.3373 37.2411 16.3232 37.3102 16.2949L37.9329 16.0455C37.9878 16.0173 38.016 15.9906 38.016 15.9216V10.4298V10.4283Z",
              fill: "#008051"
            }
          ),
          /* @__PURE__ */ i.jsx(
            "path",
            {
              d: "M42.471 14.1224C42.0427 14.0816 41.7102 13.9702 41.489 13.7632C41.2537 13.542 41.1298 13.1969 41.1298 12.6573V12.2149C41.1298 11.6612 41.1847 11.4824 41.558 11.1075L41.9173 10.7482C42.2357 10.4439 42.471 10.3467 42.9965 10.3467H44.4067C44.8914 10.3467 45.0984 10.389 45.431 10.5961L46.2059 11.0667L45.8325 11.7443L44.8914 11.3161C44.6984 11.233 44.5588 11.2047 44.311 11.2047H43.1078C42.8318 11.2047 42.7753 11.233 42.5965 11.3992L42.2639 11.7318C42.0976 11.8981 42.0569 11.9812 42.0569 12.2024V12.7137C42.0569 13.073 42.1541 13.1984 42.5416 13.2392L45.0733 13.4745C45.5988 13.5294 45.9031 13.6408 46.1243 13.862C46.3455 14.0831 46.4427 14.4157 46.4427 14.8863V15.3286C46.4427 15.9514 46.3878 16.0894 46.0145 16.4628L45.6553 16.822C45.351 17.1263 45.1157 17.2235 44.5902 17.2235H42.8192C42.3345 17.2235 42.1274 17.1812 41.7823 16.9741L41.0074 16.5035L41.3808 15.8259L42.322 16.2682C42.5149 16.3514 42.6545 16.3655 42.9024 16.3655H44.4663C44.7424 16.3655 44.7988 16.3373 44.9776 16.171L45.3102 15.8384C45.4765 15.6722 45.5173 15.589 45.5173 15.3679V14.8832C45.5173 14.5239 45.42 14.3984 45.0325 14.3577L42.4725 14.1224H42.471Z",
              fill: "#008051"
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ i.jsx("defs", { children: /* @__PURE__ */ i.jsx("clipPath", { id: "clip0_105_5210", children: /* @__PURE__ */ i.jsx("rect", { width: "45.8039", height: "24", fill: "white", transform: "translate(0.598022)" }) }) })
    ]
  }
);
const TK = ({
  currentPage: e,
  isLoading: t = !1,
  pageSize: n,
  setCurrentPage: r,
  total: s
}) => {
  const a = Math.min(s, (e - 1) * n + 1), o = Math.min(e * n, s), c = Math.ceil(s / n), l = Math.max(e - 1, 1), d = Math.min(e + 1, c);
  let u = [1, c];
  return u.push(e - 1, e, e + 1), u = ht(
    u.sort((h, f) => h - f).filter((h) => h >= 1 && h <= c)
  ), /* @__PURE__ */ i.jsxs("div", { className: "ctw-flex ctw-justify-between ctw-px-6 ctw-py-3", children: [
    /* @__PURE__ */ i.jsx("div", { className: "ctw-text-gray-600 ctw-text-sm", children: t ? /* @__PURE__ */ i.jsx(Je, {}) : /* @__PURE__ */ i.jsxs(i.Fragment, { children: [
      /* @__PURE__ */ i.jsx("span", { className: "ctw-font-medium", children: a }),
      " to",
      " ",
      /* @__PURE__ */ i.jsx("span", { className: "ctw-font-medium", children: o }),
      " of",
      " ",
      /* @__PURE__ */ i.jsx("span", { className: "ctw-font-medium", children: s }),
      " results"
    ] }) }),
    c > 1 && /* @__PURE__ */ i.jsx("div", { children: /* @__PURE__ */ i.jsxs("nav", { className: "ctw-pagination-nav", "aria-label": "Pagination", children: [
      /* @__PURE__ */ i.jsxs(
        Fs,
        {
          page: l,
          setCurrentPage: r,
          className: "ctw-pagination-group-start ctw-hover:ctw-bg-gray-50",
          disabled: e === 1,
          children: [
            /* @__PURE__ */ i.jsx("span", { className: "ctw-sr-only", children: "Previous" }),
            /* @__PURE__ */ i.jsx(SB, { className: "ctw-h-5 ctw-w-5", "aria-hidden": "true" })
          ]
        }
      ),
      u.map((h, f) => {
        var C;
        const p = (C = u[f - 1]) != null ? C : 0, m = h - p - 1;
        return /* @__PURE__ */ i.jsxs(sn, { children: [
          m > 1 && /* @__PURE__ */ i.jsx("span", { className: "ctw-pagination-ellipsis", children: "..." }),
          m === 1 && /* @__PURE__ */ i.jsx(
            Fs,
            {
              page: h - 1,
              setCurrentPage: r,
              currentPage: e
            }
          ),
          /* @__PURE__ */ i.jsx(Fs, { setCurrentPage: r, page: h, currentPage: e })
        ] }, h);
      }),
      /* @__PURE__ */ i.jsxs(
        Fs,
        {
          page: d,
          setCurrentPage: r,
          className: "ctw-pagination-group-end",
          disabled: e === c,
          children: [
            /* @__PURE__ */ i.jsx("span", { className: "ctw-sr-only", children: "Next" }),
            /* @__PURE__ */ i.jsx(EB, { className: "ctw-h-5 ctw-w-5", "aria-hidden": "true" })
          ]
        }
      )
    ] }) })
  ] });
}, Fs = ({
  setCurrentPage: e,
  page: t,
  currentPage: n,
  children: r,
  className: s,
  disabled: a = !1
}) => {
  const { trackInteraction: o } = Be(), c = t === n;
  return /* @__PURE__ */ i.jsx(
    "button",
    {
      type: "button",
      disabled: a,
      onClick: () => {
        e(t), o("change_page", { page: t });
      },
      className: W(s, "ctw-pagination-page-btn", { active: c, disabled: a }),
      children: r || t
    }
  );
}, eh = "invalid-token";
function lZ({
  children: e,
  authToken: t,
  authTokenURL: n,
  onAuthTokenExpiration: r
}) {
  const [s, a] = Y(!1);
  if (!t && !n && !r)
    throw new Error("Either authToken, authTokenURL or onAuthTokenExpiration is required");
  he(() => {
    !t && !n && (r == null || r());
  }, [t, n, r]), he(() => {
    const l = Bs.onChange((d) => {
      d.id === eh && d.status === "removed" && a(!1);
    });
    return () => {
      l();
    };
  }, []);
  const o = vt(() => V(this, null, function* () {
    return t ? cf(t) ? t : (r == null || r(), s || (a(!0), p9(t, eh)), "") : t || "";
  }), [t, s, r]), c = ke(
    () => ({
      isExpired: !cf(t),
      token: t,
      getAuthToken: o
    }),
    [t, o]
  );
  return /* @__PURE__ */ i.jsx(Hm.Provider, { value: c, children: t ? e : /* @__PURE__ */ i.jsx(Je, {}) });
}
function dZ({ children: e }) {
  const [t, n] = Y({
    "conditions-all": []
  }), r = ke(
    () => ({
      selectedResources: t,
      setSelectedResources: n
    }),
    [t, n]
  );
  return /* @__PURE__ */ i.jsx(Ja.Provider, { value: r, children: e });
}
const uZ = 2e3;
function fZ({
  children: e,
  env: t,
  builderId: n,
  enableTelemetry: r = !1,
  datadogConfig: s,
  ehr: a
}) {
  const o = Pc(), [c, l] = Y(!1), [d, u] = Y(!1), h = ke(
    () => ({
      builderId: n,
      ehr: a,
      enableTelemetry: r,
      datadogConfig: s
    }),
    [n, a, r, s]
  );
  return he(() => {
    V(this, null, function* () {
      try {
        $e.init(t, a, r, s), $e.setBuilder(n);
        const f = yield o();
        $e.setUser(f);
      } catch (f) {
        $e.logger.error(
          "Telemetry initialization failed",
          f instanceof Error ? f : new Error(String(f))
        );
      } finally {
        l(!0);
      }
    });
  }, [n, t, a, r, o, s]), he(() => {
    const f = setTimeout(() => {
      u(!0);
    }, uZ);
    return () => clearTimeout(f);
  }, []), !c && !d ? /* @__PURE__ */ i.jsx(Je, {}) : /* @__PURE__ */ i.jsx(e0.Provider, { value: h, children: e });
}
function hZ({
  children: e,
  locals: t,
  theme: n = {}
}) {
  const r = Te(null), [s, a] = Y("");
  he(() => {
    const c = R(R({}, nO(n.colors || {})), tO);
    a(
      Object.entries(c).map(([l, d]) => `${l}:${d}`).join(";")
    );
  }, [r, n]), he(() => {
    var c;
    (c = r.current) == null || c.setAttribute("style", s);
  }, [r, s]), he(() => {
    var l;
    (l = document.getElementById("headlessui-portal-root")) == null || l.remove();
    const c = document.createElement("div");
    c.id = "headlessui-portal-root", c.innerHTML = "<div/>", c.setAttribute("style", s), document.body.appendChild(c);
  }, [s]), he(() => {
    t && Object.entries(t).forEach(([c, l]) => {
      Object.entries(l).forEach(([d, u]) => {
        st.addResourceBundle(c, d, u);
      });
    });
  }, [t]);
  const o = ke(() => {
    const d = n, { iframe: c } = d, l = ct(d, ["iframe"]);
    return {
      // Set our context theme to our default theme merged
      // with any of the provided theme overwrites.
      // This way consumers of useTheme can get access to
      // the full true theme being applied.
      theme: wm({}, km, l),
      iframeTheme: c,
      ctwThemeRef: r,
      locals: t
    };
  }, [n, t, r]);
  return /* @__PURE__ */ i.jsx("div", { ref: r, className: "ctw-theme ctw-scrollable-pass-through-height", children: /* @__PURE__ */ i.jsx(Rc.Provider, { value: o, children: e }) });
}
function pZ({ children: e }) {
  const [t, n] = Y({}), r = ke(
    () => ({
      props: t,
      setProps: n
    }),
    [t, n]
  );
  return /* @__PURE__ */ i.jsx(zl.Provider, { value: r, children: e });
}
const mZ = Sw(({ children: e }) => {
  const [t, n] = Y(0), [r, s] = Y([]), a = ke(
    () => ({
      selectedZapTabIndex: t,
      setSelectedTab: (o) => {
        const c = typeof o == "number" ? o : r.indexOf(o);
        n(c);
      },
      tabOrder: r,
      setTabOrder: s
    }),
    [t, n, r, s]
  );
  return /* @__PURE__ */ i.jsx(Jn.Provider, { value: a, children: e });
}), gZ = "4.0.2";
function RK({
  children: e,
  env: t,
  builderId: n,
  enableTelemetry: r = !1,
  datadogConfig: s,
  ehr: a,
  featureFlags: o,
  locals: c,
  theme: l,
  headers: d,
  authToken: u,
  authTokenURL: h,
  onResourceSave: f,
  onAuthTokenExpiration: p,
  resourceSaveHeaders: m,
  allowSmallBreakpointCCDAViewer: C = !1
}) {
  he(() => {
    window.CTWComponentLibrary = {
      version: gZ
    };
  }, []);
  const y = ke(
    () => ({
      env: t,
      builderId: n,
      featureFlags: o,
      onResourceSave: f,
      resourceSaveHeaders: m,
      headers: d,
      allowSmallBreakpointCCDAViewer: C
    }),
    [
      t,
      n,
      o,
      f,
      m,
      d,
      C
    ]
  );
  return /* @__PURE__ */ i.jsx(hZ, { theme: l, locals: c, children: /* @__PURE__ */ i.jsx(m0, { children: /* @__PURE__ */ i.jsx(
    lZ,
    {
      headers: d,
      authToken: u,
      authTokenURL: h,
      onAuthTokenExpiration: p,
      children: /* @__PURE__ */ i.jsx(zH, { env: t, children: /* @__PURE__ */ i.jsx(
        fZ,
        {
          env: t,
          builderId: n,
          ehr: a,
          enableTelemetry: r,
          datadogConfig: s,
          children: /* @__PURE__ */ i.jsx(Wm.Provider, { value: y, children: /* @__PURE__ */ i.jsx(fv, { client: In, children: /* @__PURE__ */ i.jsx(mZ, { children: /* @__PURE__ */ i.jsx(dZ, { children: /* @__PURE__ */ i.jsx(ev, { workerUrl: "https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js", children: /* @__PURE__ */ i.jsx(pZ, { children: e }) }) }) }) }) })
        }
      ) })
    }
  ) }) });
}
const wZ = ({ name: e, text: t, onChange: n, inputProps: r }) => /* @__PURE__ */ i.jsxs("div", { className: "ctw-toggle", children: [
  /* @__PURE__ */ i.jsx("div", { className: "ctw-relative ctw-mr-2 ctw-inline-block ctw-w-10 ctw-select-none ctw-align-middle ctw-transition ctw-duration-200 ctw-ease-in", children: /* @__PURE__ */ i.jsxs(
    "label",
    {
      htmlFor: e,
      className: "ctw-relative ctw-block ctw-h-6 ctw-cursor-pointer ctw-overflow-hidden ctw-rounded-full ctw-bg-divider-light",
      children: [
        /* @__PURE__ */ i.jsx("input", X(R({ onChange: n }, r), { type: "checkbox", name: e, id: e })),
        /* @__PURE__ */ i.jsx("span", { className: "ctw-toggle-span" })
      ]
    }
  ) }),
  /* @__PURE__ */ i.jsx("label", { htmlFor: e, className: "ctw-text-sm ctw-font-medium ctw-text-icon-default", children: t })
] }), MK = ({ toggleProps: e, onFormChange: t }) => /* @__PURE__ */ i.jsx("form", { onChange: t, className: "ctw-text-end", children: /* @__PURE__ */ i.jsx(wZ, R({}, e)) }), vZ = 5e3, PK = () => {
  const [e, t] = Y(!1), [n, r] = Y(!1), [s, a] = Y(!1);
  return he(() => {
    const o = ({ data: l }) => {
      l.type === gw && ($e.logger.debug(
        "ZusAggregatedProfileIframe - Receiving IFrameReady message in parent frame, setting hostedZapReady to true"
      ), t(!0)), l.type === ww && $e.logger.debug(
        "ZusAggregatedProfileIframe - Receiving onConfigReceived message in parent frame"
      );
    };
    window.addEventListener("message", o), $e.logger.debug(
      "ZusAggregatedProfileIframe - Added onMessageReady listener to parent frame"
    ), r(!0);
    const c = setTimeout(() => {
      a(!0);
    }, vZ);
    return () => {
      clearTimeout(c), $e.logger.debug(
        "ZusAggregatedProfileIframe - Unmounting, removing onMessageReady listener from parent frame"
      ), window.removeEventListener("message", o);
    };
  }, []), { hostedZapReady: e, preparedOnReadyListener: n, iframeShouldBeLoaded: s };
};
export {
  IK as ActionList,
  cZ as ActionListItem,
  vV as AlertFeatureFlag,
  Og as AllergyModel,
  ft as AnalyticsProvider,
  kt as Badge,
  Ml as BetaLabel,
  uK as CTWBox,
  RK as CTWProvider,
  Uc as CTW_EXTENSION_LENS_AGGREGATED_FROM,
  iK as CautionAlert,
  Ug as ConditionModel,
  Ji as CopyToClipboard,
  KQ as CustomComboBox,
  ds as DEFAULT_PAGE_SIZE,
  si as DEFAULT_ZAP_TABS,
  qg as DiagnosticReportModel,
  Iq as DisplayCorrectTabLabel,
  hn as DocumentModel,
  et as Drawer,
  Nl as DrawerFormWithFields,
  xt as EmptyPatientTable,
  WH as EmptyTableNoneFound,
  za as EncounterModel,
  MG as EncountersOverviewCard,
  TG as EncountersOverviewCardComponent,
  QF as EpisodeOfCareModel,
  Zn as ErrorAlert,
  YB as ErrorBoundary,
  x0 as ExpandList,
  L0 as FeatureFlagContext,
  zH as FeatureFlagProvider,
  Bc as LENS_EXTENSION_AGGREGATED_FROM,
  e9 as LENS_EXTENSION_ID,
  vg as LENS_EXTENSION_MEDICATION_DAYS_SUPPLY,
  mg as LENS_EXTENSION_MEDICATION_LAST_FILL_DATE,
  gg as LENS_EXTENSION_MEDICATION_LAST_PRESCRIBED_DATE,
  xg as LENS_EXTENSION_MEDICATION_LAST_PRESCRIBER,
  wg as LENS_EXTENSION_MEDICATION_QUANTITY,
  yg as LENS_EXTENSION_MEDICATION_REFILLS,
  t9 as LENS_EXTENSION_RELATED_BINARIES,
  Cl as ListBox,
  Je as Loading,
  jt as MAX_OBJECTS_PER_REQUEST,
  da as MedicationDispenseModel,
  HF as MedicationModel,
  Ot as MedicationStatementModel,
  hl as Modal,
  Vf as OVERVIEW_CARD_MIN_WIDTH,
  jW as OVERVIEW_CARD_MIN_WIDTH_CLASS_NAME,
  rl as ObservationModel,
  bg as OperationOutcomeModel,
  pF as OrganizationModel,
  pO as OverlayProvider,
  Ds as OverviewCard,
  V0 as OverviewCardBody,
  Vr as OverviewCardBodyMessage,
  H0 as OverviewCardBox,
  q0 as OverviewCardFooter,
  W0 as OverviewCardHeader,
  TK as Pagination,
  eW as PatientAllergies,
  lW as PatientCareTeam,
  VW as PatientConditionOverview,
  WW as PatientConditionOverviewComponent,
  UW as PatientConditionsAllGrouped,
  RY as PatientContactInformation,
  cV as PatientDiagnosticReports,
  hV as PatientDiagnosticReportsOverview,
  fV as PatientDiagnosticReportsOverviewComponent,
  xQ as PatientDocuments,
  Qq as PatientEncounters,
  xG as PatientHistoryLastCompleted,
  jK as PatientHistoryTable,
  bG as PatientHistoryWithAction,
  IQ as PatientImmunizations,
  G1 as PatientInfoLine,
  vK as PatientMedicationDispense,
  ZG as PatientMedicationOverview,
  QG as PatientMedicationOverviewComponent,
  aG as PatientMedications,
  pG as PatientMedicationsAll,
  gG as PatientMedicationsOutside,
  yK as PatientMedicationsOutsideBadge,
  xK as PatientMedicationsProfile,
  zt as PatientModel,
  JQ as PatientNameColumn,
  AY as PatientOverview,
  $Y as PatientOverviewComponent,
  sK as PatientProvider,
  zY as PatientRecordSearch,
  VY as PatientReferrals,
  YY as PatientSources,
  nQ as PatientTimeline,
  hQ as PatientVitals,
  CK as PatientsSearch,
  SK as PatientsTable,
  Lr as PractitionerModel,
  Ht as ResourceTableActions,
  zr as ResponsiveSourceDocumentLink,
  GB as SUPPORT_FORM_URL,
  GZ as SYSTEM_ACT_CODE,
  nK as SYSTEM_ATHENA_PATIENT,
  VL as SYSTEM_BASIC_RESOURCE_TYPE,
  On as SYSTEM_CCI,
  sf as SYSTEM_CCS,
  Os as SYSTEM_CMS_HCC,
  qL as SYSTEM_CONDITION_CATEGORY,
  yo as SYSTEM_CONDITION_CLINICAL,
  hg as SYSTEM_CONDITION_VERIFICATION_STATUS,
  QL as SYSTEM_CPT,
  ZL as SYSTEM_CVX,
  GL as SYSTEM_DIAGNOSIS_ROLE,
  YL as SYSTEM_DIAGNOSTIC_SERVICE_SECTION_ID,
  xr as SYSTEM_ENRICHMENT,
  af as SYSTEM_ICD10,
  xo as SYSTEM_ICD10_CM,
  KL as SYSTEM_ICD9,
  JL as SYSTEM_ICD9_CM,
  Yt as SYSTEM_LOINC,
  YZ as SYSTEM_MARITAL_STATUS,
  XL as SYSTEM_NDC,
  rf as SYSTEM_NULL_FLAVOR,
  QZ as SYSTEM_PROVENANCE_ACTIVITY_TYPE,
  ZZ as SYSTEM_PROVENANCE_AGENT_TYPE,
  KZ as SYSTEM_RELATIONSHIP,
  is as SYSTEM_RXNORM,
  os as SYSTEM_SNOMED,
  yt as SYSTEM_SUMMARY,
  JZ as SYSTEM_TASK_STATUS,
  XZ as SYSTEM_ZUS_BUILDER_ID,
  Lc as SYSTEM_ZUS_CREATED_AT,
  pg as SYSTEM_ZUS_LENS,
  En as SYSTEM_ZUS_OWNER,
  eK as SYSTEM_ZUS_PRACTITIONER_ID,
  zs as SYSTEM_ZUS_PROFILE_ACTION,
  Fa as SYSTEM_ZUS_SUMMARY,
  Ln as SYSTEM_ZUS_THIRD_PARTY,
  yr as SYSTEM_ZUS_UNIVERSAL_ID,
  Fc as SYSTEM_ZUS_UPI_RECORD_TYPE,
  tK as SYSTEM_ZUS_USER_TYPE,
  mw as SimplePagination,
  fH as SortButton,
  an as Spinner,
  ol as SupportFormLink,
  DF as THIRD_PARTY_SOURCE_SYSTEM,
  wl as Table,
  $e as Telemetry,
  fZ as TelemetryProvider,
  wZ as Toggle,
  MK as ToggleControl,
  Sn as Tooltip,
  Nn as UnableToRenderError,
  oK as UnreadAllergiesNotification,
  cK as UnreadConditionsNotification,
  pK as UnreadDiagnosticReportsNotification,
  mK as UnreadDocumentsNotification,
  gK as UnreadEncountersNotification,
  wK as UnreadImmunizationsNotification,
  bK as UnreadMedicationsNotification,
  fK as UnreadRecordsNotification,
  tH as ViewButton,
  pU as ViewDocument,
  PQ as ZAP_TAB_NAMES,
  rZ as ZapIFrameConfigMessageType,
  gw as ZapIFrameReadyMessageType,
  aZ as ZapOnAddToRecordMessageType,
  ww as ZapOnConfigReceivedMessageType,
  AK as ZapOnPatientSaveMessageType,
  sZ as ZapOnResourceSaveMessageType,
  kQ as ZusAggregatedProfile,
  EK as ZusAggregatedProfileIFrame,
  _K as ZusIcon,
  CG as ZusInformationCard,
  jG as ZusInformationCardComponent,
  El as allergyData,
  Al as allergyHistory,
  dW as careTeamData,
  Re as createGraphqlClient,
  Ba as createOrEditFhirResource,
  hF as editPatient,
  nB as fetchResource,
  lK as filterMedicationsWithNoRxNorms,
  HW as filters,
  dt as fqsRequest,
  Ut as fqsRequestAll,
  Un as fqsRequestContext,
  LV as getBuilderMedicationsFQS,
  sa as getCTWBaseUrl,
  Eq as getDataIndicators,
  Vm as getEHRIntegrationServiceBaseUrl,
  E9 as getFetchFromFqs,
  wO as getFormsConditionsUrl,
  vO as getFormsMedicationsUrl,
  rK as getHistoryResources,
  Oc as getLensBuilderId,
  BV as getMedicationAdministrationsForPatientByIdFQS,
  UV as getMedicationDispensesForPatientByIdFQS,
  zV as getMedicationRequestsForPatientByIdFQS,
  f1 as getMedicationStatementsByIdFQS,
  FV as getMedicationStatementsForPatientByIdFQS,
  dV as getOverviewFilters,
  M0 as getPatientHistoryJobs,
  I9 as getResourceNodes,
  WV as getSummaryMedicationsFQS,
  UH as getUnleashContext,
  BH as getUnleashProxyForEnv,
  mO as getZapIFrameUrl,
  Pa as getZusApiBaseUrl,
  gO as getZusFhirBaseUrl,
  Kt as getZusServiceUrl,
  lB as handleGetPatient,
  DK as invalidateAllMedicationQueries,
  XQ as invalidateBuilderMedsQueries,
  tZ as invalidateMedicationHistoryQueries,
  eZ as invalidateOtherProviderMedsQueries,
  NK as invalidateQueries,
  ai as invalidateQueriesFrom,
  tl as isRenderableBinary,
  mr as numRecordsToLookbackForUnread,
  $K as refreshPatientsTable,
  tB as searchBuilderRecords,
  br as searchRecords,
  VV as splitMedications,
  Be as useAnalytics,
  q1 as useBuilderConfig,
  Cs as useCCDAModal,
  Xe as useCTW,
  Aq as useDataIndicators,
  BU as useDownloadBinary,
  Vn as useDrawer,
  uO as useDrawerState,
  kG as useEpisodeOfCareDrawer,
  aK as useHandlePatientSave,
  R1 as useHasDataRecordsByResource,
  PK as useIframeAuthProvider,
  qV as useMedicationHistory,
  U1 as useMedicationRowActions,
  cB as usePatient,
  nG as usePatientBuilderMedications,
  Ze as usePatientContext,
  Ns as usePatientHistory,
  P0 as usePatientHistoryDetails,
  dB as usePatientPromise,
  ZQ as usePatientSearchList,
  rG as usePatientSummaryMedications,
  Xn as useQueryAllPatientMedications,
  _t as useResourceDetailsDrawer,
  Jt as useTimerQueryWithCTW,
  Oe as useTimingQueryWithPatient,
  pw as useUnreadRecordsByResource,
  hK as useUnreadZAPTabsCount,
  gZ as version,
  He as withErrorBoundary,
  Yc as withTimerMetric
};
//# sourceMappingURL=index.es.js.map
